
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7daa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7daa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.4" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("5ETHc", function(module, exports) {

var $9vzhD = parcelRequire("9vzhD");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $9vzhD(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("9vzhD", function(module, exports) {
function $6ec260e3212aa3ad$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $6ec260e3212aa3ad$var$RetryOperation;
$6ec260e3212aa3ad$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.start = $6ec260e3212aa3ad$var$RetryOperation.prototype.try;
$6ec260e3212aa3ad$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$6ec260e3212aa3ad$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});


var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));




var $acw62 = parcelRequire("acw62");
var $b6d378dfee037fa8$exports = {};
'use strict';
var $e0c9a09fa1097fc7$exports = {};

$e0c9a09fa1097fc7$exports = (parcelRequire("5ETHc"));


const $b6d378dfee037fa8$var$networkErrorMsgs = [
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
    'The Internet connection appears to be offline.',
    'Network request failed' // `cross-fetch`
];
class $b6d378dfee037fa8$var$AbortError extends Error {
    constructor(message){
        super();
        if (message instanceof Error) {
            this.originalError = message;
            ({ message: message } = message);
        } else {
            this.originalError = new Error(message);
            this.originalError.stack = this.stack;
        }
        this.name = 'AbortError';
        this.message = message;
    }
}
const $b6d378dfee037fa8$var$decorateErrorWithCounts = (error, attemptNumber, options)=>{
    // Minus 1 from attemptNumber because the first attempt does not count as a retry
    const retriesLeft = options.retries - (attemptNumber - 1);
    error.attemptNumber = attemptNumber;
    error.retriesLeft = retriesLeft;
    return error;
};
const $b6d378dfee037fa8$var$isNetworkError = (errorMessage)=>$b6d378dfee037fa8$var$networkErrorMsgs.includes(errorMessage);
const $b6d378dfee037fa8$var$pRetry = (input, options)=>new Promise((resolve, reject)=>{
        options = {
            onFailedAttempt: ()=>{},
            retries: 10,
            ...options
        };
        const operation = $e0c9a09fa1097fc7$exports.operation(options);
        operation.attempt(async (attemptNumber)=>{
            try {
                resolve(await input(attemptNumber));
            } catch (error) {
                if (!(error instanceof Error)) {
                    reject(new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`));
                    return;
                }
                if (error instanceof $b6d378dfee037fa8$var$AbortError) {
                    operation.stop();
                    reject(error.originalError);
                } else if (error instanceof TypeError && !$b6d378dfee037fa8$var$isNetworkError(error.message)) {
                    operation.stop();
                    reject(error);
                } else {
                    $b6d378dfee037fa8$var$decorateErrorWithCounts(error, attemptNumber, options);
                    try {
                        await options.onFailedAttempt(error);
                    } catch (error) {
                        reject(error);
                        return;
                    }
                    if (!operation.retry(error)) reject(operation.mainError());
                }
            }
        });
    });
$b6d378dfee037fa8$exports = $b6d378dfee037fa8$var$pRetry;
// TODO: remove this in the next major version
$b6d378dfee037fa8$exports.default = $b6d378dfee037fa8$var$pRetry;
$b6d378dfee037fa8$exports.AbortError = $b6d378dfee037fa8$var$AbortError;


/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ let $e4deb49dba5321bc$var$_defaultBaseGeminiUrl = undefined;
let $e4deb49dba5321bc$var$_defaultBaseVertexUrl = undefined;
/**
 * Overrides the base URLs for the Gemini API and Vertex AI API.
 *
 * @remarks This function should be called before initializing the SDK. If the
 * base URLs are set after initializing the SDK, the base URLs will not be
 * updated. Base URLs provided in the HttpOptions will also take precedence over
 * URLs set here.
 *
 * @example
 * ```ts
 * import {GoogleGenAI, setDefaultBaseUrls} from '@google/genai';
 * // Override the base URL for the Gemini API.
 * setDefaultBaseUrls({geminiUrl:'https://gemini.google.com'});
 *
 * // Override the base URL for the Vertex AI API.
 * setDefaultBaseUrls({vertexUrl: 'https://vertexai.googleapis.com'});
 *
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 */ function $e4deb49dba5321bc$export$73f5ab1d327f9edc(baseUrlParams) {
    $e4deb49dba5321bc$var$_defaultBaseGeminiUrl = baseUrlParams.geminiUrl;
    $e4deb49dba5321bc$var$_defaultBaseVertexUrl = baseUrlParams.vertexUrl;
}
/**
 * Returns the default base URLs for the Gemini API and Vertex AI API.
 */ function $e4deb49dba5321bc$var$getDefaultBaseUrls() {
    return {
        geminiUrl: $e4deb49dba5321bc$var$_defaultBaseGeminiUrl,
        vertexUrl: $e4deb49dba5321bc$var$_defaultBaseVertexUrl
    };
}
/**
 * Returns the default base URL based on the following priority:
 *   1. Base URLs set via HttpOptions.
 *   2. Base URLs set via the latest call to setDefaultBaseUrls.
 *   3. Base URLs set via environment variables.
 */ function $e4deb49dba5321bc$var$getBaseUrl(httpOptions, vertexai, vertexBaseUrlFromEnv, geminiBaseUrlFromEnv) {
    var _a, _b;
    if (!(httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.baseUrl)) {
        const defaultBaseUrls = $e4deb49dba5321bc$var$getDefaultBaseUrls();
        if (vertexai) return (_a = defaultBaseUrls.vertexUrl) !== null && _a !== void 0 ? _a : vertexBaseUrlFromEnv;
        else return (_b = defaultBaseUrls.geminiUrl) !== null && _b !== void 0 ? _b : geminiBaseUrlFromEnv;
    }
    return httpOptions.baseUrl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BaseModule {
}
function $e4deb49dba5321bc$var$formatMap(templateString, valueMap) {
    // Use a regular expression to find all placeholders in the template string
    const regex = /\{([^}]+)\}/g;
    // Replace each placeholder with its corresponding value from the valueMap
    return templateString.replace(regex, (match, key)=>{
        if (Object.prototype.hasOwnProperty.call(valueMap, key)) {
            const value = valueMap[key];
            // Convert the value to a string if it's not a string already
            return value !== undefined && value !== null ? String(value) : '';
        } else // Handle missing keys
        throw new Error(`Key '${key}' not found in valueMap.`);
    });
}
function $e4deb49dba5321bc$var$setValueByPath(data, keys, value) {
    for(let i = 0; i < keys.length - 1; i++){
        const key = keys[i];
        if (key.endsWith('[]')) {
            const keyName = key.slice(0, -2);
            if (!(keyName in data)) {
                if (Array.isArray(value)) data[keyName] = Array.from({
                    length: value.length
                }, ()=>({}));
                else throw new Error(`Value must be a list given an array path ${key}`);
            }
            if (Array.isArray(data[keyName])) {
                const arrayData = data[keyName];
                if (Array.isArray(value)) for(let j = 0; j < arrayData.length; j++){
                    const entry = arrayData[j];
                    $e4deb49dba5321bc$var$setValueByPath(entry, keys.slice(i + 1), value[j]);
                }
                else for (const d of arrayData)$e4deb49dba5321bc$var$setValueByPath(d, keys.slice(i + 1), value);
            }
            return;
        } else if (key.endsWith('[0]')) {
            const keyName = key.slice(0, -3);
            if (!(keyName in data)) data[keyName] = [
                {}
            ];
            const arrayData = data[keyName];
            $e4deb49dba5321bc$var$setValueByPath(arrayData[0], keys.slice(i + 1), value);
            return;
        }
        if (!data[key] || typeof data[key] !== 'object') data[key] = {};
        data = data[key];
    }
    const keyToSet = keys[keys.length - 1];
    const existingData = data[keyToSet];
    if (existingData !== undefined) {
        if (!value || typeof value === 'object' && Object.keys(value).length === 0) return;
        if (value === existingData) return;
        if (typeof existingData === 'object' && typeof value === 'object' && existingData !== null && value !== null) Object.assign(existingData, value);
        else throw new Error(`Cannot set value for an existing key. Key: ${keyToSet}`);
    } else if (keyToSet === '_self' && typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const valueAsRecord = value;
        Object.assign(data, valueAsRecord);
    } else data[keyToSet] = value;
}
function $e4deb49dba5321bc$var$getValueByPath(data, keys, defaultValue) {
    try {
        if (keys.length === 1 && keys[0] === '_self') return data;
        for(let i = 0; i < keys.length; i++){
            if (typeof data !== 'object' || data === null) return defaultValue;
            const key = keys[i];
            if (key.endsWith('[]')) {
                const keyName = key.slice(0, -2);
                if (keyName in data) {
                    const arrayData = data[keyName];
                    if (!Array.isArray(arrayData)) return defaultValue;
                    return arrayData.map((d)=>$e4deb49dba5321bc$var$getValueByPath(d, keys.slice(i + 1), defaultValue));
                } else return defaultValue;
            } else data = data[key];
        }
        return data;
    } catch (error) {
        if (error instanceof TypeError) return defaultValue;
        throw error;
    }
}
/**
 * Moves values from source paths to destination paths.
 *
 * Examples:
 *   moveValueByPath(
 *     {'requests': [{'content': v1}, {'content': v2}]},
 *     {'requests[].*': 'requests[].request.*'}
 *   )
 *     -> {'requests': [{'request': {'content': v1}}, {'request': {'content': v2}}]}
 */ function $e4deb49dba5321bc$var$moveValueByPath(data, paths) {
    for (const [sourcePath, destPath] of Object.entries(paths)){
        const sourceKeys = sourcePath.split('.');
        const destKeys = destPath.split('.');
        // Determine keys to exclude from wildcard to avoid cyclic references
        const excludeKeys = new Set();
        let wildcardIdx = -1;
        for(let i = 0; i < sourceKeys.length; i++)if (sourceKeys[i] === '*') {
            wildcardIdx = i;
            break;
        }
        if (wildcardIdx !== -1 && destKeys.length > wildcardIdx) // Extract the intermediate key between source and dest paths
        // Example: source=['requests[]', '*'], dest=['requests[]', 'request', '*']
        // We want to exclude 'request'
        for(let i = wildcardIdx; i < destKeys.length; i++){
            const key = destKeys[i];
            if (key !== '*' && !key.endsWith('[]') && !key.endsWith('[0]')) excludeKeys.add(key);
        }
        $e4deb49dba5321bc$var$_moveValueRecursive(data, sourceKeys, destKeys, 0, excludeKeys);
    }
}
/**
 * Recursively moves values from source path to destination path.
 */ function $e4deb49dba5321bc$var$_moveValueRecursive(data, sourceKeys, destKeys, keyIdx, excludeKeys) {
    if (keyIdx >= sourceKeys.length) return;
    if (typeof data !== 'object' || data === null) return;
    const key = sourceKeys[keyIdx];
    if (key.endsWith('[]')) {
        const keyName = key.slice(0, -2);
        const dataRecord = data;
        if (keyName in dataRecord && Array.isArray(dataRecord[keyName])) for (const item of dataRecord[keyName])$e4deb49dba5321bc$var$_moveValueRecursive(item, sourceKeys, destKeys, keyIdx + 1, excludeKeys);
    } else if (key === '*') // wildcard - move all fields
    {
        if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
            const dataRecord = data;
            const keysToMove = Object.keys(dataRecord).filter((k)=>!k.startsWith('_') && !excludeKeys.has(k));
            const valuesToMove = {};
            for (const k of keysToMove)valuesToMove[k] = dataRecord[k];
            // Set values at destination
            for (const [k, v] of Object.entries(valuesToMove)){
                const newDestKeys = [];
                for (const dk of destKeys.slice(keyIdx))if (dk === '*') newDestKeys.push(k);
                else newDestKeys.push(dk);
                $e4deb49dba5321bc$var$setValueByPath(dataRecord, newDestKeys, v);
            }
            for (const k of keysToMove)delete dataRecord[k];
        }
    } else {
        // Navigate to next level
        const dataRecord = data;
        if (key in dataRecord) $e4deb49dba5321bc$var$_moveValueRecursive(dataRecord[key], sourceKeys, destKeys, keyIdx + 1, excludeKeys);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$tBytes$1(fromBytes) {
    if (typeof fromBytes !== 'string') throw new Error('fromImageBytes must be a string');
    // TODO(b/389133914): Remove dummy bytes converter.
    return fromBytes;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$fetchPredictOperationParametersToVertex(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'operationName'
    ], fromOperationName);
    const fromResourceName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resourceName'
    ]);
    if (fromResourceName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'resourceName'
    ], fromResourceName);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromMldev$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromMldev$1(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromVertex$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromVertex$1(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromVertex$1(fromObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromMldev$1(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromMldev$1(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromVertex$1(fromObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromVertex$1(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$getOperationParametersToMldev(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    return toObject;
}
function $e4deb49dba5321bc$var$getOperationParametersToVertex(fromObject) {
    const toObject = {};
    const fromOperationName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operationName'
    ]);
    if (fromOperationName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'operationName'
    ], fromOperationName);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileOperationFromMldev$1(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$importFileResponseFromMldev$1(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$importFileResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parent'
    ], fromParent);
    const fromDocumentName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documentName'
    ]);
    if (fromDocumentName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'documentName'
    ], fromDocumentName);
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreOperationFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$uploadToFileSearchStoreResponseFromMldev(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parent'
    ], fromParent);
    const fromDocumentName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documentName'
    ]);
    if (fromDocumentName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'documentName'
    ], fromDocumentName);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromMldev$1(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes$1(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromVertex$1(fromObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes$1(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /** Programming language of the `code`. */ var $e4deb49dba5321bc$export$ce4fe1c9e6520c1a;
(function(Language) {
    /**
     * Unspecified language. This value should not be used.
     */ Language["LANGUAGE_UNSPECIFIED"] = "LANGUAGE_UNSPECIFIED";
    /**
     * Python >= 3.10, with numpy and simpy available.
     */ Language["PYTHON"] = "PYTHON";
})($e4deb49dba5321bc$export$ce4fe1c9e6520c1a || ($e4deb49dba5321bc$export$ce4fe1c9e6520c1a = {}));
/** Outcome of the code execution. */ var $e4deb49dba5321bc$export$524cbb9c5a897bf8;
(function(Outcome) {
    /**
     * Unspecified status. This value should not be used.
     */ Outcome["OUTCOME_UNSPECIFIED"] = "OUTCOME_UNSPECIFIED";
    /**
     * Code execution completed successfully.
     */ Outcome["OUTCOME_OK"] = "OUTCOME_OK";
    /**
     * Code execution finished but with a failure. `stderr` should contain the reason.
     */ Outcome["OUTCOME_FAILED"] = "OUTCOME_FAILED";
    /**
     * Code execution ran for too long, and was cancelled. There may or may not be a partial output present.
     */ Outcome["OUTCOME_DEADLINE_EXCEEDED"] = "OUTCOME_DEADLINE_EXCEEDED";
})($e4deb49dba5321bc$export$524cbb9c5a897bf8 || ($e4deb49dba5321bc$export$524cbb9c5a897bf8 = {}));
/** Specifies how the response should be scheduled in the conversation. */ var $e4deb49dba5321bc$export$5faf5a36745d3723;
(function(FunctionResponseScheduling) {
    /**
     * This value is unused.
     */ FunctionResponseScheduling["SCHEDULING_UNSPECIFIED"] = "SCHEDULING_UNSPECIFIED";
    /**
     * Only add the result to the conversation context, do not interrupt or trigger generation.
     */ FunctionResponseScheduling["SILENT"] = "SILENT";
    /**
     * Add the result to the conversation context, and prompt to generate output without interrupting ongoing generation.
     */ FunctionResponseScheduling["WHEN_IDLE"] = "WHEN_IDLE";
    /**
     * Add the result to the conversation context, interrupt ongoing generation and prompt to generate output.
     */ FunctionResponseScheduling["INTERRUPT"] = "INTERRUPT";
})($e4deb49dba5321bc$export$5faf5a36745d3723 || ($e4deb49dba5321bc$export$5faf5a36745d3723 = {}));
/** Data type of the schema field. */ var $e4deb49dba5321bc$export$92738401e1603719;
(function(Type) {
    /**
     * Not specified, should not be used.
     */ Type["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /**
     * OpenAPI string type
     */ Type["STRING"] = "STRING";
    /**
     * OpenAPI number type
     */ Type["NUMBER"] = "NUMBER";
    /**
     * OpenAPI integer type
     */ Type["INTEGER"] = "INTEGER";
    /**
     * OpenAPI boolean type
     */ Type["BOOLEAN"] = "BOOLEAN";
    /**
     * OpenAPI array type
     */ Type["ARRAY"] = "ARRAY";
    /**
     * OpenAPI object type
     */ Type["OBJECT"] = "OBJECT";
    /**
     * Null type
     */ Type["NULL"] = "NULL";
})($e4deb49dba5321bc$export$92738401e1603719 || ($e4deb49dba5321bc$export$92738401e1603719 = {}));
/** The environment being operated. */ var $e4deb49dba5321bc$export$7dc6752a22ab011a;
(function(Environment) {
    /**
     * Defaults to browser.
     */ Environment["ENVIRONMENT_UNSPECIFIED"] = "ENVIRONMENT_UNSPECIFIED";
    /**
     * Operates in a web browser.
     */ Environment["ENVIRONMENT_BROWSER"] = "ENVIRONMENT_BROWSER";
})($e4deb49dba5321bc$export$7dc6752a22ab011a || ($e4deb49dba5321bc$export$7dc6752a22ab011a = {}));
/** Type of auth scheme. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$e04cb10fd7e39267;
(function(AuthType) {
    AuthType["AUTH_TYPE_UNSPECIFIED"] = "AUTH_TYPE_UNSPECIFIED";
    /**
     * No Auth.
     */ AuthType["NO_AUTH"] = "NO_AUTH";
    /**
     * API Key Auth.
     */ AuthType["API_KEY_AUTH"] = "API_KEY_AUTH";
    /**
     * HTTP Basic Auth.
     */ AuthType["HTTP_BASIC_AUTH"] = "HTTP_BASIC_AUTH";
    /**
     * Google Service Account Auth.
     */ AuthType["GOOGLE_SERVICE_ACCOUNT_AUTH"] = "GOOGLE_SERVICE_ACCOUNT_AUTH";
    /**
     * OAuth auth.
     */ AuthType["OAUTH"] = "OAUTH";
    /**
     * OpenID Connect (OIDC) Auth.
     */ AuthType["OIDC_AUTH"] = "OIDC_AUTH";
})($e4deb49dba5321bc$export$e04cb10fd7e39267 || ($e4deb49dba5321bc$export$e04cb10fd7e39267 = {}));
/** The location of the API key. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$c98bbdcbceec6af6;
(function(HttpElementLocation) {
    HttpElementLocation["HTTP_IN_UNSPECIFIED"] = "HTTP_IN_UNSPECIFIED";
    /**
     * Element is in the HTTP request query.
     */ HttpElementLocation["HTTP_IN_QUERY"] = "HTTP_IN_QUERY";
    /**
     * Element is in the HTTP request header.
     */ HttpElementLocation["HTTP_IN_HEADER"] = "HTTP_IN_HEADER";
    /**
     * Element is in the HTTP request path.
     */ HttpElementLocation["HTTP_IN_PATH"] = "HTTP_IN_PATH";
    /**
     * Element is in the HTTP request body.
     */ HttpElementLocation["HTTP_IN_BODY"] = "HTTP_IN_BODY";
    /**
     * Element is in the HTTP request cookie.
     */ HttpElementLocation["HTTP_IN_COOKIE"] = "HTTP_IN_COOKIE";
})($e4deb49dba5321bc$export$c98bbdcbceec6af6 || ($e4deb49dba5321bc$export$c98bbdcbceec6af6 = {}));
/** The API spec that the external API implements. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$31f7f72babb81944;
(function(ApiSpec) {
    /**
     * Unspecified API spec. This value should not be used.
     */ ApiSpec["API_SPEC_UNSPECIFIED"] = "API_SPEC_UNSPECIFIED";
    /**
     * Simple search API spec.
     */ ApiSpec["SIMPLE_SEARCH"] = "SIMPLE_SEARCH";
    /**
     * Elastic search API spec.
     */ ApiSpec["ELASTIC_SEARCH"] = "ELASTIC_SEARCH";
})($e4deb49dba5321bc$export$31f7f72babb81944 || ($e4deb49dba5321bc$export$31f7f72babb81944 = {}));
/** Sites with confidence level chosen & above this value will be blocked from the search results. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$834f9d49019de650;
(function(PhishBlockThreshold) {
    /**
     * Defaults to unspecified.
     */ PhishBlockThreshold["PHISH_BLOCK_THRESHOLD_UNSPECIFIED"] = "PHISH_BLOCK_THRESHOLD_UNSPECIFIED";
    /**
     * Blocks Low and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    /**
     * Blocks Medium and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    /**
     * Blocks High and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_HIGH_AND_ABOVE"] = "BLOCK_HIGH_AND_ABOVE";
    /**
     * Blocks Higher and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_HIGHER_AND_ABOVE"] = "BLOCK_HIGHER_AND_ABOVE";
    /**
     * Blocks Very high and above confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_VERY_HIGH_AND_ABOVE"] = "BLOCK_VERY_HIGH_AND_ABOVE";
    /**
     * Blocks Extremely high confidence URL that is risky.
     */ PhishBlockThreshold["BLOCK_ONLY_EXTREMELY_HIGH"] = "BLOCK_ONLY_EXTREMELY_HIGH";
})($e4deb49dba5321bc$export$834f9d49019de650 || ($e4deb49dba5321bc$export$834f9d49019de650 = {}));
/** Specifies the function Behavior. Currently only supported by the BidiGenerateContent method. This enum is not supported in Vertex AI. */ var $e4deb49dba5321bc$export$875db781adde08fb;
(function(Behavior) {
    /**
     * This value is unused.
     */ Behavior["UNSPECIFIED"] = "UNSPECIFIED";
    /**
     * If set, the system will wait to receive the function response before continuing the conversation.
     */ Behavior["BLOCKING"] = "BLOCKING";
    /**
     * If set, the system will not wait to receive the function response. Instead, it will attempt to handle function responses as they become available while maintaining the conversation between the user and the model.
     */ Behavior["NON_BLOCKING"] = "NON_BLOCKING";
})($e4deb49dba5321bc$export$875db781adde08fb || ($e4deb49dba5321bc$export$875db781adde08fb = {}));
/** The mode of the predictor to be used in dynamic retrieval. */ var $e4deb49dba5321bc$export$a95ec93224b807c1;
(function(DynamicRetrievalConfigMode) {
    /**
     * Always trigger retrieval.
     */ DynamicRetrievalConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Run retrieval only when system decides it is necessary.
     */ DynamicRetrievalConfigMode["MODE_DYNAMIC"] = "MODE_DYNAMIC";
})($e4deb49dba5321bc$export$a95ec93224b807c1 || ($e4deb49dba5321bc$export$a95ec93224b807c1 = {}));
/** Function calling mode. */ var $e4deb49dba5321bc$export$dd6bff2bc68258b9;
(function(FunctionCallingConfigMode) {
    /**
     * Unspecified function calling mode. This value should not be used.
     */ FunctionCallingConfigMode["MODE_UNSPECIFIED"] = "MODE_UNSPECIFIED";
    /**
     * Default model behavior, model decides to predict either function calls or natural language response.
     */ FunctionCallingConfigMode["AUTO"] = "AUTO";
    /**
     * Model is constrained to always predicting function calls only. If "allowed_function_names" are set, the predicted function calls will be limited to any one of "allowed_function_names", else the predicted function calls will be any one of the provided "function_declarations".
     */ FunctionCallingConfigMode["ANY"] = "ANY";
    /**
     * Model will not predict any function calls. Model behavior is same as when not passing any function declarations.
     */ FunctionCallingConfigMode["NONE"] = "NONE";
    /**
     * Model is constrained to predict either function calls or natural language response. If "allowed_function_names" are set, the predicted function calls will be limited to any one of "allowed_function_names", else the predicted function calls will be any one of the provided "function_declarations".
     */ FunctionCallingConfigMode["VALIDATED"] = "VALIDATED";
})($e4deb49dba5321bc$export$dd6bff2bc68258b9 || ($e4deb49dba5321bc$export$dd6bff2bc68258b9 = {}));
/** The number of thoughts tokens that the model should generate. */ var $e4deb49dba5321bc$export$d13806ce060d5375;
(function(ThinkingLevel) {
    /**
     * Unspecified thinking level.
     */ ThinkingLevel["THINKING_LEVEL_UNSPECIFIED"] = "THINKING_LEVEL_UNSPECIFIED";
    /**
     * MINIMAL thinking level.
     */ ThinkingLevel["MINIMAL"] = "MINIMAL";
    /**
     * Low thinking level.
     */ ThinkingLevel["LOW"] = "LOW";
    /**
     * Medium thinking level.
     */ ThinkingLevel["MEDIUM"] = "MEDIUM";
    /**
     * High thinking level.
     */ ThinkingLevel["HIGH"] = "HIGH";
})($e4deb49dba5321bc$export$d13806ce060d5375 || ($e4deb49dba5321bc$export$d13806ce060d5375 = {}));
/** Enum that controls the generation of people. */ var $e4deb49dba5321bc$export$d9baac936bd08721;
(function(PersonGeneration) {
    /**
     * Block generation of images of people.
     */ PersonGeneration["DONT_ALLOW"] = "DONT_ALLOW";
    /**
     * Generate images of adults, but not children.
     */ PersonGeneration["ALLOW_ADULT"] = "ALLOW_ADULT";
    /**
     * Generate images that include adults and children.
     */ PersonGeneration["ALLOW_ALL"] = "ALLOW_ALL";
})($e4deb49dba5321bc$export$d9baac936bd08721 || ($e4deb49dba5321bc$export$d9baac936bd08721 = {}));
/** Controls whether prominent people (celebrities) generation is allowed. If used with personGeneration, personGeneration enum would take precedence. For instance, if ALLOW_NONE is set, all person generation would be blocked. If this field is unspecified, the default behavior is to allow prominent people. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$8f9c651e5adfa09e;
(function(ProminentPeople) {
    /**
     * Unspecified value. The model will proceed with the default behavior, which is to allow generation of prominent people.
     */ ProminentPeople["PROMINENT_PEOPLE_UNSPECIFIED"] = "PROMINENT_PEOPLE_UNSPECIFIED";
    /**
     * Allows the model to generate images of prominent people.
     */ ProminentPeople["ALLOW_PROMINENT_PEOPLE"] = "ALLOW_PROMINENT_PEOPLE";
    /**
     * Prevents the model from generating images of prominent people.
     */ ProminentPeople["BLOCK_PROMINENT_PEOPLE"] = "BLOCK_PROMINENT_PEOPLE";
})($e4deb49dba5321bc$export$8f9c651e5adfa09e || ($e4deb49dba5321bc$export$8f9c651e5adfa09e = {}));
/** The harm category to be blocked. */ var $e4deb49dba5321bc$export$798c77e44df53af3;
(function(HarmCategory) {
    /**
     * Default value. This value is unused.
     */ HarmCategory["HARM_CATEGORY_UNSPECIFIED"] = "HARM_CATEGORY_UNSPECIFIED";
    /**
     * Abusive, threatening, or content intended to bully, torment, or ridicule.
     */ HarmCategory["HARM_CATEGORY_HARASSMENT"] = "HARM_CATEGORY_HARASSMENT";
    /**
     * Content that promotes violence or incites hatred against individuals or groups based on certain attributes.
     */ HarmCategory["HARM_CATEGORY_HATE_SPEECH"] = "HARM_CATEGORY_HATE_SPEECH";
    /**
     * Content that contains sexually explicit material.
     */ HarmCategory["HARM_CATEGORY_SEXUALLY_EXPLICIT"] = "HARM_CATEGORY_SEXUALLY_EXPLICIT";
    /**
     * Content that promotes, facilitates, or enables dangerous activities.
     */ HarmCategory["HARM_CATEGORY_DANGEROUS_CONTENT"] = "HARM_CATEGORY_DANGEROUS_CONTENT";
    /**
     * Deprecated: Election filter is not longer supported. The harm category is civic integrity.
     */ HarmCategory["HARM_CATEGORY_CIVIC_INTEGRITY"] = "HARM_CATEGORY_CIVIC_INTEGRITY";
    /**
     * Images that contain hate speech. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_HATE"] = "HARM_CATEGORY_IMAGE_HATE";
    /**
     * Images that contain dangerous content. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_DANGEROUS_CONTENT"] = "HARM_CATEGORY_IMAGE_DANGEROUS_CONTENT";
    /**
     * Images that contain harassment. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_HARASSMENT"] = "HARM_CATEGORY_IMAGE_HARASSMENT";
    /**
     * Images that contain sexually explicit content. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_IMAGE_SEXUALLY_EXPLICIT"] = "HARM_CATEGORY_IMAGE_SEXUALLY_EXPLICIT";
    /**
     * Prompts designed to bypass safety filters. This enum value is not supported in Gemini API.
     */ HarmCategory["HARM_CATEGORY_JAILBREAK"] = "HARM_CATEGORY_JAILBREAK";
})($e4deb49dba5321bc$export$798c77e44df53af3 || ($e4deb49dba5321bc$export$798c77e44df53af3 = {}));
/** The method for blocking content. If not specified, the default behavior is to use the probability score. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$963daae60acaff70;
(function(HarmBlockMethod) {
    /**
     * The harm block method is unspecified.
     */ HarmBlockMethod["HARM_BLOCK_METHOD_UNSPECIFIED"] = "HARM_BLOCK_METHOD_UNSPECIFIED";
    /**
     * The harm block method uses both probability and severity scores.
     */ HarmBlockMethod["SEVERITY"] = "SEVERITY";
    /**
     * The harm block method uses the probability score.
     */ HarmBlockMethod["PROBABILITY"] = "PROBABILITY";
})($e4deb49dba5321bc$export$963daae60acaff70 || ($e4deb49dba5321bc$export$963daae60acaff70 = {}));
/** The threshold for blocking content. If the harm probability exceeds this threshold, the content will be blocked. */ var $e4deb49dba5321bc$export$b0bfc55fdde52aac;
(function(HarmBlockThreshold) {
    /**
     * The harm block threshold is unspecified.
     */ HarmBlockThreshold["HARM_BLOCK_THRESHOLD_UNSPECIFIED"] = "HARM_BLOCK_THRESHOLD_UNSPECIFIED";
    /**
     * Block content with a low harm probability or higher.
     */ HarmBlockThreshold["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    /**
     * Block content with a medium harm probability or higher.
     */ HarmBlockThreshold["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    /**
     * Block content with a high harm probability.
     */ HarmBlockThreshold["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    /**
     * Do not block any content, regardless of its harm probability.
     */ HarmBlockThreshold["BLOCK_NONE"] = "BLOCK_NONE";
    /**
     * Turn off the safety filter entirely.
     */ HarmBlockThreshold["OFF"] = "OFF";
})($e4deb49dba5321bc$export$b0bfc55fdde52aac || ($e4deb49dba5321bc$export$b0bfc55fdde52aac = {}));
/** Output only. The reason why the model stopped generating tokens.

If empty, the model has not stopped generating the tokens. */ var $e4deb49dba5321bc$export$e94f0100e6b2fa1a;
(function(FinishReason) {
    /**
     * The finish reason is unspecified.
     */ FinishReason["FINISH_REASON_UNSPECIFIED"] = "FINISH_REASON_UNSPECIFIED";
    /**
     * Token generation reached a natural stopping point or a configured stop sequence.
     */ FinishReason["STOP"] = "STOP";
    /**
     * Token generation reached the configured maximum output tokens.
     */ FinishReason["MAX_TOKENS"] = "MAX_TOKENS";
    /**
     * Token generation stopped because the content potentially contains safety violations. NOTE: When streaming, [content][] is empty if content filters blocks the output.
     */ FinishReason["SAFETY"] = "SAFETY";
    /**
     * The token generation stopped because of potential recitation.
     */ FinishReason["RECITATION"] = "RECITATION";
    /**
     * The token generation stopped because of using an unsupported language.
     */ FinishReason["LANGUAGE"] = "LANGUAGE";
    /**
     * All other reasons that stopped the token generation.
     */ FinishReason["OTHER"] = "OTHER";
    /**
     * Token generation stopped because the content contains forbidden terms.
     */ FinishReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * Token generation stopped for potentially containing prohibited content.
     */ FinishReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
    /**
     * Token generation stopped because the content potentially contains Sensitive Personally Identifiable Information (SPII).
     */ FinishReason["SPII"] = "SPII";
    /**
     * The function call generated by the model is invalid.
     */ FinishReason["MALFORMED_FUNCTION_CALL"] = "MALFORMED_FUNCTION_CALL";
    /**
     * Token generation stopped because generated images have safety violations.
     */ FinishReason["IMAGE_SAFETY"] = "IMAGE_SAFETY";
    /**
     * The tool call generated by the model is invalid.
     */ FinishReason["UNEXPECTED_TOOL_CALL"] = "UNEXPECTED_TOOL_CALL";
    /**
     * Image generation stopped because the generated images have prohibited content.
     */ FinishReason["IMAGE_PROHIBITED_CONTENT"] = "IMAGE_PROHIBITED_CONTENT";
    /**
     * The model was expected to generate an image, but none was generated.
     */ FinishReason["NO_IMAGE"] = "NO_IMAGE";
    /**
     * Image generation stopped because the generated image may be a recitation from a source.
     */ FinishReason["IMAGE_RECITATION"] = "IMAGE_RECITATION";
    /**
     * Image generation stopped for a reason not otherwise specified.
     */ FinishReason["IMAGE_OTHER"] = "IMAGE_OTHER";
})($e4deb49dba5321bc$export$e94f0100e6b2fa1a || ($e4deb49dba5321bc$export$e94f0100e6b2fa1a = {}));
/** Output only. The probability of harm for this category. */ var $e4deb49dba5321bc$export$d51a615154b7f9a;
(function(HarmProbability) {
    /**
     * The harm probability is unspecified.
     */ HarmProbability["HARM_PROBABILITY_UNSPECIFIED"] = "HARM_PROBABILITY_UNSPECIFIED";
    /**
     * The harm probability is negligible.
     */ HarmProbability["NEGLIGIBLE"] = "NEGLIGIBLE";
    /**
     * The harm probability is low.
     */ HarmProbability["LOW"] = "LOW";
    /**
     * The harm probability is medium.
     */ HarmProbability["MEDIUM"] = "MEDIUM";
    /**
     * The harm probability is high.
     */ HarmProbability["HIGH"] = "HIGH";
})($e4deb49dba5321bc$export$d51a615154b7f9a || ($e4deb49dba5321bc$export$d51a615154b7f9a = {}));
/** Output only. The severity of harm for this category. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$7b3efb76b33fbefa;
(function(HarmSeverity) {
    /**
     * The harm severity is unspecified.
     */ HarmSeverity["HARM_SEVERITY_UNSPECIFIED"] = "HARM_SEVERITY_UNSPECIFIED";
    /**
     * The harm severity is negligible.
     */ HarmSeverity["HARM_SEVERITY_NEGLIGIBLE"] = "HARM_SEVERITY_NEGLIGIBLE";
    /**
     * The harm severity is low.
     */ HarmSeverity["HARM_SEVERITY_LOW"] = "HARM_SEVERITY_LOW";
    /**
     * The harm severity is medium.
     */ HarmSeverity["HARM_SEVERITY_MEDIUM"] = "HARM_SEVERITY_MEDIUM";
    /**
     * The harm severity is high.
     */ HarmSeverity["HARM_SEVERITY_HIGH"] = "HARM_SEVERITY_HIGH";
})($e4deb49dba5321bc$export$7b3efb76b33fbefa || ($e4deb49dba5321bc$export$7b3efb76b33fbefa = {}));
/** The status of the URL retrieval. */ var $e4deb49dba5321bc$export$975c9cf3fb61453a;
(function(UrlRetrievalStatus) {
    /**
     * Default value. This value is unused.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_UNSPECIFIED"] = "URL_RETRIEVAL_STATUS_UNSPECIFIED";
    /**
     * The URL was retrieved successfully.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_SUCCESS"] = "URL_RETRIEVAL_STATUS_SUCCESS";
    /**
     * The URL retrieval failed.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_ERROR"] = "URL_RETRIEVAL_STATUS_ERROR";
    /**
     * Url retrieval is failed because the content is behind paywall. This enum value is not supported in Vertex AI.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_PAYWALL"] = "URL_RETRIEVAL_STATUS_PAYWALL";
    /**
     * Url retrieval is failed because the content is unsafe. This enum value is not supported in Vertex AI.
     */ UrlRetrievalStatus["URL_RETRIEVAL_STATUS_UNSAFE"] = "URL_RETRIEVAL_STATUS_UNSAFE";
})($e4deb49dba5321bc$export$975c9cf3fb61453a || ($e4deb49dba5321bc$export$975c9cf3fb61453a = {}));
/** Output only. The reason why the prompt was blocked. */ var $e4deb49dba5321bc$export$b3338cf9227c61d4;
(function(BlockedReason) {
    /**
     * The blocked reason is unspecified.
     */ BlockedReason["BLOCKED_REASON_UNSPECIFIED"] = "BLOCKED_REASON_UNSPECIFIED";
    /**
     * The prompt was blocked for safety reasons.
     */ BlockedReason["SAFETY"] = "SAFETY";
    /**
     * The prompt was blocked for other reasons. For example, it may be due to the prompt's language, or because it contains other harmful content.
     */ BlockedReason["OTHER"] = "OTHER";
    /**
     * The prompt was blocked because it contains a term from the terminology blocklist.
     */ BlockedReason["BLOCKLIST"] = "BLOCKLIST";
    /**
     * The prompt was blocked because it contains prohibited content.
     */ BlockedReason["PROHIBITED_CONTENT"] = "PROHIBITED_CONTENT";
    /**
     * The prompt was blocked because it contains content that is unsafe for image generation.
     */ BlockedReason["IMAGE_SAFETY"] = "IMAGE_SAFETY";
    /**
     * The prompt was blocked by Model Armor. This enum value is not supported in Gemini API.
     */ BlockedReason["MODEL_ARMOR"] = "MODEL_ARMOR";
    /**
     * The prompt was blocked as a jailbreak attempt. This enum value is not supported in Gemini API.
     */ BlockedReason["JAILBREAK"] = "JAILBREAK";
})($e4deb49dba5321bc$export$b3338cf9227c61d4 || ($e4deb49dba5321bc$export$b3338cf9227c61d4 = {}));
/** Output only. The traffic type for this request. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$fd67c688a6010ded;
(function(TrafficType) {
    /**
     * Unspecified request traffic type.
     */ TrafficType["TRAFFIC_TYPE_UNSPECIFIED"] = "TRAFFIC_TYPE_UNSPECIFIED";
    /**
     * The request was processed using Pay-As-You-Go quota.
     */ TrafficType["ON_DEMAND"] = "ON_DEMAND";
    /**
     * Type for Priority Pay-As-You-Go traffic.
     */ TrafficType["ON_DEMAND_PRIORITY"] = "ON_DEMAND_PRIORITY";
    /**
     * Type for Flex traffic.
     */ TrafficType["ON_DEMAND_FLEX"] = "ON_DEMAND_FLEX";
    /**
     * Type for Provisioned Throughput traffic.
     */ TrafficType["PROVISIONED_THROUGHPUT"] = "PROVISIONED_THROUGHPUT";
})($e4deb49dba5321bc$export$fd67c688a6010ded || ($e4deb49dba5321bc$export$fd67c688a6010ded = {}));
/** Server content modalities. */ var $e4deb49dba5321bc$export$9c9a8220008ddfc0;
(function(Modality) {
    /**
     * The modality is unspecified.
     */ Modality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Indicates the model should return text
     */ Modality["TEXT"] = "TEXT";
    /**
     * Indicates the model should return images.
     */ Modality["IMAGE"] = "IMAGE";
    /**
     * Indicates the model should return audio.
     */ Modality["AUDIO"] = "AUDIO";
})($e4deb49dba5321bc$export$9c9a8220008ddfc0 || ($e4deb49dba5321bc$export$9c9a8220008ddfc0 = {}));
/** The stage of the underlying model. This enum is not supported in Vertex AI. */ var $e4deb49dba5321bc$export$aaca900f87455b2;
(function(ModelStage) {
    /**
     * Unspecified model stage.
     */ ModelStage["MODEL_STAGE_UNSPECIFIED"] = "MODEL_STAGE_UNSPECIFIED";
    /**
     * The underlying model is subject to lots of tunings.
     */ ModelStage["UNSTABLE_EXPERIMENTAL"] = "UNSTABLE_EXPERIMENTAL";
    /**
     * Models in this stage are for experimental purposes only.
     */ ModelStage["EXPERIMENTAL"] = "EXPERIMENTAL";
    /**
     * Models in this stage are more mature than experimental models.
     */ ModelStage["PREVIEW"] = "PREVIEW";
    /**
     * Models in this stage are considered stable and ready for production use.
     */ ModelStage["STABLE"] = "STABLE";
    /**
     * If the model is on this stage, it means that this model is on the path to deprecation in near future. Only existing customers can use this model.
     */ ModelStage["LEGACY"] = "LEGACY";
    /**
     * Models in this stage are deprecated. These models cannot be used.
     */ ModelStage["DEPRECATED"] = "DEPRECATED";
    /**
     * Models in this stage are retired. These models cannot be used.
     */ ModelStage["RETIRED"] = "RETIRED";
})($e4deb49dba5321bc$export$aaca900f87455b2 || ($e4deb49dba5321bc$export$aaca900f87455b2 = {}));
/** The media resolution to use. */ var $e4deb49dba5321bc$export$c7a89108d7123ab7;
(function(MediaResolution) {
    /**
     * Media resolution has not been set
     */ MediaResolution["MEDIA_RESOLUTION_UNSPECIFIED"] = "MEDIA_RESOLUTION_UNSPECIFIED";
    /**
     * Media resolution set to low (64 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_LOW"] = "MEDIA_RESOLUTION_LOW";
    /**
     * Media resolution set to medium (256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_MEDIUM"] = "MEDIA_RESOLUTION_MEDIUM";
    /**
     * Media resolution set to high (zoomed reframing with 256 tokens).
     */ MediaResolution["MEDIA_RESOLUTION_HIGH"] = "MEDIA_RESOLUTION_HIGH";
})($e4deb49dba5321bc$export$c7a89108d7123ab7 || ($e4deb49dba5321bc$export$c7a89108d7123ab7 = {}));
/** Tuning mode. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$8c0e99cba1f473f5;
(function(TuningMode) {
    /**
     * Tuning mode is unspecified.
     */ TuningMode["TUNING_MODE_UNSPECIFIED"] = "TUNING_MODE_UNSPECIFIED";
    /**
     * Full fine-tuning mode.
     */ TuningMode["TUNING_MODE_FULL"] = "TUNING_MODE_FULL";
    /**
     * PEFT adapter tuning mode.
     */ TuningMode["TUNING_MODE_PEFT_ADAPTER"] = "TUNING_MODE_PEFT_ADAPTER";
})($e4deb49dba5321bc$export$8c0e99cba1f473f5 || ($e4deb49dba5321bc$export$8c0e99cba1f473f5 = {}));
/** Adapter size for tuning. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$4d0388a23e87b9ee;
(function(AdapterSize) {
    /**
     * Adapter size is unspecified.
     */ AdapterSize["ADAPTER_SIZE_UNSPECIFIED"] = "ADAPTER_SIZE_UNSPECIFIED";
    /**
     * Adapter size 1.
     */ AdapterSize["ADAPTER_SIZE_ONE"] = "ADAPTER_SIZE_ONE";
    /**
     * Adapter size 2.
     */ AdapterSize["ADAPTER_SIZE_TWO"] = "ADAPTER_SIZE_TWO";
    /**
     * Adapter size 4.
     */ AdapterSize["ADAPTER_SIZE_FOUR"] = "ADAPTER_SIZE_FOUR";
    /**
     * Adapter size 8.
     */ AdapterSize["ADAPTER_SIZE_EIGHT"] = "ADAPTER_SIZE_EIGHT";
    /**
     * Adapter size 16.
     */ AdapterSize["ADAPTER_SIZE_SIXTEEN"] = "ADAPTER_SIZE_SIXTEEN";
    /**
     * Adapter size 32.
     */ AdapterSize["ADAPTER_SIZE_THIRTY_TWO"] = "ADAPTER_SIZE_THIRTY_TWO";
})($e4deb49dba5321bc$export$4d0388a23e87b9ee || ($e4deb49dba5321bc$export$4d0388a23e87b9ee = {}));
/** Job state. */ var $e4deb49dba5321bc$export$d30a7cb66801c974;
(function(JobState) {
    /**
     * The job state is unspecified.
     */ JobState["JOB_STATE_UNSPECIFIED"] = "JOB_STATE_UNSPECIFIED";
    /**
     * The job has been just created or resumed and processing has not yet begun.
     */ JobState["JOB_STATE_QUEUED"] = "JOB_STATE_QUEUED";
    /**
     * The service is preparing to run the job.
     */ JobState["JOB_STATE_PENDING"] = "JOB_STATE_PENDING";
    /**
     * The job is in progress.
     */ JobState["JOB_STATE_RUNNING"] = "JOB_STATE_RUNNING";
    /**
     * The job completed successfully.
     */ JobState["JOB_STATE_SUCCEEDED"] = "JOB_STATE_SUCCEEDED";
    /**
     * The job failed.
     */ JobState["JOB_STATE_FAILED"] = "JOB_STATE_FAILED";
    /**
     * The job is being cancelled. From this state the job may only go to either `JOB_STATE_SUCCEEDED`, `JOB_STATE_FAILED` or `JOB_STATE_CANCELLED`.
     */ JobState["JOB_STATE_CANCELLING"] = "JOB_STATE_CANCELLING";
    /**
     * The job has been cancelled.
     */ JobState["JOB_STATE_CANCELLED"] = "JOB_STATE_CANCELLED";
    /**
     * The job has been stopped, and can be resumed.
     */ JobState["JOB_STATE_PAUSED"] = "JOB_STATE_PAUSED";
    /**
     * The job has expired.
     */ JobState["JOB_STATE_EXPIRED"] = "JOB_STATE_EXPIRED";
    /**
     * The job is being updated. Only jobs in the `JOB_STATE_RUNNING` state can be updated. After updating, the job goes back to the `JOB_STATE_RUNNING` state.
     */ JobState["JOB_STATE_UPDATING"] = "JOB_STATE_UPDATING";
    /**
     * The job is partially succeeded, some results may be missing due to errors.
     */ JobState["JOB_STATE_PARTIALLY_SUCCEEDED"] = "JOB_STATE_PARTIALLY_SUCCEEDED";
})($e4deb49dba5321bc$export$d30a7cb66801c974 || ($e4deb49dba5321bc$export$d30a7cb66801c974 = {}));
/** Output only. The detail state of the tuning job (while the overall `JobState` is running). This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$e3226ba271c1a3bc;
(function(TuningJobState) {
    /**
     * Default tuning job state.
     */ TuningJobState["TUNING_JOB_STATE_UNSPECIFIED"] = "TUNING_JOB_STATE_UNSPECIFIED";
    /**
     * Tuning job is waiting for job quota.
     */ TuningJobState["TUNING_JOB_STATE_WAITING_FOR_QUOTA"] = "TUNING_JOB_STATE_WAITING_FOR_QUOTA";
    /**
     * Tuning job is validating the dataset.
     */ TuningJobState["TUNING_JOB_STATE_PROCESSING_DATASET"] = "TUNING_JOB_STATE_PROCESSING_DATASET";
    /**
     * Tuning job is waiting for hardware capacity.
     */ TuningJobState["TUNING_JOB_STATE_WAITING_FOR_CAPACITY"] = "TUNING_JOB_STATE_WAITING_FOR_CAPACITY";
    /**
     * Tuning job is running.
     */ TuningJobState["TUNING_JOB_STATE_TUNING"] = "TUNING_JOB_STATE_TUNING";
    /**
     * Tuning job is doing some post processing steps.
     */ TuningJobState["TUNING_JOB_STATE_POST_PROCESSING"] = "TUNING_JOB_STATE_POST_PROCESSING";
})($e4deb49dba5321bc$export$e3226ba271c1a3bc || ($e4deb49dba5321bc$export$e3226ba271c1a3bc = {}));
/** Aggregation metric. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$37794e35e9e49bf0;
(function(AggregationMetric) {
    /**
     * Unspecified aggregation metric.
     */ AggregationMetric["AGGREGATION_METRIC_UNSPECIFIED"] = "AGGREGATION_METRIC_UNSPECIFIED";
    /**
     * Average aggregation metric. Not supported for Pairwise metric.
     */ AggregationMetric["AVERAGE"] = "AVERAGE";
    /**
     * Mode aggregation metric.
     */ AggregationMetric["MODE"] = "MODE";
    /**
     * Standard deviation aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["STANDARD_DEVIATION"] = "STANDARD_DEVIATION";
    /**
     * Variance aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["VARIANCE"] = "VARIANCE";
    /**
     * Minimum aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["MINIMUM"] = "MINIMUM";
    /**
     * Maximum aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["MAXIMUM"] = "MAXIMUM";
    /**
     * Median aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["MEDIAN"] = "MEDIAN";
    /**
     * 90th percentile aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["PERCENTILE_P90"] = "PERCENTILE_P90";
    /**
     * 95th percentile aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["PERCENTILE_P95"] = "PERCENTILE_P95";
    /**
     * 99th percentile aggregation metric. Not supported for pairwise metric.
     */ AggregationMetric["PERCENTILE_P99"] = "PERCENTILE_P99";
})($e4deb49dba5321bc$export$37794e35e9e49bf0 || ($e4deb49dba5321bc$export$37794e35e9e49bf0 = {}));
/** Output only. Pairwise metric choice. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$de04308f420c4317;
(function(PairwiseChoice) {
    /**
     * Unspecified prediction choice.
     */ PairwiseChoice["PAIRWISE_CHOICE_UNSPECIFIED"] = "PAIRWISE_CHOICE_UNSPECIFIED";
    /**
     * Baseline prediction wins
     */ PairwiseChoice["BASELINE"] = "BASELINE";
    /**
     * Candidate prediction wins
     */ PairwiseChoice["CANDIDATE"] = "CANDIDATE";
    /**
     * Winner cannot be determined
     */ PairwiseChoice["TIE"] = "TIE";
})($e4deb49dba5321bc$export$de04308f420c4317 || ($e4deb49dba5321bc$export$de04308f420c4317 = {}));
/** The tuning task. Either I2V or T2V. This enum is not supported in Gemini API. */ var $e4deb49dba5321bc$export$c219c92dc5374d63;
(function(TuningTask) {
    /**
     * Default value. This value is unused.
     */ TuningTask["TUNING_TASK_UNSPECIFIED"] = "TUNING_TASK_UNSPECIFIED";
    /**
     * Tuning task for image to video.
     */ TuningTask["TUNING_TASK_I2V"] = "TUNING_TASK_I2V";
    /**
     * Tuning task for text to video.
     */ TuningTask["TUNING_TASK_T2V"] = "TUNING_TASK_T2V";
    /**
     * Tuning task for reference to video.
     */ TuningTask["TUNING_TASK_R2V"] = "TUNING_TASK_R2V";
})($e4deb49dba5321bc$export$c219c92dc5374d63 || ($e4deb49dba5321bc$export$c219c92dc5374d63 = {}));
/** Output only. Current state of the `Document`. This enum is not supported in Vertex AI. */ var $e4deb49dba5321bc$export$4c6f7616f18c0be;
(function(DocumentState) {
    /**
     * The default value. This value is used if the state is omitted.
     */ DocumentState["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    /**
     * Some `Chunks` of the `Document` are being processed (embedding and vector storage).
     */ DocumentState["STATE_PENDING"] = "STATE_PENDING";
    /**
     * All `Chunks` of the `Document` is processed and available for querying.
     */ DocumentState["STATE_ACTIVE"] = "STATE_ACTIVE";
    /**
     * Some `Chunks` of the `Document` failed processing.
     */ DocumentState["STATE_FAILED"] = "STATE_FAILED";
})($e4deb49dba5321bc$export$4c6f7616f18c0be || ($e4deb49dba5321bc$export$4c6f7616f18c0be = {}));
/** The tokenization quality used for given media. */ var $e4deb49dba5321bc$export$e11a6ed625c60d8a;
(function(PartMediaResolutionLevel) {
    /**
     * Media resolution has not been set.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_UNSPECIFIED"] = "MEDIA_RESOLUTION_UNSPECIFIED";
    /**
     * Media resolution set to low.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_LOW"] = "MEDIA_RESOLUTION_LOW";
    /**
     * Media resolution set to medium.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_MEDIUM"] = "MEDIA_RESOLUTION_MEDIUM";
    /**
     * Media resolution set to high.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_HIGH"] = "MEDIA_RESOLUTION_HIGH";
    /**
     * Media resolution set to ultra high.
     */ PartMediaResolutionLevel["MEDIA_RESOLUTION_ULTRA_HIGH"] = "MEDIA_RESOLUTION_ULTRA_HIGH";
})($e4deb49dba5321bc$export$e11a6ed625c60d8a || ($e4deb49dba5321bc$export$e11a6ed625c60d8a = {}));
/** The type of tool in the function call. */ var $e4deb49dba5321bc$export$707234614e94de52;
(function(ToolType) {
    /**
     * Unspecified tool type.
     */ ToolType["TOOL_TYPE_UNSPECIFIED"] = "TOOL_TYPE_UNSPECIFIED";
    /**
     * Google search tool, maps to Tool.google_search.search_types.web_search.
     */ ToolType["GOOGLE_SEARCH_WEB"] = "GOOGLE_SEARCH_WEB";
    /**
     * Image search tool, maps to Tool.google_search.search_types.image_search.
     */ ToolType["GOOGLE_SEARCH_IMAGE"] = "GOOGLE_SEARCH_IMAGE";
    /**
     * URL context tool, maps to Tool.url_context.
     */ ToolType["URL_CONTEXT"] = "URL_CONTEXT";
    /**
     * Google maps tool, maps to Tool.google_maps.
     */ ToolType["GOOGLE_MAPS"] = "GOOGLE_MAPS";
    /**
     * File search tool, maps to Tool.file_search.
     */ ToolType["FILE_SEARCH"] = "FILE_SEARCH";
})($e4deb49dba5321bc$export$707234614e94de52 || ($e4deb49dba5321bc$export$707234614e94de52 = {}));
/** Resource scope. */ var $e4deb49dba5321bc$export$ce358901f8c7a617;
(function(ResourceScope) {
    /**
     * When setting base_url, this value configures resource scope to be the collection.
        The resource name will not include api version, project, or location.
        For example, if base_url is set to "https://aiplatform.googleapis.com",
        then the resource name for a Model would be
        "https://aiplatform.googleapis.com/publishers/google/models/gemini-3-pro-preview
     */ ResourceScope["COLLECTION"] = "COLLECTION";
})($e4deb49dba5321bc$export$ce358901f8c7a617 || ($e4deb49dba5321bc$export$ce358901f8c7a617 = {}));
/** Pricing and performance service tier. */ var $e4deb49dba5321bc$export$2c967c63a4c92b8;
(function(ServiceTier) {
    /**
     * Default service tier, which is standard.
     */ ServiceTier["UNSPECIFIED"] = "unspecified";
    /**
     * Flex service tier.
     */ ServiceTier["FLEX"] = "flex";
    /**
     * Standard service tier.
     */ ServiceTier["STANDARD"] = "standard";
    /**
     * Priority service tier.
     */ ServiceTier["PRIORITY"] = "priority";
})($e4deb49dba5321bc$export$2c967c63a4c92b8 || ($e4deb49dba5321bc$export$2c967c63a4c92b8 = {}));
/** Options for feature selection preference. */ var $e4deb49dba5321bc$export$5154132c56fb1c00;
(function(FeatureSelectionPreference) {
    FeatureSelectionPreference["FEATURE_SELECTION_PREFERENCE_UNSPECIFIED"] = "FEATURE_SELECTION_PREFERENCE_UNSPECIFIED";
    FeatureSelectionPreference["PRIORITIZE_QUALITY"] = "PRIORITIZE_QUALITY";
    FeatureSelectionPreference["BALANCED"] = "BALANCED";
    FeatureSelectionPreference["PRIORITIZE_COST"] = "PRIORITIZE_COST";
})($e4deb49dba5321bc$export$5154132c56fb1c00 || ($e4deb49dba5321bc$export$5154132c56fb1c00 = {}));
/** Enum representing the Vertex embedding API to use. */ var $e4deb49dba5321bc$export$adb1a6c77f7d58e6;
(function(EmbeddingApiType) {
    /**
     * predict API endpoint (default)
     */ EmbeddingApiType["PREDICT"] = "PREDICT";
    /**
     * embedContent API Endpoint
     */ EmbeddingApiType["EMBED_CONTENT"] = "EMBED_CONTENT";
})($e4deb49dba5321bc$export$adb1a6c77f7d58e6 || ($e4deb49dba5321bc$export$adb1a6c77f7d58e6 = {}));
/** Enum that controls the safety filter level for objectionable content. */ var $e4deb49dba5321bc$export$5204024137f6aea1;
(function(SafetyFilterLevel) {
    SafetyFilterLevel["BLOCK_LOW_AND_ABOVE"] = "BLOCK_LOW_AND_ABOVE";
    SafetyFilterLevel["BLOCK_MEDIUM_AND_ABOVE"] = "BLOCK_MEDIUM_AND_ABOVE";
    SafetyFilterLevel["BLOCK_ONLY_HIGH"] = "BLOCK_ONLY_HIGH";
    SafetyFilterLevel["BLOCK_NONE"] = "BLOCK_NONE";
})($e4deb49dba5321bc$export$5204024137f6aea1 || ($e4deb49dba5321bc$export$5204024137f6aea1 = {}));
/** Enum that specifies the language of the text in the prompt. */ var $e4deb49dba5321bc$export$504293347a2f9b0;
(function(ImagePromptLanguage) {
    /**
     * Auto-detect the language.
     */ ImagePromptLanguage["auto"] = "auto";
    /**
     * English
     */ ImagePromptLanguage["en"] = "en";
    /**
     * Japanese
     */ ImagePromptLanguage["ja"] = "ja";
    /**
     * Korean
     */ ImagePromptLanguage["ko"] = "ko";
    /**
     * Hindi
     */ ImagePromptLanguage["hi"] = "hi";
    /**
     * Chinese
     */ ImagePromptLanguage["zh"] = "zh";
    /**
     * Portuguese
     */ ImagePromptLanguage["pt"] = "pt";
    /**
     * Spanish
     */ ImagePromptLanguage["es"] = "es";
})($e4deb49dba5321bc$export$504293347a2f9b0 || ($e4deb49dba5321bc$export$504293347a2f9b0 = {}));
/** Enum representing the mask mode of a mask reference image. */ var $e4deb49dba5321bc$export$76940fd539710332;
(function(MaskReferenceMode) {
    MaskReferenceMode["MASK_MODE_DEFAULT"] = "MASK_MODE_DEFAULT";
    MaskReferenceMode["MASK_MODE_USER_PROVIDED"] = "MASK_MODE_USER_PROVIDED";
    MaskReferenceMode["MASK_MODE_BACKGROUND"] = "MASK_MODE_BACKGROUND";
    MaskReferenceMode["MASK_MODE_FOREGROUND"] = "MASK_MODE_FOREGROUND";
    MaskReferenceMode["MASK_MODE_SEMANTIC"] = "MASK_MODE_SEMANTIC";
})($e4deb49dba5321bc$export$76940fd539710332 || ($e4deb49dba5321bc$export$76940fd539710332 = {}));
/** Enum representing the control type of a control reference image. */ var $e4deb49dba5321bc$export$26974b3b69e46d1d;
(function(ControlReferenceType) {
    ControlReferenceType["CONTROL_TYPE_DEFAULT"] = "CONTROL_TYPE_DEFAULT";
    ControlReferenceType["CONTROL_TYPE_CANNY"] = "CONTROL_TYPE_CANNY";
    ControlReferenceType["CONTROL_TYPE_SCRIBBLE"] = "CONTROL_TYPE_SCRIBBLE";
    ControlReferenceType["CONTROL_TYPE_FACE_MESH"] = "CONTROL_TYPE_FACE_MESH";
})($e4deb49dba5321bc$export$26974b3b69e46d1d || ($e4deb49dba5321bc$export$26974b3b69e46d1d = {}));
/** Enum representing the subject type of a subject reference image. */ var $e4deb49dba5321bc$export$59262bdf2638eb32;
(function(SubjectReferenceType) {
    SubjectReferenceType["SUBJECT_TYPE_DEFAULT"] = "SUBJECT_TYPE_DEFAULT";
    SubjectReferenceType["SUBJECT_TYPE_PERSON"] = "SUBJECT_TYPE_PERSON";
    SubjectReferenceType["SUBJECT_TYPE_ANIMAL"] = "SUBJECT_TYPE_ANIMAL";
    SubjectReferenceType["SUBJECT_TYPE_PRODUCT"] = "SUBJECT_TYPE_PRODUCT";
})($e4deb49dba5321bc$export$59262bdf2638eb32 || ($e4deb49dba5321bc$export$59262bdf2638eb32 = {}));
/** Enum representing the editing mode. */ var $e4deb49dba5321bc$export$5304145354a3bee9;
(function(EditMode) {
    EditMode["EDIT_MODE_DEFAULT"] = "EDIT_MODE_DEFAULT";
    EditMode["EDIT_MODE_INPAINT_REMOVAL"] = "EDIT_MODE_INPAINT_REMOVAL";
    EditMode["EDIT_MODE_INPAINT_INSERTION"] = "EDIT_MODE_INPAINT_INSERTION";
    EditMode["EDIT_MODE_OUTPAINT"] = "EDIT_MODE_OUTPAINT";
    EditMode["EDIT_MODE_CONTROLLED_EDITING"] = "EDIT_MODE_CONTROLLED_EDITING";
    EditMode["EDIT_MODE_STYLE"] = "EDIT_MODE_STYLE";
    EditMode["EDIT_MODE_BGSWAP"] = "EDIT_MODE_BGSWAP";
    EditMode["EDIT_MODE_PRODUCT_IMAGE"] = "EDIT_MODE_PRODUCT_IMAGE";
})($e4deb49dba5321bc$export$5304145354a3bee9 || ($e4deb49dba5321bc$export$5304145354a3bee9 = {}));
/** Enum that represents the segmentation mode. */ var $e4deb49dba5321bc$export$824f092534347f02;
(function(SegmentMode) {
    SegmentMode["FOREGROUND"] = "FOREGROUND";
    SegmentMode["BACKGROUND"] = "BACKGROUND";
    SegmentMode["PROMPT"] = "PROMPT";
    SegmentMode["SEMANTIC"] = "SEMANTIC";
    SegmentMode["INTERACTIVE"] = "INTERACTIVE";
})($e4deb49dba5321bc$export$824f092534347f02 || ($e4deb49dba5321bc$export$824f092534347f02 = {}));
/** Enum for the reference type of a video generation reference image. */ var $e4deb49dba5321bc$export$492cea19f892fe1e;
(function(VideoGenerationReferenceType) {
    /**
     * A reference image that provides assets to the generated video,
        such as the scene, an object, a character, etc.
     */ VideoGenerationReferenceType["ASSET"] = "ASSET";
    /**
     * A reference image that provides aesthetics including colors,
        lighting, texture, etc., to be used as the style of the generated video,
        such as 'anime', 'photography', 'origami', etc.
     */ VideoGenerationReferenceType["STYLE"] = "STYLE";
})($e4deb49dba5321bc$export$492cea19f892fe1e || ($e4deb49dba5321bc$export$492cea19f892fe1e = {}));
/** Enum for the mask mode of a video generation mask. */ var $e4deb49dba5321bc$export$99d85d0ee14173f1;
(function(VideoGenerationMaskMode) {
    /**
     * The image mask contains a masked rectangular region which is
        applied on the first frame of the input video. The object described in
        the prompt is inserted into this region and will appear in subsequent
        frames.
     */ VideoGenerationMaskMode["INSERT"] = "INSERT";
    /**
     * The image mask is used to determine an object in the
        first video frame to track. This object is removed from the video.
     */ VideoGenerationMaskMode["REMOVE"] = "REMOVE";
    /**
     * The image mask is used to determine a region in the
        video. Objects in this region will be removed.
     */ VideoGenerationMaskMode["REMOVE_STATIC"] = "REMOVE_STATIC";
    /**
     * The image mask contains a masked rectangular region where
        the input video will go. The remaining area will be generated. Video
        masks are not supported.
     */ VideoGenerationMaskMode["OUTPAINT"] = "OUTPAINT";
})($e4deb49dba5321bc$export$99d85d0ee14173f1 || ($e4deb49dba5321bc$export$99d85d0ee14173f1 = {}));
/** Enum that controls the compression quality of the generated videos. */ var $e4deb49dba5321bc$export$c8d56a80437cfac3;
(function(VideoCompressionQuality) {
    /**
     * Optimized video compression quality. This will produce videos
        with a compressed, smaller file size.
     */ VideoCompressionQuality["OPTIMIZED"] = "OPTIMIZED";
    /**
     * Lossless video compression quality. This will produce videos
        with a larger file size.
     */ VideoCompressionQuality["LOSSLESS"] = "LOSSLESS";
})($e4deb49dba5321bc$export$c8d56a80437cfac3 || ($e4deb49dba5321bc$export$c8d56a80437cfac3 = {}));
/** Enum representing the tuning method. */ var $e4deb49dba5321bc$export$d72986ac56b9469e;
(function(TuningMethod) {
    /**
     * Supervised fine tuning.
     */ TuningMethod["SUPERVISED_FINE_TUNING"] = "SUPERVISED_FINE_TUNING";
    /**
     * Preference optimization tuning.
     */ TuningMethod["PREFERENCE_TUNING"] = "PREFERENCE_TUNING";
    /**
     * Distillation tuning.
     */ TuningMethod["DISTILLATION"] = "DISTILLATION";
})($e4deb49dba5321bc$export$d72986ac56b9469e || ($e4deb49dba5321bc$export$d72986ac56b9469e = {}));
/** State for the lifecycle of a File. */ var $e4deb49dba5321bc$export$4ddb69e6513a9971;
(function(FileState) {
    FileState["STATE_UNSPECIFIED"] = "STATE_UNSPECIFIED";
    FileState["PROCESSING"] = "PROCESSING";
    FileState["ACTIVE"] = "ACTIVE";
    FileState["FAILED"] = "FAILED";
})($e4deb49dba5321bc$export$4ddb69e6513a9971 || ($e4deb49dba5321bc$export$4ddb69e6513a9971 = {}));
/** Source of the File. */ var $e4deb49dba5321bc$export$27a4864e1e35718c;
(function(FileSource) {
    FileSource["SOURCE_UNSPECIFIED"] = "SOURCE_UNSPECIFIED";
    FileSource["UPLOADED"] = "UPLOADED";
    FileSource["GENERATED"] = "GENERATED";
    FileSource["REGISTERED"] = "REGISTERED";
})($e4deb49dba5321bc$export$27a4864e1e35718c || ($e4deb49dba5321bc$export$27a4864e1e35718c = {}));
/** The reason why the turn is complete. */ var $e4deb49dba5321bc$export$99c4e0f48ba51160;
(function(TurnCompleteReason) {
    /**
     * Default value. Reason is unspecified.
     */ TurnCompleteReason["TURN_COMPLETE_REASON_UNSPECIFIED"] = "TURN_COMPLETE_REASON_UNSPECIFIED";
    /**
     * The function call generated by the model is invalid.
     */ TurnCompleteReason["MALFORMED_FUNCTION_CALL"] = "MALFORMED_FUNCTION_CALL";
    /**
     * The response is rejected by the model.
     */ TurnCompleteReason["RESPONSE_REJECTED"] = "RESPONSE_REJECTED";
    /**
     * Needs more input from the user.
     */ TurnCompleteReason["NEED_MORE_INPUT"] = "NEED_MORE_INPUT";
})($e4deb49dba5321bc$export$99c4e0f48ba51160 || ($e4deb49dba5321bc$export$99c4e0f48ba51160 = {}));
/** Server content modalities. */ var $e4deb49dba5321bc$export$cd2f9f264fad7b02;
(function(MediaModality) {
    /**
     * The modality is unspecified.
     */ MediaModality["MODALITY_UNSPECIFIED"] = "MODALITY_UNSPECIFIED";
    /**
     * Plain text.
     */ MediaModality["TEXT"] = "TEXT";
    /**
     * Images.
     */ MediaModality["IMAGE"] = "IMAGE";
    /**
     * Video.
     */ MediaModality["VIDEO"] = "VIDEO";
    /**
     * Audio.
     */ MediaModality["AUDIO"] = "AUDIO";
    /**
     * Document, e.g. PDF.
     */ MediaModality["DOCUMENT"] = "DOCUMENT";
})($e4deb49dba5321bc$export$cd2f9f264fad7b02 || ($e4deb49dba5321bc$export$cd2f9f264fad7b02 = {}));
/** The type of the VAD signal. */ var $e4deb49dba5321bc$export$d962e369f570c257;
(function(VadSignalType) {
    /**
     * The default is VAD_SIGNAL_TYPE_UNSPECIFIED.
     */ VadSignalType["VAD_SIGNAL_TYPE_UNSPECIFIED"] = "VAD_SIGNAL_TYPE_UNSPECIFIED";
    /**
     * Start of sentence signal.
     */ VadSignalType["VAD_SIGNAL_TYPE_SOS"] = "VAD_SIGNAL_TYPE_SOS";
    /**
     * End of sentence signal.
     */ VadSignalType["VAD_SIGNAL_TYPE_EOS"] = "VAD_SIGNAL_TYPE_EOS";
})($e4deb49dba5321bc$export$d962e369f570c257 || ($e4deb49dba5321bc$export$d962e369f570c257 = {}));
/** The type of the voice activity signal. */ var $e4deb49dba5321bc$export$4af8b5043679ed9b;
(function(VoiceActivityType) {
    /**
     * The default is VOICE_ACTIVITY_TYPE_UNSPECIFIED.
     */ VoiceActivityType["TYPE_UNSPECIFIED"] = "TYPE_UNSPECIFIED";
    /**
     * Start of sentence signal.
     */ VoiceActivityType["ACTIVITY_START"] = "ACTIVITY_START";
    /**
     * End of sentence signal.
     */ VoiceActivityType["ACTIVITY_END"] = "ACTIVITY_END";
})($e4deb49dba5321bc$export$4af8b5043679ed9b || ($e4deb49dba5321bc$export$4af8b5043679ed9b = {}));
/** Start of speech sensitivity. */ var $e4deb49dba5321bc$export$148372f2e0cd8282;
(function(StartSensitivity) {
    /**
     * The default is START_SENSITIVITY_LOW.
     */ StartSensitivity["START_SENSITIVITY_UNSPECIFIED"] = "START_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection will detect the start of speech more often.
     */ StartSensitivity["START_SENSITIVITY_HIGH"] = "START_SENSITIVITY_HIGH";
    /**
     * Automatic detection will detect the start of speech less often.
     */ StartSensitivity["START_SENSITIVITY_LOW"] = "START_SENSITIVITY_LOW";
})($e4deb49dba5321bc$export$148372f2e0cd8282 || ($e4deb49dba5321bc$export$148372f2e0cd8282 = {}));
/** End of speech sensitivity. */ var $e4deb49dba5321bc$export$c980be37f56c00d9;
(function(EndSensitivity) {
    /**
     * The default is END_SENSITIVITY_LOW.
     */ EndSensitivity["END_SENSITIVITY_UNSPECIFIED"] = "END_SENSITIVITY_UNSPECIFIED";
    /**
     * Automatic detection ends speech more often.
     */ EndSensitivity["END_SENSITIVITY_HIGH"] = "END_SENSITIVITY_HIGH";
    /**
     * Automatic detection ends speech less often.
     */ EndSensitivity["END_SENSITIVITY_LOW"] = "END_SENSITIVITY_LOW";
})($e4deb49dba5321bc$export$c980be37f56c00d9 || ($e4deb49dba5321bc$export$c980be37f56c00d9 = {}));
/** The different ways of handling user activity. */ var $e4deb49dba5321bc$export$d8dcee4c2401eaaa;
(function(ActivityHandling) {
    /**
     * If unspecified, the default behavior is `START_OF_ACTIVITY_INTERRUPTS`.
     */ ActivityHandling["ACTIVITY_HANDLING_UNSPECIFIED"] = "ACTIVITY_HANDLING_UNSPECIFIED";
    /**
     * If true, start of activity will interrupt the model's response (also called "barge in"). The model's current response will be cut-off in the moment of the interruption. This is the default behavior.
     */ ActivityHandling["START_OF_ACTIVITY_INTERRUPTS"] = "START_OF_ACTIVITY_INTERRUPTS";
    /**
     * The model's response will not be interrupted.
     */ ActivityHandling["NO_INTERRUPTION"] = "NO_INTERRUPTION";
})($e4deb49dba5321bc$export$d8dcee4c2401eaaa || ($e4deb49dba5321bc$export$d8dcee4c2401eaaa = {}));
/** Options about which input is included in the user's turn. */ var $e4deb49dba5321bc$export$23fe448c5e1fa7ce;
(function(TurnCoverage) {
    /**
     * If unspecified, the default behavior is `TURN_INCLUDES_ONLY_ACTIVITY`.
     */ TurnCoverage["TURN_COVERAGE_UNSPECIFIED"] = "TURN_COVERAGE_UNSPECIFIED";
    /**
     * The users turn only includes activity since the last turn, excluding inactivity (e.g. silence on the audio stream). This is the default behavior.
     */ TurnCoverage["TURN_INCLUDES_ONLY_ACTIVITY"] = "TURN_INCLUDES_ONLY_ACTIVITY";
    /**
     * The users turn includes all realtime input since the last turn, including inactivity (e.g. silence on the audio stream).
     */ TurnCoverage["TURN_INCLUDES_ALL_INPUT"] = "TURN_INCLUDES_ALL_INPUT";
    /**
     * Includes audio activity and all video since the last turn. With automatic activity detection, audio activity means speech and excludes silence.
     */ TurnCoverage["TURN_INCLUDES_AUDIO_ACTIVITY_AND_ALL_VIDEO"] = "TURN_INCLUDES_AUDIO_ACTIVITY_AND_ALL_VIDEO";
})($e4deb49dba5321bc$export$23fe448c5e1fa7ce || ($e4deb49dba5321bc$export$23fe448c5e1fa7ce = {}));
/** Scale of the generated music. */ var $e4deb49dba5321bc$export$d60cfc58d3c358b6;
(function(Scale) {
    /**
     * Default value. This value is unused.
     */ Scale["SCALE_UNSPECIFIED"] = "SCALE_UNSPECIFIED";
    /**
     * C major or A minor.
     */ Scale["C_MAJOR_A_MINOR"] = "C_MAJOR_A_MINOR";
    /**
     * Db major or Bb minor.
     */ Scale["D_FLAT_MAJOR_B_FLAT_MINOR"] = "D_FLAT_MAJOR_B_FLAT_MINOR";
    /**
     * D major or B minor.
     */ Scale["D_MAJOR_B_MINOR"] = "D_MAJOR_B_MINOR";
    /**
     * Eb major or C minor
     */ Scale["E_FLAT_MAJOR_C_MINOR"] = "E_FLAT_MAJOR_C_MINOR";
    /**
     * E major or Db minor.
     */ Scale["E_MAJOR_D_FLAT_MINOR"] = "E_MAJOR_D_FLAT_MINOR";
    /**
     * F major or D minor.
     */ Scale["F_MAJOR_D_MINOR"] = "F_MAJOR_D_MINOR";
    /**
     * Gb major or Eb minor.
     */ Scale["G_FLAT_MAJOR_E_FLAT_MINOR"] = "G_FLAT_MAJOR_E_FLAT_MINOR";
    /**
     * G major or E minor.
     */ Scale["G_MAJOR_E_MINOR"] = "G_MAJOR_E_MINOR";
    /**
     * Ab major or F minor.
     */ Scale["A_FLAT_MAJOR_F_MINOR"] = "A_FLAT_MAJOR_F_MINOR";
    /**
     * A major or Gb minor.
     */ Scale["A_MAJOR_G_FLAT_MINOR"] = "A_MAJOR_G_FLAT_MINOR";
    /**
     * Bb major or G minor.
     */ Scale["B_FLAT_MAJOR_G_MINOR"] = "B_FLAT_MAJOR_G_MINOR";
    /**
     * B major or Ab minor.
     */ Scale["B_MAJOR_A_FLAT_MINOR"] = "B_MAJOR_A_FLAT_MINOR";
})($e4deb49dba5321bc$export$d60cfc58d3c358b6 || ($e4deb49dba5321bc$export$d60cfc58d3c358b6 = {}));
/** The mode of music generation. */ var $e4deb49dba5321bc$export$23b8931bd532ef11;
(function(MusicGenerationMode) {
    /**
     * Rely on the server default generation mode.
     */ MusicGenerationMode["MUSIC_GENERATION_MODE_UNSPECIFIED"] = "MUSIC_GENERATION_MODE_UNSPECIFIED";
    /**
     * Steer text prompts to regions of latent space with higher quality
        music.
     */ MusicGenerationMode["QUALITY"] = "QUALITY";
    /**
     * Steer text prompts to regions of latent space with a larger
        diversity of music.
     */ MusicGenerationMode["DIVERSITY"] = "DIVERSITY";
    /**
     * Steer text prompts to regions of latent space more likely to
        generate music with vocals.
     */ MusicGenerationMode["VOCALIZATION"] = "VOCALIZATION";
})($e4deb49dba5321bc$export$23b8931bd532ef11 || ($e4deb49dba5321bc$export$23b8931bd532ef11 = {}));
/** The playback control signal to apply to the music generation. */ var $e4deb49dba5321bc$export$3d1b3b2fa769f3a;
(function(LiveMusicPlaybackControl) {
    /**
     * This value is unused.
     */ LiveMusicPlaybackControl["PLAYBACK_CONTROL_UNSPECIFIED"] = "PLAYBACK_CONTROL_UNSPECIFIED";
    /**
     * Start generating the music.
     */ LiveMusicPlaybackControl["PLAY"] = "PLAY";
    /**
     * Hold the music generation. Use PLAY to resume from the current position.
     */ LiveMusicPlaybackControl["PAUSE"] = "PAUSE";
    /**
     * Stop the music generation and reset the context (prompts retained).
        Use PLAY to restart the music generation.
     */ LiveMusicPlaybackControl["STOP"] = "STOP";
    /**
     * Reset the context of the music generation without stopping it.
        Retains the current prompts and config.
     */ LiveMusicPlaybackControl["RESET_CONTEXT"] = "RESET_CONTEXT";
})($e4deb49dba5321bc$export$3d1b3b2fa769f3a || ($e4deb49dba5321bc$export$3d1b3b2fa769f3a = {}));
/** The output from a server-side `ToolCall` execution.

This message contains the results of a tool invocation that was initiated by a
`ToolCall` from the model. The client should pass this `ToolResponse` back to
the API in a subsequent turn within a `Content` message, along with the
corresponding `ToolCall`. */ class $e4deb49dba5321bc$export$80c9eb2056a71583 {
}
/** Raw media bytes for function response.

Text should not be sent as raw bytes, use the FunctionResponse.response
field. */ class $e4deb49dba5321bc$export$986b56fce455c677 {
}
/** URI based data for function response. */ class $e4deb49dba5321bc$export$3297d9ce7c428abc {
}
/** A datatype containing media that is part of a `FunctionResponse` message.

A `FunctionResponsePart` consists of data which has an associated datatype. A
`FunctionResponsePart` can only contain one of the accepted types in
`FunctionResponsePart.data`.

A `FunctionResponsePart` must have a fixed IANA MIME type identifying the
type and subtype of the media if the `inline_data` field is filled with raw
bytes. */ class $e4deb49dba5321bc$export$aa6d46887deab26c {
}
/**
 * Creates a `FunctionResponsePart` object from a `base64` encoded `string`.
 */ function $e4deb49dba5321bc$export$e9d5b9ce9b46d2e2(data, mimeType) {
    return {
        inlineData: {
            data: data,
            mimeType: mimeType
        }
    };
}
/**
 * Creates a `FunctionResponsePart` object from a `URI` string.
 */ function $e4deb49dba5321bc$export$3a70ab76783719f9(uri, mimeType) {
    return {
        fileData: {
            fileUri: uri,
            mimeType: mimeType
        }
    };
}
/** A function response. */ class $e4deb49dba5321bc$export$65d34e7763af8846 {
}
/**
 * Creates a `Part` object from a `URI` string.
 */ function $e4deb49dba5321bc$export$609bc3722c813117(uri, mimeType, mediaResolution) {
    return Object.assign({
        fileData: {
            fileUri: uri,
            mimeType: mimeType
        }
    }, mediaResolution && {
        mediaResolution: {
            level: mediaResolution
        }
    });
}
/**
 * Creates a `Part` object from a `text` string.
 */ function $e4deb49dba5321bc$export$2db44f3a4d11da4c(text) {
    return {
        text: text
    };
}
/**
 * Creates a `Part` object from a `FunctionCall` object.
 */ function $e4deb49dba5321bc$export$a3e123769033f7c0(name, args) {
    return {
        functionCall: {
            name: name,
            args: args
        }
    };
}
/**
 * Creates a `Part` object from a `FunctionResponse` object.
 */ function $e4deb49dba5321bc$export$2636c86ed18e1200(id, name, response, parts = []) {
    return {
        functionResponse: Object.assign({
            id: id,
            name: name,
            response: response
        }, parts.length > 0 && {
            parts: parts
        })
    };
}
/**
 * Creates a `Part` object from a `base64` encoded `string`.
 */ function $e4deb49dba5321bc$export$fff7d82602c9c90f(data, mimeType, mediaResolution) {
    return Object.assign({
        inlineData: {
            data: data,
            mimeType: mimeType
        }
    }, mediaResolution && {
        mediaResolution: {
            level: mediaResolution
        }
    });
}
/**
 * Creates a `Part` object from the `outcome` and `output` of a `CodeExecutionResult` object.
 */ function $e4deb49dba5321bc$export$42aa341e98336a1b(outcome, output) {
    return {
        codeExecutionResult: {
            outcome: outcome,
            output: output
        }
    };
}
/**
 * Creates a `Part` object from the `code` and `language` of an `ExecutableCode` object.
 */ function $e4deb49dba5321bc$export$245f0e57663865ef(code, language) {
    return {
        executableCode: {
            code: code,
            language: language
        }
    };
}
function $e4deb49dba5321bc$var$_isPart(obj) {
    if (typeof obj === 'object' && obj !== null) return 'fileData' in obj || 'text' in obj || 'functionCall' in obj || 'functionResponse' in obj || 'inlineData' in obj || 'videoMetadata' in obj || 'codeExecutionResult' in obj || 'executableCode' in obj;
    return false;
}
function $e4deb49dba5321bc$var$_toParts(partOrString) {
    const parts = [];
    if (typeof partOrString === 'string') parts.push($e4deb49dba5321bc$export$2db44f3a4d11da4c(partOrString));
    else if ($e4deb49dba5321bc$var$_isPart(partOrString)) parts.push(partOrString);
    else if (Array.isArray(partOrString)) {
        if (partOrString.length === 0) throw new Error('partOrString cannot be an empty array');
        for (const part of partOrString){
            if (typeof part === 'string') parts.push($e4deb49dba5321bc$export$2db44f3a4d11da4c(part));
            else if ($e4deb49dba5321bc$var$_isPart(part)) parts.push(part);
            else throw new Error('element in PartUnion must be a Part object or string');
        }
    } else throw new Error('partOrString must be a Part object, string, or array');
    return parts;
}
/**
 * Creates a `Content` object with a user role from a `PartListUnion` object or `string`.
 */ function $e4deb49dba5321bc$export$fe075102324a2d5b(partOrString) {
    return {
        role: 'user',
        parts: $e4deb49dba5321bc$var$_toParts(partOrString)
    };
}
/**
 * Creates a `Content` object with a model role from a `PartListUnion` object or `string`.
 */ function $e4deb49dba5321bc$export$f32d0a9788adfa64(partOrString) {
    return {
        role: 'model',
        parts: $e4deb49dba5321bc$var$_toParts(partOrString)
    };
}
/** A wrapper class for the http response. */ class $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7 {
    constructor(response){
        // Process the headers.
        const headers = {};
        for (const pair of response.headers.entries())headers[pair[0]] = pair[1];
        this.headers = headers;
        // Keep the original response.
        this.responseInternal = response;
    }
    json() {
        return this.responseInternal.json();
    }
}
/** Content filter results for a prompt sent in the request. Note: This is sent only in the first stream chunk and only if no candidates were generated due to content violations. */ class $e4deb49dba5321bc$export$37d485a092233165 {
}
/** Usage metadata about the content generation request and response. This message provides a detailed breakdown of token usage and other relevant metrics. This data type is not supported in Gemini API. */ class $e4deb49dba5321bc$export$3248e9acea8b5df0 {
}
/** Response message for PredictionService.GenerateContent. */ class $e4deb49dba5321bc$export$87445595052c5212 {
    /**
     * Returns the concatenation of all text parts from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the text from the first
     * one will be returned.
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     * If there are thought parts in the response, the concatenation of all text
     * parts excluding the thought parts will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'Why is the sky blue?',
     * });
     *
     * console.debug(response.text);
     * ```
     */ get text() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning text from the first one.');
        let text = '';
        let anyTextPartText = false;
        const nonTextParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && fieldName !== 'thoughtSignature' && (fieldValue !== null || fieldValue !== undefined)) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartText = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartText ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the first candidate
     * in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the inline data from the
     * first one will be returned. If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning data from the first one.');
        let data = '';
        const nonDataParts = [];
        for (const part of (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) !== null && _h !== void 0 ? _h : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && (fieldValue !== null || fieldValue !== undefined)) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
    /**
     * Returns the function calls from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the function calls from
     * the first one will be returned.
     * If there are no function calls in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const controlLightFunctionDeclaration: FunctionDeclaration = {
     *   name: 'controlLight',
     *   parameters: {
     *   type: Type.OBJECT,
     *   description: 'Set the brightness and color temperature of a room light.',
     *   properties: {
     *     brightness: {
     *       type: Type.NUMBER,
     *       description:
     *         'Light level from 0 to 100. Zero is off and 100 is full brightness.',
     *     },
     *     colorTemperature: {
     *       type: Type.STRING,
     *       description:
     *         'Color temperature of the light fixture which can be `daylight`, `cool` or `warm`.',
     *     },
     *   },
     *   required: ['brightness', 'colorTemperature'],
     *  };
     *  const response = await ai.models.generateContent({
     *     model: 'gemini-2.0-flash',
     *     contents: 'Dim the lights so the room feels cozy and warm.',
     *     config: {
     *       tools: [{functionDeclarations: [controlLightFunctionDeclaration]}],
     *       toolConfig: {
     *         functionCallingConfig: {
     *           mode: FunctionCallingConfigMode.ANY,
     *           allowedFunctionNames: ['controlLight'],
     *         },
     *       },
     *     },
     *   });
     *  console.debug(JSON.stringify(response.functionCalls));
     * ```
     */ get functionCalls() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning function calls from the first one.');
        const functionCalls = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.functionCall).map((part)=>part.functionCall).filter((functionCall)=>functionCall !== undefined);
        if ((functionCalls === null || functionCalls === void 0 ? void 0 : functionCalls.length) === 0) return undefined;
        return functionCalls;
    }
    /**
     * Returns the first executable code from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the executable code from
     * the first one will be returned.
     * If there are no executable code in the response, undefined will be
     * returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.executableCode);
     * ```
     */ get executableCode() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning executable code from the first one.');
        const executableCode = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.executableCode).map((part)=>part.executableCode).filter((executableCode)=>executableCode !== undefined);
        if ((executableCode === null || executableCode === void 0 ? void 0 : executableCode.length) === 0) return undefined;
        return (_j = executableCode === null || executableCode === void 0 ? void 0 : executableCode[0]) === null || _j === void 0 ? void 0 : _j.code;
    }
    /**
     * Returns the first code execution result from the first candidate in the response.
     *
     * @remarks
     * If there are multiple candidates in the response, the code execution result from
     * the first one will be returned.
     * If there are no code execution result in the response, undefined will be returned.
     *
     * @example
     * ```ts
     * const response = await ai.models.generateContent({
     *   model: 'gemini-2.0-flash',
     *   contents:
     *     'What is the sum of the first 50 prime numbers? Generate and run code for the calculation, and make sure you get all 50.'
     *   config: {
     *     tools: [{codeExecution: {}}],
     *   },
     * });
     *
     * console.debug(response.codeExecutionResult);
     * ```
     */ get codeExecutionResult() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (((_d = (_c = (_b = (_a = this.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.parts) === null || _d === void 0 ? void 0 : _d.length) === 0) return undefined;
        if (this.candidates && this.candidates.length > 1) console.warn('there are multiple candidates in the response, returning code execution result from the first one.');
        const codeExecutionResult = (_h = (_g = (_f = (_e = this.candidates) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.parts) === null || _h === void 0 ? void 0 : _h.filter((part)=>part.codeExecutionResult).map((part)=>part.codeExecutionResult).filter((codeExecutionResult)=>codeExecutionResult !== undefined);
        if ((codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult.length) === 0) return undefined;
        return (_j = codeExecutionResult === null || codeExecutionResult === void 0 ? void 0 : codeExecutionResult[0]) === null || _j === void 0 ? void 0 : _j.output;
    }
}
/** Response for the embed_content method. */ class $e4deb49dba5321bc$export$1e9eee8641627f00 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$f08095e7138eb0f4 {
}
/** Response for the request to edit an image. */ class $e4deb49dba5321bc$export$661afcf00ed2fbe8 {
}
class $e4deb49dba5321bc$export$690402256314214 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$c2ead2074351d0f2 {
}
/** The output images response. */ class $e4deb49dba5321bc$export$304f360366a6eb53 {
}
class $e4deb49dba5321bc$export$f159131a50016456 {
}
class $e4deb49dba5321bc$export$179335935ae1d762 {
}
/** Response for counting tokens. */ class $e4deb49dba5321bc$export$b2422e769fe9acde {
}
/** Response for computing tokens. */ class $e4deb49dba5321bc$export$8fb35c7d28173be {
}
/** Response with generated videos. */ class $e4deb49dba5321bc$export$b2145aacd8f1c9d6 {
}
/** A video generation operation. */ class $e4deb49dba5321bc$export$d39812a6cdac2c57 {
    /**
     * Instantiates an Operation of the same type as the one being called with the fields set from the API response.
     */ _fromAPIResponse({ apiResponse: apiResponse, _isVertexAI: _isVertexAI }) {
        const operation = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
        let response;
        const op = apiResponse;
        if (_isVertexAI) response = $e4deb49dba5321bc$var$generateVideosOperationFromVertex$1(op);
        else response = $e4deb49dba5321bc$var$generateVideosOperationFromMldev$1(op);
        Object.assign(operation, response);
        return operation;
    }
}
/** The results from an evaluation run performed by the EvaluationService. This data type is not supported in Gemini API. */ class $e4deb49dba5321bc$export$4b83cbea77a18372 {
}
/** Response for the list tuning jobs method. */ class $e4deb49dba5321bc$export$32bcd29afb9d1292 {
}
/** Empty response for tunings.cancel method. */ class $e4deb49dba5321bc$export$4ec84eddeb3a0f6d {
}
/** Empty response for caches.delete method. */ class $e4deb49dba5321bc$export$12b40cf453f95df4 {
}
class $e4deb49dba5321bc$export$b704e9f6d5866ff0 {
}
/** Config for documents.list return value. */ class $e4deb49dba5321bc$export$5cc5885838c19de3 {
}
/** Config for file_search_stores.list return value. */ class $e4deb49dba5321bc$export$e4346969d6f84113 {
}
/** Response for the resumable upload method. */ class $e4deb49dba5321bc$export$179988cb790ed88a {
}
/** Response for ImportFile to import a File API file with a file search store. */ class $e4deb49dba5321bc$export$aef018cf5290edf7 {
}
/** Long-running operation for importing a file to a FileSearchStore. */ class $e4deb49dba5321bc$export$12076be78e50463e {
    /**
     * Instantiates an Operation of the same type as the one being called with the fields set from the API response.
     */ _fromAPIResponse({ apiResponse: apiResponse, _isVertexAI: _isVertexAI }) {
        const operation = new $e4deb49dba5321bc$export$12076be78e50463e();
        const op = apiResponse;
        const response = $e4deb49dba5321bc$var$importFileOperationFromMldev$1(op);
        Object.assign(operation, response);
        return operation;
    }
}
/** Response for the list files method. */ class $e4deb49dba5321bc$export$70c4c7aa1360da5a {
}
/** Response for the create file method. */ class $e4deb49dba5321bc$export$e6f7a7cf305d85e3 {
}
/** Response for the delete file method. */ class $e4deb49dba5321bc$export$a33f0b325263613a {
}
/** Response for the _register file method. */ class $e4deb49dba5321bc$export$aecf05d67e6b4829 {
}
/** Config for `inlined_responses` parameter. */ class $e4deb49dba5321bc$export$5a6a720963f2cc93 {
}
/** Config for `response` parameter. */ class $e4deb49dba5321bc$export$bcc77db6b6164a92 {
}
/** Config for `inlined_embedding_responses` parameter. */ class $e4deb49dba5321bc$export$37d6004458e8d4bf {
}
/** Config for batches.list return value. */ class $e4deb49dba5321bc$export$aad8e472c65c38a4 {
}
/** Represents a single response in a replay. */ class $e4deb49dba5321bc$export$aacd0b67d1adb66d {
}
/** A raw reference image.

A raw reference image represents the base image to edit, provided by the user.
It can optionally be provided in addition to a mask reference image or
a style reference image. */ class $e4deb49dba5321bc$export$66efc3ead37215f1 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_RAW',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId
        };
        return referenceImageAPI;
    }
}
/** A mask reference image.

This encapsulates either a mask image provided by the user and configs for
the user provided mask, or only config parameters for the model to generate
a mask.

A mask image is an image whose non-zero values indicate where to edit the base
image. If the user provides a mask image, the mask must be in the same
dimensions as the raw image. */ class $e4deb49dba5321bc$export$df9dc1e4034fa3a8 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_MASK',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            maskImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A control reference image.

The image of the control reference image is either a control image provided
by the user, or a regular image which the backend will use to generate a
control image of. In the case of the latter, the
enable_control_image_computation field in the config should be set to True.

A control image is an image that represents a sketch image of areas for the
model to fill in based on the prompt. */ class $e4deb49dba5321bc$export$35d10f93a6c10713 {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_CONTROL',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            controlImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A style reference image.

This encapsulates a style reference image provided by the user, and
additionally optional config parameters for the style reference image.

A raw reference image can also be provided as a destination for the style to
be applied to. */ class $e4deb49dba5321bc$export$36a9e1f6d51bfc4f {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_STYLE',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            styleImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A subject reference image.

This encapsulates a subject reference image provided by the user, and
additionally optional config parameters for the subject reference image.

A raw reference image can also be provided as a destination for the subject to
be applied to. */ class $e4deb49dba5321bc$export$47ed4b5d00a5d70b {
    /* Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_SUBJECT',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId,
            subjectImageConfig: this.config
        };
        return referenceImageAPI;
    }
}
/** A content reference image.

A content reference image represents a subject to reference (ex. person,
product, animal) provided by the user. It can optionally be provided in
addition to a style reference image (ex. background, style reference). */ class $e4deb49dba5321bc$export$ebe9cec99c220ebb {
    /** Internal method to convert to ReferenceImageAPIInternal. */ toReferenceImageAPI() {
        const referenceImageAPI = {
            referenceType: 'REFERENCE_TYPE_CONTENT',
            referenceImage: this.referenceImage,
            referenceId: this.referenceId
        };
        return referenceImageAPI;
    }
}
/** Response message for API call. */ class $e4deb49dba5321bc$export$a509bcf6072c871c {
    /**
     * Returns the concatenation of all text parts from the server content if present.
     *
     * @remarks
     * If there are non-text parts in the response, the concatenation of all text
     * parts will be returned, and a warning will be logged.
     */ get text() {
        var _a, _b, _c;
        let text = '';
        let anyTextPartFound = false;
        const nonTextParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'text' && fieldName !== 'thought' && fieldValue !== null) nonTextParts.push(fieldName);
            if (typeof part.text === 'string') {
                if (typeof part.thought === 'boolean' && part.thought) continue;
                anyTextPartFound = true;
                text += part.text;
            }
        }
        if (nonTextParts.length > 0) console.warn(`there are non-text parts ${nonTextParts} in the response, returning concatenation of all text parts. Please refer to the non text parts for a full response from model.`);
        // part.text === '' is different from part.text is null
        return anyTextPartFound ? text : undefined;
    }
    /**
     * Returns the concatenation of all inline data parts from the server content if present.
     *
     * @remarks
     * If there are non-inline data parts in the
     * response, the concatenation of all inline data parts will be returned, and
     * a warning will be logged.
     */ get data() {
        var _a, _b, _c;
        let data = '';
        const nonDataParts = [];
        for (const part of (_c = (_b = (_a = this.serverContent) === null || _a === void 0 ? void 0 : _a.modelTurn) === null || _b === void 0 ? void 0 : _b.parts) !== null && _c !== void 0 ? _c : []){
            for (const [fieldName, fieldValue] of Object.entries(part))if (fieldName !== 'inlineData' && fieldValue !== null) nonDataParts.push(fieldName);
            if (part.inlineData && typeof part.inlineData.data === 'string') data += atob(part.inlineData.data);
        }
        if (nonDataParts.length > 0) console.warn(`there are non-data parts ${nonDataParts} in the response, returning concatenation of all data parts. Please refer to the non data parts for a full response from model.`);
        return data.length > 0 ? btoa(data) : undefined;
    }
}
/** Client generated response to a `ToolCall` received from the server.

Individual `FunctionResponse` objects are matched to the respective
`FunctionCall` objects by the `id` field.

Note that in the unary and server-streaming GenerateContent APIs function
calling happens by exchanging the `Content` parts, while in the bidi
GenerateContent APIs function calling happens over this dedicated set of
messages. */ class $e4deb49dba5321bc$export$690fe23e241eac7d {
}
/** Parameters for sending tool responses to the live API. */ class $e4deb49dba5321bc$export$5e9f94bd32ad075f {
    constructor(){
        /** Tool responses to send to the session. */ this.functionResponses = [];
    }
}
/** Response message for the LiveMusicClientMessage call. */ class $e4deb49dba5321bc$export$5f085d7f78cd2680 {
    /**
     * Returns the first audio chunk from the server content, if present.
     *
     * @remarks
     * If there are no audio chunks in the response, undefined will be returned.
     */ get audioChunk() {
        if (this.serverContent && this.serverContent.audioChunks && this.serverContent.audioChunks.length > 0) return this.serverContent.audioChunks[0];
        return undefined;
    }
}
/** The response when long-running operation for uploading a file to a FileSearchStore complete. */ class $e4deb49dba5321bc$export$37c90edafa324a50 {
}
/** Long-running operation for uploading a file to a FileSearchStore. */ class $e4deb49dba5321bc$export$9b1ce68551588ef4 {
    /**
     * Instantiates an Operation of the same type as the one being called with the fields set from the API response.
     */ _fromAPIResponse({ apiResponse: apiResponse, _isVertexAI: _isVertexAI }) {
        const operation = new $e4deb49dba5321bc$export$9b1ce68551588ef4();
        const op = apiResponse;
        const response = $e4deb49dba5321bc$var$uploadToFileSearchStoreOperationFromMldev(op);
        Object.assign(operation, response);
        return operation;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$tModel(apiClient, model) {
    if (!model || typeof model !== 'string') throw new Error('model is required and must be a string');
    if (model.includes('..') || model.includes('?') || model.includes('&')) throw new Error('invalid model parameter');
    if (apiClient.isVertexAI()) {
        if (model.startsWith('publishers/') || model.startsWith('projects/') || model.startsWith('models/')) return model;
        else if (model.indexOf('/') >= 0) {
            const parts = model.split('/', 2);
            return `publishers/${parts[0]}/models/${parts[1]}`;
        } else return `publishers/google/models/${model}`;
    } else {
        if (model.startsWith('models/') || model.startsWith('tunedModels/')) return model;
        else return `models/${model}`;
    }
}
function $e4deb49dba5321bc$var$tCachesModel(apiClient, model) {
    const transformedModel = $e4deb49dba5321bc$var$tModel(apiClient, model);
    if (!transformedModel) return '';
    if (transformedModel.startsWith('publishers/') && apiClient.isVertexAI()) // vertex caches only support model name start with projects.
    return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/${transformedModel}`;
    else if (transformedModel.startsWith('models/') && apiClient.isVertexAI()) return `projects/${apiClient.getProject()}/locations/${apiClient.getLocation()}/publishers/google/${transformedModel}`;
    else return transformedModel;
}
function $e4deb49dba5321bc$var$tBlobs(blobs) {
    if (Array.isArray(blobs)) return blobs.map((blob)=>$e4deb49dba5321bc$var$tBlob(blob));
    else return [
        $e4deb49dba5321bc$var$tBlob(blobs)
    ];
}
function $e4deb49dba5321bc$var$tBlob(blob) {
    if (typeof blob === 'object' && blob !== null) return blob;
    throw new Error(`Could not parse input as Blob. Unsupported blob type: ${typeof blob}`);
}
function $e4deb49dba5321bc$var$tImageBlob(blob) {
    const transformedBlob = $e4deb49dba5321bc$var$tBlob(blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('image/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function $e4deb49dba5321bc$var$tAudioBlob(blob) {
    const transformedBlob = $e4deb49dba5321bc$var$tBlob(blob);
    if (transformedBlob.mimeType && transformedBlob.mimeType.startsWith('audio/')) return transformedBlob;
    throw new Error(`Unsupported mime type: ${transformedBlob.mimeType}`);
}
function $e4deb49dba5321bc$var$tPart(origin) {
    if (origin === null || origin === undefined) throw new Error('PartUnion is required');
    if (typeof origin === 'object') return origin;
    if (typeof origin === 'string') return {
        text: origin
    };
    throw new Error(`Unsupported part type: ${typeof origin}`);
}
function $e4deb49dba5321bc$var$tParts(origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('PartListUnion is required');
    if (Array.isArray(origin)) return origin.map((item)=>$e4deb49dba5321bc$var$tPart(item));
    return [
        $e4deb49dba5321bc$var$tPart(origin)
    ];
}
function $e4deb49dba5321bc$var$_isContent(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'parts' in origin && Array.isArray(origin.parts);
}
function $e4deb49dba5321bc$var$_isFunctionCallPart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionCall' in origin;
}
function $e4deb49dba5321bc$var$_isFunctionResponsePart(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'functionResponse' in origin;
}
function $e4deb49dba5321bc$var$tContent(origin) {
    if (origin === null || origin === undefined) throw new Error('ContentUnion is required');
    if ($e4deb49dba5321bc$var$_isContent(origin)) // _isContent is a utility function that checks if the
    // origin is a Content.
    return origin;
    return {
        role: 'user',
        parts: $e4deb49dba5321bc$var$tParts(origin)
    };
}
function $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, origin) {
    if (!origin) return [];
    if (apiClient.isVertexAI() && Array.isArray(origin)) return origin.flatMap((item)=>{
        const content = $e4deb49dba5321bc$var$tContent(item);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    });
    else if (apiClient.isVertexAI()) {
        const content = $e4deb49dba5321bc$var$tContent(origin);
        if (content.parts && content.parts.length > 0 && content.parts[0].text !== undefined) return [
            content.parts[0].text
        ];
        return [];
    }
    if (Array.isArray(origin)) return origin.map((item)=>$e4deb49dba5321bc$var$tContent(item));
    return [
        $e4deb49dba5321bc$var$tContent(origin)
    ];
}
function $e4deb49dba5321bc$var$tContents(origin) {
    if (origin === null || origin === undefined || Array.isArray(origin) && origin.length === 0) throw new Error('contents are required');
    if (!Array.isArray(origin)) {
        // If it's not an array, it's a single content or a single PartUnion.
        if ($e4deb49dba5321bc$var$_isFunctionCallPart(origin) || $e4deb49dba5321bc$var$_isFunctionResponsePart(origin)) throw new Error('To specify functionCall or functionResponse parts, please wrap them in a Content object, specifying the role for them');
        return [
            $e4deb49dba5321bc$var$tContent(origin)
        ];
    }
    const result = [];
    const accumulatedParts = [];
    const isContentArray = $e4deb49dba5321bc$var$_isContent(origin[0]);
    for (const item of origin){
        const isContent = $e4deb49dba5321bc$var$_isContent(item);
        if (isContent != isContentArray) throw new Error('Mixing Content and Parts is not supported, please group the parts into a the appropriate Content objects and specify the roles for them');
        if (isContent) // `isContent` contains the result of _isContent, which is a utility
        // function that checks if the item is a Content.
        result.push(item);
        else if ($e4deb49dba5321bc$var$_isFunctionCallPart(item) || $e4deb49dba5321bc$var$_isFunctionResponsePart(item)) throw new Error('To specify functionCall or functionResponse parts, please wrap them, and any other parts, in Content objects as appropriate, specifying the role for them');
        else accumulatedParts.push(item);
    }
    if (!isContentArray) result.push({
        role: 'user',
        parts: $e4deb49dba5321bc$var$tParts(accumulatedParts)
    });
    return result;
}
/*
Transform the type field from an array of types to an array of anyOf fields.
Example:
  {type: ['STRING', 'NUMBER']}
will be transformed to
  {anyOf: [{type: 'STRING'}, {type: 'NUMBER'}]}
*/ function $e4deb49dba5321bc$var$flattenTypeArrayToAnyOf(typeList, resultingSchema) {
    if (typeList.includes('null')) resultingSchema['nullable'] = true;
    const listWithoutNull = typeList.filter((type)=>type !== 'null');
    if (listWithoutNull.length === 1) resultingSchema['type'] = Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(listWithoutNull[0].toUpperCase()) ? listWithoutNull[0].toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED;
    else {
        resultingSchema['anyOf'] = [];
        for (const i of listWithoutNull)resultingSchema['anyOf'].push({
            'type': Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(i.toUpperCase()) ? i.toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED
        });
    }
}
function $e4deb49dba5321bc$var$processJsonSchema(_jsonSchema) {
    const genAISchema = {};
    const schemaFieldNames = [
        'items'
    ];
    const listSchemaFieldNames = [
        'anyOf'
    ];
    const dictSchemaFieldNames = [
        'properties'
    ];
    if (_jsonSchema['type'] && _jsonSchema['anyOf']) throw new Error('type and anyOf cannot be both populated.');
    /*
    This is to handle the nullable array or object. The _jsonSchema will
    be in the format of {anyOf: [{type: 'null'}, {type: 'object'}]}. The
    logic is to check if anyOf has 2 elements and one of the element is null,
    if so, the anyOf field is unnecessary, so we need to get rid of the anyOf
    field and make the schema nullable. Then use the other element as the new
    _jsonSchema for processing. This is because the backend doesn't have a null
    type.
    This has to be checked before we process any other fields.
    For example:
      const objectNullable = z.object({
        nullableArray: z.array(z.string()).nullable(),
      });
    Will have the raw _jsonSchema as:
    {
      type: 'OBJECT',
      properties: {
          nullableArray: {
             anyOf: [
                {type: 'null'},
                {
                  type: 'array',
                  items: {type: 'string'},
                },
              ],
          }
      },
      required: [ 'nullableArray' ],
    }
    Will result in following schema compatible with Gemini API:
      {
        type: 'OBJECT',
        properties: {
           nullableArray: {
              nullable: true,
              type: 'ARRAY',
              items: {type: 'string'},
           }
        },
        required: [ 'nullableArray' ],
      }
    */ const incomingAnyOf = _jsonSchema['anyOf'];
    if (incomingAnyOf != null && incomingAnyOf.length == 2) {
        if (incomingAnyOf[0]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[1];
        } else if (incomingAnyOf[1]['type'] === 'null') {
            genAISchema['nullable'] = true;
            _jsonSchema = incomingAnyOf[0];
        }
    }
    if (_jsonSchema['type'] instanceof Array) $e4deb49dba5321bc$var$flattenTypeArrayToAnyOf(_jsonSchema['type'], genAISchema);
    for (const [fieldName, fieldValue] of Object.entries(_jsonSchema)){
        // Skip if the fieldvalue is undefined or null.
        if (fieldValue == null) continue;
        if (fieldName == 'type') {
            if (fieldValue === 'null') throw new Error('type: null can not be the only possible type for the field.');
            if (fieldValue instanceof Array) continue;
            genAISchema['type'] = Object.values($e4deb49dba5321bc$export$92738401e1603719).includes(fieldValue.toUpperCase()) ? fieldValue.toUpperCase() : $e4deb49dba5321bc$export$92738401e1603719.TYPE_UNSPECIFIED;
        } else if (schemaFieldNames.includes(fieldName)) genAISchema[fieldName] = $e4deb49dba5321bc$var$processJsonSchema(fieldValue);
        else if (listSchemaFieldNames.includes(fieldName)) {
            const listSchemaFieldValue = [];
            for (const item of fieldValue){
                if (item['type'] == 'null') {
                    genAISchema['nullable'] = true;
                    continue;
                }
                listSchemaFieldValue.push($e4deb49dba5321bc$var$processJsonSchema(item));
            }
            genAISchema[fieldName] = listSchemaFieldValue;
        } else if (dictSchemaFieldNames.includes(fieldName)) {
            const dictSchemaFieldValue = {};
            for (const [key, value] of Object.entries(fieldValue))dictSchemaFieldValue[key] = $e4deb49dba5321bc$var$processJsonSchema(value);
            genAISchema[fieldName] = dictSchemaFieldValue;
        } else {
            // additionalProperties is not included in JSONSchema, skipping it.
            if (fieldName === 'additionalProperties') continue;
            genAISchema[fieldName] = fieldValue;
        }
    }
    return genAISchema;
}
// we take the unknown in the schema field because we want enable user to pass
// the output of major schema declaration tools without casting. Tools such as
// zodToJsonSchema, typebox, zodToJsonSchema function can return JsonSchema7Type
// or object, see details in
// https://github.com/StefanTerdell/zod-to-json-schema/blob/70525efe555cd226691e093d171370a3b10921d1/src/zodToJsonSchema.ts#L7
// typebox can return unknown, see details in
// https://github.com/sinclairzx81/typebox/blob/5a5431439f7d5ca6b494d0d18fbfd7b1a356d67c/src/type/create/type.ts#L35
// Note: proper json schemas with the $schema field set never arrive to this
// transformer. Schemas with $schema are routed to the equivalent API json
// schema field.
function $e4deb49dba5321bc$var$tSchema(schema) {
    return $e4deb49dba5321bc$var$processJsonSchema(schema);
}
function $e4deb49dba5321bc$var$tSpeechConfig(speechConfig) {
    if (typeof speechConfig === 'object') return speechConfig;
    else if (typeof speechConfig === 'string') return {
        voiceConfig: {
            prebuiltVoiceConfig: {
                voiceName: speechConfig
            }
        }
    };
    else throw new Error(`Unsupported speechConfig type: ${typeof speechConfig}`);
}
function $e4deb49dba5321bc$var$tLiveSpeechConfig(speechConfig) {
    if ('multiSpeakerVoiceConfig' in speechConfig) throw new Error('multiSpeakerVoiceConfig is not supported in the live API.');
    return speechConfig;
}
function $e4deb49dba5321bc$var$tTool(tool) {
    if (tool.functionDeclarations) for (const functionDeclaration of tool.functionDeclarations){
        if (functionDeclaration.parameters) {
            if (!Object.keys(functionDeclaration.parameters).includes('$schema')) functionDeclaration.parameters = $e4deb49dba5321bc$var$processJsonSchema(functionDeclaration.parameters);
            else if (!functionDeclaration.parametersJsonSchema) {
                functionDeclaration.parametersJsonSchema = functionDeclaration.parameters;
                delete functionDeclaration.parameters;
            }
        }
        if (functionDeclaration.response) {
            if (!Object.keys(functionDeclaration.response).includes('$schema')) functionDeclaration.response = $e4deb49dba5321bc$var$processJsonSchema(functionDeclaration.response);
            else if (!functionDeclaration.responseJsonSchema) {
                functionDeclaration.responseJsonSchema = functionDeclaration.response;
                delete functionDeclaration.response;
            }
        }
    }
    return tool;
}
function $e4deb49dba5321bc$var$tTools(tools) {
    // Check if the incoming type is defined.
    if (tools === undefined || tools === null) throw new Error('tools is required');
    if (!Array.isArray(tools)) throw new Error('tools is required and must be an array of Tools');
    const result = [];
    for (const tool of tools)result.push(tool);
    return result;
}
/**
 * Prepends resource name with project, location, resource_prefix if needed.
 *
 * @param client The API client.
 * @param resourceName The resource name.
 * @param resourcePrefix The resource prefix.
 * @param splitsAfterPrefix The number of splits after the prefix.
 * @returns The completed resource name.
 *
 * Examples:
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/bar/locations/us-west1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'projects/foo/locations/us-central1/cachedContents/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = True
 * client.project = 'bar'
 * client.location = 'us-west1'
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns: 'projects/foo/locations/us-central1/cachedContents/123'
 * ```
 *
 * ```
 * resource_name = '123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * returns 'cachedContents/123'
 * ```
 *
 * ```
 * resource_name = 'some/wrong/cachedContents/resource/name/123'
 * resource_prefix = 'cachedContents'
 * splits_after_prefix = 1
 * client.vertexai = False
 * # client.vertexai = True
 * _resource_name(client, resource_name, resource_prefix, splits_after_prefix)
 * -> 'some/wrong/resource/name/123'
 * ```
 */ function $e4deb49dba5321bc$var$resourceName(client, resourceName1, resourcePrefix, splitsAfterPrefix = 1) {
    const shouldAppendPrefix = !resourceName1.startsWith(`${resourcePrefix}/`) && resourceName1.split('/').length === splitsAfterPrefix;
    if (client.isVertexAI()) {
        if (resourceName1.startsWith('projects/')) return resourceName1;
        else if (resourceName1.startsWith('locations/')) return `projects/${client.getProject()}/${resourceName1}`;
        else if (resourceName1.startsWith(`${resourcePrefix}/`)) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourceName1}`;
        else if (shouldAppendPrefix) return `projects/${client.getProject()}/locations/${client.getLocation()}/${resourcePrefix}/${resourceName1}`;
        else return resourceName1;
    }
    if (shouldAppendPrefix) return `${resourcePrefix}/${resourceName1}`;
    return resourceName1;
}
function $e4deb49dba5321bc$var$tCachedContentName(apiClient, name) {
    if (typeof name !== 'string') throw new Error('name must be a string');
    return $e4deb49dba5321bc$var$resourceName(apiClient, name, 'cachedContents');
}
function $e4deb49dba5321bc$var$tTuningJobStatus(status) {
    switch(status){
        case 'STATE_UNSPECIFIED':
            return 'JOB_STATE_UNSPECIFIED';
        case 'CREATING':
            return 'JOB_STATE_RUNNING';
        case 'ACTIVE':
            return 'JOB_STATE_SUCCEEDED';
        case 'FAILED':
            return 'JOB_STATE_FAILED';
        default:
            return status;
    }
}
function $e4deb49dba5321bc$var$tBytes(fromImageBytes) {
    return $e4deb49dba5321bc$var$tBytes$1(fromImageBytes);
}
function $e4deb49dba5321bc$var$_isFile(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'name' in origin;
}
function $e4deb49dba5321bc$var$isGeneratedVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'video' in origin;
}
function $e4deb49dba5321bc$var$isVideo(origin) {
    return origin !== null && origin !== undefined && typeof origin === 'object' && 'uri' in origin;
}
function $e4deb49dba5321bc$var$tFileName(fromName) {
    var _a;
    let name;
    if ($e4deb49dba5321bc$var$_isFile(fromName)) name = fromName.name;
    if ($e4deb49dba5321bc$var$isVideo(fromName)) {
        name = fromName.uri;
        if (name === undefined) return undefined;
    }
    if ($e4deb49dba5321bc$var$isGeneratedVideo(fromName)) {
        name = (_a = fromName.video) === null || _a === void 0 ? void 0 : _a.uri;
        if (name === undefined) return undefined;
    }
    if (typeof fromName === 'string') name = fromName;
    if (name === undefined) throw new Error('Could not extract file name from the provided input.');
    if (name.startsWith('https://')) {
        const suffix = name.split('files/')[1];
        const match = suffix.match(/[a-z0-9]+/);
        if (match === null) throw new Error(`Could not extract file name from URI ${name}`);
        name = match[0];
    } else if (name.startsWith('files/')) name = name.split('files/')[1];
    return name;
}
function $e4deb49dba5321bc$var$tModelsUrl(apiClient, baseModels) {
    let res;
    if (apiClient.isVertexAI()) res = baseModels ? 'publishers/google/models' : 'models';
    else res = baseModels ? 'models' : 'tunedModels';
    return res;
}
function $e4deb49dba5321bc$var$tExtractModels(response) {
    for (const key of [
        'models',
        'tunedModels',
        'publisherModels'
    ]){
        if ($e4deb49dba5321bc$var$hasField(response, key)) return response[key];
    }
    return [];
}
function $e4deb49dba5321bc$var$hasField(data, fieldName) {
    return data !== null && typeof data === 'object' && fieldName in data;
}
function $e4deb49dba5321bc$var$mcpToGeminiTool(mcpTool, config = {}) {
    const mcpToolSchema = mcpTool;
    const functionDeclaration = {
        name: mcpToolSchema['name'],
        description: mcpToolSchema['description'],
        parametersJsonSchema: mcpToolSchema['inputSchema']
    };
    if (mcpToolSchema['outputSchema']) functionDeclaration['responseJsonSchema'] = mcpToolSchema['outputSchema'];
    if (config.behavior) functionDeclaration['behavior'] = config.behavior;
    const geminiTool = {
        functionDeclarations: [
            functionDeclaration
        ]
    };
    return geminiTool;
}
/**
 * Converts a list of MCP tools to a single Gemini tool with a list of function
 * declarations.
 */ function $e4deb49dba5321bc$var$mcpToolsToGeminiTool(mcpTools, config = {}) {
    const functionDeclarations = [];
    const toolNames = new Set();
    for (const mcpTool of mcpTools){
        const mcpToolName = mcpTool.name;
        if (toolNames.has(mcpToolName)) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
        toolNames.add(mcpToolName);
        const geminiTool = $e4deb49dba5321bc$var$mcpToGeminiTool(mcpTool, config);
        if (geminiTool.functionDeclarations) functionDeclarations.push(...geminiTool.functionDeclarations);
    }
    return {
        functionDeclarations: functionDeclarations
    };
}
// Transforms a source input into a BatchJobSource object with validation.
function $e4deb49dba5321bc$var$tBatchJobSource(client, src) {
    let sourceObj;
    if (typeof src === 'string') {
        if (client.isVertexAI()) {
            if (src.startsWith('gs://')) sourceObj = {
                format: 'jsonl',
                gcsUri: [
                    src
                ]
            };
            else if (src.startsWith('bq://')) sourceObj = {
                format: 'bigquery',
                bigqueryUri: src
            };
            else throw new Error(`Unsupported string source for Vertex AI: ${src}`);
        } else {
            // MLDEV
            if (src.startsWith('files/')) sourceObj = {
                fileName: src
            }; // Default to fileName for string input
            else throw new Error(`Unsupported string source for Gemini API: ${src}`);
        }
    } else if (Array.isArray(src)) {
        if (client.isVertexAI()) throw new Error('InlinedRequest[] is not supported in Vertex AI.');
        sourceObj = {
            inlinedRequests: src
        };
    } else // It's already a BatchJobSource object
    sourceObj = src;
    // Validation logic
    const vertexSourcesCount = [
        sourceObj.gcsUri,
        sourceObj.bigqueryUri
    ].filter(Boolean).length;
    const mldevSourcesCount = [
        sourceObj.inlinedRequests,
        sourceObj.fileName
    ].filter(Boolean).length;
    if (client.isVertexAI()) {
        if (mldevSourcesCount > 0 || vertexSourcesCount !== 1) throw new Error('Exactly one of `gcsUri` or `bigqueryUri` must be set for Vertex AI.');
    } else {
        // MLDEV
        if (vertexSourcesCount > 0 || mldevSourcesCount !== 1) throw new Error("Exactly one of `inlinedRequests`, `fileName`, must be set for Gemini API.");
    }
    return sourceObj;
}
function $e4deb49dba5321bc$var$tBatchJobDestination(dest) {
    if (typeof dest !== 'string') return dest;
    const destString = dest;
    if (destString.startsWith('gs://')) return {
        format: 'jsonl',
        gcsUri: destString
    };
    else if (destString.startsWith('bq://')) return {
        format: 'bigquery',
        bigqueryUri: destString
    };
    else throw new Error(`Unsupported destination: ${destString}`);
}
function $e4deb49dba5321bc$var$tRecvBatchJobDestination(dest) {
    // Ensure dest is a non-null object before proceeding.
    if (typeof dest !== 'object' || dest === null) // If the input is not an object, it cannot be a valid BatchJobDestination
    // based on the operations performed. Return it cast, or handle as an error.
    // Casting an empty object might be a safe default.
    return {};
    // Cast to Record<string, unknown> to allow string property access.
    const obj = dest;
    // Safely access nested properties.
    const inlineResponsesVal = obj['inlinedResponses'];
    if (typeof inlineResponsesVal !== 'object' || inlineResponsesVal === null) return dest;
    const inlineResponsesObj = inlineResponsesVal;
    const responsesArray = inlineResponsesObj['inlinedResponses'];
    if (!Array.isArray(responsesArray) || responsesArray.length === 0) return dest;
    // Check if any response has the 'embedding' property.
    let hasEmbedding = false;
    for (const responseItem of responsesArray){
        if (typeof responseItem !== 'object' || responseItem === null) continue;
        const responseItemObj = responseItem;
        const responseVal = responseItemObj['response'];
        if (typeof responseVal !== 'object' || responseVal === null) continue;
        const responseObj = responseVal;
        // Check for the existence of the 'embedding' key.
        if (responseObj['embedding'] !== undefined) {
            hasEmbedding = true;
            break;
        }
    }
    // Perform the transformation if an embedding was found.
    if (hasEmbedding) {
        obj['inlinedEmbedContentResponses'] = obj['inlinedResponses'];
        delete obj['inlinedResponses'];
    }
    // Cast the (potentially) modified object to the target type.
    return dest;
}
function $e4deb49dba5321bc$var$tBatchJobName(apiClient, name) {
    const nameString = name;
    if (!apiClient.isVertexAI()) {
        const mldevPattern = /batches\/[^/]+$/;
        if (mldevPattern.test(nameString)) return nameString.split('/').pop();
        else throw new Error(`Invalid batch job name: ${nameString}.`);
    }
    const vertexPattern = /^projects\/[^/]+\/locations\/[^/]+\/batchPredictionJobs\/[^/]+$/;
    if (vertexPattern.test(nameString)) return nameString.split('/').pop();
    else if (/^\d+$/.test(nameString)) return nameString;
    else throw new Error(`Invalid batch job name: ${nameString}.`);
}
function $e4deb49dba5321bc$var$tJobState(state) {
    const stateString = state;
    if (stateString === 'BATCH_STATE_UNSPECIFIED') return 'JOB_STATE_UNSPECIFIED';
    else if (stateString === 'BATCH_STATE_PENDING') return 'JOB_STATE_PENDING';
    else if (stateString === 'BATCH_STATE_RUNNING') return 'JOB_STATE_RUNNING';
    else if (stateString === 'BATCH_STATE_SUCCEEDED') return 'JOB_STATE_SUCCEEDED';
    else if (stateString === 'BATCH_STATE_FAILED') return 'JOB_STATE_FAILED';
    else if (stateString === 'BATCH_STATE_CANCELLED') return 'JOB_STATE_CANCELLED';
    else if (stateString === 'BATCH_STATE_EXPIRED') return 'JOB_STATE_EXPIRED';
    else return stateString;
}
function $e4deb49dba5321bc$var$tIsVertexEmbedContentModel(model) {
    return model.includes('gemini') && model !== 'gemini-embedding-001' || model.includes('maas');
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$authConfigToMldev$4(fromObject) {
    const toObject = {};
    const fromApiKey = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKey'
    ]);
    if (fromApiKey != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKey'
    ], fromApiKey);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]) !== undefined) throw new Error('apiKeyConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]) !== undefined) throw new Error('authType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]) !== undefined) throw new Error('googleServiceAccountConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]) !== undefined) throw new Error('httpBasicAuthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]) !== undefined) throw new Error('oauthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]) !== undefined) throw new Error('oidcConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationFromMldev(fromObject) {
    const toObject = {};
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responsesFile'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromInlinedResponses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedResponses',
        'inlinedResponses'
    ]);
    if (fromInlinedResponses != null) {
        let transformedList = fromInlinedResponses;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$inlinedResponseFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'inlinedResponses'
        ], transformedList);
    }
    const fromInlinedEmbedContentResponses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedEmbedContentResponses',
        'inlinedResponses'
    ]);
    if (fromInlinedEmbedContentResponses != null) {
        let transformedList = fromInlinedEmbedContentResponses;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'inlinedEmbedContentResponses'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationFromVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictionsFormat'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsDestination',
        'outputUriPrefix'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryDestination',
        'outputUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryUri'
    ], fromBigqueryUri);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobDestinationToVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'predictionsFormat'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsDestination',
        'outputUriPrefix'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryDestination',
        'outputUri'
    ], fromBigqueryUri);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]) !== undefined) throw new Error('fileName parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedResponses'
    ]) !== undefined) throw new Error('inlinedResponses parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedEmbedContentResponses'
    ]) !== undefined) throw new Error('inlinedEmbedContentResponses parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tJobState(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata',
        'output'
    ]);
    if (fromDest != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dest'
    ], $e4deb49dba5321bc$var$batchJobDestinationFromMldev($e4deb49dba5321bc$var$tRecvBatchJobDestination(fromDest)));
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobFromVertex(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tJobState(fromState));
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputConfig'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'src'
    ], $e4deb49dba5321bc$var$batchJobSourceFromVertex(fromSrc));
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputConfig'
    ]);
    if (fromDest != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dest'
    ], $e4deb49dba5321bc$var$batchJobDestinationFromVertex($e4deb49dba5321bc$var$tRecvBatchJobDestination(fromDest)));
    const fromCompletionStats = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'completionStats'
    ]);
    if (fromCompletionStats != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'completionStats'
    ], fromCompletionStats);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceFromVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'instancesFormat'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'format'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsSource',
        'uris'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigquerySource',
        'inputUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigqueryUri'
    ], fromBigqueryUri);
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceToMldev(apiClient, fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]) !== undefined) throw new Error('format parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]) !== undefined) throw new Error('bigqueryUri parameter is not supported in Gemini API.');
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromInlinedRequests = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]);
    if (fromInlinedRequests != null) {
        let transformedList = fromInlinedRequests;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$inlinedRequestToMldev(apiClient, item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'requests',
            'requests'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$batchJobSourceToVertex(fromObject) {
    const toObject = {};
    const fromFormat = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'format'
    ]);
    if (fromFormat != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instancesFormat'
    ], fromFormat);
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsSource',
        'uris'
    ], fromGcsUri);
    const fromBigqueryUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bigqueryUri'
    ]);
    if (fromBigqueryUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bigquerySource',
        'inputUri'
    ], fromBigqueryUri);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]) !== undefined) throw new Error('fileName parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]) !== undefined) throw new Error('inlinedRequests parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$4(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$cancelBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$candidateFromMldev$1(fromObject) {
    const toObject = {};
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'content'
    ], fromContent);
    const fromCitationMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citationMetadata'
    ], $e4deb49dba5321bc$var$citationMetadataFromMldev$1(fromCitationMetadata));
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    const fromFinishReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromAvgLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) {
        let transformedList = fromSafetyRatings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'safetyRatings'
        ], transformedList);
    }
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], fromUrlContextMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$citationMetadataFromMldev$1(fromObject) {
    const toObject = {};
    const fromCitations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationSources'
    ]);
    if (fromCitations != null) {
        let transformedList = fromCitations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'citations'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$4(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$4(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'batch',
        'displayName'
    ], fromDisplayName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dest'
    ]) !== undefined) throw new Error('dest parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDest = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'dest'
    ]);
    if (parentObject !== undefined && fromDest != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'outputConfig'
    ], $e4deb49dba5321bc$var$batchJobDestinationToVertex($e4deb49dba5321bc$var$tBatchJobDestination(fromDest)));
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'batch',
        'inputConfig'
    ], $e4deb49dba5321bc$var$batchJobSourceToMldev(apiClient, $e4deb49dba5321bc$var$tBatchJobSource(apiClient, fromSrc)));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createBatchJobConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputConfig'
    ], $e4deb49dba5321bc$var$batchJobSourceToVertex($e4deb49dba5321bc$var$tBatchJobSource(apiClient, fromSrc)));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createBatchJobConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createEmbeddingsBatchJobConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'batch',
        'displayName'
    ], fromDisplayName);
    return toObject;
}
function $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSrc = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'src'
    ]);
    if (fromSrc != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'batch',
        'inputConfig'
    ], $e4deb49dba5321bc$var$embeddingsBatchJobSourceToMldev(apiClient, fromSrc));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createEmbeddingsBatchJobConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteResourceJobFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteResourceJobFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentBatchToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'requests[]',
            'request',
            'content'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) {
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            '_self'
        ], $e4deb49dba5321bc$var$embedContentConfigToMldev$1(fromConfig, toObject));
        $e4deb49dba5321bc$var$moveValueByPath(toObject, {
            'requests[].*': 'requests[].request.*'
        });
    }
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToMldev$1(fromObject, parentObject) {
    const toObject = {};
    const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'taskType'
    ], fromTaskType);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'outputDimensionality'
    ], fromOutputDimensionality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]) !== undefined) throw new Error('mimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'autoTruncate'
    ]) !== undefined) throw new Error('autoTruncate parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$embeddingsBatchJobSourceToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'file_name'
    ], fromFileName);
    const fromInlinedRequests = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlinedRequests'
    ]);
    if (fromInlinedRequests != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests'
    ], $e4deb49dba5321bc$var$embedContentBatchToMldev(apiClient, fromInlinedRequests));
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$4(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$4(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'streamFunctionCallArguments'
    ]) !== undefined) throw new Error('streamFunctionCallArguments parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToMldev$1(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$4($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$tSchema(fromResponseSchema));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]) !== undefined) throw new Error('routingConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]) !== undefined) throw new Error('modelSelectionConfig parameter is not supported in Gemini API.');
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$safetySettingToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$4($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev$2(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]) !== undefined) throw new Error('audioTimestamp parameter is not supported in Gemini API.');
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageConfig'
    ]);
    if (fromImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageConfig'
    ], $e4deb49dba5321bc$var$imageConfigToMldev$1(fromImageConfig));
    const fromEnableEnhancedCivicAnswers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]);
    if (fromEnableEnhancedCivicAnswers != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableEnhancedCivicAnswers'
    ], fromEnableEnhancedCivicAnswers);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelArmorConfig'
    ]) !== undefined) throw new Error('modelArmorConfig parameter is not supported in Gemini API.');
    const fromServiceTier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serviceTier'
    ]);
    if (parentObject !== undefined && fromServiceTier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'serviceTier'
    ], fromServiceTier);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromMldev$1(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$candidateFromMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    const fromModelStatus = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelStatus'
    ]);
    if (fromModelStatus != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelStatus'
    ], fromModelStatus);
    return toObject;
}
function $e4deb49dba5321bc$var$getBatchJobParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$getBatchJobParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tBatchJobName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$4(fromObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToMldev$4(fromAuthConfig));
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$4(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$imageConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'aspectRatio'
    ], fromAspectRatio);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageSize'
    ], fromImageSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]) !== undefined) throw new Error('personGeneration parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prominentPeople'
    ]) !== undefined) throw new Error('prominentPeople parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]) !== undefined) throw new Error('outputMimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]) !== undefined) throw new Error('outputCompressionQuality parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageOutputOptions'
    ]) !== undefined) throw new Error('imageOutputOptions parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$inlinedRequestToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'request',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$4(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'request',
            'contents'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'request',
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToMldev$1(apiClient, fromConfig, $e4deb49dba5321bc$var$getValueByPath(toObject, [
        'request'
    ], {})));
    return toObject;
}
function $e4deb49dba5321bc$var$inlinedResponseFromMldev(fromObject) {
    const toObject = {};
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateContentResponseFromMldev$1(fromResponse));
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]) !== undefined) throw new Error('filter parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listBatchJobsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsParametersToVertex(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listBatchJobsConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromBatchJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'operations'
    ]);
    if (fromBatchJobs != null) {
        let transformedList = fromBatchJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$batchJobFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'batchJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listBatchJobsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromBatchJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'batchPredictionJobs'
    ]);
    if (fromBatchJobs != null) {
        let transformedList = fromBatchJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$batchJobFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'batchJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$4(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$4(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$4(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$4(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], fromToolCall);
    const fromToolResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]);
    if (fromToolResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolResponse'
    ], fromToolResponse);
    const fromPartMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]);
    if (fromPartMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partMetadata'
    ], fromPartMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$safetySettingToMldev$1(fromObject) {
    const toObject = {};
    const fromCategory = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'category'
    ], fromCategory);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'method'
    ]) !== undefined) throw new Error('method parameter is not supported in Gemini API.');
    const fromThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev$2(fromFunctionCallingConfig));
    const fromIncludeServerSideToolInvocations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeServerSideToolInvocations'
    ]);
    if (fromIncludeServerSideToolInvocations != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'includeServerSideToolInvocations'
    ], fromIncludeServerSideToolInvocations);
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$4(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$4(fromGoogleSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$4(fromGoogleMaps));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]) !== undefined) throw new Error('parallelAiSearch parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ var $e4deb49dba5321bc$export$e18b8de308fd2439;
(function(PagedItem) {
    PagedItem["PAGED_ITEM_BATCH_JOBS"] = "batchJobs";
    PagedItem["PAGED_ITEM_MODELS"] = "models";
    PagedItem["PAGED_ITEM_TUNING_JOBS"] = "tuningJobs";
    PagedItem["PAGED_ITEM_FILES"] = "files";
    PagedItem["PAGED_ITEM_CACHED_CONTENTS"] = "cachedContents";
    PagedItem["PAGED_ITEM_FILE_SEARCH_STORES"] = "fileSearchStores";
    PagedItem["PAGED_ITEM_DOCUMENTS"] = "documents";
})($e4deb49dba5321bc$export$e18b8de308fd2439 || ($e4deb49dba5321bc$export$e18b8de308fd2439 = {}));
/**
 * Pager class for iterating through paginated results.
 */ class $e4deb49dba5321bc$export$57625d62e5386b09 {
    constructor(name, request, response, params){
        this.pageInternal = [];
        this.paramsInternal = {};
        this.requestInternal = request;
        this.init(name, response, params);
    }
    init(name, response, params) {
        var _a, _b;
        this.nameInternal = name;
        this.pageInternal = response[this.nameInternal] || [];
        this.sdkHttpResponseInternal = response === null || response === void 0 ? void 0 : response.sdkHttpResponse;
        this.idxInternal = 0;
        let requestParams = {
            config: {}
        };
        if (!params || Object.keys(params).length === 0) requestParams = {
            config: {}
        };
        else if (typeof params === 'object') requestParams = Object.assign({}, params);
        else requestParams = params;
        if (requestParams['config']) requestParams['config']['pageToken'] = response['nextPageToken'];
        this.paramsInternal = requestParams;
        this.pageInternalSize = (_b = (_a = requestParams['config']) === null || _a === void 0 ? void 0 : _a['pageSize']) !== null && _b !== void 0 ? _b : this.pageInternal.length;
    }
    initNextPage(response) {
        this.init(this.nameInternal, response, this.paramsInternal);
    }
    /**
     * Returns the current page, which is a list of items.
     *
     * @remarks
     * The first page is retrieved when the pager is created. The returned list of
     * items could be a subset of the entire list.
     */ get page() {
        return this.pageInternal;
    }
    /**
     * Returns the type of paged item (for example, ``batch_jobs``).
     */ get name() {
        return this.nameInternal;
    }
    /**
     * Returns the length of the page fetched each time by this pager.
     *
     * @remarks
     * The number of items in the page is less than or equal to the page length.
     */ get pageSize() {
        return this.pageInternalSize;
    }
    /**
     * Returns the headers of the API response.
     */ get sdkHttpResponse() {
        return this.sdkHttpResponseInternal;
    }
    /**
     * Returns the parameters when making the API request for the next page.
     *
     * @remarks
     * Parameters contain a set of optional configs that can be
     * used to customize the API request. For example, the `pageToken` parameter
     * contains the token to request the next page.
     */ get params() {
        return this.paramsInternal;
    }
    /**
     * Returns the total number of items in the current page.
     */ get pageLength() {
        return this.pageInternal.length;
    }
    /**
     * Returns the item at the given index.
     */ getItem(index) {
        return this.pageInternal[index];
    }
    /**
     * Returns an async iterator that support iterating through all items
     * retrieved from the API.
     *
     * @remarks
     * The iterator will automatically fetch the next page if there are more items
     * to fetch from the API.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * for await (const file of pager) {
     *   console.log(file.name);
     * }
     * ```
     */ [Symbol.asyncIterator]() {
        return {
            next: async ()=>{
                if (this.idxInternal >= this.pageLength) {
                    if (this.hasNextPage()) await this.nextPage();
                    else return {
                        value: undefined,
                        done: true
                    };
                }
                const item = this.getItem(this.idxInternal);
                this.idxInternal += 1;
                return {
                    value: item,
                    done: false
                };
            },
            return: async ()=>{
                return {
                    value: undefined,
                    done: true
                };
            }
        };
    }
    /**
     * Fetches the next page of items. This makes a new API request.
     *
     * @throws {Error} If there are no more pages to fetch.
     *
     * @example
     *
     * ```ts
     * const pager = await ai.files.list({config: {pageSize: 10}});
     * let page = pager.page;
     * while (true) {
     *   for (const file of page) {
     *     console.log(file.name);
     *   }
     *   if (!pager.hasNextPage()) {
     *     break;
     *   }
     *   page = await pager.nextPage();
     * }
     * ```
     */ async nextPage() {
        if (!this.hasNextPage()) throw new Error('No more pages to fetch.');
        const response = await this.requestInternal(this.params);
        this.initNextPage(response);
        return this.page;
    }
    /**
     * Returns true if there are more pages to fetch from the API.
     */ hasNextPage() {
        var _a;
        if (((_a = this.params['config']) === null || _a === void 0 ? void 0 : _a['pageToken']) !== undefined) return true;
        return false;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$ed828fcd19953e0d extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists batch jobs.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of batch jobs.
         *
         * @example
         * ```ts
         * const batchJobs = await ai.batches.list({config: {'pageSize': 2}});
         * for await (const batchJob of batchJobs) {
         *   console.log(batchJob);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_BATCH_JOBS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
        /**
         * Create batch job.
         *
         * @param params - The parameters for create batch job request.
         * @return The created batch job.
         *
         * @example
         * ```ts
         * const response = await ai.batches.create({
         *   model: 'gemini-2.0-flash',
         *   src: {gcsUri: 'gs://bucket/path/to/file.jsonl', format: 'jsonl'},
         *   config: {
         *     dest: {gcsUri: 'gs://bucket/path/output/directory', format: 'jsonl'},
         *   }
         * });
         * console.log(response);
         * ```
         */ this.create = async (params)=>{
            if (this.apiClient.isVertexAI()) // Format destination if not provided
            // Cast params.src as Vertex AI path does not handle InlinedRequest[]
            params.config = this.formatDestination(params.src, params.config);
            return this.createInternal(params);
        };
        /**
         * **Experimental** Creates an embedding batch job.
         *
         * @param params - The parameters for create embedding batch job request.
         * @return The created batch job.
         *
         * @example
         * ```ts
         * const response = await ai.batches.createEmbeddings({
         *   model: 'text-embedding-004',
         *   src: {fileName: 'files/my_embedding_input'},
         * });
         * console.log(response);
         * ```
         */ this.createEmbeddings = async (params)=>{
            console.warn('batches.createEmbeddings() is experimental and may change without notice.');
            if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support batches.createEmbeddings.');
            return this.createEmbeddingsInternal(params);
        };
    }
    // Helper function to handle inlined generate content requests
    createInlinedGenerateContentRequest(params) {
        const body = $e4deb49dba5321bc$var$createBatchJobParametersToMldev(this.apiClient, params);
        const urlParams = body['_url'];
        const path = $e4deb49dba5321bc$var$formatMap('{model}:batchGenerateContent', urlParams);
        const batch = body['batch'];
        const inputConfig = batch['inputConfig'];
        const requestsWrapper = inputConfig['requests'];
        const requests = requestsWrapper['requests'];
        const newRequests = [];
        for (const request of requests){
            const requestDict = Object.assign({}, request); // Clone
            if (requestDict['systemInstruction']) {
                const systemInstructionValue = requestDict['systemInstruction'];
                delete requestDict['systemInstruction'];
                const requestContent = requestDict['request'];
                requestContent['systemInstruction'] = systemInstructionValue;
                requestDict['request'] = requestContent;
            }
            newRequests.push(requestDict);
        }
        requestsWrapper['requests'] = newRequests;
        delete body['config'];
        delete body['_url'];
        delete body['_query'];
        return {
            path: path,
            body: body
        };
    }
    // Helper function to get the first GCS URI
    getGcsUri(src) {
        if (typeof src === 'string') return src.startsWith('gs://') ? src : undefined;
        if (!Array.isArray(src) && src.gcsUri && src.gcsUri.length > 0) return src.gcsUri[0];
        return undefined;
    }
    // Helper function to get the BigQuery URI
    getBigqueryUri(src) {
        if (typeof src === 'string') return src.startsWith('bq://') ? src : undefined;
        if (!Array.isArray(src)) return src.bigqueryUri;
        return undefined;
    }
    // Function to format the destination configuration for Vertex AI
    formatDestination(src, config) {
        const newConfig = config ? Object.assign({}, config) : {};
        const timestampStr = Date.now().toString();
        if (!newConfig.displayName) newConfig.displayName = `genaiBatchJob_${timestampStr}`;
        if (newConfig.dest === undefined) {
            const gcsUri = this.getGcsUri(src);
            const bigqueryUri = this.getBigqueryUri(src);
            if (gcsUri) {
                if (gcsUri.endsWith('.jsonl')) // For .jsonl files, remove suffix and add /dest
                newConfig.dest = `${gcsUri.slice(0, -6)}/dest`;
                else // Fallback for other GCS URIs
                newConfig.dest = `${gcsUri}_dest_${timestampStr}`;
            } else if (bigqueryUri) newConfig.dest = `${bigqueryUri}_dest_${timestampStr}`;
            else throw new Error('Unsupported source for Vertex AI: No GCS or BigQuery URI found.');
        }
        return newConfig;
    }
    /**
     * Internal method to create batch job.
     *
     * @param params - The parameters for create batch job request.
     * @return The created batch job.
     *
     */ async createInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$createBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:batchGenerateContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Internal method to create batch job.
     *
     * @param params - The parameters for create batch job request.
     * @return The created batch job.
     *
     */ async createEmbeddingsInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createEmbeddingsBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:asyncBatchEmbedContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Gets batch job configurations.
     *
     * @param params - The parameters for the get request.
     * @return The batch job.
     *
     * @example
     * ```ts
     * await ai.batches.get({name: '...'}); // The server-generated resource name.
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$batchJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Cancels a batch job.
     *
     * @param params - The parameters for the cancel request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.batches.cancel({name: '...'}); // The server-generated resource name.
     * ```
     */ async cancel(params) {
        var _a, _b, _c, _d;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$cancelBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        } else {
            const body = $e4deb49dba5321bc$var$cancelBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listBatchJobsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listBatchJobsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aad8e472c65c38a4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listBatchJobsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('batches', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listBatchJobsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aad8e472c65c38a4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Deletes a batch job.
     *
     * @param params - The parameters for the delete request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.batches.delete({name: '...'}); // The server-generated resource name.
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteBatchJobParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batchPredictionJobs/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteResourceJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteBatchJobParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('batches/{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteResourceJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$authConfigToMldev$3(fromObject) {
    const toObject = {};
    const fromApiKey = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKey'
    ]);
    if (fromApiKey != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKey'
    ], fromApiKey);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]) !== undefined) throw new Error('apiKeyConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]) !== undefined) throw new Error('authType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]) !== undefined) throw new Error('googleServiceAccountConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]) !== undefined) throw new Error('httpBasicAuthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]) !== undefined) throw new Error('oauthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]) !== undefined) throw new Error('oidcConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$3(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$3(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToVertex$2(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$3($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$3(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev$1(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'kmsKeyName'
    ]) !== undefined) throw new Error('kmsKeyName parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (parentObject !== undefined && fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'contents'
        ], transformedList);
    }
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex$2($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToVertex$1(fromToolConfig));
    const fromKmsKeyName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'kmsKeyName'
    ]);
    if (parentObject !== undefined && fromKmsKeyName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'encryption_spec',
        'kmsKeyName'
    ], fromKmsKeyName);
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tCachesModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createCachedContentConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], $e4deb49dba5321bc$var$tCachesModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createCachedContentConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteCachedContentResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$3(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$3(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'streamFunctionCallArguments'
    ]) !== undefined) throw new Error('streamFunctionCallArguments parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex$2(fromObject) {
    const toObject = {};
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$getCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$getCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$3(fromObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToMldev$3(fromAuthConfig));
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$3(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listCachedContentsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsParametersToVertex(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listCachedContentsConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listCachedContentsResponseFromVertex(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromCachedContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContents'
    ]);
    if (fromCachedContents != null) {
        let transformedList = fromCachedContents;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cachedContents'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$3(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$3(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$3(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$3(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], fromToolCall);
    const fromToolResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]);
    if (fromToolResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolResponse'
    ], fromToolResponse);
    const fromPartMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]);
    if (fromPartMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partMetadata'
    ], fromPartMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$partToVertex$2(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], fromFileData);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], fromInlineData);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]) !== undefined) throw new Error('toolCall parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]) !== undefined) throw new Error('toolResponse parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]) !== undefined) throw new Error('partMetadata parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev$1(fromFunctionCallingConfig));
    const fromIncludeServerSideToolInvocations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeServerSideToolInvocations'
    ]);
    if (fromIncludeServerSideToolInvocations != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'includeServerSideToolInvocations'
    ], fromIncludeServerSideToolInvocations);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], fromFunctionCallingConfig);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeServerSideToolInvocations'
    ]) !== undefined) throw new Error('includeServerSideToolInvocations parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$3(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$3(fromGoogleSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$3(fromGoogleMaps));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]) !== undefined) throw new Error('parallelAiSearch parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex$2(fromObject) {
    const toObject = {};
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]) !== undefined) throw new Error('fileSearch parameter is not supported in Vertex AI.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], fromGoogleSearch);
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], fromGoogleMaps);
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], fromEnterpriseWebSearch);
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromParallelAiSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]);
    if (fromParallelAiSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parallelAiSearch'
    ], fromParallelAiSearch);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]) !== undefined) throw new Error('mcpServers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromTtl = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'ttl'
    ]);
    if (parentObject !== undefined && fromTtl != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'ttl'
    ], fromTtl);
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateCachedContentConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$updateCachedContentParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromName));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateCachedContentConfigToVertex(fromConfig, toObject);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$4c60919c4fe22d9 extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists cached contents.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of cached contents.
         *
         * @example
         * ```ts
         * const cachedContents = await ai.caches.list({config: {'pageSize': 2}});
         * for await (const cachedContent of cachedContents) {
         *   console.log(cachedContent);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_CACHED_CONTENTS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Creates a cached contents resource.
     *
     * @remarks
     * Context caching is only supported for specific models. See [Gemini
     * Developer API reference](https://ai.google.dev/gemini-api/docs/caching?lang=node/context-cac)
     * and [Vertex AI reference](https://cloud.google.com/vertex-ai/generative-ai/docs/context-cache/context-cache-overview#supported_models)
     * for more information.
     *
     * @param params - The parameters for the create request.
     * @return The created cached content.
     *
     * @example
     * ```ts
     * const contents = ...; // Initialize the content to cache.
     * const response = await ai.caches.create({
     *   model: 'gemini-2.0-flash-001',
     *   config: {
     *    'contents': contents,
     *    'displayName': 'test cache',
     *    'systemInstruction': 'What is the sum of the two pdfs?',
     *    'ttl': '86400s',
     *  }
     * });
     * ```
     */ async create(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$createCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Gets cached content configurations.
     *
     * @param params - The parameters for the get request.
     * @return The cached content.
     *
     * @example
     * ```ts
     * await ai.caches.get({name: '...'}); // The server-generated resource name.
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes cached content.
     *
     * @param params - The parameters for the delete request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.caches.delete({name: '...'}); // The server-generated resource name.
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteCachedContentResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12b40cf453f95df4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteCachedContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12b40cf453f95df4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates cached content configurations.
     *
     * @param params - The parameters for the update request.
     * @return The updated cached content.
     *
     * @example
     * ```ts
     * const response = await ai.caches.update({
     *   name: '...',  // The server-generated resource name.
     *   config: {'ttl': '7600s'}
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$updateCachedContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$updateCachedContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listCachedContentsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listCachedContentsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b704e9f6d5866ff0();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listCachedContentsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('cachedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listCachedContentsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b704e9f6d5866ff0();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $e4deb49dba5321bc$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e4deb49dba5321bc$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e4deb49dba5321bc$var$__await(v) {
    return this instanceof $e4deb49dba5321bc$var$__await ? (this.v = v, this) : new $e4deb49dba5321bc$var$__await(v);
}
function $e4deb49dba5321bc$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e4deb49dba5321bc$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e4deb49dba5321bc$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e4deb49dba5321bc$var$__values === "function" ? $e4deb49dba5321bc$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns true if the response is valid, false otherwise.
 */ function $e4deb49dba5321bc$var$isValidResponse(response) {
    var _a;
    if (response.candidates == undefined || response.candidates.length === 0) return false;
    const content = (_a = response.candidates[0]) === null || _a === void 0 ? void 0 : _a.content;
    if (content === undefined) return false;
    return $e4deb49dba5321bc$var$isValidContent(content);
}
function $e4deb49dba5321bc$var$isValidContent(content) {
    if (content.parts === undefined || content.parts.length === 0) return false;
    for (const part of content.parts){
        if (part === undefined || Object.keys(part).length === 0) return false;
    }
    return true;
}
/**
 * Validates the history contains the correct roles.
 *
 * @throws Error if the history does not start with a user turn.
 * @throws Error if the history contains an invalid role.
 */ function $e4deb49dba5321bc$var$validateHistory(history) {
    // Empty history is valid.
    if (history.length === 0) return;
    for (const content of history){
        if (content.role !== 'user' && content.role !== 'model') throw new Error(`Role must be user or model, but got ${content.role}.`);
    }
}
/**
 * Extracts the curated (valid) history from a comprehensive history.
 *
 * @remarks
 * The model may sometimes generate invalid or empty contents(e.g., due to safty
 * filters or recitation). Extracting valid turns from the history
 * ensures that subsequent requests could be accpeted by the model.
 */ function $e4deb49dba5321bc$var$extractCuratedHistory(comprehensiveHistory) {
    if (comprehensiveHistory === undefined || comprehensiveHistory.length === 0) return [];
    const curatedHistory = [];
    const length = comprehensiveHistory.length;
    let i = 0;
    while(i < length)if (comprehensiveHistory[i].role === 'user') {
        curatedHistory.push(comprehensiveHistory[i]);
        i++;
    } else {
        const modelOutput = [];
        let isValid = true;
        while(i < length && comprehensiveHistory[i].role === 'model'){
            modelOutput.push(comprehensiveHistory[i]);
            if (isValid && !$e4deb49dba5321bc$var$isValidContent(comprehensiveHistory[i])) isValid = false;
            i++;
        }
        if (isValid) curatedHistory.push(...modelOutput);
        else // Remove the last user input when model content is invalid.
        curatedHistory.pop();
    }
    return curatedHistory;
}
/**
 * A utility class to create a chat session.
 */ class $e4deb49dba5321bc$export$84088b07cfe11a74 {
    constructor(modelsModule, apiClient){
        this.modelsModule = modelsModule;
        this.apiClient = apiClient;
    }
    /**
     * Creates a new chat session.
     *
     * @remarks
     * The config in the params will be used for all requests within the chat
     * session unless overridden by a per-request `config` in
     * @see {@link types.SendMessageParameters#config}.
     *
     * @param params - Parameters for creating a chat session.
     * @returns A new chat session.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({
     *   model: 'gemini-2.0-flash'
     *   config: {
     *     temperature: 0.5,
     *     maxOutputTokens: 1024,
     *   }
     * });
     * ```
     */ create(params) {
        return new $e4deb49dba5321bc$export$d49dffca20dba6f7(this.apiClient, this.modelsModule, params.model, params.config, // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        structuredClone(params.history));
    }
}
/**
 * Chat session that enables sending messages to the model with previous
 * conversation context.
 *
 * @remarks
 * The session maintains all the turns between user and model.
 */ class $e4deb49dba5321bc$export$d49dffca20dba6f7 {
    constructor(apiClient, modelsModule, model, config = {}, history = []){
        this.apiClient = apiClient;
        this.modelsModule = modelsModule;
        this.model = model;
        this.config = config;
        this.history = history;
        // A promise to represent the current state of the message being sent to the
        // model.
        this.sendPromise = Promise.resolve();
        $e4deb49dba5321bc$var$validateHistory(history);
    }
    /**
     * Sends a message to the model and returns the response.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessageStream} for streaming method.
     * @param params - parameters for sending messages within a chat session.
     * @returns The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessage({
     *   message: 'Why is the sky blue?'
     * });
     * console.log(response.text);
     * ```
     */ async sendMessage(params) {
        var _a;
        await this.sendPromise;
        const inputContent = $e4deb49dba5321bc$var$tContent(params.message);
        const responsePromise = this.modelsModule.generateContent({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        this.sendPromise = (async ()=>{
            var _a, _b, _c;
            const response = await responsePromise;
            const outputContent = (_b = (_a = response.candidates) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.content;
            // Because the AFC input contains the entire curated chat history in
            // addition to the new user input, we need to truncate the AFC history
            // to deduplicate the existing chat history.
            const fullAutomaticFunctionCallingHistory = response.automaticFunctionCallingHistory;
            const index = this.getHistory(true).length;
            let automaticFunctionCallingHistory = [];
            if (fullAutomaticFunctionCallingHistory != null) automaticFunctionCallingHistory = (_c = fullAutomaticFunctionCallingHistory.slice(index)) !== null && _c !== void 0 ? _c : [];
            const modelOutput = outputContent ? [
                outputContent
            ] : [];
            this.recordHistory(inputContent, modelOutput, automaticFunctionCallingHistory);
            return;
        })();
        await this.sendPromise.catch(()=>{
            // Resets sendPromise to avoid subsequent calls failing
            this.sendPromise = Promise.resolve();
        });
        return responsePromise;
    }
    /**
     * Sends a message to the model and returns the response in chunks.
     *
     * @remarks
     * This method will wait for the previous message to be processed before
     * sending the next message.
     *
     * @see {@link Chat#sendMessage} for non-streaming method.
     * @param params - parameters for sending the message.
     * @return The model's response.
     *
     * @example
     * ```ts
     * const chat = ai.chats.create({model: 'gemini-2.0-flash'});
     * const response = await chat.sendMessageStream({
     *   message: 'Why is the sky blue?'
     * });
     * for await (const chunk of response) {
     *   console.log(chunk.text);
     * }
     * ```
     */ async sendMessageStream(params) {
        var _a;
        await this.sendPromise;
        const inputContent = $e4deb49dba5321bc$var$tContent(params.message);
        const streamResponse = this.modelsModule.generateContentStream({
            model: this.model,
            contents: this.getHistory(true).concat(inputContent),
            config: (_a = params.config) !== null && _a !== void 0 ? _a : this.config
        });
        // Resolve the internal tracking of send completion promise - `sendPromise`
        // for both success and failure response. The actual failure is still
        // propagated by the `await streamResponse`.
        this.sendPromise = streamResponse.then(()=>undefined).catch(()=>undefined);
        const response = await streamResponse;
        const result = this.processStreamResponse(response, inputContent);
        return result;
    }
    /**
     * Returns the chat history.
     *
     * @remarks
     * The history is a list of contents alternating between user and model.
     *
     * There are two types of history:
     * - The `curated history` contains only the valid turns between user and
     * model, which will be included in the subsequent requests sent to the model.
     * - The `comprehensive history` contains all turns, including invalid or
     *   empty model outputs, providing a complete record of the history.
     *
     * The history is updated after receiving the response from the model,
     * for streaming response, it means receiving the last chunk of the response.
     *
     * The `comprehensive history` is returned by default. To get the `curated
     * history`, set the `curated` parameter to `true`.
     *
     * @param curated - whether to return the curated history or the comprehensive
     *     history.
     * @return History contents alternating between user and model for the entire
     *     chat session.
     */ getHistory(curated = false) {
        const history = curated ? $e4deb49dba5321bc$var$extractCuratedHistory(this.history) : this.history;
        // Deep copy the history to avoid mutating the history outside of the
        // chat session.
        return structuredClone(history);
    }
    processStreamResponse(streamResponse, inputContent) {
        return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* processStreamResponse_1() {
            var _a, e_1, _b, _c;
            var _d, _e;
            const outputContent = [];
            try {
                for(var _f = true, streamResponse_1 = $e4deb49dba5321bc$var$__asyncValues(streamResponse), streamResponse_1_1; streamResponse_1_1 = yield $e4deb49dba5321bc$var$__await(streamResponse_1.next()), _a = streamResponse_1_1.done, !_a; _f = true){
                    _c = streamResponse_1_1.value;
                    _f = false;
                    const chunk = _c;
                    if ($e4deb49dba5321bc$var$isValidResponse(chunk)) {
                        const content = (_e = (_d = chunk.candidates) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.content;
                        if (content !== undefined) outputContent.push(content);
                    }
                    yield yield $e4deb49dba5321bc$var$__await(chunk);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_f && !_a && (_b = streamResponse_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(streamResponse_1));
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.recordHistory(inputContent, outputContent);
        });
    }
    recordHistory(userInput, modelOutput, automaticFunctionCallingHistory) {
        let outputContents = [];
        if (modelOutput.length > 0 && modelOutput.every((content)=>content.role !== undefined)) outputContents = modelOutput;
        else // Appends an empty content when model returns empty response, so that the
        // history is always alternating between user and model.
        outputContents.push({
            role: 'model',
            parts: []
        });
        if (automaticFunctionCallingHistory && automaticFunctionCallingHistory.length > 0) this.history.push(...$e4deb49dba5321bc$var$extractCuratedHistory(automaticFunctionCallingHistory));
        else this.history.push(userInput);
        this.history.push(...outputContents);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * API errors raised by the GenAI API.
 */ class $e4deb49dba5321bc$export$f2e832acab1bdd79 extends Error {
    constructor(options){
        super(options.message);
        this.name = 'ApiError';
        this.status = options.status;
        Object.setPrototypeOf(this, $e4deb49dba5321bc$export$f2e832acab1bdd79.prototype);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$createFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromFile = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'file'
    ]);
    if (fromFile != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'file'
    ], fromFile);
    return toObject;
}
function $e4deb49dba5321bc$var$createFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file'
    ], $e4deb49dba5321bc$var$tFileName(fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$getFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file'
    ], $e4deb49dba5321bc$var$tFileName(fromName));
    return toObject;
}
function $e4deb49dba5321bc$var$internalRegisterFilesParametersToMldev(fromObject) {
    const toObject = {};
    const fromUris = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uris'
    ]);
    if (fromUris != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uris'
    ], fromUris);
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listFilesConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listFilesResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromFiles = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'files'
    ]);
    if (fromFiles != null) {
        let transformedList = fromFiles;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'files'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$registerFilesResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromFiles = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'files'
    ]);
    if (fromFiles != null) {
        let transformedList = fromFiles;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'files'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$9330ab61a7e5c11b extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists files.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of files.
         *
         * @example
         * ```ts
         * const files = await ai.files.list({config: {'pageSize': 2}});
         * for await (const file of files) {
         *   console.log(file);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_FILES, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Uploads a file asynchronously to the Gemini API.
     * This method is not available in Vertex AI.
     * Supported upload sources:
     * - Node.js: File path (string) or Blob object.
     * - Browser: Blob object (e.g., File).
     *
     * @remarks
     * The `mimeType` can be specified in the `config` parameter. If omitted:
     *  - For file path (string) inputs, the `mimeType` will be inferred from the
     *     file extension.
     *  - For Blob object inputs, the `mimeType` will be set to the Blob's `type`
     *     property.
     * Somex eamples for file extension to mimeType mapping:
     * .txt -> text/plain
     * .json -> application/json
     * .jpg  -> image/jpeg
     * .png -> image/png
     * .mp3 -> audio/mpeg
     * .mp4 -> video/mp4
     *
     * This section can contain multiple paragraphs and code examples.
     *
     * @param params - Optional parameters specified in the
     *        `types.UploadFileParameters` interface.
     *         @see {@link types.UploadFileParameters#config} for the optional
     *         config in the parameters.
     * @return A promise that resolves to a `types.File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     * the `mimeType` can be provided in the `params.config` parameter.
     * @throws An error occurs if a suitable upload location cannot be established.
     *
     * @example
     * The following code uploads a file to Gemini API.
     *
     * ```ts
     * const file = await ai.files.upload({file: 'file.txt', config: {
     *   mimeType: 'text/plain',
     * }});
     * console.log(file.name);
     * ```
     */ async upload(params) {
        if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support uploading files. You can share files through a GCS bucket.');
        return this.apiClient.uploadFile(params.file, params.config).then((resp)=>{
            return resp;
        });
    }
    /**
     * Downloads a remotely stored file asynchronously to a location specified in
     * the `params` object. This method only works on Node environment, to
     * download files in the browser, use a browser compliant method like an <a>
     * tag.
     *
     * @param params - The parameters for the download request.
     *
     * @example
     * The following code downloads an example file named "files/mehozpxf877d" as
     * "file.txt".
     *
     * ```ts
     * await ai.files.download({file: file.name, downloadPath: 'file.txt'});
     * ```
     */ async download(params) {
        await this.apiClient.downloadFile(params);
    }
    /**
     * Registers Google Cloud Storage files for use with the API.
     * This method is only available in Node.js environments.
     */ async registerFiles(params) {
        throw new Error('registerFiles is only supported in Node.js environments.');
    }
    async _registerFiles(params) {
        return this.registerFilesInternal(params);
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$listFilesParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listFilesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$70c4c7aa1360da5a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async createInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('upload/v1beta/files', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$createFileResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$e6f7a7cf305d85e3();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Retrieves the file information from the service.
     *
     * @param params - The parameters for the get request
     * @return The Promise that resolves to the types.File object requested.
     *
     * @example
     * ```ts
     * const config: GetFileParameters = {
     *   name: fileName,
     * };
     * file = await ai.files.get(config);
     * console.log(file.name);
     * ```
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$getFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes a remotely stored file.
     *
     * @param params - The parameters for the delete request.
     * @return The DeleteFileResponse, the response for the delete method.
     *
     * @example
     * The following code deletes an example file named "files/mehozpxf877d".
     *
     * ```ts
     * await ai.files.delete({name: file.name});
     * ```
     */ async delete(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$deleteFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files/{file}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteFileResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$a33f0b325263613a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async registerFilesInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$internalRegisterFilesParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('files:register', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$registerFilesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$aecf05d67e6b4829();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev$1(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCodes'
    ]) !== undefined) throw new Error('languageCodes parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$authConfigToMldev$2(fromObject) {
    const toObject = {};
    const fromApiKey = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKey'
    ]);
    if (fromApiKey != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKey'
    ], fromApiKey);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]) !== undefined) throw new Error('apiKeyConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]) !== undefined) throw new Error('authType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]) !== undefined) throw new Error('googleServiceAccountConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]) !== undefined) throw new Error('httpBasicAuthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]) !== undefined) throw new Error('oauthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]) !== undefined) throw new Error('oidcConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$2(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$2(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToVertex$1(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$2(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex$1(fromObject) {
    const toObject = {};
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$generationConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromModelSelectionConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelConfig'
    ], fromModelSelectionConfig);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    const fromAudioTimestamp = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], fromResponseSchema);
    const fromRoutingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToVertex$1(fromSpeechConfig));
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]) !== undefined) throw new Error('enableEnhancedCivicAnswers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$2(fromObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToMldev$2(fromAuthConfig));
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$2(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToMldev$1(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig));
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (parentObject !== undefined && fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$2($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$2($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], $e4deb49dba5321bc$var$sessionResumptionConfigToMldev$1(fromSessionResumption));
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev$1(fromInputAudioTranscription));
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev$1(fromOutputAudioTranscription));
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], fromRealtimeInputConfig);
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], fromContextWindowCompression);
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], fromProactivity);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'explicitVadSignal'
    ]) !== undefined) throw new Error('explicitVadSignal parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToVertex(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], $e4deb49dba5321bc$var$generationConfigToVertex$1(fromGenerationConfig));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToVertex$1($e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig)));
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (parentObject !== undefined && fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex$1($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex$1($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], fromSessionResumption);
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], fromInputAudioTranscription);
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], fromOutputAudioTranscription);
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], fromRealtimeInputConfig);
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], fromContextWindowCompression);
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], fromProactivity);
    const fromExplicitVadSignal = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'explicitVadSignal'
    ]);
    if (parentObject !== undefined && fromExplicitVadSignal != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'explicitVadSignal'
    ], fromExplicitVadSignal);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToMldev$1(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectParametersToVertex(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToVertex(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicSetConfigParametersToMldev(fromObject) {
    const toObject = {};
    const fromMusicGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'musicGenerationConfig'
    ]);
    if (fromMusicGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'musicGenerationConfig'
    ], fromMusicGenerationConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$liveMusicSetWeightedPromptsParametersToMldev(fromObject) {
    const toObject = {};
    const fromWeightedPrompts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'weightedPrompts'
    ]);
    if (fromWeightedPrompts != null) {
        let transformedList = fromWeightedPrompts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'weightedPrompts'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToMldev(fromObject) {
    const toObject = {};
    const fromMedia = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) {
        let transformedList = $e4deb49dba5321bc$var$tBlobs(fromMedia);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$blobToMldev$2(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mediaChunks'
        ], transformedList);
    }
    const fromAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audio'
    ]);
    if (fromAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audio'
    ], $e4deb49dba5321bc$var$blobToMldev$2($e4deb49dba5321bc$var$tAudioBlob(fromAudio)));
    const fromAudioStreamEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$blobToMldev$2($e4deb49dba5321bc$var$tImageBlob(fromVideo)));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromActivityStart = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityStart'
    ], fromActivityStart);
    const fromActivityEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityEnd'
    ], fromActivityEnd);
    return toObject;
}
function $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToVertex(fromObject) {
    const toObject = {};
    const fromMedia = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'media'
    ]);
    if (fromMedia != null) {
        let transformedList = $e4deb49dba5321bc$var$tBlobs(fromMedia);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mediaChunks'
        ], transformedList);
    }
    const fromAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audio'
    ]);
    if (fromAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audio'
    ], $e4deb49dba5321bc$var$tAudioBlob(fromAudio));
    const fromAudioStreamEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioStreamEnd'
    ]);
    if (fromAudioStreamEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioStreamEnd'
    ], fromAudioStreamEnd);
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$tImageBlob(fromVideo));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromActivityStart = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityStart'
    ]);
    if (fromActivityStart != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityStart'
    ], fromActivityStart);
    const fromActivityEnd = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'activityEnd'
    ]);
    if (fromActivityEnd != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'activityEnd'
    ], fromActivityEnd);
    return toObject;
}
function $e4deb49dba5321bc$var$liveServerMessageFromVertex(fromObject) {
    const toObject = {};
    const fromSetupComplete = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'setupComplete'
    ]);
    if (fromSetupComplete != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setupComplete'
    ], fromSetupComplete);
    const fromServerContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serverContent'
    ]);
    if (fromServerContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serverContent'
    ], fromServerContent);
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], fromToolCall);
    const fromToolCallCancellation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCallCancellation'
    ]);
    if (fromToolCallCancellation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCallCancellation'
    ], fromToolCallCancellation);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], $e4deb49dba5321bc$var$usageMetadataFromVertex(fromUsageMetadata));
    const fromGoAway = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'goAway'
    ]);
    if (fromGoAway != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'goAway'
    ], fromGoAway);
    const fromSessionResumptionUpdate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumptionUpdate'
    ]);
    if (fromSessionResumptionUpdate != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sessionResumptionUpdate'
    ], fromSessionResumptionUpdate);
    const fromVoiceActivityDetectionSignal = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceActivityDetectionSignal'
    ]);
    if (fromVoiceActivityDetectionSignal != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceActivityDetectionSignal'
    ], fromVoiceActivityDetectionSignal);
    const fromVoiceActivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceActivity'
    ]);
    if (fromVoiceActivity != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceActivity'
    ], $e4deb49dba5321bc$var$voiceActivityFromVertex(fromVoiceActivity));
    return toObject;
}
function $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$speakerVoiceConfigToVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$2(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$2(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$2(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$2(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], fromToolCall);
    const fromToolResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]);
    if (fromToolResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolResponse'
    ], fromToolResponse);
    const fromPartMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]);
    if (fromPartMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partMetadata'
    ], fromPartMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$partToVertex$1(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], fromFileData);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], fromInlineData);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]) !== undefined) throw new Error('toolCall parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]) !== undefined) throw new Error('toolResponse parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]) !== undefined) throw new Error('partMetadata parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$replicatedVoiceConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromVoiceSampleAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceSampleAudio'
    ]);
    if (fromVoiceSampleAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceSampleAudio'
    ], fromVoiceSampleAudio);
    return toObject;
}
function $e4deb49dba5321bc$var$sessionResumptionConfigToMldev$1(fromObject) {
    const toObject = {};
    const fromHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$speakerVoiceConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromSpeaker = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToVertex$1(fromVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToVertex$1(fromVoiceConfig));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    const fromMultiSpeakerVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToVertex$1(fromMultiSpeakerVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$2(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$2(fromGoogleSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$2(fromGoogleMaps));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]) !== undefined) throw new Error('parallelAiSearch parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex$1(fromObject) {
    const toObject = {};
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]) !== undefined) throw new Error('fileSearch parameter is not supported in Vertex AI.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], fromGoogleSearch);
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], fromGoogleMaps);
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], fromEnterpriseWebSearch);
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromParallelAiSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]);
    if (fromParallelAiSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parallelAiSearch'
    ], fromParallelAiSearch);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]) !== undefined) throw new Error('mcpServers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$usageMetadataFromVertex(fromObject) {
    const toObject = {};
    const fromPromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokenCount'
    ]);
    if (fromPromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptTokenCount'
    ], fromPromptTokenCount);
    const fromCachedContentTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    const fromResponseTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidatesTokenCount'
    ]);
    if (fromResponseTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseTokenCount'
    ], fromResponseTokenCount);
    const fromToolUsePromptTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokenCount'
    ]);
    if (fromToolUsePromptTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolUsePromptTokenCount'
    ], fromToolUsePromptTokenCount);
    const fromThoughtsTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtsTokenCount'
    ]);
    if (fromThoughtsTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtsTokenCount'
    ], fromThoughtsTokenCount);
    const fromTotalTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokenCount'
    ]);
    if (fromTotalTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokenCount'
    ], fromTotalTokenCount);
    const fromPromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptTokensDetails'
    ]);
    if (fromPromptTokensDetails != null) {
        let transformedList = fromPromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'promptTokensDetails'
        ], transformedList);
    }
    const fromCacheTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cacheTokensDetails'
    ]);
    if (fromCacheTokensDetails != null) {
        let transformedList = fromCacheTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'cacheTokensDetails'
        ], transformedList);
    }
    const fromResponseTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidatesTokensDetails'
    ]);
    if (fromResponseTokensDetails != null) {
        let transformedList = fromResponseTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'responseTokensDetails'
        ], transformedList);
    }
    const fromToolUsePromptTokensDetails = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolUsePromptTokensDetails'
    ]);
    if (fromToolUsePromptTokensDetails != null) {
        let transformedList = fromToolUsePromptTokensDetails;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'toolUsePromptTokensDetails'
        ], transformedList);
    }
    const fromTrafficType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trafficType'
    ]);
    if (fromTrafficType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'trafficType'
    ], fromTrafficType);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceActivityFromVertex(fromObject) {
    const toObject = {};
    const fromVoiceActivityType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'type'
    ]);
    if (fromVoiceActivityType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceActivityType'
    ], fromVoiceActivityType);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToVertex$1(fromObject) {
    const toObject = {};
    const fromReplicatedVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'replicatedVoiceConfig'
    ]);
    if (fromReplicatedVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'replicatedVoiceConfig'
    ], $e4deb49dba5321bc$var$replicatedVoiceConfigToVertex$1(fromReplicatedVoiceConfig));
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], fromPrebuiltVoiceConfig);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$authConfigToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    const fromApiKey = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKey'
    ]);
    if (fromApiKey != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKey'
    ], fromApiKey);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]) !== undefined) throw new Error('apiKeyConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]) !== undefined) throw new Error('authType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]) !== undefined) throw new Error('googleServiceAccountConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]) !== undefined) throw new Error('httpBasicAuthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]) !== undefined) throw new Error('oauthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]) !== undefined) throw new Error('oidcConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$candidateFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'content'
    ], fromContent);
    const fromCitationMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationMetadata'
    ]);
    if (fromCitationMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'citationMetadata'
    ], $e4deb49dba5321bc$var$citationMetadataFromMldev(fromCitationMetadata));
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokenCount'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    const fromFinishReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'finishReason'
    ]);
    if (fromFinishReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'finishReason'
    ], fromFinishReason);
    const fromGroundingMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'groundingMetadata'
    ]);
    if (fromGroundingMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'groundingMetadata'
    ], fromGroundingMetadata);
    const fromAvgLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'avgLogprobs'
    ]);
    if (fromAvgLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'avgLogprobs'
    ], fromAvgLogprobs);
    const fromIndex = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'index'
    ]);
    if (fromIndex != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'index'
    ], fromIndex);
    const fromLogprobsResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobsResult'
    ]);
    if (fromLogprobsResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobsResult'
    ], fromLogprobsResult);
    const fromSafetyRatings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyRatings'
    ]);
    if (fromSafetyRatings != null) {
        let transformedList = fromSafetyRatings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'safetyRatings'
        ], transformedList);
    }
    const fromUrlContextMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContextMetadata'
    ]);
    if (fromUrlContextMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContextMetadata'
    ], fromUrlContextMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$citationMetadataFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromCitations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'citationSources'
    ]);
    if (fromCitations != null) {
        let transformedList = fromCitations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'citations'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$computeTokensParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$computeTokensResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTokensInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tokensInfo'
    ]);
    if (fromTokensInfo != null) {
        let transformedList = fromTokensInfo;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tokensInfo'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromValues = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'values'
    ]);
    if (fromValues != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'values'
    ], fromValues);
    const fromStatistics = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'statistics'
    ]);
    if (fromStatistics != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'statistics'
    ], $e4deb49dba5321bc$var$contentEmbeddingStatisticsFromVertex(fromStatistics));
    return toObject;
}
function $e4deb49dba5321bc$var$contentEmbeddingStatisticsFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromTruncated = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'truncated'
    ]);
    if (fromTruncated != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'truncated'
    ], fromTruncated);
    const fromTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'token_count'
    ]);
    if (fromTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tokenCount'
    ], fromTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev$1(fromObject, rootObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$controlReferenceConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromControlType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'controlType'
    ]);
    if (fromControlType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'controlType'
    ], fromControlType);
    const fromEnableControlImageComputation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableControlImageComputation'
    ]);
    if (fromEnableControlImageComputation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computeControl'
    ], fromEnableControlImageComputation);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensConfigToMldev(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]) !== undefined) throw new Error('systemInstruction parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]) !== undefined) throw new Error('tools parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]) !== undefined) throw new Error('generationConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = fromTools;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generationConfigToVertex(fromGenerationConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$countTokensConfigToMldev(fromConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$countTokensConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTotalTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    const fromCachedContentTokenCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContentTokenCount'
    ]);
    if (fromCachedContentTokenCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'cachedContentTokenCount'
    ], fromCachedContentTokenCount);
    return toObject;
}
function $e4deb49dba5321bc$var$countTokensResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromTotalTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'totalTokens'
    ]);
    if (fromTotalTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'totalTokens'
    ], fromTotalTokens);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelParametersToMldev(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelParametersToVertex(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteModelResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$editImageConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromEditMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'editMode'
    ]);
    if (parentObject !== undefined && fromEditMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'editMode'
    ], fromEditMode);
    const fromBaseSteps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseSteps'
    ]);
    if (parentObject !== undefined && fromBaseSteps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'editConfig',
        'baseSteps'
    ], fromBaseSteps);
    return toObject;
}
function $e4deb49dba5321bc$var$editImageParametersInternalToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$referenceImageAPIInternalToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$editImageConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$editImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'taskType'
    ]);
    if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'taskType'
    ], fromTaskType);
    const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'title'
    ]);
    if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'title'
    ], fromTitle);
    const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputDimensionality'
    ]);
    if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'requests[]',
        'outputDimensionality'
    ], fromOutputDimensionality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]) !== undefined) throw new Error('mimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'autoTruncate'
    ]) !== undefined) throw new Error('autoTruncate parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    let discriminatorTaskType = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorTaskType === undefined) discriminatorTaskType = 'PREDICT';
    if (discriminatorTaskType === 'PREDICT') {
        const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'taskType'
        ]);
        if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[]',
            'task_type'
        ], fromTaskType);
    } else if (discriminatorTaskType === 'EMBED_CONTENT') {
        const fromTaskType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'taskType'
        ]);
        if (parentObject !== undefined && fromTaskType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'taskType'
        ], fromTaskType);
    }
    let discriminatorTitle = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorTitle === undefined) discriminatorTitle = 'PREDICT';
    if (discriminatorTitle === 'PREDICT') {
        const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'title'
        ]);
        if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[]',
            'title'
        ], fromTitle);
    } else if (discriminatorTitle === 'EMBED_CONTENT') {
        const fromTitle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'title'
        ]);
        if (parentObject !== undefined && fromTitle != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'title'
        ], fromTitle);
    }
    let discriminatorOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorOutputDimensionality === undefined) discriminatorOutputDimensionality = 'PREDICT';
    if (discriminatorOutputDimensionality === 'PREDICT') {
        const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'outputDimensionality'
        ]);
        if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'parameters',
            'outputDimensionality'
        ], fromOutputDimensionality);
    } else if (discriminatorOutputDimensionality === 'EMBED_CONTENT') {
        const fromOutputDimensionality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'outputDimensionality'
        ]);
        if (parentObject !== undefined && fromOutputDimensionality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'outputDimensionality'
        ], fromOutputDimensionality);
    }
    let discriminatorMimeType = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorMimeType === undefined) discriminatorMimeType = 'PREDICT';
    if (discriminatorMimeType === 'PREDICT') {
        const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'mimeType'
        ]);
        if (parentObject !== undefined && fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[]',
            'mimeType'
        ], fromMimeType);
    }
    let discriminatorAutoTruncate = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorAutoTruncate === undefined) discriminatorAutoTruncate = 'PREDICT';
    if (discriminatorAutoTruncate === 'PREDICT') {
        const fromAutoTruncate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'autoTruncate'
        ]);
        if (parentObject !== undefined && fromAutoTruncate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'parameters',
            'autoTruncate'
        ], fromAutoTruncate);
    } else if (discriminatorAutoTruncate === 'EMBED_CONTENT') {
        const fromAutoTruncate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'autoTruncate'
        ]);
        if (parentObject !== undefined && fromAutoTruncate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'autoTruncate'
        ], fromAutoTruncate);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentParametersPrivateToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'requests[]',
            'content'
        ], transformedList);
    }
    const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'content'
    ]);
    if (fromContent != null) $e4deb49dba5321bc$var$contentToMldev$1($e4deb49dba5321bc$var$tContent(fromContent));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$embedContentConfigToMldev(fromConfig, toObject);
    const fromModelForEmbedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModelForEmbedContent !== undefined) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'requests[]',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModelForEmbedContent));
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentParametersPrivateToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    let discriminatorContents = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorContents === undefined) discriminatorContents = 'PREDICT';
    if (discriminatorContents === 'PREDICT') {
        const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'contents'
        ]);
        if (fromContents != null) {
            let transformedList = $e4deb49dba5321bc$var$tContentsForEmbed(apiClient, fromContents);
            if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
                return item;
            });
            $e4deb49dba5321bc$var$setValueByPath(toObject, [
                'instances[]',
                'content'
            ], transformedList);
        }
    }
    let discriminatorContent = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]);
    if (discriminatorContent === undefined) discriminatorContent = 'PREDICT';
    if (discriminatorContent === 'EMBED_CONTENT') {
        const fromContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'content'
        ]);
        if (fromContent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'content'
        ], $e4deb49dba5321bc$var$contentToVertex($e4deb49dba5321bc$var$tContent(fromContent)));
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$embedContentConfigToVertex(fromConfig, toObject, rootObject);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromEmbeddings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$embedContentResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromEmbeddings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions[]',
        'embeddings'
    ]);
    if (fromEmbeddings != null) {
        let transformedList = fromEmbeddings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentEmbeddingFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'embeddings'
        ], transformedList);
    }
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    if (rootObject && $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'embeddingApiType'
    ]) === 'EMBED_CONTENT') {
        const embedding = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'embedding'
        ]);
        const usageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'usageMetadata'
        ]);
        const truncated = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'truncated'
        ]);
        if (embedding) {
            const stats = {};
            if (usageMetadata && usageMetadata['promptTokenCount']) stats.tokenCount = usageMetadata['promptTokenCount'];
            if (truncated) stats.truncated = truncated;
            embedding.statistics = stats;
            $e4deb49dba5321bc$var$setValueByPath(toObject, [
                'embeddings'
            ], [
                embedding
            ]);
        }
    }
    return toObject;
}
function $e4deb49dba5321bc$var$endpointFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endpoint'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDeployedModelId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'deployedModelId'
    ]);
    if (fromDeployedModelId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'deployedModelId'
    ], fromDeployedModelId);
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallingConfigToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromAllowedFunctionNames = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'allowedFunctionNames'
    ]);
    if (fromAllowedFunctionNames != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'allowedFunctionNames'
    ], fromAllowedFunctionNames);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (fromMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mode'
    ], fromMode);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'streamFunctionCallArguments'
    ]) !== undefined) throw new Error('streamFunctionCallArguments parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$functionDeclarationToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromParameters = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parameters'
    ]);
    if (fromParameters != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters'
    ], fromParameters);
    const fromParametersJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parametersJsonSchema'
    ]);
    if (fromParametersJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parametersJsonSchema'
    ], fromParametersJsonSchema);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], fromResponse);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'behavior'
    ]) !== undefined) throw new Error('behavior parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToMldev(apiClient, fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev$1($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$tSchema(fromResponseSchema));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]) !== undefined) throw new Error('routingConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]) !== undefined) throw new Error('modelSelectionConfig parameter is not supported in Gemini API.');
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$safetySettingToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev$1($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToMldev(fromToolConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]) !== undefined) throw new Error('audioTimestamp parameter is not supported in Gemini API.');
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageConfig'
    ]);
    if (fromImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageConfig'
    ], $e4deb49dba5321bc$var$imageConfigToMldev(fromImageConfig));
    const fromEnableEnhancedCivicAnswers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]);
    if (fromEnableEnhancedCivicAnswers != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableEnhancedCivicAnswers'
    ], fromEnableEnhancedCivicAnswers);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelArmorConfig'
    ]) !== undefined) throw new Error('modelArmorConfig parameter is not supported in Gemini API.');
    const fromServiceTier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serviceTier'
    ]);
    if (parentObject !== undefined && fromServiceTier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'serviceTier'
    ], fromServiceTier);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentConfigToVertex(apiClient, fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToVertex($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], $e4deb49dba5321bc$var$tSchema(fromResponseSchema));
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    const fromRoutingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromModelSelectionConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelConfig'
    ], fromModelSelectionConfig);
    const fromSafetySettings = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetySettings'
    ]);
    if (parentObject !== undefined && fromSafetySettings != null) {
        let transformedList = fromSafetySettings;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'safetySettings'
        ], transformedList);
    }
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToVertex($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'tools'
        ], transformedList);
    }
    const fromToolConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolConfig'
    ]);
    if (parentObject !== undefined && fromToolConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'toolConfig'
    ], $e4deb49dba5321bc$var$toolConfigToVertex(fromToolConfig));
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromCachedContent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'cachedContent'
    ]);
    if (parentObject !== undefined && fromCachedContent != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'cachedContent'
    ], $e4deb49dba5321bc$var$tCachedContentName(apiClient, fromCachedContent));
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToVertex($e4deb49dba5321bc$var$tSpeechConfig(fromSpeechConfig)));
    const fromAudioTimestamp = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageConfig'
    ]);
    if (fromImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageConfig'
    ], $e4deb49dba5321bc$var$imageConfigToVertex(fromImageConfig));
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]) !== undefined) throw new Error('enableEnhancedCivicAnswers parameter is not supported in Vertex AI.');
    const fromModelArmorConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelArmorConfig'
    ]);
    if (parentObject !== undefined && fromModelArmorConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'modelArmorConfig'
    ], fromModelArmorConfig);
    const fromServiceTier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serviceTier'
    ]);
    if (parentObject !== undefined && fromServiceTier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'serviceTier'
    ], fromServiceTier);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToMldev$1(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromContents = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contents'
    ]);
    if (fromContents != null) {
        let transformedList = $e4deb49dba5321bc$var$tContents(fromContents);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$contentToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'contents'
        ], transformedList);
    }
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'generationConfig'
    ], $e4deb49dba5321bc$var$generateContentConfigToVertex(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$candidateFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    const fromModelStatus = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelStatus'
    ]);
    if (fromModelStatus != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelStatus'
    ], fromModelStatus);
    return toObject;
}
function $e4deb49dba5321bc$var$generateContentResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromCandidates = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidates'
    ]);
    if (fromCandidates != null) {
        let transformedList = fromCandidates;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'candidates'
        ], transformedList);
    }
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromModelVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelVersion'
    ]);
    if (fromModelVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelVersion'
    ], fromModelVersion);
    const fromPromptFeedback = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'promptFeedback'
    ]);
    if (fromPromptFeedback != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'promptFeedback'
    ], fromPromptFeedback);
    const fromResponseId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseId'
    ]);
    if (fromResponseId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseId'
    ], fromResponseId);
    const fromUsageMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'usageMetadata'
    ]);
    if (fromUsageMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'usageMetadata'
    ], fromUsageMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]) !== undefined) throw new Error('negativePrompt parameter is not supported in Gemini API.');
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]) !== undefined) throw new Error('addWatermark parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (parentObject !== undefined && fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleImageSize'
    ], fromImageSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]) !== undefined) throw new Error('enhancePrompt parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromGuidanceScale = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'guidanceScale'
    ]);
    if (parentObject !== undefined && fromGuidanceScale != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'guidanceScale'
    ], fromGuidanceScale);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeSafetyAttributes'
    ]);
    if (parentObject !== undefined && fromIncludeSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeSafetyAttributes'
    ], fromIncludeSafetyAttributes);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromLanguage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'language'
    ]);
    if (parentObject !== undefined && fromLanguage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'language'
    ], fromLanguage);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (parentObject !== undefined && fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleImageSize'
    ], fromImageSize);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateImagesConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateImagesConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromPositivePromptSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$generateImagesResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    const fromPositivePromptSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'positivePromptSafetyAttributes'
    ]);
    if (fromPositivePromptSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'positivePromptSafetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromPositivePromptSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosConfigToMldev(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromNumberOfVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]) !== undefined) throw new Error('outputGcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]) !== undefined) throw new Error('fps parameter is not supported in Gemini API.');
    const fromDurationSeconds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]) !== undefined) throw new Error('seed parameter is not supported in Gemini API.');
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resolution'
    ]);
    if (parentObject !== undefined && fromResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'resolution'
    ], fromResolution);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pubsubTopic'
    ]) !== undefined) throw new Error('pubsubTopic parameter is not supported in Gemini API.');
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generateAudio'
    ]) !== undefined) throw new Error('generateAudio parameter is not supported in Gemini API.');
    const fromLastFrame = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastFrame'
    ]);
    if (parentObject !== undefined && fromLastFrame != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'lastFrame'
    ], $e4deb49dba5321bc$var$imageToMldev(fromLastFrame));
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (parentObject !== undefined && fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$videoGenerationReferenceImageToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mask'
    ]) !== undefined) throw new Error('mask parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'compressionQuality'
    ]) !== undefined) throw new Error('compressionQuality parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromNumberOfVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfVideos'
    ]);
    if (parentObject !== undefined && fromNumberOfVideos != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfVideos);
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromFps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fps'
    ]);
    if (parentObject !== undefined && fromFps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'fps'
    ], fromFps);
    const fromDurationSeconds = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'durationSeconds'
    ]);
    if (parentObject !== undefined && fromDurationSeconds != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'durationSeconds'
    ], fromDurationSeconds);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (parentObject !== undefined && fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'aspectRatio'
    ], fromAspectRatio);
    const fromResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'resolution'
    ]);
    if (parentObject !== undefined && fromResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'resolution'
    ], fromResolution);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromPubsubTopic = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pubsubTopic'
    ]);
    if (parentObject !== undefined && fromPubsubTopic != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'pubsubTopic'
    ], fromPubsubTopic);
    const fromNegativePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'negativePrompt'
    ]);
    if (parentObject !== undefined && fromNegativePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'negativePrompt'
    ], fromNegativePrompt);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    const fromGenerateAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generateAudio'
    ]);
    if (parentObject !== undefined && fromGenerateAudio != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'generateAudio'
    ], fromGenerateAudio);
    const fromLastFrame = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lastFrame'
    ]);
    if (parentObject !== undefined && fromLastFrame != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'lastFrame'
    ], $e4deb49dba5321bc$var$imageToVertex(fromLastFrame));
    const fromReferenceImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImages'
    ]);
    if (parentObject !== undefined && fromReferenceImages != null) {
        let transformedList = fromReferenceImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$videoGenerationReferenceImageToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'referenceImages'
        ], transformedList);
    }
    const fromMask = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mask'
    ]);
    if (parentObject !== undefined && fromMask != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'mask'
    ], $e4deb49dba5321bc$var$videoGenerationMaskToVertex(fromMask));
    const fromCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'compressionQuality'
    ]);
    if (parentObject !== undefined && fromCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'compressionQuality'
    ], fromCompressionQuality);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response',
        'generateVideoResponse'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromMldev(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosOperationFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$generateVideosResponseFromVertex(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToMldev(fromVideo));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$generateVideosSourceToMldev(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateVideosConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToVertex(fromVideo));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$generateVideosSourceToVertex(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$generateVideosConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generatedSamples'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedVideos = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videos'
    ]);
    if (fromGeneratedVideos != null) {
        let transformedList = fromGeneratedVideos;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedVideoFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedVideos'
        ], transformedList);
    }
    const fromRaiMediaFilteredCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredCount'
    ]);
    if (fromRaiMediaFilteredCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredCount'
    ], fromRaiMediaFilteredCount);
    const fromRaiMediaFilteredReasons = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiMediaFilteredReasons'
    ]);
    if (fromRaiMediaFilteredReasons != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiMediaFilteredReasons'
    ], fromRaiMediaFilteredReasons);
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosSourceToMldev(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (parentObject !== undefined && fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToMldev(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generateVideosSourceToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (parentObject !== undefined && fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'video'
    ], $e4deb49dba5321bc$var$videoToVertex(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageFromMldev(fromImage));
    const fromRaiFilteredReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromSafetyAttributes));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageFromVertex(fromImage));
    const fromRaiFilteredReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'raiFilteredReason'
    ]);
    if (fromRaiFilteredReason != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'raiFilteredReason'
    ], fromRaiFilteredReason);
    const fromSafetyAttributes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromSafetyAttributes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'safetyAttributes'
    ], $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromSafetyAttributes));
    const fromEnhancedPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (fromEnhancedPrompt != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enhancedPrompt'
    ], fromEnhancedPrompt);
    return toObject;
}
function $e4deb49dba5321bc$var$generatedImageMaskFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromMask = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromMask != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mask'
    ], $e4deb49dba5321bc$var$imageFromVertex(fromMask));
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) {
        let transformedList = fromLabels;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'labels'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'video'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromMldev(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generatedVideoFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromVideo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromVideo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'video'
    ], $e4deb49dba5321bc$var$videoFromVertex(fromVideo));
    return toObject;
}
function $e4deb49dba5321bc$var$generationConfigToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromModelSelectionConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'modelSelectionConfig'
    ]);
    if (fromModelSelectionConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'modelConfig'
    ], fromModelSelectionConfig);
    const fromResponseJsonSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseJsonSchema'
    ]);
    if (fromResponseJsonSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseJsonSchema'
    ], fromResponseJsonSchema);
    const fromAudioTimestamp = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'audioTimestamp'
    ]);
    if (fromAudioTimestamp != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'audioTimestamp'
    ], fromAudioTimestamp);
    const fromCandidateCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'candidateCount'
    ]);
    if (fromCandidateCount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'candidateCount'
    ], fromCandidateCount);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromFrequencyPenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'frequencyPenalty'
    ]);
    if (fromFrequencyPenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'frequencyPenalty'
    ], fromFrequencyPenalty);
    const fromLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'logprobs'
    ]);
    if (fromLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'logprobs'
    ], fromLogprobs);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromPresencePenalty = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'presencePenalty'
    ]);
    if (fromPresencePenalty != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'presencePenalty'
    ], fromPresencePenalty);
    const fromResponseLogprobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseLogprobs'
    ]);
    if (fromResponseLogprobs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseLogprobs'
    ], fromResponseLogprobs);
    const fromResponseMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseMimeType'
    ]);
    if (fromResponseMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseMimeType'
    ], fromResponseMimeType);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseModalities'
    ], fromResponseModalities);
    const fromResponseSchema = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseSchema'
    ]);
    if (fromResponseSchema != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'responseSchema'
    ], fromResponseSchema);
    const fromRoutingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'routingConfig'
    ]);
    if (fromRoutingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'routingConfig'
    ], fromRoutingConfig);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speechConfig'
    ], $e4deb49dba5321bc$var$speechConfigToVertex(fromSpeechConfig));
    const fromStopSequences = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'stopSequences'
    ]);
    if (fromStopSequences != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'stopSequences'
    ], fromStopSequences);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableEnhancedCivicAnswers'
    ]) !== undefined) throw new Error('enableEnhancedCivicAnswers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$getModelParametersToMldev(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$getModelParametersToVertex(apiClient, fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev$1(fromObject, rootObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToMldev$1(fromAuthConfig));
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev$1(fromObject, _rootObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$imageConfigToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'aspectRatio'
    ], fromAspectRatio);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageSize'
    ], fromImageSize);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]) !== undefined) throw new Error('personGeneration parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prominentPeople'
    ]) !== undefined) throw new Error('prominentPeople parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]) !== undefined) throw new Error('outputMimeType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]) !== undefined) throw new Error('outputCompressionQuality parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageOutputOptions'
    ]) !== undefined) throw new Error('imageOutputOptions parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$imageConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromAspectRatio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'aspectRatio'
    ]);
    if (fromAspectRatio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'aspectRatio'
    ], fromAspectRatio);
    const fromImageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageSize'
    ]);
    if (fromImageSize != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageSize'
    ], fromImageSize);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'personGeneration'
    ], fromPersonGeneration);
    const fromProminentPeople = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prominentPeople'
    ]);
    if (fromProminentPeople != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prominentPeople'
    ], fromProminentPeople);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageOutputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageOutputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromImageOutputOptions = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageOutputOptions'
    ]);
    if (fromImageOutputOptions != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageOutputOptions'
    ], fromImageOutputOptions);
    return toObject;
}
function $e4deb49dba5321bc$var$imageFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$imageFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'imageBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$imageToMldev(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$imageToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromGcsUri);
    const fromImageBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imageBytes'
    ]);
    if (fromImageBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromImageBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsConfigToMldev(apiClient, fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], $e4deb49dba5321bc$var$tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsConfigToVertex(apiClient, fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    const fromQueryBase = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'queryBase'
    ]);
    if (parentObject !== undefined && fromQueryBase != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_url',
        'models_url'
    ], $e4deb49dba5321bc$var$tModelsUrl(apiClient, fromQueryBase));
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listModelsConfigToMldev(apiClient, fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listModelsConfigToVertex(apiClient, fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = $e4deb49dba5321bc$var$tExtractModels(fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modelFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listModelsResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromModels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromModels != null) {
        let transformedList = $e4deb49dba5321bc$var$tExtractModels(fromModels);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$modelFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'models'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$maskReferenceConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromMaskMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskMode'
    ]);
    if (fromMaskMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskMode'
    ], fromMaskMode);
    const fromSegmentationClasses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'segmentationClasses'
    ]);
    if (fromSegmentationClasses != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskClasses'
    ], fromSegmentationClasses);
    const fromMaskDilation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskDilation'
    ]);
    if (fromMaskDilation != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'dilation'
    ], fromMaskDilation);
    return toObject;
}
function $e4deb49dba5321bc$var$modelFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'version'
    ]);
    if (fromVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromTunedModelInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelInfo'
    ], $e4deb49dba5321bc$var$tunedModelInfoFromMldev(fromTunedModelInfo));
    const fromInputTokenLimit = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputTokenLimit'
    ]);
    if (fromInputTokenLimit != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inputTokenLimit'
    ], fromInputTokenLimit);
    const fromOutputTokenLimit = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputTokenLimit'
    ]);
    if (fromOutputTokenLimit != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputTokenLimit'
    ], fromOutputTokenLimit);
    const fromSupportedActions = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'supportedGenerationMethods'
    ]);
    if (fromSupportedActions != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'supportedActions'
    ], fromSupportedActions);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'temperature'
    ], fromTemperature);
    const fromMaxTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxTemperature'
    ]);
    if (fromMaxTemperature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maxTemperature'
    ], fromMaxTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'topK'
    ], fromTopK);
    const fromThinking = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinking'
    ]);
    if (fromThinking != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thinking'
    ], fromThinking);
    return toObject;
}
function $e4deb49dba5321bc$var$modelFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromVersion = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'versionId'
    ]);
    if (fromVersion != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'version'
    ], fromVersion);
    const fromEndpoints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'deployedModels'
    ]);
    if (fromEndpoints != null) {
        let transformedList = fromEndpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$endpointFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'endpoints'
        ], transformedList);
    }
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromTunedModelInfo = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModelInfo != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelInfo'
    ], $e4deb49dba5321bc$var$tunedModelInfoFromVertex(fromTunedModelInfo));
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    const fromCheckpoints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'checkpoints'
    ]);
    if (fromCheckpoints != null) {
        let transformedList = fromCheckpoints;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'checkpoints'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSpeakerVoiceConfigs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speakerVoiceConfigs'
    ]);
    if (fromSpeakerVoiceConfigs != null) {
        let transformedList = fromSpeakerVoiceConfigs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$speakerVoiceConfigToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'speakerVoiceConfigs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev$1(fromObject, rootObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev$1(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev$1(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev$1(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], fromToolCall);
    const fromToolResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]);
    if (fromToolResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolResponse'
    ], fromToolResponse);
    const fromPartMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]);
    if (fromPartMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partMetadata'
    ], fromPartMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$partToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], fromFileData);
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], fromFunctionCall);
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], fromInlineData);
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]) !== undefined) throw new Error('toolCall parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]) !== undefined) throw new Error('toolResponse parameter is not supported in Vertex AI.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]) !== undefined) throw new Error('partMetadata parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$productImageToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromProductImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'productImage'
    ]);
    if (fromProductImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromProductImage));
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromBaseSteps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseSteps'
    ]);
    if (parentObject !== undefined && fromBaseSteps != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'baseSteps'
    ], fromBaseSteps);
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'seed'
    ], fromSeed);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromAddWatermark = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'addWatermark'
    ]);
    if (parentObject !== undefined && fromAddWatermark != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'addWatermark'
    ], fromAddWatermark);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromEnhancePrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhancePrompt'
    ]);
    if (parentObject !== undefined && fromEnhancePrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'enhancePrompt'
    ], fromEnhancePrompt);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$recontextImageSourceToVertex(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$recontextImageConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$recontextImageSourceToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromPersonImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personImage'
    ]);
    if (parentObject !== undefined && fromPersonImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'personImage',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromPersonImage));
    const fromProductImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'productImages'
    ]);
    if (parentObject !== undefined && fromProductImages != null) {
        let transformedList = fromProductImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$productImageToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'instances[0]',
            'productImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$referenceImageAPIInternalToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromReferenceImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceImage'
    ]);
    if (fromReferenceImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceImage'
    ], $e4deb49dba5321bc$var$imageToVertex(fromReferenceImage));
    const fromReferenceId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceId'
    ]);
    if (fromReferenceId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceId'
    ], fromReferenceId);
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    const fromMaskImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskImageConfig'
    ]);
    if (fromMaskImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskImageConfig'
    ], $e4deb49dba5321bc$var$maskReferenceConfigToVertex(fromMaskImageConfig));
    const fromControlImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'controlImageConfig'
    ]);
    if (fromControlImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'controlImageConfig'
    ], $e4deb49dba5321bc$var$controlReferenceConfigToVertex(fromControlImageConfig));
    const fromStyleImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'styleImageConfig'
    ]);
    if (fromStyleImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'styleImageConfig'
    ], fromStyleImageConfig);
    const fromSubjectImageConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'subjectImageConfig'
    ]);
    if (fromSubjectImageConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'subjectImageConfig'
    ], fromSubjectImageConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$replicatedVoiceConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    const fromVoiceSampleAudio = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceSampleAudio'
    ]);
    if (fromVoiceSampleAudio != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceSampleAudio'
    ], fromVoiceSampleAudio);
    return toObject;
}
function $e4deb49dba5321bc$var$safetyAttributesFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromCategories = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetyAttributesFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromCategories = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'categories'
    ]);
    if (fromCategories != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'categories'
    ], fromCategories);
    const fromScores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyAttributes',
        'scores'
    ]);
    if (fromScores != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'scores'
    ], fromScores);
    const fromContentType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contentType'
    ]);
    if (fromContentType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'contentType'
    ], fromContentType);
    return toObject;
}
function $e4deb49dba5321bc$var$safetySettingToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromCategory = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'category'
    ]);
    if (fromCategory != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'category'
    ], fromCategory);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'method'
    ]) !== undefined) throw new Error('method parameter is not supported in Gemini API.');
    const fromThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'threshold'
    ]);
    if (fromThreshold != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'threshold'
    ], fromThreshold);
    return toObject;
}
function $e4deb49dba5321bc$var$scribbleImageToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (parentObject !== undefined && fromMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'mode'
    ], fromMode);
    const fromMaxPredictions = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxPredictions'
    ]);
    if (parentObject !== undefined && fromMaxPredictions != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'maxPredictions'
    ], fromMaxPredictions);
    const fromConfidenceThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'confidenceThreshold'
    ]);
    if (parentObject !== undefined && fromConfidenceThreshold != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'confidenceThreshold'
    ], fromConfidenceThreshold);
    const fromMaskDilation = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskDilation'
    ]);
    if (parentObject !== undefined && fromMaskDilation != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'maskDilation'
    ], fromMaskDilation);
    const fromBinaryColorThreshold = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'binaryColorThreshold'
    ]);
    if (parentObject !== undefined && fromBinaryColorThreshold != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'binaryColorThreshold'
    ], fromBinaryColorThreshold);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'source'
    ]);
    if (fromSource != null) $e4deb49dba5321bc$var$segmentImageSourceToVertex(fromSource, toObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$segmentImageConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromGeneratedMasks = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedMasks != null) {
        let transformedList = fromGeneratedMasks;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageMaskFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedMasks'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$segmentImageSourceToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    const fromPrompt = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prompt'
    ]);
    if (parentObject !== undefined && fromPrompt != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'prompt'
    ], fromPrompt);
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (parentObject !== undefined && fromImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromScribbleImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'scribbleImage'
    ]);
    if (parentObject !== undefined && fromScribbleImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'instances[0]',
        'scribble'
    ], $e4deb49dba5321bc$var$scribbleImageToVertex(fromScribbleImage));
    return toObject;
}
function $e4deb49dba5321bc$var$speakerVoiceConfigToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSpeaker = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speaker'
    ]);
    if (fromSpeaker != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'speaker'
    ], fromSpeaker);
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToVertex(fromVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$speechConfigToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'voiceConfig'
    ]);
    if (fromVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'voiceConfig'
    ], $e4deb49dba5321bc$var$voiceConfigToVertex(fromVoiceConfig));
    const fromLanguageCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCode'
    ]);
    if (fromLanguageCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'languageCode'
    ], fromLanguageCode);
    const fromMultiSpeakerVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'multiSpeakerVoiceConfig'
    ]);
    if (fromMultiSpeakerVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'multiSpeakerVoiceConfig'
    ], $e4deb49dba5321bc$var$multiSpeakerVoiceConfigToVertex(fromMultiSpeakerVoiceConfig));
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], $e4deb49dba5321bc$var$functionCallingConfigToMldev(fromFunctionCallingConfig));
    const fromIncludeServerSideToolInvocations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeServerSideToolInvocations'
    ]);
    if (fromIncludeServerSideToolInvocations != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'includeServerSideToolInvocations'
    ], fromIncludeServerSideToolInvocations);
    return toObject;
}
function $e4deb49dba5321bc$var$toolConfigToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromRetrievalConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrievalConfig'
    ]);
    if (fromRetrievalConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrievalConfig'
    ], fromRetrievalConfig);
    const fromFunctionCallingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCallingConfig'
    ]);
    if (fromFunctionCallingConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCallingConfig'
    ], fromFunctionCallingConfig);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeServerSideToolInvocations'
    ]) !== undefined) throw new Error('includeServerSideToolInvocations parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev$1(fromObject, rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev$1(fromGoogleSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev$1(fromGoogleMaps));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]) !== undefined) throw new Error('parallelAiSearch parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$toolToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]);
    if (fromRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'retrieval'
    ], fromRetrieval);
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]) !== undefined) throw new Error('fileSearch parameter is not supported in Vertex AI.');
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], fromGoogleSearch);
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], fromGoogleMaps);
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    const fromEnterpriseWebSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]);
    if (fromEnterpriseWebSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enterpriseWebSearch'
    ], fromEnterpriseWebSearch);
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$functionDeclarationToVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    const fromParallelAiSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]);
    if (fromParallelAiSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parallelAiSearch'
    ], fromParallelAiSearch);
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]) !== undefined) throw new Error('mcpServers parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelInfoFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelInfoFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels',
        'google-vertex-llm-tuning-base-model-id'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    const fromDefaultCheckpointId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'defaultCheckpointId'
    ]);
    if (parentObject !== undefined && fromDefaultCheckpointId != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'defaultCheckpointId'
    ], fromDefaultCheckpointId);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelParametersToMldev(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateModelConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$updateModelParametersToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$updateModelConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageAPIConfigInternalToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromOutputGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputGcsUri'
    ]);
    if (parentObject !== undefined && fromOutputGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'storageUri'
    ], fromOutputGcsUri);
    const fromSafetyFilterLevel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'safetyFilterLevel'
    ]);
    if (parentObject !== undefined && fromSafetyFilterLevel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'safetySetting'
    ], fromSafetyFilterLevel);
    const fromPersonGeneration = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'personGeneration'
    ]);
    if (parentObject !== undefined && fromPersonGeneration != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'personGeneration'
    ], fromPersonGeneration);
    const fromIncludeRaiReason = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'includeRaiReason'
    ]);
    if (parentObject !== undefined && fromIncludeRaiReason != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'includeRaiReason'
    ], fromIncludeRaiReason);
    const fromOutputMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputMimeType'
    ]);
    if (parentObject !== undefined && fromOutputMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'mimeType'
    ], fromOutputMimeType);
    const fromOutputCompressionQuality = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputCompressionQuality'
    ]);
    if (parentObject !== undefined && fromOutputCompressionQuality != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'outputOptions',
        'compressionQuality'
    ], fromOutputCompressionQuality);
    const fromEnhanceInputImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enhanceInputImage'
    ]);
    if (parentObject !== undefined && fromEnhanceInputImage != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'upscaleConfig',
        'enhanceInputImage'
    ], fromEnhanceInputImage);
    const fromImagePreservationFactor = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'imagePreservationFactor'
    ]);
    if (parentObject !== undefined && fromImagePreservationFactor != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'upscaleConfig',
        'imagePreservationFactor'
    ], fromImagePreservationFactor);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromNumberOfImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'numberOfImages'
    ]);
    if (parentObject !== undefined && fromNumberOfImages != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'sampleCount'
    ], fromNumberOfImages);
    const fromMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mode'
    ]);
    if (parentObject !== undefined && fromMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'parameters',
        'mode'
    ], fromMode);
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageAPIParametersInternalToVertex(apiClient, fromObject, rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'instances[0]',
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromUpscaleFactor = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'upscaleFactor'
    ]);
    if (fromUpscaleFactor != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parameters',
        'upscaleConfig',
        'upscaleFactor'
    ], fromUpscaleFactor);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$upscaleImageAPIConfigInternalToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$upscaleImageResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromGeneratedImages = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'predictions'
    ]);
    if (fromGeneratedImages != null) {
        let transformedList = fromGeneratedImages;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$generatedImageFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'generatedImages'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encodedVideo'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encoding'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'bytesBase64Encoded'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoBytes'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationMaskToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_self'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromMaskMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maskMode'
    ]);
    if (fromMaskMode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'maskMode'
    ], fromMaskMode);
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationReferenceImageToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToMldev(fromImage));
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoGenerationReferenceImageToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromImage = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'image'
    ]);
    if (fromImage != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'image'
    ], $e4deb49dba5321bc$var$imageToVertex(fromImage));
    const fromReferenceType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'referenceType'
    ]);
    if (fromReferenceType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'referenceType'
    ], fromReferenceType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'uri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoBytes'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'encodedVideo'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'encoding'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$videoToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uri'
    ]);
    if (fromUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'gcsUri'
    ], fromUri);
    const fromVideoBytes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoBytes'
    ]);
    if (fromVideoBytes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'bytesBase64Encoded'
    ], $e4deb49dba5321bc$var$tBytes(fromVideoBytes));
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$voiceConfigToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromReplicatedVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'replicatedVoiceConfig'
    ]);
    if (fromReplicatedVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'replicatedVoiceConfig'
    ], $e4deb49dba5321bc$var$replicatedVoiceConfigToVertex(fromReplicatedVoiceConfig));
    const fromPrebuiltVoiceConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'prebuiltVoiceConfig'
    ]);
    if (fromPrebuiltVoiceConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'prebuiltVoiceConfig'
    ], fromPrebuiltVoiceConfig);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$createFileSearchStoreConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    return toObject;
}
function $e4deb49dba5321bc$var$createFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createFileSearchStoreConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileSearchStoreConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromForce = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'force'
    ]);
    if (parentObject !== undefined && fromForce != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'force'
    ], fromForce);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$deleteFileSearchStoreConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$getFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromCustomMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customMetadata'
    ]);
    if (parentObject !== undefined && fromCustomMetadata != null) {
        let transformedList = fromCustomMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'customMetadata'
        ], transformedList);
    }
    const fromChunkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'chunkingConfig'
    ]);
    if (parentObject !== undefined && fromChunkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'chunkingConfig'
    ], fromChunkingConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileOperationFromMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'response'
    ]);
    if (fromResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'response'
    ], $e4deb49dba5321bc$var$importFileResponseFromMldev(fromResponse));
    return toObject;
}
function $e4deb49dba5321bc$var$importFileParametersToMldev(fromObject) {
    const toObject = {};
    const fromFileSearchStoreName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearchStoreName'
    ]);
    if (fromFileSearchStoreName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file_search_store_name'
    ], fromFileSearchStoreName);
    const fromFileName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileName'
    ]);
    if (fromFileName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileName'
    ], fromFileName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$importFileConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$importFileResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'parent'
    ], fromParent);
    const fromDocumentName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documentName'
    ]);
    if (fromDocumentName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'documentName'
    ], fromDocumentName);
    return toObject;
}
function $e4deb49dba5321bc$var$listFileSearchStoresConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listFileSearchStoresParametersToMldev(fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listFileSearchStoresConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listFileSearchStoresResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromFileSearchStores = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearchStores'
    ]);
    if (fromFileSearchStores != null) {
        let transformedList = fromFileSearchStores;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'fileSearchStores'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (parentObject !== undefined && fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'mimeType'
    ], fromMimeType);
    const fromDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]);
    if (parentObject !== undefined && fromDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromDisplayName);
    const fromCustomMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customMetadata'
    ]);
    if (parentObject !== undefined && fromCustomMetadata != null) {
        let transformedList = fromCustomMetadata;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'customMetadata'
        ], transformedList);
    }
    const fromChunkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'chunkingConfig'
    ]);
    if (parentObject !== undefined && fromChunkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'chunkingConfig'
    ], fromChunkingConfig);
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreParametersToMldev(fromObject) {
    const toObject = {};
    const fromFileSearchStoreName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearchStoreName'
    ]);
    if (fromFileSearchStoreName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'file_search_store_name'
    ], fromFileSearchStoreName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$uploadToFileSearchStoreConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$uploadToFileSearchStoreResumableResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$CONTENT_TYPE_HEADER = 'Content-Type';
const $e4deb49dba5321bc$var$SERVER_TIMEOUT_HEADER = 'X-Server-Timeout';
const $e4deb49dba5321bc$var$USER_AGENT_HEADER = 'User-Agent';
const $e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER = 'x-goog-api-client';
const $e4deb49dba5321bc$var$SDK_VERSION = '1.48.0'; // x-release-please-version
const $e4deb49dba5321bc$var$LIBRARY_LABEL = `google-genai-sdk/${$e4deb49dba5321bc$var$SDK_VERSION}`;
const $e4deb49dba5321bc$var$VERTEX_AI_API_DEFAULT_VERSION = 'v1beta1';
const $e4deb49dba5321bc$var$GOOGLE_AI_API_DEFAULT_VERSION = 'v1beta';
// Default retry options.
// The config is based on https://cloud.google.com/storage/docs/retry-strategy.
const $e4deb49dba5321bc$var$DEFAULT_RETRY_ATTEMPTS = 5; // Including the initial call
// LINT.IfChange
const $e4deb49dba5321bc$var$DEFAULT_RETRY_HTTP_STATUS_CODES = [
    408,
    429,
    500,
    502,
    503,
    504
];
/**
 * The ApiClient class is used to send requests to the Gemini API or Vertex AI
 * endpoints.
 *
 * WARNING: This is an internal API and may change without notice. Direct usage
 * is not supported and may break your application.
 */ class $e4deb49dba5321bc$var$ApiClient {
    constructor(opts){
        var _a, _b, _c;
        this.clientOptions = Object.assign({}, opts);
        this.customBaseUrl = (_a = opts.httpOptions) === null || _a === void 0 ? void 0 : _a.baseUrl;
        if (this.clientOptions.vertexai) {
            if (this.clientOptions.project && this.clientOptions.location) this.clientOptions.apiKey = undefined;
            else if (this.clientOptions.apiKey) {
                this.clientOptions.project = undefined;
                this.clientOptions.location = undefined;
            }
        }
        const initHttpOptions = {};
        if (this.clientOptions.vertexai) {
            if (!this.clientOptions.location && !this.clientOptions.apiKey && !this.customBaseUrl) this.clientOptions.location = 'global';
            const hasSufficientAuth = this.clientOptions.project && this.clientOptions.location || this.clientOptions.apiKey;
            if (!hasSufficientAuth && !this.customBaseUrl) throw new Error('Authentication is not set up. Please provide either a project and location, or an API key, or a custom base URL.');
            const hasConstructorAuth = opts.project && opts.location || !!opts.apiKey;
            if (this.customBaseUrl && !hasConstructorAuth) {
                initHttpOptions.baseUrl = this.customBaseUrl;
                this.clientOptions.project = undefined;
                this.clientOptions.location = undefined;
            } else if (this.clientOptions.apiKey || this.clientOptions.location === 'global') // Vertex Express or global endpoint case.
            initHttpOptions.baseUrl = 'https://aiplatform.googleapis.com/';
            else if (this.clientOptions.project && this.clientOptions.location && this.clientOptions.location === 'us') initHttpOptions.baseUrl = `https://aiplatform.${this.clientOptions.location}.rep.googleapis.com/`;
            else if (this.clientOptions.project && this.clientOptions.location) initHttpOptions.baseUrl = `https://${this.clientOptions.location}-aiplatform.googleapis.com/`;
            initHttpOptions.apiVersion = (_b = this.clientOptions.apiVersion) !== null && _b !== void 0 ? _b : $e4deb49dba5321bc$var$VERTEX_AI_API_DEFAULT_VERSION;
        } else {
            // Gemini API
            if (!this.clientOptions.apiKey) console.warn('API key should be set when using the Gemini API.');
            initHttpOptions.apiVersion = (_c = this.clientOptions.apiVersion) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$GOOGLE_AI_API_DEFAULT_VERSION;
            initHttpOptions.baseUrl = `https://generativelanguage.googleapis.com/`;
        }
        initHttpOptions.headers = this.getDefaultHeaders();
        this.clientOptions.httpOptions = initHttpOptions;
        if (opts.httpOptions) this.clientOptions.httpOptions = this.patchHttpOptions(initHttpOptions, opts.httpOptions);
    }
    isVertexAI() {
        var _a;
        return (_a = this.clientOptions.vertexai) !== null && _a !== void 0 ? _a : false;
    }
    getProject() {
        return this.clientOptions.project;
    }
    getLocation() {
        return this.clientOptions.location;
    }
    getCustomBaseUrl() {
        return this.customBaseUrl;
    }
    async getAuthHeaders() {
        const headers = new Headers();
        await this.clientOptions.auth.addAuthHeaders(headers);
        return headers;
    }
    getApiVersion() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.apiVersion !== undefined) return this.clientOptions.httpOptions.apiVersion;
        throw new Error('API version is not set.');
    }
    getBaseUrl() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.baseUrl !== undefined) return this.clientOptions.httpOptions.baseUrl;
        throw new Error('Base URL is not set.');
    }
    getRequestUrl() {
        return this.getRequestUrlInternal(this.clientOptions.httpOptions);
    }
    getHeaders() {
        if (this.clientOptions.httpOptions && this.clientOptions.httpOptions.headers !== undefined) return this.clientOptions.httpOptions.headers;
        else throw new Error('Headers are not set.');
    }
    getRequestUrlInternal(httpOptions) {
        if (!httpOptions || httpOptions.baseUrl === undefined || httpOptions.apiVersion === undefined) throw new Error('HTTP options are not correctly set.');
        const baseUrl = httpOptions.baseUrl.endsWith('/') ? httpOptions.baseUrl.slice(0, -1) : httpOptions.baseUrl;
        const urlElement = [
            baseUrl
        ];
        if (httpOptions.apiVersion && httpOptions.apiVersion !== '') urlElement.push(httpOptions.apiVersion);
        return urlElement.join('/');
    }
    getBaseResourcePath() {
        return `projects/${this.clientOptions.project}/locations/${this.clientOptions.location}`;
    }
    getApiKey() {
        return this.clientOptions.apiKey;
    }
    getWebsocketBaseUrl() {
        const baseUrl = this.getBaseUrl();
        const urlParts = new URL(baseUrl);
        urlParts.protocol = urlParts.protocol == 'http:' ? 'ws' : 'wss';
        return urlParts.toString();
    }
    setBaseUrl(url) {
        if (this.clientOptions.httpOptions) this.clientOptions.httpOptions.baseUrl = url;
        else throw new Error('HTTP options are not correctly set.');
    }
    constructUrl(path, httpOptions, prependProjectLocation) {
        const urlElement = [
            this.getRequestUrlInternal(httpOptions)
        ];
        if (prependProjectLocation) urlElement.push(this.getBaseResourcePath());
        if (path !== '') urlElement.push(path);
        const url = new URL(`${urlElement.join('/')}`);
        return url;
    }
    shouldPrependVertexProjectPath(request, httpOptions) {
        if (httpOptions.baseUrl && httpOptions.baseUrlResourceScope === $e4deb49dba5321bc$export$ce358901f8c7a617.COLLECTION) return false;
        if (this.clientOptions.apiKey) return false;
        if (!this.clientOptions.vertexai) return false;
        if (request.path.startsWith('projects/')) // Assume the path already starts with
        // `projects/<project>/location/<location>`.
        return false;
        if (request.httpMethod === 'GET' && request.path.startsWith('publishers/google/models')) // These paths are used by Vertex's models.get and models.list
        // calls. For base models Vertex does not accept a project/location
        // prefix (for tuned model the prefix is required).
        return false;
        return true;
    }
    async request(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request, patchedHttpOptions);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (request.queryParams) for (const [key, value] of Object.entries(request.queryParams))url.searchParams.append(key, String(value));
        let requestInit = {};
        if (request.httpMethod === 'GET') {
            if (request.body && request.body !== '{}') throw new Error('Request body should be empty for GET request, but got non empty request body');
        } else requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, url.toString(), request.abortSignal);
        return this.unaryApiCall(url, requestInit, request.httpMethod);
    }
    patchHttpOptions(baseHttpOptions, requestHttpOptions) {
        const patchedHttpOptions = JSON.parse(JSON.stringify(baseHttpOptions));
        for (const [key, value] of Object.entries(requestHttpOptions)){
            // Records compile to objects.
            if (typeof value === 'object') // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = Object.assign(Object.assign({}, patchedHttpOptions[key]), value);
            else if (value !== undefined) // @ts-expect-error TS2345TS7053: Element implicitly has an 'any' type
            // because expression of type 'string' can't be used to index type
            // 'HttpOptions'.
            patchedHttpOptions[key] = value;
        }
        return patchedHttpOptions;
    }
    async requestStream(request) {
        let patchedHttpOptions = this.clientOptions.httpOptions;
        if (request.httpOptions) patchedHttpOptions = this.patchHttpOptions(this.clientOptions.httpOptions, request.httpOptions);
        const prependProjectLocation = this.shouldPrependVertexProjectPath(request, patchedHttpOptions);
        const url = this.constructUrl(request.path, patchedHttpOptions, prependProjectLocation);
        if (!url.searchParams.has('alt') || url.searchParams.get('alt') !== 'sse') url.searchParams.set('alt', 'sse');
        let requestInit = {};
        requestInit.body = request.body;
        requestInit = await this.includeExtraHttpOptionsToRequestInit(requestInit, patchedHttpOptions, url.toString(), request.abortSignal);
        return this.streamApiCall(url, requestInit, request.httpMethod);
    }
    async includeExtraHttpOptionsToRequestInit(requestInit, httpOptions, url, abortSignal) {
        if (httpOptions && httpOptions.timeout || abortSignal) {
            const abortController = new AbortController();
            const signal = abortController.signal;
            if (httpOptions.timeout && (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.timeout) > 0) {
                const timeoutHandle = setTimeout(()=>abortController.abort(), httpOptions.timeout);
                if (timeoutHandle && typeof timeoutHandle.unref === 'function') // call unref to prevent nodejs process from hanging, see
                // https://nodejs.org/api/timers.html#timeoutunref
                timeoutHandle.unref();
            }
            if (abortSignal) abortSignal.addEventListener('abort', ()=>{
                abortController.abort();
            });
            requestInit.signal = signal;
        }
        if (httpOptions && httpOptions.extraBody !== null) $e4deb49dba5321bc$var$includeExtraBodyToRequestInit(requestInit, httpOptions.extraBody);
        requestInit.headers = await this.getHeadersInternal(httpOptions, url);
        return requestInit;
    }
    async unaryApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await $e4deb49dba5321bc$var$throwErrorIfNotOK(response);
            return new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    async streamApiCall(url, requestInit, httpMethod) {
        return this.apiCall(url.toString(), Object.assign(Object.assign({}, requestInit), {
            method: httpMethod
        })).then(async (response)=>{
            await $e4deb49dba5321bc$var$throwErrorIfNotOK(response);
            return this.processStreamResponse(response);
        }).catch((e)=>{
            if (e instanceof Error) throw e;
            else throw new Error(JSON.stringify(e));
        });
    }
    processStreamResponse(response) {
        return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* processStreamResponse_1() {
            var _a;
            const reader = (_a = response === null || response === void 0 ? void 0 : response.body) === null || _a === void 0 ? void 0 : _a.getReader();
            const decoder = new TextDecoder('utf-8');
            if (!reader) throw new Error('Response body is empty');
            try {
                let buffer = '';
                const dataPrefix = 'data:';
                const delimiters = [
                    '\n\n',
                    '\r\r',
                    '\r\n\r\n'
                ];
                while(true){
                    const { done: done, value: value } = yield $e4deb49dba5321bc$var$__await(reader.read());
                    if (done) {
                        if (buffer.trim().length > 0) throw new Error('Incomplete JSON segment at the end');
                        break;
                    }
                    const chunkString = decoder.decode(value, {
                        stream: true
                    });
                    // Parse and throw an error if the chunk contains an error.
                    try {
                        const chunkJson = JSON.parse(chunkString);
                        if ('error' in chunkJson) {
                            const errorJson = JSON.parse(JSON.stringify(chunkJson['error']));
                            const status = errorJson['status'];
                            const code = errorJson['code'];
                            const errorMessage = `got status: ${status}. ${JSON.stringify(chunkJson)}`;
                            if (code >= 400 && code < 600) {
                                const apiError = new $e4deb49dba5321bc$export$f2e832acab1bdd79({
                                    message: errorMessage,
                                    status: code
                                });
                                throw apiError;
                            }
                        }
                    } catch (e) {
                        const error = e;
                        if (error.name === 'ApiError') throw e;
                    }
                    buffer += chunkString;
                    let delimiterIndex = -1;
                    let delimiterLength = 0;
                    while(true){
                        delimiterIndex = -1;
                        delimiterLength = 0;
                        for (const delimiter of delimiters){
                            const index = buffer.indexOf(delimiter);
                            if (index !== -1 && (delimiterIndex === -1 || index < delimiterIndex)) {
                                delimiterIndex = index;
                                delimiterLength = delimiter.length;
                            }
                        }
                        if (delimiterIndex === -1) break; // No complete event in buffer
                        const eventString = buffer.substring(0, delimiterIndex);
                        buffer = buffer.substring(delimiterIndex + delimiterLength);
                        const trimmedEvent = eventString.trim();
                        if (trimmedEvent.startsWith(dataPrefix)) {
                            const processedChunkString = trimmedEvent.substring(dataPrefix.length).trim();
                            try {
                                const partialResponse = new Response(processedChunkString, {
                                    headers: response === null || response === void 0 ? void 0 : response.headers,
                                    status: response === null || response === void 0 ? void 0 : response.status,
                                    statusText: response === null || response === void 0 ? void 0 : response.statusText
                                });
                                yield yield $e4deb49dba5321bc$var$__await(new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(partialResponse));
                            } catch (e) {
                                throw new Error(`exception parsing stream chunk ${processedChunkString}. ${e}`);
                            }
                        }
                    }
                }
            } finally{
                reader.releaseLock();
            }
        });
    }
    async apiCall(url, requestInit) {
        var _a;
        if (!this.clientOptions.httpOptions || !this.clientOptions.httpOptions.retryOptions) return fetch(url, requestInit);
        const retryOptions = this.clientOptions.httpOptions.retryOptions;
        const runFetch = async ()=>{
            const response = await fetch(url, requestInit);
            if (response.ok) return response;
            if ($e4deb49dba5321bc$var$DEFAULT_RETRY_HTTP_STATUS_CODES.includes(response.status)) throw new Error(`Retryable HTTP Error: ${response.statusText}`);
            throw new (0, $b6d378dfee037fa8$exports.AbortError)(`Non-retryable exception ${response.statusText} sending request`);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($b6d378dfee037fa8$exports)))(runFetch, {
            // Retry attempts is one less than the number of total attempts.
            retries: ((_a = retryOptions.attempts) !== null && _a !== void 0 ? _a : $e4deb49dba5321bc$var$DEFAULT_RETRY_ATTEMPTS) - 1
        });
    }
    getDefaultHeaders() {
        const headers = {};
        const versionHeaderValue = $e4deb49dba5321bc$var$LIBRARY_LABEL + ' ' + this.clientOptions.userAgentExtra;
        headers[$e4deb49dba5321bc$var$USER_AGENT_HEADER] = versionHeaderValue;
        headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER] = versionHeaderValue;
        headers[$e4deb49dba5321bc$var$CONTENT_TYPE_HEADER] = 'application/json';
        return headers;
    }
    async getHeadersInternal(httpOptions, url) {
        const headers = new Headers();
        if (httpOptions && httpOptions.headers) {
            for (const [key, value] of Object.entries(httpOptions.headers))headers.append(key, value);
            // Append a timeout header if it is set, note that the timeout option is
            // in milliseconds but the header is in seconds.
            if (httpOptions.timeout && httpOptions.timeout > 0) headers.append($e4deb49dba5321bc$var$SERVER_TIMEOUT_HEADER, String(Math.ceil(httpOptions.timeout / 1000)));
        }
        await this.clientOptions.auth.addAuthHeaders(headers, url);
        return headers;
    }
    getFileName(file) {
        var _a;
        let fileName = '';
        if (typeof file === 'string') {
            fileName = file.replace(/[/\\]+$/, '');
            fileName = (_a = fileName.split(/[/\\]/).pop()) !== null && _a !== void 0 ? _a : '';
        }
        return fileName;
    }
    /**
     * Uploads a file asynchronously using Gemini API only, this is not supported
     * in Vertex AI.
     *
     * @param file The string path to the file to be uploaded or a Blob object.
     * @param config Optional parameters specified in the `UploadFileConfig`
     *     interface. @see {@link types.UploadFileConfig}
     * @return A promise that resolves to a `File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     */ async uploadFile(file, config) {
        var _a;
        const fileToUpload = {};
        if (config != null) {
            fileToUpload.mimeType = config.mimeType;
            fileToUpload.name = config.name;
            fileToUpload.displayName = config.displayName;
        }
        if (fileToUpload.name && !fileToUpload.name.startsWith('files/')) fileToUpload.name = `files/${fileToUpload.name}`;
        const uploader = this.clientOptions.uploader;
        const fileStat = await uploader.stat(file);
        fileToUpload.sizeBytes = String(fileStat.size);
        const mimeType = (_a = config === null || config === void 0 ? void 0 : config.mimeType) !== null && _a !== void 0 ? _a : fileStat.type;
        if (mimeType === undefined || mimeType === '') throw new Error('Can not determine mimeType. Please provide mimeType in the config.');
        fileToUpload.mimeType = mimeType;
        const body = {
            file: fileToUpload
        };
        const fileName = this.getFileName(file);
        const path = $e4deb49dba5321bc$var$formatMap('upload/v1beta/files', body['_url']);
        const uploadUrl = await this.fetchUploadUrl(path, fileToUpload.sizeBytes, fileToUpload.mimeType, fileName, body, config === null || config === void 0 ? void 0 : config.httpOptions);
        return uploader.upload(file, uploadUrl, this);
    }
    /**
     * Uploads a file to a given file search store asynchronously using Gemini API only, this is not supported
     * in Vertex AI.
     *
     * @param fileSearchStoreName The name of the file search store to upload the file to.
     * @param file The string path to the file to be uploaded or a Blob object.
     * @param config Optional parameters specified in the `UploadFileConfig`
     *     interface. @see {@link UploadFileConfig}
     * @return A promise that resolves to a `File` object.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     */ async uploadFileToFileSearchStore(fileSearchStoreName, file, config) {
        var _a;
        const uploader = this.clientOptions.uploader;
        const fileStat = await uploader.stat(file);
        const sizeBytes = String(fileStat.size);
        const mimeType = (_a = config === null || config === void 0 ? void 0 : config.mimeType) !== null && _a !== void 0 ? _a : fileStat.type;
        if (mimeType === undefined || mimeType === '') throw new Error('Can not determine mimeType. Please provide mimeType in the config.');
        const path = `upload/v1beta/${fileSearchStoreName}:uploadToFileSearchStore`;
        const fileName = this.getFileName(file);
        const body = {};
        if (config != null) $e4deb49dba5321bc$var$uploadToFileSearchStoreConfigToMldev(config, body);
        const uploadUrl = await this.fetchUploadUrl(path, sizeBytes, mimeType, fileName, body, config === null || config === void 0 ? void 0 : config.httpOptions);
        return uploader.uploadToFileSearchStore(file, uploadUrl, this);
    }
    /**
     * Downloads a file asynchronously to the specified path.
     *
     * @params params - The parameters for the download request, see {@link
     * types.DownloadFileParameters}
     */ async downloadFile(params) {
        const downloader = this.clientOptions.downloader;
        await downloader.download(params, this);
    }
    async fetchUploadUrl(path, sizeBytes, mimeType, fileName, body, configHttpOptions) {
        var _a;
        let httpOptions = {};
        if (configHttpOptions) httpOptions = configHttpOptions;
        else httpOptions = {
            apiVersion: '',
            headers: Object.assign({
                'Content-Type': 'application/json',
                'X-Goog-Upload-Protocol': 'resumable',
                'X-Goog-Upload-Command': 'start',
                'X-Goog-Upload-Header-Content-Length': `${sizeBytes}`,
                'X-Goog-Upload-Header-Content-Type': `${mimeType}`
            }, fileName ? {
                'X-Goog-Upload-File-Name': fileName
            } : {})
        };
        const httpResponse = await this.request({
            path: path,
            body: JSON.stringify(body),
            httpMethod: 'POST',
            httpOptions: httpOptions
        });
        if (!httpResponse || !(httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers)) throw new Error('Server did not return an HttpResponse or the returned HttpResponse did not have headers.');
        const uploadUrl = (_a = httpResponse === null || httpResponse === void 0 ? void 0 : httpResponse.headers) === null || _a === void 0 ? void 0 : _a['x-goog-upload-url'];
        if (uploadUrl === undefined) throw new Error('Failed to get upload url. Server did not return the x-google-upload-url in the headers');
        return uploadUrl;
    }
}
async function $e4deb49dba5321bc$var$throwErrorIfNotOK(response) {
    var _a;
    if (response === undefined) throw new Error('response is undefined');
    if (!response.ok) {
        const status = response.status;
        let errorBody;
        if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) errorBody = await response.json();
        else errorBody = {
            error: {
                message: await response.text(),
                code: response.status,
                status: response.statusText
            }
        };
        const errorMessage = JSON.stringify(errorBody);
        if (status >= 400 && status < 600) {
            const apiError = new $e4deb49dba5321bc$export$f2e832acab1bdd79({
                message: errorMessage,
                status: status
            });
            throw apiError;
        }
        throw new Error(errorMessage);
    }
}
/**
 * Recursively updates the `requestInit.body` with values from an `extraBody` object.
 *
 * If `requestInit.body` is a string, it's assumed to be JSON and will be parsed.
 * The `extraBody` is then deeply merged into this parsed object.
 * If `requestInit.body` is a Blob, `extraBody` will be ignored, and a warning logged,
 * as merging structured data into an opaque Blob is not supported.
 *
 * The function does not enforce that updated values from `extraBody` have the
 * same type as existing values in `requestInit.body`. Type mismatches during
 * the merge will result in a warning, but the value from `extraBody` will overwrite
 * the original. `extraBody` users are responsible for ensuring `extraBody` has the correct structure.
 *
 * @param requestInit The RequestInit object whose body will be updated.
 * @param extraBody The object containing updates to be merged into `requestInit.body`.
 */ function $e4deb49dba5321bc$var$includeExtraBodyToRequestInit(requestInit, extraBody) {
    if (!extraBody || Object.keys(extraBody).length === 0) return;
    if (requestInit.body instanceof Blob) {
        console.warn('includeExtraBodyToRequestInit: extraBody provided but current request body is a Blob. extraBody will be ignored as merging is not supported for Blob bodies.');
        return;
    }
    let currentBodyObject = {};
    // If adding new type to HttpRequest.body, please check the code below to
    // see if we need to update the logic.
    if (typeof requestInit.body === 'string' && requestInit.body.length > 0) try {
        const parsedBody = JSON.parse(requestInit.body);
        if (typeof parsedBody === 'object' && parsedBody !== null && !Array.isArray(parsedBody)) currentBodyObject = parsedBody;
        else {
            console.warn('includeExtraBodyToRequestInit: Original request body is valid JSON but not a non-array object. Skip applying extraBody to the request body.');
            return;
        }
    /*  eslint-disable-next-line @typescript-eslint/no-unused-vars */ } catch (e) {
        console.warn('includeExtraBodyToRequestInit: Original request body is not valid JSON. Skip applying extraBody to the request body.');
        return;
    }
    function deepMerge(target, source) {
        const output = Object.assign({}, target);
        for(const key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
            const sourceValue = source[key];
            const targetValue = output[key];
            if (sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue) && targetValue && typeof targetValue === 'object' && !Array.isArray(targetValue)) output[key] = deepMerge(targetValue, sourceValue);
            else {
                if (targetValue && sourceValue && typeof targetValue !== typeof sourceValue) console.warn(`includeExtraBodyToRequestInit:deepMerge: Type mismatch for key "${key}". Original type: ${typeof targetValue}, New type: ${typeof sourceValue}. Overwriting.`);
                output[key] = sourceValue;
            }
        }
        return output;
    }
    const mergedBody = deepMerge(currentBodyObject, extraBody);
    requestInit.body = JSON.stringify(mergedBody);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // TODO: b/416041229 - Determine how to retrieve the MCP package version.
const $e4deb49dba5321bc$var$MCP_LABEL = 'mcp_used/unknown';
// Whether MCP tool usage is detected from mcpToTool. This is used for
// telemetry.
let $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool = false;
// Checks whether the list of tools contains any MCP tools.
function $e4deb49dba5321bc$var$hasMcpToolUsage(tools) {
    for (const tool of tools){
        if ($e4deb49dba5321bc$var$isMcpCallableTool(tool)) return true;
        if (typeof tool === 'object' && 'inputSchema' in tool) return true;
    }
    return $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool;
}
// Sets the MCP version label in the Google API client header.
function $e4deb49dba5321bc$var$setMcpUsageHeader(headers) {
    var _a;
    const existingHeader = (_a = headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER]) !== null && _a !== void 0 ? _a : '';
    headers[$e4deb49dba5321bc$var$GOOGLE_API_CLIENT_HEADER] = (existingHeader + ` ${$e4deb49dba5321bc$var$MCP_LABEL}`).trimStart();
}
// Returns true if the object is a MCP CallableTool, otherwise false.
function $e4deb49dba5321bc$var$isMcpCallableTool(object) {
    return object !== null && typeof object === 'object' && object instanceof $e4deb49dba5321bc$var$McpCallableTool;
}
// List all tools from the MCP client.
function $e4deb49dba5321bc$var$listAllTools(mcpClient_1) {
    return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* listAllTools_1(mcpClient, maxTools = 100) {
        let cursor = undefined;
        let numTools = 0;
        while(numTools < maxTools){
            const t = yield $e4deb49dba5321bc$var$__await(mcpClient.listTools({
                cursor: cursor
            }));
            for (const tool of t.tools){
                yield yield $e4deb49dba5321bc$var$__await(tool);
                numTools++;
            }
            if (!t.nextCursor) break;
            cursor = t.nextCursor;
        }
    });
}
/**
 * McpCallableTool can be used for model inference and invoking MCP clients with
 * given function call arguments.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ class $e4deb49dba5321bc$var$McpCallableTool {
    constructor(mcpClients = [], config){
        this.mcpTools = [];
        this.functionNameToMcpClient = {};
        this.mcpClients = mcpClients;
        this.config = config;
    }
    /**
     * Creates a McpCallableTool.
     */ static create(mcpClients, config) {
        return new $e4deb49dba5321bc$var$McpCallableTool(mcpClients, config);
    }
    /**
     * Validates the function names are not duplicate and initialize the function
     * name to MCP client mapping.
     *
     * @throws {Error} if the MCP tools from the MCP clients have duplicate tool
     *     names.
     */ async initialize() {
        var _a, e_1, _b, _c;
        if (this.mcpTools.length > 0) return;
        const functionMap = {};
        const mcpTools = [];
        for (const mcpClient of this.mcpClients)try {
            for(var _d = true, _e = (e_1 = void 0, $e4deb49dba5321bc$var$__asyncValues($e4deb49dba5321bc$var$listAllTools(mcpClient))), _f; _f = await _e.next(), _a = _f.done, !_a; _d = true){
                _c = _f.value;
                _d = false;
                const mcpTool = _c;
                mcpTools.push(mcpTool);
                const mcpToolName = mcpTool.name;
                if (functionMap[mcpToolName]) throw new Error(`Duplicate function name ${mcpToolName} found in MCP tools. Please ensure function names are unique.`);
                functionMap[mcpToolName] = mcpClient;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = _e.return)) await _b.call(_e);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.mcpTools = mcpTools;
        this.functionNameToMcpClient = functionMap;
    }
    async tool() {
        await this.initialize();
        return $e4deb49dba5321bc$var$mcpToolsToGeminiTool(this.mcpTools, this.config);
    }
    async callTool(functionCalls) {
        await this.initialize();
        const functionCallResponseParts = [];
        for (const functionCall of functionCalls)if (functionCall.name in this.functionNameToMcpClient) {
            const mcpClient = this.functionNameToMcpClient[functionCall.name];
            let requestOptions = undefined;
            // TODO: b/424238654 - Add support for finer grained timeout control.
            if (this.config.timeout) requestOptions = {
                timeout: this.config.timeout
            };
            const callToolResponse = await mcpClient.callTool({
                name: functionCall.name,
                arguments: functionCall.args
            }, // Set the result schema to undefined to allow MCP to rely on the
            // default schema.
            undefined, requestOptions);
            functionCallResponseParts.push({
                functionResponse: {
                    name: functionCall.name,
                    response: callToolResponse.isError ? {
                        error: callToolResponse
                    } : callToolResponse
                }
            });
        }
        return functionCallResponseParts;
    }
}
function $e4deb49dba5321bc$var$isMcpClient(client) {
    return client !== null && typeof client === 'object' && 'listTools' in client && typeof client.listTools === 'function';
}
/**
 * Creates a McpCallableTool from MCP clients and an optional config.
 *
 * The callable tool can invoke the MCP clients with given function call
 * arguments. (often for automatic function calling).
 * Use the config to modify tool parameters such as behavior.
 *
 * @experimental Built-in MCP support is an experimental feature, may change in future
 * versions.
 */ function $e4deb49dba5321bc$export$836b74d9f63bb1cd(...args) {
    // Set MCP usage for telemetry.
    $e4deb49dba5321bc$var$hasMcpToolUsageFromMcpToTool = true;
    if (args.length === 0) throw new Error('No MCP clients provided');
    const maybeConfig = args[args.length - 1];
    if ($e4deb49dba5321bc$var$isMcpClient(maybeConfig)) return $e4deb49dba5321bc$var$McpCallableTool.create(args, {});
    return $e4deb49dba5321bc$var$McpCallableTool.create(args.slice(0, args.length - 1), maybeConfig);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveMusicServerMessage, and then calling the onmessage callback.
 * Note that the first message which is received from the server is a
 * setupComplete message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function $e4deb49dba5321bc$var$handleWebSocketMessage$1(apiClient, onmessage, event) {
    const serverMessage = new $e4deb49dba5321bc$export$5f085d7f78cd2680();
    let data;
    if (event.data instanceof Blob) data = JSON.parse(await event.data.text());
    else data = JSON.parse(event.data);
    Object.assign(serverMessage, data);
    onmessage(serverMessage);
}
/**
   LiveMusic class encapsulates the configuration for live music
   generation via Lyria Live models.

   @experimental
  */ class $e4deb49dba5321bc$var$LiveMusic {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
    }
    /**
       Establishes a connection to the specified model and returns a
       LiveMusicSession object representing that connection.
  
       @experimental
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model = 'models/lyria-realtime-exp';
       const session = await ai.live.music.connect({
         model: model,
         callbacks: {
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b;
        if (this.apiClient.isVertexAI()) throw new Error('Live music is not supported for Vertex AI.');
        console.warn('Live music generation is experimental and may change in future versions.');
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        const headers = $e4deb49dba5321bc$var$mapToHeaders$1(this.apiClient.getDefaultHeaders());
        const apiKey = this.apiClient.getApiKey();
        const url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.BidiGenerateMusic?key=${apiKey}`;
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                $e4deb49dba5321bc$var$handleWebSocketMessage$1(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, $e4deb49dba5321bc$var$headersToMap$1(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        const model = $e4deb49dba5321bc$var$tModel(this.apiClient, params.model);
        const setup = {
            model: model
        };
        const clientMessage = {
            setup: setup
        };
        conn.send(JSON.stringify(clientMessage));
        return new $e4deb49dba5321bc$var$LiveMusicSession(conn, this.apiClient);
    }
}
/**
   Represents a connection to the API.

   @experimental
  */ class $e4deb49dba5321bc$var$LiveMusicSession {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    /**
      Sets inputs to steer music generation. Updates the session's current
      weighted prompts.
  
      @param params - Contains one property, `weightedPrompts`.
  
        - `weightedPrompts` to send to the model; weights are normalized to
          sum to 1.0.
  
      @experimental
     */ async setWeightedPrompts(params) {
        if (!params.weightedPrompts || Object.keys(params.weightedPrompts).length === 0) throw new Error('Weighted prompts must be set and contain at least one entry.');
        const clientContent = $e4deb49dba5321bc$var$liveMusicSetWeightedPromptsParametersToMldev(params);
        this.conn.send(JSON.stringify({
            clientContent: clientContent
        }));
    }
    /**
      Sets a configuration to the model. Updates the session's current
      music generation config.
  
      @param params - Contains one property, `musicGenerationConfig`.
  
        - `musicGenerationConfig` to set in the model. Passing an empty or
      undefined config to the model will reset the config to defaults.
  
      @experimental
     */ async setMusicGenerationConfig(params) {
        if (!params.musicGenerationConfig) params.musicGenerationConfig = {};
        const setConfigParameters = $e4deb49dba5321bc$var$liveMusicSetConfigParametersToMldev(params);
        this.conn.send(JSON.stringify(setConfigParameters));
    }
    sendPlaybackControl(playbackControl) {
        const clientMessage = {
            playbackControl: playbackControl
        };
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
     * Start the music stream.
     *
     * @experimental
     */ play() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.PLAY);
    }
    /**
     * Temporarily halt the music stream. Use `play` to resume from the current
     * position.
     *
     * @experimental
     */ pause() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.PAUSE);
    }
    /**
     * Stop the music stream and reset the state. Retains the current prompts
     * and config.
     *
     * @experimental
     */ stop() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.STOP);
    }
    /**
     * Resets the context of the music generation without stopping it.
     * Retains the current prompts and config.
     *
     * @experimental
     */ resetContext() {
        this.sendPlaybackControl($e4deb49dba5321bc$export$3d1b3b2fa769f3a.RESET_CONTEXT);
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function $e4deb49dba5321bc$var$headersToMap$1(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function $e4deb49dba5321bc$var$mapToHeaders$1(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$FUNCTION_RESPONSE_REQUIRES_ID = 'FunctionResponse request must have an `id` field from the response of a ToolCall.FunctionalCalls in Google AI.';
/**
 * Handles incoming messages from the WebSocket.
 *
 * @remarks
 * This function is responsible for parsing incoming messages, transforming them
 * into LiveServerMessages, and then calling the onmessage callback. Note that
 * the first message which is received from the server is a setupComplete
 * message.
 *
 * @param apiClient The ApiClient instance.
 * @param onmessage The user-provided onmessage callback (if any).
 * @param event The MessageEvent from the WebSocket.
 */ async function $e4deb49dba5321bc$var$handleWebSocketMessage(apiClient, onmessage, event) {
    const serverMessage = new $e4deb49dba5321bc$export$a509bcf6072c871c();
    let jsonData;
    if (event.data instanceof Blob) jsonData = await event.data.text();
    else if (event.data instanceof ArrayBuffer) jsonData = new TextDecoder().decode(event.data);
    else jsonData = event.data;
    const data = JSON.parse(jsonData);
    if (apiClient.isVertexAI()) {
        const resp = $e4deb49dba5321bc$var$liveServerMessageFromVertex(data);
        Object.assign(serverMessage, resp);
    } else {
        const resp = data;
        Object.assign(serverMessage, resp);
    }
    onmessage(serverMessage);
}
/**
   Live class encapsulates the configuration for live interaction with the
   Generative Language API. It embeds ApiClient for general API settings.

   @experimental
  */ class $e4deb49dba5321bc$export$db78b3d0b2aa666a {
    constructor(apiClient, auth, webSocketFactory){
        this.apiClient = apiClient;
        this.auth = auth;
        this.webSocketFactory = webSocketFactory;
        this.music = new $e4deb49dba5321bc$var$LiveMusic(this.apiClient, this.auth, this.webSocketFactory);
    }
    /**
       Establishes a connection to the specified model with the given
       configuration and returns a Session object representing that connection.
  
       @experimental Built-in MCP support is an experimental feature, may change in
       future versions.
  
       @remarks
  
       @param params - The parameters for establishing a connection to the model.
       @return A live session.
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-live-2.5-flash-preview';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         },
         callbacks: {
           onopen: () => {
             console.log('Connected to the socket.');
           },
           onmessage: (e: MessageEvent) => {
             console.log('Received message from the server: %s\n', debug(e.data));
           },
           onerror: (e: ErrorEvent) => {
             console.log('Error occurred: %s\n', debug(e.error));
           },
           onclose: (e: CloseEvent) => {
             console.log('Connection closed.');
           },
         },
       });
       ```
      */ async connect(params) {
        var _a, _b, _c, _d, _e, _f;
        // TODO: b/404946746 - Support per request HTTP options.
        if (params.config && params.config.httpOptions) throw new Error("The Live module does not support httpOptions at request-level in LiveConnectConfig yet. Please use the client-level httpOptions configuration instead.");
        const websocketBaseUrl = this.apiClient.getWebsocketBaseUrl();
        const apiVersion = this.apiClient.getApiVersion();
        let url;
        const clientHeaders = this.apiClient.getHeaders();
        if (params.config && params.config.tools && $e4deb49dba5321bc$var$hasMcpToolUsage(params.config.tools)) $e4deb49dba5321bc$var$setMcpUsageHeader(clientHeaders);
        const headers = $e4deb49dba5321bc$var$mapToHeaders(clientHeaders);
        if (this.apiClient.isVertexAI()) {
            const project = this.apiClient.getProject();
            const location = this.apiClient.getLocation();
            const apiKey = this.apiClient.getApiKey();
            const hasStandardAuth = !!project && !!location || !!apiKey;
            if (this.apiClient.getCustomBaseUrl() && !hasStandardAuth) // Custom base URL without standard auth (e.g., proxy).
            url = websocketBaseUrl;
            else {
                url = `${websocketBaseUrl}/ws/google.cloud.aiplatform.${apiVersion}.LlmBidiService/BidiGenerateContent`;
                await this.auth.addAuthHeaders(headers, url);
            }
        } else {
            const apiKey = this.apiClient.getApiKey();
            let method = 'BidiGenerateContent';
            let keyName = 'key';
            if (apiKey === null || apiKey === void 0 ? void 0 : apiKey.startsWith('auth_tokens/')) {
                console.warn('Warning: Ephemeral token support is experimental and may change in future versions.');
                if (apiVersion !== 'v1alpha') console.warn("Warning: The SDK's ephemeral token support is in v1alpha only. Please use const ai = new GoogleGenAI({apiKey: token.name, httpOptions: { apiVersion: 'v1alpha' }}); before session connection.");
                method = 'BidiGenerateContentConstrained';
                keyName = 'access_token';
            }
            url = `${websocketBaseUrl}/ws/google.ai.generativelanguage.${apiVersion}.GenerativeService.${method}?${keyName}=${apiKey}`;
        }
        let onopenResolve = ()=>{};
        const onopenPromise = new Promise((resolve)=>{
            onopenResolve = resolve;
        });
        const callbacks = params.callbacks;
        const onopenAwaitedCallback = function() {
            var _a;
            (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onopen) === null || _a === void 0 || _a.call(callbacks);
            onopenResolve({});
        };
        const apiClient = this.apiClient;
        const websocketCallbacks = {
            onopen: onopenAwaitedCallback,
            onmessage: (event)=>{
                $e4deb49dba5321bc$var$handleWebSocketMessage(apiClient, callbacks.onmessage, event);
            },
            onerror: (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onerror) !== null && _a !== void 0 ? _a : function(e) {},
            onclose: (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onclose) !== null && _b !== void 0 ? _b : function(e) {}
        };
        const conn = this.webSocketFactory.create(url, $e4deb49dba5321bc$var$headersToMap(headers), websocketCallbacks);
        conn.connect();
        // Wait for the websocket to open before sending requests.
        await onopenPromise;
        let transformedModel = $e4deb49dba5321bc$var$tModel(this.apiClient, params.model);
        if (this.apiClient.isVertexAI() && transformedModel.startsWith('publishers/')) {
            const project = this.apiClient.getProject();
            const location = this.apiClient.getLocation();
            if (project && location) transformedModel = `projects/${project}/locations/${location}/` + transformedModel;
        }
        let clientMessage = {};
        if (this.apiClient.isVertexAI() && ((_c = params.config) === null || _c === void 0 ? void 0 : _c.responseModalities) === undefined) {
            // Set default to AUDIO to align with MLDev API.
            if (params.config === undefined) params.config = {
                responseModalities: [
                    $e4deb49dba5321bc$export$9c9a8220008ddfc0.AUDIO
                ]
            };
            else params.config.responseModalities = [
                $e4deb49dba5321bc$export$9c9a8220008ddfc0.AUDIO
            ];
        }
        if ((_d = params.config) === null || _d === void 0 ? void 0 : _d.generationConfig) // Raise deprecation warning for generationConfig.
        console.warn('Setting `LiveConnectConfig.generation_config` is deprecated, please set the fields on `LiveConnectConfig` directly. This will become an error in a future version (not before Q3 2025).');
        const inputTools = (_f = (_e = params.config) === null || _e === void 0 ? void 0 : _e.tools) !== null && _f !== void 0 ? _f : [];
        const convertedTools = [];
        for (const tool of inputTools)if (this.isCallableTool(tool)) {
            const callableTool = tool;
            convertedTools.push(await callableTool.tool());
        } else convertedTools.push(tool);
        if (convertedTools.length > 0) params.config.tools = convertedTools;
        const liveConnectParameters = {
            model: transformedModel,
            config: params.config,
            callbacks: params.callbacks
        };
        if (this.apiClient.isVertexAI()) clientMessage = $e4deb49dba5321bc$var$liveConnectParametersToVertex(this.apiClient, liveConnectParameters);
        else clientMessage = $e4deb49dba5321bc$var$liveConnectParametersToMldev(this.apiClient, liveConnectParameters);
        delete clientMessage['config'];
        conn.send(JSON.stringify(clientMessage));
        return new $e4deb49dba5321bc$export$1fb4852a55678982(conn, this.apiClient);
    }
    // TODO: b/416041229 - Abstract this method to a common place.
    isCallableTool(tool) {
        return 'callTool' in tool && typeof tool.callTool === 'function';
    }
}
const $e4deb49dba5321bc$var$defaultLiveSendClientContentParamerters = {
    turnComplete: true
};
/**
   Represents a connection to the API.

   @experimental
  */ class $e4deb49dba5321bc$export$1fb4852a55678982 {
    constructor(conn, apiClient){
        this.conn = conn;
        this.apiClient = apiClient;
    }
    tLiveClientContent(apiClient, params) {
        if (params.turns !== null && params.turns !== undefined) {
            let contents = [];
            try {
                contents = $e4deb49dba5321bc$var$tContents(params.turns);
                if (!apiClient.isVertexAI()) contents = contents.map((item)=>$e4deb49dba5321bc$var$contentToMldev$1(item));
            } catch (_a) {
                throw new Error(`Failed to parse client content "turns", type: '${typeof params.turns}'`);
            }
            return {
                clientContent: {
                    turns: contents,
                    turnComplete: params.turnComplete
                }
            };
        }
        return {
            clientContent: {
                turnComplete: params.turnComplete
            }
        };
    }
    tLiveClienttToolResponse(apiClient, params) {
        let functionResponses = [];
        if (params.functionResponses == null) throw new Error('functionResponses is required.');
        if (!Array.isArray(params.functionResponses)) functionResponses = [
            params.functionResponses
        ];
        else functionResponses = params.functionResponses;
        if (functionResponses.length === 0) throw new Error('functionResponses is required.');
        for (const functionResponse of functionResponses){
            if (typeof functionResponse !== 'object' || functionResponse === null || !('name' in functionResponse) || !('response' in functionResponse)) throw new Error(`Could not parse function response, type '${typeof functionResponse}'.`);
            if (!apiClient.isVertexAI() && !('id' in functionResponse)) throw new Error($e4deb49dba5321bc$var$FUNCTION_RESPONSE_REQUIRES_ID);
        }
        const clientMessage = {
            toolResponse: {
                'functionResponses': functionResponses
            }
        };
        return clientMessage;
    }
    /**
      Send a message over the established connection.
  
      @param params - Contains two **optional** properties, `turns` and
          `turnComplete`.
  
        - `turns` will be converted to a `Content[]`
        - `turnComplete: true` [default] indicates that you are done sending
          content and expect a response. If `turnComplete: false`, the server
          will wait for additional messages before starting generation.
  
      @experimental
  
      @remarks
      There are two ways to send messages to the live API:
      `sendClientContent` and `sendRealtimeInput`.
  
      `sendClientContent` messages are added to the model context **in order**.
      Having a conversation using `sendClientContent` messages is roughly
      equivalent to using the `Chat.sendMessageStream`, except that the state of
      the `chat` history is stored on the API server instead of locally.
  
      Because of `sendClientContent`'s order guarantee, the model cannot respons
      as quickly to `sendClientContent` messages as to `sendRealtimeInput`
      messages. This makes the biggest difference when sending objects that have
      significant preprocessing time (typically images).
  
      The `sendClientContent` message sends a `Content[]`
      which has more options than the `Blob` sent by `sendRealtimeInput`.
  
      So the main use-cases for `sendClientContent` over `sendRealtimeInput` are:
  
      - Sending anything that can't be represented as a `Blob` (text,
      `sendClientContent({turns="Hello?"}`)).
      - Managing turns when not using audio input and voice activity detection.
        (`sendClientContent({turnComplete:true})` or the short form
      `sendClientContent()`)
      - Prefilling a conversation context
        ```
        sendClientContent({
            turns: [
              Content({role:user, parts:...}),
              Content({role:user, parts:...}),
              ...
            ]
        })
        ```
      @experimental
     */ sendClientContent(params) {
        params = Object.assign(Object.assign({}, $e4deb49dba5321bc$var$defaultLiveSendClientContentParamerters), params);
        const clientMessage = this.tLiveClientContent(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a realtime message over the established connection.
  
      @param params - Contains one property, `media`.
  
        - `media` will be converted to a `Blob`
  
      @experimental
  
      @remarks
      Use `sendRealtimeInput` for realtime audio chunks and video frames (images).
  
      With `sendRealtimeInput` the api will respond to audio automatically
      based on voice activity detection (VAD).
  
      `sendRealtimeInput` is optimized for responsivness at the expense of
      deterministic ordering guarantees. Audio and video tokens are to the
      context when they become available.
  
      Note: The Call signature expects a `Blob` object, but only a subset
      of audio and image mimetypes are allowed.
     */ sendRealtimeInput(params) {
        let clientMessage = {};
        if (this.apiClient.isVertexAI()) clientMessage = {
            'realtimeInput': $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToVertex(params)
        };
        else clientMessage = {
            'realtimeInput': $e4deb49dba5321bc$var$liveSendRealtimeInputParametersToMldev(params)
        };
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
      Send a function response message over the established connection.
  
      @param params - Contains property `functionResponses`.
  
        - `functionResponses` will be converted to a `functionResponses[]`
  
      @remarks
      Use `sendFunctionResponse` to reply to `LiveServerToolCall` from the server.
  
      Use {@link types.LiveConnectConfig#tools} to configure the callable functions.
  
      @experimental
     */ sendToolResponse(params) {
        if (params.functionResponses == null) throw new Error('Tool response parameters are required.');
        const clientMessage = this.tLiveClienttToolResponse(this.apiClient, params);
        this.conn.send(JSON.stringify(clientMessage));
    }
    /**
       Terminates the WebSocket connection.
  
       @experimental
  
       @example
       ```ts
       let model: string;
       if (GOOGLE_GENAI_USE_VERTEXAI) {
         model = 'gemini-2.0-flash-live-preview-04-09';
       } else {
         model = 'gemini-live-2.5-flash-preview';
       }
       const session = await ai.live.connect({
         model: model,
         config: {
           responseModalities: [Modality.AUDIO],
         }
       });
  
       session.close();
       ```
     */ close() {
        this.conn.close();
    }
}
// Converts an headers object to a "map" object as expected by the WebSocket
// constructor. We use this as the Auth interface works with Headers objects
// while the WebSocket constructor takes a map.
function $e4deb49dba5321bc$var$headersToMap(headers) {
    const headerMap = {};
    headers.forEach((value, key)=>{
        headerMap[key] = value;
    });
    return headerMap;
}
// Converts a "map" object to a headers object. We use this as the Auth
// interface works with Headers objects while the API client default headers
// returns a map.
function $e4deb49dba5321bc$var$mapToHeaders(map) {
    const headers = new Headers();
    for (const [key, value] of Object.entries(map))headers.append(key, value);
    return headers;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS = 10;
/** Returns whether automatic function calling is disabled. */ function $e4deb49dba5321bc$var$shouldDisableAfc(config) {
    var _a, _b, _c;
    if ((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.disable) return true;
    let callableToolsPresent = false;
    for (const tool of (_b = config === null || config === void 0 ? void 0 : config.tools) !== null && _b !== void 0 ? _b : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
        callableToolsPresent = true;
        break;
    }
    if (!callableToolsPresent) return true;
    const maxCalls = (_c = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _c === void 0 ? void 0 : _c.maximumRemoteCalls;
    if (maxCalls && (maxCalls < 0 || !Number.isInteger(maxCalls)) || maxCalls == 0) {
        console.warn('Invalid maximumRemoteCalls value provided for automatic function calling. Disabled automatic function calling. Please provide a valid integer value greater than 0. maximumRemoteCalls provided:', maxCalls);
        return true;
    }
    return false;
}
function $e4deb49dba5321bc$var$isCallableTool(tool) {
    return 'callTool' in tool && typeof tool.callTool === 'function';
}
// Checks whether the list of tools contains any CallableTools. Will return true
// if there is at least one CallableTool.
function $e4deb49dba5321bc$var$hasCallableTools(params) {
    var _a, _b, _c;
    return (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) === null || _b === void 0 ? void 0 : _b.some((tool)=>$e4deb49dba5321bc$var$isCallableTool(tool))) !== null && _c !== void 0 ? _c : false;
}
/**
 * Returns the indexes of the tools that are not compatible with AFC.
 */ function $e4deb49dba5321bc$var$findAfcIncompatibleToolIndexes(params) {
    var _a;
    // Use number[] for an array of numbers in TypeScript
    const afcIncompatibleToolIndexes = [];
    if (!((_a = params === null || params === void 0 ? void 0 : params.config) === null || _a === void 0 ? void 0 : _a.tools)) return afcIncompatibleToolIndexes;
    params.config.tools.forEach((tool, index)=>{
        if ($e4deb49dba5321bc$var$isCallableTool(tool)) return;
        const geminiTool = tool;
        if (geminiTool.functionDeclarations && geminiTool.functionDeclarations.length > 0) afcIncompatibleToolIndexes.push(index);
    });
    return afcIncompatibleToolIndexes;
}
/**
 * Returns whether to append automatic function calling history to the
 * response.
 */ function $e4deb49dba5321bc$var$shouldAppendAfcHistory(config) {
    var _a;
    return !((_a = config === null || config === void 0 ? void 0 : config.automaticFunctionCalling) === null || _a === void 0 ? void 0 : _a.ignoreCallHistory);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$6edbc060ce567afa extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Calculates embeddings for the given contents.
         *
         * @param params - The parameters for embedding contents.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await ai.models.embedContent({
         *  model: 'text-embedding-004',
         *  contents: [
         *    'What is your name?',
         *    'What is your favorite color?',
         *  ],
         *  config: {
         *    outputDimensionality: 64,
         *  },
         * });
         * console.log(response);
         * ```
         */ this.embedContent = async (params)=>{
            if (!this.apiClient.isVertexAI()) return await this.embedContentInternal(params);
            const isVertexEmbedContentModel = params.model.includes('gemini') && params.model !== 'gemini-embedding-001' || params.model.includes('maas');
            if (isVertexEmbedContentModel) {
                const contents = $e4deb49dba5321bc$var$tContents(params.contents);
                if (contents.length > 1) throw new Error('The embedContent API for this model only supports one content at a time.');
                const paramsPrivate = Object.assign(Object.assign({}, params), {
                    content: contents[0],
                    embeddingApiType: $e4deb49dba5321bc$export$adb1a6c77f7d58e6.EMBED_CONTENT
                });
                return await this.embedContentInternal(paramsPrivate);
            } else {
                const paramsPrivate = Object.assign(Object.assign({}, params), {
                    embeddingApiType: $e4deb49dba5321bc$export$adb1a6c77f7d58e6.PREDICT
                });
                return await this.embedContentInternal(paramsPrivate);
            }
        };
        /**
         * Makes an API request to generate content with a given model.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         * 'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContent({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     candidateCount: 2,
         *   }
         * });
         * console.log(response);
         * ```
         */ this.generateContent = async (params)=>{
            var _a, _b, _c, _d, _e;
            const transformedParams = await this.processParamsMaybeAddMcpUsage(params);
            this.maybeMoveToResponseJsonSchem(params);
            if (!$e4deb49dba5321bc$var$hasCallableTools(params) || $e4deb49dba5321bc$var$shouldDisableAfc(params.config)) return await this.generateContentInternal(transformedParams);
            const incompatibleToolIndexes = $e4deb49dba5321bc$var$findAfcIncompatibleToolIndexes(params);
            if (incompatibleToolIndexes.length > 0) {
                const formattedIndexes = incompatibleToolIndexes.map((index)=>`tools[${index}]`).join(', ');
                throw new Error(`Automatic function calling with CallableTools (or MCP objects) and basic FunctionDeclarations is not yet supported. Incompatible tools found at ${formattedIndexes}.`);
            }
            let response;
            let functionResponseContent;
            const automaticFunctionCallingHistory = $e4deb49dba5321bc$var$tContents(transformedParams.contents);
            const maxRemoteCalls = (_c = (_b = (_a = transformedParams.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS;
            let remoteCalls = 0;
            while(remoteCalls < maxRemoteCalls){
                response = await this.generateContentInternal(transformedParams);
                if (!response.functionCalls || response.functionCalls.length === 0) break;
                const responseContent = response.candidates[0].content;
                const functionResponseParts = [];
                for (const tool of (_e = (_d = params.config) === null || _d === void 0 ? void 0 : _d.tools) !== null && _e !== void 0 ? _e : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
                    const callableTool = tool;
                    const parts = await callableTool.callTool(response.functionCalls);
                    functionResponseParts.push(...parts);
                }
                remoteCalls++;
                functionResponseContent = {
                    role: 'user',
                    parts: functionResponseParts
                };
                transformedParams.contents = $e4deb49dba5321bc$var$tContents(transformedParams.contents);
                transformedParams.contents.push(responseContent);
                transformedParams.contents.push(functionResponseContent);
                if ($e4deb49dba5321bc$var$shouldAppendAfcHistory(transformedParams.config)) {
                    automaticFunctionCallingHistory.push(responseContent);
                    automaticFunctionCallingHistory.push(functionResponseContent);
                }
            }
            if ($e4deb49dba5321bc$var$shouldAppendAfcHistory(transformedParams.config)) response.automaticFunctionCallingHistory = automaticFunctionCallingHistory;
            return response;
        };
        /**
         * Makes an API request to generate content with a given model and yields the
         * response in chunks.
         *
         * For the `model` parameter, supported formats for Vertex AI API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The full resource name starts with 'projects/', for example:
         *  'projects/my-project-id/locations/us-central1/publishers/google/models/gemini-2.0-flash'
         * - The partial resource name with 'publishers/', for example:
         *  'publishers/google/models/gemini-2.0-flash' or
         *  'publishers/meta/models/llama-3.1-405b-instruct-maas'
         * - `/` separated publisher and model name, for example:
         * 'google/gemini-2.0-flash' or 'meta/llama-3.1-405b-instruct-maas'
         *
         * For the `model` parameter, supported formats for Gemini API include:
         * - The Gemini model ID, for example: 'gemini-2.0-flash'
         * - The model name starts with 'models/', for example:
         *  'models/gemini-2.0-flash'
         * - For tuned models, the model name starts with 'tunedModels/',
         * for example:
         *  'tunedModels/1234567890123456789'
         *
         * Some models support multimodal input and output.
         *
         * @param params - The parameters for generating content with streaming response.
         * @return The response from generating content.
         *
         * @example
         * ```ts
         * const response = await ai.models.generateContentStream({
         *   model: 'gemini-2.0-flash',
         *   contents: 'why is the sky blue?',
         *   config: {
         *     maxOutputTokens: 200,
         *   }
         * });
         * for await (const chunk of response) {
         *   console.log(chunk);
         * }
         * ```
         */ this.generateContentStream = async (params)=>{
            var _a, _b, _c, _d, _e;
            this.maybeMoveToResponseJsonSchem(params);
            if ($e4deb49dba5321bc$var$shouldDisableAfc(params.config)) {
                const transformedParams = await this.processParamsMaybeAddMcpUsage(params);
                return await this.generateContentStreamInternal(transformedParams);
            }
            const incompatibleToolIndexes = $e4deb49dba5321bc$var$findAfcIncompatibleToolIndexes(params);
            if (incompatibleToolIndexes.length > 0) {
                const formattedIndexes = incompatibleToolIndexes.map((index)=>`tools[${index}]`).join(', ');
                throw new Error(`Incompatible tools found at ${formattedIndexes}. Automatic function calling with CallableTools (or MCP objects) and basic FunctionDeclarations" is not yet supported.`);
            }
            // With tool compatibility confirmed, validate that the configuration are
            // compatible with each other and raise an error if invalid.
            const streamFunctionCall = (_c = (_b = (_a = params === null || params === void 0 ? void 0 : params.config) === null || _a === void 0 ? void 0 : _a.toolConfig) === null || _b === void 0 ? void 0 : _b.functionCallingConfig) === null || _c === void 0 ? void 0 : _c.streamFunctionCallArguments;
            const disableAfc = (_e = (_d = params === null || params === void 0 ? void 0 : params.config) === null || _d === void 0 ? void 0 : _d.automaticFunctionCalling) === null || _e === void 0 ? void 0 : _e.disable;
            if (streamFunctionCall && !disableAfc) throw new Error("Running in streaming mode with 'streamFunctionCallArguments' enabled, this feature is not compatible with automatic function calling (AFC). Please set 'config.automaticFunctionCalling.disable' to true to disable AFC or leave 'config.toolConfig.functionCallingConfig.streamFunctionCallArguments' to be undefined or set to false to disable streaming function call arguments feature.");
            return await this.processAfcStream(params);
        };
        /**
         * Generates an image based on a text description and configuration.
         *
         * @param params - The parameters for generating images.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.generateImages({
         *  model: 'imagen-4.0-generate-001',
         *  prompt: 'Robot holding a red skateboard',
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.generateImages = async (params)=>{
            return await this.generateImagesInternal(params).then((apiResponse)=>{
                var _a;
                let positivePromptSafetyAttributes;
                const generatedImages = [];
                if (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.generatedImages) {
                    for (const generatedImage of apiResponse.generatedImages)if (generatedImage && (generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) && ((_a = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes) === null || _a === void 0 ? void 0 : _a.contentType) === 'Positive Prompt') positivePromptSafetyAttributes = generatedImage === null || generatedImage === void 0 ? void 0 : generatedImage.safetyAttributes;
                    else generatedImages.push(generatedImage);
                }
                let response;
                if (positivePromptSafetyAttributes) response = {
                    generatedImages: generatedImages,
                    positivePromptSafetyAttributes: positivePromptSafetyAttributes,
                    sdkHttpResponse: apiResponse.sdkHttpResponse
                };
                else response = {
                    generatedImages: generatedImages,
                    sdkHttpResponse: apiResponse.sdkHttpResponse
                };
                return response;
            });
        };
        this.list = async (params)=>{
            var _a;
            const defaultConfig = {
                queryBase: true
            };
            const actualConfig = Object.assign(Object.assign({}, defaultConfig), params === null || params === void 0 ? void 0 : params.config);
            const actualParams = {
                config: actualConfig
            };
            if (this.apiClient.isVertexAI()) {
                if (!actualParams.config.queryBase) {
                    if ((_a = actualParams.config) === null || _a === void 0 ? void 0 : _a.filter) throw new Error('Filtering tuned models list for Vertex AI is not currently supported');
                    else actualParams.config.filter = 'labels.tune-type:*';
                }
            }
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_MODELS, (x)=>this.listInternal(x), await this.listInternal(actualParams), actualParams);
        };
        /**
         * Edits an image based on a prompt, list of reference images, and configuration.
         *
         * @param params - The parameters for editing an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.editImage({
         *  model: 'imagen-3.0-capability-001',
         *  prompt: 'Generate an image containing a mug with the product logo [1] visible on the side of the mug.',
         *  referenceImages: [subjectReferenceImage]
         *  config: {
         *    numberOfImages: 1,
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.editImage = async (params)=>{
            const paramsInternal = {
                model: params.model,
                prompt: params.prompt,
                referenceImages: [],
                config: params.config
            };
            if (params.referenceImages) {
                if (params.referenceImages) paramsInternal.referenceImages = params.referenceImages.map((img)=>img.toReferenceImageAPI());
            }
            return await this.editImageInternal(paramsInternal);
        };
        /**
         * Upscales an image based on an image, upscale factor, and configuration.
         * Only supported in Vertex AI currently.
         *
         * @param params - The parameters for upscaling an image.
         * @return The response from the API.
         *
         * @example
         * ```ts
         * const response = await client.models.upscaleImage({
         *  model: 'imagen-4.0-upscale-preview',
         *  image: image,
         *  upscaleFactor: 'x2',
         *  config: {
         *    includeRaiReason: true,
         *  },
         * });
         * console.log(response?.generatedImages?.[0]?.image?.imageBytes);
         * ```
         */ this.upscaleImage = async (params)=>{
            let apiConfig = {
                numberOfImages: 1,
                mode: 'upscale'
            };
            if (params.config) apiConfig = Object.assign(Object.assign({}, apiConfig), params.config);
            const apiParams = {
                model: params.model,
                image: params.image,
                upscaleFactor: params.upscaleFactor,
                config: apiConfig
            };
            return await this.upscaleImageInternal(apiParams);
        };
        /**
         *  Generates videos based on a text description and configuration.
         *
         * @param params - The parameters for generating videos.
         * @return A Promise<GenerateVideosOperation> which allows you to track the progress and eventually retrieve the generated videos using the operations.get method.
         *
         * @example
         * ```ts
         * const operation = await ai.models.generateVideos({
         *  model: 'veo-2.0-generate-001',
         *  source: {
         *    prompt: 'A neon hologram of a cat driving at top speed',
         *  },
         *  config: {
         *    numberOfVideos: 1
         * });
         *
         * while (!operation.done) {
         *   await new Promise(resolve => setTimeout(resolve, 10000));
         *   operation = await ai.operations.getVideosOperation({operation: operation});
         * }
         *
         * console.log(operation.response?.generatedVideos?.[0]?.video?.uri);
         * ```
         */ this.generateVideos = async (params)=>{
            var _a, _b, _c, _d, _e, _f;
            if ((params.prompt || params.image || params.video) && params.source) throw new Error('Source and prompt/image/video are mutually exclusive. Please only use source.');
            // Gemini API does not support video bytes.
            if (!this.apiClient.isVertexAI()) {
                if (((_a = params.video) === null || _a === void 0 ? void 0 : _a.uri) && ((_b = params.video) === null || _b === void 0 ? void 0 : _b.videoBytes)) params.video = {
                    uri: params.video.uri,
                    mimeType: params.video.mimeType
                };
                else if (((_d = (_c = params.source) === null || _c === void 0 ? void 0 : _c.video) === null || _d === void 0 ? void 0 : _d.uri) && ((_f = (_e = params.source) === null || _e === void 0 ? void 0 : _e.video) === null || _f === void 0 ? void 0 : _f.videoBytes)) params.source.video = {
                    uri: params.source.video.uri,
                    mimeType: params.source.video.mimeType
                };
            }
            return await this.generateVideosInternal(params);
        };
    }
    /**
     * This logic is needed for GenerateContentConfig only.
     * Previously we made GenerateContentConfig.responseSchema field to accept
     * unknown. Since v1.9.0, we switch to use backend JSON schema support.
     * To maintain backward compatibility, we move the data that was treated as
     * JSON schema from the responseSchema field to the responseJsonSchema field.
     */ maybeMoveToResponseJsonSchem(params) {
        if (params.config && params.config.responseSchema) {
            if (!params.config.responseJsonSchema) {
                if (Object.keys(params.config.responseSchema).includes('$schema')) {
                    params.config.responseJsonSchema = params.config.responseSchema;
                    delete params.config.responseSchema;
                }
            }
        }
        return;
    }
    /**
     * Transforms the CallableTools in the parameters to be simply Tools, it
     * copies the params into a new object and replaces the tools, it does not
     * modify the original params. Also sets the MCP usage header if there are
     * MCP tools in the parameters.
     */ async processParamsMaybeAddMcpUsage(params) {
        var _a, _b, _c;
        const tools = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools;
        if (!tools) return params;
        const transformedTools = await Promise.all(tools.map(async (tool)=>{
            if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
                const callableTool = tool;
                return await callableTool.tool();
            }
            return tool;
        }));
        const newParams = {
            model: params.model,
            contents: params.contents,
            config: Object.assign(Object.assign({}, params.config), {
                tools: transformedTools
            })
        };
        newParams.config.tools = transformedTools;
        if (params.config && params.config.tools && $e4deb49dba5321bc$var$hasMcpToolUsage(params.config.tools)) {
            const headers = (_c = (_b = params.config.httpOptions) === null || _b === void 0 ? void 0 : _b.headers) !== null && _c !== void 0 ? _c : {};
            let newHeaders = Object.assign({}, headers);
            if (Object.keys(newHeaders).length === 0) newHeaders = this.apiClient.getDefaultHeaders();
            $e4deb49dba5321bc$var$setMcpUsageHeader(newHeaders);
            newParams.config.httpOptions = Object.assign(Object.assign({}, params.config.httpOptions), {
                headers: newHeaders
            });
        }
        return newParams;
    }
    async initAfcToolsMap(params) {
        var _a, _b, _c;
        const afcTools = new Map();
        for (const tool of (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.tools) !== null && _b !== void 0 ? _b : [])if ($e4deb49dba5321bc$var$isCallableTool(tool)) {
            const callableTool = tool;
            const toolDeclaration = await callableTool.tool();
            for (const declaration of (_c = toolDeclaration.functionDeclarations) !== null && _c !== void 0 ? _c : []){
                if (!declaration.name) throw new Error('Function declaration name is required.');
                if (afcTools.has(declaration.name)) throw new Error(`Duplicate tool declaration name: ${declaration.name}`);
                afcTools.set(declaration.name, callableTool);
            }
        }
        return afcTools;
    }
    async processAfcStream(params) {
        var _a, _b, _c;
        const maxRemoteCalls = (_c = (_b = (_a = params.config) === null || _a === void 0 ? void 0 : _a.automaticFunctionCalling) === null || _b === void 0 ? void 0 : _b.maximumRemoteCalls) !== null && _c !== void 0 ? _c : $e4deb49dba5321bc$var$DEFAULT_MAX_REMOTE_CALLS;
        let wereFunctionsCalled = false;
        let remoteCallCount = 0;
        const afcToolsMap = await this.initAfcToolsMap(params);
        return function(models, afcTools, params) {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                var _a, e_1, _b, _c;
                var _d, _e;
                while(remoteCallCount < maxRemoteCalls){
                    if (wereFunctionsCalled) {
                        remoteCallCount++;
                        wereFunctionsCalled = false;
                    }
                    const transformedParams = yield $e4deb49dba5321bc$var$__await(models.processParamsMaybeAddMcpUsage(params));
                    const response = yield $e4deb49dba5321bc$var$__await(models.generateContentStreamInternal(transformedParams));
                    const functionResponses = [];
                    const responseContents = [];
                    try {
                        for(var _f = true, response_1 = (e_1 = void 0, $e4deb49dba5321bc$var$__asyncValues(response)), response_1_1; response_1_1 = yield $e4deb49dba5321bc$var$__await(response_1.next()), _a = response_1_1.done, !_a; _f = true){
                            _c = response_1_1.value;
                            _f = false;
                            const chunk = _c;
                            yield yield $e4deb49dba5321bc$var$__await(chunk);
                            if (chunk.candidates && ((_d = chunk.candidates[0]) === null || _d === void 0 ? void 0 : _d.content)) {
                                responseContents.push(chunk.candidates[0].content);
                                for (const part of (_e = chunk.candidates[0].content.parts) !== null && _e !== void 0 ? _e : [])if (remoteCallCount < maxRemoteCalls && part.functionCall) {
                                    if (!part.functionCall.name) throw new Error('Function call name was not returned by the model.');
                                    if (!afcTools.has(part.functionCall.name)) throw new Error(`Automatic function calling was requested, but not all the tools the model used implement the CallableTool interface. Available tools: ${afcTools.keys()}, mising tool: ${part.functionCall.name}`);
                                    else {
                                        const responseParts = yield $e4deb49dba5321bc$var$__await(afcTools.get(part.functionCall.name).callTool([
                                            part.functionCall
                                        ]));
                                        functionResponses.push(...responseParts);
                                    }
                                }
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_f && !_a && (_b = response_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(response_1));
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    if (functionResponses.length > 0) {
                        wereFunctionsCalled = true;
                        const typedResponseChunk = new $e4deb49dba5321bc$export$87445595052c5212();
                        typedResponseChunk.candidates = [
                            {
                                content: {
                                    role: 'user',
                                    parts: functionResponses
                                }
                            }
                        ];
                        yield yield $e4deb49dba5321bc$var$__await(typedResponseChunk);
                        const newContents = [];
                        newContents.push(...responseContents);
                        newContents.push({
                            role: 'user',
                            parts: functionResponses
                        });
                        const updatedContents = $e4deb49dba5321bc$var$tContents(params.contents).concat(newContents);
                        params.contents = updatedContents;
                    } else break;
                }
            });
        }(this, afcToolsMap, params);
    }
    async generateContentInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateContentResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:generateContent', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async generateContentStreamInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateContentParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
            return response.then(function(apiResponse) {
                return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                    var _a, e_2, _b, _c;
                    try {
                        for(var _d = true, apiResponse_1 = $e4deb49dba5321bc$var$__asyncValues(apiResponse), apiResponse_1_1; apiResponse_1_1 = yield $e4deb49dba5321bc$var$__await(apiResponse_1.next()), _a = apiResponse_1_1.done, !_a; _d = true){
                            _c = apiResponse_1_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = $e4deb49dba5321bc$var$generateContentResponseFromVertex((yield $e4deb49dba5321bc$var$__await(chunk.json())), params);
                            resp['sdkHttpResponse'] = {
                                headers: chunk.headers
                            };
                            const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                            Object.assign(typedResp, resp);
                            yield yield $e4deb49dba5321bc$var$__await(typedResp);
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(apiResponse_1));
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                });
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateContentParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:streamGenerateContent?alt=sse', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            const apiClient = this.apiClient;
            response = apiClient.requestStream({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            });
            return response.then(function(apiResponse) {
                return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function*() {
                    var _a, e_3, _b, _c;
                    try {
                        for(var _d = true, apiResponse_2 = $e4deb49dba5321bc$var$__asyncValues(apiResponse), apiResponse_2_1; apiResponse_2_1 = yield $e4deb49dba5321bc$var$__await(apiResponse_2.next()), _a = apiResponse_2_1.done, !_a; _d = true){
                            _c = apiResponse_2_1.value;
                            _d = false;
                            const chunk = _c;
                            const resp = $e4deb49dba5321bc$var$generateContentResponseFromMldev((yield $e4deb49dba5321bc$var$__await(chunk.json())), params);
                            resp['sdkHttpResponse'] = {
                                headers: chunk.headers
                            };
                            const typedResp = new $e4deb49dba5321bc$export$87445595052c5212();
                            Object.assign(typedResp, resp);
                            yield yield $e4deb49dba5321bc$var$__await(typedResp);
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = apiResponse_2.return)) yield $e4deb49dba5321bc$var$__await(_b.call(apiResponse_2));
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                });
            });
        }
    }
    /**
     * Calculates embeddings for the given contents. Only text is supported.
     *
     * @param params - The parameters for embedding contents.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.embedContent({
     *  model: 'text-embedding-004',
     *  contents: [
     *    'What is your name?',
     *    'What is your favorite color?',
     *  ],
     *  config: {
     *    outputDimensionality: 64,
     *  },
     * });
     * console.log(response);
     * ```
     */ async embedContentInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$embedContentParametersPrivateToVertex(this.apiClient, params, params);
            const endpointUrl = $e4deb49dba5321bc$var$tIsVertexEmbedContentModel(params.model) ? '{model}:embedContent' : '{model}:predict';
            path = $e4deb49dba5321bc$var$formatMap(endpointUrl, body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$embedContentResponseFromVertex(apiResponse, params);
                const typedResp = new $e4deb49dba5321bc$export$1e9eee8641627f00();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$embedContentParametersPrivateToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:batchEmbedContents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$embedContentResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$1e9eee8641627f00();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Private method for generating images.
     */ async generateImagesInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateImagesParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateImagesResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f08095e7138eb0f4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateImagesParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateImagesResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f08095e7138eb0f4();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Private method for editing an image.
     */ async editImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$editImageParametersInternalToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$editImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$661afcf00ed2fbe8();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Private method for upscaling an image.
     */ async upscaleImageInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$upscaleImageAPIParametersInternalToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$upscaleImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$690402256314214();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Recontextualizes an image.
     *
     * There are two types of recontextualization currently supported:
     * 1) Imagen Product Recontext - Generate images of products in new scenes
     *    and contexts.
     * 2) Virtual Try-On: Generate images of persons modeling fashion products.
     *
     * @param params - The parameters for recontextualizing an image.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response1 = await ai.models.recontextImage({
     *  model: 'imagen-product-recontext-preview-06-30',
     *  source: {
     *    prompt: 'In a modern kitchen setting.',
     *    productImages: [productImage],
     *  },
     *  config: {
     *    numberOfImages: 1,
     *  },
     * });
     * console.log(response1?.generatedImages?.[0]?.image?.imageBytes);
     *
     * const response2 = await ai.models.recontextImage({
     *  model: 'virtual-try-on-001',
     *  source: {
     *    personImage: personImage,
     *    productImages: [productImage],
     *  },
     *  config: {
     *    numberOfImages: 1,
     *  },
     * });
     * console.log(response2?.generatedImages?.[0]?.image?.imageBytes);
     * ```
     */ async recontextImage(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$recontextImageParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$recontextImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$c2ead2074351d0f2();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Segments an image, creating a mask of a specified area.
     *
     * @param params - The parameters for segmenting an image.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.segmentImage({
     *  model: 'image-segmentation-001',
     *  source: {
     *    image: image,
     *  },
     *  config: {
     *    mode: 'foreground',
     *  },
     * });
     * console.log(response?.generatedMasks?.[0]?.mask?.imageBytes);
     * ```
     */ async segmentImage(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$segmentImageParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predict', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$segmentImageResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$304f360366a6eb53();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Fetches information about a model by name.
     *
     * @example
     * ```ts
     * const modelInfo = await ai.models.get({model: 'gemini-2.0-flash'});
     * ```
     */ async get(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromMldev(apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listModelsParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listModelsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f159131a50016456();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listModelsParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{models_url}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listModelsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$f159131a50016456();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Updates a tuned model by its name.
     *
     * @param params - The parameters for updating the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.update({
     *   model: 'tuned-model-name',
     *   config: {
     *     displayName: 'New display name',
     *     description: 'New description',
     *   },
     * });
     * ```
     */ async update(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$updateModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$updateModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'PATCH',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$modelFromMldev(apiResponse);
                return resp;
            });
        }
    }
    /**
     * Deletes a tuned model by its name.
     *
     * @param params - The parameters for deleting the model.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.delete({model: 'tuned-model-name'});
     * ```
     */ async delete(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$deleteModelParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteModelResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179335935ae1d762();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$deleteModelParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$deleteModelResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179335935ae1d762();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Counts the number of tokens in the given contents. Multimodal input is
     * supported for Gemini models.
     *
     * @param params - The parameters for counting tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.countTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'The quick brown fox jumps over the lazy dog.'
     * });
     * console.log(response);
     * ```
     */ async countTokens(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$countTokensParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$countTokensResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b2422e769fe9acde();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$countTokensParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:countTokens', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$countTokensResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$b2422e769fe9acde();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Given a list of contents, returns a corresponding TokensInfo containing
     * the list of tokens and list of token ids.
     *
     * This method is not supported by the Gemini Developer API.
     *
     * @param params - The parameters for computing tokens.
     * @return The response from the API.
     *
     * @example
     * ```ts
     * const response = await ai.models.computeTokens({
     *  model: 'gemini-2.0-flash',
     *  contents: 'What is your name?'
     * });
     * console.log(response);
     * ```
     */ async computeTokens(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$computeTokensParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:computeTokens', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$computeTokensResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$8fb35c7d28173be();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    /**
     * Private method for generating videos.
     */ async generateVideosInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$generateVideosParametersToVertex(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateVideosOperationFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$generateVideosParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('{model}:predictLongRunning', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$generateVideosOperationFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$d39812a6cdac2c57();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$export$3d72bd1ae0aee044 extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Gets the status of a long-running operation.
     *
     * @param parameters The parameters for the get operation request.
     * @return The updated Operation object, with the latest status or result.
     */ async getVideosOperation(parameters) {
        const operation = parameters.operation;
        const config = parameters.config;
        if (operation.name === undefined || operation.name === '') throw new Error('Operation name is required.');
        if (this.apiClient.isVertexAI()) {
            const resourceName = operation.name.split('/operations/')[0];
            let httpOptions = undefined;
            if (config && 'httpOptions' in config) httpOptions = config.httpOptions;
            const rawOperation = await this.fetchPredictVideosOperationInternal({
                operationName: operation.name,
                resourceName: resourceName,
                config: {
                    httpOptions: httpOptions
                }
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: true
            });
        } else {
            const rawOperation = await this.getVideosOperationInternal({
                operationName: operation.name,
                config: config
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: false
            });
        }
    }
    /**
     * Gets the status of a long-running operation.
     *
     * @param parameters The parameters for the get operation request.
     * @return The updated Operation object, with the latest status or result.
     */ async get(parameters) {
        const operation = parameters.operation;
        const config = parameters.config;
        if (operation.name === undefined || operation.name === '') throw new Error('Operation name is required.');
        if (this.apiClient.isVertexAI()) {
            const resourceName = operation.name.split('/operations/')[0];
            let httpOptions = undefined;
            if (config && 'httpOptions' in config) httpOptions = config.httpOptions;
            const rawOperation = await this.fetchPredictVideosOperationInternal({
                operationName: operation.name,
                resourceName: resourceName,
                config: {
                    httpOptions: httpOptions
                }
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: true
            });
        } else {
            const rawOperation = await this.getVideosOperationInternal({
                operationName: operation.name,
                config: config
            });
            return operation._fromAPIResponse({
                apiResponse: rawOperation,
                _isVertexAI: false
            });
        }
    }
    async getVideosOperationInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getOperationParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        } else {
            const body = $e4deb49dba5321bc$var$getOperationParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{operationName}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        }
    }
    async fetchPredictVideosOperationInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$fetchPredictOperationParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{resourceName}:fetchPredictOperation', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response;
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'languageCodes'
    ]) !== undefined) throw new Error('languageCodes parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$authConfigToMldev(fromObject) {
    const toObject = {};
    const fromApiKey = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKey'
    ]);
    if (fromApiKey != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'apiKey'
    ], fromApiKey);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'apiKeyConfig'
    ]) !== undefined) throw new Error('apiKeyConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authType'
    ]) !== undefined) throw new Error('authType parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleServiceAccountConfig'
    ]) !== undefined) throw new Error('googleServiceAccountConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'httpBasicAuthConfig'
    ]) !== undefined) throw new Error('httpBasicAuthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oauthConfig'
    ]) !== undefined) throw new Error('oauthConfig parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'oidcConfig'
    ]) !== undefined) throw new Error('oidcConfig parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$blobToMldev(fromObject) {
    const toObject = {};
    const fromData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'data'
    ]);
    if (fromData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'data'
    ], fromData);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$contentToMldev(fromObject) {
    const toObject = {};
    const fromParts = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parts'
    ]);
    if (fromParts != null) {
        let transformedList = fromParts;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$partToMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'parts'
        ], transformedList);
    }
    const fromRole = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'role'
    ]);
    if (fromRole != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'role'
    ], fromRole);
    return toObject;
}
function $e4deb49dba5321bc$var$createAuthTokenConfigToMldev(apiClient, fromObject, parentObject) {
    const toObject = {};
    const fromExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'expireTime'
    ]);
    if (parentObject !== undefined && fromExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'expireTime'
    ], fromExpireTime);
    const fromNewSessionExpireTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'newSessionExpireTime'
    ]);
    if (parentObject !== undefined && fromNewSessionExpireTime != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'newSessionExpireTime'
    ], fromNewSessionExpireTime);
    const fromUses = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'uses'
    ]);
    if (parentObject !== undefined && fromUses != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'uses'
    ], fromUses);
    const fromLiveConnectConstraints = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'liveConnectConstraints'
    ]);
    if (parentObject !== undefined && fromLiveConnectConstraints != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'bidiGenerateContentSetup'
    ], $e4deb49dba5321bc$var$liveConnectConstraintsToMldev(apiClient, fromLiveConnectConstraints));
    const fromLockAdditionalFields = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'lockAdditionalFields'
    ]);
    if (parentObject !== undefined && fromLockAdditionalFields != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'fieldMask'
    ], fromLockAdditionalFields);
    return toObject;
}
function $e4deb49dba5321bc$var$createAuthTokenParametersToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$createAuthTokenConfigToMldev(apiClient, fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$fileDataToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'displayName'
    ]) !== undefined) throw new Error('displayName parameter is not supported in Gemini API.');
    const fromFileUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileUri'
    ]);
    if (fromFileUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileUri'
    ], fromFileUri);
    const fromMimeType = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mimeType'
    ]);
    if (fromMimeType != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mimeType'
    ], fromMimeType);
    return toObject;
}
function $e4deb49dba5321bc$var$functionCallToMldev(fromObject) {
    const toObject = {};
    const fromId = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'id'
    ]);
    if (fromId != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'id'
    ], fromId);
    const fromArgs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'args'
    ]);
    if (fromArgs != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'args'
    ], fromArgs);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partialArgs'
    ]) !== undefined) throw new Error('partialArgs parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'willContinue'
    ]) !== undefined) throw new Error('willContinue parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$googleMapsToMldev(fromObject) {
    const toObject = {};
    const fromAuthConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'authConfig'
    ]);
    if (fromAuthConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'authConfig'
    ], $e4deb49dba5321bc$var$authConfigToMldev(fromAuthConfig));
    const fromEnableWidget = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableWidget'
    ]);
    if (fromEnableWidget != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'enableWidget'
    ], fromEnableWidget);
    return toObject;
}
function $e4deb49dba5321bc$var$googleSearchToMldev(fromObject) {
    const toObject = {};
    const fromSearchTypes = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'searchTypes'
    ]);
    if (fromSearchTypes != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'searchTypes'
    ], fromSearchTypes);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'blockingConfidence'
    ]) !== undefined) throw new Error('blockingConfidence parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'excludeDomains'
    ]) !== undefined) throw new Error('excludeDomains parameter is not supported in Gemini API.');
    const fromTimeRangeFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'timeRangeFilter'
    ]);
    if (fromTimeRangeFilter != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'timeRangeFilter'
    ], fromTimeRangeFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromGenerationConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'generationConfig'
    ]);
    if (parentObject !== undefined && fromGenerationConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig'
    ], fromGenerationConfig);
    const fromResponseModalities = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'responseModalities'
    ]);
    if (parentObject !== undefined && fromResponseModalities != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'responseModalities'
    ], fromResponseModalities);
    const fromTemperature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'temperature'
    ]);
    if (parentObject !== undefined && fromTemperature != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'temperature'
    ], fromTemperature);
    const fromTopP = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topP'
    ]);
    if (parentObject !== undefined && fromTopP != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topP'
    ], fromTopP);
    const fromTopK = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'topK'
    ]);
    if (parentObject !== undefined && fromTopK != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'topK'
    ], fromTopK);
    const fromMaxOutputTokens = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'maxOutputTokens'
    ]);
    if (parentObject !== undefined && fromMaxOutputTokens != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'maxOutputTokens'
    ], fromMaxOutputTokens);
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (parentObject !== undefined && fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'mediaResolution'
    ], fromMediaResolution);
    const fromSeed = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'seed'
    ]);
    if (parentObject !== undefined && fromSeed != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'seed'
    ], fromSeed);
    const fromSpeechConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'speechConfig'
    ]);
    if (parentObject !== undefined && fromSpeechConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'speechConfig'
    ], $e4deb49dba5321bc$var$tLiveSpeechConfig(fromSpeechConfig));
    const fromThinkingConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thinkingConfig'
    ]);
    if (parentObject !== undefined && fromThinkingConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'thinkingConfig'
    ], fromThinkingConfig);
    const fromEnableAffectiveDialog = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enableAffectiveDialog'
    ]);
    if (parentObject !== undefined && fromEnableAffectiveDialog != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'generationConfig',
        'enableAffectiveDialog'
    ], fromEnableAffectiveDialog);
    const fromSystemInstruction = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'systemInstruction'
    ]);
    if (parentObject !== undefined && fromSystemInstruction != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'systemInstruction'
    ], $e4deb49dba5321bc$var$contentToMldev($e4deb49dba5321bc$var$tContent(fromSystemInstruction)));
    const fromTools = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tools'
    ]);
    if (parentObject !== undefined && fromTools != null) {
        let transformedList = $e4deb49dba5321bc$var$tTools(fromTools);
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$toolToMldev($e4deb49dba5321bc$var$tTool(item));
        });
        $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'setup',
            'tools'
        ], transformedList);
    }
    const fromSessionResumption = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sessionResumption'
    ]);
    if (parentObject !== undefined && fromSessionResumption != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'sessionResumption'
    ], $e4deb49dba5321bc$var$sessionResumptionConfigToMldev(fromSessionResumption));
    const fromInputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromInputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'inputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev(fromInputAudioTranscription));
    const fromOutputAudioTranscription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputAudioTranscription'
    ]);
    if (parentObject !== undefined && fromOutputAudioTranscription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'outputAudioTranscription'
    ], $e4deb49dba5321bc$var$audioTranscriptionConfigToMldev(fromOutputAudioTranscription));
    const fromRealtimeInputConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'realtimeInputConfig'
    ]);
    if (parentObject !== undefined && fromRealtimeInputConfig != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'realtimeInputConfig'
    ], fromRealtimeInputConfig);
    const fromContextWindowCompression = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'contextWindowCompression'
    ]);
    if (parentObject !== undefined && fromContextWindowCompression != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'contextWindowCompression'
    ], fromContextWindowCompression);
    const fromProactivity = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'proactivity'
    ]);
    if (parentObject !== undefined && fromProactivity != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'setup',
        'proactivity'
    ], fromProactivity);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'explicitVadSignal'
    ]) !== undefined) throw new Error('explicitVadSignal parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$liveConnectConstraintsToMldev(apiClient, fromObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'model'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'setup',
        'model'
    ], $e4deb49dba5321bc$var$tModel(apiClient, fromModel));
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'config'
    ], $e4deb49dba5321bc$var$liveConnectConfigToMldev(fromConfig, toObject));
    return toObject;
}
function $e4deb49dba5321bc$var$partToMldev(fromObject) {
    const toObject = {};
    const fromMediaResolution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mediaResolution'
    ]);
    if (fromMediaResolution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'mediaResolution'
    ], fromMediaResolution);
    const fromCodeExecutionResult = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecutionResult'
    ]);
    if (fromCodeExecutionResult != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecutionResult'
    ], fromCodeExecutionResult);
    const fromExecutableCode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'executableCode'
    ]);
    if (fromExecutableCode != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'executableCode'
    ], fromExecutableCode);
    const fromFileData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileData'
    ]);
    if (fromFileData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileData'
    ], $e4deb49dba5321bc$var$fileDataToMldev(fromFileData));
    const fromFunctionCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionCall'
    ]);
    if (fromFunctionCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionCall'
    ], $e4deb49dba5321bc$var$functionCallToMldev(fromFunctionCall));
    const fromFunctionResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionResponse'
    ]);
    if (fromFunctionResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'functionResponse'
    ], fromFunctionResponse);
    const fromInlineData = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'inlineData'
    ]);
    if (fromInlineData != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'inlineData'
    ], $e4deb49dba5321bc$var$blobToMldev(fromInlineData));
    const fromText = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'text'
    ]);
    if (fromText != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'text'
    ], fromText);
    const fromThought = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thought'
    ]);
    if (fromThought != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thought'
    ], fromThought);
    const fromThoughtSignature = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'thoughtSignature'
    ]);
    if (fromThoughtSignature != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'thoughtSignature'
    ], fromThoughtSignature);
    const fromVideoMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'videoMetadata'
    ]);
    if (fromVideoMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'videoMetadata'
    ], fromVideoMetadata);
    const fromToolCall = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolCall'
    ]);
    if (fromToolCall != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolCall'
    ], fromToolCall);
    const fromToolResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'toolResponse'
    ]);
    if (fromToolResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'toolResponse'
    ], fromToolResponse);
    const fromPartMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partMetadata'
    ]);
    if (fromPartMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partMetadata'
    ], fromPartMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$sessionResumptionConfigToMldev(fromObject) {
    const toObject = {};
    const fromHandle = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'handle'
    ]);
    if (fromHandle != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'handle'
    ], fromHandle);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'transparent'
    ]) !== undefined) throw new Error('transparent parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$toolToMldev(fromObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'retrieval'
    ]) !== undefined) throw new Error('retrieval parameter is not supported in Gemini API.');
    const fromComputerUse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'computerUse'
    ]);
    if (fromComputerUse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'computerUse'
    ], fromComputerUse);
    const fromFileSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fileSearch'
    ]);
    if (fromFileSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fileSearch'
    ], fromFileSearch);
    const fromGoogleSearch = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearch'
    ]);
    if (fromGoogleSearch != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearch'
    ], $e4deb49dba5321bc$var$googleSearchToMldev(fromGoogleSearch));
    const fromGoogleMaps = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleMaps'
    ]);
    if (fromGoogleMaps != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleMaps'
    ], $e4deb49dba5321bc$var$googleMapsToMldev(fromGoogleMaps));
    const fromCodeExecution = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'codeExecution'
    ]);
    if (fromCodeExecution != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'codeExecution'
    ], fromCodeExecution);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'enterpriseWebSearch'
    ]) !== undefined) throw new Error('enterpriseWebSearch parameter is not supported in Gemini API.');
    const fromFunctionDeclarations = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'functionDeclarations'
    ]);
    if (fromFunctionDeclarations != null) {
        let transformedList = fromFunctionDeclarations;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'functionDeclarations'
        ], transformedList);
    }
    const fromGoogleSearchRetrieval = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'googleSearchRetrieval'
    ]);
    if (fromGoogleSearchRetrieval != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'googleSearchRetrieval'
    ], fromGoogleSearchRetrieval);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parallelAiSearch'
    ]) !== undefined) throw new Error('parallelAiSearch parameter is not supported in Gemini API.');
    const fromUrlContext = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'urlContext'
    ]);
    if (fromUrlContext != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'urlContext'
    ], fromUrlContext);
    const fromMcpServers = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'mcpServers'
    ]);
    if (fromMcpServers != null) {
        let transformedList = fromMcpServers;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'mcpServers'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Returns a comma-separated list of field masks from a given object.
 *
 * @param setup The object to extract field masks from.
 * @return A comma-separated list of field masks.
 */ function $e4deb49dba5321bc$var$getFieldMasks(setup) {
    const fields = [];
    for(const key in setup)if (Object.prototype.hasOwnProperty.call(setup, key)) {
        const value = setup[key];
        // 2nd layer, recursively get field masks see TODO(b/418290100)
        if (typeof value === 'object' && value != null && Object.keys(value).length > 0) {
            const field = Object.keys(value).map((kk)=>`${key}.${kk}`);
            fields.push(...field);
        } else fields.push(key); // 1st layer
    }
    return fields.join(',');
}
/**
 * Converts bidiGenerateContentSetup.
 * @param requestDict - The request dictionary.
 * @param config - The configuration object.
 * @return - The modified request dictionary.
 */ function $e4deb49dba5321bc$var$convertBidiSetupToTokenSetup(requestDict, config) {
    // Convert bidiGenerateContentSetup from bidiGenerateContentSetup.setup.
    let setupForMaskGeneration = null;
    const bidiGenerateContentSetupValue = requestDict['bidiGenerateContentSetup'];
    if (typeof bidiGenerateContentSetupValue === 'object' && bidiGenerateContentSetupValue !== null && 'setup' in bidiGenerateContentSetupValue) {
        // Now we know bidiGenerateContentSetupValue is an object and has a 'setup'
        // property.
        const innerSetup = bidiGenerateContentSetupValue.setup;
        if (typeof innerSetup === 'object' && innerSetup !== null) {
            // Valid inner setup found.
            requestDict['bidiGenerateContentSetup'] = innerSetup;
            setupForMaskGeneration = innerSetup;
        } else // `bidiGenerateContentSetupValue.setup` is not a valid object; treat as
        // if bidiGenerateContentSetup is invalid.
        delete requestDict['bidiGenerateContentSetup'];
    } else if (bidiGenerateContentSetupValue !== undefined) // `bidiGenerateContentSetup` exists but not in the expected
    // shape {setup: {...}}; treat as invalid.
    delete requestDict['bidiGenerateContentSetup'];
    const preExistingFieldMask = requestDict['fieldMask'];
    // Handle mask generation setup.
    if (setupForMaskGeneration) {
        const generatedMaskFromBidi = $e4deb49dba5321bc$var$getFieldMasks(setupForMaskGeneration);
        if (Array.isArray(config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && (config === null || config === void 0 ? void 0 : config.lockAdditionalFields.length) === 0) {
            // Case 1: lockAdditionalFields is an empty array. Lock only fields from
            // bidi setup.
            if (generatedMaskFromBidi) // Only assign if mask is not empty
            requestDict['fieldMask'] = generatedMaskFromBidi;
            else delete requestDict['fieldMask']; // If mask is empty, effectively no
        } else if ((config === null || config === void 0 ? void 0 : config.lockAdditionalFields) && config.lockAdditionalFields.length > 0 && preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) {
            // Case 2: Lock fields from bidi setup + additional fields
            // (preExistingFieldMask).
            const generationConfigFields = [
                'temperature',
                'topK',
                'topP',
                'maxOutputTokens',
                'responseModalities',
                'seed',
                'speechConfig'
            ];
            let mappedFieldsFromPreExisting = [];
            if (preExistingFieldMask.length > 0) mappedFieldsFromPreExisting = preExistingFieldMask.map((field)=>{
                if (generationConfigFields.includes(field)) return `generationConfig.${field}`;
                return field; // Keep original field name if not in
            // generationConfigFields
            });
            const finalMaskParts = [];
            if (generatedMaskFromBidi) finalMaskParts.push(generatedMaskFromBidi);
            if (mappedFieldsFromPreExisting.length > 0) finalMaskParts.push(...mappedFieldsFromPreExisting);
            if (finalMaskParts.length > 0) requestDict['fieldMask'] = finalMaskParts.join(',');
            else // If no fields from bidi and no valid additional fields from
            // pre-existing mask.
            delete requestDict['fieldMask'];
        } else // Case 3: "Lock all fields" (meaning, don't send a field_mask, let server
        // defaults apply or all are mutable). This is hit if:
        //  - `config.lockAdditionalFields` is undefined.
        //  - `config.lockAdditionalFields` is non-empty, BUT
        //  `preExistingFieldMask` is null, not a string, or an empty string.
        delete requestDict['fieldMask'];
    } else // No valid `bidiGenerateContentSetup` was found or extracted.
    // "Lock additional null fields if any".
    if (preExistingFieldMask !== null && Array.isArray(preExistingFieldMask) && preExistingFieldMask.length > 0) // If there's a pre-existing field mask, it's a string, and it's not
    // empty, then we should lock all fields.
    requestDict['fieldMask'] = preExistingFieldMask.join(',');
    else delete requestDict['fieldMask'];
    return requestDict;
}
class $e4deb49dba5321bc$export$8e1e81ac145e31be extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
    }
    /**
     * Creates an ephemeral auth token resource.
     *
     * @experimental
     *
     * @remarks
     * Ephemeral auth tokens is only supported in the Gemini Developer API.
     * It can be used for the session connection to the Live constrained API.
     * Support in v1alpha only.
     *
     * @param params - The parameters for the create request.
     * @return The created auth token.
     *
     * @example
     * ```ts
     * const ai = new GoogleGenAI({
     *     apiKey: token.name,
     *     httpOptions: { apiVersion: 'v1alpha' }  // Support in v1alpha only.
     * });
     *
     * // Case 1: If LiveEphemeralParameters is unset, unlock LiveConnectConfig
     * // when using the token in Live API sessions. Each session connection can
     * // use a different configuration.
     * const config: CreateAuthTokenConfig = {
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 2: If LiveEphemeralParameters is set, lock all fields in
     * // LiveConnectConfig when using the token in Live API sessions. For
     * // example, changing `outputAudioTranscription` in the Live API
     * // connection will be ignored by the API.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     }
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 3: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // set, lock LiveConnectConfig with set and additional fields (e.g.
     * // responseModalities, systemInstruction, temperature in this example) when
     * // using the token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: ['temperature'],
     * }
     * const token = await ai.tokens.create(config);
     *
     * // Case 4: If LiveEphemeralParameters is set and lockAdditionalFields is
     * // empty array, lock LiveConnectConfig with set fields (e.g.
     * // responseModalities, systemInstruction in this example) when using the
     * // token in Live API sessions.
     * const config: CreateAuthTokenConfig =
     *     uses: 3,
     *     expireTime: '2025-05-01T00:00:00Z',
     *     LiveEphemeralParameters: {
     *        model: 'gemini-2.0-flash-001',
     *        config: {
     *           'responseModalities': ['AUDIO'],
     *           'systemInstruction': 'Always answer in English.',
     *        }
     *     },
     *     lockAdditionalFields: [],
     * }
     * const token = await ai.tokens.create(config);
     * ```
     */ async create(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('The client.tokens.create method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createAuthTokenParametersToMldev(this.apiClient, params);
            path = $e4deb49dba5321bc$var$formatMap('auth_tokens', body['_url']);
            queryParams = body['_query'];
            delete body['config'];
            delete body['_url'];
            delete body['_query'];
            const transformedBody = $e4deb49dba5321bc$var$convertBidiSetupToTokenSetup(body, params.config);
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(transformedBody),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$deleteDocumentConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromForce = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'force'
    ]);
    if (parentObject !== undefined && fromForce != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'force'
    ], fromForce);
    return toObject;
}
function $e4deb49dba5321bc$var$deleteDocumentParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$deleteDocumentConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$getDocumentParametersToMldev(fromObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$listDocumentsConfigToMldev(fromObject, parentObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    return toObject;
}
function $e4deb49dba5321bc$var$listDocumentsParametersToMldev(fromObject) {
    const toObject = {};
    const fromParent = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'parent'
    ]);
    if (fromParent != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'parent'
    ], fromParent);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listDocumentsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listDocumentsResponseFromMldev(fromObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromDocuments = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'documents'
    ]);
    if (fromDocuments != null) {
        let transformedList = fromDocuments;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'documents'
        ], transformedList);
    }
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$Documents extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists documents.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of documents.
         *
         * @example
         * ```ts
         * const documents = await ai.documents.list({parent:'rag_store_name', config: {'pageSize': 2}});
         * for await (const document of documents) {
         *   console.log(document);
         * }
         * ```
         */ this.list = async (params)=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_DOCUMENTS, (x)=>this.listInternal({
                    parent: params.parent,
                    config: x.config
                }), await this.listInternal(params), params);
        };
    }
    /**
     * Gets a Document.
     *
     * @param params - The parameters for getting a document.
     * @return Document.
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$getDocumentParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes a Document.
     *
     * @param params - The parameters for deleting a document.
     */ async delete(params) {
        var _a, _b;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$deleteDocumentParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        }
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$listDocumentsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{parent}/documents', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listDocumentsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$5cc5885838c19de3();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$FileSearchStores extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient, documents = new $e4deb49dba5321bc$var$Documents(apiClient)){
        super();
        this.apiClient = apiClient;
        this.documents = documents;
        /**
         * Lists file search stores.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of file search stores.
         *
         * @example
         * ```ts
         * const fileSearchStores = await ai.fileSearchStores.list({config: {'pageSize': 2}});
         * for await (const fileSearchStore of fileSearchStores) {
         *   console.log(fileSearchStore);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_FILE_SEARCH_STORES, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
    }
    /**
     * Uploads a file asynchronously to a given File Search Store.
     * This method is not available in Vertex AI.
     * Supported upload sources:
     * - Node.js: File path (string) or Blob object.
     * - Browser: Blob object (e.g., File).
     *
     * @remarks
     * The `mimeType` can be specified in the `config` parameter. If omitted:
     *  - For file path (string) inputs, the `mimeType` will be inferred from the
     *     file extension.
     *  - For Blob object inputs, the `mimeType` will be set to the Blob's `type`
     *     property.
     *
     * This section can contain multiple paragraphs and code examples.
     *
     * @param params - Optional parameters specified in the
     *        `types.UploadToFileSearchStoreParameters` interface.
     *         @see {@link types.UploadToFileSearchStoreParameters#config} for the optional
     *         config in the parameters.
     * @return A promise that resolves to a long running operation.
     * @throws An error if called on a Vertex AI client.
     * @throws An error if the `mimeType` is not provided and can not be inferred,
     * the `mimeType` can be provided in the `params.config` parameter.
     * @throws An error occurs if a suitable upload location cannot be established.
     *
     * @example
     * The following code uploads a file to a given file search store.
     *
     * ```ts
     * const operation = await ai.fileSearchStores.upload({fileSearchStoreName: 'fileSearchStores/foo-bar', file: 'file.txt', config: {
     *   mimeType: 'text/plain',
     * }});
     * console.log(operation.name);
     * ```
     */ async uploadToFileSearchStore(params) {
        if (this.apiClient.isVertexAI()) throw new Error('Vertex AI does not support uploading files to a file search store.');
        return this.apiClient.uploadFileToFileSearchStore(params.fileSearchStoreName, params.file, params.config);
    }
    /**
     * Creates a File Search Store.
     *
     * @param params - The parameters for creating a File Search Store.
     * @return FileSearchStore.
     */ async create(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('fileSearchStores', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Gets a File Search Store.
     *
     * @param params - The parameters for getting a File Search Store.
     * @return FileSearchStore.
     */ async get(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$getFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((resp)=>{
                return resp;
            });
        }
    }
    /**
     * Deletes a File Search Store.
     *
     * @param params - The parameters for deleting a File Search Store.
     */ async delete(params) {
        var _a, _b;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$deleteFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            await this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'DELETE',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            });
        }
    }
    async listInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$listFileSearchStoresParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('fileSearchStores', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listFileSearchStoresResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$e4346969d6f84113();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async uploadToFileSearchStoreInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$uploadToFileSearchStoreParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('upload/v1beta/{file_search_store_name}:uploadToFileSearchStore', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$uploadToFileSearchStoreResumableResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$179988cb790ed88a();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Imports a File from File Service to a FileSearchStore.
     *
     * This is a long-running operation, see aip.dev/151
     *
     * @param params - The parameters for importing a file to a file search store.
     * @return ImportFileOperation.
     */ async importFile(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$importFileParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{file_search_store_name}:importFile', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json();
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$importFileOperationFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$12076be78e50463e();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
/**
 * https://stackoverflow.com/a/2117523
 */ let $e4deb49dba5321bc$var$uuid4Internal = function() {
    const { crypto: crypto } = globalThis;
    if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) {
        $e4deb49dba5321bc$var$uuid4Internal = crypto.randomUUID.bind(crypto);
        return crypto.randomUUID();
    }
    const u8 = new Uint8Array(1);
    const randomByte = crypto ? ()=>crypto.getRandomValues(u8)[0] : ()=>Math.random() * 0xff & 0xff;
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c)=>(+c ^ randomByte() & 15 >> +c / 4).toString(16));
};
const $e4deb49dba5321bc$var$uuid4 = ()=>$e4deb49dba5321bc$var$uuid4Internal();
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
function $e4deb49dba5321bc$var$isAbortError(err) {
    return typeof err === 'object' && err !== null && // Spec-compliant fetch implementations
    ('name' in err && err.name === 'AbortError' || // Expo fetch
    'message' in err && String(err.message).includes('FetchRequestCanceledException'));
}
const $e4deb49dba5321bc$var$castToError = (err)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'object' && err !== null) {
        try {
            if (Object.prototype.toString.call(err) === '[object Error]') {
                // @ts-ignore - not all envs have native support for cause yet
                const error = new Error(err.message, err.cause ? {
                    cause: err.cause
                } : {});
                if (err.stack) error.stack = err.stack;
                // @ts-ignore - not all envs have native support for cause yet
                if (err.cause && !error.cause) error.cause = err.cause;
                if (err.name) error.name = err.name;
                return error;
            }
        } catch (_a) {}
        try {
            return new Error(JSON.stringify(err));
        } catch (_b) {}
    }
    return new Error(err);
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
class $e4deb49dba5321bc$var$GeminiNextGenAPIClientError extends Error {
}
class $e4deb49dba5321bc$var$APIError extends $e4deb49dba5321bc$var$GeminiNextGenAPIClientError {
    constructor(status, error, message, headers){
        super(`${$e4deb49dba5321bc$var$APIError.makeMessage(status, error, message)}`);
        this.status = status;
        this.headers = headers;
        this.error = error;
    }
    static makeMessage(status, error, message) {
        const msg = (error === null || error === void 0 ? void 0 : error.message) ? typeof error.message === 'string' ? error.message : JSON.stringify(error.message) : error ? JSON.stringify(error) : message;
        if (status && msg) return `${status} ${msg}`;
        if (status) return `${status} status code (no body)`;
        if (msg) return msg;
        return '(no status code or body)';
    }
    static generate(status, errorResponse, message, headers) {
        if (!status || !headers) return new $e4deb49dba5321bc$var$APIConnectionError({
            message: message,
            cause: $e4deb49dba5321bc$var$castToError(errorResponse)
        });
        const error = errorResponse;
        if (status === 400) return new $e4deb49dba5321bc$var$BadRequestError(status, error, message, headers);
        if (status === 401) return new $e4deb49dba5321bc$var$AuthenticationError(status, error, message, headers);
        if (status === 403) return new $e4deb49dba5321bc$var$PermissionDeniedError(status, error, message, headers);
        if (status === 404) return new $e4deb49dba5321bc$var$NotFoundError(status, error, message, headers);
        if (status === 409) return new $e4deb49dba5321bc$var$ConflictError(status, error, message, headers);
        if (status === 422) return new $e4deb49dba5321bc$var$UnprocessableEntityError(status, error, message, headers);
        if (status === 429) return new $e4deb49dba5321bc$var$RateLimitError(status, error, message, headers);
        if (status >= 500) return new $e4deb49dba5321bc$var$InternalServerError(status, error, message, headers);
        return new $e4deb49dba5321bc$var$APIError(status, error, message, headers);
    }
}
class $e4deb49dba5321bc$var$APIUserAbortError extends $e4deb49dba5321bc$var$APIError {
    constructor({ message: message } = {}){
        super(undefined, undefined, message || 'Request was aborted.', undefined);
    }
}
class $e4deb49dba5321bc$var$APIConnectionError extends $e4deb49dba5321bc$var$APIError {
    constructor({ message: message, cause: cause }){
        super(undefined, undefined, message || 'Connection error.', undefined);
        // in some environments the 'cause' property is already declared
        // @ts-ignore
        if (cause) this.cause = cause;
    }
}
class $e4deb49dba5321bc$var$APIConnectionTimeoutError extends $e4deb49dba5321bc$var$APIConnectionError {
    constructor({ message: message } = {}){
        super({
            message: message !== null && message !== void 0 ? message : 'Request timed out.'
        });
    }
}
class $e4deb49dba5321bc$var$BadRequestError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$AuthenticationError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$PermissionDeniedError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$NotFoundError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$ConflictError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$UnprocessableEntityError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$RateLimitError extends $e4deb49dba5321bc$var$APIError {
}
class $e4deb49dba5321bc$var$InternalServerError extends $e4deb49dba5321bc$var$APIError {
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
// https://url.spec.whatwg.org/#url-scheme-string
const $e4deb49dba5321bc$var$startsWithSchemeRegexp = /^[a-z][a-z0-9+.-]*:/i;
const $e4deb49dba5321bc$var$isAbsoluteURL = (url)=>{
    return $e4deb49dba5321bc$var$startsWithSchemeRegexp.test(url);
};
let $e4deb49dba5321bc$var$isArrayInternal = (val)=>($e4deb49dba5321bc$var$isArrayInternal = Array.isArray, $e4deb49dba5321bc$var$isArrayInternal(val));
const $e4deb49dba5321bc$var$isArray = $e4deb49dba5321bc$var$isArrayInternal;
let $e4deb49dba5321bc$var$isReadonlyArrayInternal = $e4deb49dba5321bc$var$isArray;
const $e4deb49dba5321bc$var$isReadonlyArray = $e4deb49dba5321bc$var$isReadonlyArrayInternal;
// https://stackoverflow.com/a/34491287
function $e4deb49dba5321bc$var$isEmptyObj(obj) {
    if (!obj) return true;
    for(const _k in obj)return false;
    return true;
}
// https://eslint.org/docs/latest/rules/no-prototype-builtins
function $e4deb49dba5321bc$var$hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
const $e4deb49dba5321bc$var$validatePositiveInteger = (name, n)=>{
    if (typeof n !== 'number' || !Number.isInteger(n)) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`${name} must be an integer`);
    if (n < 0) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`${name} must be a positive integer`);
    return n;
};
const $e4deb49dba5321bc$var$safeJSON = (text)=>{
    try {
        return JSON.parse(text);
    } catch (err) {
        return undefined;
    }
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
const $e4deb49dba5321bc$var$sleep$1 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$getDefaultFetch() {
    if (typeof fetch !== 'undefined') return fetch;
    throw new Error('`fetch` is not defined as a global; Either pass `fetch` to the client, `new GeminiNextGenAPIClient({ fetch })` or polyfill the global, `globalThis.fetch = fetch`');
}
function $e4deb49dba5321bc$var$makeReadableStream(...args) {
    const ReadableStream = globalThis.ReadableStream;
    if (typeof ReadableStream === 'undefined') // Note: All of the platforms / runtimes we officially support already define
    // `ReadableStream` as a global, so this should only ever be hit on unsupported runtimes.
    throw new Error('`ReadableStream` is not defined as a global; You will need to polyfill it, `globalThis.ReadableStream = ReadableStream`');
    return new ReadableStream(...args);
}
function $e4deb49dba5321bc$var$ReadableStreamFrom(iterable) {
    let iter = Symbol.asyncIterator in iterable ? iterable[Symbol.asyncIterator]() : iterable[Symbol.iterator]();
    return $e4deb49dba5321bc$var$makeReadableStream({
        start () {},
        async pull (controller) {
            const { done: done, value: value } = await iter.next();
            if (done) controller.close();
            else controller.enqueue(value);
        },
        async cancel () {
            var _a;
            await ((_a = iter.return) === null || _a === void 0 ? void 0 : _a.call(iter));
        }
    });
}
/**
 * Most browsers don't yet have async iterable support for ReadableStream,
 * and Node has a very different way of reading bytes from its "ReadableStream".
 *
 * This polyfill was pulled from https://github.com/MattiasBuelens/web-streams-polyfill/pull/122#issuecomment-1627354490
 */ function $e4deb49dba5321bc$var$ReadableStreamToAsyncIterable(stream) {
    if (stream[Symbol.asyncIterator]) return stream;
    const reader = stream.getReader();
    return {
        async next () {
            try {
                const result = await reader.read();
                if (result === null || result === void 0 ? void 0 : result.done) reader.releaseLock(); // release lock when stream becomes closed
                return result;
            } catch (e) {
                reader.releaseLock(); // release lock when stream becomes errored
                throw e;
            }
        },
        async return () {
            const cancelPromise = reader.cancel();
            reader.releaseLock();
            await cancelPromise;
            return {
                done: true,
                value: undefined
            };
        },
        [Symbol.asyncIterator] () {
            return this;
        }
    };
}
/**
 * Cancels a ReadableStream we don't need to consume.
 * See https://undici.nodejs.org/#/?id=garbage-collection
 */ async function $e4deb49dba5321bc$var$CancelReadableStream(stream) {
    var _a, _b;
    if (stream === null || typeof stream !== 'object') return;
    if (stream[Symbol.asyncIterator]) {
        await ((_b = (_a = stream[Symbol.asyncIterator]()).return) === null || _b === void 0 ? void 0 : _b.call(_a));
        return;
    }
    const reader = stream.getReader();
    const cancelPromise = reader.cancel();
    reader.releaseLock();
    await cancelPromise;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$FallbackEncoder = ({ headers: headers, body: body })=>{
    return {
        bodyHeaders: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(body)
    };
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
/**
 * Basic re-implementation of `qs.stringify` for primitive types.
 */ function $e4deb49dba5321bc$var$stringifyQuery(query) {
    return Object.entries(query).filter(([_, value])=>typeof value !== 'undefined').map(([key, value])=>{
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
        if (value === null) return `${encodeURIComponent(key)}=`;
        throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Cannot stringify type ${typeof value}; Expected string, number, boolean, or null. If you need to pass nested query parameters, you can manually encode them, e.g. { query: { 'foo[key1]': value1, 'foo[key2]': value2 } }, and please open a GitHub issue requesting better support for your use case.`);
    }).join('&');
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$VERSION = '0.0.1';
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$checkFileSupport = ()=>{
    var _a;
    if (typeof File === 'undefined') {
        const { process: process } = globalThis;
        const isOldNode = typeof ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) === 'string' && parseInt(process.versions.node.split('.')) < 20;
        throw new Error('`File` is not defined as a global, which is required for file uploads.' + (isOldNode ? " Update to Node 20 LTS or newer, or set `globalThis.File` to `import('node:buffer').File`." : ''));
    }
};
/**
 * Construct a `File` instance. This is used to ensure a helpful error is thrown
 * for environments that don't define a global `File` yet.
 */ function $e4deb49dba5321bc$var$makeFile(fileBits, fileName, options) {
    $e4deb49dba5321bc$var$checkFileSupport();
    return new File(fileBits, fileName !== null && fileName !== void 0 ? fileName : 'unknown_file', options);
}
function $e4deb49dba5321bc$var$getName(value) {
    return (typeof value === 'object' && value !== null && ('name' in value && value.name && String(value.name) || 'url' in value && value.url && String(value.url) || 'filename' in value && value.filename && String(value.filename) || 'path' in value && value.path && String(value.path)) || '').split(/[\\/]/).pop() || undefined;
}
const $e4deb49dba5321bc$var$isAsyncIterable = (value)=>value != null && typeof value === 'object' && typeof value[Symbol.asyncIterator] === 'function';
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * This check adds the arrayBuffer() method type because it is available and used at runtime
 */ const $e4deb49dba5321bc$var$isBlobLike = (value)=>value != null && typeof value === 'object' && typeof value.size === 'number' && typeof value.type === 'string' && typeof value.text === 'function' && typeof value.slice === 'function' && typeof value.arrayBuffer === 'function';
/**
 * This check adds the arrayBuffer() method type because it is available and used at runtime
 */ const $e4deb49dba5321bc$var$isFileLike = (value)=>value != null && typeof value === 'object' && typeof value.name === 'string' && typeof value.lastModified === 'number' && $e4deb49dba5321bc$var$isBlobLike(value);
const $e4deb49dba5321bc$var$isResponseLike = (value)=>value != null && typeof value === 'object' && typeof value.url === 'string' && typeof value.blob === 'function';
/**
 * Helper for creating a {@link File} to pass to an SDK upload method from a variety of different data formats
 * @param value the raw content of the file. Can be an {@link Uploadable}, BlobLikePart, or AsyncIterable of BlobLikeParts
 * @param {string=} name the name of the file. If omitted, toFile will try to determine a file name from bits if possible
 * @param {Object=} options additional properties
 * @param {string=} options.type the MIME type of the content
 * @param {number=} options.lastModified the last modified timestamp
 * @returns a {@link File} with the given properties
 */ async function $e4deb49dba5321bc$var$toFile(value, name, options) {
    $e4deb49dba5321bc$var$checkFileSupport();
    // If it's a promise, resolve it.
    value = await value;
    // If we've been given a `File` we don't need to do anything
    if ($e4deb49dba5321bc$var$isFileLike(value)) {
        if (value instanceof File) return value;
        return $e4deb49dba5321bc$var$makeFile([
            await value.arrayBuffer()
        ], value.name);
    }
    if ($e4deb49dba5321bc$var$isResponseLike(value)) {
        const blob = await value.blob();
        name || (name = new URL(value.url).pathname.split(/[\\/]/).pop());
        return $e4deb49dba5321bc$var$makeFile(await $e4deb49dba5321bc$var$getBytes(blob), name, options);
    }
    const parts = await $e4deb49dba5321bc$var$getBytes(value);
    name || (name = $e4deb49dba5321bc$var$getName(value));
    if (!(options === null || options === void 0 ? void 0 : options.type)) {
        const type = parts.find((part)=>typeof part === 'object' && 'type' in part && part.type);
        if (typeof type === 'string') options = Object.assign(Object.assign({}, options), {
            type: type
        });
    }
    return $e4deb49dba5321bc$var$makeFile(parts, name, options);
}
async function $e4deb49dba5321bc$var$getBytes(value) {
    var _a, e_1, _b, _c;
    var _d;
    let parts = [];
    if (typeof value === 'string' || ArrayBuffer.isView(value) || // includes Uint8Array, Buffer, etc.
    value instanceof ArrayBuffer) parts.push(value);
    else if ($e4deb49dba5321bc$var$isBlobLike(value)) parts.push(value instanceof Blob ? value : await value.arrayBuffer());
    else if ($e4deb49dba5321bc$var$isAsyncIterable(value) // includes Readable, ReadableStream, etc.
    ) try {
        for(var _e = true, value_1 = $e4deb49dba5321bc$var$__asyncValues(value), value_1_1; value_1_1 = await value_1.next(), _a = value_1_1.done, !_a; _e = true){
            _c = value_1_1.value;
            _e = false;
            const chunk = _c;
            parts.push(...await $e4deb49dba5321bc$var$getBytes(chunk)); // TODO, consider validating?
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (!_e && !_a && (_b = value_1.return)) await _b.call(value_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else {
        const constructor = (_d = value === null || value === void 0 ? void 0 : value.constructor) === null || _d === void 0 ? void 0 : _d.name;
        throw new Error(`Unexpected data type: ${typeof value}${constructor ? `; constructor: ${constructor}` : ''}${$e4deb49dba5321bc$var$propsForError(value)}`);
    }
    return parts;
}
function $e4deb49dba5321bc$var$propsForError(value) {
    if (typeof value !== 'object' || value === null) return '';
    const props = Object.getOwnPropertyNames(value);
    return `; props: [${props.map((p)=>`"${p}"`).join(', ')}]`;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$APIResource {
    constructor(client){
        this._client = client;
    }
}
/**
 * The key path from the client. For example, a resource accessible as `client.resource.subresource` would
 * have a property `static override readonly _key = Object.freeze(['resource', 'subresource'] as const);`.
 */ $e4deb49dba5321bc$var$APIResource._key = [];
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * Percent-encode everything that isn't safe to have in a path without encoding safe chars.
 *
 * Taken from https://datatracker.ietf.org/doc/html/rfc3986#section-3.3:
 * > unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
 * > sub-delims  = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
 * > pchar       = unreserved / pct-encoded / sub-delims / ":" / "@"
 */ function $e4deb49dba5321bc$var$encodeURIPath(str) {
    return str.replace(/[^A-Za-z0-9\-._~!$&'()*+,;=:@]+/g, encodeURIComponent);
}
const $e4deb49dba5321bc$var$EMPTY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.create(null));
const $e4deb49dba5321bc$var$createPathTagFunction = (pathEncoder = $e4deb49dba5321bc$var$encodeURIPath)=>function path(statics, ...params) {
        // If there are no params, no processing is needed.
        if (statics.length === 1) return statics[0];
        let postPath = false;
        const invalidSegments = [];
        const path1 = statics.reduce((previousValue, currentValue, index)=>{
            var _a, _b, _c;
            if (/[?#]/.test(currentValue)) postPath = true;
            const value = params[index];
            let encoded = (postPath ? encodeURIComponent : pathEncoder)('' + value);
            if (index !== params.length && (value == null || typeof value === 'object' && // handle values from other realms
            value.toString === ((_c = Object.getPrototypeOf((_b = Object.getPrototypeOf((_a = value.hasOwnProperty) !== null && _a !== void 0 ? _a : $e4deb49dba5321bc$var$EMPTY)) !== null && _b !== void 0 ? _b : $e4deb49dba5321bc$var$EMPTY)) === null || _c === void 0 ? void 0 : _c.toString))) {
                encoded = value + '';
                invalidSegments.push({
                    start: previousValue.length + currentValue.length,
                    length: encoded.length,
                    error: `Value of type ${Object.prototype.toString.call(value).slice(8, -1)} is not a valid path parameter`
                });
            }
            return previousValue + currentValue + (index === params.length ? '' : encoded);
        }, '');
        const pathOnly = path1.split(/[?#]/, 1)[0];
        const invalidSegmentPattern = /(^|\/)(?:\.|%2e){1,2}(?=\/|$)/gi;
        let match;
        // Find all invalid segments
        while((match = invalidSegmentPattern.exec(pathOnly)) !== null){
            const hasLeadingSlash = match[0].startsWith('/');
            const offset = hasLeadingSlash ? 1 : 0;
            const cleanMatch = hasLeadingSlash ? match[0].slice(1) : match[0];
            invalidSegments.push({
                start: match.index + offset,
                length: cleanMatch.length,
                error: `Value "${cleanMatch}" can\'t be safely passed as a path parameter`
            });
        }
        invalidSegments.sort((a, b)=>a.start - b.start);
        if (invalidSegments.length > 0) {
            let lastEnd = 0;
            const underline = invalidSegments.reduce((acc, segment)=>{
                const spaces = ' '.repeat(segment.start - lastEnd);
                const arrows = '^'.repeat(segment.length);
                lastEnd = segment.start + segment.length;
                return acc + spaces + arrows;
            }, '');
            throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Path parameters result in path with invalid segments:\n${invalidSegments.map((e)=>e.error).join('\n')}\n${path1}\n${underline}`);
        }
        return path1;
    };
/**
 * URI-encodes path params and ensures no unsafe /./ or /../ path segments are introduced.
 */ const $e4deb49dba5321bc$var$path = /* @__PURE__ */ $e4deb49dba5321bc$var$createPathTagFunction($e4deb49dba5321bc$var$encodeURIPath);
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BaseInteractions extends $e4deb49dba5321bc$var$APIResource {
    create(params, options) {
        var _a;
        const { api_version: api_version = this._client.apiVersion } = params, body = $e4deb49dba5321bc$var$__rest(params, [
            "api_version"
        ]);
        if ('model' in body && 'agent_config' in body) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Invalid request: specified \`model\` and \`agent_config\`. If specifying \`model\`, use \`generation_config\`.`);
        if ('agent' in body && 'generation_config' in body) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Invalid request: specified \`agent\` and \`generation_config\`. If specifying \`agent\`, use \`agent_config\`.`);
        return this._client.post($e4deb49dba5321bc$var$path`/${api_version}/interactions`, Object.assign(Object.assign({
            body: body
        }, options), {
            stream: (_a = params.stream) !== null && _a !== void 0 ? _a : false
        }));
    }
    /**
     * Deletes the interaction by id.
     *
     * @example
     * ```ts
     * const interaction = await client.interactions.delete('id', {
     *   api_version: 'api_version',
     * });
     * ```
     */ delete(id, params = {}, options) {
        const { api_version: api_version = this._client.apiVersion } = params !== null && params !== void 0 ? params : {};
        return this._client.delete($e4deb49dba5321bc$var$path`/${api_version}/interactions/${id}`, options);
    }
    /**
     * Cancels an interaction by id. This only applies to background interactions that are still running.
     *
     * @example
     * ```ts
     * const interaction = await client.interactions.cancel('id', {
     *   api_version: 'api_version',
     * });
     * ```
     */ cancel(id, params = {}, options) {
        const { api_version: api_version = this._client.apiVersion } = params !== null && params !== void 0 ? params : {};
        return this._client.post($e4deb49dba5321bc$var$path`/${api_version}/interactions/${id}/cancel`, options);
    }
    get(id, params = {}, options) {
        var _a;
        const _b = params !== null && params !== void 0 ? params : {}, { api_version: api_version = this._client.apiVersion } = _b, query = $e4deb49dba5321bc$var$__rest(_b, [
            "api_version"
        ]);
        return this._client.get($e4deb49dba5321bc$var$path`/${api_version}/interactions/${id}`, Object.assign(Object.assign({
            query: query
        }, options), {
            stream: (_a = params === null || params === void 0 ? void 0 : params.stream) !== null && _a !== void 0 ? _a : false
        }));
    }
}
$e4deb49dba5321bc$var$BaseInteractions._key = Object.freeze([
    'interactions'
]);
class $e4deb49dba5321bc$var$Interactions extends $e4deb49dba5321bc$var$BaseInteractions {
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ function $e4deb49dba5321bc$var$concatBytes(buffers) {
    let length = 0;
    for (const buffer of buffers)length += buffer.length;
    const output = new Uint8Array(length);
    let index = 0;
    for (const buffer of buffers){
        output.set(buffer, index);
        index += buffer.length;
    }
    return output;
}
let $e4deb49dba5321bc$var$encodeUTF8_;
function $e4deb49dba5321bc$var$encodeUTF8(str) {
    let encoder;
    return ($e4deb49dba5321bc$var$encodeUTF8_ !== null && $e4deb49dba5321bc$var$encodeUTF8_ !== void 0 ? $e4deb49dba5321bc$var$encodeUTF8_ : (encoder = new globalThis.TextEncoder(), $e4deb49dba5321bc$var$encodeUTF8_ = encoder.encode.bind(encoder)))(str);
}
let $e4deb49dba5321bc$var$decodeUTF8_;
function $e4deb49dba5321bc$var$decodeUTF8(bytes) {
    let decoder;
    return ($e4deb49dba5321bc$var$decodeUTF8_ !== null && $e4deb49dba5321bc$var$decodeUTF8_ !== void 0 ? $e4deb49dba5321bc$var$decodeUTF8_ : (decoder = new globalThis.TextDecoder(), $e4deb49dba5321bc$var$decodeUTF8_ = decoder.decode.bind(decoder)))(bytes);
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * A re-implementation of httpx's `LineDecoder` in Python that handles incrementally
 * reading lines from text.
 *
 * https://github.com/encode/httpx/blob/920333ea98118e9cf617f246905d7b202510941c/httpx/_decoders.py#L258
 */ class $e4deb49dba5321bc$var$LineDecoder {
    constructor(){
        this.buffer = new Uint8Array();
        this.carriageReturnIndex = null;
        this.searchIndex = 0;
    }
    decode(chunk) {
        var _a;
        if (chunk == null) return [];
        const binaryChunk = chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : typeof chunk === 'string' ? $e4deb49dba5321bc$var$encodeUTF8(chunk) : chunk;
        this.buffer = $e4deb49dba5321bc$var$concatBytes([
            this.buffer,
            binaryChunk
        ]);
        const lines = [];
        let patternIndex;
        while((patternIndex = $e4deb49dba5321bc$var$findNewlineIndex(this.buffer, (_a = this.carriageReturnIndex) !== null && _a !== void 0 ? _a : this.searchIndex)) != null){
            if (patternIndex.carriage && this.carriageReturnIndex == null) {
                // skip until we either get a corresponding `\n`, a new `\r` or nothing
                this.carriageReturnIndex = patternIndex.index;
                continue;
            }
            // we got double \r or \rtext\n
            if (this.carriageReturnIndex != null && (patternIndex.index !== this.carriageReturnIndex + 1 || patternIndex.carriage)) {
                lines.push($e4deb49dba5321bc$var$decodeUTF8(this.buffer.subarray(0, this.carriageReturnIndex - 1)));
                this.buffer = this.buffer.subarray(this.carriageReturnIndex);
                this.carriageReturnIndex = null;
                this.searchIndex = 0;
                continue;
            }
            const endIndex = this.carriageReturnIndex !== null ? patternIndex.preceding - 1 : patternIndex.preceding;
            const line = $e4deb49dba5321bc$var$decodeUTF8(this.buffer.subarray(0, endIndex));
            lines.push(line);
            this.buffer = this.buffer.subarray(patternIndex.index);
            this.carriageReturnIndex = null;
            this.searchIndex = 0;
        }
        this.searchIndex = Math.max(0, this.buffer.length - 1);
        return lines;
    }
    flush() {
        if (!this.buffer.length) return [];
        return this.decode('\n');
    }
}
// prettier-ignore
$e4deb49dba5321bc$var$LineDecoder.NEWLINE_CHARS = new Set([
    '\n',
    '\r'
]);
$e4deb49dba5321bc$var$LineDecoder.NEWLINE_REGEXP = /\r\n|[\n\r]/g;
/**
 * This function searches the buffer for the end patterns, (\r or \n)
 * and returns an object with the index preceding the matched newline and the
 * index after the newline char. `null` is returned if no new line is found.
 *
 * ```ts
 * findNewLineIndex('abc\ndef') -> { preceding: 2, index: 3 }
 * ```
 */ function $e4deb49dba5321bc$var$findNewlineIndex(buffer, startIndex) {
    const newline = 0x0a; // \n
    const carriage = 0x0d; // \r
    const start = startIndex !== null && startIndex !== void 0 ? startIndex : 0;
    const nextNewline = buffer.indexOf(newline, start);
    const nextCarriage = buffer.indexOf(carriage, start);
    if (nextNewline === -1 && nextCarriage === -1) return null;
    let i;
    if (nextNewline !== -1 && nextCarriage !== -1) i = Math.min(nextNewline, nextCarriage);
    else i = nextNewline !== -1 ? nextNewline : nextCarriage;
    if (buffer[i] === newline) return {
        preceding: i,
        index: i + 1,
        carriage: false
    };
    return {
        preceding: i,
        index: i + 1,
        carriage: true
    };
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
const $e4deb49dba5321bc$var$levelNumbers = {
    off: 0,
    error: 200,
    warn: 300,
    info: 400,
    debug: 500
};
const $e4deb49dba5321bc$var$parseLogLevel = (maybeLevel, sourceName, client)=>{
    if (!maybeLevel) return undefined;
    if ($e4deb49dba5321bc$var$hasOwn($e4deb49dba5321bc$var$levelNumbers, maybeLevel)) return maybeLevel;
    $e4deb49dba5321bc$var$loggerFor(client).warn(`${sourceName} was set to ${JSON.stringify(maybeLevel)}, expected one of ${JSON.stringify(Object.keys($e4deb49dba5321bc$var$levelNumbers))}`);
    return undefined;
};
function $e4deb49dba5321bc$var$noop() {}
function $e4deb49dba5321bc$var$makeLogFn(fnLevel, logger, logLevel) {
    if (!logger || $e4deb49dba5321bc$var$levelNumbers[fnLevel] > $e4deb49dba5321bc$var$levelNumbers[logLevel]) return $e4deb49dba5321bc$var$noop;
    else // Don't wrap logger functions, we want the stacktrace intact!
    return logger[fnLevel].bind(logger);
}
const $e4deb49dba5321bc$var$noopLogger = {
    error: $e4deb49dba5321bc$var$noop,
    warn: $e4deb49dba5321bc$var$noop,
    info: $e4deb49dba5321bc$var$noop,
    debug: $e4deb49dba5321bc$var$noop
};
let $e4deb49dba5321bc$var$cachedLoggers = /* @__PURE__ */ new WeakMap();
function $e4deb49dba5321bc$var$loggerFor(client) {
    var _a;
    const logger = client.logger;
    const logLevel = (_a = client.logLevel) !== null && _a !== void 0 ? _a : 'off';
    if (!logger) return $e4deb49dba5321bc$var$noopLogger;
    const cachedLogger = $e4deb49dba5321bc$var$cachedLoggers.get(logger);
    if (cachedLogger && cachedLogger[0] === logLevel) return cachedLogger[1];
    const levelLogger = {
        error: $e4deb49dba5321bc$var$makeLogFn('error', logger, logLevel),
        warn: $e4deb49dba5321bc$var$makeLogFn('warn', logger, logLevel),
        info: $e4deb49dba5321bc$var$makeLogFn('info', logger, logLevel),
        debug: $e4deb49dba5321bc$var$makeLogFn('debug', logger, logLevel)
    };
    $e4deb49dba5321bc$var$cachedLoggers.set(logger, [
        logLevel,
        levelLogger
    ]);
    return levelLogger;
}
const $e4deb49dba5321bc$var$formatRequestDetails = (details)=>{
    if (details.options) {
        details.options = Object.assign({}, details.options);
        delete details.options['headers']; // redundant + leaks internals
    }
    if (details.headers) details.headers = Object.fromEntries((details.headers instanceof Headers ? [
        ...details.headers
    ] : Object.entries(details.headers)).map(([name, value])=>[
            name,
            name.toLowerCase() === 'x-goog-api-key' || name.toLowerCase() === 'authorization' || name.toLowerCase() === 'cookie' || name.toLowerCase() === 'set-cookie' ? '***' : value
        ]));
    if ('retryOfRequestLogID' in details) {
        if (details.retryOfRequestLogID) details.retryOf = details.retryOfRequestLogID;
        delete details.retryOfRequestLogID;
    }
    return details;
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$Stream {
    constructor(iterator, controller, client){
        this.iterator = iterator;
        this.controller = controller;
        this.client = client;
    }
    static fromSSEResponse(response, controller, client) {
        let consumed = false;
        const logger = client ? $e4deb49dba5321bc$var$loggerFor(client) : console;
        function iterator() {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterator_1() {
                var _a, e_1, _b, _c;
                if (consumed) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError('Cannot iterate over a consumed stream, use `.tee()` to split the stream.');
                consumed = true;
                let done = false;
                try {
                    try {
                        for(var _d = true, _e = $e4deb49dba5321bc$var$__asyncValues($e4deb49dba5321bc$var$_iterSSEMessages(response, controller)), _f; _f = yield $e4deb49dba5321bc$var$__await(_e.next()), _a = _f.done, !_a; _d = true){
                            _c = _f.value;
                            _d = false;
                            const sse = _c;
                            if (done) continue;
                            if (sse.data.startsWith('[DONE]')) {
                                done = true;
                                continue;
                            } else try {
                                // @ts-ignore
                                yield yield $e4deb49dba5321bc$var$__await(JSON.parse(sse.data));
                            } catch (e) {
                                logger.error(`Could not parse message into JSON:`, sse.data);
                                logger.error(`From chunk:`, sse.raw);
                                throw e;
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = {
                            error: e_1_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = _e.return)) yield $e4deb49dba5321bc$var$__await(_b.call(_e));
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                    }
                    done = true;
                } catch (e) {
                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                    if ($e4deb49dba5321bc$var$isAbortError(e)) return yield $e4deb49dba5321bc$var$__await(void 0);
                    throw e;
                } finally{
                    // If the user `break`s, abort the ongoing request.
                    if (!done) controller.abort();
                }
            });
        }
        return new $e4deb49dba5321bc$var$Stream(iterator, controller, client);
    }
    /**
     * Generates a Stream from a newline-separated ReadableStream
     * where each item is a JSON value.
     */ static fromReadableStream(readableStream, controller, client) {
        let consumed = false;
        function iterLines() {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterLines_1() {
                var _a, e_2, _b, _c;
                const lineDecoder = new $e4deb49dba5321bc$var$LineDecoder();
                const iter = $e4deb49dba5321bc$var$ReadableStreamToAsyncIterable(readableStream);
                try {
                    for(var _d = true, iter_1 = $e4deb49dba5321bc$var$__asyncValues(iter), iter_1_1; iter_1_1 = yield $e4deb49dba5321bc$var$__await(iter_1.next()), _a = iter_1_1.done, !_a; _d = true){
                        _c = iter_1_1.value;
                        _d = false;
                        const chunk = _c;
                        for (const line of lineDecoder.decode(chunk))yield yield $e4deb49dba5321bc$var$__await(line);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = iter_1.return)) yield $e4deb49dba5321bc$var$__await(_b.call(iter_1));
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                for (const line of lineDecoder.flush())yield yield $e4deb49dba5321bc$var$__await(line);
            });
        }
        function iterator() {
            return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterator_2() {
                var _a, e_3, _b, _c;
                if (consumed) throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError('Cannot iterate over a consumed stream, use `.tee()` to split the stream.');
                consumed = true;
                let done = false;
                try {
                    try {
                        for(var _d = true, _e = $e4deb49dba5321bc$var$__asyncValues(iterLines()), _f; _f = yield $e4deb49dba5321bc$var$__await(_e.next()), _a = _f.done, !_a; _d = true){
                            _c = _f.value;
                            _d = false;
                            const line = _c;
                            if (done) continue;
                            // @ts-ignore
                            if (line) yield yield $e4deb49dba5321bc$var$__await(JSON.parse(line));
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (!_d && !_a && (_b = _e.return)) yield $e4deb49dba5321bc$var$__await(_b.call(_e));
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                    done = true;
                } catch (e) {
                    // If the user calls `stream.controller.abort()`, we should exit without throwing.
                    if ($e4deb49dba5321bc$var$isAbortError(e)) return yield $e4deb49dba5321bc$var$__await(void 0);
                    throw e;
                } finally{
                    // If the user `break`s, abort the ongoing request.
                    if (!done) controller.abort();
                }
            });
        }
        return new $e4deb49dba5321bc$var$Stream(iterator, controller, client);
    }
    [Symbol.asyncIterator]() {
        return this.iterator();
    }
    /**
     * Splits the stream into two streams which can be
     * independently read from at different speeds.
     */ tee() {
        const left = [];
        const right = [];
        const iterator = this.iterator();
        const teeIterator = (queue)=>{
            return {
                next: ()=>{
                    if (queue.length === 0) {
                        const result = iterator.next();
                        left.push(result);
                        right.push(result);
                    }
                    return queue.shift();
                }
            };
        };
        return [
            new $e4deb49dba5321bc$var$Stream(()=>teeIterator(left), this.controller, this.client),
            new $e4deb49dba5321bc$var$Stream(()=>teeIterator(right), this.controller, this.client)
        ];
    }
    /**
     * Converts this stream to a newline-separated ReadableStream of
     * JSON stringified values in the stream
     * which can be turned back into a Stream with `Stream.fromReadableStream()`.
     */ toReadableStream() {
        const self = this;
        let iter;
        return $e4deb49dba5321bc$var$makeReadableStream({
            async start () {
                iter = self[Symbol.asyncIterator]();
            },
            async pull (ctrl) {
                try {
                    const { value: value, done: done } = await iter.next();
                    if (done) return ctrl.close();
                    const bytes = $e4deb49dba5321bc$var$encodeUTF8(JSON.stringify(value) + '\n');
                    ctrl.enqueue(bytes);
                } catch (err) {
                    ctrl.error(err);
                }
            },
            async cancel () {
                var _a;
                await ((_a = iter.return) === null || _a === void 0 ? void 0 : _a.call(iter));
            }
        });
    }
}
function $e4deb49dba5321bc$var$_iterSSEMessages(response, controller) {
    return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* _iterSSEMessages_1() {
        var _a, e_4, _b, _c;
        if (!response.body) {
            controller.abort();
            if (typeof globalThis.navigator !== 'undefined' && globalThis.navigator.product === 'ReactNative') throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`The default react-native fetch implementation does not support streaming. Please use expo/fetch: https://docs.expo.dev/versions/latest/sdk/expo/#expofetch-api`);
            throw new $e4deb49dba5321bc$var$GeminiNextGenAPIClientError(`Attempted to iterate over a response with no body`);
        }
        const sseDecoder = new $e4deb49dba5321bc$var$SSEDecoder();
        const lineDecoder = new $e4deb49dba5321bc$var$LineDecoder();
        const iter = $e4deb49dba5321bc$var$ReadableStreamToAsyncIterable(response.body);
        try {
            for(var _d = true, _e = $e4deb49dba5321bc$var$__asyncValues($e4deb49dba5321bc$var$iterBinaryChunks(iter)), _f; _f = yield $e4deb49dba5321bc$var$__await(_e.next()), _a = _f.done, !_a; _d = true){
                _c = _f.value;
                _d = false;
                const sseChunk = _c;
                for (const line of lineDecoder.decode(sseChunk)){
                    const sse = sseDecoder.decode(line);
                    if (sse) yield yield $e4deb49dba5321bc$var$__await(sse);
                }
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = _e.return)) yield $e4deb49dba5321bc$var$__await(_b.call(_e));
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        for (const line of lineDecoder.flush()){
            const sse = sseDecoder.decode(line);
            if (sse) yield yield $e4deb49dba5321bc$var$__await(sse);
        }
    });
}
/**
 * Given an async iterable iterator, normalizes each chunk to a
 * Uint8Array and yields it.
 */ function $e4deb49dba5321bc$var$iterBinaryChunks(iterator) {
    return $e4deb49dba5321bc$var$__asyncGenerator(this, arguments, function* iterBinaryChunks_1() {
        var _a, e_5, _b, _c;
        try {
            for(var _d = true, iterator_3 = $e4deb49dba5321bc$var$__asyncValues(iterator), iterator_3_1; iterator_3_1 = yield $e4deb49dba5321bc$var$__await(iterator_3.next()), _a = iterator_3_1.done, !_a; _d = true){
                _c = iterator_3_1.value;
                _d = false;
                const chunk = _c;
                if (chunk == null) continue;
                const binaryChunk = chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : typeof chunk === 'string' ? $e4deb49dba5321bc$var$encodeUTF8(chunk) : chunk;
                yield yield $e4deb49dba5321bc$var$__await(binaryChunk);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (!_d && !_a && (_b = iterator_3.return)) yield $e4deb49dba5321bc$var$__await(_b.call(iterator_3));
            } finally{
                if (e_5) throw e_5.error;
            }
        }
    });
}
class $e4deb49dba5321bc$var$SSEDecoder {
    constructor(){
        this.event = null;
        this.data = [];
        this.chunks = [];
    }
    decode(line) {
        if (line.endsWith('\r')) line = line.substring(0, line.length - 1);
        if (!line) {
            // empty line and we didn't previously encounter any messages
            if (!this.event && !this.data.length) return null;
            const sse = {
                event: this.event,
                data: this.data.join('\n'),
                raw: this.chunks
            };
            this.event = null;
            this.data = [];
            this.chunks = [];
            return sse;
        }
        this.chunks.push(line);
        if (line.startsWith(':')) return null;
        let [fieldname, _, value] = $e4deb49dba5321bc$var$partition(line, ':');
        if (value.startsWith(' ')) value = value.substring(1);
        if (fieldname === 'event') this.event = value;
        else if (fieldname === 'data') this.data.push(value);
        return null;
    }
}
function $e4deb49dba5321bc$var$partition(str, delimiter) {
    const index = str.indexOf(delimiter);
    if (index !== -1) return [
        str.substring(0, index),
        delimiter,
        str.substring(index + delimiter.length)
    ];
    return [
        str,
        '',
        ''
    ];
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ async function $e4deb49dba5321bc$var$defaultParseResponse(client, props) {
    const { response: response, requestLogID: requestLogID, retryOfRequestLogID: retryOfRequestLogID, startTime: startTime } = props;
    const body = await (async ()=>{
        var _a;
        if (props.options.stream) {
            $e4deb49dba5321bc$var$loggerFor(client).debug('response', response.status, response.url, response.headers, response.body);
            // Note: there is an invariant here that isn't represented in the type system
            // that if you set `stream: true` the response type must also be `Stream<T>`
            if (props.options.__streamClass) return props.options.__streamClass.fromSSEResponse(response, props.controller, client);
            return $e4deb49dba5321bc$var$Stream.fromSSEResponse(response, props.controller, client);
        }
        // fetch refuses to read the body when the status code is 204.
        if (response.status === 204) return null;
        if (props.options.__binaryResponse) return response;
        const contentType = response.headers.get('content-type');
        const mediaType = (_a = contentType === null || contentType === void 0 ? void 0 : contentType.split(';')[0]) === null || _a === void 0 ? void 0 : _a.trim();
        const isJSON = (mediaType === null || mediaType === void 0 ? void 0 : mediaType.includes('application/json')) || (mediaType === null || mediaType === void 0 ? void 0 : mediaType.endsWith('+json'));
        if (isJSON) {
            const contentLength = response.headers.get('content-length');
            if (contentLength === '0') // if there is no content we can't do anything
            return undefined;
            const json = await response.json();
            return json;
        }
        const text = await response.text();
        return text;
    })();
    $e4deb49dba5321bc$var$loggerFor(client).debug(`[${requestLogID}] response parsed`, $e4deb49dba5321bc$var$formatRequestDetails({
        retryOfRequestLogID: retryOfRequestLogID,
        url: response.url,
        status: response.status,
        body: body,
        durationMs: Date.now() - startTime
    }));
    return body;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ /**
 * A subclass of `Promise` providing additional helper methods
 * for interacting with the SDK.
 */ class $e4deb49dba5321bc$var$APIPromise extends Promise {
    constructor(client, responsePromise, parseResponse = $e4deb49dba5321bc$var$defaultParseResponse){
        super((resolve)=>{
            // this is maybe a bit weird but this has to be a no-op to not implicitly
            // parse the response body; instead .then, .catch, .finally are overridden
            // to parse the response
            resolve(null);
        });
        this.responsePromise = responsePromise;
        this.parseResponse = parseResponse;
        this.client = client;
    }
    _thenUnwrap(transform) {
        return new $e4deb49dba5321bc$var$APIPromise(this.client, this.responsePromise, async (client, props)=>transform(await this.parseResponse(client, props), props));
    }
    /**
     * Gets the raw `Response` instance instead of parsing the response
     * data.
     *
     * If you want to parse the response body but still get the `Response`
     * instance, you can use {@link withResponse()}.
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` or add `"lib": ["DOM"]`
     * to your `tsconfig.json`.
     */ asResponse() {
        return this.responsePromise.then((p)=>p.response);
    }
    /**
     * Gets the parsed response data and the raw `Response` instance.
     *
     * If you just want to get the raw `Response` instance without parsing it,
     * you can use {@link asResponse()}.
     *
     * 👋 Getting the wrong TypeScript type for `Response`?
     * Try setting `"moduleResolution": "NodeNext"` or add `"lib": ["DOM"]`
     * to your `tsconfig.json`.
     */ async withResponse() {
        const [data, response] = await Promise.all([
            this.parse(),
            this.asResponse()
        ]);
        return {
            data: data,
            response: response
        };
    }
    parse() {
        if (!this.parsedPromise) this.parsedPromise = this.responsePromise.then((data)=>this.parseResponse(this.client, data));
        return this.parsedPromise;
    }
    then(onfulfilled, onrejected) {
        return this.parse().then(onfulfilled, onrejected);
    }
    catch(onrejected) {
        return this.parse().catch(onrejected);
    }
    finally(onfinally) {
        return this.parse().finally(onfinally);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
const $e4deb49dba5321bc$var$brand_privateNullableHeaders = /* @__PURE__ */ Symbol('brand.privateNullableHeaders');
function* $e4deb49dba5321bc$var$iterateHeaders(headers) {
    if (!headers) return;
    if ($e4deb49dba5321bc$var$brand_privateNullableHeaders in headers) {
        const { values: values, nulls: nulls } = headers;
        yield* values.entries();
        for (const name of nulls)yield [
            name,
            null
        ];
        return;
    }
    let shouldClear = false;
    let iter;
    if (headers instanceof Headers) iter = headers.entries();
    else if ($e4deb49dba5321bc$var$isReadonlyArray(headers)) iter = headers;
    else {
        shouldClear = true;
        iter = Object.entries(headers !== null && headers !== void 0 ? headers : {});
    }
    for (let row of iter){
        const name = row[0];
        if (typeof name !== 'string') throw new TypeError('expected header name to be a string');
        const values = $e4deb49dba5321bc$var$isReadonlyArray(row[1]) ? row[1] : [
            row[1]
        ];
        let didClear = false;
        for (const value of values){
            if (value === undefined) continue;
            // Objects keys always overwrite older headers, they never append.
            // Yield a null to clear the header before adding the new values.
            if (shouldClear && !didClear) {
                didClear = true;
                yield [
                    name,
                    null
                ];
            }
            yield [
                name,
                value
            ];
        }
    }
}
const $e4deb49dba5321bc$var$buildHeaders = (newHeaders)=>{
    const targetHeaders = new Headers();
    const nullHeaders = new Set();
    for (const headers of newHeaders){
        const seenHeaders = new Set();
        for (const [name, value] of $e4deb49dba5321bc$var$iterateHeaders(headers)){
            const lowerName = name.toLowerCase();
            if (!seenHeaders.has(lowerName)) {
                targetHeaders.delete(name);
                seenHeaders.add(lowerName);
            }
            if (value === null) {
                targetHeaders.delete(name);
                nullHeaders.add(lowerName);
            } else {
                targetHeaders.append(name, value);
                nullHeaders.delete(lowerName);
            }
        }
    }
    return {
        [$e4deb49dba5321bc$var$brand_privateNullableHeaders]: true,
        values: targetHeaders,
        nulls: nullHeaders
    };
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
/**
 * Read an environment variable.
 *
 * Trims beginning and trailing whitespace.
 *
 * Will return undefined if the environment variable doesn't exist or cannot be accessed.
 */ const $e4deb49dba5321bc$var$readEnv = (env)=>{
    var _a, _b, _c, _d, _e, _f;
    if (typeof globalThis.process !== 'undefined') return (_c = (_b = (_a = globalThis.process.env) === null || _a === void 0 ? void 0 : _a[env]) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : undefined;
    if (typeof globalThis.Deno !== 'undefined') return (_f = (_e = (_d = globalThis.Deno.env) === null || _d === void 0 ? void 0 : _d.get) === null || _e === void 0 ? void 0 : _e.call(_d, env)) === null || _f === void 0 ? void 0 : _f.trim();
    return undefined;
};
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ var $e4deb49dba5321bc$var$_a;
/**
 * Base class for Gemini Next Gen API API clients.
 */ class $e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient {
    /**
     * API Client for interfacing with the Gemini Next Gen API API.
     *
     * @param {string | null | undefined} [opts.apiKey=process.env['GEMINI_API_KEY'] ?? null]
     * @param {string | undefined} [opts.apiVersion=v1beta]
     * @param {string} [opts.baseURL=process.env['GEMINI_NEXT_GEN_API_BASE_URL'] ?? https://generativelanguage.googleapis.com] - Override the default base URL for the API.
     * @param {number} [opts.timeout=1 minute] - The maximum amount of time (in milliseconds) the client will wait for a response before timing out.
     * @param {MergedRequestInit} [opts.fetchOptions] - Additional `RequestInit` options to be passed to `fetch` calls.
     * @param {Fetch} [opts.fetch] - Specify a custom `fetch` function implementation.
     * @param {number} [opts.maxRetries=2] - The maximum number of times the client will retry a request.
     * @param {HeadersLike} opts.defaultHeaders - Default headers to include with every request to the API.
     * @param {Record<string, string | undefined>} opts.defaultQuery - Default query parameters to include with every request to the API.
     */ constructor(_b){
        var _c, _d, _e, _f, _g, _h, _j;
        var { baseURL: baseURL = $e4deb49dba5321bc$var$readEnv('GEMINI_NEXT_GEN_API_BASE_URL'), apiKey: apiKey = (_c = $e4deb49dba5321bc$var$readEnv('GEMINI_API_KEY')) !== null && _c !== void 0 ? _c : null, apiVersion: apiVersion = 'v1beta' } = _b, opts = $e4deb49dba5321bc$var$__rest(_b, [
            "baseURL",
            "apiKey",
            "apiVersion"
        ]);
        const options = Object.assign(Object.assign({
            apiKey: apiKey,
            apiVersion: apiVersion
        }, opts), {
            baseURL: baseURL || `https://generativelanguage.googleapis.com`
        });
        this.baseURL = options.baseURL;
        this.timeout = (_d = options.timeout) !== null && _d !== void 0 ? _d : $e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient.DEFAULT_TIMEOUT /* 1 minute */ ;
        this.logger = (_e = options.logger) !== null && _e !== void 0 ? _e : console;
        const defaultLogLevel = 'warn';
        // Set default logLevel early so that we can log a warning in parseLogLevel.
        this.logLevel = defaultLogLevel;
        this.logLevel = (_g = (_f = $e4deb49dba5321bc$var$parseLogLevel(options.logLevel, 'ClientOptions.logLevel', this)) !== null && _f !== void 0 ? _f : $e4deb49dba5321bc$var$parseLogLevel($e4deb49dba5321bc$var$readEnv('GEMINI_NEXT_GEN_API_LOG'), "process.env['GEMINI_NEXT_GEN_API_LOG']", this)) !== null && _g !== void 0 ? _g : defaultLogLevel;
        this.fetchOptions = options.fetchOptions;
        this.maxRetries = (_h = options.maxRetries) !== null && _h !== void 0 ? _h : 2;
        this.fetch = (_j = options.fetch) !== null && _j !== void 0 ? _j : $e4deb49dba5321bc$var$getDefaultFetch();
        this.encoder = $e4deb49dba5321bc$var$FallbackEncoder;
        this._options = options;
        this.apiKey = apiKey;
        this.apiVersion = apiVersion;
        this.clientAdapter = options.clientAdapter;
    }
    /**
     * Create a new client instance re-using the same options given to the current client with optional overriding.
     */ withOptions(options) {
        const client = new this.constructor(Object.assign(Object.assign(Object.assign({}, this._options), {
            baseURL: this.baseURL,
            maxRetries: this.maxRetries,
            timeout: this.timeout,
            logger: this.logger,
            logLevel: this.logLevel,
            fetch: this.fetch,
            fetchOptions: this.fetchOptions,
            apiKey: this.apiKey,
            apiVersion: this.apiVersion
        }), options));
        return client;
    }
    /**
     * Check whether the base URL is set to its default.
     */ baseURLOverridden() {
        return this.baseURL !== 'https://generativelanguage.googleapis.com';
    }
    defaultQuery() {
        return this._options.defaultQuery;
    }
    validateHeaders({ values: values, nulls: nulls }) {
        // The headers object handles case insensitivity.
        if (values.has('authorization') || values.has('x-goog-api-key')) return;
        if (this.apiKey && values.get('x-goog-api-key')) return;
        if (nulls.has('x-goog-api-key')) return;
        throw new Error('Could not resolve authentication method. Expected the apiKey to be set. Or for the "x-goog-api-key" headers to be explicitly omitted');
    }
    async authHeaders(opts) {
        const existingHeaders = $e4deb49dba5321bc$var$buildHeaders([
            opts.headers
        ]);
        if (existingHeaders.values.has('authorization') || existingHeaders.values.has('x-goog-api-key')) return undefined;
        if (this.apiKey) return $e4deb49dba5321bc$var$buildHeaders([
            {
                'x-goog-api-key': this.apiKey
            }
        ]);
        if (this.clientAdapter.isVertexAI()) return $e4deb49dba5321bc$var$buildHeaders([
            await this.clientAdapter.getAuthHeaders()
        ]);
        return undefined;
    }
    /**
     * Basic re-implementation of `qs.stringify` for primitive types.
     */ stringifyQuery(query) {
        return $e4deb49dba5321bc$var$stringifyQuery(query);
    }
    getUserAgent() {
        return `${this.constructor.name}/JS ${$e4deb49dba5321bc$var$VERSION}`;
    }
    defaultIdempotencyKey() {
        return `stainless-node-retry-${$e4deb49dba5321bc$var$uuid4()}`;
    }
    makeStatusError(status, error, message, headers) {
        return $e4deb49dba5321bc$var$APIError.generate(status, error, message, headers);
    }
    buildURL(path, query, defaultBaseURL) {
        const baseURL = !this.baseURLOverridden() && defaultBaseURL || this.baseURL;
        const url = $e4deb49dba5321bc$var$isAbsoluteURL(path) ? new URL(path) : new URL(baseURL + (baseURL.endsWith('/') && path.startsWith('/') ? path.slice(1) : path));
        const defaultQuery = this.defaultQuery();
        const pathQuery = Object.fromEntries(url.searchParams);
        if (!$e4deb49dba5321bc$var$isEmptyObj(defaultQuery) || !$e4deb49dba5321bc$var$isEmptyObj(pathQuery)) query = Object.assign(Object.assign(Object.assign({}, pathQuery), defaultQuery), query);
        if (typeof query === 'object' && query && !Array.isArray(query)) url.search = this.stringifyQuery(query);
        return url.toString();
    }
    /**
     * Used as a callback for mutating the given `FinalRequestOptions` object.
  
     */ async prepareOptions(options) {
        if (this.clientAdapter && this.clientAdapter.isVertexAI() && !options.path.startsWith(`/${this.apiVersion}/projects/`)) {
            const oldPath = options.path.slice(this.apiVersion.length + 1);
            options.path = `/${this.apiVersion}/projects/${this.clientAdapter.getProject()}/locations/${this.clientAdapter.getLocation()}${oldPath}`;
        }
    }
    /**
     * Used as a callback for mutating the given `RequestInit` object.
     *
     * This is useful for cases where you want to add certain headers based off of
     * the request properties, e.g. `method` or `url`.
     */ async prepareRequest(request, { url: url, options: options }) {}
    get(path, opts) {
        return this.methodRequest('get', path, opts);
    }
    post(path, opts) {
        return this.methodRequest('post', path, opts);
    }
    patch(path, opts) {
        return this.methodRequest('patch', path, opts);
    }
    put(path, opts) {
        return this.methodRequest('put', path, opts);
    }
    delete(path, opts) {
        return this.methodRequest('delete', path, opts);
    }
    methodRequest(method, path, opts) {
        return this.request(Promise.resolve(opts).then((opts)=>{
            return Object.assign({
                method: method,
                path: path
            }, opts);
        }));
    }
    request(options, remainingRetries = null) {
        return new $e4deb49dba5321bc$var$APIPromise(this, this.makeRequest(options, remainingRetries, undefined));
    }
    async makeRequest(optionsInput, retriesRemaining, retryOfRequestLogID) {
        var _b, _c, _d;
        const options = await optionsInput;
        const maxRetries = (_b = options.maxRetries) !== null && _b !== void 0 ? _b : this.maxRetries;
        if (retriesRemaining == null) retriesRemaining = maxRetries;
        await this.prepareOptions(options);
        const { req: req, url: url, timeout: timeout } = await this.buildRequest(options, {
            retryCount: maxRetries - retriesRemaining
        });
        await this.prepareRequest(req, {
            url: url,
            options: options
        });
        /** Not an API request ID, just for correlating local log entries. */ const requestLogID = 'log_' + (Math.random() * 16777216 | 0).toString(16).padStart(6, '0');
        const retryLogStr = retryOfRequestLogID === undefined ? '' : `, retryOf: ${retryOfRequestLogID}`;
        const startTime = Date.now();
        $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] sending request`, $e4deb49dba5321bc$var$formatRequestDetails({
            retryOfRequestLogID: retryOfRequestLogID,
            method: options.method,
            url: url,
            options: options,
            headers: req.headers
        }));
        if ((_c = options.signal) === null || _c === void 0 ? void 0 : _c.aborted) throw new $e4deb49dba5321bc$var$APIUserAbortError();
        const controller = new AbortController();
        const response = await this.fetchWithTimeout(url, req, timeout, controller).catch($e4deb49dba5321bc$var$castToError);
        const headersTime = Date.now();
        if (response instanceof globalThis.Error) {
            const retryMessage = `retrying, ${retriesRemaining} attempts remaining`;
            if ((_d = options.signal) === null || _d === void 0 ? void 0 : _d.aborted) throw new $e4deb49dba5321bc$var$APIUserAbortError();
            // detect native connection timeout errors
            // deno throws "TypeError: error sending request for url (https://example/): client error (Connect): tcp connect error: Operation timed out (os error 60): Operation timed out (os error 60)"
            // undici throws "TypeError: fetch failed" with cause "ConnectTimeoutError: Connect Timeout Error (attempted address: example:443, timeout: 1ms)"
            // others do not provide enough information to distinguish timeouts from other connection errors
            const isTimeout = $e4deb49dba5321bc$var$isAbortError(response) || /timed? ?out/i.test(String(response) + ('cause' in response ? String(response.cause) : ''));
            if (retriesRemaining) {
                $e4deb49dba5321bc$var$loggerFor(this).info(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} - ${retryMessage}`);
                $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} (${retryMessage})`, $e4deb49dba5321bc$var$formatRequestDetails({
                    retryOfRequestLogID: retryOfRequestLogID,
                    url: url,
                    durationMs: headersTime - startTime,
                    message: response.message
                }));
                return this.retryRequest(options, retriesRemaining, retryOfRequestLogID !== null && retryOfRequestLogID !== void 0 ? retryOfRequestLogID : requestLogID);
            }
            $e4deb49dba5321bc$var$loggerFor(this).info(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} - error; no more retries left`);
            $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] connection ${isTimeout ? 'timed out' : 'failed'} (error; no more retries left)`, $e4deb49dba5321bc$var$formatRequestDetails({
                retryOfRequestLogID: retryOfRequestLogID,
                url: url,
                durationMs: headersTime - startTime,
                message: response.message
            }));
            if (isTimeout) throw new $e4deb49dba5321bc$var$APIConnectionTimeoutError();
            throw new $e4deb49dba5321bc$var$APIConnectionError({
                cause: response
            });
        }
        const responseInfo = `[${requestLogID}${retryLogStr}] ${req.method} ${url} ${response.ok ? 'succeeded' : 'failed'} with status ${response.status} in ${headersTime - startTime}ms`;
        if (!response.ok) {
            const shouldRetry = await this.shouldRetry(response);
            if (retriesRemaining && shouldRetry) {
                const retryMessage = `retrying, ${retriesRemaining} attempts remaining`;
                // We don't need the body of this response.
                await $e4deb49dba5321bc$var$CancelReadableStream(response.body);
                $e4deb49dba5321bc$var$loggerFor(this).info(`${responseInfo} - ${retryMessage}`);
                $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] response error (${retryMessage})`, $e4deb49dba5321bc$var$formatRequestDetails({
                    retryOfRequestLogID: retryOfRequestLogID,
                    url: response.url,
                    status: response.status,
                    headers: response.headers,
                    durationMs: headersTime - startTime
                }));
                return this.retryRequest(options, retriesRemaining, retryOfRequestLogID !== null && retryOfRequestLogID !== void 0 ? retryOfRequestLogID : requestLogID, response.headers);
            }
            const retryMessage = shouldRetry ? `error; no more retries left` : `error; not retryable`;
            $e4deb49dba5321bc$var$loggerFor(this).info(`${responseInfo} - ${retryMessage}`);
            const errText = await response.text().catch((err)=>$e4deb49dba5321bc$var$castToError(err).message);
            const errJSON = $e4deb49dba5321bc$var$safeJSON(errText);
            const errMessage = errJSON ? undefined : errText;
            $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] response error (${retryMessage})`, $e4deb49dba5321bc$var$formatRequestDetails({
                retryOfRequestLogID: retryOfRequestLogID,
                url: response.url,
                status: response.status,
                headers: response.headers,
                message: errMessage,
                durationMs: Date.now() - startTime
            }));
            // @ts-ignore
            const err = this.makeStatusError(response.status, errJSON, errMessage, response.headers);
            throw err;
        }
        $e4deb49dba5321bc$var$loggerFor(this).info(responseInfo);
        $e4deb49dba5321bc$var$loggerFor(this).debug(`[${requestLogID}] response start`, $e4deb49dba5321bc$var$formatRequestDetails({
            retryOfRequestLogID: retryOfRequestLogID,
            url: response.url,
            status: response.status,
            headers: response.headers,
            durationMs: headersTime - startTime
        }));
        return {
            response: response,
            options: options,
            controller: controller,
            requestLogID: requestLogID,
            retryOfRequestLogID: retryOfRequestLogID,
            startTime: startTime
        };
    }
    async fetchWithTimeout(url, init, ms, controller) {
        const _b = init || {}, { signal: signal, method: method } = _b, options = $e4deb49dba5321bc$var$__rest(_b, [
            "signal",
            "method"
        ]);
        const abort = this._makeAbort(controller);
        if (signal) signal.addEventListener('abort', abort, {
            once: true
        });
        const timeout = setTimeout(abort, ms);
        const isReadableBody = globalThis.ReadableStream && options.body instanceof globalThis.ReadableStream || typeof options.body === 'object' && options.body !== null && Symbol.asyncIterator in options.body;
        const fetchOptions = Object.assign(Object.assign(Object.assign({
            signal: controller.signal
        }, isReadableBody ? {
            duplex: 'half'
        } : {}), {
            method: 'GET'
        }), options);
        if (method) // Custom methods like 'patch' need to be uppercased
        // See https://github.com/nodejs/undici/issues/2294
        fetchOptions.method = method.toUpperCase();
        try {
            // use undefined this binding; fetch errors if bound to something else in browser/cloudflare
            return await this.fetch.call(undefined, url, fetchOptions);
        } finally{
            clearTimeout(timeout);
        }
    }
    async shouldRetry(response) {
        // Note this is not a standard header.
        const shouldRetryHeader = response.headers.get('x-should-retry');
        // If the server explicitly says whether or not to retry, obey.
        if (shouldRetryHeader === 'true') return true;
        if (shouldRetryHeader === 'false') return false;
        // Retry on request timeouts.
        if (response.status === 408) return true;
        // Retry on lock timeouts.
        if (response.status === 409) return true;
        // Retry on rate limits.
        if (response.status === 429) return true;
        // Retry internal errors.
        if (response.status >= 500) return true;
        return false;
    }
    async retryRequest(options, retriesRemaining, requestLogID, responseHeaders) {
        var _b;
        let timeoutMillis;
        // Note the `retry-after-ms` header may not be standard, but is a good idea and we'd like proactive support for it.
        const retryAfterMillisHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders.get('retry-after-ms');
        if (retryAfterMillisHeader) {
            const timeoutMs = parseFloat(retryAfterMillisHeader);
            if (!Number.isNaN(timeoutMs)) timeoutMillis = timeoutMs;
        }
        // About the Retry-After header: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After
        const retryAfterHeader = responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders.get('retry-after');
        if (retryAfterHeader && !timeoutMillis) {
            const timeoutSeconds = parseFloat(retryAfterHeader);
            if (!Number.isNaN(timeoutSeconds)) timeoutMillis = timeoutSeconds * 1000;
            else timeoutMillis = Date.parse(retryAfterHeader) - Date.now();
        }
        // If the API asks us to wait a certain amount of time, just do what it
        // says, but otherwise calculate a default
        if (timeoutMillis === undefined) {
            const maxRetries = (_b = options.maxRetries) !== null && _b !== void 0 ? _b : this.maxRetries;
            timeoutMillis = this.calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries);
        }
        await $e4deb49dba5321bc$var$sleep$1(timeoutMillis);
        return this.makeRequest(options, retriesRemaining - 1, requestLogID);
    }
    calculateDefaultRetryTimeoutMillis(retriesRemaining, maxRetries) {
        const initialRetryDelay = 0.5;
        const maxRetryDelay = 8.0;
        const numRetries = maxRetries - retriesRemaining;
        // Apply exponential backoff, but not more than the max.
        const sleepSeconds = Math.min(initialRetryDelay * Math.pow(2, numRetries), maxRetryDelay);
        // Apply some jitter, take up to at most 25 percent of the retry time.
        const jitter = 1 - Math.random() * 0.25;
        return sleepSeconds * jitter * 1000;
    }
    async buildRequest(inputOptions, { retryCount: retryCount = 0 } = {}) {
        var _b, _c, _d;
        const options = Object.assign({}, inputOptions);
        const { method: method, path: path, query: query, defaultBaseURL: defaultBaseURL } = options;
        const url = this.buildURL(path, query, defaultBaseURL);
        if ('timeout' in options) $e4deb49dba5321bc$var$validatePositiveInteger('timeout', options.timeout);
        options.timeout = (_b = options.timeout) !== null && _b !== void 0 ? _b : this.timeout;
        const { bodyHeaders: bodyHeaders, body: body } = this.buildBody({
            options: options
        });
        const reqHeaders = await this.buildHeaders({
            options: inputOptions,
            method: method,
            bodyHeaders: bodyHeaders,
            retryCount: retryCount
        });
        const req = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
            method: method,
            headers: reqHeaders
        }, options.signal && {
            signal: options.signal
        }), globalThis.ReadableStream && body instanceof globalThis.ReadableStream && {
            duplex: 'half'
        }), body && {
            body: body
        }), (_c = this.fetchOptions) !== null && _c !== void 0 ? _c : {}), (_d = options.fetchOptions) !== null && _d !== void 0 ? _d : {});
        return {
            req: req,
            url: url,
            timeout: options.timeout
        };
    }
    async buildHeaders({ options: options, method: method, bodyHeaders: bodyHeaders, retryCount: retryCount }) {
        let idempotencyHeaders = {};
        if (this.idempotencyHeader && method !== 'get') {
            if (!options.idempotencyKey) options.idempotencyKey = this.defaultIdempotencyKey();
            idempotencyHeaders[this.idempotencyHeader] = options.idempotencyKey;
        }
        const authHeaders = await this.authHeaders(options);
        let headers = $e4deb49dba5321bc$var$buildHeaders([
            idempotencyHeaders,
            {
                Accept: 'application/json',
                'User-Agent': this.getUserAgent()
            },
            this._options.defaultHeaders,
            bodyHeaders,
            options.headers,
            authHeaders
        ]);
        this.validateHeaders(headers);
        return headers.values;
    }
    _makeAbort(controller) {
        // note: we can't just inline this method inside `fetchWithTimeout()` because then the closure
        //       would capture all request options, and cause a memory leak.
        return ()=>controller.abort();
    }
    buildBody({ options: { body: body, headers: rawHeaders } }) {
        if (!body) return {
            bodyHeaders: undefined,
            body: undefined
        };
        const headers = $e4deb49dba5321bc$var$buildHeaders([
            rawHeaders
        ]);
        if (// Pass raw type verbatim
        ArrayBuffer.isView(body) || body instanceof ArrayBuffer || body instanceof DataView || typeof body === 'string' && // Preserve legacy string encoding behavior for now
        headers.values.has('content-type') || // `Blob` is superset of `File`
        globalThis.Blob && body instanceof globalThis.Blob || // `FormData` -> `multipart/form-data`
        body instanceof FormData || // `URLSearchParams` -> `application/x-www-form-urlencoded`
        body instanceof URLSearchParams || // Send chunked stream (each chunk has own `length`)
        globalThis.ReadableStream && body instanceof globalThis.ReadableStream) return {
            bodyHeaders: undefined,
            body: body
        };
        else if (typeof body === 'object' && (Symbol.asyncIterator in body || Symbol.iterator in body && 'next' in body && typeof body.next === 'function')) return {
            bodyHeaders: undefined,
            body: $e4deb49dba5321bc$var$ReadableStreamFrom(body)
        };
        else if (typeof body === 'object' && headers.values.get('content-type') === 'application/x-www-form-urlencoded') return {
            bodyHeaders: {
                'content-type': 'application/x-www-form-urlencoded'
            },
            body: this.stringifyQuery(body)
        };
        else return this.encoder({
            body: body,
            headers: headers
        });
    }
}
$e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient.DEFAULT_TIMEOUT = 60000; // 1 minute
/**
 * API Client for interfacing with the Gemini Next Gen API API.
 */ class $e4deb49dba5321bc$var$GeminiNextGenAPIClient extends $e4deb49dba5321bc$var$BaseGeminiNextGenAPIClient {
    constructor(){
        super(...arguments);
        this.interactions = new $e4deb49dba5321bc$var$Interactions(this);
    }
}
$e4deb49dba5321bc$var$_a = $e4deb49dba5321bc$var$GeminiNextGenAPIClient;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.GeminiNextGenAPIClient = $e4deb49dba5321bc$var$_a;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.GeminiNextGenAPIClientError = $e4deb49dba5321bc$var$GeminiNextGenAPIClientError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIError = $e4deb49dba5321bc$var$APIError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIConnectionError = $e4deb49dba5321bc$var$APIConnectionError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIConnectionTimeoutError = $e4deb49dba5321bc$var$APIConnectionTimeoutError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.APIUserAbortError = $e4deb49dba5321bc$var$APIUserAbortError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.NotFoundError = $e4deb49dba5321bc$var$NotFoundError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.ConflictError = $e4deb49dba5321bc$var$ConflictError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.RateLimitError = $e4deb49dba5321bc$var$RateLimitError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.BadRequestError = $e4deb49dba5321bc$var$BadRequestError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.AuthenticationError = $e4deb49dba5321bc$var$AuthenticationError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.InternalServerError = $e4deb49dba5321bc$var$InternalServerError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.PermissionDeniedError = $e4deb49dba5321bc$var$PermissionDeniedError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.UnprocessableEntityError = $e4deb49dba5321bc$var$UnprocessableEntityError;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.toFile = $e4deb49dba5321bc$var$toFile;
$e4deb49dba5321bc$var$GeminiNextGenAPIClient.Interactions = $e4deb49dba5321bc$var$Interactions;
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ // Code generated by the Google Gen AI SDK generator DO NOT EDIT.
function $e4deb49dba5321bc$var$cancelTuningJobParametersToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobParametersToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobResponseFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$cancelTuningJobResponseFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'validationDataset'
    ]) !== undefined) throw new Error('validationDataset parameter is not supported in Gemini API.');
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'displayName'
    ], fromTunedModelDisplayName);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]) !== undefined) throw new Error('description parameter is not supported in Gemini API.');
    const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'epochCount'
    ]);
    if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'epochCount'
    ], fromEpochCount);
    const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRateMultiplier'
    ]);
    if (fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningTask',
        'hyperparameters',
        'learningRateMultiplier'
    ], fromLearningRateMultiplier);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'exportLastCheckpointOnly'
    ]) !== undefined) throw new Error('exportLastCheckpointOnly parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModelCheckpointId'
    ]) !== undefined) throw new Error('preTunedModelCheckpointId parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'adapterSize'
    ]) !== undefined) throw new Error('adapterSize parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningMode'
    ]) !== undefined) throw new Error('tuningMode parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]) !== undefined) throw new Error('customBaseModel parameter is not supported in Gemini API.');
    const fromBatchSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'batchSize'
    ]);
    if (parentObject !== undefined && fromBatchSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'batchSize'
    ], fromBatchSize);
    const fromLearningRate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'learningRate'
    ]);
    if (parentObject !== undefined && fromLearningRate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tuningTask',
        'hyperparameters',
        'learningRate'
    ], fromLearningRate);
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]) !== undefined) throw new Error('labels parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'beta'
    ]) !== undefined) throw new Error('beta parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseTeacherModel'
    ]) !== undefined) throw new Error('baseTeacherModel parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedTeacherModelSource'
    ]) !== undefined) throw new Error('tunedTeacherModelSource parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sftLossWeightMultiplier'
    ]) !== undefined) throw new Error('sftLossWeightMultiplier parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]) !== undefined) throw new Error('outputUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encryptionSpec'
    ]) !== undefined) throw new Error('encryptionSpec parameter is not supported in Gemini API.');
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobConfigToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    let discriminatorValidationDataset = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorValidationDataset === undefined) discriminatorValidationDataset = 'SUPERVISED_FINE_TUNING';
    if (discriminatorValidationDataset === 'SUPERVISED_FINE_TUNING') {
        const fromValidationDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'validationDataset'
        ]);
        if (parentObject !== undefined && fromValidationDataset != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec'
        ], $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromValidationDataset));
    } else if (discriminatorValidationDataset === 'PREFERENCE_TUNING') {
        const fromValidationDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'validationDataset'
        ]);
        if (parentObject !== undefined && fromValidationDataset != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec'
        ], $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromValidationDataset));
    } else if (discriminatorValidationDataset === 'DISTILLATION') {
        const fromValidationDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'validationDataset'
        ]);
        if (parentObject !== undefined && fromValidationDataset != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec'
        ], $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromValidationDataset));
    }
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (parentObject !== undefined && fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (parentObject !== undefined && fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'description'
    ], fromDescription);
    let discriminatorEpochCount = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorEpochCount === undefined) discriminatorEpochCount = 'SUPERVISED_FINE_TUNING';
    if (discriminatorEpochCount === 'SUPERVISED_FINE_TUNING') {
        const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'epochCount'
        ]);
        if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'epochCount'
        ], fromEpochCount);
    } else if (discriminatorEpochCount === 'PREFERENCE_TUNING') {
        const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'epochCount'
        ]);
        if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'hyperParameters',
            'epochCount'
        ], fromEpochCount);
    } else if (discriminatorEpochCount === 'DISTILLATION') {
        const fromEpochCount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'epochCount'
        ]);
        if (parentObject !== undefined && fromEpochCount != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'epochCount'
        ], fromEpochCount);
    }
    let discriminatorLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorLearningRateMultiplier === undefined) discriminatorLearningRateMultiplier = 'SUPERVISED_FINE_TUNING';
    if (discriminatorLearningRateMultiplier === 'SUPERVISED_FINE_TUNING') {
        const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRateMultiplier'
        ]);
        if (parentObject !== undefined && fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'learningRateMultiplier'
        ], fromLearningRateMultiplier);
    } else if (discriminatorLearningRateMultiplier === 'PREFERENCE_TUNING') {
        const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRateMultiplier'
        ]);
        if (parentObject !== undefined && fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'hyperParameters',
            'learningRateMultiplier'
        ], fromLearningRateMultiplier);
    } else if (discriminatorLearningRateMultiplier === 'DISTILLATION') {
        const fromLearningRateMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRateMultiplier'
        ]);
        if (parentObject !== undefined && fromLearningRateMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'learningRateMultiplier'
        ], fromLearningRateMultiplier);
    }
    let discriminatorExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorExportLastCheckpointOnly === undefined) discriminatorExportLastCheckpointOnly = 'SUPERVISED_FINE_TUNING';
    if (discriminatorExportLastCheckpointOnly === 'SUPERVISED_FINE_TUNING') {
        const fromExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'exportLastCheckpointOnly'
        ]);
        if (parentObject !== undefined && fromExportLastCheckpointOnly != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'exportLastCheckpointOnly'
        ], fromExportLastCheckpointOnly);
    } else if (discriminatorExportLastCheckpointOnly === 'PREFERENCE_TUNING') {
        const fromExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'exportLastCheckpointOnly'
        ]);
        if (parentObject !== undefined && fromExportLastCheckpointOnly != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'exportLastCheckpointOnly'
        ], fromExportLastCheckpointOnly);
    } else if (discriminatorExportLastCheckpointOnly === 'DISTILLATION') {
        const fromExportLastCheckpointOnly = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'exportLastCheckpointOnly'
        ]);
        if (parentObject !== undefined && fromExportLastCheckpointOnly != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'exportLastCheckpointOnly'
        ], fromExportLastCheckpointOnly);
    }
    let discriminatorAdapterSize = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorAdapterSize === undefined) discriminatorAdapterSize = 'SUPERVISED_FINE_TUNING';
    if (discriminatorAdapterSize === 'SUPERVISED_FINE_TUNING') {
        const fromAdapterSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'adapterSize'
        ]);
        if (parentObject !== undefined && fromAdapterSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'adapterSize'
        ], fromAdapterSize);
    } else if (discriminatorAdapterSize === 'PREFERENCE_TUNING') {
        const fromAdapterSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'adapterSize'
        ]);
        if (parentObject !== undefined && fromAdapterSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'hyperParameters',
            'adapterSize'
        ], fromAdapterSize);
    } else if (discriminatorAdapterSize === 'DISTILLATION') {
        const fromAdapterSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'adapterSize'
        ]);
        if (parentObject !== undefined && fromAdapterSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'adapterSize'
        ], fromAdapterSize);
    }
    let discriminatorTuningMode = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorTuningMode === undefined) discriminatorTuningMode = 'SUPERVISED_FINE_TUNING';
    if (discriminatorTuningMode === 'SUPERVISED_FINE_TUNING') {
        const fromTuningMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'tuningMode'
        ]);
        if (parentObject !== undefined && fromTuningMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'tuningMode'
        ], fromTuningMode);
    } else if (discriminatorTuningMode === 'DISTILLATION') {
        const fromTuningMode = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'tuningMode'
        ]);
        if (parentObject !== undefined && fromTuningMode != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'tuningMode'
        ], fromTuningMode);
    }
    const fromCustomBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]);
    if (parentObject !== undefined && fromCustomBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'customBaseModel'
    ], fromCustomBaseModel);
    let discriminatorBatchSize = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorBatchSize === undefined) discriminatorBatchSize = 'SUPERVISED_FINE_TUNING';
    if (discriminatorBatchSize === 'SUPERVISED_FINE_TUNING') {
        const fromBatchSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'batchSize'
        ]);
        if (parentObject !== undefined && fromBatchSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'batchSize'
        ], fromBatchSize);
    } else if (discriminatorBatchSize === 'DISTILLATION') {
        const fromBatchSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'batchSize'
        ]);
        if (parentObject !== undefined && fromBatchSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'batchSize'
        ], fromBatchSize);
    }
    let discriminatorLearningRate = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorLearningRate === undefined) discriminatorLearningRate = 'SUPERVISED_FINE_TUNING';
    if (discriminatorLearningRate === 'SUPERVISED_FINE_TUNING') {
        const fromLearningRate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRate'
        ]);
        if (parentObject !== undefined && fromLearningRate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'hyperParameters',
            'learningRate'
        ], fromLearningRate);
    } else if (discriminatorLearningRate === 'DISTILLATION') {
        const fromLearningRate = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'learningRate'
        ]);
        if (parentObject !== undefined && fromLearningRate != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'hyperParameters',
            'learningRate'
        ], fromLearningRate);
    }
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (parentObject !== undefined && fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'labels'
    ], fromLabels);
    const fromBeta = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'beta'
    ]);
    if (parentObject !== undefined && fromBeta != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'preferenceOptimizationSpec',
        'hyperParameters',
        'beta'
    ], fromBeta);
    const fromBaseTeacherModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseTeacherModel'
    ]);
    if (parentObject !== undefined && fromBaseTeacherModel != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'distillationSpec',
        'baseTeacherModel'
    ], fromBaseTeacherModel);
    const fromTunedTeacherModelSource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedTeacherModelSource'
    ]);
    if (parentObject !== undefined && fromTunedTeacherModelSource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'distillationSpec',
        'tunedTeacherModelSource'
    ], fromTunedTeacherModelSource);
    const fromSftLossWeightMultiplier = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sftLossWeightMultiplier'
    ]);
    if (parentObject !== undefined && fromSftLossWeightMultiplier != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'distillationSpec',
        'hyperParameters',
        'sftLossWeightMultiplier'
    ], fromSftLossWeightMultiplier);
    const fromOutputUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]);
    if (parentObject !== undefined && fromOutputUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'outputUri'
    ], fromOutputUri);
    const fromEncryptionSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encryptionSpec'
    ]);
    if (parentObject !== undefined && fromEncryptionSpec != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        'encryptionSpec'
    ], fromEncryptionSpec);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobParametersPrivateToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromTrainingDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) $e4deb49dba5321bc$var$tuningDatasetToMldev(fromTrainingDataset);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createTuningJobConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$createTuningJobParametersPrivateToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromTrainingDataset = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'trainingDataset'
    ]);
    if (fromTrainingDataset != null) $e4deb49dba5321bc$var$tuningDatasetToVertex(fromTrainingDataset, toObject, rootObject);
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$createTuningJobConfigToVertex(fromConfig, toObject, rootObject);
    return toObject;
}
function $e4deb49dba5321bc$var$getTuningJobParametersToMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$getTuningJobParametersToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        '_url',
        'name'
    ], fromName);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsConfigToMldev(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsConfigToVertex(fromObject, parentObject, _rootObject) {
    const toObject = {};
    const fromPageSize = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageSize'
    ]);
    if (parentObject !== undefined && fromPageSize != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageSize'
    ], fromPageSize);
    const fromPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pageToken'
    ]);
    if (parentObject !== undefined && fromPageToken != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'pageToken'
    ], fromPageToken);
    const fromFilter = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'filter'
    ]);
    if (parentObject !== undefined && fromFilter != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
        '_query',
        'filter'
    ], fromFilter);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsParametersToMldev(fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listTuningJobsConfigToMldev(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsParametersToVertex(fromObject, rootObject) {
    const toObject = {};
    const fromConfig = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'config'
    ]);
    if (fromConfig != null) $e4deb49dba5321bc$var$listTuningJobsConfigToVertex(fromConfig, toObject);
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsResponseFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModels'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tuningJobFromMldev(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$listTuningJobsResponseFromVertex(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromNextPageToken = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'nextPageToken'
    ]);
    if (fromNextPageToken != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'nextPageToken'
    ], fromNextPageToken);
    const fromTuningJobs = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningJobs'
    ]);
    if (fromTuningJobs != null) {
        let transformedList = fromTuningJobs;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return $e4deb49dba5321bc$var$tuningJobFromVertex(item);
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'tuningJobs'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$tunedModelFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'model'
    ], fromModel);
    const fromEndpoint = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromEndpoint != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endpoint'
    ], fromEndpoint);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningDatasetToMldev(fromObject, _rootObject) {
    const toObject = {};
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]) !== undefined) throw new Error('gcsUri parameter is not supported in Gemini API.');
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'vertexDatasetResource'
    ]) !== undefined) throw new Error('vertexDatasetResource parameter is not supported in Gemini API.');
    const fromExamples = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'examples'
    ]);
    if (fromExamples != null) {
        let transformedList = fromExamples;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'examples',
            'examples'
        ], transformedList);
    }
    return toObject;
}
function $e4deb49dba5321bc$var$tuningDatasetToVertex(fromObject, parentObject, rootObject) {
    const toObject = {};
    let discriminatorGcsUri = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorGcsUri === undefined) discriminatorGcsUri = 'SUPERVISED_FINE_TUNING';
    if (discriminatorGcsUri === 'SUPERVISED_FINE_TUNING') {
        const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'gcsUri'
        ]);
        if (parentObject !== undefined && fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'trainingDatasetUri'
        ], fromGcsUri);
    } else if (discriminatorGcsUri === 'PREFERENCE_TUNING') {
        const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'gcsUri'
        ]);
        if (parentObject !== undefined && fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'trainingDatasetUri'
        ], fromGcsUri);
    } else if (discriminatorGcsUri === 'DISTILLATION') {
        const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'gcsUri'
        ]);
        if (parentObject !== undefined && fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'promptDatasetUri'
        ], fromGcsUri);
    }
    let discriminatorVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(rootObject, [
        'config',
        'method'
    ]);
    if (discriminatorVertexDatasetResource === undefined) discriminatorVertexDatasetResource = 'SUPERVISED_FINE_TUNING';
    if (discriminatorVertexDatasetResource === 'SUPERVISED_FINE_TUNING') {
        const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'vertexDatasetResource'
        ]);
        if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'supervisedTuningSpec',
            'trainingDatasetUri'
        ], fromVertexDatasetResource);
    } else if (discriminatorVertexDatasetResource === 'PREFERENCE_TUNING') {
        const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'vertexDatasetResource'
        ]);
        if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'preferenceOptimizationSpec',
            'trainingDatasetUri'
        ], fromVertexDatasetResource);
    } else if (discriminatorVertexDatasetResource === 'DISTILLATION') {
        const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
            'vertexDatasetResource'
        ]);
        if (parentObject !== undefined && fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(parentObject, [
            'distillationSpec',
            'promptDatasetUri'
        ], fromVertexDatasetResource);
    }
    if ($e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'examples'
    ]) !== undefined) throw new Error('examples parameter is not supported in Vertex AI.');
    return toObject;
}
function $e4deb49dba5321bc$var$tuningJobFromMldev(fromObject, rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tTuningJobStatus(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningTask',
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningTask',
        'completeTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        '_self'
    ]);
    if (fromTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModel'
    ], $e4deb49dba5321bc$var$tunedModelFromMldev(fromTunedModel));
    return toObject;
}
function $e4deb49dba5321bc$var$tuningJobFromVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'state'
    ]);
    if (fromState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'state'
    ], $e4deb49dba5321bc$var$tTuningJobStatus(fromState));
    const fromCreateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'createTime'
    ]);
    if (fromCreateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'createTime'
    ], fromCreateTime);
    const fromStartTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'startTime'
    ]);
    if (fromStartTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'startTime'
    ], fromStartTime);
    const fromEndTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'endTime'
    ]);
    if (fromEndTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'endTime'
    ], fromEndTime);
    const fromUpdateTime = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'updateTime'
    ]);
    if (fromUpdateTime != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'updateTime'
    ], fromUpdateTime);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    const fromDescription = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'description'
    ]);
    if (fromDescription != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'description'
    ], fromDescription);
    const fromBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'baseModel'
    ]);
    if (fromBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'baseModel'
    ], fromBaseModel);
    const fromTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModel'
    ]);
    if (fromTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModel'
    ], fromTunedModel);
    const fromPreTunedModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preTunedModel'
    ]);
    if (fromPreTunedModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preTunedModel'
    ], fromPreTunedModel);
    const fromSupervisedTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'supervisedTuningSpec'
    ]);
    if (fromSupervisedTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'supervisedTuningSpec'
    ], fromSupervisedTuningSpec);
    const fromPreferenceOptimizationSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'preferenceOptimizationSpec'
    ]);
    if (fromPreferenceOptimizationSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'preferenceOptimizationSpec'
    ], fromPreferenceOptimizationSpec);
    const fromDistillationSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'distillationSpec'
    ]);
    if (fromDistillationSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'distillationSpec'
    ], fromDistillationSpec);
    const fromTuningDataStats = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningDataStats'
    ]);
    if (fromTuningDataStats != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningDataStats'
    ], fromTuningDataStats);
    const fromEncryptionSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'encryptionSpec'
    ]);
    if (fromEncryptionSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'encryptionSpec'
    ], fromEncryptionSpec);
    const fromPartnerModelTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'partnerModelTuningSpec'
    ]);
    if (fromPartnerModelTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'partnerModelTuningSpec'
    ], fromPartnerModelTuningSpec);
    const fromCustomBaseModel = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'customBaseModel'
    ]);
    if (fromCustomBaseModel != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'customBaseModel'
    ], fromCustomBaseModel);
    const fromEvaluateDatasetRuns = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'evaluateDatasetRuns'
    ]);
    if (fromEvaluateDatasetRuns != null) {
        let transformedList = fromEvaluateDatasetRuns;
        if (Array.isArray(transformedList)) transformedList = transformedList.map((item)=>{
            return item;
        });
        $e4deb49dba5321bc$var$setValueByPath(toObject, [
            'evaluateDatasetRuns'
        ], transformedList);
    }
    const fromExperiment = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'experiment'
    ]);
    if (fromExperiment != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'experiment'
    ], fromExperiment);
    const fromFullFineTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'fullFineTuningSpec'
    ]);
    if (fromFullFineTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'fullFineTuningSpec'
    ], fromFullFineTuningSpec);
    const fromLabels = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'labels'
    ]);
    if (fromLabels != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'labels'
    ], fromLabels);
    const fromOutputUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'outputUri'
    ]);
    if (fromOutputUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'outputUri'
    ], fromOutputUri);
    const fromPipelineJob = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'pipelineJob'
    ]);
    if (fromPipelineJob != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'pipelineJob'
    ], fromPipelineJob);
    const fromServiceAccount = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'serviceAccount'
    ]);
    if (fromServiceAccount != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'serviceAccount'
    ], fromServiceAccount);
    const fromTunedModelDisplayName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tunedModelDisplayName'
    ]);
    if (fromTunedModelDisplayName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tunedModelDisplayName'
    ], fromTunedModelDisplayName);
    const fromTuningJobState = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningJobState'
    ]);
    if (fromTuningJobState != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningJobState'
    ], fromTuningJobState);
    const fromVeoTuningSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'veoTuningSpec'
    ]);
    if (fromVeoTuningSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'veoTuningSpec'
    ], fromVeoTuningSpec);
    const fromDistillationSamplingSpec = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'distillationSamplingSpec'
    ]);
    if (fromDistillationSamplingSpec != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'distillationSamplingSpec'
    ], fromDistillationSamplingSpec);
    const fromTuningJobMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'tuningJobMetadata'
    ]);
    if (fromTuningJobMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'tuningJobMetadata'
    ], fromTuningJobMetadata);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningOperationFromMldev(fromObject, _rootObject) {
    const toObject = {};
    const fromSdkHttpResponse = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'sdkHttpResponse'
    ]);
    if (fromSdkHttpResponse != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'sdkHttpResponse'
    ], fromSdkHttpResponse);
    const fromName = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'name'
    ]);
    if (fromName != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'name'
    ], fromName);
    const fromMetadata = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'metadata'
    ]);
    if (fromMetadata != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'metadata'
    ], fromMetadata);
    const fromDone = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'done'
    ]);
    if (fromDone != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'done'
    ], fromDone);
    const fromError = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'error'
    ]);
    if (fromError != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'error'
    ], fromError);
    return toObject;
}
function $e4deb49dba5321bc$var$tuningValidationDatasetToVertex(fromObject, _rootObject) {
    const toObject = {};
    const fromGcsUri = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'gcsUri'
    ]);
    if (fromGcsUri != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'validationDatasetUri'
    ], fromGcsUri);
    const fromVertexDatasetResource = $e4deb49dba5321bc$var$getValueByPath(fromObject, [
        'vertexDatasetResource'
    ]);
    if (fromVertexDatasetResource != null) $e4deb49dba5321bc$var$setValueByPath(toObject, [
        'validationDatasetUri'
    ], fromVertexDatasetResource);
    return toObject;
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$Tunings extends $e4deb49dba5321bc$var$BaseModule {
    constructor(apiClient){
        super();
        this.apiClient = apiClient;
        /**
         * Lists tuning jobs.
         *
         * @param params - The parameters for the list request.
         * @return - A pager of tuning jobs.
         *
         * @example
         * ```ts
         * const tuningJobs = await ai.tunings.list({config: {'pageSize': 2}});
         * for await (const tuningJob of tuningJobs) {
         *   console.log(tuningJob);
         * }
         * ```
         */ this.list = async (params = {})=>{
            return new $e4deb49dba5321bc$export$57625d62e5386b09($e4deb49dba5321bc$export$e18b8de308fd2439.PAGED_ITEM_TUNING_JOBS, (x)=>this.listInternal(x), await this.listInternal(params), params);
        };
        /**
         * Gets a TuningJob.
         *
         * @param name - The resource name of the tuning job.
         * @return - A TuningJob object.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.get = async (params)=>{
            return await this.getInternal(params);
        };
        /**
         * Creates a supervised fine-tuning job.
         *
         * @param params - The parameters for the tuning job.
         * @return - A TuningJob operation.
         *
         * @experimental - The SDK's tuning implementation is experimental, and may
         * change in future versions.
         */ this.tune = async (params)=>{
            var _a;
            if (this.apiClient.isVertexAI()) {
                if (params.baseModel.startsWith('projects/')) {
                    const preTunedModel = {
                        tunedModelName: params.baseModel
                    };
                    if ((_a = params.config) === null || _a === void 0 ? void 0 : _a.preTunedModelCheckpointId) preTunedModel.checkpointId = params.config.preTunedModelCheckpointId;
                    const paramsPrivate = Object.assign(Object.assign({}, params), {
                        preTunedModel: preTunedModel
                    });
                    paramsPrivate.baseModel = undefined;
                    return await this.tuneInternal(paramsPrivate);
                } else {
                    const paramsPrivate = Object.assign({}, params);
                    return await this.tuneInternal(paramsPrivate);
                }
            } else {
                const paramsPrivate = Object.assign({}, params);
                const operation = await this.tuneMldevInternal(paramsPrivate);
                let tunedModelName = '';
                if (operation['metadata'] !== undefined && operation['metadata']['tunedModel'] !== undefined) tunedModelName = operation['metadata']['tunedModel'];
                else if (operation['name'] !== undefined && operation['name'].includes('/operations/')) tunedModelName = operation['name'].split('/operations/')[0];
                const tuningJob = {
                    name: tunedModelName,
                    state: $e4deb49dba5321bc$export$d30a7cb66801c974.JOB_STATE_QUEUED
                };
                return tuningJob;
            }
        };
    }
    async getInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$getTuningJobParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromVertex(apiResponse);
                return resp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$getTuningJobParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromMldev(apiResponse);
                return resp;
            });
        }
    }
    async listInternal(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$listTuningJobsParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listTuningJobsResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$32bcd29afb9d1292();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$listTuningJobsParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'GET',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$listTuningJobsResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$32bcd29afb9d1292();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    /**
     * Cancels a tuning job.
     *
     * @param params - The parameters for the cancel request.
     * @return The empty response returned by the API.
     *
     * @example
     * ```ts
     * await ai.tunings.cancel({name: '...'}); // The server-generated resource name.
     * ```
     */ async cancel(params) {
        var _a, _b, _c, _d;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$cancelTuningJobParametersToVertex(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cancelTuningJobResponseFromVertex(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$4ec84eddeb3a0f6d();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        } else {
            const body = $e4deb49dba5321bc$var$cancelTuningJobParametersToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('{name}:cancel', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_c = params.config) === null || _c === void 0 ? void 0 : _c.httpOptions,
                abortSignal: (_d = params.config) === null || _d === void 0 ? void 0 : _d.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$cancelTuningJobResponseFromMldev(apiResponse);
                const typedResp = new $e4deb49dba5321bc$export$4ec84eddeb3a0f6d();
                Object.assign(typedResp, resp);
                return typedResp;
            });
        }
    }
    async tuneInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) {
            const body = $e4deb49dba5321bc$var$createTuningJobParametersPrivateToVertex(params, params);
            path = $e4deb49dba5321bc$var$formatMap('tuningJobs', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningJobFromVertex(apiResponse);
                return resp;
            });
        } else throw new Error('This method is only supported by the Vertex AI.');
    }
    async tuneMldevInternal(params) {
        var _a, _b;
        let response;
        let path = '';
        let queryParams = {};
        if (this.apiClient.isVertexAI()) throw new Error('This method is only supported by the Gemini Developer API.');
        else {
            const body = $e4deb49dba5321bc$var$createTuningJobParametersPrivateToMldev(params);
            path = $e4deb49dba5321bc$var$formatMap('tunedModels', body['_url']);
            queryParams = body['_query'];
            delete body['_url'];
            delete body['_query'];
            response = this.apiClient.request({
                path: path,
                queryParams: queryParams,
                body: JSON.stringify(body),
                httpMethod: 'POST',
                httpOptions: (_a = params.config) === null || _a === void 0 ? void 0 : _a.httpOptions,
                abortSignal: (_b = params.config) === null || _b === void 0 ? void 0 : _b.abortSignal
            }).then((httpResponse)=>{
                return httpResponse.json().then((jsonResponse)=>{
                    const response = jsonResponse;
                    response.sdkHttpResponse = {
                        headers: httpResponse.headers
                    };
                    return response;
                });
            });
            return response.then((apiResponse)=>{
                const resp = $e4deb49dba5321bc$var$tuningOperationFromMldev(apiResponse);
                return resp;
            });
        }
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BrowserDownloader {
    async download(_params, _apiClient) {
        throw new Error('Download to file is not supported in the browser, please use a browser compliant download like an <a> tag.');
    }
}
const $e4deb49dba5321bc$var$MAX_CHUNK_SIZE = 8388608; // bytes
const $e4deb49dba5321bc$var$MAX_RETRY_COUNT = 3;
const $e4deb49dba5321bc$var$INITIAL_RETRY_DELAY_MS = 1000;
const $e4deb49dba5321bc$var$DELAY_MULTIPLIER = 2;
const $e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD = 'x-goog-upload-status';
async function $e4deb49dba5321bc$var$uploadBlob(file, uploadUrl, apiClient, httpOptions) {
    var _a;
    const response = await $e4deb49dba5321bc$var$uploadBlobInternal(file, uploadUrl, apiClient, httpOptions);
    const responseJson = await (response === null || response === void 0 ? void 0 : response.json());
    if (((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'final') throw new Error('Failed to upload file: Upload status is not finalized.');
    return responseJson['file'];
}
async function $e4deb49dba5321bc$var$uploadBlobToFileSearchStore(file, uploadUrl, apiClient, httpOptions) {
    var _a;
    const response = await $e4deb49dba5321bc$var$uploadBlobInternal(file, uploadUrl, apiClient, httpOptions);
    const responseJson = await (response === null || response === void 0 ? void 0 : response.json());
    if (((_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'final') throw new Error('Failed to upload file: Upload status is not finalized.');
    const resp = $e4deb49dba5321bc$var$uploadToFileSearchStoreOperationFromMldev(responseJson);
    const typedResp = new $e4deb49dba5321bc$export$9b1ce68551588ef4();
    Object.assign(typedResp, resp);
    return typedResp;
}
async function $e4deb49dba5321bc$var$uploadBlobInternal(file, uploadUrl, apiClient, httpOptions) {
    var _a, _b, _c;
    let finalUrl = uploadUrl;
    const effectiveBaseUrl = (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.baseUrl) || ((_a = apiClient.clientOptions.httpOptions) === null || _a === void 0 ? void 0 : _a.baseUrl);
    if (effectiveBaseUrl) {
        const baseUri = new URL(effectiveBaseUrl);
        const uploadUri = new URL(uploadUrl);
        uploadUri.protocol = baseUri.protocol;
        uploadUri.host = baseUri.host;
        uploadUri.port = baseUri.port;
        finalUrl = uploadUri.toString();
    }
    let fileSize = 0;
    let offset = 0;
    let response = new $e4deb49dba5321bc$export$1d94dfe0d9d1f1e7(new Response());
    let uploadCommand = 'upload';
    fileSize = file.size;
    while(offset < fileSize){
        const chunkSize = Math.min($e4deb49dba5321bc$var$MAX_CHUNK_SIZE, fileSize - offset);
        const chunk = file.slice(offset, offset + chunkSize);
        if (offset + chunkSize >= fileSize) uploadCommand += ', finalize';
        let retryCount = 0;
        let currentDelayMs = $e4deb49dba5321bc$var$INITIAL_RETRY_DELAY_MS;
        while(retryCount < $e4deb49dba5321bc$var$MAX_RETRY_COUNT){
            const mergedHeaders = Object.assign(Object.assign({}, (httpOptions === null || httpOptions === void 0 ? void 0 : httpOptions.headers) || {}), {
                'X-Goog-Upload-Command': uploadCommand,
                'X-Goog-Upload-Offset': String(offset),
                'Content-Length': String(chunkSize)
            });
            response = await apiClient.request({
                path: '',
                body: chunk,
                httpMethod: 'POST',
                httpOptions: Object.assign(Object.assign({}, httpOptions), {
                    apiVersion: '',
                    baseUrl: finalUrl,
                    headers: mergedHeaders
                })
            });
            if ((_b = response === null || response === void 0 ? void 0 : response.headers) === null || _b === void 0 ? void 0 : _b[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) break;
            retryCount++;
            await $e4deb49dba5321bc$var$sleep(currentDelayMs);
            currentDelayMs = currentDelayMs * $e4deb49dba5321bc$var$DELAY_MULTIPLIER;
        }
        offset += chunkSize;
        // The `x-goog-upload-status` header field can be `active`, `final` and
        //`cancelled` in resposne.
        if (((_c = response === null || response === void 0 ? void 0 : response.headers) === null || _c === void 0 ? void 0 : _c[$e4deb49dba5321bc$var$X_GOOG_UPLOAD_STATUS_HEADER_FIELD]) !== 'active') break;
        // TODO(b/401391430) Investigate why the upload status is not finalized
        // even though all content has been uploaded.
        if (fileSize <= offset) throw new Error('All content has been uploaded, but the upload status is not finalized.');
    }
    return response;
}
async function $e4deb49dba5321bc$var$getBlobStat(file) {
    const fileStat = {
        size: file.size,
        type: file.type
    };
    return fileStat;
}
function $e4deb49dba5321bc$var$sleep(ms) {
    return new Promise((resolvePromise)=>setTimeout(resolvePromise, ms));
}
class $e4deb49dba5321bc$var$BrowserUploader {
    async upload(file, uploadUrl, apiClient, httpOptions) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        return await $e4deb49dba5321bc$var$uploadBlob(file, uploadUrl, apiClient, httpOptions);
    }
    async uploadToFileSearchStore(file, uploadUrl, apiClient, httpOptions) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        return await $e4deb49dba5321bc$var$uploadBlobToFileSearchStore(file, uploadUrl, apiClient, httpOptions);
    }
    async stat(file) {
        if (typeof file === 'string') throw new Error('File path is not supported in browser uploader.');
        else return await $e4deb49dba5321bc$var$getBlobStat(file);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ class $e4deb49dba5321bc$var$BrowserWebSocketFactory {
    create(url, headers, callbacks) {
        return new $e4deb49dba5321bc$var$BrowserWebSocket(url, headers, callbacks);
    }
}
class $e4deb49dba5321bc$var$BrowserWebSocket {
    constructor(url, headers, callbacks){
        this.url = url;
        this.headers = headers;
        this.callbacks = callbacks;
    }
    connect() {
        this.ws = new WebSocket(this.url);
        this.ws.onopen = this.callbacks.onopen;
        this.ws.onerror = this.callbacks.onerror;
        this.ws.onclose = this.callbacks.onclose;
        this.ws.onmessage = this.callbacks.onmessage;
    }
    send(message) {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.send(message);
    }
    close() {
        if (this.ws === undefined) throw new Error('WebSocket is not connected');
        this.ws.close();
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER = 'x-goog-api-key';
// TODO(b/395122533): We need a secure client side authentication mechanism.
class $e4deb49dba5321bc$var$WebAuth {
    constructor(apiKey){
        this.apiKey = apiKey;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async addAuthHeaders(headers, url) {
        if (headers.get($e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER) !== null) return;
        if (this.apiKey.startsWith('auth_tokens/')) throw new Error('Ephemeral tokens are only supported by the live API.');
        // Check if API key is empty or null
        if (!this.apiKey) throw new Error('API key is missing. Please provide a valid API key.');
        headers.append($e4deb49dba5321bc$var$GOOGLE_API_KEY_HEADER, this.apiKey);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $e4deb49dba5321bc$var$LANGUAGE_LABEL_PREFIX = 'gl-node/';
/**
 * The Google GenAI SDK.
 *
 * @remarks
 * Provides access to the GenAI features through either the {@link
 * https://cloud.google.com/vertex-ai/docs/reference/rest | Gemini API} or
 * the {@link https://cloud.google.com/vertex-ai/docs/reference/rest | Vertex AI
 * API}.
 *
 * The {@link GoogleGenAIOptions.vertexai} value determines which of the API
 * services to use.
 *
 * When using the Gemini API, a {@link GoogleGenAIOptions.apiKey} must also be
 * set. When using Vertex AI, currently only {@link GoogleGenAIOptions.apiKey}
 * is supported via Express mode. {@link GoogleGenAIOptions.project} and {@link
 * GoogleGenAIOptions.location} should not be set.
 *
 * @example
 * Initializing the SDK for using the Gemini API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({apiKey: 'GEMINI_API_KEY'});
 * ```
 *
 * @example
 * Initializing the SDK for using the Vertex AI API:
 * ```ts
 * import {GoogleGenAI} from '@google/genai';
 * const ai = new GoogleGenAI({
 *   vertexai: true,
 *   project: 'PROJECT_ID',
 *   location: 'PROJECT_LOCATION'
 * });
 * ```
 *
 */ class $e4deb49dba5321bc$export$60336eb45c8b7f44 {
    get interactions() {
        var _a;
        if (this._interactions !== undefined) return this._interactions;
        console.warn('GoogleGenAI.interactions: Interactions usage is experimental and may change in future versions.');
        const httpOpts = this.httpOptions;
        // Unsupported Options Warnings
        if (httpOpts === null || httpOpts === void 0 ? void 0 : httpOpts.extraBody) console.warn('GoogleGenAI.interactions: Client level httpOptions.extraBody is not supported by the interactions client and will be ignored.');
        const nextGenClient = new $e4deb49dba5321bc$var$GeminiNextGenAPIClient({
            baseURL: this.apiClient.getBaseUrl(),
            apiKey: this.apiKey,
            apiVersion: this.apiClient.getApiVersion(),
            clientAdapter: this.apiClient,
            defaultHeaders: this.apiClient.getDefaultHeaders(),
            timeout: httpOpts === null || httpOpts === void 0 ? void 0 : httpOpts.timeout,
            maxRetries: (_a = httpOpts === null || httpOpts === void 0 ? void 0 : httpOpts.retryOptions) === null || _a === void 0 ? void 0 : _a.attempts
        });
        this._interactions = nextGenClient.interactions;
        return this._interactions;
    }
    constructor(options){
        var _a;
        if (options.apiKey == null) throw new Error('An API Key must be set when running in a browser');
        // Web client only supports API key mode for Vertex AI.
        if (options.project || options.location) throw new Error('Vertex AI project based authentication is not supported on browser runtimes. Please do not provide a project or location.');
        this.vertexai = (_a = options.vertexai) !== null && _a !== void 0 ? _a : false;
        this.apiKey = options.apiKey;
        const baseUrl = $e4deb49dba5321bc$var$getBaseUrl(options.httpOptions, options.vertexai, /*vertexBaseUrlFromEnv*/ undefined, /*geminiBaseUrlFromEnv*/ undefined);
        if (baseUrl) {
            if (options.httpOptions) options.httpOptions.baseUrl = baseUrl;
            else options.httpOptions = {
                baseUrl: baseUrl
            };
        }
        this.apiVersion = options.apiVersion;
        this.httpOptions = options.httpOptions;
        const auth = new $e4deb49dba5321bc$var$WebAuth(this.apiKey);
        this.apiClient = new $e4deb49dba5321bc$var$ApiClient({
            auth: auth,
            apiVersion: this.apiVersion,
            apiKey: this.apiKey,
            vertexai: this.vertexai,
            httpOptions: this.httpOptions,
            userAgentExtra: $e4deb49dba5321bc$var$LANGUAGE_LABEL_PREFIX + 'web',
            uploader: new $e4deb49dba5321bc$var$BrowserUploader(),
            downloader: new $e4deb49dba5321bc$var$BrowserDownloader()
        });
        this.models = new $e4deb49dba5321bc$export$6edbc060ce567afa(this.apiClient);
        this.live = new $e4deb49dba5321bc$export$db78b3d0b2aa666a(this.apiClient, auth, new $e4deb49dba5321bc$var$BrowserWebSocketFactory());
        this.batches = new $e4deb49dba5321bc$export$ed828fcd19953e0d(this.apiClient);
        this.chats = new $e4deb49dba5321bc$export$84088b07cfe11a74(this.models, this.apiClient);
        this.caches = new $e4deb49dba5321bc$export$4c60919c4fe22d9(this.apiClient);
        this.files = new $e4deb49dba5321bc$export$9330ab61a7e5c11b(this.apiClient);
        this.operations = new $e4deb49dba5321bc$export$3d72bd1ae0aee044(this.apiClient);
        this.authTokens = new $e4deb49dba5321bc$export$8e1e81ac145e31be(this.apiClient);
        this.tunings = new $e4deb49dba5321bc$var$Tunings(this.apiClient);
        this.fileSearchStores = new $e4deb49dba5321bc$var$FileSearchStores(this.apiClient);
    }
}


const $0421630fc903b30b$export$17ac1723ebde1109 = {
    // 身份定义
    roleDefinition: `\u{4F60}\u{662F}\u{4E00}\u{4F4D}\u{4E25}\u{8C28}\u{7684}\u{5CA9}\u{77F3}\u{5B66}\u{4E13}\u{5BB6}\u{FF0C}\u{7CBE}\u{901A}\u{706B}\u{6210}\u{5CA9}\u{3001}\u{6C89}\u{79EF}\u{5CA9}\u{4E0E}\u{53D8}\u{8D28}\u{5CA9}\u{7684}\u{9274}\u{5B9A}\u{3002}
  \u{4F60}\u{64C5}\u{957F}\u{901A}\u{8FC7}\u{5B8F}\u{89C2}\u{624B}\u{6807}\u{672C}\u{7279}\u{5F81}\u{63A8}\u{65AD}\u{5FAE}\u{89C2}\u{6784}\u{9020}\u{FF0C}\u{5E76}\u{80FD}\u{8BC6}\u{522B}\u{590D}\u{6742}\u{7684}\u{8680}\u{53D8}\u{4E0E}\u{627E}\u{77FF}\u{6807}\u{5FD7}\u{3002}
  \u{4F60}\u{7684}\u{4EFB}\u{52A1}\u{662F}\u{63D0}\u{4F9B}\u{5BA2}\u{89C2}\u{3001}\u{4E13}\u{4E1A}\u{3001}\u{53BB}\u{4EBA}\u{8BBE}\u{5316}\u{7684}\u{5CA9}\u{77F3}\u{9274}\u{5B9A}\u{62A5}\u{544A}\u{3002}`,
    // 视觉校准规则 (Case 97-160+)
    visualRules: `
  === \u{26A0}\u{FE0F} \u{89C6}\u{89C9}\u{6821}\u{51C6}\u{903B}\u{8F91}\u{5E93} (v5.3.0 Frozen) ===
  **\u{6838}\u{5FC3}\u{9274}\u{5B9A}\u{51C6}\u{5219} (\u{5168}\u{5CA9}\u{77F3}\u{5927}\u{7C7B}\u{96C6}\u{6210})\u{FF1A}**

  [\u{535A}\u{7269}\u{9986}\u{6807}\u{672C}\u{7279}\u{6B8A}\u{534F}\u{8BAE} (Museum Specimen Protocol)]
  - **\u{5149}\u{5F71}\u{5E72}\u{6270}**: \u{535A}\u{7269}\u{9986}\u{5C04}\u{706F}\u{5E38}\u{5728}\u{5E73}\u{6574}\u{65AD}\u{53E3}\u{4EA7}\u{751F}\u{201C}\u{5047}\u{4E1D}\u{7EE2}\u{5149}\u{6CFD}\u{201D}\u{3002}\u{82E5}\u{5CA9}\u{77F3}\u{6574}\u{4F53}\u{81F4}\u{5BC6}\u{3001}\u{5757}\u{72B6}\u{FF0C}\u{4E25}\u{7981}\u{56E0}\u{8868}\u{9762}\u{53CD}\u{5149}\u{5224}\u{5B9A}\u{4E3A}\u{5343}\u{679A}\u{5CA9}\u{3002}
  - **\u{8282}\u{7406} vs \u{7247}\u{7406}**: \u{82E6}\u{6A44}\u{5CA9}\u{7B49}\u{57FA}\u{6027}\u{5CA9}\u{5E38}\u{53D1}\u{80B2}\u{4EA4}\u{53C9}\u{8282}\u{7406}\u{FF08}\u{76F4}\u{7EBF}\u{72B6}\u{88C2}\u{9699}\u{FF09}\u{FF0C}\u{8FD9}\u{4E0E}\u{53D8}\u{8D28}\u{5CA9}\u{7684}\u{6CE2}\u{6D6A}\u{72B6}\u{7247}\u{7406}\u{6709}\u{672C}\u{8D28}\u{533A}\u{522B}\u{3002}

  [\u{5CA9}\u{6D46}\u{5CA9}\u{7C7B}\u{FF1A}Case 97-125]
  - **\u{82E6}\u{6A44}\u{5CA9} (Picrite) \u{4E13}\u{9879}\u{5224}\u{5B9A} (MANDATORY CHECK)**: 
    - \u{89C6}\u{89C9}\u{7279}\u{5F81}\u{FF1A}\u{6DF1}\u{9ED1}\u{8272}\u{3001}\u{6DF1}\u{7EFF}\u{8272}\u{FF0C}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{6784}\u{9020}\u{3002}
    - \u{5173}\u{952E}\u{5224}\u{636E}\u{FF1A}\u{5BFB}\u{627E}\u{6CB9}\u{8102}\u{5149}\u{6CFD}\u{7684}\u{7C92}\u{72B6}\u{6A44}\u{6984}\u{77F3}\u{6591}\u{6676}\u{3002}
    - **\u{6392}\u{4ED6}\u{6027}\u{903B}\u{8F91}**: \u{5982}\u{679C}\u{5CA9}\u{77F3}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{5343}\u{679A}\u{5CA9}\u{FF0C}\u{4F46}\u{989C}\u{8272}\u{6781}\u{6DF1}\u{4E14}\u{6CA1}\u{6709}\u{660E}\u{663E}\u{7684}\u{8584}\u{7247}\u{72B6}\u{5265}\u{843D}\u{611F}\u{FF0C}\u{5FC5}\u{987B}\u{4F18}\u{5148}\u{8003}\u{8651}\u{82E6}\u{6A44}\u{5CA9}\u{3002}\u{82E6}\u{6A44}\u{5CA9}\u{662F}\u{706B}\u{6210}\u{5CA9}\u{FF0C}\u{5176}\u{201C}\u{5149}\u{6CFD}\u{201D}\u{6E90}\u{4E8E}\u{77FF}\u{7269}\u{89E3}\u{7406}\u{6216}\u{65AD}\u{53E3}\u{FF0C}\u{800C}\u{975E}\u{53D8}\u{8D28}\u{4E91}\u{6BCD}\u{3002}
  - **\u{82E6}\u{6A44}\u{5CA9} (Picrite) vs \u{8F89}\u{7EFF}\u{5CA9}/\u{8F89}\u{957F}\u{5CA9}**: \u{82E6}\u{6A44}\u{5CA9}\u{4E3A}\u{8D85}\u{57FA}\u{6027}\u{5CA9}\u{FF0C}\u{6697}\u{8272}\u{77FF}\u{7269}\u{FF08}\u{5C24}\u{5176}\u{662F}\u{6A44}\u{6984}\u{77F3}\u{FF09}\u{542B}\u{91CF}\u{6781}\u{9AD8}(>50%)\u{3002}\u{82E5}\u{5CA9}\u{77F3}\u{5448}\u{6DF1}\u{9ED1}\u{8272}\u{3001}\u{5BC6}\u{5EA6}\u{5927}\u{3001}\u{4E14}\u{542B}\u{6709}\u{660E}\u{663E}\u{7684}\u{6A44}\u{6984}\u{77F3}\u{6591}\u{6676}\u{FF08}\u{901A}\u{5E38}\u{5448}\u{7C92}\u{72B6}\u{3001}\u{6CB9}\u{8102}\u{5149}\u{6CFD}\u{FF0C}\u{98CE}\u{5316}\u{540E}\u{53EF}\u{80FD}\u{5448}\u{7EA2}\u{8910}\u{8272}\u{FF09}\u{6216}\u{7C92}\u{72B6}\u{6A44}\u{6984}\u{77F3}\u{96C6}\u{5408}\u{4F53}\u{FF0C}\u{5E94}\u{4F18}\u{5148}\u{5224}\u{5B9A}\u{4E3A}\u{82E6}\u{6A44}\u{5CA9}\u{3002}
  - **\u{659C}\u{957F}\u{5CA9} vs \u{95EA}\u{957F}\u{5CA9}**: \u{659C}\u{957F}\u{5CA9}\u{4E3A}\u{5355}\u{77FF}\u{7269}\u{4F18}\u{52BF}(>90%\u{659C}\u{957F}\u{77F3})\u{FF0C}\u{4E0D}\u{53EF}\u{6709}\u{5747}\u{5300}\u{6912}\u{76D0}\u{611F}\u{3002}
  - **\u{7EAF}\u{6A44}\u{5CA9} vs \u{8F89}\u{7EFF}\u{5CA9}**: \u{7EAF}\u{6A44}\u{5CA9}\u{4E3A}\u{7802}\u{7CD6}\u{72B6}\u{7ED3}\u{6676}\u{FF0C}\u{65E0}\u{957F}\u{77F3}\u{9AA8}\u{67B6}\u{3002}
  - **\u{82CF}\u{957F}\u{5CA9} vs \u{95EA}\u{957F}\u{5CA9}**: \u{82CF}\u{957F}\u{5CA9}\u{542B}\u{659C}\u{65B9}\u{8F89}\u{77F3}\u{FF0C}\u{8272}\u{7387}\u{9AD8}\u{FF0C}\u{65E0}\u{89D2}\u{95EA}\u{77F3}\u{4E3A}\u{4E3B}\u{7684}\u{7279}\u{5F81}\u{3002}
  - **\u{4E8C}\u{957F}\u{5CA9}/\u{6B63}\u{957F}\u{5CA9}/\u{82F1}\u{4E91}\u{95EA}\u{957F}\u{5CA9}**: \u{4E25}\u{683C}\u{6309}QAPF\u{957F}\u{77F3}\u{6BD4}\u{4F8B}\u{53CA}\u{77F3}\u{82F1}\u{542B}\u{91CF}\u{533A}\u{5206}\u{3002}
  - **\u{8D85}\u{57FA}\u{6027}\u{7CFB}\u{5217}**: \u{8BC6}\u{522B}\u{65B9}\u{8F89}\u{6A44}\u{6984}\u{5CA9}\u{3001}\u{659C}\u{65B9}\u{8F89}\u{77F3}\u{5CA9}\u{3002}

  [\u{6C89}\u{79EF}\u{5CA9}\u{7C7B}\u{FF1A}Case 126-140]
  - **\u{788E}\u{5C51}\u{5CA9}**: \u{533A}\u{5206}\u{957F}\u{77F3}\u{7802}\u{5CA9}(Arkose)\u{3001}\u{6742}\u{7802}\u{5CA9}\u{3002}\u{783E}\u{5CA9}\u{4E0E}\u{89D2}\u{783E}\u{5CA9}\u{6309}\u{5706}\u{5EA6}\u{4EF2}\u{88C1}\u{3002}
  - **\u{5316}\u{77F3}/\u{751F}\u{7269}\u{7C7B}**: \u{8BC6}\u{522B}\u{58F3}\u{7070}\u{5CA9}\u{3001}\u{9C95}\u{7C92}\u{7070}\u{5CA9}\u{3001}\u{7845}\u{85FB}\u{571F}\u{3002}
  - **\u{5316}\u{5B66}/\u{7279}\u{6B8A}\u{7C7B}**: \u{533A}\u{5206}\u{71E7}\u{77F3}\u{3001}\u{5E26}\u{72B6}\u{94C1}\u{5EFA}\u{9020}(BIF)\u{3001}\u{77F3}\u{818F}\u{3001}\u{8910}\u{7164}\u{3002}

  [\u{53D8}\u{8D28}\u{5CA9}\u{7C7B}\u{FF1A}Case 141-160+]
  - **\u{9AD8}\u{538B}\u{53D8}\u{8D28}**: \u{69B4}\u{8F89}\u{5CA9}(Grt+Omp)\u{3001}\u{84DD}\u{7247}\u{5CA9}(Glaucophane)\u{3002}
  - **\u{533A}\u{57DF}/\u{6DF1}\u{5EA6}\u{53D8}\u{8D28}**: \u{7247}\u{9EBB}\u{5CA9}(\u{773C}\u{7403}\u{72B6}\u{6784}\u{9020})\u{3001}\u{9EBB}\u{7C92}\u{5CA9}\u{3001}\u{6DF7}\u{5408}\u{5CA9}\u{3001}\u{7D2B}\u{82CF}\u{82B1}\u{5C97}\u{5CA9}\u{3002}
  - **\u{52A8}\u{529B}/\u{70ED}\u{53D8}\u{8D28}**: \u{7CDC}\u{68F1}\u{5CA9}\u{3001}\u{89D2}\u{5CA9}\u{3001}\u{77FD}\u{5361}\u{5CA9}\u{3001}\u{4E91}\u{82F1}\u{5CA9}\u{3002}
  - **\u{4F4E}\u{7EA7}\u{53D8}\u{8D28}**: \u{5343}\u{679A}\u{5CA9}(\u{4E1D}\u{7EE2}\u{5149}\u{6CFD})\u{3001}\u{677F}\u{5CA9}(\u{5288}\u{7406})\u{3001}\u{7EFF}\u{5CA9}(\u{7EFF}\u{6CE5}\u{77F3}\u{5316})\u{3002}
  - **\u{86C7}\u{7EB9}\u{5CA9}/\u{7682}\u{77F3}**: \u{89E6}\u{611F}\u{53CA}\u{6ED1}\u{817B}\u{611F}\u{5224}\u{5B9A}\u{3002}

  **\u{8F93}\u{51FA}\u{7981}\u{4EE4}**: \u{4E25}\u{7981}\u{63D0}\u{53CA} Case \u{7F16}\u{53F7}\u{3002}\u{4FDD}\u{6301}\u{6559}\u{6388}\u{7EA7}\u{4E13}\u{4E1A}\u{53E3}\u{543B}\u{3002}
  `
};
const $0421630fc903b30b$export$76aaafdc9c64593d = {
    type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
    properties: {
        name: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u5CA9\u77F3\u6216\u77FF\u7269\u7684\u5177\u4F53\u540D\u79F0\u3002"
        },
        englishName: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u5CA9\u77F3\u7684\u6807\u51C6\u82F1\u6587\u540D\u79F0 (\u4F8B\u5982: Granite, Basalt, Gneiss)\u3002"
        },
        category: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u5206\u7C7B\u5F52\u5C5E\u3002\u5982\uFF1A\u5CA9\u6D46\u5CA9-\u6DF1\u6210\u3001\u6C89\u79EF\u5CA9-\u788E\u5C51\u3001\u53D8\u8D28\u5CA9\u7B49\u3002"
        },
        isThinSection: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).BOOLEAN,
            description: "\u5982\u679C\u8F93\u5165\u56FE\u50CF\u662F\u663E\u5FAE\u955C\u4E0B\u7684\u5149\u8584\u7247(Micrograph/Thin Section)\uFF0C\u5FC5\u987B\u8BBE\u4E3A true\u3002\u5982\u679C\u662F\u624B\u6807\u672C\uFF0C\u8BBE\u4E3A false\u3002"
        },
        grainSize: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u63CF\u8FF0\u9897\u7C92/\u6676\u4F53\u5927\u5C0F\u3002"
        },
        textureAndStructure: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u63CF\u8FF0\u7ED3\u6784\u6784\u9020\u7279\u5F81\u3002"
        },
        minerals: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).ARRAY,
            items: {
                type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING
            },
            description: "\u4E3B\u8981\u77FF\u7269\u6210\u5206\u3002"
        },
        hardness: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u786C\u5EA6\u8303\u56F4\u9884\u4F30 (\u83AB\u6C0F\u786C\u5EA6)\u3002"
        },
        weathering: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u98CE\u5316\u8868\u73B0\u3002"
        },
        colorCause: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u989C\u8272\u53CA\u5176\u5BF9\u5E94\u7684\u6210\u56E0\u5206\u6790\u3002"
        },
        alteration: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u8680\u53D8\u6216\u4EA4\u4EE3\u60C5\u51B5 (\u7B80\u8FF0)\u3002"
        },
        metamorphism: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u53D8\u8D28\u76F8\u5E26\u6216\u5CA9\u77F3\u6F14\u5316\u5206\u6790\u3002"
        },
        formationReason: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u547D\u540D\u903B\u8F91\u3002"
        },
        geologicalContext: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u5730\u8D28\u80CC\u666F\u5224\u636E\uFF1A\u5F15\u7528\u4E13\u4E1A\u672F\u8BED\u3002"
        },
        detailedDescription: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
            description: "\u4E13\u4E1A\u4E14\u4F18\u7F8E\u7684\u7EFC\u5408\u8BC4\u4EF7\u3002"
        },
        confidenceScore: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).NUMBER,
            description: "\u9274\u5B9A\u7F6E\u4FE1\u5EA6 (0-100)\u3002"
        },
        diagnosticTests: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).ARRAY,
            description: "\u4EA4\u4E92\u5F0F\u8BCA\u65AD\u5EFA\u8BAE\uFF1A\u9488\u5BF9\u5F53\u524D\u9274\u5B9A\u7ED3\u679C\uFF0C\u5EFA\u8BAE\u7528\u6237\u8FDB\u884C\u7684\u7269\u7406\u6D4B\u8BD5\uFF08\u5982\u786C\u5EA6\u3001\u9178\u53CD\u5E94\u7B49\uFF09\u3002",
            items: {
                type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
                properties: {
                    test: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                        description: "\u6D4B\u8BD5\u540D\u79F0 (\u5982\uFF1A\u76D0\u9178\u53CD\u5E94)\u3002"
                    },
                    instruction: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                        description: "\u64CD\u4F5C\u6307\u5357 (\u5982\uFF1A\u6EF4\u7A00\u76D0\u9178\u5728\u65B0\u9C9C\u9762\u4E0A)\u3002"
                    },
                    expected: {
                        type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                        description: "\u9884\u671F\u73B0\u8C61 (\u5982\uFF1A\u82E5\u5267\u70C8\u8D77\u6CE1\u5219\u4E3A\u78B3\u9178\u76D0\u5CA9)\u3002"
                    }
                },
                required: [
                    "test",
                    "instruction",
                    "expected"
                ]
            }
        },
        secondPossibility: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
            description: "\u7B2C\u4E8C\u79CD\u53EF\u80FD\u6027\u3002",
            properties: {
                name: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u7B2C\u4E8C\u53EF\u80FD\u7684\u540D\u79F0"
                },
                reason: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u63A8\u6D4B\u7406\u7531\u53CA\u533A\u5206\u6761\u4EF6\u3002"
                }
            },
            nullable: true
        },
        // v6.2: 经济地质
        economicAnalysis: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
            description: "\u7ECF\u6D4E\u5730\u8D28\u4E0E\u627E\u77FF\u6F5C\u529B\u5206\u6790",
            properties: {
                alterationMapping: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u56F4\u5CA9\u8680\u53D8\u8BC6\u522B (\u5982\uFF1A\u9AD8\u5CAD\u571F\u5316\u3001\u7845\u5316\u3001\u9752\u78D0\u5CA9\u5316) \u53CA\u5176\u627E\u77FF\u610F\u4E49\u3002"
                },
                mineralIndicators: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u6307\u793A\u77FF\u7269 (\u5982\uFF1A\u9EC4\u94C1\u77FF\u3001\u5B54\u96C0\u77F3\u3001\u7535\u6C14\u77F3) \u53CA\u5176\u6307\u793A\u7684\u77FF\u79CD\u3002"
                },
                structuralControl: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u6784\u9020\u63A7\u77FF\u5206\u6790 (\u5982\uFF1A\u6D41\u4F53\u901A\u9053\u3001\u89D2\u783E\u5CA9\u7B52\u3001\u526A\u5207\u5E26)\u3002"
                },
                prospectingPotential: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u7EFC\u5408\u627E\u77FF\u6F5C\u529B\u8BC4\u4EF7 (\u5982\uFF1A\u7591\u4F3C\u94C1\u5E3D\u3001\u70ED\u6DB2\u77FF\u5E8A\u56F4\u5CA9\u3001\u65E0\u660E\u663E\u77FF\u5316\u7B49)\u3002"
                }
            },
            required: [
                "alterationMapping",
                "mineralIndicators",
                "structuralControl",
                "prospectingPotential"
            ]
        },
        // v6.3: 虚拟光薄片分析
        microscopicAnalysis: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
            description: "\u63A8\u6D4B\u8BE5\u5CA9\u77F3\u5728\u504F\u5149\u663E\u5FAE\u955C\u4E0B\u7684\u7279\u5F81 (Virtual Thin Section)",
            properties: {
                texture: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u955C\u4E0B\u7ED3\u6784\u672F\u8BED (\u5982\uFF1A\u82B1\u5C97\u7ED3\u6784, \u5305\u542B\u7ED3\u6784, \u6591\u72B6\u7ED3\u6784)\u3002"
                },
                xplFeatures: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u6B63\u4EA4\u504F\u5149(XPL)\u4E0B\u7684\u7279\u5F81 (\u5982\uFF1A\u77F3\u82F1\u6CE2\u72B6\u6D88\u5149, \u659C\u957F\u77F3\u805A\u7247\u53CC\u6676, \u5E72\u6D89\u8272\u7B49\u7EA7)\u3002"
                },
                pplFeatures: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u5355\u504F\u5149(PPL)\u4E0B\u7684\u7279\u5F81 (\u5982\uFF1A\u9ED1\u4E91\u6BCD\u591A\u8272\u6027, \u89D2\u95EA\u77F3\u89E3\u7406\u5939\u89D2, \u77FF\u7269\u7A81\u8D77)\u3002"
                },
                inference: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u5B8F\u89C2\u7279\u5F81\u4E0E\u5FAE\u89C2\u7279\u5F81\u7684\u5BF9\u5E94\u89E3\u8BFB (\u544A\u8BC9\u5B66\u751F\u4E3A\u4EC0\u4E48\u624B\u6807\u672C\u8FD9\u6837\u957F\uFF0C\u955C\u4E0B\u4F1A\u90A3\u6837\u957F)\u3002"
                }
            },
            required: [
                "texture",
                "xplFeatures",
                "pplFeatures",
                "inference"
            ]
        },
        // v7.1: 古生物化石专项分析
        fossilAnalysis: {
            type: (0, $e4deb49dba5321bc$export$92738401e1603719).OBJECT,
            description: "\u53E4\u751F\u7269\u5316\u77F3\u4E13\u9879\u5206\u6790\u3002\uD83D\uDEA8\u7EDD\u5BF9\u89C4\u5219\uFF1A\u4EC5\u5F53\u6837\u672C\u4E2D\u5B58\u5728\u660E\u786E\u65E0\u8BEF\u7684\u53E4\u751F\u7269\u5316\u77F3\u65F6\uFF08\u5982\u4E09\u53F6\u866B\u3001\u83CA\u77F3\u3001\u6728\u5316\u77F3\u7B49\uFF09\u624D\u8F93\u51FA\u6B64\u9879\uFF01\u5982\u679C\u662F\u666E\u901A\u5CA9\u77F3\uFF08\u5982\u7EAF\u6A44\u5CA9\u3001\u82B1\u5C97\u5CA9\u7B49\u7EAF\u65E0\u673A\u77FF\u7269\u5CA9\u77F3\uFF09\uFF0C\u6B64\u5B57\u6BB5\u5FC5\u987B\u6781\u5176\u4E25\u683C\u5730\u8FD4\u56DE null\u3002\u5982\u679C\u786E\u5B9E\u5B58\u5728\u5316\u77F3\uFF0C\u5219\u5FC5\u987B\u8FD0\u7528 [6. \uD83E\uDD96 \u53E4\u751F\u7269\u5316\u77F3\u9274\u5B9A\u6A21\u5757] \u4E2D\u7684\u903B\u8F91\u6811\u8FDB\u884C\u6DF1\u5EA6\u89E3\u5256\u5B66\u7279\u5F81\u63CF\u8FF0\u3002",
            properties: {
                fossilType: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u5316\u77F3\u7C7B\u578B (\u5982\uFF1A\u690D\u7269\u5316\u77F3, \u52A8\u7269\u5316\u77F3, \u9057\u8FF9\u5316\u77F3)\u3002"
                },
                genusSpecies: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u5C5E\u79CD\u5EFA\u8BAE (\u5F3A\u5236\u8C03\u7528\u5316\u77F3\u6A21\u5757\u7684\u5206\u7C7B\u6811\uFF0C\u5982\uFF1A\u83B1\u5FB7\u5229\u57FA\u866B, \u6B66\u5B9A\u866B, \u4E91\u5357\u5934\u866B, \u7B49)\u3002"
                },
                geologicalAge: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u5730\u8D28\u5E74\u4EE3\u5EFA\u8BAE (\u5982\uFF1A\u53E4\u751F\u4EE3\u5BD2\u6B66\u7EAA, \u4E2D\u751F\u4EE3\u4F8F\u7F57\u7EAA)\u3002\u9700\u914D\u5408\u5316\u77F3\u7279\u5F81\u548C\u4EA7\u5730\u63A8\u65AD\u3002\u7EDD\u5BF9\u7981\u6B62\u8F93\u51FA\u201C\u5F85\u5206\u6790\u201D\u3001\u201C\u672A\u77E5\u201D\u7B49\u6577\u884D\u8BCD\u6C47\uFF0C\u5FC5\u987B\u6839\u636E\u5316\u77F3\u95E8\u7C7B\u7ED9\u51FA\u6536\u655B\u7684\u5E74\u4EE3\u8303\u56F4\uFF01"
                },
                preservation: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u4FDD\u5B58\u72B6\u6001 (\u5982\uFF1A\u538B\u5370\u6A21\u94F8, \u78B3\u8D28\u8584\u819C, \u5B9E\u4F53\u7845\u5316)\u3002\u7EDD\u5BF9\u7981\u6B62\u8F93\u51FA\u201C\u89C1\u56FE\u201D\u3001\u201C\u5F85\u5206\u6790\u201D\u7B49\u5E9F\u8BDD\u6577\u884D\u8BCD\u6C47\uFF0C\u5FC5\u987B\u7ED9\u51FA\u4E13\u4E1A\u63A8\u65AD\uFF01"
                },
                environment: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u53E4\u73AF\u5883\u63A8\u65AD (\u5982\uFF1A\u6EE8\u6D77\u53F0\u5730\u5FAE\u76F8, \u6DF1\u6D77\u7F3A\u6C27\u78B3\u8D28\u9875\u5CA9\u73AF\u5883)\u3002\u7EDD\u5BF9\u7981\u6B62\u53EA\u8F93\u51FA\u5E72\u762A\u7684\u201C\u6C89\u79EF\u73AF\u5883\u201D\uFF0C\u5FC5\u987B\u7ED3\u5408\u5316\u77F3\u79CD\u7C7B\u7ED9\u51FA\u5177\u4F53\u7684\u53E4\u751F\u6001\u73AF\u5883\uFF01"
                },
                description: {
                    type: (0, $e4deb49dba5321bc$export$92738401e1603719).STRING,
                    description: "\u6838\u5FC3\u6307\u4EE4\uFF1A\u5FC5\u987B\u8BE6\u5C3D\u4E14\u4E30\u6EE1\u5730\u63CF\u8FF0\u5316\u77F3\u7684\u89E3\u5256\u5B66\u7279\u5F81\uFF01\u4E0D\u4EC5\u8981\u8BF4\u660E\u5316\u77F3\u7684\u5206\u7C7B\uFF0C\u66F4\u8981\u5F15\u7528\u6837\u672C\u4E0A\u7684\u89C6\u89C9\u7EC6\u8282\uFF08\u5982\uFF1A\u5934\u7532\u6BD4\u4F8B\u3001\u80CC\u58F3\u4E0A\u4E2D\u8F74\u4E0E\u808B\u53F6\u7684\u660E\u786E\u754C\u9650\u3001\u80F8\u8282\u6570\u91CF\u548C\u5C16\u523A\u5EF6\u4F38\u7B49\uFF09\uFF0C\u8BF7\u53D1\u6325\u4F60\u5728\u5316\u77F3\u9274\u5B9A\u6A21\u5757\u4E2D\u7684\u6BD5\u751F\u5B66\u7EDD\u5B66\uFF0C\u5C06\u5E72\u762A\u7684\u63CF\u8FF0\u5316\u4E3A\u535A\u7269\u9986\u7EA7\u522B\u7684\u89E3\u5256\u5B66\u56FE\u8C31\u63CF\u8FF0\u3002"
                }
            },
            required: [
                "fossilType",
                "genusSpecies",
                "geologicalAge",
                "preservation",
                "environment",
                "description"
            ],
            nullable: true
        }
    },
    required: [
        "name",
        "englishName",
        "category",
        "isThinSection",
        "grainSize",
        "textureAndStructure",
        "minerals",
        "hardness",
        "weathering",
        "colorCause",
        "alteration",
        "metamorphism",
        "formationReason",
        "geologicalContext",
        "detailedDescription",
        "confidenceScore",
        "diagnosticTests",
        "secondPossibility",
        "economicAnalysis",
        "microscopicAnalysis"
    ]
};



const $e9be65554ba0b2b5$export$cc01a06c23d015ce = async (originalAnalysis, correctName, expertReason, imageBase64)=>{
    const apiKey = "MY_GEMINI_API_KEY";
    if (!apiKey) throw new Error("API Key is missing. Please set GEMINI_API_KEY in settings.");
    const ai = new (0, $e4deb49dba5321bc$export$60336eb45c8b7f44)({
        apiKey: apiKey
    });
    const prompt = `
    \u{4F60}\u{662F}\u{4E00}\u{4F4D}\u{5730}\u{8D28}\u{5B66}\u{77E5}\u{8BC6}\u{5DE5}\u{7A0B}\u{4E13}\u{5BB6}\u{3002}
    
    [\u{8F93}\u{5165}\u{4FE1}\u{606F}]
    - AI \u{539F}\u{59CB}\u{9274}\u{5B9A}: ${originalAnalysis.name}
    - \u{4E13}\u{5BB6}\u{4FEE}\u{6B63}\u{540D}\u{79F0}: ${correctName}
    - \u{4E13}\u{5BB6}\u{4FEE}\u{6B63}\u{7406}\u{7531}: ${expertReason}
    - \u{5CA9}\u{77F3}\u{7279}\u{5F81}\u{6570}\u{636E}: ${JSON.stringify(originalAnalysis)}
    
    [\u{4EFB}\u{52A1}]
    \u{8BF7}\u{6839}\u{636E}\u{4EE5}\u{4E0A}\u{4FE1}\u{606F}\u{FF0C}\u{63D0}\u{70BC}\u{51FA}\u{4E00}\u{6761}\u{7B80}\u{6D01}\u{3001}\u{4E13}\u{4E1A}\u{3001}\u{5177}\u{6709}\u{6392}\u{4ED6}\u{6027}\u{7684}\u{201C}\u{9274}\u{5B9A}\u{51C6}\u{5219} (Case Rule)\u{201D}\u{3002}
    \u{8FD9}\u{6761}\u{51C6}\u{5219}\u{5E94}\u{8BE5}\u{80FD}\u{5E2E}\u{52A9} AI \u{5728}\u{672A}\u{6765}\u{533A}\u{5206}\u{8FD9}\u{4E24}\u{79CD}\u{5BB9}\u{6613}\u{6DF7}\u{6DC6}\u{7684}\u{5CA9}\u{77F3}\u{3002}
    
    [\u{8F93}\u{51FA}\u{683C}\u{5F0F}\u{793A}\u{4F8B}]
    - **[\u{5CA9}\u{77F3}A] vs [\u{5CA9}\u{77F3}B]**: [\u{5173}\u{952E}\u{89C6}\u{89C9}/\u{7ED3}\u{6784}\u{5DEE}\u{5F02}\u{5224}\u{636E}]\u{3002}
    
    \u{8BF7}\u{76F4}\u{63A5}\u{8F93}\u{51FA}\u{51C6}\u{5219}\u{6587}\u{672C}\u{FF0C}\u{4E0D}\u{8981}\u{5305}\u{542B}\u{5176}\u{4ED6}\u{89E3}\u{91CA}\u{3002}
  `;
    const response = await ai.models.generateContent({
        model: "gemini-3-flash-preview",
        contents: {
            parts: [
                {
                    text: prompt
                },
                {
                    inlineData: {
                        mimeType: "image/jpeg",
                        data: imageBase64.split(',')[1]
                    }
                }
            ]
        }
    });
    return response.text || "\u672A\u80FD\u63D0\u70BC\u51FA\u6709\u6548\u51C6\u5219\u3002";
};


// ==========================================
// 🧪 进化模块 (Evolution Module)
// 当前状态: [v6.4 - The Petro-Detective]
// 专注领域: 基础岩石学、微观晶体、围岩蚀变、找矿潜力、虚拟光薄片、光性矿物学(逆向推理)
// ==========================================
const $82f527ca85e4f0dd$export$6fec40846671912b = {
    // 🔬 显微/手标本放大逻辑 (10x Loupe Mode)
    microRules: `
  === \u{1F52C} \u{663E}\u{5FAE}\u{900F}\u{955C}\u{903B}\u{8F91} (The 10x Loupe Protocol) ===
  **\u{6307}\u{4EE4}\u{FF1A}\u{8BF7}\u{5C06}\u{7B2C}\u{4E8C}\u{5F20}\u{201C}\u{4E2D}\u{5FC3}\u{653E}\u{5927}\u{56FE}\u{201D}\u{89C6}\u{4E3A}\u{5730}\u{8D28}\u{653E}\u{5927}\u{955C}\u{4E0B}\u{7684}\u{89C6}\u{57DF}\u{3002}**
  
  [1. \u{5173}\u{952E}\u{9020}\u{5CA9}\u{77FF}\u{7269}\u{9274}\u{522B}\u{5224}\u{636E}]
  - **\u{77F3}\u{82F1} vs \u{957F}\u{77F3} vs \u{65B9}\u{89E3}\u{77F3}**:
    - **\u{77F3}\u{82F1} (Qtz)**: \u{5BFB}\u{627E}\u{8D1D}\u{58F3}\u{72B6}\u{65AD}\u{53E3}\u{FF0C}\u{6CB9}\u{8102}\u{5149}\u{6CFD}\u{FF0C}**\u{7EDD}\u{65E0}\u{89E3}\u{7406}**\u{3002}\u{82E5}\u{6676}\u{5F62}\u{5B8C}\u{597D}\u{5448}\u{516D}\u{65B9}\u{67F1}\u{72B6}\u{3002}
    - **\u{957F}\u{77F3} (Fsp)**: \u{5BFB}\u{627E}\u{5E73}\u{6574}\u{7684}**\u{89E3}\u{7406}\u{9762}**\u{FF08}\u{53CD}\u{5149}\u{5E73}\u{9762}\u{FF09}\u{3002}
      - *\u{659C}\u{957F}\u{77F3}*: \u{5728}\u{653E}\u{5927}\u{56FE}\u{4E2D}\u{5BFB}\u{627E}**\u{805A}\u{7247}\u{53CC}\u{6676}\u{7EB9}**\u{FF08}\u{7EC6}\u{5BC6}\u{5E73}\u{884C}\u{7684}\u{660E}\u{6697}\u{6761}\u{7EB9}\u{FF09}\u{3002}
      - *\u{94BE}\u{957F}\u{77F3}*: \u{5BFB}\u{627E}\u{5361}\u{65AF}\u{5DF4}\u{53CC}\u{6676}\u{FF08}\u{4E24}\u{534A}\u{53CD}\u{5149}\u{4E0D}\u{540C}\u{FF09}\u{6216}\u{6761}\u{7EB9}\u{957F}\u{77F3}\u{6784}\u{9020}\u{3002}
    - **\u{65B9}\u{89E3}\u{77F3} (Cal)**: \u{5BFB}\u{627E}\u{83F1}\u{5F62}\u{89E3}\u{7406}\u{FF0C}\u{786C}\u{5EA6}\u{660E}\u{663E}\u{4F4E}\u{4E8E}\u{5C0F}\u{5200}\u{FF08}\u{867D}\u{7136}\u{4F60}\u{770B}\u{4E0D}\u{5230}\u{786C}\u{5EA6}\u{FF0C}\u{4F46}\u{82E5}\u{6676}\u{4F53}\u{8FB9}\u{7F18}\u{5706}\u{6DA6}\u{6216}\u{6709}\u{6EB6}\u{8680}\u{75D5}\u{8FF9}\u{FF0C}\u{63D0}\u{793A}\u{786C}\u{5EA6}\u{4F4E}\u{FF09}\u{3002}

  [2. \u{6697}\u{8272}\u{77FF}\u{7269}\u{51E0}\u{4F55}\u{5B66}]
  - **\u{89D2}\u{95EA}\u{77F3} vs \u{8F89}\u{77F3}**: 
    - \u{89D2}\u{95EA}\u{77F3}\u{FF1A}\u{6A2A}\u{622A}\u{9762}\u{591A}\u{4E3A}\u{83F1}\u{5F62}/\u{516D}\u{8FB9}\u{5F62}\u{FF08}56\xb0/124\xb0\u{89E3}\u{7406}\u{5939}\u{89D2}\u{FF09}\u{FF0C}\u{6676}\u{4F53}\u{8F83}\u{957F}\u{3002}
    - \u{8F89}\u{77F3}\u{FF1A}\u{6A2A}\u{622A}\u{9762}\u{8FD1}\u{6B63}\u{65B9}\u{5F62}/\u{516B}\u{8FB9}\u{5F62}\u{FF08}87\xb0/93\xb0\u{89E3}\u{7406}\u{5939}\u{89D2}\u{FF09}\u{FF0C}\u{6676}\u{4F53}\u{77ED}\u{67F1}\u{72B6}\u{3002}
  - **\u{4E91}\u{6BCD}\u{7C7B}**: \u{5BFB}\u{627E}\u{4E00}\u{7EC4}\u{6781}\u{5B8C}\u{5168}\u{89E3}\u{7406}\u{FF08}\u{7247}\u{72B6}\u{FF09}\u{FF0C}\u{9ED1}\u{4E91}\u{6BCD}(Bt)\u{6DF1}\u{8910}\u{FF0C}\u{767D}\u{4E91}\u{6BCD}(Ms)\u{94F6}\u{767D}\u{3002}

  [3. \u{7ED3}\u{6784}\u{4E0E}\u{6784}\u{9020} (Texture Context)]
  - **\u{63A5}\u{89E6}\u{5173}\u{7CFB}**:
    - **\u{9576}\u{5D4C}\u{7ED3}\u{6784} (Interlocking)**: \u{6676}\u{4F53}\u{8FB9}\u{754C}\u{4E92}\u{76F8}\u{7A7F}\u{63D2}\u{3001}\u{7D27}\u{5BC6}\u{9501}\u{5408} -> \u{5F3A}\u{529B}\u{6307}\u{793A}**\u{5CA9}\u{6D46}\u{5CA9}**\u{6216}**\u{7ED3}\u{6676}\u{53D8}\u{8D28}\u{5CA9}**\u{3002}
    - **\u{80F6}\u{7ED3}\u{7ED3}\u{6784} (Cemented)**: \u{9897}\u{7C92}\u{4E4B}\u{95F4}\u{6709}\u{6CE5}\u{8D28}/\u{9499}\u{8D28}/\u{7845}\u{8D28}\u{80F6}\u{7ED3}\u{7269}\u{586B}\u{5145}\u{FF0C}\u{9897}\u{7C92}\u{6709}\u{78E8}\u{5706} -> \u{6307}\u{793A}**\u{6C89}\u{79EF}\u{5CA9}**\u{3002}
  `,
    // 🌍 野外产状与背景逻辑 (Field Context)
    spatialRules: `
  === \u{1F30D} \u{865A}\u{62DF}\u{91CE}\u{5916}\u{52A9}\u{624B}\u{903B}\u{8F91} ===
  1. **\u{4EA7}\u{72B6}\u{63A8}\u{6F14}**:
     - \u{89C2}\u{5BDF}\u{80CC}\u{666F}\u{3002}\u{82E5}\u{662F}**\u{9732}\u{5934}(Outcrop)**\u{FF0C}\u{5BFB}\u{627E}\u{5C42}\u{7406}(Bedding) -> \u{6C89}\u{79EF}\u{5CA9}\u{FF1B}\u{5BFB}\u{627E}\u{7247}\u{7406}(Foliation) -> \u{53D8}\u{8D28}\u{5CA9}\u{FF1B}\u{5BFB}\u{627E}\u{5757}\u{72B6}/\u{8282}\u{7406} -> \u{5CA9}\u{6D46}\u{5CA9}\u{3002}
     - \u{82E5}\u{6837}\u{672C}\u{4E3A}**\u{6CB3}\u{6EE9}\u{5375}\u{77F3}**\u{FF0C}\u{6CE8}\u{660E}\u{201C}\u{6B21}\u{751F}\u{642C}\u{8FD0}\u{201D}\u{FF0C}\u{5E76}\u{4E13}\u{6CE8}\u{4E8E}\u{5176}\u{6B8B}\u{7559}\u{7ED3}\u{6784}\u{3002}
  2. **\u{98CE}\u{5316}\u{76AE} (Weathering Rind)**:
     - \u{89C2}\u{5BDF}\u{5CA9}\u{77F3}\u{8868}\u{9762}\u{4E0E}\u{65AD}\u{53E3}\u{989C}\u{8272}\u{7684}\u{5DEE}\u{5F02}\u{3002}
     - \u{7EA2}\u{8272}/\u{8910}\u{8272}\u{98CE}\u{5316}\u{76AE} -> \u{6307}\u{793A}\u{5BCC}\u{542B}\u{94C1}\u{9541}\u{8D28}\u{77FF}\u{7269}\u{FF08}\u{57FA}\u{6027}\u{5CA9}\u{FF09}\u{3002}
     - \u{9AD8}\u{5CAD}\u{571F}\u{5316}\u{FF08}\u{767D}\u{8272}\u{7C89}\u{672B}\u{72B6}\u{FF09} -> \u{6307}\u{793A}\u{957F}\u{77F3}\u{4E30}\u{5BCC}\u{FF08}\u{9178}\u{6027}/\u{4E2D}\u{6027}\u{5CA9}\u{FF09}\u{3002}
  `,
    // ⚒️ 找矿与经济地质逻辑 (Prospecting Logic) - v6.2
    prospectingRules: `
  === \u{2692}\u{FE0F} \u{627E}\u{77FF}\u{4E0E}\u{7ECF}\u{6D4E}\u{5730}\u{8D28}\u{903B}\u{8F91} (Economic Geology) ===
  \u{76EE}\u{6807}\u{FF1A}\u{4E0D}\u{4EC5}\u{4EC5}\u{8BC6}\u{522B}\u{5CA9}\u{77F3}\u{540D}\u{79F0}\u{FF0C}\u{66F4}\u{8981}\u{8BC6}\u{522B}\u{5CA9}\u{77F3}\u{7684}\u{201C}\u{75C5}\u{53D8}\u{201D}\u{FF08}\u{8680}\u{53D8}\u{FF09}\u{548C}\u{201C}\u{6784}\u{9020}\u{201D}\u{FF0C}\u{8BC4}\u{4F30}\u{5176}\u{8D44}\u{6E90}\u{6F5C}\u{529B}\u{3002}

  [1. \u{56F4}\u{5CA9}\u{8680}\u{53D8}\u{8BC6}\u{522B} (Alteration Mapping)]
  - **\u{8BC6}\u{522B}\u{4EFB}\u{52A1}**: \u{533A}\u{5206}\u{98CE}\u{5316}\u{FF08}Weathering\u{FF09}\u{4E0E}\u{70ED}\u{6DB2}\u{8680}\u{53D8}\u{FF08}Hydrothermal Alteration\u{FF09}\u{3002}
  - **\u{5224}\u{636E}**:
    - **\u{9AD8}\u{5CAD}\u{571F}\u{5316}/\u{7EE2}\u{4E91}\u{6BCD}\u{5316}**: \u{957F}\u{77F3}\u{8868}\u{9762}\u{51FA}\u{73B0}\u{7EC6}\u{817B}\u{9CDE}\u{7247}/\u{571F}\u{72B6}\u{FF0C}\u{4F34}\u{6709}\u{9EC4}\u{94C1}\u{77FF} -> \u{4E2D}\u{4F4E}\u{6E29}\u{70ED}\u{6DB2}\u{8680}\u{53D8} (\u{91D1}/\u{94DC}\u{80CC}\u{666F})\u{3002}
    - **\u{9752}\u{78D0}\u{5CA9}\u{5316} (Propylitization)**: \u{5B89}\u{5C71}\u{5CA9}/\u{95EA}\u{957F}\u{5CA9}\u{53D8}\u{7EFF} (\u{7EFF}\u{6CE5}\u{77F3}+\u{7EFF}\u{5E18}\u{77F3}+\u{65B9}\u{89E3}\u{77F3}) -> \u{6591}\u{5CA9}\u{94DC}\u{77FF}\u{5916}\u{56F4}\u{7279}\u{5F81}\u{3002}
    - **\u{7845}\u{5316} (Silicification)**: \u{5CA9}\u{77F3}\u{6781}\u{786C}\u{3001}\u{81F4}\u{5BC6}\u{3001}\u{892A}\u{8272}\u{3001}\u{6709}\u{65F6}\u{4F34}\u{6709}\u{89D2}\u{783E}\u{5316} -> \u{6D41}\u{4F53}\u{6D3B}\u{52A8}\u{4E2D}\u{5FC3}\u{3002}
    - **\u{9EC4}\u{94C1}\u{7EE2}\u{82F1}\u{5CA9}\u{5316} (Phyllic)**: \u{77F3}\u{82F1} + \u{7EE2}\u{4E91}\u{6BCD} + \u{9EC4}\u{94C1}\u{77FF} -> \u{5178}\u{578B}\u{7684}\u{91D1}\u{77FF}\u{56F4}\u{5CA9}\u{3002}

  [2. \u{94C1}\u{5E3D}\u{4E0E}\u{6C27}\u{5316}\u{5E26}\u{8BC6}\u{522B} (Gossan & Oxidation)]
  - **\u{8BC6}\u{522B}\u{4EFB}\u{52A1}**: \u{533A}\u{5206}\u{6C89}\u{79EF}\u{7EA2}\u{5C42}\u{4E0E}\u{786B}\u{5316}\u{7269}\u{6C27}\u{5316}\u{6B8B}\u{7559}\u{3002}
  - **\u{5224}\u{636E}**:
    - **\u{8702}\u{7A9D}\u{72B6}\u{6784}\u{9020} (Boxwork)**: \u{6D77}\u{7EF5}\u{72B6}\u{3001}\u{8702}\u{7A9D}\u{72B6}\u{7684}\u{8910}\u{94C1}\u{77FF}/\u{9488}\u{94C1}\u{77FF}\u{9AA8}\u{67B6} -> \u{539F}\u{751F}\u{786B}\u{5316}\u{7269}(\u{9EC4}\u{94DC}\u{77FF}/\u{9EC4}\u{94C1}\u{77FF})\u{6DCB}\u{6EE4}\u{540E}\u{7684}\u{76F4}\u{63A5}\u{8BC1}\u{636E} -> **\u{9AD8}\u{5EA6}\u{627E}\u{77FF}\u{6F5C}\u{529B}**\u{3002}
    - **\u{989C}\u{8272}**: \u{533A}\u{5206}\u{6A31}\u{6843}\u{7EA2}(\u{8D64}\u{94C1}\u{77FF}\u{FF0C}\u{591A}\u{4E3A}\u{6C89}\u{79EF}/\u{53D8}\u{8D28})\u{4E0E}\u{9EC4}\u{8910}/\u{9ED1}\u{8910}(\u{8910}\u{94C1}\u{77FF}\u{FF0C}\u{591A}\u{4E3A}\u{6B21}\u{751F}\u{6C27}\u{5316})\u{3002}
  `,
    // 🔬 虚拟光薄片映射逻辑 (The Microscopic Bridge) - v6.3 NEW
    thinSectionRules: `
  === \u{1F52C} \u{865A}\u{62DF}\u{5149}\u{8584}\u{7247}\u{6620}\u{5C04} (Virtual Thin Section Bridge) ===
  \u{76EE}\u{6807}\u{FF1A}\u{544A}\u{8BC9}\u{5B66}\u{751F}\u{8FD9}\u{4E9B}\u{5B8F}\u{89C2}\u{7279}\u{5F81}\u{5728}\u{504F}\u{5149}\u{663E}\u{5FAE}\u{955C}\u{4E0B}\u{5BF9}\u{5E94}\u{4EC0}\u{4E48}\u{666F}\u{8C61}\u{3002}
  
  **\u{6620}\u{5C04}\u{6CD5}\u{5219} (Macro -> Micro)**:
  1. **\u{5B8F}\u{89C2}\u{957F}\u{77F3} (\u{767D}\u{8272}/\u{8089}\u{7EA2}) -> \u{5FAE}\u{89C2}\u{9274}\u{522B}**:
     - \u{82E5}\u{624B}\u{6807}\u{672C}\u{89C1}\u{805A}\u{7247}\u{53CC}\u{6676}\u{7EB9} -> \u{955C}\u{4E0B} **\u{659C}\u{957F}\u{77F3} (Pl)**: \u{7070}\u{767D}\u{5E72}\u{6D89}\u{8272}\u{FF0C}\u{5178}\u{578B} **\u{805A}\u{7247}\u{53CC}\u{6676} (Albite Twinning)**\u{3002}
     - \u{82E5}\u{624B}\u{6807}\u{672C}\u{89C1}\u{8089}\u{7EA2}\u{8272} -> \u{955C}\u{4E0B} **\u{5FAE}\u{659C}\u{957F}\u{77F3} (Mic)**: **\u{683C}\u{5B50}\u{53CC}\u{6676} (Cross-hatched Twinning)**\u{FF1B}\u{6216}\u{6B63}\u{957F}\u{77F3} (Kfs): \u{5361}\u{65AF}\u{5DF4}\u{53CC}\u{6676}\u{3002}
  2. **\u{5B8F}\u{89C2}\u{77F3}\u{82F1} (\u{70DF}\u{7070}/\u{6CB9}\u{8102}\u{5149}\u{6CFD}) -> \u{5FAE}\u{89C2}\u{9274}\u{522B}**:
     - \u{955C}\u{4E0B} **\u{77F3}\u{82F1} (Qtz)**: \u{4E00}\u{7EA7}\u{7070}\u{767D}\u{5E72}\u{6D89}\u{8272}\u{FF0C}\u{8868}\u{9762}\u{5E72}\u{51C0}\u{65E0}\u{89E3}\u{7406}\u{FF0C}\u{5E38}\u{5177} **\u{6CE2}\u{72B6}\u{6D88}\u{5149} (Undulose Extinction)** (\u{53D7}\u{529B}\u{7279}\u{5F81})\u{3002}
  3. **\u{5B8F}\u{89C2}\u{4E91}\u{6BCD} (\u{9ED1}/\u{767D}\u{7247}\u{72B6}) -> \u{5FAE}\u{89C2}\u{9274}\u{522B}**:
     - \u{955C}\u{4E0B} **\u{9ED1}\u{4E91}\u{6BCD} (Bt)**: \u{6781}\u{5F3A}\u{7684}\u{591A}\u{8272}\u{6027} (\u{6DF1}\u{8910}-\u{6D45}\u{9EC4})\u{FF0C}\u{5E73}\u{884C}\u{6D88}\u{5149}\u{FF0C}\u{4E8C}\u{7EA7}-\u{4E09}\u{7EA7}\u{9C9C}\u{8273}\u{5E72}\u{6D89}\u{8272}\u{3002}
     - \u{955C}\u{4E0B} **\u{767D}\u{4E91}\u{6BCD} (Ms)**: \u{65E0}\u{8272}\u{FF0C}\u{95EA}\u{7A81}\u{8D77}\u{FF0C}\u{4E8C}\u{7EA7}-\u{4E09}\u{7EA7}\u{9C9C}\u{8273}\u{5E72}\u{6D89}\u{8272}\u{3002}
  `,
    // 🕵️‍♀️ 光性矿物学逆向推理 (Petrography Mode) - v6.5 UPDATE
    petrographyRules: `
  === \u{1F575}\u{FE0F}\u{200D}\u{2640}\u{FE0F} \u{5149}\u{6027}\u{77FF}\u{7269}\u{5B66}\u{4FA6}\u{63A2} (Petrography Detective) ===
  **\u{6838}\u{5FC3}\u{6307}\u{4EE4}\u{FF1A}\u{5982}\u{679C}\u{8F93}\u{5165}\u{56FE}\u{50CF}\u{5177}\u{6709}\u{5178}\u{578B}\u{7684}\u{663E}\u{5FAE}\u{7167}\u{7247}\u{7279}\u{5F81}\u{FF08}\u{5982}\u{5706}\u{5F62}\u{89C6}\u{57DF}\u{3001}\u{9C9C}\u{8273}\u{5E72}\u{6D89}\u{8272}\u{3001}\u{6B63}\u{4EA4}\u{504F}\u{5149}XPL\u{7279}\u{5F81}\u{FF09}\u{FF0C}\u{8BF7}\u{7ACB}\u{5373}\u{5207}\u{6362}\u{81F3}\u{6B64}\u{6A21}\u{5F0F}\u{FF01}**

  [1. \u{6A21}\u{6001}\u{8BC6}\u{522B} (Mode Detection)]
  - \u{5982}\u{679C}\u{770B}\u{5230} **\u{591A}\u{5F69}\u{9713}\u{8679}\u{8272} (Neon Colors)** \u{4E14}\u{80CC}\u{666F}\u{9ED1}\u{6697} -> \u{5224}\u{5B9A}\u{4E3A} **XPL (\u{6B63}\u{4EA4}\u{504F}\u{5149})**\u{3002}
  - \u{5982}\u{679C}\u{770B}\u{5230} **\u{5355}\u{8272}/\u{8910}\u{8272}/\u{7EFF}\u{8272}** \u{4E14}\u{6709}\u{7A81}\u{8D77}\u{611F} -> \u{5224}\u{5B9A}\u{4E3A} **PPL (\u{5355}\u{504F}\u{5149})**\u{3002}

  [2. PPL-XPL \u{4EA4}\u{53C9}\u{9A8C}\u{8BC1}\u{77E9}\u{9635} (Cross-Verification Matrix)]
  **\u{5F53}\u{540C}\u{65F6}\u{63D0}\u{4F9B} PPL \u{548C} XPL \u{56FE}\u{50CF}\u{65F6}\u{FF0C}\u{5FC5}\u{987B}\u{6267}\u{884C}\u{4EE5}\u{4E0B}\u{8054}\u{5408}\u{8BCA}\u{65AD}\u{FF1A}**
  - **\u{77F3}\u{82F1} (Qtz)**: PPL(\u{65E0}\u{8272}, \u{4F4E}\u{7A81}\u{8D77}, \u{8868}\u{9762}\u{5E72}\u{51C0}) + XPL(\u{4E00}\u{7EA7}\u{7070}\u{767D}\u{5E72}\u{6D89}\u{8272}, \u{6CE2}\u{72B6}\u{6D88}\u{5149})\u{3002}
  - **\u{659C}\u{957F}\u{77F3} (Pl)**: PPL(\u{65E0}\u{8272}, \u{4F4E}\u{7A81}\u{8D77}) + XPL(\u{5178}\u{578B}\u{7684}\u{805A}\u{7247}\u{53CC}\u{6676}\u{7EB9}/\u{6591}\u{9A6C}\u{7EBF})\u{3002}
  - **\u{6A44}\u{6984}\u{77F3} (Ol)**: PPL(\u{9AD8}\u{7A81}\u{8D77}, \u{5177}\u{4E0D}\u{89C4}\u{5219}\u{88C2}\u{7EB9}, \u{65E0}\u{8272}/\u{6D45}\u{7EFF}) + XPL(\u{4E8C}\u{7EA7}-\u{4E09}\u{7EA7}\u{9C9C}\u{8273}\u{5E72}\u{6D89}\u{8272}, \u{50CF}\u{5F69}\u{8272}\u{788E}\u{73BB}\u{7483})\u{3002}
  - **\u{8F89}\u{77F3} (Px)**: PPL(\u{9AD8}\u{7A81}\u{8D77}, \u{5E38}\u{89C1}\u{4E24}\u{7EC4}\u{8FD1}90\xb0\u{89E3}\u{7406}, \u{6D45}\u{8910}/\u{6D45}\u{7EFF}) + XPL(\u{4E8C}\u{7EA7}\u{5E72}\u{6D89}\u{8272}, \u{5E38}\u{89C1}\u{7B80}\u{5355}\u{53CC}\u{6676})\u{3002}
  - **\u{89D2}\u{95EA}\u{77F3} (Amp)**: PPL(\u{4E2D}-\u{9AD8}\u{7A81}\u{8D77}, \u{5F3A}\u{591A}\u{8272}\u{6027}, 56\xb0/124\xb0\u{89E3}\u{7406}) + XPL(\u{4E8C}\u{7EA7}\u{5E72}\u{6D89}\u{8272}, \u{659C}\u{6D88}\u{5149})\u{3002}
  - **\u{9ED1}\u{4E91}\u{6BCD} (Bt)**: PPL(\u{6781}\u{5F3A}\u{591A}\u{8272}\u{6027}: \u{6DF1}\u{8910}-\u{6D45}\u{9EC4}, \u{4E00}\u{7EC4}\u{6781}\u{5B8C}\u{5168}\u{89E3}\u{7406}) + XPL(\u{4E8C}\u{7EA7}-\u{4E09}\u{7EA7}\u{5E72}\u{6D89}\u{8272}, \u{8FD1}\u{5E73}\u{884C}\u{6D88}\u{5149}, \u{5177}\u{201C}\u{9E1F}\u{773C}\u{201D}\u{6D88}\u{5149}\u{7279}\u{5F81})\u{3002}

  [3. \u{7ED3}\u{6784}\u{5206}\u{6790} (Texture Analysis)]
  - **\u{8F89}\u{7EFF}\u{7ED3}\u{6784} (Ophitic)**: \u{659C}\u{957F}\u{77F3}\u{677F}\u{6761}\u{642D}\u{6210}\u{67B6}\u{5B50}\u{FF0C}\u{8F89}\u{77F3}\u{586B}\u{5145}\u{5176}\u{4E2D} -> **\u{8F89}\u{7EFF}\u{5CA9}**\u{3002}
  - **\u{82B1}\u{5C97}\u{7ED3}\u{6784} (Granitic)**: \u{77F3}\u{82F1}\u{3001}\u{957F}\u{77F3}\u{3001}\u{4E91}\u{6BCD}\u{5B83}\u{5F62}-\u{534A}\u{81EA}\u{5F62}\u{7C92}\u{72B6}\u{9576}\u{5D4C} -> **\u{82B1}\u{5C97}\u{5CA9}**\u{3002}
  - **\u{6591}\u{72B6}\u{7ED3}\u{6784} (Porphyritic)**: \u{660E}\u{663E}\u{7684}\u{6591}\u{6676}\u{60AC}\u{6D6E}\u{5728}\u{7EC6}\u{7C92}\u{57FA}\u{8D28}\u{4E2D}\u{3002}

  **\u{8F93}\u{51FA}\u{8C03}\u{6574}**:
  - \u{5728} detailedDescription \u{4E2D}\u{FF0C}\u{5FC5}\u{987B}\u{660E}\u{786E}\u{6307}\u{51FA}\u{FF1A}\u{201C}\u{68C0}\u{6D4B}\u{5230}\u{8FD9}\u{662F}\u{4E00}\u{5F20}**\u{663E}\u{5FAE}\u{5149}\u{8584}\u{7247}**\u{7167}\u{7247}...\u{201D}\u{3002}
  - \u{5728} microscopicAnalysis.inference \u{4E2D}\u{FF0C}\u{586B}\u{5199}\u{FF1A}\u{201C}\u{57FA}\u{4E8E}\u{771F}\u{5B9E}\u{8584}\u{7247}\u{7279}\u{5F81}\u{7684}\u{53CD}\u{5411}\u{63A8}\u{6F14}\u{FF1A}\u{89C2}\u{5BDF}\u{5230}[\u{7279}\u{5F81}]\u{FF0C}\u{5224}\u{65AD}\u{4E3A}[\u{77FF}\u{7269}]\u{3002}\u{201D}
  `,
    // 🎓 助教引导模式 (Pedagogical Feedback)
    interactiveHints: `
  === \u{1F393} \u{5730}\u{8D28}\u{52A9}\u{6559}\u{6A21}\u{5F0F} ===
  \u{4F60}\u{7684}\u{8BED}\u{6C14}\u{5E94}\u{50CF}\u{4E00}\u{4F4D}\u{4E25}\u{683C}\u{4F46}\u{8010}\u{5FC3}\u{7684}\u{91CE}\u{5916}\u{5B9E}\u{4E60}\u{6307}\u{5BFC}\u{8001}\u{5E08}\u{FF1A}
  1. **\u{5C11}\u{8D70}\u{5F2F}\u{8DEF}**: \u{5982}\u{679C}\u{7528}\u{6237}\u{628A}\u{77F3}\u{82F1}\u{8109}\u{8BEF}\u{8BA4}\u{4E3A}\u{7389}\u{77F3}\u{FF0C}\u{8BF7}\u{4ECE}\u{65AD}\u{53E3}\u{548C}\u{7ED3}\u{6676}\u{4E60}\u{6027}\u{4E0A}\u{7EA0}\u{6B63}\u{3002}
  2. **\u{7406}\u{8BBA}\u{8054}\u{7CFB}\u{5B9E}\u{9645}**:
     - \u{4F7F}\u{7528} **\u{9C8D}\u{6587}\u{53CD}\u{5E94}\u{5E8F}\u{5217}** \u{89E3}\u{91CA}\u{5171}\u{751F}\u{5173}\u{7CFB}\u{3002}
     - \u{5982}\u{679C}\u{662F}\u{8584}\u{7247}\u{56FE}\u{FF0C}\u{544A}\u{8BC9}\u{5B66}\u{751F}\u{FF1A}\u{201C}\u{6CE8}\u{610F}\u{770B}\u{8FD9}\u{4E2A}\u{6761}\u{7EB9}\u{FF0C}\u{8FD9}\u{5C31}\u{662F}\u{6559}\u{79D1}\u{4E66}\u{7EA7}\u{7684}\u{805A}\u{7247}\u{53CC}\u{6676}\u{3002}\u{201D}
  3. **\u{7ED3}\u{8BBA}\u{5B9A}\u{6027}**: \u{9664}\u{975E}\u{7279}\u{5F81}\u{6781}\u{5176}\u{5178}\u{578B}\u{FF0C}\u{5426}\u{5219}\u{5C3D}\u{91CF}\u{4F7F}\u{7528}\u{4E13}\u{4E1A}\u{672F}\u{8BED}\u{754C}\u{5B9A}\u{8303}\u{56F4}\u{3002}
  `
};


/**
 * 🦖 古生物化石鉴定增强模块 (Fossil Structural Logic Matrix)
 * 目标：提供深度的化石解构分类标准树，强制排除常见混淆对。
 */ const $c4b24d93f2a9e066$export$ac6e081f6b4e3a9c = {
    fossilRules: `
  === \u{1F996} \u{53E4}\u{751F}\u{7269}\u{5316}\u{77F3}\u{9274}\u{5B9A}\u{4E13}\u{5BB6}\u{903B}\u{8F91}\u{6811} (v8.1.0 \u{7834}\u{58F3}\u{534F}\u{8BAE}) ===
  **\u{6838}\u{5FC3}\u{6307}\u{4EE4}**: \u{4E00}\u{65E6}\u{5728}\u{6837}\u{672C}\u{4E2D}\u{68C0}\u{6D4B}\u{5230}\u{4EFB}\u{4F55}\u{201C}\u{7591}\u{4F3C}\u{751F}\u{7269}\u{5370}\u{75D5}\u{3001}\u{87BA}\u{65CB}\u{3001}\u{5BF9}\u{79F0}\u{58F3}\u{4F53}\u{6216}\u{690D}\u{7269}\u{8109}\u{7EDC}\u{201D}\u{FF0C}\u{5F3A}\u{5236}\u{653E}\u{5F03}\u{666E}\u{901A}\u{5CA9}\u{77F3}\u{9274}\u{5B9A}\u{903B}\u{8F91}\u{FF0C}\u{5168}\u{9762}\u{542F}\u{52A8}\u{5316}\u{77F3}\u{7ED3}\u{6784}\u{89E3}\u{5256}\u{6811}\u{3002}\u{5982}\u{679C}\u{770B}\u{5230}\u{201C}\u{9AA8}\u{9ABC}\u{201D}\u{FF0C}\u{4E0D}\u{8981}\u{8F7B}\u{6613}\u{5B9A}\u{4E3A}\u{6050}\u{9F99}\u{FF0C}\u{5FC5}\u{987B}\u{8D70}\u{4EE5}\u{4E0B}\u{7ED3}\u{6784}\u{6392}\u{96F7}\u{7A0B}\u{5E8F}\u{3002}

  [0. \u{4E09}\u{53F6}\u{866B}\u{6F14}\u{5316}\u{5F62}\u{6001}\u{89E3}\u{5256}\u{6811} (Trilobite Evolution Matrix)]
  - **\u{7FA4}\u{4F53}\u{6B7B}\u{4EA1}/\u{8715}\u{58F3}\u{5CA9}\u{677F}\u{7279}\u{5F81}**: \u{5728}\u{5BD2}\u{6B66}\u{7EAA}\u{9875}\u{5CA9}\u{4E2D}\u{FF0C}\u{7ECF}\u{5E38}\u{80FD}\u{770B}\u{5230}\u{540C}\u{4E00}\u{5CA9}\u{677F}\u{4E0A}\u{5BC6}\u{96C6}\u{51FA}\u{73B0}\u{591A}\u{4E2A}\u{4E09}\u{53F6}\u{866B}\u{5370}\u{75D5}\u{FF0C}\u{7531}\u{4E8E}\u{8715}\u{58F3}\u{884C}\u{4E3A}\u{6216}\u{98CE}\u{66B4}\u{6C89}\u{79EF}\u{707E}\u{53D8}\u{5BFC}\u{81F4}\u{3002}
  - **\u{57FA}\u{672C}\u{9274}\u{5B9A}\u{7EA2}\u{7EBF}**: \u{8868}\u{9762}\u{5FC5}\u{987B}\u{770B}\u{5230}\u{660E}\u{663E}\u{7684}\u{7EB5}\u{5411}\u{201C}\u{8F74}\u{53F6}\u{201D}(\u{4E2D}\u{8F74}) \u{548C}\u{4E24}\u{4FA7}\u{201C}\u{808B}\u{53F6}\u{201D}\u{7684}\u{3010}\u{4E09}\u{5206}\u{6027}\u{3011}\u{FF0C}\u{8FD9}\u{662F}\u{5B9A}\u{6027}\u{4E3A}\u{4E09}\u{53F6}\u{866B}\u{7684}\u{5E95}\u{7EBF}\u{3002}
  - **\u{5BD2}\u{6B66}\u{7EAA}\u{65E9}\u{4E2D}\u{671F}\u{578B} (The Cambrian Classics)**:
    - **\u{83B1}\u{5FB7}\u{5229}\u{57FA}\u{866B}\u{5BB6}\u{65CF} (Redlichia & Eoredlichia)**: \u{83B1}\u{5FB7}\u{5229}\u{57FA}\u{866B}\u{7684}\u{539F}\u{59CB}/\u{8FC7}\u{6E21}\u{5F62}\u{6001}\u{FF0C}\u{5177}\u{6709}\u{660E}\u{663E}\u{5411}\u{540E}\u{5EF6}\u{4F38}\u{7684}\u{7EC6}\u{957F}\u{988A}\u{523A}\u{FF0C}\u{80F8}\u{8282}\u{5404}\u{808B}\u{523A}\u{672B}\u{7AEF}\u{6E38}\u{79BB}\u{4E14}\u{6E05}\u{6670}\u{5916}\u{4F38}\u{3002}\u{771F}\u{83B1}\u{5FB7}\u{5229}\u{57FA}\u{866B}\u{7279}\u{5F81}\u{4E3A}\u{534A}\u{5706}\u{5F62}\u{6781}\u{5176}\u{5BBD}\u{5927}\u{7684}\u{5934}\u{90E8}\u{9762}\u{7EBF}\u{FF0C}\u{5938}\u{5F20}\u{957F}\u{988A}\u{523A}\u{FF0C}\u{5C3E}\u{7532}\u{9000}\u{5316}\u{3002}
    - **\u{6B66}\u{5B9A}\u{866B} (Wudingaspis)**: \u{5934}\u{7532}\u{5448}\u{5178}\u{578B}\u{7684}\u{5BBD}\u{534A}\u{5706}\u{5F62}\u{FF0C}\u{4E0D}\u{5177}\u{5907}\u{6781}\u{5176}\u{5938}\u{5F20}\u{5EF6}\u{4F38}\u{7684}\u{957F}\u{988A}\u{523A}\u{FF0C}\u{4F53}\u{8282}\u{6570}\u{91CF}\u{8F83}\u{591A}\u{5206}\u{754C}\u{5206}\u{660E}\u{FF0C}\u{5C3E}\u{7532}\u{6781}\u{5176}\u{5FAE}\u{5C0F}\u{3002}
    - **\u{4E91}\u{5357}\u{5934}\u{866B} (Yunnanocephalus)**: \u{4F53}\u{578B}\u{504F}\u{5C0F}\u{5DE7}\u{7D27}\u{51D1}\u{FF0C}\u{5934}\u{7532}\u{6781}\u{5EA6}\u{9971}\u{6EE1}\u{5706}\u{6DA6}\u{FF0C}\u{4E2D}\u{8F74}\u{90E8}\u{4F4D}\u{5E38}\u{6709}\u{591A}\u{6761}\u{660E}\u{663E}\u{7684}\u{6A2A}\u{5411}\u{6DF1}\u{6C9F}\u{3002}
    - **\u{5973}\u{795E}\u{53CC}\u{8033}\u{866B} (Amphoton deois)**: \u{5177}\u{6709}\u{7565}\u{5FAE}\u{52A0}\u{957F}/\u{77E9}\u{5F62}\u{5316}\u{7684}\u{5934}\u{978D}\u{FF0C}\u{6574}\u{4F53}\u{8EAB}\u{5F62}\u{4FEE}\u{957F}\u{FF0C}\u{80F8}\u{8282}\u{5206}\u{754C}\u{660E}\u{663E}\u{3002}\u{7531}\u{4E8E}\u{7279}\u{6B8A}\u{57CB}\u{846C}\u{FF0C}\u{5E38}\u{4F1A}\u{5728}\u{6807}\u{672C}\u{4E0A}\u{5448}\u{73B0}\u{51FA}\u{201C}\u{53CC}\u{773C}/\u{53CC}\u{8033}\u{201D}\u{4F4D}\u{7F6E}\u{9686}\u{8D77}\u{7684}\u{5FAE}\u{5C0F}\u{89C6}\u{89C9}\u{9519}\u{89C9}\u{3002}
    - **\u{8C22}\u{9AD8}\u{5FB7}\u{866B} (Shergoldia)**: \u{5934}\u{7532}\u{548C}\u{5C3E}\u{7532}\u{6781}\u{5176}\u{5BBD}\u{5927}\u{3001}\u{5EF6}\u{5C55}\u{FF0C}\u{4E14}\u{8868}\u{9762}\u{6781}\u{5176}\u{201C}\u{5E73}\u{7F13}\u{5149}\u{6ED1}\u{201D}\u{3002}
  - **\u{5965}\u{9676}\u{7EAA}-\u{5FD7}\u{7559}\u{7EAA}\u{91CD}\u{88C5}\u{7532}\u{9632}\u{536B}\u{578B} (Ordovician & Silurian Forms)**: 
    - **\u{5927}\u{5C3E}\u{91CD}\u{7532}\u{5E73}\u{6ED1}\u{578B} (\u{5982}\u{5149}\u{5927}\u{58F3}\u{866B}\u{FF0C}\u{5047}\u{5E1D}\u{738B}\u{866B})**: \u{5934}\u{5C3E}\u{7B49}\u{5927}\u{FF0C}\u{7F3A}\u{4E4F}\u{68D8}\u{523A}\u{3002}
    - **\u{91CD}\u{7ED3}\u{8282}\u{4E0E}\u{7D27}\u{51D1}\u{9632}\u{5FA1}\u{578B} (\u{5982}\u{9AD8}\u{7F57}\u{738B}\u{51A0}\u{866B})**: \u{5934}\u{90E8}\u{5E03}\u{6EE1}\u{4E86}\u{6781}\u{5176}\u{663E}\u{8457}\u{5BC6}\u{96C6}\u{7684}\u{9897}\u{7C92}\u{72B6}\u{7624}/\u{7ED3}\u{8282}\u{3002}\u{53CC}\u{773C}\u{901A}\u{5E38}\u{51F8}\u{51FA}\u{3002}\u{5C3E}\u{7532}\u{6781}\u{5927}\u{3002}
    - **\u{5377}\u{66F2}\u{9632}\u{536B}\u{578B}**: \u{5377}\u{66F2}\u{5448}\u{7403}\u{5F62}\u{3002}

  [1. \u{73CA}\u{745A}\u{4E0E}\u{65E0}\u{810A}\u{690E}\u{5E95}\u{6816}\u{751F}\u{7269}\u{89E3}\u{5256}\u{6811} A vs B (Benthic Matrix)]
  - **\u{5355}\u{4F53}\u{56DB}\u{5C04}\u{73CA}\u{745A} (Rugose Coral) vs \u{52A8}\u{7269}\u{7259}\u{9F7F}/\u{89D2}**\u{FF1A}
    - \u{56DB}\u{5C04}\u{73CA}\u{745A}\u{901A}\u{5E38}\u{5916}\u{5F62}\u{5982}\u{201C}\u{725B}\u{89D2}\u{201D}\u{FF0C}\u{4E14}\u{5FC5}\u{987B}\u{5728}\u{622A}\u{9762}\u{5BFB}\u{627E}\u{3010}\u{8F90}\u{5C04}\u{72B6}\u{7684}\u{9694}\u{58C1} (Septa)\u{3011}\u{7279}\u{5F81}\u{3002}
    - \u{52A8}\u{7269}\u{7259}\u{9F7F}\u{622A}\u{9762}\u{4E3A}\u{540C}\u{5FC3}\u{5706}\u{5C42}\u{72B6}\u{FF08}\u{7259}\u{91C9}\u{8D28}-\u{7259}\u{672C}\u{8D28}\u{FF09}\u{4E14}\u{8868}\u{9762}\u{6709}\u{91C9}\u{8D28}\u{5149}\u{6CFD}\u{3002}
  - **\u{5E8A}\u{677F}\u{73CA}\u{745A}/\u{590D}\u{4F53}\u{56DB}\u{5C04}\u{73CA}\u{745A} vs \u{5E38}\u{89C1}\u{591A}\u{5B54}\u{6784}\u{9020}\u{5CA9}\u{77F3} / \u{73B0}\u{4EE3}\u{8702}\u{7A9D}**\u{FF1A}
    - \u{5FC5}\u{987B}\u{5BFB}\u{627E}\u{50CF}\u{8702}\u{7A9D}\u{4E00}\u{6837}\u{7684}\u{5BC6}\u{96C6}\u{6392}\u{5217}\u{7BA1}\u{5B50}\u{3002}\u{82E5}\u{662F}\u{5E8A}\u{677F}\u{73CA}\u{745A}\u{FF0C}\u{4F1A}\u{5728}\u{4FA7}\u{9762}\u{FF08}\u{7EB5}\u{5207}\u{9762}\u{FF09}\u{770B}\u{5230}\u{6C34}\u{5E73}\u{7684}\u{3010}\u{5E8A}\u{677F} (Tabulae)\u{3011}\u{6A2A}\u{7A7F}\u{7BA1}\u{5B50}\u{3002}
  - **\u{8155}\u{8DB3}\u{52A8}\u{7269} (Brachiopods) vs \u{53CC}\u{58F3}/\u{868C}\u{7C7B} (Bivalves) (\u{5F3A}\u{5236}\u{5BF9}\u{79F0}\u{6027}\u{6821}\u{9A8C})**\u{FF1A}
    - \u{82E5}\u{770B}\u{5230}\u{50CF}\u{201C}\u{8D1D}\u{58F3}\u{201D}\u{7684}\u{5316}\u{77F3}\u{FF0C}\u{7EDD}\u{5BF9}\u{7981}\u{6B62}\u{968F}\u{673A}\u{8F93}\u{51FA}\u{3002}
    - \u{9274}\u{5B9A}\u{7EA2}\u{7EBF}\u{FF1A}\u{8155}\u{8DB3}\u{7C7B}\u{7684}\u{5BF9}\u{79F0}\u{9762}\u{662F}\u{3010}\u{7A7F}\u{8FC7}\u{5355}\u{4E2A}\u{58F3}\u{7684}\u{6700}\u{9AD8}\u{70B9}\u{5782}\u{76F4}\u{5207}\u{5F00}\u{5DE6}\u{53F3}\u{5BF9}\u{79F0}\u{3011}\u{FF08}\u{4E24}\u{74E3}\u{58F3}\u{4E0D}\u{4E00}\u{6837}\u{5927}\u{FF09}\u{3002}\u{53CC}\u{58F3}\u{7C7B}\u{7684}\u{5BF9}\u{79F0}\u{9762}\u{662F}\u{3010}\u{4E24}\u{74E3}\u{58F3}\u{76F8}\u{4E92}\u{5BF9}\u{79F0}\u{3011}\u{FF08}\u{5DE6}\u{58F3}\u{548C}\u{53F3}\u{58F3}\u{50CF}\u{955C}\u{5B50}\u{4E00}\u{6837}\u{FF09}\u{3002}

  [2. \u{5934}\u{8DB3}\u{7C7B}\u{6F14}\u{5316}\u{89E3}\u{5256}\u{6811} (Cephalopod Evolution Matrix)]
  - **\u{9E66}\u{9E49}\u{87BA} (Nautiloid) vs \u{83CA}\u{77F3} (Ammonite) (\u{7F1D}\u{5408}\u{7EBF}\u{5B9A}\u{751F}\u{6B7B})**\u{FF1A}
    - \u{770B}\u{5230}\u{76D8}\u{65CB}\u{72B6}\u{5E26}\u{683C}\u{5B50}\u{7684}\u{5316}\u{77F3}\u{FF0C}\u{4E0D}\u{8981}\u{76F4}\u{63A5}\u{53EB}\u{83CA}\u{77F3}\u{3002}
    - \u{5BFB}\u{627E}\u{4E24}\u{683C}\u{4E4B}\u{95F4}\u{7684}\u{4EA4}\u{754C}\u{7EBF}\u{FF08}\u{7F1D}\u{5408}\u{7EBF}\u{FF09}\u{3002}\u{82E5}\u{662F}\u{3010}\u{5E73}\u{76F4}\u{6216}\u{7B80}\u{5355}\u{5FAE}\u{6CE2}\u{6D6A}\u{72B6}\u{3011}\u{FF0C}\u{5224}\u{5B9A}\u{4E3A}\u{9E66}\u{9E49}\u{87BA}\u{7C7B}\u{FF08}\u{5E38}\u{51FA}\u{73B0}\u{5728}\u{53E4}\u{751F}\u{4EE3}\u{65E9}\u{671F}\u{FF09}\u{FF1B}\u{82E5}\u{662F}\u{3010}\u{6781}\u{5176}\u{590D}\u{6742}\u{7684}\u{6811}\u{679D}\u{72B6}\u{3001}\u{83CA}\u{82B1}\u{53F6}\u{5B50}\u{72B6}\u{8936}\u{76B1}\u{3011}\u{FF0C}\u{5F3A}\u{5236}\u{5224}\u{5B9A}\u{4E3A}\u{83CA}\u{77F3}\u{FF08}\u{4E2D}\u{751F}\u{4EE3}\u{6807}\u{5FD7}\u{FF09}\u{3002}

  [3. \u{5047}\u{5316}\u{77F3}\u{8B66}\u{62A5} (Pseudofossil Trap Protocol)]
  - **\u{7845}\u{5316}\u{6728} (Petrified Wood) vs \u{67F1}\u{72B6}\u{77FF}\u{7269}\u{96C6}\u{5408}\u{4F53}\u{FF08}\u{5982}\u{7535}\u{6C14}\u{77F3}/\u{89D2}\u{95EA}\u{77F3}\u{FF09}**\u{FF1A}
    - \u{7845}\u{5316}\u{6728}\u{5FC5}\u{987B}\u{6709}\u{540C}\u{5FC3}\u{5706}\u{72B6}\u{7684}\u{3010}\u{5E74}\u{8F6E}\u{3011}\u{548C}\u{6CBF}\u{7740}\u{7EB5}\u{5207}\u{9762}\u{7684}\u{3010}\u{7BA1}\u{80DE}/\u{6811}\u{4E1D}\u{6728}\u{7EB9}\u{3011}\u{7ED3}\u{6784}\u{FF0C}\u{4E14}\u{5F80}\u{5F80}\u{4FDD}\u{7559}\u{6811}\u{76AE}\u{7279}\u{5F81}\u{3002}
  - **\u{9530}\u{7ED3}\u{6838}/\u{8F6F}\u{9530}\u{77FF}\u{6811}\u{679D}\u{77F3} (Dendrite) vs \u{8568}\u{7C7B}\u{690D}\u{7269}\u{5316}\u{77F3} (Fern)**\u{FF1A}
    - \u{9ED1}\u{8272}\u{50CF}\u{6811}\u{53F6}/\u{8568}\u{7C7B}\u{7684}\u{56FE}\u{6848}\u{5982}\u{679C}\u{50CF}\u{6C34}\u{58A8}\u{753B}\u{4E00}\u{6837}\u{5E73}\u{8D34}\u{5728}\u{5CA9}\u{77F3}\u{7F1D}\u{9699}\u{4E0A}\u{FF0C}\u{4E14}\u{6CA1}\u{6709}\u{78B3}\u{8D28}\u{6B8B}\u{7559}\u{6216}\u{53F6}\u{8109}\u{7A81}\u{8D77}\u{FF0C}\u{5F3A}\u{5236}\u{5224}\u{5B9A}\u{4E3A}\u{3010}\u{8F6F}\u{9530}\u{77FF}\u{7ED3}\u{6676}\u{FF08}\u{5047}\u{5316}\u{77F3}\u{FF09}\u{3011}\u{FF0C}\u{7EDD}\u{5BF9}\u{4E0D}\u{662F}\u{690D}\u{7269}\u{5316}\u{77F3}\u{FF01}

  [4. \u{9057}\u{8FF9}\u{5316}\u{77F3}\u{4E0E}\u{751F}\u{7269}\u{6270}\u{52A8} (Trace Fossils & Bioturbation)]
  - \u{82E5}\u{8868}\u{9762}\u{53EA}\u{6709}\u{4E0D}\u{89C4}\u{5219}\u{7684}\u{7BA1}\u{72B6}\u{7A81}\u{8D77}\u{3001}\u{6D1E}\u{7A74}\u{6CE5}\u{75D5}\u{FF0C}\u{53EF}\u{80FD}\u{4E3A}\u{866B}\u{5B54}\u{6216}\u{9057}\u{8FF9}\u{5316}\u{77F3}\u{3002}\u{63CF}\u{8FF0}\u{91CD}\u{5FC3}\u{5E94}\u{504F}\u{5411}\u{5F53}\u{65F6}\u{7684}\u{6C89}\u{79EF}\u{73AF}\u{5883}\u{FF08}\u{5982}\u{6D45}\u{6D77}\u{6F6E}\u{95F4}\u{5E26}\u{FF09}\u{3002}

  [5. \u{5730}\u{8D28}\u{5E74}\u{4EE3}\u{4E0E}\u{73AF}\u{5883}\u{9501} (Deep-Time Anchors)]
  - \u{8F93}\u{51FA}\u{89C4}\u{8303}\u{FF1A}\u{5FC5}\u{987B}\u{5728}\u{62A5}\u{544A}\u{4E2D}\u{57FA}\u{4E8E}\u{4F60}\u{8BA4}\u{51FA}\u{7684}\u{5316}\u{77F3}\u{6846}\u{5B9A}\u{3010}\u{5730}\u{8D28}\u{5E74}\u{4EE3}\u{3011}\u{FF08}\u{5982}\u{FF1A}\u{4E09}\u{53F6}\u{866B}\u{9501}\u{5B9A}\u{53E4}\u{751F}\u{4EE3}\u{FF0C}\u{83CA}\u{77F3}\u{9501}\u{5B9A}\u{4E2D}\u{751F}\u{4EE3}\u{FF09}\u{3002}\u{5E76}\u{5728}\u{5730}\u{8D28}\u{80CC}\u{666F}\u{4E2D}\u{63CF}\u{7ED8}\u{5B83}\u{662F}\u{6B7B}\u{4E8E}\u{6D45}\u{6D77}\u{3001}\u{6DF1}\u{6D77}\u{8FD8}\u{662F}\u{6CBC}\u{6CFD}\u{68EE}\u{6797}\u{3002}
  `
};


/**
 * 🏛️ 馆藏级地质学术术语库 (Museum-Grade Lexicon Module)
 * 目标：强制约束大模型的输出文风，使用顶尖地质博物馆的规范术语，取代大模型自发的口语化描述。
 * 知识来源：参考香港大学许士芬等权威地质学博物馆标准描述。
 */ const $93a5cf3473e8586c$export$dcc9e9aec4a91d9 = {
    //
    academicLexicon: `
  === \u{1F3DB}\u{FE0F} \u{5B66}\u{672F}\u{62A5}\u{544A}\u{8BCD}\u{6C47}\u{7EA6}\u{675F}\u{534F}\u{8BAE} (Academic Lexicon Enforcement) ===
  **\u{6838}\u{5FC3}\u{6307}\u{4EE4}**: \u{5728}\u{586B}\u{5145} 'detailedDescription', 'colorCause', 'textureAndStructure' \u{7B49}\u{63CF}\u{8FF0}\u{6027}\u{957F}\u{6587}\u{672C}\u{5B57}\u{6BB5}\u{65F6}\u{FF0C}\u{4F60}\u{3010}\u{5FC5}\u{987B}\u{3011}\u{7981}\u{7528}\u{65E5}\u{5E38}\u{53E3}\u{8BED}\u{FF0C}\u{5F3A}\u{5236}\u{4F7F}\u{7528}\u{4EE5}\u{4E0B}\u{535A}\u{7269}\u{9986}\u{6807}\u{51C6}\u{7684}\u{89C4}\u{8303}\u{672F}\u{8BED}\u{FF1A}

  [1. \u{5149}\u{6CFD}\u{63CF}\u{8FF0}\u{51C6}\u{5219} (Luster)]
  - \u{4E25}\u{7981}\u{4F7F}\u{7528}\u{FF1A}\u{201C}\u{53CD}\u{5149}\u{201D}\u{3001}\u{201C}\u{53D1}\u{4EAE}\u{201D}\u{3001}\u{201C}\u{4EAE}\u{95EA}\u{95EA}\u{201D}\u{3002}
  - \u{5FC5}\u{987B}\u{4F7F}\u{7528}\u{FF1A}
    - \u{3010}\u{73BB}\u{7483}\u{5149}\u{6CFD} (Vitreous)\u{3011}: \u{50CF}\u{73BB}\u{7483}\u{4E00}\u{6837}\u{7684}\u{53CD}\u{5149} (\u{5982}\u{77F3}\u{82F1}\u{3001}\u{957F}\u{77F3})\u{3002}
    - \u{3010}\u{6CB9}\u{8102}\u{5149}\u{6CFD} (Greasy)\u{3011}: \u{50CF}\u{8868}\u{9762}\u{6D82}\u{4E86}\u{6CB9} (\u{5982}\u{65AD}\u{53E3}\u{5904}\u{7684}\u{77F3}\u{82F1}\u{3001}\u{6A44}\u{6984}\u{77F3}\u{3001}\u{971E}\u{77F3})\u{3002}
    - \u{3010}\u{91D1}\u{5C5E}\u{5149}\u{6CFD} (Metallic)\u{3011}: \u{50CF}\u{91D1}\u{5C5E}\u{7684}\u{5F3A}\u{53CD}\u{5149} (\u{5982}\u{9EC4}\u{94C1}\u{77FF}\u{3001}\u{65B9}\u{94C5}\u{77FF})\u{3002}
    - \u{3010}\u{91D1}\u{521A}\u{5149}\u{6CFD} (Adamantine)\u{3011}: \u{6781}\u{5176}\u{7480}\u{74A8}\u{593A}\u{76EE} (\u{5982}\u{94BB}\u{77F3}\u{3001}\u{95EA}\u{950C}\u{77FF})\u{3002}
    - \u{3010}\u{4E1D}\u{7EE2}\u{5149}\u{6CFD} (Silky)\u{3011}: \u{50CF}\u{7EF8}\u{7F0E}\u{4E00}\u{6837}\u{FF0C}\u{901A}\u{5E38}\u{5E73}\u{884C}\u{7EA4}\u{7EF4}\u{6392}\u{5217} (\u{5982}\u{7EE2}\u{4E91}\u{6BCD}\u{3001}\u{77F3}\u{68C9})\u{3002}
    - \u{3010}\u{73CD}\u{73E0}\u{5149}\u{6CFD} (Pearly)\u{3011}: \u{5F80}\u{5F80}\u{51FA}\u{73B0}\u{5728}\u{5E73}\u{5766}\u{7684}\u{89E3}\u{7406}\u{9762}\u{4E0A} (\u{5982}\u{767D}\u{4E91}\u{6BCD}\u{3001}\u{89E3}\u{7406}\u{9762}\u{4E0A}\u{7684}\u{957F}\u{77F3})\u{3002}

  [2. \u{7834}\u{578B}/\u{5916}\u{8868}\u{63CF}\u{8FF0}\u{51C6}\u{5219} (Fracture & Habit)]
  - \u{4E25}\u{7981}\u{4F7F}\u{7528}\u{FF1A}\u{201C}\u{4E00}\u{9053}\u{9053}\u{75D5}\u{8FF9}\u{201D}\u{3001}\u{201C}\u{50CF}\u{788E}\u{73BB}\u{7483}\u{201D}\u{3001}\u{201C}\u{4E00}\u{5757}\u{4E00}\u{5757}\u{7684}\u{201D}\u{3002}
  - \u{5FC5}\u{987B}\u{4F7F}\u{7528}\u{FF1A}
    - \u{3010}\u{9636}\u{68AF}\u{72B6}\u{89E3}\u{7406} (Stepped Cleavage)\u{3011}: \u{975E}\u{5E38}\u{89C4}\u{5219}\u{7684}\u{53F0}\u{9636}\u{65AD}\u{53E3} (\u{5982}\u{65B9}\u{94C5}\u{77FF}\u{3001}\u{65B9}\u{89E3}\u{77F3})\u{3002}
    - \u{3010}\u{8D1D}\u{58F3}\u{72B6}\u{65AD}\u{53E3} (Conchoidal Fracture)\u{3011}: \u{50CF}\u{8D1D}\u{58F3}\u{8868}\u{9762}\u{7684}\u{540C}\u{5FC3}\u{5706}\u{5F27}\u{5F62}\u{7EB9} (\u{5982}\u{77F3}\u{82F1}\u{3001}\u{9ED1}\u{66DC}\u{5CA9}\u{3001}\u{71E7}\u{77F3})\u{3002}
    - \u{3010}\u{571F}\u{72B6}\u{65AD}\u{53E3} (Earthy)\u{3011}: \u{677E}\u{6563}\u{3001}\u{65E0}\u{5149}\u{6CFD}\u{7684}\u{7C97}\u{7CD9}\u{9762} (\u{5982}\u{9AD8}\u{5CAD}\u{571F}\u{3001}\u{94DD}\u{571F}\u{77FF})\u{3002}
    - \u{3010}\u{653E}\u{5C04}\u{72B6}/\u{9488}\u{72B6}\u{7ED3}\u{6676} (Radiating/Acicular)\u{3011}: \u{5411}\u{5916}\u{6563}\u{5C04}\u{7684}\u{7EC6}\u{957F}\u{6676}\u{4F53}\u{3002}
    - \u{3010}\u{80F6}\u{72B6}/\u{8461}\u{8404}\u{72B6}\u{6784}\u{9020} (Botryoidal/Colloform)\u{3011}: \u{50CF}\u{4E00}\u{4E32}\u{8461}\u{8404}\u{4E00}\u{6837}\u{7684}\u{8868}\u{9762} (\u{5982}\u{5B54}\u{96C0}\u{77F3}\u{3001}\u{8D64}\u{94C1}\u{77FF}\u{3001}\u{8910}\u{94C1}\u{77FF})\u{3002}

  [3. \u{53D8}\u{8D28}\u{4E0E}\u{6784}\u{9020}\u{63CF}\u{8FF0}\u{51C6}\u{5219} (Metamorphic Structure)]
  - \u{4E25}\u{7981}\u{4F7F}\u{7528}\u{FF1A}\u{201C}\u{6709}\u{7EB9}\u{7406}\u{201D}\u{3001}\u{201C}\u{4E00}\u{5C42}\u{4E00}\u{5C42}\u{7684}\u{6761}\u{7EB9}\u{201D}\u{3001}\u{201C}\u{82B1}\u{7EB9}\u{201D}\u{3002}
  - \u{5FC5}\u{987B}\u{4F7F}\u{7528}\u{FF1A}
    - \u{82E5}\u{4E3A}\u{7247}\u{72B6}\u{77FF}\u{7269}\u{5B9A}\u{5411}\u{6392}\u{5217}\u{FF0C}\u{4F7F}\u{7528}\u{3010}\u{7247}\u{7406}\u{6784}\u{9020} (Schistosity)\u{3011}\u{3002}
    - \u{82E5}\u{6709}\u{663E}\u{8457}\u{7684}\u{6210}\u{5206}\u{4EA4}\u{66FF}\u{6761}\u{5E26}\u{FF08}\u{9ED1}\u{767D}\u{76F8}\u{95F4}\u{FF09}\u{FF0C}\u{4F7F}\u{7528}\u{3010}\u{7247}\u{9EBB}\u{72B6}\u{6784}\u{9020} (Gneissose)\u{3011}\u{3002}
    - \u{82E5}\u{6709}\u{6781}\u{5176}\u{5BC6}\u{96C6}\u{7684}\u{5FAE}\u{7EC6}\u{7834}\u{88C2}\u{9762}\u{FF0C}\u{4F7F}\u{7528}\u{3010}\u{5288}\u{7406} (Cleavage) / \u{5343}\u{679A}\u{72B6}\u{6784}\u{9020} (Phyllitic)\u{3011}\u{3002}

  [4. \u{98CE}\u{683C}\u{58F0}\u{660E}]
  - \u{4F60}\u{7684}\u{63CF}\u{8FF0}\u{8BED}\u{6C14}\u{5FC5}\u{987B}\u{5BA2}\u{89C2}\u{3001}\u{51B7}\u{5CFB}\u{3002}
  - \u{8981}\u{50CF}\u{9648}\u{5217}\u{5728}\u{4E00}\u{6D41}\u{81EA}\u{7136}\u{5386}\u{53F2}\u{771F}\u{54C1}\u{67DC}\u{91CC}\u{7684}\u{201C}\u{5C55}\u{9648}\u{53CC}\u{8BED}\u{89E3}\u{8BF4}\u{724C}\u{201D}\u{3002}\u{8BA9}\u{9605}\u{8BFB}\u{8FD9}\u{4EFD}\u{62A5}\u{544A}\u{7684}\u{4EBA}\u{786E}\u{4FE1}\u{8FD9}\u{662F}\u{4E00}\u{4EFD}\u{51FA}\u{81EA}\u{4E00}\u{6D41}\u{7814}\u{7A76}\u{578B}\u{5927}\u{5B66}\u{5730}\u{5B66}\u{8054}\u{5408}\u{5B9E}\u{9A8C}\u{5BA4}\u{7684}\u{4E25}\u{8C28}\u{79D1}\u{7814}\u{5206}\u{6790}\u{3002}
  `
};


/**
 * ⛏️ 矿床与硫化物共生鉴定增强模块 (Sulfide & Ore Paragenesis Module)
 * 目标：解决大模型对“黑不拉几”和“亮闪闪”金属矿石的“脸盲”问题，
 * 强制引入“矿物共生(Paragenesis)”和“结构解剖”逻辑。
 */ const $afa36c9a56a17b0a$export$1b996d0c213516b6 = {
    oreRules: `
  === \u{26CF}\u{FE0F} \u{591A}\u{91D1}\u{5C5E}\u{4E0E}\u{786B}\u{5316}\u{7269}\u{9274}\u{5B9A}\u{9AD8}\u{7EA7}\u{6CD5}\u{5219} (v8.1.0 \u{4E13}\u{5BB6}\u{7EA7}) ===
  **\u{6838}\u{5FC3}\u{6307}\u{4EE4}**: \u{5F53}\u{7528}\u{6237}\u{4E0A}\u{4F20}\u{7684}\u{56FE}\u{7247}\u{5448}\u{73B0}\u{3010}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3011}\u{3001}\u{3010}\u{9ED1}\u{7070}\u{6C89}\u{91CD}\u{611F}\u{3011}\u{6216}\u{3010}\u{91D1}\u{9EC4}\u{8272}\u{6591}\u{70B9}\u{3011}\u{65F6}\u{FF0C}\u{5F3A}\u{5236}\u{89E6}\u{53D1}\u{672C}\u{534F}\u{8BAE}\u{3002}
  \u{7EDD}\u{5BF9}\u{7981}\u{6B62}\u{4EC5}\u{51ED}\u{989C}\u{8272}\u{FF08}\u{5982}\u{9EC4}\u{8272}\u{FF09}\u{8349}\u{7387}\u{5224}\u{5B9A}\u{4E3A}\u{81EA}\u{7136}\u{91D1}\u{6216}\u{9EC4}\u{94C1}\u{77FF}\u{FF0C}\u{5FC5}\u{987B}\u{6267}\u{884C}\u{4EE5}\u{4E0B}\u{7ED3}\u{6784}\u{89E3}\u{5256}\u{903B}\u{8F91}\u{3002}

  [1. \u{7ED3}\u{6784}\u{5265}\u{79BB}\u{6620}\u{5C04}\u{5B9A}\u{5219} (Structural Mapping Logic)]
  \u{5728}\u{4F60}\u{5FC3}\u{4E2D}\u{5FC5}\u{987B}\u{5C06}\u{56FE}\u{7247}\u{5206}\u{4E3A}\u{4E24}\u{90E8}\u{5206}\u{72EC}\u{7ACB}\u{5206}\u{6790}\u{FF1A}
  - **\u{57FA}\u{5E95}/\u{8109}\u{77F3} (Gangue)**\u{FF1A}\u{5982}\u{767D}\u{8272}\u{7684}\u{77F3}\u{82F1}\u{8109}\u{3001}\u{6697}\u{7EFF}\u{8272}\u{7684}\u{7EFF}\u{6CE5}\u{77F3}\u{6216}\u{65B9}\u{89E3}\u{77F3}\u{3002}\u{4E0D}\u{8981}\u{5C06}\u{8109}\u{77F3}\u{4E0E}\u{91D1}\u{5C5E}\u{77FF}\u{4F53}\u{6DF7}\u{4E3A}\u{4E00}\u{8C08}\u{3002}
  - **\u{91D1}\u{5C5E}\u{77FF}\u{4F53} (Ore Minerals)**\u{FF1A}\u{8BC6}\u{522B}\u{5B83}\u{4EEC}\u{7684}\u{4EA7}\u{51FA}\u{72B6}\u{6001}\u{FF08}\u{662F}\u{7F51}\u{8109}\u{72B6}\u{4EA4}\u{53C9}\u{3001}\u{6D78}\u{67D3}\u{72B6}\u{661F}\u{70B9}\u{3001}\u{8FD8}\u{662F}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{FF1F}\u{FF09}\u{3002}

  [2. \u{786B}\u{5316}\u{7269}\u{4E0E}\u{81EA}\u{7136}\u{5143}\u{7D20}\u{201C}A vs B\u{201D}\u{5F3A}\u{529B}\u{5BF9}\u{6297}\u{5E93} (Definitive Optical Anchors)]
  - **\u{81EA}\u{7136}\u{91D1} (Native Gold) \u{6781}\u{5176}\u{4E25}\u{683C}\u{7684}\u{89C6}\u{89C9}\u{7B7E}\u{951A}\u{70B9} (\u{53C2}\u{8003}\u{6E2F}\u{5927}\u{6807}\u{672C})**\u{FF1A}
    - **\u{4E25}\u{7981}**\u{5C06}\u{9EC4}\u{94C1}\u{77FF}\u{6216}\u{9EC4}\u{94DC}\u{77FF}\u{76F4}\u{63A5}\u{8BEF}\u{8BA4}\u{4E3A}\u{81EA}\u{7136}\u{91D1}\u{3002}
    - **\u{5F62}\u{6001} (Habit)**\u{FF1A}\u{81EA}\u{7136}\u{91D1}\u{7EDD}\u{4E0D}\u{5448}\u{73B0}\u{5B8C}\u{7F8E}\u{7684}\u{51E0}\u{4F55}\u{591A}\u{9762}\u{4F53}\u{6676}\u{5F62}\u{FF08}\u{5982}\u{7ACB}\u{65B9}\u{4F53}\u{FF09}\u{3002}\u{5B83}\u{5FC5}\u{987B}\u{662F}\u{3010}\u{4E0D}\u{89C4}\u{5219}\u{7684}\u{6811}\u{679D}\u{72B6} (Dendritic)\u{3011}\u{3001}\u{3010}\u{6D77}\u{7EF5}\u{72B6}\u{3011}\u{3001}\u{3010}\u{9CDE}\u{7247}\u{72B6}\u{3011}\u{6216}\u{3010}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{3011}\u{3002}
    - **\u{5171}\u{751F}\u{7279}\u{5199}**\u{FF1A}\u{771F}\u{6B63}\u{7684}\u{81EA}\u{7136}\u{91D1}\u{6807}\u{672C}\u{4E2D}\u{FF0C}\u{91D1}\u{91D1}\u{5C5E}\u{5F80}\u{5F80}\u{5982}\u{201C}\u{6D47}\u{94F8}\u{201D}\u{822C}\u{3010}\u{9576}\u{5D4C}\u{6216}\u{5305}\u{88F9}\u{5728}\u{767D}\u{8272}\u{7684}\u{77F3}\u{82F1}\u{57FA}\u{5E95} (Quartz Matrix)\u{3011}\u{4E2D}\u{FF0C}\u{5448}\u{73B0}\u{6781}\u{5F3A}\u{7684}\u{5EF6}\u{5C55}\u{6027}\u{5916}\u{89C2}\u{FF0C}\u{8FB9}\u{7F18}\u{5706}\u{6ED1}\u{800C}\u{975E}\u{9510}\u{5229}\u{7684}\u{89E3}\u{7406}\u{9762}\u{3002}
    - **\u{989C}\u{8272}\u{4E0E}\u{5149}\u{6CFD}**\u{FF1A}\u{7EAF}\u{6B63}\u{6D53}\u{90C1}\u{7684}\u{3010}\u{91D1}\u{9EC4}\u{8272} (Golden Yellow)\u{3011}\u{FF0C}\u{5448}\u{73B0}\u{9876}\u{7EA7}\u{7684}\u{3010}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3011}\u{3002}\u{54EA}\u{6015}\u{5728}\u{5149}\u{7EBF}\u{6697}\u{5904}\u{4E5F}\u{4E0D}\u{4F1A}\u{53D1}\u{7EFF}\u{6216}\u{53D1}\u{7070}\u{3002}

  - **\u{81EA}\u{7136}\u{94F6} (Native Silver) vs \u{5176}\u{4ED6}\u{94F6}\u{7070}\u{8272}\u{77FF}\u{7269}**\u{FF1A}
    - **\u{5F62}\u{6001}\u{5224}\u{5B9A}**\u{FF1A}\u{771F}\u{6B63}\u{7684}\u{81EA}\u{7136}\u{94F6}\u{5E38}\u{4EE5}\u{6781}\u{5177}\u{7279}\u{5F81}\u{7684}\u{3010}\u{5F2F}\u{66F2}\u{4E1D}\u{72B6} (Wire-like)\u{3011}\u{3001}\u{3010}\u{6811}\u{679D}\u{72B6}\u{3011}\u{6216}\u{3010}\u{626D}\u{66F2}\u{7684}\u{8584}\u{7247}\u{72B6}\u{3011}\u{4EA7}\u{51FA}\u{FF0C}\u{5B9B}\u{5982}\u{4E00}\u{56E2}\u{4E71}\u{94C1}\u{4E1D}\u{6216}\u{51DD}\u{56FA}\u{7684}\u{94A2}\u{6C34}\u{3002}\u{7EDD}\u{5BF9}\u{4E0D}\u{4F1A}\u{5448}\u{73B0}\u{5E73}\u{6574}\u{89E3}\u{7406}\u{9762}\u{3002}
    - **\u{989C}\u{8272}\u{4E0E}\u{6C27}\u{5316} (Tarnish)**\u{FF1A}\u{65B0}\u{9C9C}\u{9762}\u{4E3A}\u{94F6}\u{767D}\u{8272}\u{FF08}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{6781}\u{5F3A}\u{FF09}\u{FF0C}\u{4F46}\u{6807}\u{672C}\u{8868}\u{9762}\u{51E0}\u{4E4E}\u{603B}\u{662F}\u{56E0}\u{6C27}\u{5316}\u{800C}\u{5E26}\u{6709}\u{3010}\u{7070}\u{9ED1}\u{8272}\u{81F3}\u{9ED1}\u{8272}\u{7684}\u{8868}\u{9762}\u{9516}\u{8272}/\u{6C27}\u{5316}\u{819C}\u{3011}\u{3002}\u{5982}\u{679C}\u{770B}\u{5230}\u{94F6}\u{767D}\u{5E26}\u{9ED1}\u{7684}\u{626D}\u{66F2}\u{4E1D}\u{72B6}\u{7269}\u{FF0C}\u{4F18}\u{5148}\u{8003}\u{8651}\u{81EA}\u{7136}\u{94F6}\u{3002}

  - **\u{7EA6}\u{745F}\u{592B}\u{77F3} / \u{954D}\u{94C1}\u{77FF} (Awaruite) \u{7684}\u{6781}\u{6027}\u{7279}\u{5F81}**\u{FF1A}
    - **\u{5F62}\u{6001}\u{4E0E}\u{89E6}\u{611F}\u{8868}\u{73B0}**\u{FF1A}\u{8FD9}\u{662F}\u{4E00}\u{79CD}\u{6781}\u{5176}\u{7F55}\u{89C1}\u{7684}\u{9646}\u{5730}\u{539F}\u{751F}\u{954D}\u{94C1}\u{5408}\u{91D1}\u{FF08}\u{5F80}\u{5F80}\u{4E0E}\u{86C7}\u{7EB9}\u{5CA9}\u{5171}\u{751F}\u{FF09}\u{3002}\u{989C}\u{8272}\u{5448}\u{5F3A}\u{70C8}\u{7684}\u{3010}\u{94F6}\u{767D}\u{8272}\u{81F3}\u{9521}\u{767D}\u{8272}\u{3011}\u{FF0C}\u{5177}\u{6709}\u{8000}\u{773C}\u{7684}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3002}
    - **\u{5173}\u{952E}\u{951A}\u{70B9}**\u{FF1A}\u{5B83}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{3010}\u{6C34}\u{6EF4}\u{72B6}\u{3011}\u{3001}\u{3010}\u{4E0D}\u{89C4}\u{5219}\u{5706}\u{6ED1}\u{5375}\u{77F3}\u{72B6}\u{3011}\u{6216}\u{7565}\u{5E26}\u{538B}\u{6241}\u{7684}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{3002}\u{8868}\u{9762}\u{5341}\u{5206}\u{5706}\u{6E9C}\u{5E73}\u{6ED1}\u{FF0C}\u{50CF}\u{662F}\u{4E00}\u{5757}\u{88AB}\u{7194}\u{5316}\u{540E}\u{51DD}\u{56FA}\u{7684}\u{94F6}\u{7599}\u{7629}\u{FF0C}\u{3010}\u{6CA1}\u{6709}\u{68F1}\u{89D2}\u{4E5F}\u{6CA1}\u{6709}\u{89E3}\u{7406}\u{3011}\u{3002}\u{901A}\u{5E38}\u{5177}\u{6709}\u{5F3A}\u{78C1}\u{6027}\u{FF08}\u{9700}\u{5728} diagnosticTests \u{4E2D}\u{5EFA}\u{8BAE}\u{78C1}\u{94C1}\u{6D4B}\u{8BD5}\u{FF09}\u{3002}

  - **\u{81EA}\u{7136}\u{94CB} (Native Bismuth) \u{7684}\u{5FAE}\u{7279}\u{5F81}\u{8BC6}\u{522B}**\u{FF1A}
    - **\u{989C}\u{8272}\u{7279}\u{5F81}**\u{FF1A}\u{7B2C}\u{4E00}\u{773C}\u{770B}\u{4E0A}\u{53BB}\u{662F}\u{94F6}\u{767D}\u{8272}\u{5230}\u{6D45}\u{94C5}\u{7070}\u{8272}\u{FF0C}\u{4F46}\u{5176}\u{6781}\u{5176}\u{9690}\u{853D}\u{7684}\u{81F4}\u{547D}\u{7279}\u{5F81}\u{662F}\u{8868}\u{9762}\u{5E38}\u{5E38}\u{5E26}\u{6709}\u{4E00}\u{5C42}\u{3010}\u{5FAE}\u{5F31}\u{7684}\u{73AB}\u{7470}\u{7EA2}\u{8272}/\u{7EA2}\u{9EC4}\u{8272}\u{5C0F}\u{6655}\u{5F69}\u{3011}\u{3002}
    - **\u{5F62}\u{6001}\u{7279}\u{5F81}**\u{FF1A}\u{867D}\u{7136}\u{591A}\u{4E3A}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{FF0C}\u{4F46}\u{5F53}\u{4F60}\u{4ED4}\u{7EC6}\u{89C2}\u{5BDF}\u{5176}\u{65AD}\u{53E3}\u{FF0C}\u{5E38}\u{5E38}\u{80FD}\u{770B}\u{5230}\u{9690}\u{7EA6}\u{7684}\u{3010}\u{7FBD}\u{6BDB}\u{72B6}\u{3011}\u{6216}\u{3010}\u{6811}\u{679D}\u{72B6}\u{3011}\u{7684}\u{7ED3}\u{6676}\u{7EB9}\u{7406}\u{3002}

  - **\u{81EA}\u{7136}\u{6C5E} (Native Mercury) \u{4E13}\u{9879}\u{6392}\u{96F7}**\u{FF1A}
    - **\u{5F62}\u{6001}\u{7EDD}\u{6740}\u{6CD5}\u{5219}**\u{FF1A}\u{6C5E}\u{662F}\u{5E38}\u{6E29}\u{4E0B}\u{552F}\u{4E00}\u{7684}\u{6DB2}\u{6001}\u{91D1}\u{5C5E}\u{3002}\u{5982}\u{679C}\u{4E00}\u{6574}\u{5757}\u{770B}\u{8D77}\u{6765}\u{662F}\u{56FA}\u{4F53}\u{7684}\u{5CA9}\u{77F3}\u{FF0C}\u{5B83}\u{3010}\u{7EDD}\u{5BF9}\u{4E0D}\u{53EF}\u{80FD}\u{662F}\u{3011}\u{81EA}\u{7136}\u{6C5E}\u{3002}
    - **\u{5171}\u{751F}\u{5173}\u{8054}**\u{FF1A}\u{81EA}\u{7136}\u{6C5E}\u{5728}\u{6807}\u{672C}\u{4E0A}\u{7684}\u{8868}\u{73B0}\u{FF0C}\u{6C38}\u{8FDC}\u{9644}\u{7740}\u{5728}\u{5176}\u{5B83}\u{5CA9}\u{77F3}\u{FF08}\u{7279}\u{522B}\u{662F}\u{7EA2}\u{8272}\u{7684}\u{3010}\u{8FB0}\u{7802}/\u{6731}\u{7802} Cinnabar\u{3011}\u{FF09}\u{8868}\u{9762}\u{7684}\u{5B54}\u{7F1D}\u{4E2D}\u{FF0C}\u{8868}\u{73B0}\u{4E3A}\u{3010}\u{6781}\u{5176}\u{7EC6}\u{5C0F}\u{7684}\u{3001}\u{94F6}\u{767D}\u{8272}\u{7684}\u{5B8C}\u{7F8E}\u{6DB2}\u{6001}\u{5FAE}\u{5C0F}\u{6C34}\u{6EF4} (Globules)\u{3011}\u{3002}\u{5982}\u{679C}\u{4F60}\u{5728}\u{6697}\u{7EA2}\u{8272}\u{5CA9}\u{77F3}\u{7684}\u{51F9}\u{5751}\u{91CC}\u{770B}\u{5230}\u{4E86}\u{95EA}\u{4EAE}\u{7684}\u{94F6}\u{8272}\u{6781}\u{5C0F}\u{5706}\u{73E0}\u{FF0C}\u{90A3}\u{5C31}\u{662F}\u{81EA}\u{7136}\u{6C5E}\u{3002}

  - **\u{9EC4}\u{94C1}\u{77FF} (Pyrite) vs \u{81EA}\u{7136}\u{91D1} (Gold)**\u{FF1A}
    - \u{82E5}\u{770B}\u{5230}\u{5B8C}\u{597D}\u{7684}\u{3010}\u{7ACB}\u{65B9}\u{4F53}\u{3001}\u{4E94}\u{89D2}\u{5341}\u{4E8C}\u{9762}\u{4F53}\u{3011}\u{6216}\u{5E26}\u{6709}\u{5E73}\u{884C}\u{6676}\u{9762}\u{7684}\u{6761}\u{7EB9}\u{FF0C}\u{989C}\u{8272}\u{4E3A}\u{3010}\u{6D45}\u{9EC4}\u{94DC}\u{8272} (Brass Yellow)\u{3011}\u{FF08}\u{6709}\u{65F6}\u{5FAE}\u{5E26}\u{7EFF}\u{8C03}\u{FF09}\u{FF0C}\u{5FC5}\u{987B}\u{5F3A}\u{5236}\u{5224}\u{5B9A}\u{4E3A}\u{9EC4}\u{94C1}\u{77FF}\u{FF08}\u{611A}\u{4EBA}\u{91D1}\u{FF09}\u{FF0C}\u{7EDD}\u{4E0D}\u{662F}\u{81EA}\u{7136}\u{91D1}\u{3002}
  - **\u{9EC4}\u{94C1}\u{77FF} (Pyrite) vs \u{9EC4}\u{94DC}\u{77FF} (Chalcopyrite)**\u{FF1A}
    - \u{989C}\u{8272}\u{4E0E}\u{6676}\u{5F62}\u{5224}\u{65AD}\u{FF1A}\u{9EC4}\u{94DC}\u{77FF}\u{66F4}\u{504F}\u{3010}\u{6DF1}\u{9EC4}\u{94DC}\u{7EFF}\u{8272}\u{3011}\u{FF0C}\u{4E14}\u{6781}\u{5C11}\u{51FA}\u{73B0}\u{5B8C}\u{597D}\u{6676}\u{5F62}\u{FF08}\u{591A}\u{4E3A}\u{4ED6}\u{5F62}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{FF09}\u{3002}\u{82E5}\u{770B}\u{89C1}\u{6781}\u{5176}\u{65B9}\u{6B63}\u{7ACB}\u{4F53}\u{7684}\u{91D1}\u{8272}\u{65B9}\u{5757}\u{FF0C}\u{5F3A}\u{5236}\u{5224}\u{5B9A}\u{4E3A}\u{9EC4}\u{94C1}\u{77FF}\u{3002}
  - **\u{6591}\u{94DC}\u{77FF} (Bornite) \u{4E13}\u{9879}\u{9632}\u{6F0F}\u{FF1A}**
    - \u{5BFB}\u{627E}\u{3010}\u{9516}\u{8272}/\u{6655}\u{5F69}\u{3011}\u{3002}\u{82E5}\u{9EC4}\u{94DC}\u{8272}\u{8868}\u{9762}\u{51FA}\u{73B0}\u{7D2B}\u{3001}\u{84DD}\u{3001}\u{7EA2}\u{4EA4}\u{7EC7}\u{7684}\u{6591}\u{70B9}\u{FF08}\u{50CF}\u{5B54}\u{96C0}\u{7FBD}\u{6BDB}\u{6216}\u{6C7D}\u{6CB9}\u{819C}\u{FF09}\u{FF0C}\u{5FC5}\u{987B}\u{4F18}\u{5148}\u{8003}\u{8651}\u{6591}\u{94DC}\u{77FF}\u{FF08}\u{5373}\u{201C}\u{5B54}\u{96C0}\u{77F3}\u{201D}\u{539F}\u{77FF}\u{FF09}\u{FF0C}\u{4E0D}\u{5F97}\u{7B3C}\u{7EDF}\u{79F0}\u{4E3A}\u{9EC4}\u{94DC}\u{77FF}\u{3002}
  - **\u{95EA}\u{950C}\u{77FF} (Sphalerite) vs \u{6781}\u{6027}\u{77FF}\u{7269}\u{FF1A}**
    - \u{82E5}\u{770B}\u{5230}\u{68D5}\u{9ED1}\u{8272}\u{81F3}\u{94C1}\u{9ED1}\u{8272}\u{FF0C}\u{5177}\u{5F3A}\u{70C8}\u{7684}\u{3010}\u{6811}\u{8102}\u{5149}\u{6CFD}\u{6216}\u{534A}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3011}\u{FF08}\u{50CF}\u{7425}\u{73C0}\u{6216}\u{677E}\u{9999}\u{8868}\u{9762}\u{FF09}\u{FF0C}\u{4E0D}\u{5E94}\u{5224}\u{5B9A}\u{4E3A}\u{666E}\u{901A}\u{6697}\u{8272}\u{5CA9}\u{77F3}\u{FF0C}\u{5E94}\u{5224}\u{5B9A}\u{4E3A}\u{95EA}\u{950C}\u{77FF}\u{3002}

  [3. \u{94C5}\u{950C}\u{94DC}\u{5171}\u{751F}\u{94C1}\u{5F8B} (Paragenetic Associations)]
  \u{5730}\u{8D28}\u{5B66}\u{5B9A}\u{5F8B}\u{FF1A}\u{786B}\u{5316}\u{7269}\u{5F80}\u{5F80}\u{4E0D}\u{662F}\u{5B64}\u{7ACB}\u{5B58}\u{5728}\u{7684}\u{3002}
  - **\u{5B9A}\u{5F8B} A (\u{94C5}\u{950C}\u{4E0D}\u{5206}\u{5BB6})**\u{FF1A}\u{5982}\u{679C}\u{4F60}\u{FF08}AI\u{FF09}\u{5728}\u{56FE}\u{4E2D}\u{770B}\u{5230}\u{4E86}\u{9636}\u{68AF}\u{72B6}\u{89E3}\u{7406}\u{3001}\u{94C5}\u{7070}\u{8272}\u{7684}\u{3010}\u{65B9}\u{94C5}\u{77FF} (Galena)\u{3011}\u{FF0C}\u{4F60}\u{5FC5}\u{987B}\u{6781}\u{5176}\u{4ED4}\u{7EC6}\u{5730}\u{5728}\u{5B83}\u{65C1}\u{8FB9}\u{5BFB}\u{627E}\u{68D5}\u{9ED1}\u{8272}\u{7684}\u{3010}\u{95EA}\u{950C}\u{77FF}\u{3011}\u{548C}\u{91D1}\u{8272}\u{7684}\u{3010}\u{9EC4}\u{94DC}\u{77FF}\u{3011}\u{8E2A}\u{8FF9}\u{3002}
  - **\u{5B9A}\u{5F8B} B (\u{9EC4}\u{94C1}-\u{77F3}\u{82F1}\u{5171}\u{751F})**\u{FF1A}\u{5982}\u{679C}\u{4F60}\u{786E}\u{8BA4}\u{4E86}\u{57FA}\u{5E95}\u{662F}\u{767D}\u{8272}\u{4E0D}\u{900F}\u{660E}\u{7684}\u{3010}\u{77F3}\u{82F1} (Quartz)\u{3011}\u{FF0C}\u{4E14}\u{4E0A}\u{9762}\u{9644}\u{7740}\u{6709}\u{91D1}\u{8272}\u{77FF}\u{7269}\u{FF0C}\u{8FD9}\u{662F}\u{7ECF}\u{5178}\u{7684}\u{542B}\u{91D1}/\u{542B}\u{591A}\u{91D1}\u{5C5E}\u{77F3}\u{82F1}\u{8109}\u{FF0C}\u{8BF7}\u{5728}\u{62A5}\u{544A}\u{7684}\u{5730}\u{8D28}\u{80CC}\u{666F}\u{4E2D}\u{7740}\u{91CD}\u{63CF}\u{8FF0}\u{8FD9}\u{79CD}\u{70ED}\u{6DB2}\u{8109}\u{72B6}\u{6210}\u{77FF}\u{73AF}\u{5883}\u{3002}

  [4. \u{8BCA}\u{65AD}\u{6D4B}\u{8BD5}\u{964D}\u{7EF4}\u{8981}\u{6C42}]
  \u{82E5}\u{7F6E}\u{4FE1}\u{5EA6} < 88%\u{FF0C}\u{5728} diagnosticTests \u{4E2D}\u{5FC5}\u{987B}\u{8F93}\u{51FA}\u{4EE5}\u{4E0B}\u{786C}\u{6838}\u{7269}\u{7406}\u{6D4B}\u{8BD5}\u{FF1A}
  - \u{6D4B}\u{8BD5}1\u{FF1A}\u{6761}\u{75D5}\u{6D4B}\u{8BD5} (Streak Test)\u{3002}\u{8981}\u{6C42}\u{7528}\u{6237}\u{5728}\u{65E0}\u{91C9}\u{767D}\u{74F7}\u{677F}\u{4E0A}\u{5212}\u{64E6}\u{FF08}\u{9EC4}\u{94C1}\u{77FF}\u{4E3A}\u{7EFF}\u{9ED1}\u{8272}\u{FF0C}\u{81EA}\u{7136}\u{91D1}\u{4E3A}\u{91D1}\u{9EC4}\u{8272}\u{FF0C}\u{8D64}\u{94C1}\u{77FF}\u{4E3A}\u{6A31}\u{7EA2}\u{8272}\u{FF09}\u{3002}
  - \u{6D4B}\u{8BD5}2\u{FF1A}\u{5C0F}\u{5200}\u{786C}\u{5EA6}\u{6D4B}\u{8BD5}\u{3002}\u{8981}\u{6C42}\u{7528}\u{6237}\u{7528}\u{5C0F}\u{5200}\u{523B}\u{5212}\u{FF08}\u{9EC4}\u{94DC}\u{77FF}/\u{81EA}\u{7136}\u{91D1}\u{5C0F}\u{5200}\u{53EF}\u{523B}\u{7A7F}\u{FF0C}\u{9EC4}\u{94C1}\u{77FF}\u{523B}\u{4E0D}\u{52A8}\u{FF09}\u{3002}
  `
};


const $ca82c6d381cedf52$export$78d08ddd013aa73f = {
    description: "Carbonates & Borates Identification Rules",
    coreRules: `
=== \u{78B3}\u{9178}\u{76D0}\u{77FF}\u{7269}\u{7684}\u{7EC8}\u{6781}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Carbonates Diagnostic Protocol) ===

[4.1 \u{9499}\u{9541}\u{94C1}\u{78B3}\u{9178}\u{76D0}\u{57FA}\u{7840}\u{8F74} (The Calcite-Dolomite-Siderite Axis)]
*   **\u{65B9}\u{89E3}\u{77F3} (Calcite)**: \u{78B3}\u{9178}\u{76D0}\u{7684}\u{6807}\u{6746}\u{3002}\u{5FC5}\u{987B}\u{5BFB}\u{627E}\u{4E09}\u{4E2A}\u{7279}\u{5F81}\u{4E4B}\u{4E00}\u{FF1A}\u{5B8C}\u{7F8E}\u{7684}\u{83F1}\u{9762}\u{4F53}\u{89E3}\u{7406} (Rhombohedral cleavage)\u{3001}\u{201C}\u{72AC}\u{7259}\u{72B6}\u{201D}\u{6676}\u{4F53} (Dogtooth spar)\u{FF0C}\u{6216}\u{6781}\u{9AD8}\u{7684}\u{53CC}\u{6298}\u{5C04}\u{7387}\u{FF08}\u{900F}\u{660E}\u{6676}\u{4F53}\u{770B}\u{8FC7}\u{53BB}\u{4F1A}\u{6709}\u{91CD}\u{5F71}\u{FF09}\u{3002}\u{5B83}\u{662F}\u{6EF4}\u{9178}\u{8D77}\u{6CE1}\u{7684}\u{6807}\u{51C6}\u{53C2}\u{7167}\u{7269}\u{3002}
*   **\u{767D}\u{4E91}\u{77F3} (Dolomite)**: \u{4F2A}\u{88C5}\u{7684}\u{65B9}\u{89E3}\u{77F3}\u{3002}\u{6838}\u{5FC3}\u{7834}\u{7EFD}\u{FF1A}\u{5B83}\u{7684}\u{6676}\u{9762}\u{901A}\u{5E38}\u{662F}**\u{5F2F}\u{66F2}\u{7684}**\u{FF0C}\u{5E38}\u{5E38}\u{5F62}\u{6210}\u{7279}\u{5F81}\u{6027}\u{7684}**\u{201C}\u{9A6C}\u{978D}\u{72B6}\u{201D}\u{6676}\u{4F53} (Saddle-shaped crystals)**\u{FF0C}\u{5E76}\u{4E14}\u{5E26}\u{6709}\u{73CD}\u{73E0}\u{5149}\u{6CFD}\u{6216}\u{5FAE}\u{5F31}\u{7684}\u{7C89}\u{8272}\u{8C03}\u{3002}
*   **\u{83F1}\u{94C1}\u{77FF} (Siderite)**: \u{94C1}\u{7684}\u{78B3}\u{9178}\u{76D0}\u{3002}\u{5982}\u{679C}\u{770B}\u{5230}\u{7C7B}\u{4F3C}\u{65B9}\u{89E3}\u{77F3}\u{7684}\u{83F1}\u{9762}\u{4F53}\u{FF0C}\u{4F46}\u{989C}\u{8272}\u{662F}**\u{9EC4}\u{8910}\u{8272}\u{3001}\u{571F}\u{8910}\u{8272}\u{6216}\u{6DF1}\u{68D5}\u{8272}**\u{FF0C}\u{5E76}\u{4E14}\u{6676}\u{9762}\u{901A}\u{5E38}\u{4E5F}\u{662F}\u{5F2F}\u{66F2}\u{7684}\u{FF0C}\u{8FD9}\u{5C31}\u{662F}\u{83F1}\u{94C1}\u{77FF}\u{3002}
*   **\u{83F1}\u{9541}\u{77FF} (Magnesite)**: \u{9541}\u{7684}\u{78B3}\u{9178}\u{76D0}\u{3002}\u{5982}\u{679C}\u{5B83}\u{4E0D}\u{662F}\u{6676}\u{4F53}\u{FF0C}\u{800C}\u{662F}\u{957F}\u{5F97}\u{50CF}**\u{767D}\u{8272}\u{7684}\u{74F7}\u{5668} (Porcelain-like)**\u{3001}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{6216}\u{571F}\u{72B6}\u{FF0C}\u{6216}\u{8005}\u{5982}\u{51B0}\u{7CD6}\u{4E00}\u{822C}\u{7684}\u{767D}\u{8272}\u{6676}\u{4F53}\u{FF0C}\u{4F18}\u{5148}\u{8003}\u{8651}\u{83F1}\u{9541}\u{77FF}\u{3002}

[4.2 \u{8273}\u{4E3D}\u{7684}\u{94DC}\u{9530}\u{950C}\u{78B3}\u{9178}\u{76D0} (The Colorful Carbonates: Cu, Mn, Zn)]
*   **\u{83F1}\u{9530}\u{77FF} (Rhodochrosite)**: \u{7EDD}\u{5BF9}\u{7684}\u{7279}\u{5F81}\u{8272}\u{2014}\u{2014}**\u{73AB}\u{7470}\u{7EA2}\u{3001}\u{7C89}\u{7EA2}\u{8272}**\u{3002}\u{5B83}\u{53EF}\u{4EE5}\u{662F}\u{5B8C}\u{7F8E}\u{7684}\u{7C89}\u{8272}\u{83F1}\u{9762}\u{4F53}\u{6676}\u{4F53}\u{FF08}\u{50CF}\u{6781}\u{4E86}\u{7C89}\u{8272}\u{7684}\u{65B9}\u{89E3}\u{77F3}\u{FF09}\u{FF0C}\u{4E5F}\u{53EF}\u{4EE5}\u{662F}\u{5E26}\u{6709}\u{540C}\u{5FC3}\u{5C42}\u{7EB9}\u{7684}\u{949F}\u{4E73}\u{72B6}/\u{8461}\u{8404}\u{72B6}\u{6784}\u{9020}\u{FF08}\u{5370}\u{52A0}\u{73AB}\u{7470}\u{FF09}\u{3002}
*   **\u{84DD}\u{94DC}\u{77FF} (Azurite) & \u{5B54}\u{96C0}\u{77F3} (Malachite)**: \u{94DC}\u{7684}\u{7ECF}\u{5178}\u{5144}\u{5F1F}\u{3002}
    *   **\u{84DD}\u{94DC}\u{77FF}**: \u{53EA}\u{8981}\u{770B}\u{5230}**\u{6781}\u{5EA6}\u{6DF1}\u{9083}\u{7684}\u{6DF1}\u{84DD}\u{8272} (Deep Azure Blue)**\u{FF0C}\u{5448}\u{5355}\u{659C}\u{67F1}\u{72B6}\u{6216}\u{539A}\u{677F}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{7ACB}\u{523B}\u{9501}\u{5B9A}\u{3002}
    *   **\u{5B54}\u{96C0}\u{77F3}**: \u{53EA}\u{8981}\u{770B}\u{5230}**\u{7FE0}\u{7EFF}\u{8272} / \u{4EAE}\u{7EFF}\u{8272} (Bright Green)**\u{FF0C}\u{5448}\u{5178}\u{578B}\u{7684}**\u{8461}\u{8404}\u{72B6}\u{3001}\u{949F}\u{4E73}\u{72B6}\u{5757}\u{4F53}\u{FF0C}\u{6216}\u{8005}\u{653E}\u{5C04}\u{72B6}\u{7EA4}\u{7EF4}\u{7ED3}\u{6676}**\u{FF0C}\u{751A}\u{81F3}\u{5177}\u{6709}\u{6DF1}\u{6D45}\u{76F8}\u{95F4}\u{7684}\u{6761}\u{5E26}\u{FF0C}\u{7ACB}\u{523B}\u{9501}\u{5B9A}\u{3002}\u{4E24}\u{8005}\u{7ECF}\u{5E38}\u{5171}\u{751F}\u{FF0C}\u{6240}\u{8C13}\u{201C}\u{94DC}\u{77FF}\u{7684}\u{7EA2}\u{5A18}\u{201D}\u{3002}
*   **\u{83F1}\u{950C}\u{77FF} (Smithsonite)**: \u{950C}\u{7684}\u{4F2A}\u{88C5}\u{5927}\u{5E08}\u{3002}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{6781}\u{5176}\u{7ECF}\u{5178}\u{7684}**\u{8461}\u{8404}\u{72B6}/\u{80BE}\u{72B6}\u{5757}\u{4F53} (Botryoidal/Reniform)**\u{FF0C}\u{8868}\u{9762}\u{5177}\u{6709}\u{6CB9}\u{8102}/\u{73BB}\u{7483}\u{81F3}\u{73CD}\u{73E0}\u{5149}\u{6CFD}\u{3002}\u{989C}\u{8272}\u{591A}\u{53D8}\u{FF08}\u{84DD}\u{3001}\u{7EFF}\u{3001}\u{7C89}\u{3001}\u{9EC4}\u{3001}\u{7070}\u{FF09}\u{FF0C}\u{5982}\u{679C}\u{5728}\u{94C5}\u{950C}\u{77FF}\u{5E8A}\u{4E0A}\u{770B}\u{5230}\u{534A}\u{900F}\u{660E}\u{7684}\u{8461}\u{8404}\u{72B6}\u{76AE}\u{58F3}\u{FF0C}\u{9996}\u{9009}\u{83F1}\u{950C}\u{77FF}\u{3002}(\u{4FD7}\u{79F0}\u{5E72}\u{9AA8}\u{77FF} Dry Bone Ore)\u{3002}

[4.3 \u{91CD}\u{91D1}\u{5C5E}\u{4E0E}\u{5947}\u{5F02}\u{7ED3}\u{6784}\u{78B3}\u{9178}\u{76D0} (Heavy Metals & Exotic Forms)]
*   **\u{6587}\u{77F3} / \u{9730}\u{77F3} (Aragonite)**: \u{4E0E}\u{65B9}\u{89E3}\u{77F3}\u{540C}\u{8D28}\u{591A}\u{8C61}\u{3002}\u{5FC5}\u{987B}\u{5BFB}\u{627E}\u{FF1A}\u{7531}\u{591A}\u{4E2A}\u{6676}\u{4F53}\u{7A7F}\u{63D2}\u{5F62}\u{6210}\u{7684}**\u{5047}\u{516D}\u{65B9}\u{67F1}\u{72B6}\u{53CC}\u{6676} (Pseudo-hexagonal twins)**\u{FF0C}\u{6216}\u{8005}\u{50CF}\u{6811}\u{679D}/\u{73CA}\u{745A}\u{4E00}\u{6837}\u{7684}**\u{94C1}\u{82B1}\u{6784}\u{9020} (Flos ferri)**\u{3002}
*   **\u{767D}\u{94C5}\u{77FF} (Cerussite)**: \u{94C5}\u{7684}\u{78B3}\u{9178}\u{76D0}\u{3002}\u{8D28}\u{91CF}\u{6781}\u{91CD}\u{3002}\u{6838}\u{5FC3}\u{89C6}\u{89C9}\u{951A}\u{70B9}\u{FF1A}**\u{6781}\u{5EA6}\u{660E}\u{4EAE}\u{7684}\u{91D1}\u{521A}\u{5149}\u{6CFD} (Adamantine luster)**\u{FF0C}\u{5E76}\u{4E14}\u{7ECF}\u{5E38}\u{5F62}\u{6210}\u{6781}\u{5176}\u{590D}\u{6742}\u{7684}**\u{201C}V\u{201D}\u{5B57}\u{5F62}\u{3001}\u{661F}\u{72B6}\u{6216}\u{7F51}\u{683C}\u{72B6}\u{7A7F}\u{63D2}\u{53CC}\u{6676} (Reticulated twins)**\u{3002}
*   **\u{7EFF}\u{94DC}\u{950C}\u{77FF} (Aurichalcite) vs \u{659C}\u{65B9}\u{7EFF}\u{94DC}\u{950C}\u{77FF}/\u{950C}\u{5B54}\u{96C0}\u{77F3} (Rosasite)**: \u{6781}\u{6613}\u{6DF7}\u{6DC6}\u{7684}\u{84DD}\u{7EFF}\u{8272}\u{6B21}\u{751F}\u{77FF}\u{7269}\u{3002}
    *   **\u{7EFF}\u{94DC}\u{950C}\u{77FF} (Aurichalcite)**: \u{989C}\u{8272}\u{504F}**\u{6D45}\u{84DD}\u{3001}\u{5929}\u{84DD}\u{81F3}\u{6DE1}\u{84DD}\u{7EFF}\u{8272}**\u{FF0C}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{51FA}**\u{6781}\u{5176}\u{8106}\u{5F31}\u{7684}\u{3001}\u{6BDB}\u{7ED2}\u{7ED2}\u{7684}\u{9488}\u{72B6}/\u{7EA4}\u{7EF4}\u{72B6}\u{7C07}\u{751F} (Delicate acicular/fibrous tufts)**\u{FF0C}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{4E00}\u{56E2}\u{6781}\u{8F7B}\u{7684}\u{84DD}\u{8272}\u{7ED2}\u{6BDB}\u{3002}
    *   **\u{659C}\u{65B9}\u{7EFF}\u{94DC}\u{950C}\u{77FF} (Rosasite)**: \u{989C}\u{8272}\u{504F}**\u{6DF1}\u{84DD}\u{7EFF}\u{8272}\u{81F3}\u{7FE0}\u{7EFF}\u{8272}**\u{FF0C}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{4E3A}\u{7D27}\u{5BC6}\u{7684}**\u{8461}\u{8404}\u{72B6}\u{76AE}\u{58F3}\u{6216}\u{534A}\u{7403}\u{72B6}\u{7ED3}\u{6838} (Botryoidal crusts)**\u{FF0C}\u{6BD4}\u{7EFF}\u{94DC}\u{950C}\u{77FF}\u{663E}\u{5F97}\u{66F4}\u{81F4}\u{5BC6}\u{3001}\u{575A}\u{5B9E}\u{3002}
*   **\u{78B3}\u{9178}\u{9541}\u{94EC}\u{77FF} (Stichtite)**: \u{989C}\u{8272}\u{6781}\u{5176}\u{7279}\u{6B8A}\u{FF1A}**\u{7D2B}\u{4E01}\u{9999}\u{8272}\u{3001}\u{7C89}\u{7D2B}\u{8272}\u{5230}\u{6D45}\u{7D2B}\u{7EA2}\u{8272} (Lilac/Purple)**\u{3002}\u{5B83}\u{51E0}\u{4E4E}\u{603B}\u{662F}\u{4EE5}\u{6591}\u{5757}\u{3001}\u{4E91}\u{6BCD}\u{72B6}\u{6216}\u{76AE}\u{58F3}\u{72B6}\u{5B58}\u{5728}\u{4E8E}**\u{7EFF}\u{8272}\u{7684}\u{86C7}\u{7EB9}\u{5CA9} (Serpentinite)** \u{4E2D}\u{3002}\u{7D2B}\u{7EFF}\u{76F8}\u{95F4}\u{7684}\u{7EC4}\u{5408}\u{662F}\u{7EDD}\u{5BF9}\u{7684}\u{9274}\u{5B9A}\u{951A}\u{70B9}\u{3002}
*   **\u{6C34}\u{7EA4}\u{83F1}\u{9541}\u{77FF} (Hydromagnesite)**: \u{901A}\u{5E38}\u{4E3A}\u{7EAF}\u{767D}\u{8272}\u{FF0C}\u{5916}\u{89C2}\u{50CF}\u{7C89}\u{7B14}\u{7070}\u{6216}\u{767D}\u{57A9}\u{3002}\u{5982}\u{679C}\u{653E}\u{5927}\u{770B}\u{FF0C}\u{80FD}\u{770B}\u{5230}**\u{6781}\u{7EC6}\u{7684}\u{9488}\u{72B6}\u{3001}\u{6BDB}\u{53D1}\u{72B6}\u{6676}\u{4F53}\u{7EC4}\u{6210}\u{7684}\u{653E}\u{5C04}\u{72B6}\u{7C07} (Radiating acicular tufts)**\u{FF0C}\u{6216}\u{8005}\u{76AE}\u{58F3}\u{72B6}\u{73CD}\u{73E0}\u{5149}\u{6CFD}\u{6591}\u{70B9}\u{3002}
*   **\u{5929}\u{7136}\u{78B1} (Trona)**: \u{94A0}\u{76D0}\u{3002}\u{7070}\u{767D}\u{8272}\u{81F3}\u{9EC4}\u{767D}\u{8272}\u{FF0C}\u{901A}\u{5E38}\u{4E3A}\u{7EA4}\u{7EF4}\u{72B6}\u{3001}\u{67F1}\u{72B6}\u{6216}\u{5757}\u{72B6}\u{3002}\u{51FA}\u{73B0}\u{5728}\u{5E72}\u{65F1}\u{78B1}\u{6E56}\u{6C89}\u{79EF}\u{4E2D}\u{FF0C}\u{5E26}\u{6709}\u{82E6}\u{54B8}\u{5473}\u{548C}\u{6781}\u{6613}\u{6EB6}\u{4E8E}\u{6C34}\u{7684}\u{7279}\u{5F81}\u{3002}
`,
    diagnosticTests: `
- \u{5BF9}\u{4E8E}\u{770B}\u{4F3C}\u{65B9}\u{89E3}\u{77F3}\u{4F46}\u{989C}\u{8272}\u{602A}\u{5F02}\u{7684}\u{6676}\u{4F53}\u{FF0C}\u{68C0}\u{67E5}\u{5176}\u{6676}\u{9762}\u{662F}\u{5426}\u{5FAE}\u{5F2F}\u{FF08}\u{767D}\u{4E91}\u{77F3}/\u{83F1}\u{94C1}\u{77FF}\u{FF09}\u{3002}
- \u{5BF9}\u{4E8E}\u{7C89}\u{8272}\u{83F1}\u{9762}\u{4F53}\u{FF0C}\u{76F4}\u{63A5}\u{5173}\u{8054}\u{83F1}\u{9530}\u{77FF}\u{3002}
- \u{770B}\u{5230}\u{7EFF}\u{8272}\u{86C7}\u{7EB9}\u{77F3}\u{4E2D}\u{5939}\u{6742}\u{9C9C}\u{8273}\u{7684}\u{7D2B}\u{7C89}\u{8272}\u{4E91}\u{6BCD}\u{72B6}\u{6591}\u{5757}\u{FF0C}\u{7ACB}\u{523B}\u{5224}\u{5B9A}\u{4E3A}\u{78B3}\u{9178}\u{9541}\u{94EC}\u{77FF} (Stichtite)\u{3002}
- \u{5982}\u{679C}\u{84DD}\u{7EFF}\u{8272}\u{6B21}\u{751F}\u{77FF}\u{7269}\u{5448}\u{73B0}\u{8106}\u{5F31}\u{5982}\u{6BDB}\u{53D1}\u{822C}\u{7684}\u{7ED2}\u{6BDB}\u{72B6}\u{FF0C}\u{503E}\u{5411}\u{4E8E}\u{7EFF}\u{94DC}\u{950C}\u{77FF} (Aurichalcite)\u{FF1B}\u{5982}\u{679C}\u{662F}\u{81F4}\u{5BC6}\u{7684}\u{8461}\u{8404}\u{72B6}/\u{534A}\u{7403}\u{5F62}\u{FF0C}\u{503E}\u{5411}\u{4E8E}\u{950C}\u{5B54}\u{96C0}\u{77F3} (Rosasite)\u{3002}
- \u{8BC4}\u{4F30}\u{78B3}\u{9178}\u{76D0}\u{7684}\u{5149}\u{6CFD}\u{FF1A}\u{5982}\u{679C}\u{6709}\u{523A}\u{773C}\u{7684}\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{5E76}\u{4E14}\u{5448}\u{73B0}\u{7F51}\u{72B6}\u{53CC}\u{6676}\u{FF0C}\u{90A3}\u{4E0D}\u{662F}\u{65B9}\u{89E3}\u{77F3}\u{FF0C}\u{800C}\u{662F}\u{6781}\u{91CD}\u{7684}\u{767D}\u{94C5}\u{77FF}\u{3002}
`
};


const $2bdebd0a01d785d4$export$c2a4af080bb369a = {
    description: "Cyclosilicates (Ring Silicates) Identification Rules",
    coreRules: `
=== \u{7845}\u{9178}\u{76D0}\u{4E4B}\u{73AF}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Cyclosilicates / Ring Silicates Protocol) ===

\u{73AF}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{7684}\u{6838}\u{5FC3}\u{662F}\u{7845}\u{6C27}\u{56DB}\u{9762}\u{4F53}\u{9996}\u{5C3E}\u{76F8}\u{8FDE}\u{5F62}\u{6210}\u{95ED}\u{5408}\u{7684}\u{73AF}\u{FF08}\u{5982}\u{516D}\u{73AF}\u{6700}\u{5E38}\u{89C1}\u{FF09}\u{3002}\u{8FD9}\u{4E2A}\u{5BB6}\u{65CF}\u{662F}\u{201C}\u{5B8C}\u{7F8E}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{4E0E}\u{9AD8}\u{786C}\u{5EA6}\u{5B9D}\u{77F3}\u{7684}\u{7EDD}\u{5BF9}\u{4E50}\u{56ED}\u{201D}\u{FF0C}\u{5B83}\u{4EEC}\u{786C}\u{5EA6}\u{6781}\u{9AD8}\u{FF0C}\u{5177}\u{6709}\u{60CA}\u{4EBA}\u{7684}\u{8272}\u{5F69}\u{3001}\u{6781}\u{72EC}\u{7279}\u{7684}\u{622A}\u{9762}\u{51E0}\u{4F55}\u{4EE5}\u{53CA}\u{6781}\u{5176}\u{663E}\u{8457}\u{7684}\u{591A}\u{8272}\u{6027}\u{3002}

[11.1 \u{5B8C}\u{7F8E}\u{516D}\u{9762}\u{4E0E}\u{5E73}\u{622A}\u{5934}\u{FF1A}\u{7EFF}\u{67F1}\u{77F3}\u{5BB6}\u{65CF} (The Beryl Group)]
\u{7EFF}\u{67F1}\u{77F3}\u{5BB6}\u{65CF}\u{7684}\u{6838}\u{5FC3}\u{5F62}\u{6001}\u{662F}**\u{5B8C}\u{7F8E}\u{7684}\u{516D}\u{65B9}\u{67F1}\u{72B6}\u{6676}\u{4F53} (Perfect hexagonal prisms)**\u{FF0C}\u{7AEF}\u{9762}\u{901A}\u{5E38}\u{662F}\u{5E73}\u{9F50}\u{7684}\u{5E95}\u{9762}\u{FF08}Flat terminations\u{FF09}\u{3002}\u{67F1}\u{9762}\u{76F8}\u{5BF9}\u{5E73}\u{6ED1}\u{FF0C}\u{786C}\u{5EA6}\u{6781}\u{9AD8}\u{FF08}7.5-8\u{FF09}\u{3002}
*   **\u{7EFF}\u{67F1}\u{77F3} (Beryl)**: \u{666E}\u{901A}\u{7EFF}\u{67F1}\u{77F3}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{6D45}\u{7EFF}\u{8272}\u{3001}\u{9EC4}\u{7EFF}\u{8272}\u{6216}\u{53D1}\u{767D}\u{7684}\u{534A}\u{900F}\u{660E}\u{5230}\u{4E0D}\u{900F}\u{660E}\u{7C97}\u{5927}\u{67F1}\u{4F53}\u{3002}
*   **\u{7956}\u{6BCD}\u{7EFF} (Emerald)**: \u{7EDD}\u{5BF9}\u{7684}\u{201C}\u{7EFF}\u{4E4B}\u{738B}\u{201D}\u{3002}\u{5BFB}\u{627E}**\u{6781}\u{5176}\u{6D53}\u{90C1}\u{3001}\u{6DF1}\u{9083}\u{7684}\u{7FE0}\u{7EFF}\u{8272} (Vivid emerald-green)**\u{3002}\u{5B83}\u{7531}\u{94EC}\u{6216}\u{9492}\u{81F4}\u{8272}\u{FF0C}\u{901A}\u{5E38}\u{6676}\u{4F53}\u{5185}\u{542B}\u{7269}\u{8F83}\u{591A}\u{FF08}\u{6240}\u{8C13}\u{7684}\u{201C}\u{82B1}\u{56ED}\u{201D}\u{88C2}\u{9699}\u{FF09}\u{3002}
*   **\u{6D77}\u{84DD}\u{5B9D}\u{77F3} (Aquamarine)**: \u{5BFB}\u{627E}**\u{6E05}\u{6F88}\u{7684}\u{6D45}\u{84DD}\u{8272}\u{3001}\u{5929}\u{84DD}\u{8272}\u{6216}\u{84DD}\u{7EFF}\u{8272} (Light blue, sea-blue)** \u{7684}\u{900F}\u{660E}\u{81F3}\u{534A}\u{900F}\u{660E}\u{67F1}\u{4F53}\u{3002}\u{5B83}\u{6676}\u{83B9}\u{5254}\u{900F}\u{FF0C}\u{50CF}\u{662F}\u{628A}\u{51B0}\u{51BB}\u{7684}\u{6D77}\u{6C34}\u{5C01}\u{5370}\u{5728}\u{5B8C}\u{7F8E}\u{7684}\u{516D}\u{65B9}\u{67F1}\u{5185}\u{3002}

[11.2 \u{5706}\u{89D2}\u{4E09}\u{89D2}\u{622A}\u{9762}\u{4E0E}\u{6DF1}\u{69FD}\u{6761}\u{7EB9}\u{FF1A}\u{7535}\u{6C14}\u{77F3}\u{5BB6}\u{65CF} (The Tourmaline Group)]
\u{6781}\u{5176}\u{7ECF}\u{5178}\u{7684}\u{67F1}\u{72B6}\u{77FF}\u{7269}\u{FF0C}\u{4F46}\u{4E0E}\u{7EFF}\u{67F1}\u{77F3}\u{6709}\u{7740}\u{51B3}\u{5B9A}\u{6027}\u{7684}\u{5F62}\u{6001}\u{7269}\u{7406}\u{5DEE}\u{5F02}\u{FF01}
*   **\u{5F62}\u{6001}\u{7EDD}\u{6740}\u{7279}\u{5F81}**: \u{5BFB}\u{627E}\u{67F1}\u{4F53}\u{8868}\u{9762}**\u{6781}\u{5EA6}\u{53D1}\u{8FBE}\u{3001}\u{6DF1}\u{6DF1}\u{7684}\u{5E73}\u{884C}\u{7EB5}\u{5411}\u{6761}\u{7EB9} (Heavy vertical striations)**\u{FF1B}\u{622A}\u{65AD}\u{5B83}\u{770B}\u{6A2A}\u{622A}\u{9762}\u{FF0C}\u{5B83}\u{4E0D}\u{662F}\u{6B63}\u{516D}\u{8FB9}\u{5F62}\u{FF0C}\u{800C}\u{662F}**\u{50CF}\u{7403}\u{9762}\u{81A8}\u{80C0}\u{7684}\u{201C}\u{5E26}\u{5706}\u{89D2}\u{7684}\u{4E09}\u{89D2}\u{5F62}\u{201D} (Rounded triangular spherical cross-section)**\u{3002}
*   **\u{7535}\u{6C14}\u{77F3} / \u{9ED1}\u{7535}\u{6C14}\u{77F3} (Tourmaline / Schorl)**: \u{4F1F}\u{6676}\u{5CA9}\u{548C}\u{82B1}\u{5C97}\u{5CA9}\u{4E2D}\u{6700}\u{731B}\u{70C8}\u{7684}\u{9ED1}\u{8272}\u{5165}\u{4FB5}\u{8005}\u{3002}\u{5448}\u{73B0}**\u{6781}\u{5176}\u{4E4C}\u{9ED1}\u{53D1}\u{4EAE}\u{3001}\u{5E26}\u{6709}\u{6DF1}\u{9083}\u{7EB5}\u{7EB9}\u{7684}\u{7C97}\u{7CD9}\u{4E43}\u{81F3}\u{8000}\u{773C}\u{7684}\u{9ED1}\u{67F1}\u{4F53} (Pitch-black heavily striated prisms)**\u{3002}
*   **\u{9502}\u{7535}\u{6C14}\u{77F3} (Elbaite)**: \u{5B9D}\u{77F3}\u{7EA7}\u{7535}\u{6C14}\u{77F3}\u{3002}\u{5448}\u{73B0}\u{6781}\u{5176}\u{7EDA}\u{4E3D}\u{989C}\u{8272}\u{7684}\u{7EB5}\u{7EB9}\u{6676}\u{4F53}\u{FF08}\u{5982}\u{56FE}\u{4E2D}\u{591A}\u{53D8}\u{7684}\u{6DE1}\u{7C89}\u{7D2B}\u{3001}\u{6D45}\u{84DD}\u{7B49}\u{989C}\u{8272}\u{4EA4}\u{7EC7}\u{FF0C}\u{6216}\u{5176}\u{4ED6}\u{591A}\u{8272}\u{3001}\u{897F}\u{74DC}\u{8272}\u{53D8}\u{79CD}\u{FF09}\u{3002}

[11.3 \u{6781}\u{5EA6}\u{7F55}\u{89C1}\u{7684}\u{5947}\u{5E7B}\u{7ED3}\u{6784}\u{4E0E}\u{8272}\u{5F69}\u{56FE}\u{817E}]
*   **\u{5807}\u{9752}\u{77F3} (Cordierite / Iolite)**: \u{201C}\u{7EF4}\u{4EAC}\u{4EBA}\u{7684}\u{7F57}\u{76D8}\u{201D}\u{3002}
    *   **\u{7EC8}\u{6781}\u{5149}\u{5B66}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}\u{6DF1}\u{9083}\u{7684}\u{84DD}\u{7D2B}\u{8272}\u{3001}\u{7070}\u{84DD}\u{8272}\u{5757}\u{4F53}\u{6216}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{3002}\u{5B83}\u{62E5}\u{6709}\u{77FF}\u{7269}\u{754C}\u{6700}\u{6050}\u{6016}\u{7684}**\u{591A}\u{8272}\u{6027} (Strong Pleochroism)**\u{3002}\u{7EAF}\u{51C0}\u{7684}\u{5807}\u{9752}\u{77F3}\u{7A0D}\u{5FAE}\u{8F6C}\u{52A8}\u{89D2}\u{5EA6}\u{FF0C}\u{5B83}\u{7684}\u{989C}\u{8272}\u{4F1A}\u{4ECE}\u{6781}\u{5176}\u{6D53}\u{90C1}\u{7684}\u{84DD}\u{7D2B}\u{8272}\u{FF0C}\u{77AC}\u{95F4}\u{53D8}\u{6210}\u{7070}\u{9EC4}\u{8272}\u{3001}\u{6D45}\u{8910}\u{8272}\u{6216}\u{82CD}\u{767D}\u{8272}\u{3002}\u{5177}\u{6CB9}\u{8102}\u{548C}\u{73BB}\u{7483}\u{6DF7}\u{5408}\u{5149}\u{6CFD}\u{3002}
*   **\u{7FE0}\u{94DC}\u{77FF} (Dioptase)**: \u{201C}\u{9A97}\u{8FC7}\u{53CC}\u{773C}\u{7684}\u{5047}\u{7956}\u{6BCD}\u{7EFF}\u{201D}\u{3002}
    *   **\u{89C6}\u{89C9}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}**\u{6781}\u{5176}\u{6D53}\u{90C1}\u{8BF1}\u{4EBA}\u{7684}\u{6DF1}\u{7FE0}\u{7EFF}\u{8272}\u{3001}\u{58A8}\u{7EFF}\u{8272}\u{6676}\u{4F53}\u{5806}\u{79EF} (Intense emerald-green to bluish-green crystals)**\u{3002}
    *   **\u{6676}\u{5F62}\u{7EDD}\u{6740}\u{89C4}\u{5219}**: \u{5B83}\u{7684}\u{6676}\u{5F62}\u{5F80}\u{5F80}\u{662F}**\u{83F1}\u{9762}\u{4F53}\u{6216}\u{77ED}\u{67F1}\u{72B6}\u{3001}\u{504F}\u{5C16}\u{5934}\u{7684}\u{6676}\u{5F62}\u{7C07} (Rhombohedral crystals)**\u{FF0C}\u{800C}\u{4E0D}\u{50CF}\u{7956}\u{6BCD}\u{7EFF}\u{90A3}\u{6837}\u{957F}\u{6210}\u{5E73}\u{5934}\u{7684}\u{5DE8}\u{5927}\u{516D}\u{65B9}\u{957F}\u{67F1}\u{3002}\u{5E38}\u{89C1}\u{4E8E}\u{5E72}\u{65F1}\u{5E26}\u{542B}\u{94DC}\u{5CA9}\u{5C42}\u{88C2}\u{9699}\u{FF0C}\u{786C}\u{5EA6}\u{4E3A}5\u{FF08}\u{6BD4}\u{7EFF}\u{67F1}\u{77F3}\u{8F6F}\u{5F97}\u{591A}\u{FF09}\u{3002}
*   **\u{84DD}\u{9525}\u{77FF} (Benitoite)**: \u{5168}\u{7403}\u{4EC5}\u{4EE5}\u{52A0}\u{5DDE}\u{4EA7}\u{51FA}\u{95FB}\u{540D}\u{7684}\u{6781}\u{7A00}\u{6709}\u{8367}\u{5149}\u{5B9D}\u{77F3}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{5E38}\u{5E38}\u{5728}\u{767D}\u{8272}\u{57FA}\u{5CA9}\u{FF08}\u{94A0}\u{6CB8}\u{77F3}\u{FF09}\u{4E0A}\u{5BFB}\u{627E}**\u{8000}\u{773C}\u{7684}\u{5B9D}\u{84DD}\u{8272}\u{3001}\u{84DD}\u{7D2B}\u{8272}\u{6676}\u{4F53}**\u{3002}
    *   **\u{7EDD}\u{6740}\u{51E0}\u{4F55}\u{7279}\u{5F81}**: \u{5B83}\u{62E5}\u{6709}\u{7F55}\u{89C1}\u{7684}\u{6676}\u{4F53}\u{51E0}\u{4F55}\u{5F62}\u{4F53}\u{FF0C}\u{770B}\u{8D77}\u{6765}\u{50CF}**\u{88AB}\u{538B}\u{6241}\u{7684}\u{3001}\u{5E26}\u{6709}\u{4E09}\u{89D2}\u{5F62}\u{622A}\u{9762}\u{6216}\u{590D}\u{4E09}\u{89D2}\u{53CC}\u{9525}\u{7684}\u{6241}\u{5E73}\u{72B6}\u{6676}\u{4F53} (Distorted triangular / ditrigonal bipyramids)**\u{3002}\u{53E6}\u{5916}\u{FF0C}\u{77ED}\u{6CE2}\u{7D2B}\u{5916}\u{5149}\u{4E0B}\u{53D1}\u{51FA}\u{5F3A}\u{70C8}\u{7684}\u{660E}\u{4EAE}\u{4EAE}\u{84DD}\u{8272}\u{8367}\u{5149}\u{3002}
*   **\u{5F02}\u{6027}\u{77F3} (Eudialyte)**: \u{6B63}\u{957F}\u{5CA9}\u{FF08}\u{78B1}\u{6027}\u{5CA9}\u{FF09}\u{4E2D}\u{7684}\u{8840}\u{8272}\u{4FE1}\u{53F7}\u{3002}
    *   **\u{89C6}\u{89C9}\u{951A}\u{70B9}**: \u{590D}\u{6742}\u{7684}\u{7A00}\u{571F}\u{7845}\u{9178}\u{76D0}\u{3002}\u{5728}\u{9ED1}\u{767D}\u{76F8}\u{95F4}\u{FF08}\u{6BD4}\u{5982}\u{971E}\u{77F3}\u{3001}\u{9713}\u{77F3}\u{4EA4}\u{7EC7}\u{FF09}\u{7684}\u{6742}\u{5CA9}\u{4E2D}\u{FF0C}\u{5E38}\u{5E38}\u{7A81}\u{5140}\u{5730}\u{51FA}\u{73B0}**\u{81F4}\u{5BC6}\u{3001}\u{663E}\u{773C}\u{7684}\u{6D0B}\u{7EA2}\u{3001}\u{6A31}\u{6843}\u{7EA2}\u{6216}\u{5927}\u{7EA2}\u{8272}/\u{6697}\u{7EA2}\u{8272}\u{7684}\u{56E2}\u{5757}\u{788E}\u{6D46}\u{6216}\u{6676}\u{4F53}\u{9897}\u{7C92} (Magenta, bright pink, or cherry-red patches/grains)**\u{3002}\u{8FD9}\u{79CD}\u{50CF}\u{5728}\u{82B1}\u{5C97}\u{5CA9}\u{8D28}\u{77F3}\u{5934}\u{4E0A}\u{6EF4}\u{4E0A}\u{9C9C}\u{7EA2}\u{6D53}\u{70C8}\u{989C}\u{6599}\u{7684}\u{5BF9}\u{6BD4}\u{FF0C}\u{662F}\u{6781}\u{5176}\u{7ECF}\u{5178}\u{7684}\u{5F02}\u{6027}\u{77F3}\u{6807}\u{672C}\u{FF01}

`,
    diagnosticTests: `
- \u{9762}\u{4E34}\u{957F}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{5224}\u{5B9A}\u{FF1A}\u{5982}\u{679C}\u{67F1}\u{5B50}\u{8868}\u{9762}\u{6781}\u{5176}\u{5E73}\u{6ED1}\u{65E0}\u{6DF1}\u{6C9F}\u{3001}\u{6A2A}\u{622A}\u{9762}\u{662F}\u{6B63}\u{516D}\u{8FB9}\u{5F62}\u{FF0C}\u{90A3}\u{662F}\u{7EFF}\u{67F1}\u{77F3}\u{5BB6}\u{65CF}\u{FF1B}\u{5982}\u{679C}\u{67F1}\u{9762}\u{5E03}\u{6EE1}\u{6DF1}\u{6DF1}\u{7684}\u{7AD6}\u{5411}\u{7C97}\u{6761}\u{7EB9}\u{3001}\u{6A2A}\u{622A}\u{9762}\u{662F}\u{5F88}\u{50CF}\u{88AB}\u{5439}\u{9F13}\u{7684}\u{4E09}\u{89D2}\u{5F62}\u{FF08}\u{5E26}\u{5706}\u{89D2}\u{FF09}\u{FF0C}\u{7EDD}\u{6740}\u{9501}\u{5B9A}\u{7535}\u{6C14}\u{77F3}\u{FF01}
- \u{9762}\u{4E34}\u{660E}\u{8273}\u{7EFF}\u{8272}\u{6676}\u{4F53}\u{5224}\u{5B9A}\u{FF1A}\u{5982}\u{679C}\u{662F}\u{5E73}\u{5934}\u{7AEF}\u{9762}\u{3001}\u{5E38}\u{5E38}\u{5F88}\u{901A}\u{900F}\u{7684}\u{6DF1}\u{7EFF}\u{8272}\u{516D}\u{65B9}\u{67F1}\u{FF0C}\u{662F}\u{7956}\u{6BCD}\u{7EFF}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{77ED}\u{5C0F}\u{3001}\u{5E26}\u{6709}\u{5C16}\u{5934}\u{6216}\u{83F1}\u{9762}\u{4F53}\u{7684}\u{6781}\u{6DF1}\u{7FE0}\u{7EFF}\u{6676}\u{4F53}\u{7C07}\u{96C6}\u{805A}\u{FF08}\u{4E14}\u{7ECF}\u{5E38}\u{4F34}\u{968F}\u{77F3}\u{82F1}\u{7B49}\u{FF09}\u{FF0C}\u{5FC5}\u{987B}\u{6000}\u{7591}\u{7FE0}\u{94DC}\u{77FF}\u{3002}
- \u{7EC8}\u{6781}\u{8272}\u{5F69}\u{5207}\u{5272}\u{8005}\u{FF1A}\u{62FF}\u{4E00}\u{5757}\u{7D2B}\u{84DD}\u{8272}\u{900F}\u{660E}\u{77FF}\u{77F3}\u{FF0C}\u{987A}\u{7740}\u{4E0D}\u{540C}\u{8F74}\u{5411}\u{770B}\u{FF0C}\u{5982}\u{679C}\u{84DD}\u{7D2B}\u{8272}\u{5FFD}\u{7136}\u{5F7B}\u{5E95}\u{53D8}\u{6210}\u{7070}\u{9EC4}/\u{82CD}\u{767D}/\u{6D45}\u{8272}\u{FF0C}\u{7ACB}\u{523B}\u{5224}\u{5B9A}\u{5807}\u{9752}\u{77F3}\u{7684}\u{591A}\u{8272}\u{6027}\u{3002}
- \u{9ED1}\u{767D}\u{5E95}\u{8272}\u{4E0A}\u{7684}\u{8840}\u{70B9}\u{FF1A}\u{5982}\u{679C}\u{5728}\u{9ED1}\u{767D}\u{4EA4}\u{6742}\u{7684}\u{5CA9}\u{77F3}\u{6807}\u{672C}\u{4E2D}\u{FF0C}\u{770B}\u{5230}\u{50CF}\u{8840}\u{6DB2}/\u{6D0B}\u{7EA2}\u{67D3}\u{6599}\u{4E00}\u{6837}\u{7684}\u{8273}\u{7C89}\u{3001}\u{6697}\u{7EA2}\u{8272}\u{81F4}\u{5BC6}\u{6591}\u{5757}\u{548C}\u{9897}\u{7C92}\u{5D4C}\u{5728}\u{91CC}\u{9762}\u{FF0C}\u{6700}\u{9AD8}\u{4F18}\u{5148}\u{7EA7}\u{5224}\u{5B9A}\u{5F02}\u{6027}\u{77F3}\u{3002}
- \u{52A0}\u{5DDE}\u{4E09}\u{5408}\u{4E00}\u{89C4}\u{5219}\u{FF1A}\u{767D}\u{8272}\u{57FA}\u{5E95} + \u{5B9D}\u{84DD}\u{8272}\u{622A}\u{9762}\u{7C7B}\u{4E09}\u{89D2}\u{5F62}\u{6676}\u{4F53} + UV\u{4EAE}\u{84DD}\u{8367}\u{5149} = \u{84DD}\u{9525}\u{77FF}\u{7EDD}\u{5BF9}\u{65E0}\u{8BEF}\u{3002}
`
};


const $e6779539ed4da71b$export$6d292e672fbfe60d = {
    description: "Halides Identification Rules",
    coreRules: `
=== \u{5364}\u{5316}\u{7269}\u{77FF}\u{7269}\u{7684}\u{7EC8}\u{6781}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Halides Diagnostic Protocol) ===

[5.1 \u{57FA}\u{7840}\u{76D0}\u{7C7B}\u{FF1A}\u{5CA9}\u{76D0}\u{4E0E}\u{94BE}\u{76D0}\u{7684}\u{6218}\u{4E89} (The Core Salts: Halite vs Sylvite)]
*   **\u{5CA9}\u{76D0} (Halite - NaCl)**: \u{6C2F}\u{5316}\u{94A0}\u{672C}\u{5C0A}\u{3002}\u{5B83}\u{662F}\u{5364}\u{5316}\u{7269}\u{7684}\u{57FA}\u{51C6}\u{3002}\u{5FC5}\u{987B}\u{5BFB}\u{627E}**\u{5B8C}\u{7F8E}\u{7684}\u{7ACB}\u{65B9}\u{4F53}\u{6676}\u{5F62} (Perfect Cubic Crystals)** \u{4E0E}**\u{9636}\u{68AF}\u{72B6}\u{7684}\u{7ACB}\u{65B9}\u{4F53}\u{89E3}\u{7406}**\u{3002}\u{5916}\u{89C2}\u{901A}\u{5E38}\u{662F}\u{900F}\u{660E}\u{5230}\u{4E73}\u{767D}\u{8272}\u{FF0C}\u{6709}\u{65F6}\u{5FAE}\u{5E26}\u{6742}\u{8272}\u{FF08}\u{7531}\u{4E8E}\u{6742}\u{8D28}\u{FF09}\u{3002}
*   **\u{94BE}\u{76D0} (Sylvite - KCl)**: \u{5CA9}\u{76D0}\u{7684}\u{5F71}\u{5B50}\u{3002}\u{5916}\u{89C2}\u{51E0}\u{4E4E}\u{548C}\u{5CA9}\u{76D0}\u{4E00}\u{6A21}\u{4E00}\u{6837}\u{FF0C}\u{4E5F}\u{662F}\u{900F}\u{660E}/\u{767D}\u{8272}\u{7684}\u{5757}\u{72B6}\u{6216}\u{7ACB}\u{65B9}\u{4F53}\u{3002}
    *   \u{3010}\u{7EC8}\u{6781}\u{533A}\u{5206}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{5982}\u{679C}\u{5728}\u{535A}\u{7269}\u{9986}\u{6807}\u{672C}\u{63CF}\u{8FF0}\u{6216}\u{6D4B}\u{8BD5}\u{53CD}\u{9988}\u{4E2D}\u{9047}\u{5230}\u{201C}\u{5C1D}\u{8D77}\u{6765}\u{7684}\u{5473}\u{9053}\u{201D}\u{2014}\u{2014}**\u{5CA9}\u{76D0}\u{662F}\u{7EAF}\u{54B8}\u{5473}**\u{FF0C}\u{800C}**\u{94BE}\u{76D0}\u{4E0D}\u{4EC5}\u{54B8}\u{FF0C}\u{800C}\u{4E14}\u{5177}\u{6709}\u{660E}\u{663E}\u{7684}\u{3010}\u{82E6}\u{6DA9}\u{5473}\u{3011} (Bitter taste)**\u{3002}\u{5982}\u{679C}\u{5728}\u{56FE}\u{7247}\u{4E2D}\u{5B83}\u{5931}\u{53BB}\u{4E86}\u{5B8C}\u{7F8E}\u{7684}\u{7ACB}\u{65B9}\u{4F53}\u{5F62}\u{72B6}\u{800C}\u{504F}\u{5411}\u{4E0D}\u{89C4}\u{5219}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{FF0C}\u{7ED3}\u{5408}\u{201C}\u{94BE}\u{76D0}\u{201D}\u{6807}\u{7B7E}\u{FF0C}\u{53EF}\u{4EE5}\u{786E}\u{8BA4}\u{3002}

[5.2 \u{7ED3}\u{6676}\u{4E0E}\u{5149}\u{5B66}\u{7684}\u{9738}\u{4E3B}\u{FF1A}\u{8424}\u{77F3}\u{4E0E}\u{51B0}\u{6676}\u{77F3} (The Optical Giants: Fluorite vs Cryolite)]
*   **\u{8424}\u{77F3} (Fluorite - CaF2)**: \u{5364}\u{5316}\u{7269}\u{4E2D}\u{6700}\u{534E}\u{4E3D}\u{7684}\u{7ED3}\u{6676}\u{77FF}\u{7269}\u{3002}\u{5FC5}\u{987B}\u{5BFB}\u{627E}\u{FF1A}**\u{7ACB}\u{65B9}\u{4F53} (Cubic)** \u{6216}\u{8005} **\u{516B}\u{9762}\u{4F53} (Octahedral)** \u{6676}\u{7CFB}\u{FF0C}\u{5E76}\u{4E14}\u{901A}\u{5E38}\u{4F34}\u{968F}\u{6709}\u{5F15}\u{4EBA}\u{6CE8}\u{76EE}\u{7684}\u{989C}\u{8272}\u{5206}\u{5E26}\u{FF08}\u{7D2B}\u{3001}\u{7EFF}\u{3001}\u{9EC4}\u{3001}\u{84DD}\u{7686}\u{6709}\u{53EF}\u{80FD}\u{FF09}\u{3002}
    *   \u{3010}\u{5173}\u{952E}\u{7834}\u{7EFD}\u{3011}\u{FF1A}\u{5C3D}\u{7BA1}\u{957F}\u{5F97}\u{50CF}\u{51B0}\u{7CD6}\u{6216}\u{5B9D}\u{77F3}\u{FF0C}\u{4F46}\u{5B83}\u{6709}\u{6781}\u{5176}\u{7279}\u{5F81}\u{7684}**\u{56DB}\u{7EC4}\u{5B8C}\u{5168}\u{89E3}\u{7406} (Perfect octahedral cleavage)**\u{3002}\u{5728}\u{8FB9}\u{89D2}\u{65AD}\u{88C2}\u{5904}\u{FF0C}\u{7EDD}\u{4E0D}\u{662F}\u{8D1D}\u{58F3}\u{72B6}\u{7684}\u{73BB}\u{7483}\u{65AD}\u{53E3}\u{FF0C}\u{800C}\u{662F}\u{5E73}\u{6574}\u{7684}\u{5207}\u{9762}\u{3002}
*   **\u{51B0}\u{6676}\u{77F3} (Cryolite - Na3AlF6)**: \u{7F55}\u{89C1}\u{7684}\u{7194}\u{5242}\u{77FF}\u{7269}\u{3002}\u{5916}\u{89C2}\u{770B}\u{8D77}\u{6765}\u{50CF}**\u{534A}\u{900F}\u{660E}\u{5230}\u{767D}\u{8272}\u{7684}\u{51B0}\u{5757}\u{6216}\u{51B7}\u{51BB}\u{7684}\u{6CB9}\u{8102} (Ice-like or Greasy mass)**\u{3002}\u{5B83}\u{6781}\u{5C11}\u{5F62}\u{6210}\u{597D}\u{770B}\u{7684}\u{6676}\u{4F53}\u{FF0C}\u{5927}\u{591A}\u{4E3A}\u{81F4}\u{5BC6}\u{5757}\u{4F53}\u{3002}
    *   \u{3010}\u{6781}\u{7AEF}\u{7269}\u{7406}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{5B83}\u{7684}\u{6298}\u{5C04}\u{7387}\u{548C}\u{6C34}\u{7684}\u{6298}\u{5C04}\u{7387}\u{6781}\u{5176}\u{63A5}\u{8FD1}\u{3002}\u{5982}\u{679C}\u{5728}\u{63CF}\u{8FF0}\u{4E2D}\u{63D0}\u{5230}\u{201C}\u{653E}\u{5165}\u{6C34}\u{4E2D}\u{540E}\u{51E0}\u{4E4E}\u{9690}\u{5F62}\u{201D}\u{6216}\u{8005}\u{201C}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{878D}\u{5316}\u{4E86}\u{4E00}\u{534A}\u{7684}\u{96EA}\u{7403}\u{201D}\u{FF0C}\u{76F4}\u{63A5}\u{9501}\u{5B9A}\u{51B0}\u{6676}\u{77F3}\u{3002}

[5.3 \u{94DC}\u{94F6}\u{7684}\u{9AD8}\u{9636}\u{6B21}\u{751F}\u{53D8}\u{4F53} (The Rare Cu & Ag Halides)]
*   **\u{659C}\u{6C2F}\u{94DC}\u{77FF} (Atacamite)**: \u{6781}\u{5176}\u{81F4}\u{5BC6}\u{7684}\u{94DC}\u{6C27}\u{5316}\u{5C42}\u{5E38}\u{5BA2}\u{3002}\u{5916}\u{89C2}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{6697}\u{7EFF}\u{8272}\u{5230}\u{7FE0}\u{7EFF}\u{8272}\u{7684}\u{7802}\u{72B6}\u{3001}\u{7EA4}\u{7EF4}\u{72B6}\u{6216}\u{7EC6}\u{5C0F}\u{7684}\u{659C}\u{65B9}\u{6676}\u{4F53}\u{7ED3}\u{5757}\u{FF0C}\u{5E38}\u{9644}\u{7740}\u{5728}\u{5E72}\u{65F1}\u{5730}\u{533A}\u{7684}\u{5176}\u{4ED6}\u{542B}\u{94DC}\u{5CA9}\u{77F3}\u{8868}\u{9762}\u{3002}
    *   \u{3010}\u{8FA8}\u{8BC6}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{4E0E}\u{5B54}\u{96C0}\u{77F3}\u{7684}\u{7FE0}\u{7EFF}\u{4E0D}\u{540C}\u{FF0C}\u{659C}\u{6C2F}\u{94DC}\u{77FF}\u{7684}\u{7EFF}\u{8272}\u{66F4}\u{6DF1}\u{9083}\u{3001}\u{201C}\u{53D1}\u{5E72}\u{201D}\u{FF0C}\u{4E14}\u{5E38}\u{89C1}\u{4E8E}\u{6781}\u{5EA6}\u{5E72}\u{65F1}\u{73AF}\u{5883}\u{FF08}\u{5982}\u{6C99}\u{6F20}\u{94DC}\u{77FF}\u{7684}\u{6C27}\u{5316}\u{5E26}\u{FF09}\u{3002}
*   **\u{89D2}\u{94F6}\u{77FF} (Chlorargyrite / Horn Silver)**: \u{94F6}\u{7684}\u{6B21}\u{751F}\u{6C2F}\u{5316}\u{7269}\u{3002}
    *   \u{3010}\u{5F62}\u{6001}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{5343}\u{4E07}\u{4E0D}\u{8981}\u{5BFB}\u{627E}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{FF01}\u{5B83}\u{957F}\u{5F97}\u{50CF}\u{662F}\u{4E00}\u{5757}**\u{810F}\u{516E}\u{516E}\u{7684}\u{8721}\u{5757}\u{3001}\u{6CB9}\u{8102}\u{5757}\u{6216}\u{53D8}\u{8272}\u{7684}\u{89D2}\u{8D28}\u{7269} (Horn-like or Waxy crust)**\u{3002}\u{989C}\u{8272}\u{4ECE}\u{7070}\u{767D}\u{5230}\u{9EC4}\u{7EFF}\u{8272}\u{3002}\u{5B83}\u{6700}\u{521D}\u{53EF}\u{80FD}\u{662F}\u{900F}\u{660E}\u{7684}\u{FF0C}\u{4F46}\u{5728}\u{5149}\u{7167}\u{4E0B}\u{4F1A}\u{6781}\u{901F}\u{53D8}\u{6697}\u{6210}\u{7D2B}\u{9ED1}\u{8272}\u{6216}\u{7070}\u{9ED1}\u{8272}\u{3002}\u{5B83}\u{662F}\u{98CE}\u{5316}\u{5E26}\u{4E2D}\u{5BFB}\u{627E}\u{94F6}\u{77FF}\u{7684}\u{7EDD}\u{5BF9}\u{6307}\u{793A}\u{7269}\u{3002}
*   **\u{7898}\u{94F6}\u{77FF} / \u{5455}\u{5410}\u{77F3} (Iodyrite / Iodargyrite) (\u{9644}\u{5E26} \u{6EB4}\u{94F6}\u{77FF} Bromargyrite \u{7279}\u{5F81})**:
    *   **\u{7898}\u{94F6}\u{77FF}**: \u{989C}\u{8272}\u{5E38}\u{8868}\u{73B0}\u{4E3A}**\u{6DE1}\u{9EC4}\u{3001}\u{6811}\u{8102}\u{9EC4}\u{5230}\u{9EC4}\u{7EFF}\u{8272}**\u{3002}\u{6781}\u{5176}\u{67D4}\u{8F6F}\u{FF08}\u{786C}\u{5EA6}\u{4EC5}\u{4E3A}1-1.5\u{FF0C}\u{80FD}\u{7528}\u{6307}\u{7532}\u{8F7B}\u{6613}\u{522E}\u{4E0B}\u{FF09}\u{FF0C}\u{5177}\u{6709}\u{6811}\u{8102}\u{5230}\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{3002}\u{6676}\u{4F53}\u{591A}\u{8584}\u{677F}\u{72B6}\u{FF0C}\u{4F46}\u{66F4}\u{5E38}\u{4EE5}\u{9CDE}\u{7247}\u{72B6}\u{6216}\u{5757}\u{72B6}\u{51FA}\u{73B0}\u{3002}
    *   \u{3010}\u{6781}\u{5EA6}\u{7A00}\u{6709}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{201C}\u{5455}\u{5410}\u{77F3}\u{201D}\u{8FD9}\u{662F}\u{4E00}\u{4E2A}\u{6781}\u{5EA6}\u{7F55}\u{89C1}\u{7684}\u{4E1A}\u{5185}\u{4FD7}\u{79F0}\u{6216}\u{8005}\u{8BEF}\u{8BD1}\u{FF0C}\u{53EF}\u{80FD}\u{6307}\u{5411}\u{5176}\u{590D}\u{6742}\u{7684}\u{6DF7}\u{5408}\u{72B6}\u{6001}\u{6216}\u{98CE}\u{5316}\u{540E}\u{6781}\u{5176}\u{96BE}\u{770B}\u{7684}\u{5F62}\u{6001}\u{FF0C}\u{6DF7}\u{5408}\u{4E86}\u{89D2}\u{94F6}\u{77FF}\u{3001}\u{7898}\u{94F6}\u{77FF}\u{548C}\u{6EB4}\u{94F6}\u{77FF}\u{7684}\u{6697}\u{6DE1}\u{8D28}\u{5730}\u{3002}\u{82E5}\u{56FE}\u{7247}\u{4E2D}\u{770B}\u{5230}\u{94C5}\u{7070}/\u{9EC4}\u{7070}\u{4EA4}\u{6742}\u{FF0C}\u{6BEB}\u{65E0}\u{91D1}\u{5C5E}\u{5149}\u{611F}\u{FF0C}\u{50CF}\u{67D0}\u{79CD}\u{51DD}\u{56FA}\u{7684}\u{7070}\u{6CE5}\u{7C98}\u{5408}\u{5728}\u{5CA9}\u{77F3}\u{4E0A}\u{FF0C}\u{5E76}\u{5E26}\u{6709}\u{660E}\u{663E}\u{7684}\u{94F6}\u{77FF}\u{6B21}\u{751F}\u{6807}\u{7B7E}\u{FF0C}\u{7ACB}\u{523B}\u{5F52}\u{7C7B}\u{4E3A}\u{6B64}\u{7CFB}\u{5217}\u{3002}
`,
    diagnosticTests: `
- \u{9762}\u{5BF9}\u{900F}\u{660E}/\u{767D}\u{8272}\u{7684}\u{7ACB}\u{65B9}\u{4F53}\u{7ED3}\u{6676}\u{5757}\u{FF1A}\u{5982}\u{679C}\u{5B83}\u{53EA}\u{6709}\u{7ACB}\u{65B9}\u{53CC}\u{6676}\u{FF0C}\u{90A3}\u{662F}\u{5CA9}\u{76D0} (Halite)\u{FF1B}\u{5982}\u{679C}\u{6709}\u{7D2B}/\u{7EFF}\u{7B49}\u{9C9C}\u{8273}\u{989C}\u{8272}\u{5E76}\u{5207}\u{89D2}\u{5E73}\u{6574}\u{FF0C}\u{90A3}\u{662F}\u{8424}\u{77F3} (Fluorite)\u{3002}
- \u{5982}\u{679C}\u{4E00}\u{5757}\u{900F}\u{660E}\u{767D}\u{8272}\u{77F3}\u{5934}\u{6BEB}\u{65E0}\u{6676}\u{5F62}\u{3001}\u{957F}\u{5F97}\u{50CF}\u{4E00}\u{5757}\u{6D51}\u{6CB9}\u{6216}\u{51B0}\u{5768}\u{5B50}\u{FF0C}\u{6781}\u{5EA6}\u{5927}\u{6982}\u{7387}\u{662F}\u{51B0}\u{6676}\u{77F3} (Cryolite)\u{3002}
- \u{9762}\u{5BF9}\u{5E72}\u{65F1}\u{94DC}\u{77FF}\u{8868}\u{9762}\u{7684}\u{6697}\u{7EFF}\u{8272}\u{7802}\u{72B6}\u{6C89}\u{6DC0}\u{FF0C}\u{9664}\u{4E86}\u{5B54}\u{96C0}\u{77F3}\u{5916}\u{FF0C}\u{5FC5}\u{987B}\u{9A8C}\u{8BC1}\u{662F}\u{5426}\u{4E3A}\u{659C}\u{6C2F}\u{94DC}\u{77FF} (Atacamite)\u{3002}
- \u{5982}\u{679C}\u{770B}\u{5230}\u{8868}\u{9762}\u{9644}\u{7740}\u{50CF}\u{67D0}\u{79CD}\u{810F}\u{9EC4}\u{7EFF}\u{8272}\u{6216}\u{7D2B}\u{7070}\u{8272}\u{70C2}\u{8721}/\u{89D2}\u{8D28}\u{5C42}\u{7684}\u{6807}\u{672C}\u{FF0C}\u{5B83}\u{7EDD}\u{4E0D}\u{662F}\u{666E}\u{901A}\u{6CE5}\u{571F}\u{FF0C}\u{8FD9}\u{662F}\u{94F6}\u{77FF}\u{5316}\u{6781}\u{5EA6}\u{5BCC}\u{96C6}\u{7684}\u{6B21}\u{751F}\u{5364}\u{5316}\u{7269}\u{FF1A}\u{89D2}\u{94F6}\u{77FF}/\u{7898}\u{94F6}\u{77FF} (Horn Silver\u{7CFB}\u{5217})\u{3002}
`
};


const $31ab3576094a1174$export$bc24e6265f057b20 = {
    description: "Inosilicates (Chain Silicates) Identification Rules - Pyroxenes and Amphiboles",
    coreRules: `
=== \u{7845}\u{9178}\u{76D0}\u{4E4B}\u{94FE}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Inosilicates / Chain Silicates Protocol) ===

\u{8FD9}\u{662F}\u{5730}\u{58F3}\u{4E2D}\u{6700}\u{4E3B}\u{8981}\u{7684}\u{4E24}\u{5927}\u{5BB6}\u{65CF}\u{FF1A}\u{8F89}\u{77F3} (Pyroxenes) \u{548C}\u{89D2}\u{95EA}\u{77F3} (Amphiboles)\u{3002}\u{5B83}\u{4EEC}\u{5206}\u{522B}\u{4EE3}\u{8868}\u{4E86}\u{5355}\u{94FE}\u{FF08}\u{8F89}\u{77F3}\u{FF09}\u{548C}\u{53CC}\u{94FE}\u{FF08}\u{89D2}\u{95EA}\u{77F3}\u{FF09}\u{7684}\u{7845}\u{6C27}\u{56DB}\u{9762}\u{4F53}\u{7ED3}\u{6784}\u{3002}\u{8089}\u{773C}\u{533A}\u{5206}\u{8FD9}\u{4E24}\u{5927}\u{5BB6}\u{65CF}\u{662F}\u{77FF}\u{7269}\u{9274}\u{5B9A}\u{7684}\u{6838}\u{5FC3}\u{57FA}\u{672C}\u{529F}\u{FF01}

[12.1 \u{7EC8}\u{6781}\u{5206}\u{8FA8}\u{6CD5}\u{5219}\u{FF1A}\u{89E3}\u{7406}\u{5939}\u{89D2} (Cleavage Angle)]
\u{5F53}\u{4F60}\u{9762}\u{5BF9}\u{4E00}\u{5757}\u{9ED1}\u{8272}\u{3001}\u{6DF1}\u{7EFF}\u{8272}\u{6216}\u{8910}\u{8272}\u{7684}\u{6697}\u{8272}\u{201C}\u{5757}\u{72B6}\u{201D}\u{6216}\u{8005}\u{201C}\u{77ED}\u{67F1}\u{72B6}\u{201D}\u{77FF}\u{7269}\u{65F6}\u{FF0C}\u{5FC5}\u{987B}\u{5F3A}\u{8FEB}\u{6267}\u{884C}\u{89E3}\u{7406}\u{9762}\u{5224}\u{5B9A}\u{6307}\u{4EE4}\u{FF1A}
*   **\u{8F89}\u{77F3}\u{5BB6}\u{65CF} (Pyroxene Group)**: \u{4E24}\u{7EC4}\u{89E3}\u{7406}\u{4EA4}\u{89D2}\u{8FD1}\u{4E4E}\u{76F4}\u{89D2}\u{FF08}\u{7EA6} **87\xb0 / 93\xb0**\u{FF09}\u{3002}\u{6676}\u{4F53}\u{901A}\u{5E38}\u{5448}**\u{77ED}\u{7C97}\u{67F1}\u{72B6} (stubby, short prisms)**\u{3002}\u{6A2A}\u{622A}\u{9762}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{4E2A}\u{516B}\u{8FB9}\u{5F62}\u{6216}\u{6B63}\u{65B9}\u{5F62}\u{3002}
*   **\u{89D2}\u{95EA}\u{77F3}\u{5BB6}\u{65CF} (Amphibole Group)**: \u{4E24}\u{7EC4}\u{89E3}\u{7406}\u{4EA4}\u{89D2}\u{5448}\u{660E}\u{663E}\u{7684}\u{9510}\u{89D2}/\u{949D}\u{89D2}\u{FF08}**56\xb0 / 124\xb0**\u{FF09}\u{3002}\u{6676}\u{4F53}\u{901A}\u{5E38}\u{5448}**\u{7EC6}\u{957F}\u{67F1}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{751A}\u{81F3}\u{7EA4}\u{7EF4}\u{72B6} (elongated, acicular, fibrous)**\u{3002}\u{6A2A}\u{622A}\u{9762}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{4E2A}\u{538B}\u{6241}\u{7684}\u{83F1}\u{5F62}\u{3002}

[12.2 \u{8F89}\u{77F3}\u{5BB6}\u{65CF} (The Pyroxene Group) - \u{5355}\u{94FE}\u{7684}\u{77ED}\u{67F1}\u{5821}\u{5792}]
*   **\u{666E}\u{901A}\u{8F89}\u{77F3} (Augite)**: \u{6700}\u{5E38}\u{89C1}\u{7684}\u{6697}\u{8272}\u{8F89}\u{77F3}\u{3002}\u{989C}\u{8272}\u{4E3A}**\u{9ED1}\u{7EFF}\u{8272}\u{5230}\u{9ED1}\u{8272}**\u{3002}\u{77ED}\u{7C97}\u{67F1}\u{72B6}\u{FF0C}\u{89E3}\u{7406}\u{9762}\u{8FD1}\u{4E4E}90\u{5EA6}\u{3002}\u{8868}\u{9762}\u{5149}\u{6CFD}\u{5E38}\u{6709}\u{4E9B}\u{6697}\u{6DE1}\u{3002}
*   **\u{987D}\u{706B}\u{8F89}\u{77F3} (Enstatite)**: \u{5BCC}\u{9541}\u{7684}\u{659C}\u{65B9}\u{8F89}\u{77F3}\u{3002}\u{5E38}\u{89C1}\u{4E8E}\u{57FA}\u{6027}\u{5CA9}/\u{6A44}\u{6984}\u{5CA9}\u{4E2D}\u{3002}\u{989C}\u{8272}\u{5F80}\u{5F80}\u{504F}\u{5411}**\u{8910}\u{7EFF}\u{8272}\u{3001}\u{7070}\u{8910}\u{8272} (brownish-green to grey)**\u{3002}\u{5982}\u{679C}\u{770B}\u{5230}\u{89E3}\u{7406}\u{9762}\u{4E0A}\u{5E26}\u{6709}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{822C}\u{7684}\u{95EA}\u{5149}\u{FF08}\u{50CF}\u{9752}\u{94DC}\u{4E00}\u{6837}\u{FF09}\u{FF0C}\u{79F0}\u{4E3A}\u{201C}\u{53E4}\u{94DC}\u{8F89}\u{77F3}\u{201D}\u{53D8}\u{79CD}\u{3002}
*   **\u{900F}\u{8F89}\u{77F3} (Diopside)**: \u{5BFB}\u{627E}**\u{6781}\u{5176}\u{4EAE}\u{773C}\u{3001}\u{7EAF}\u{51C0}\u{7684}\u{4EAE}\u{6D45}\u{7EFF}\u{8272}\u{81F3}\u{8349}\u{7EFF}\u{8272} (light green to bright grass-green)**\u{3002}\u{7279}\u{522B}\u{662F}\u{5728}\u{56FE}\u{4E2D}\u{7684}\u{90A3}\u{79CD}\u{534A}\u{900F}\u{660E}\u{3001}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{6781}\u{5F3A}\u{7684}\u{7EFF}\u{8272}\u{5BBD}\u{677F}\u{72B6}/\u{77ED}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{662F}\u{5178}\u{578B}\u{900F}\u{8F89}\u{77F3}\u{3002}
*   **\u{786C}\u{7389} (Jadeite)**: \u{7FE1}\u{7FE0}\u{7684}\u{6838}\u{5FC3}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{6781}\u{5C11}\u{6709}\u{5B8C}\u{7F8E}\u{6676}\u{5F62}\u{FF0C}\u{901A}\u{5E38}\u{662F}**\u{6781}\u{5176}\u{81F4}\u{5BC6}\u{575A}\u{97E7}\u{7684}\u{5757}\u{4F53} (massive, extremely tough)**\u{3002}
    *   **\u{89C6}\u{89C9}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}**\u{82F9}\u{679C}\u{7EFF}\u{3001}\u{7FE0}\u{7EFF}\u{8272}\u{4EA4}\u{7EC7}\u{5728}\u{767D}\u{8272}\u{5E95}\u{57FA}\u{4E0A}**\u{7684}\u{7EA4}\u{7EF4}\u{72B6}\u{6216}\u{7C92}\u{72B6}\u{6BE1}\u{72B6}\u{4EA4}\u{7EC7}\u{7ED3}\u{6784}\u{3002}\u{5177}\u{6709}\u{6CB9}\u{8102}\u{5230}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{3002}\u{7531}\u{4E8E}\u{5185}\u{90E8}\u{4EA4}\u{7EC7}\u{7ED3}\u{6784}\u{FF0C}\u{5B83}\u{6BD4}\u{4EFB}\u{4F55}\u{666E}\u{901A}\u{7684}\u{5355}\u{6676}\u{8F89}\u{77F3}\u{90FD}\u{8981}\u{575A}\u{97E7}\u{3002}
*   **\u{9713}\u{8F89}\u{77F3} (Aegirine)**: \u{78B1}\u{6027}\u{5CA9}\u{7684}\u{7279}\u{5F81}\u{77FF}\u{7269}\u{FF08}\u{5E38}\u{4E0E}\u{971E}\u{77F3}\u{3001}\u{5F02}\u{6027}\u{77F3}\u{5171}\u{751F}\u{FF09}\u{3002}\u{5BFB}\u{627E}**\u{6697}\u{7EFF}\u{8272}\u{3001}\u{9ED1}\u{7EFF}\u{8272}\u{3001}\u{975E}\u{5E38}\u{7EC6}\u{957F}\u{4E14}\u{4E24}\u{7AEF}\u{5F80}\u{5F80}\u{5448}\u{5C16}\u{9510}\u{9525}\u{72B6}\u{7684}\u{957F}\u{67F1}\u{6676} (dark green, elongated, often sharply pointed prisms)**\u{3002}
*   **\u{9502}\u{8F89}\u{77F3} (Spodumene)**: \u{542B}\u{6709}\u{4F1F}\u{6676}\u{5CA9}\u{7279}\u{5F81}\u{7684}\u{957F}\u{67F1}\u{72B6}\u{3002}
    *   **\u{5F62}\u{6001}\u{7279}\u{5F81}**: \u{53EF}\u{4EE5}\u{957F}\u{6210}\u{6781}\u{5176}\u{5DE8}\u{5927}\u{7684}\u{6241}\u{5E73}\u{957F}\u{67F1}\u{72B6}\u{3002}\u{67F1}\u{9762}\u{5E38}\u{89C1}\u{6DF1}\u{6761}\u{7EB9}\u{FF0C}\u{89E3}\u{7406}\u{975E}\u{5E38}\u{53D1}\u{80B2}\u{FF0C}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{4E00}\u{5757}\u{7C97}\u{7CD9}\u{7684}\u{6728}\u{5934}\u{3002}\u{FF08}\u{56FE}\u{4E2D}\u{5C55}\u{793A}\u{7684}\u{662F}\u{900F}\u{660E}\u{53D8}\u{79CD}\u{6676}\u{4F53}\u{FF09}\u{3002}
    *   **\u{7D2B}\u{9502}\u{8F89}\u{77F3}\u{53D8}\u{79CD} (Kunzite)**: \u{5BFB}\u{627E}\u{6781}\u{5176}\u{5A07}\u{8273}\u{7684}**\u{6DE1}\u{7C89}\u{8272}\u{3001}\u{7D2B}\u{4E01}\u{9999}\u{8272} (lilac-pink to light purple)**\u{3002}
    *   **\u{7FE0}\u{7EFF}\u{9502}\u{8F89}\u{77F3}\u{53D8}\u{79CD} (Hiddenite)**: \u{5BFB}\u{627E}**\u{9EC4}\u{7EFF}\u{8272}\u{3001}\u{7FE0}\u{7EFF}\u{8272}**\u{3002}

[12.3 \u{89D2}\u{95EA}\u{77F3}\u{5BB6}\u{65CF} (The Amphibole Group) - \u{53CC}\u{94FE}\u{7684}\u{957F}\u{67F1}\u{4E0E}\u{7EA4}\u{7EF4}]
*   **\u{666E}\u{901A}\u{89D2}\u{95EA}\u{77F3} (Hornblende)**: \u{6700}\u{5E38}\u{89C1}\u{7684}\u{6697}\u{8272}\u{89D2}\u{95EA}\u{77F3}\u{3002}\u{5BFB}\u{627E}**\u{6DF1}\u{7EFF}\u{8272}\u{3001}\u{8910}\u{9ED1}\u{8272}\u{5230}\u{7EDD}\u{5BF9}\u{7684}\u{9ED1}\u{8272} (dark green to black)**\u{3002}\u{4E0E}\u{8F89}\u{77F3}\u{4E0D}\u{540C}\u{FF0C}\u{5B83}\u{7684}\u{67F1}\u{5B50}\u{66F4}\u{7EC6}\u{957F}\u{FF0C}\u{800C}\u{4E14}\u{89E3}\u{7406}\u{9762}\u{5939}\u{89D2}\u{5448}\u{5178}\u{578B}\u{7684}\u{83F1}\u{5F62}\u{FF08}56\xb0 / 124\xb0\u{FF09}\u{FF0C}\u{65AD}\u{9762}\u{53CD}\u{5149}\u{9762}\u{975E}\u{5E38}\u{660E}\u{4EAE}\u{3002}
*   **\u{900F}\u{95EA}\u{77F3} (Tremolite)**:\u{5BCC}\u{9541}\u{54C1}\u{79CD}\u{3002}\u{5BFB}\u{627E}**\u{7EAF}\u{767D}\u{8272}\u{3001}\u{7070}\u{767D}\u{8272} (white to light grey)**\u{7684}**\u{7EC6}\u{957F}\u{67F1}\u{72B6}\u{3001}\u{5203}\u{7247}\u{72B6}\u{6216}\u{7EA4}\u{7EF4}\u{72B6}\u{96C6}\u{5408}\u{4F53} (bladed, fibrous)**\u{3002}
*   **\u{9633}\u{8D77}\u{77F3} (Actinolite)**: \u{5BCC}\u{94C1}\u{54C1}\u{79CD}\u{3002}
    *   **\u{5F62}\u{6001}\u{4E0E}\u{989C}\u{8272}\u{951A}\u{70B9}**: \u{6781}\u{5176}\u{7ECF}\u{5178}\u{7684}**\u{6DF1}\u{7EFF}\u{8272}\u{3001}\u{9EC4}\u{7EFF}\u{8272} (dark green, yellowish-green)**\u{FF0C}\u{5448}\u{5BC6}\u{96C6}\u{7684}**\u{653E}\u{5C04}\u{72B6}\u{957F}\u{9488}\u{5F62}\u{3001}\u{5E72}\u{8349}\u{5806}\u{72B6}\u{3001}\u{6216}\u{8005}\u{7EA4}\u{7EF4}\u{72B6}\u{805A}\u{96C6} (radiating needles, bladed, or asbestiform masses)**\u{3002}\u{5982}\u{679C}\u{770B}\u{5230}\u{7EFF}\u{8272}\u{7684}\u{4E00}\u{5806}\u{7EC6}\u{9488}/\u{7EC6}\u{5288}\u{5F00}\u{7684}\u{6728}\u{67F4}\u{805A}\u{5728}\u{4E00}\u{8D77}\u{FF0C}\u{6781}\u{5927}\u{6982}\u{7387}\u{662F}\u{9633}\u{8D77}\u{77F3}\u{3002}
    *   **\u{8F6F}\u{7389}\u{53D8}\u{79CD} (Nephrite)**: \u{548C}\u{7530}\u{7389}\u{3002}\u{4E0E}\u{786C}\u{7389}\u{FF08}\u{7FE1}\u{7FE0}\u{FF09}\u{6781}\u{50CF}\u{7684}\u{81F4}\u{5BC6}\u{5757}\u{4F53}\u{FF0C}\u{989C}\u{8272}\u{4ECE}\u{767D}\u{5230}\u{6DF1}\u{7EFF}\u{3002}\u{7269}\u{7406}\u{9274}\u{5B9A}\u{4F9D}\u{9760}\u{6BD4}\u{91CD}\u{548C}\u{7ED3}\u{6676}\u{5F62}\u{6001}\u{FF08}\u{663E}\u{5FAE}\u{955C}\u{4E0B}\u{4E3A}\u{6781}\u{5176}\u{7EC6}\u{5FAE}\u{7684}\u{900F}\u{95EA}\u{77F3}-\u{9633}\u{8D77}\u{77F3}\u{6BDB}\u{6BE1}\u{72B6}\u{4EA4}\u{7EC7}\u{FF09}\u{3002}
*   **\u{95EA}\u{77F3}\u{5BB6}\u{65CF}\u{7684}\u{957F}\u{67F1}\u{53D8}\u{4F53}**:
    *   **\u{76F4}\u{95EA}\u{77F3} (Anthophyllite)**: \u{7ECF}\u{5E38}\u{5448}\u{73B0}**\u{7070}\u{8910}\u{8272}\u{3001}\u{4E01}\u{9999}\u{8910}\u{8272}**\u{7684}\u{653E}\u{5C04}\u{72B6}\u{6216}\u{7EA4}\u{7EF4}\u{72B6}\u{96C6}\u{5408}\u{5757}\u{FF08}\u{5982}\u{56FE}\u{4E2D}\u{94F6}\u{7070}/\u{8910}\u{8272}\u{4EA4}\u{7EC7}\u{7684}\u{95EA}\u{7247}\u{7ED2}\u{5757}\u{FF09}\u{3002}
    *   **\u{9541}\u{94C1}\u{95EA}\u{77F3} (Cummingtonite)** / **\u{94C1}\u{89D2}\u{95EA}\u{77F3} (Grunerite)**: \u{8910}\u{7EFF}\u{8272}\u{81F3}\u{68D5}\u{8272}\u{FF0C}\u{5E38}\u{5177}\u{6709}\u{7EA4}\u{7EF4}\u{72B6}\u{6216}\u{7247}\u{72B6}\u{3002}
*   **\u{78B1}\u{6027}\u{89D2}\u{95EA}\u{77F3}\u{FF08}\u{94A0}\u{95EA}\u{77F3}/\u{84DD}\u{95EA}\u{77F3}\u{7B49}\u{FF09} - \u{9AD8}\u{538B}\u{84DD}\u{7247}\u{5CA9}\u{6307}\u{5411}\u{6807}**:
    *   **\u{84DD}\u{95EA}\u{77F3} (Glaucophane)**: \u{5BFB}\u{627E}\u{53D8}\u{8D28}\u{5CA9}\u{4E2D}\u{5448}\u{73B0}**\u{660E}\u{663E}\u{7684}\u{7070}\u{84DD}\u{8272}\u{3001}\u{85B0}\u{8863}\u{8349}\u{84DD}\u{3001}\u{6DF1}\u{84DD}\u{8272} (grey-blue to lavender-blue)** \u{7684}\u{7EA4}\u{7EF4}\u{72B6}\u{3001}\u{7EC6}\u{5C0F}\u{67F1}\u{72B6}\u{77FF}\u{7269}\u{7C07}\u{3002}\u{8FD9}\u{662F}\u{9AD8}\u{538B}\u{4F4E}\u{6E29}\u{53D8}\u{8D28}\u{76F8}\u{7EDD}\u{5BF9}\u{6807}\u{5FD7}\u{3002}
    *   **\u{94A0}\u{95EA}\u{77F3} (Riebeckite)** / **\u{9752}\u{77F3}\u{68C9} (Crocidolite)**: \u{5E38}\u{5448}\u{73B0}\u{6781}\u{5176}\u{81F4}\u{5BC6}\u{7684}\u{84DD}\u{9ED1}\u{8272}\u{3001}\u{6DF1}\u{84DD}\u{8272}\u{5E73}\u{884C}\u{957F}\u{6761}\u{4EA4}\u{7EC7}\u{5757}\u{72B6}\u{FF08}\u{5982}\u{4F60}\u{7684}\u{94A0}\u{95EA}\u{77F3}\u{6DF1}\u{84DD}\u{8272}\u{7C97}\u{5927}\u{5E26}\u{72B6}\u{5C42}\u{FF09}\u{FF0C}\u{5176}\u{7EA4}\u{7EF4}\u{72B6}\u{53D8}\u{79CD}\u{6781}\u{5177}\u{5371}\u{9669}\u{6027}\u{FF08}\u{77F3}\u{68C9}\u{FF09}\u{3002}

[12.4 \u{5176}\u{5B83}\u{94FE}\u{72B6}\u{7845}\u{9178}\u{76D0}]
*   **\u{7845}\u{7070}\u{77F3} (Wollastonite)**: \u{5915}\u{5361}\u{5CA9}\u{91CD}\u{8981}\u{77FF}\u{7269}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: **\u{96EA}\u{767D}\u{8272}\u{3001}\u{7070}\u{767D}\u{8272} (snow white, greyish-white)**\u{3002}\u{5B83}\u{7279}\u{522B}\u{559C}\u{6B22}\u{957F}\u{6210}**\u{653E}\u{5C04}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{6216}\u{8005}\u{50CF}\u{538B}\u{788E}\u{7684}\u{788E}\u{6728}\u{6761}\u{4E92}\u{76F8}\u{4EA4}\u{9519}\u{7684}\u{89E3}\u{7406}\u{5757}\u{4F53} (cleavable masses with splintery fracture)**\u{3002}\u{5982}\u{679C}\u{4F60}\u{5728}\u{77F3}\u{7070}\u{5CA9}\u{8680}\u{53D8}\u{5E26}\u{770B}\u{5230}\u{767D}\u{8272}\u{7684}\u{9488}\u{72B6}\u{653E}\u{5C04}\u{56E2}\u{FF0C}\u{9996}\u{9009}\u{7845}\u{7070}\u{77F3}\u{3002}
*   **\u{67F1}\u{661F}\u{53F6}\u{77F3} (Astrophyllite)**: \u{6B63}\u{957F}\u{5CA9}\u{5947}\u{89C2}\u{FF01}
    *   **\u{7EDD}\u{6740}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}\u{5728}\u{767D}\u{8272}\u{6216}\u{6D45}\u{8272}\u{57FA}\u{5CA9}\u{4E2D}\u{FF0C}\u{7206}\u{53D1}\u{51FA}**\u{6781}\u{5176}\u{7480}\u{74A8}\u{7684}\u{9752}\u{94DC}\u{8272}\u{3001}\u{91D1}\u{9EC4}\u{8272}\u{6216}\u{7EA2}\u{8910}\u{8272} (bronze, golden-yellow, to reddish-brown)**\u{FF0C}\u{5E76}\u{4E14}\u{50CF}**\u{661F}\u{8292}\u{822C}\u{653E}\u{5C04}\u{72B6}\u{751F}\u{957F}\u{7684}\u{7EC6}\u{957F}\u{5200}\u{7247}\u{72B6}\u{6216}\u{661F}\u{53F6}\u{72B6}\u{6676}\u{7C07} (radiating, stellate bladed crystals)**\u{3002}
*   **\u{659C}\u{7845}\u{94DC}\u{77FF} (Plancheite)**: \u{7F55}\u{89C1}\u{7684}\u{94DC}\u{7845}\u{9178}\u{76D0}\u{3002}\u{5BFB}\u{627E}\u{6781}\u{5EA6}\u{7C7B}\u{4F3C}\u{7845}\u{5B54}\u{96C0}\u{77F3}\u{7684}**\u{6D45}\u{84DD}\u{7EFF}\u{8272}\u{3001}\u{5929}\u{84DD}\u{8272}**\u{FF0C}\u{4F46}\u{5B83}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{6781}\u{7EC6}\u{5FAE}\u{7684}\u{7EA4}\u{7EF4}\u{72B6}\u{6216}\u{7403}\u{72B6}\u{5185}\u{90E8}\u{7ED3}\u{6784}\u{FF08}\u{56FE}\u{4E2D}\u{662F}\u{84DD}\u{7EFF}\u{8272}\u{81F4}\u{5BC6}\u{5757}\u{4F53}\u{5939}\u{6742}\u{FF09}\u{3002}
`,
    diagnosticTests: `
- \u{9762}\u{4E34}\u{4E00}\u{9ED1}\u{8272}/\u{9ED1}\u{7EFF}\u{8272}\u{7684}\u{6697}\u{8272}\u{77F3}\u{5934}\u{FF1A}\u{5982}\u{679C}\u{5B83}\u{662F}\u{77ED}\u{7C97}\u{67F1}\u{5B50}\u{3001}\u{622A}\u{9762}\u{FF08}\u{5207}\u{65AD}\u{9762}\u{FF09}\u{50CF}\u{4E2A}\u{949D}\u{89D2}\u{5F88}\u{5C0F}\u{7684}\u{591A}\u{8FB9}\u{5F62}\u{FF0C}\u{89E3}\u{7406}\u{9762}\u{7684}\u{53CD}\u{5149}\u{662F}\u{4E24}\u{4E2A}\u{5782}\u{76F4}\u{7684}\u{9762}\u{FF0C}\u{5224}\u{5B9A}\u{4E3A}\u{3010}\u{8F89}\u{77F3} (Augite)\u{3011}\u{3002}\u{5982}\u{679C}\u{662F}\u{7EC6}\u{957F}\u{7684}\u{67F1}\u{5B50}\u{6216}\u{9488}\u{FF0C}\u{6A2A}\u{65AD}\u{9762}\u{50CF}\u{4E2A}\u{538B}\u{6241}\u{7684}\u{83F1}\u{5F62}\u{FF0C}\u{53CD}\u{5149}\u{9762}\u{5939}\u{89D2}\u{662F}56/124\u{5EA6}\u{FF0C}\u{5224}\u{5B9A}\u{4E3A}\u{3010}\u{89D2}\u{95EA}\u{77F3} (Hornblende)\u{3011}\u{3002}
- \u{9762}\u{4E34}\u{96EA}\u{767D}\u{8272}/\u{7070}\u{767D}\u{8272}\u{7684}\u{675F}\u{72B6}\u{3001}\u{653E}\u{5C04}\u{72B6}\u{77FF}\u{77F3}\u{FF1A}\u{5982}\u{679C}\u{5728}\u{63A5}\u{89E6}\u{53D8}\u{8D28}\u{5E26}\u{50CF}\u{788E}\u{6728}\u{6761}\u{4EA4}\u{7EC7}\u{7684}\u{FF0C}\u{662F}\u{3010}\u{7845}\u{7070}\u{77F3} Wollastonite\u{3011}\u{3002}\u{5982}\u{679C}\u{662F}\u{6781}\u{5176}\u{5E73}\u{76F4}\u{7684}\u{5203}\u{7247}\u{3001}\u{7EC6}\u{957F}\u{67F1}\u{5B50}\u{FF0C}\u{662F}\u{3010}\u{900F}\u{95EA}\u{77F3} Tremolite\u{3011}\u{3002}
- \u{5BFB}\u{627E}\u{653E}\u{5C04}\u{72B6}\u{7EFF}\u{9488}\u{FF1A}\u{770B}\u{5230}\u{77F3}\u{9762}\u{4E0A}\u{957F}\u{51FA}\u{4E86}\u{7EFF}\u{8272}\u{7684}\u{5E72}\u{8349}\u{5806}\u{6216}\u{7EFF}\u{8272}\u{653E}\u{5C04}\u{957F}\u{9488}\u{7ED3}\u{6676}\u{96C6}\u{5408}\u{FF0C}\u{5F3A}\u{5236}\u{5224}\u{5B9A}\u{4E3A}\u{3010}\u{9633}\u{8D77}\u{77F3} Actinolite\u{3011}\u{3002}
- \u{84DD}\u{8272}\u{53D8}\u{8D28}\u{8B66}\u{62A5}\u{FF1A}\u{5982}\u{679C}\u{5728}\u{5CA9}\u{5C42}\u{91CC}\u{770B}\u{5230}\u{6CDB}\u{7740}\u{85B0}\u{8863}\u{8349}\u{84DD}\u{3001}\u{7070}\u{84DD}\u{7EFF}\u{7684}\u{989C}\u{8272}\u{FF08}\u{5E38}\u{5E38}\u{4EA4}\u{7EC7}\u{6210}\u{7247}\u{5CA9}\u{FF09}\u{FF0C}\u{8FD9}\u{662F}\u{9AD8}\u{538B}\u{76F8}\u{6807}\u{5FD7}\u{7684}\u{3010}\u{84DD}\u{95EA}\u{77F3} Glaucophane\u{3011}\u{3002}\u{5982}\u{679C}\u{662F}\u{81F4}\u{5BC6}\u{6DF1}\u{84DD}\u{9ED1}\u{8272}\u{7C97}\u{6761}\u{5E26}\u{FF0C}\u{662F}\u{3010}\u{94A0}\u{95EA}\u{77F3} Riebeckite\u{3011}\u{3002}
- \u{5BFB}\u{627E}\u{9752}\u{94DC}\u{661F}\u{7206}\u{FF1A}\u{5982}\u{679C}\u{767D}\u{8272}\u{77F3}\u{5934}\u{4E0A}\u{70B8}\u{5F00}\u{4E86}\u{5E26}\u{7740}\u{6781}\u{5176}\u{8000}\u{773C}\u{9752}\u{94DC}\u{8272}\u{3001}\u{91D1}\u{9EC4}\u{8272}\u{6CFD}\u{7684}\u{7EC6}\u{957F}\u{53F6}\u{7247}/\u{661F}\u{8292}\u{72B6}\u{56FE}\u{6848}\u{FF0C}\u{90A3}\u{662F}\u{7EDD}\u{6740}\u{7684}\u{3010}\u{67F1}\u{661F}\u{53F6}\u{77F3} Astrophyllite\u{3011}\u{3002}
- \u{201C}\u{7389}\u{77F3}\u{201D}\u{533A}\u{5206}\u{FF1A}\u{7FE1}\u{7FE0}\u{FF08}\u{786C}\u{7389}\u{FF09}\u{662F}\u{8F89}\u{77F3}\u{FF0C}\u{548C}\u{7530}\u{FF08}\u{8F6F}\u{7389}\u{FF09}\u{662F}\u{89D2}\u{95EA}\u{77F3}\u{3002}\u{5728}\u{5730}\u{8D28}\u{9274}\u{5B9A}\u{4E0A}\u{9700}\u{8981}\u{663E}\u{5FAE}\u{6216}\u{5316}\u{5B66}\u{7279}\u{5F81}\u{3002}
`
};


const $018989608f017572$export$cd7d5b7529f554c8 = {
    description: "Nesosilicates (Island Silicates) Identification Rules",
    coreRules: `
=== \u{7845}\u{9178}\u{76D0}\u{4E4B}\u{5C9B}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Nesosilicates / Island Silicates Protocol) ===

\u{5728}\u{8FD9}\u{4E2A}\u{5E9E}\u{5927}\u{7684}\u{5BB6}\u{65CF}\u{4E2D}\u{FF0C}\u{7845}\u{6C27}\u{56DB}\u{9762}\u{4F53}\u{662F}\u{5B64}\u{7ACB}\u{5B58}\u{5728}\u{7684}\u{FF0C}\u{8FD9}\u{8D4B}\u{4E88}\u{4E86}\u{5B83}\u{4EEC}\u{6781}\u{9AD8}\u{7684}\u{786C}\u{5EA6}\u{3001}\u{6781}\u{5DEE}\u{7684}\u{89E3}\u{7406}\u{FF08}\u{5373}\u{4E0D}\u{5BB9}\u{6613}\u{6CBF}\u{7740}\u{5E73}\u{6574}\u{9762}\u{88C2}\u{5F00}\u{FF09}\u{4EE5}\u{53CA}\u{5E38}\u{5E38}\u{6781}\u{4E3A}\u{81F4}\u{5BC6}\u{7684}\u{6676}\u{4F53}\u{7ED3}\u{6784}\u{3002}\u{5B83}\u{4EEC}\u{662F}\u{5730}\u{5E54}\u{5CA9}\u{77F3}\u{548C}\u{9AD8}\u{7EA7}\u{53D8}\u{8D28}\u{5CA9}\u{7684}\u{6838}\u{5FC3}\u{4EE3}\u{8868}\u{3002}

[9.1 \u{6A44}\u{6984}\u{77F3}\u{5BB6}\u{65CF} (The Olivine Group) - \u{5730}\u{5E54}\u{7EFF}\u{5B9D}\u{77F3}]
*   **\u{6A44}\u{6984}\u{77F3} (Olivine - \u{9541}\u{94C1}\u{6A44}\u{6984}\u{77F3}\u{56FA}\u{6EB6}\u{4F53}\u{4F53}\u{7CFB})**:
    *   **\u{989C}\u{8272}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}\u{6807}\u{5FD7}\u{6027}\u{7684}**\u{9EC4}\u{7EFF}\u{8272}\u{3001}\u{6A44}\u{6984}\u{7EFF} (Olive-green, Yellow-green)**\u{3002}\u{989C}\u{8272}\u{8D8A}\u{6DF1}\u{FF0C}\u{542B}\u{94C1}\u{91CF}\u{8D8A}\u{9AD8}\u{3002}
    *   **\u{5F62}\u{6001}\u{4E0E}\u{8D28}\u{5730}**: \u{6781}\u{5C11}\u{6709}\u{5B8C}\u{7F8E}\u{7684}\u{6676}\u{5F62}\u{FF0C}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{4E3A}**\u{7802}\u{7CD6}\u{72B6}\u{3001}\u{9897}\u{7C92}\u{72B6}\u{81F4}\u{5BC6}\u{96C6}\u{5408}\u{4F53} (Granular masses)**\u{3002}\u{611F}\u{89C9}\u{5C31}\u{50CF}\u{628A}\u{7EFF}\u{8272}\u{7684}\u{788E}\u{73BB}\u{7483}\u{6216}\u{7802}\u{7CD6}\u{538B}\u{5B9E}\u{5728}\u{4E00}\u{8D77}\u{3002}
    *   **\u{65AD}\u{53E3}**: **\u{8D1D}\u{58F3}\u{72B6}\u{65AD}\u{53E3} (Conchoidal fracture)**\u{FF0C}\u{6CA1}\u{6709}\u{5E73}\u{6574}\u{7684}\u{89E3}\u{7406}\u{9762}\u{FF0C}\u{8FD9}\u{662F}\u{533A}\u{5206}\u{5B83}\u{4E0E}\u{67D0}\u{4E9B}\u{7EFF}\u{8272}\u{8F89}\u{77F3}\u{7684}\u{5173}\u{952E}\u{3002}\u{5149}\u{6CFD}\u{4E3A}\u{5F3A}\u{70C8}\u{7684}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{3002}
*   **\u{9499}\u{9541}\u{6A44}\u{6984}\u{77F3} (Monticellite)**: \u{6A44}\u{6984}\u{77F3}\u{7684}\u{8FD1}\u{4EB2}\u{3002}\u{901A}\u{5E38}\u{989C}\u{8272}\u{66F4}\u{6D45}\u{FF08}\u{7070}\u{767D}\u{3001}\u{6D45}\u{9EC4}\u{8910}\u{FF09}\u{FF0C}\u{7ECF}\u{5E38}\u{4E0E}\u{77F3}\u{7070}\u{5CA9}\u{63A5}\u{89E6}\u{53D8}\u{8D28}\u{5E26}\u{6709}\u{5173}\u{3002}

[9.2 \u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{5BB6}\u{65CF} (The Garnet Group) - \u{5341}\u{4E8C}\u{9762}\u{4F53}\u{9632}\u{7EBF}]
\u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{662F}\u{9AD8}\u{7EA7}\u{53D8}\u{8D28}\u{5E26}\u{7684}\u{7EDD}\u{5BF9}\u{7EDF}\u{6CBB}\u{8005}\u{3002}\u{5B83}\u{4EEC}\u{7684}\u{6838}\u{5FC3}\u{89C6}\u{89C9}\u{6CD5}\u{5219}\u{662F}**\u{201C}\u{5B8C}\u{7F8E}\u{7684}\u{7B49}\u{8F74}\u{6676}\u{7CFB}\u{51E0}\u{4F55}\u{4F53}\u{201D}**\u{3002}
*   **\u{5F62}\u{6001}\u{951A}\u{70B9} (\u{9002}\u{7528}\u{6240}\u{6709}\u{77F3}\u{69B4}\u{77F3})**: \u{6B7B}\u{6B7B}\u{76EF}\u{4F4F}**\u{83F1}\u{5F62}\u{5341}\u{4E8C}\u{9762}\u{4F53} (Rhombic dodecahedron) \u{6216} \u{56DB}\u{89D2}\u{4E09}\u{516B}\u{9762}\u{4F53} (Trapezohedron)**\u{3002}\u{5B83}\u{4EEC}\u{7ECF}\u{5E38}\u{50CF}\u{4E00}\u{9897}\u{9897}\u{5B8C}\u{7F8E}\u{7684}\u{51E0}\u{4F55}\u{9AB0}\u{5B50}\u{4E00}\u{6837}\u{9576}\u{5D4C}\u{5728}\u{7247}\u{5CA9}\u{6216}\u{7247}\u{9EBB}\u{5CA9}\u{7684}\u{57FA}\u{8D28}\u{4E2D}\u{3002}\u{65E0}\u{89E3}\u{7406}\u{FF0C}\u{6709}\u{8D1D}\u{58F3}\u{72B6}\u{65AD}\u{53E3}\u{FF0C}\u{786C}\u{5EA6}\u{6781}\u{5927}\u{3002}
*   **\u{94C1}\u{94DD}\u{69B4}\u{77F3} (Almandine)**: \u{6700}\u{5E38}\u{89C1}\u{7684}\u{77F3}\u{69B4}\u{77F3}\u{3002}**\u{6697}\u{7EA2}\u{8272}\u{3001}\u{7D2B}\u{7EA2}\u{8272}\u{5230}\u{8910}\u{7EA2}\u{8272} (Deep red, brownish-red, to purplish-red)**\u{3002}\u{5E38}\u{51FA}\u{73B0}\u{5728}\u{4E91}\u{6BCD}\u{7247}\u{5CA9}\u{4E2D}\u{3002}
*   **\u{9541}\u{94DD}\u{69B4}\u{77F3} (Pyrope)**: \u{901A}\u{5E38}\u{989C}\u{8272}\u{6BD4}\u{94C1}\u{94DD}\u{69B4}\u{77F3}\u{66F4}\u{4EAE}\u{FF0C}\u{5448}**\u{8840}\u{7EA2}\u{8272}\u{3001}\u{7D2B}\u{7EA2}\u{8272} (Blood-red, bright red)**\u{3002}\u{5E38}\u{4E0E}\u{8D85}\u{57FA}\u{6027}\u{5CA9}\u{6216}\u{91D1}\u{4F2F}\u{5229}\u{5CA9}\u{FF08}\u{94BB}\u{77F3}\u{4F34}\u{751F}\u{5CA9}\u{FF09}\u{76F8}\u{5173}\u{3002}
*   **\u{9530}\u{94DD}\u{69B4}\u{77F3} (Spessartine)**: **\u{9C9C}\u{8273}\u{7684}\u{6A59}\u{7EA2}\u{8272}\u{3001}\u{6A58}\u{9EC4}\u{8272}\u{5230}\u{7EA2}\u{8910}\u{8272} (Orange, red-orange, vivid mandarin red)**\u{3002}\u{82AC}\u{8FBE}\u{77F3}\u{5C31}\u{662F}\u{5B83}\u{3002}\u{5E38}\u{4EA7}\u{4E8E}\u{82B1}\u{5C97}\u{4F1F}\u{6676}\u{5CA9}\u{4E2D}\u{3002}
*   **\u{9499}\u{94DD}\u{69B4}\u{77F3} (Grossular)**: \u{989C}\u{8272}\u{591A}\u{53D8}\u{FF0C}\u{4F46}\u{5178}\u{578B}\u{7684}\u{662F}**\u{9EC4}\u{7EFF}\u{8272}\u{3001}\u{7FE0}\u{7EFF}\u{8272} (\u{6C99}\u{5F17}\u{83B1}\u{77F3}) \u{6216}\u{8089}\u{6842}\u{8272}\u{3001}\u{8910}\u{9EC4}\u{8272} (Cinnamon brown)**\u{3002}\u{5E38}\u{5728}\u{63A5}\u{89E6}\u{4EA4}\u{4EE3}\u{5915}\u{5361}\u{5CA9}\u{4E2D}\u{53D1}\u{73B0}\u{3002}
*   **\u{94C1}\u{9499}\u{69B4}\u{77F3} (Andradite - \u{9EC4}\u{69B4}\u{77F3}/\u{9ED1}\u{69B4}\u{77F3})**: \u{7FE0}\u{7EFF}\u{8272}\u{FF08}\u{7FE0}\u{69B4}\u{77F3}\u{FF09}\u{6781}\u{5176}\u{7F55}\u{89C1}\u{4E14}\u{5177}\u{6709}\u{6781}\u{9AD8}\u{8272}\u{6563}\u{FF1B}**\u{9ED1}\u{69B4}\u{77F3} (Melanite)** \u{5219}\u{5448}\u{73B0}\u{4E0D}\u{900F}\u{660E}\u{7684}**\u{4EAE}\u{9ED1}\u{8272}**\u{3002}\u{5728}\u{5915}\u{5361}\u{5CA9}\u{4E2D}\u{5E38}\u{89C1}\u{3002}

[9.3 \u{94DD}\u{7845}\u{9178}\u{76D0}\u{4E09}\u{5144}\u{5F1F} - \u{53D8}\u{8D28}\u{76F8}\u{6307}\u{793A}\u{5242}]
\u{8FD9}\u{4E09}\u{79CD}\u{77FF}\u{7269}\u{6210}\u{5206}\u{5B8C}\u{5168}\u{76F8}\u{540C} ($Al_2SiO_5$)\u{FF0C}\u{4F46}\u{5F62}\u{6210}\u{4E8E}\u{4E0D}\u{540C}\u{7684}\u{6E29}\u{5EA6}\u{548C}\u{538B}\u{529B}\u{4E0B}\u{3002}
*   **\u{7EA2}\u{67F1}\u{77F3} (Andalusite)**: \u{4F4E}\u{538B}\u{4E2D}\u{6E29}\u{6807}\u{5FD7}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}**\u{7C97}\u{5927}\u{7684}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{6A2A}\u{622A}\u{9762}\u{5448}\u{5B8C}\u{5168}\u{6B63}\u{65B9}\u{5F62} (Square cross-section)**\u{3002}
    *   **\u{7A7A}\u{6676}\u{77F3}\u{53D8}\u{79CD} (Chiastolite)**: \u{7EDD}\u{5BF9}\u{7EDD}\u{6740}\u{7684}\u{89C6}\u{89C9}\u{951A}\u{70B9}\u{FF01}\u{65AD}\u{9762}\u{4E0A}\u{5E26}\u{6709}\u{7531}\u{78B3}\u{8D28}\u{5305}\u{88F9}\u{4F53}\u{5F62}\u{6210}\u{7684}**\u{6781}\u{5176}\u{5B8C}\u{7F8E}\u{7684}\u{6DF1}\u{8272}\u{201C}\u{5341}\u{5B57}\u{67B6}\u{201D}\u{5F62}\u{72B6} (Distinct dark cross on cross-section)**\u{3002}
*   **\u{84DD}\u{6676}\u{77F3} (Kyanite)**: \u{9AD8}\u{538B}\u{4F4E}\u{6E29}\u{6807}\u{5FD7}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: **\u{84DD}\u{8272}\u{7684}\u{3001}\u{957F}\u{6781}\u{6241}\u{5E73}\u{7684}\u{5200}\u{7247}\u{72B6}/\u{677F}\u{6761}\u{72B6}\u{6676}\u{4F53} (Blue bladed crystals)**\u{3002}
    *   **\u{786C}\u{5EA6}\u{7EDD}\u{6740}\u{89C4}\u{5219}**: \u{62E5}\u{6709}\u{7F55}\u{89C1}\u{7684}\u{65B9}\u{5411}\u{6027}\u{786C}\u{5EA6}\u{3002}\u{6CBF}\u{7740}\u{6676}\u{4F53}\u{957F}\u{8F74}\u{65B9}\u{5411}\u{FF0C}\u{5C0F}\u{5200}\u{53EF}\u{4EE5}\u{5212}\u{52A8} (\u{786C}\u{5EA6}~5)\u{FF0C}\u{4F46}\u{5728}\u{5782}\u{76F4}\u{4E8E}\u{957F}\u{8F74}\u{7684}\u{65B9}\u{5411}\u{4E0A}\u{FF0C}\u{5C0F}\u{5200}\u{5212}\u{4E0D}\u{52A8} (\u{786C}\u{5EA6}~7)\u{3002}
*   **\u{7845}\u{7EBF}\u{77F3} (Sillimanite)**: \u{9AD8}\u{6E29}\u{6807}\u{5FD7}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{5982}\u{5176}\u{540D}\u{FF0C}\u{5BFB}\u{627E}**\u{7EA4}\u{7EF4}\u{72B6}\u{3001}\u{6BDB}\u{53D1}\u{72B6}\u{3001}\u{6216}\u{8005}\u{7EC6}\u{957F}\u{653E}\u{5C04}\u{72B6}\u{7684}\u{9488}\u{72B6}\u{7ED3}\u{6676} (Fibrous, needle-like, or radiating masses)**\u{3002}\u{5B83}\u{901A}\u{5E38}\u{662F}\u{7070}\u{767D}\u{8272}\u{3001}\u{6D45}\u{8910}\u{8272}\u{7684}\u{7EA4}\u{7EC6}\u{56E2}\u{5757}\u{3002}

[9.4 \u{7A00}\u{6709}\u{5C9B}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{4E0E}\u{7279}\u{6B8A}\u{6676}\u{4F53}]
*   **\u{5341}\u{5B57}\u{77F3} (Staurolite)**: \u{4E2D}\u{9AD8}\u{538B}\u{53D8}\u{8D28}\u{6807}\u{5FD7}\u{3002}
    *   **\u{7EDD}\u{5BF9}\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}\u{6DF1}\u{8910}\u{8272}\u{81F3}\u{6697}\u{7EA2}\u{8910}\u{8272}\u{7684}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{5B83}\u{4EEC}\u{7ECF}\u{5E38}\u{76F8}\u{4E92}\u{7A7F}\u{63D2}\u{FF0C}\u{5F62}\u{6210}\u{6781}\u{5176}\u{5B8C}\u{7F8E}\u{7684}**90\u{5EA6}\u{6B63}\u{5341}\u{5B57}\u{5F62}\u{6216}60\u{5EA6}\u{659C}\u{5341}\u{5B57}\u{5F62}\u{53CC}\u{6676} (Penetration cruciform twins)**\u{3002}\u{5176}\u{8868}\u{9762}\u{5E38}\u{663E}\u{5F97}\u{6709}\u{4E9B}\u{6BDB}\u{7CD9}\u{6216}\u{6697}\u{6DE1}\u{3002}
*   **\u{9EC4}\u{7389} / \u{6258}\u{5E15}\u{77F3} (Topaz)**:
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{67F1}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{6709}\u{7740}**\u{5B8C}\u{7F8E}\u{7684}\u{5E95}\u{9762}\u{89E3}\u{7406} (Perfect basal cleavage)**\u{2014}\u{2014}\u{610F}\u{5473}\u{7740}\u{6676}\u{4F53}\u{9876}\u{7AEF}\u{5E38}\u{662F}\u{5E73}\u{9F50}\u{65AD}\u{5F00}\u{7684}\u{3002}
    *   **\u{989C}\u{8272}\u{4E0E}\u{786C}\u{5EA6}**: \u{786C}\u{5EA6}\u{4E3A}8\u{7684}\u{6807}\u{5C3A}\u{3002}\u{53EF}\u{4EE5}\u{662F}\u{900F}\u{660E}\u{65E0}\u{8272}\u{3001}\u{9999}\u{69DF}\u{8272} (\u{9EC4}\u{8910}\u{8272})\u{3001}\u{84DD}\u{8272}\u{6216}\u{7C89}\u{8272}\u{3002}\u{5177}\u{6709}\u{6781}\u{5176}\u{660E}\u{4EAE}\u{751A}\u{81F3}\u{6709}\u{4E9B}\u{523A}\u{773C}\u{7684}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{3002}
*   **\u{9506}\u{77F3} (Zircon)**:
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}\u{6781}\u{5176}\u{5178}\u{578B}\u{7684}**\u{56DB}\u{65B9}\u{53CC}\u{9525}\u{6676}\u{4F53} (Tetragonal bipyramids)**\u{FF0C}\u{6709}\u{65F6}\u{5E26}\u{6709}\u{77ED}\u{67F1}\u{4F53}\u{3002}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{5FAE}\u{5C0F}\u{7684}\u{3001}\u{9876}\u{7AEF}\u{5C16}\u{9510}\u{7684}\u{91D1}\u{5B57}\u{5854}\u{5BF9}\u{6263}\u{3002}
    *   **\u{5149}\u{6CFD}\u{4E0E}\u{591A}\u{8272}\u{6027}**: \u{5177}\u{6709}\u{6781}\u{9AD8}\u{7684}\u{6298}\u{5C04}\u{7387}\u{FF0C}\u{5448}\u{73B0}**\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{81F3}\u{5F3A}\u{73BB}\u{7483}\u{5149}\u{6CFD} (Adamantine luster)**\u{3002}\u{5E38}\u{89C1}\u{7EA2}\u{8910}\u{8272}\u{3001}\u{9EC4}\u{8910}\u{8272}\u{FF0C}\u{4E5F}\u{6709}\u{7F8E}\u{4E3D}\u{7684}\u{84DD}\u{8272}\u{53D8}\u{79CD}\u{3002}
*   **\u{698D}\u{77F3} (Titanite / Sphene)**:
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{6781}\u{5176}\u{5F3A}\u{70C8}\u{7684}**\u{6954}\u{5F62}\u{3001}\u{4FE1}\u{5C01}\u{5F62}\u{6676}\u{4F53} (Wedge-shaped or envelope-like crystals)**\u{3002}
    *   **\u{5149}\u{8272}\u{7EDD}\u{6740}**: \u{5B83}\u{6709}\u{7740}\u{751A}\u{81F3}\u{8D85}\u{8FC7}\u{94BB}\u{77F3}\u{7684}\u{8272}\u{6563}\u{7387} (\u{706B}\u{5F69})\u{3002}\u{5BFB}\u{627E}**\u{9EC4}\u{7EFF}\u{8272}\u{3001}\u{68D5}\u{8910}\u{8272}\u{3001}\u{9EC4}\u{8272}\u{7684}\u{534A}\u{900F}\u{660E}\u{81F3}\u{900F}\u{660E}\u{6676}\u{4F53}\u{FF0C}\u{4F34}\u{968F}\u{6781}\u{5F3A}\u{7684}\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{81F3}\u{6811}\u{8102}\u{5149}\u{6CFD}**\u{3002}
*   **\u{7845}\u{787C}\u{9499}\u{77F3} (Datolite)**:
    *   \u{5E38}\u{5448}\u{73B0}\u{6781}\u{5176}\u{81F4}\u{5BC6}\u{3001}\u{7C7B}\u{4F3C}\u{74F7}\u{5668}\u{6216}\u{8005}\u{7EC6}\u{7C92}\u{7CD6}\u{679C}\u{72B6}\u{7684}\u{5757}\u{4F53}\u{FF08}\u{5982}\u{4F60}\u{7684}\u{7C89}\u{8272}\u{7624}\u{72B6}\u{56FE}\u{FF09}\u{FF0C}\u{4E5F}\u{53EF}\u{662F}\u{590D}\u{6742}\u{7684}\u{4EAE}\u{767D}\u{8272}\u{77ED}\u{67F1}\u{72B6}/\u{7B49}\u{8F74}\u{72B6}\u{5C0F}\u{6676}\u{4F53}\u{79EF}\u{805A}\u{3002}\u{989C}\u{8272}\u{5E38}\u{4E3A}\u{6D45}\u{7EFF}\u{767D}\u{3001}\u{9EC4}\u{767D}\u{6216}\u{6DE1}\u{7C89}\u{8272}\u{FF0C}\u{7F3A}\u{4E4F}\u{77F3}\u{82F1}\u{90A3}\u{6837}\u{7684}\u{901A}\u{900F}\u{611F}\u{FF0C}\u{65AD}\u{53E3}\u{504F}\u{5411}\u{53C2}\u{5DEE}\u{72B6}\u{3002}
*   **\u{84DD}\u{7EBF}\u{77F3} (Dumortierite)**:
    *   \u{5BFB}\u{627E}\u{5728}\u{77F3}\u{82F1}\u{6216}\u{5176}\u{4ED6}\u{6D45}\u{8272}\u{57FA}\u{5E95}\u{4E0A}\u{7684}**\u{6DF1}\u{84DD}\u{8272}\u{3001}\u{7D2B}\u{84DD}\u{8272}\u{6216}\u{7C89}\u{7D2B}\u{8272}\u{7684}\u{81F4}\u{5BC6}\u{7EA4}\u{7EF4}\u{72B6}\u{3001}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{96C6}\u{7ED3} (Fibrous, radiating deeply purplish-blue masses)**\u{3002}\u{7ECF}\u{5E38}\u{4F5C}\u{4E3A}\u{5305}\u{88F9}\u{4F53}\u{6216}\u{7C97}\u{7CD9}\u{7684}\u{5757}\u{4F53}\u{5B58}\u{5728}\u{3002}
*   **\u{7845}\u{94DC}\u{94C0}\u{77FF} (Cuprosklodowskite)**:
    *   \u{94C0}\u{7684}\u{9AD8}\u{7EA7}\u{8B66}\u{62A5}\u{3002}\u{5728}\u{6B64}\u{5904}\u{5C9B}\u{72B6}\u{7ED3}\u{6784}\u{4E2D}\u{5BFB}\u{627E}**\u{6781}\u{5176}\u{5996}\u{8273}\u{7684}\u{4EAE}\u{7FE0}\u{7EFF}\u{8272}\u{3001}\u{8349}\u{7EFF}\u{8272}\u{7684}\u{653E}\u{5C04}\u{72B6}\u{8D85}\u{7EC6}\u{6BDB}\u{53D1}\u{72B6}/\u{9488}\u{72B6}\u{6676}\u{7C07} (Radiating tufts of bright green needles)**\u{3002}\u{5B83}\u{5E26}\u{6709}\u{6781}\u{5F3A}\u{70C8}\u{7684}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{5230}\u{4E1D}\u{91D1}\u{5149}\u{6CFD}\u{FF0C}\u{4E14}\u{5177}\u{6709}\u{653E}\u{5C04}\u{6027}\u{FF01}
`,
    diagnosticTests: `
- \u{5728}\u{53D8}\u{8D28}\u{5CA9}\u{5207}\u{7247}\u{6216}\u{5757}\u{4F53}\u{4E0A}\u{FF0C}\u{5BFB}\u{627E}\u{51E0}\u{4F55}\u{5F62}\u{72B6}\u{FF1A}\u{5982}\u{679C}\u{6709}\u{6B63}\u{65B9}\u{5F62}\u{6A2A}\u{622A}\u{9762}\u{7684}\u{957F}\u{67F1}\u{FF08}\u{7279}\u{522B}\u{662F}\u{5E26}\u{6709}\u{9ED1}\u{5341}\u{5B57}\u{4E2D}\u{5FC3}\u{FF09}\u{FF0C}\u{662F}\u{7EA2}\u{67F1}\u{77F3}\u{FF1B}\u{5982}\u{679C}\u{6709}\u{5B8C}\u{7F8E}\u{9576}\u{5D4C}\u{7684}\u{83F1}\u{5F62}\u{5341}\u{4E8C}\u{9762}\u{4F53}/\u{591A}\u{9762}\u{4F53}\u{FF0C}\u{5FC5}\u{987B}\u{9501}\u{5B9A}\u{5404}\u{79CD}\u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{FF1B}\u{5982}\u{679C}\u{6709}\u{6B63}\u{4EA4}\u{6216}\u{659C}\u{4EA4}\u{7684}\u{6DF1}\u{8910}\u{8272}\u{5341}\u{5B57}\u{53CC}\u{6676}\u{FF0C}\u{90A3}\u{662F}\u{7EDD}\u{5BF9}\u{7684}\u{5341}\u{5B57}\u{77F3}\u{3002}
- \u{5982}\u{679C}\u{77FF}\u{77F3}\u{662F}\u{84DD}\u{8272}\u{7684}\u{81F4}\u{5BC6}\u{957F}\u{6761}\u{5200}\u{7247}\u{FF0C}\u{522E}\u{64E6}\u{6D4B}\u{8BD5}\u{FF1A}\u{987A}\u{7740}\u{957F}\u{6761}\u{522E}\u{5F97}\u{52A8}\u{FF0C}\u{6A2A}\u{7740}\u{522E}\u{4E0D}\u{52A8}\u{FF0C}\u{90A3}\u{662F}\u{84DD}\u{6676}\u{77F3}\u{7EDD}\u{6740}\u{3002}
- \u{770B}\u{5230}\u{50CF}\u{7ED9}\u{77F3}\u{5934}\u{88F9}\u{4E86}\u{4E00}\u{5C42}\u{534A}\u{900F}\u{660E}\u{7EFF}\u{8272}\u{7802}\u{7CD6}\u{6216}\u{788E}\u{73BB}\u{7483}\u{FF0C}\u{6CA1}\u{6709}\u{5E73}\u{6574}\u{88C2}\u{9762}\u{7684}\u{FF0C}\u{90A3}\u{662F}\u{6A44}\u{6984}\u{77F3}\u{3002}
- \u{5982}\u{679C}\u{53D1}\u{73B0}\u{68D5}\u{8910}\u{8272}\u{6676}\u{4F53}\u{FF0C}\u{5448}\u{73B0}\u{6781}\u{5176}\u{5C16}\u{9510}\u{7684}\u{6954}\u{5B50}/\u{4FE1}\u{5C01}\u{5F62}\u{72B6}\u{5E76}\u{4E14}\u{5728}\u{5F3A}\u{5149}\u{4E0B}\u{706B}\u{5F69}\u{95EA}\u{70C1}\u{6781}\u{5F3A}\u{FF0C}\u{90A3}\u{662F}\u{698D}\u{77F3}\u{3002}
- \u{770B}\u{5230}\u{5FAE}\u{5C0F}\u{4F46}\u{6298}\u{5C04}\u{7387}\u{6781}\u{9AD8}\u{3001}\u{5149}\u{8292}\u{523A}\u{773C}\u{4E14}\u{5448}\u{56DB}\u{65B9}\u{5F62}\u{53CC}\u{9525}\u{7684}\u{5C0F}\u{6676}\u{4F53}\u{FF0C}\u{5B83}\u{662F}\u{9506}\u{77F3}\u{3002}
- \u{5982}\u{679C}\u{662F}\u{6781}\u{7EC6}\u{6781}\u{9C9C}\u{8273}\u{7684}\u{8349}\u{7EFF}\u{8272}\u{653E}\u{5C04}\u{72B6}\u{957F}\u{7ED2}\u{6BDB}\u{9488}\u{7C07}\u{FF0C}\u{9AD8}\u{5EA6}\u{63D0}\u{9632}\u{653E}\u{5C04}\u{6027}\u{7684}\u{7845}\u{94DC}\u{94C0}\u{77FF}\u{3002}
`
};


const $73e7a7fda92fae7e$export$149a77c9f978853c = {
    description: "Nitrates & Borates Identification Rules",
    coreRules: `
=== \u{785D}\u{9178}\u{76D0}\u{4E0E}\u{787C}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Nitrates & Borates Diagnostic Protocol) ===

[6.1 \u{787C}\u{9178}\u{76D0}\u{7684}\u{7ECF}\u{5178}\u{767D}\u{6676}\u{7CFB} (The Core White Borates)]
*   **\u{659C}\u{65B9}\u{787C}\u{7802} / \u{8D2B}\u{6C34}\u{787C}\u{7802} (Kernite)**: \u{91CD}\u{8981}\u{7684}\u{787C}\u{77FF}\u{77F3}\u{3002}\u{957F}\u{5F97}\u{50CF}\u{767D}\u{8272}\u{7684}\u{5E72}\u{51B0}\u{6216}\u{77F3}\u{818F}\u{3002}\u{5FC5}\u{987B}\u{5BFB}\u{627E}\u{5176}**\u{6CBF}\u{7740}\u{89E3}\u{7406}\u{9762}\u{65AD}\u{88C2}\u{6210}\u{975E}\u{5E38}\u{957F}\u{7684}\u{3001}\u{65E0}\u{8272}\u{6216}\u{767D}\u{8272}\u{7684}\u{53EF}\u{5288}\u{5F00}\u{7684}\u{957F}\u{6761}\u{72B6}/\u{5288}\u{5200}\u{72B6}\u{6676}\u{4F53} (Cleavage parallel to long fibers)**\u{3002}\u{6709}\u{65F6}\u{8868}\u{9762}\u{4F1A}\u{56E0}\u{4E3A}\u{5931}\u{6C34}\u{800C}\u{4EA7}\u{751F}\u{53D1}\u{767D}\u{7684}\u{7C89}\u{672B}\u{72B6}\u{5916}\u{58F3}\u{3002}
*   **\u{94A0}\u{787C}\u{89E3}\u{77F3} (Ulexite)**: \u{6781}\u{5EA6}\u{8457}\u{540D}\u{7684}**\u{201C}\u{7535}\u{89C6}\u{77F3}\u{201D} (TV Stone)**\u{3002}
    *   \u{3010}\u{7EC8}\u{6781}\u{5149}\u{5B66}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{5F53}\u{5B83}\u{88AB}\u{5207}\u{5272}\u{6210}\u{5E73}\u{6574}\u{7684}\u{5757}\u{72B6}\u{65F6}\u{FF08}\u{5982}\u{56FE}\u{4E2D}\u{5448}\u{73B0}\u{7684}\u{90A3}\u{6837}\u{FF09}\u{FF0C}\u{5B83}\u{5177}\u{6709}\u{5E73}\u{884C}\u{6392}\u{5217}\u{7684}\u{6781}\u{7EC6}\u{7EA4}\u{7EF4}\u{3002}\u{5149}\u{7EBF}\u{6CBF}\u{7740}\u{8FD9}\u{4E9B}\u{7EA4}\u{7EF4}\u{5982}\u{540C}\u{5149}\u{7EA4}\u{4E00}\u{6837}\u{4F20}\u{5BFC}\u{3002}\u{56E0}\u{6B64}\u{FF0C}\u{5982}\u{679C}\u{5728}\u{6807}\u{672C}\u{63CF}\u{8FF0}\u{6216}\u{56FE}\u{7247}\u{4E2D}\u{770B}\u{5230}\u{4E00}\u{5757}\u{50CF}\u{80A5}\u{7682}\u{4E00}\u{6837}\u{7684}\u{767D}\u{7816}\u{FF0C}\u{5177}\u{6709}\u{89C4}\u{5219}\u{7684}\u{76F4}\u{8FB9}\u{754C}\u{7EB9}\u{7406}\u{FF0C}\u{76F4}\u{63A5}\u{9501}\u{5B9A}\u{94A0}\u{787C}\u{89E3}\u{77F3}\u{3002}
*   **\u{767D}\u{787C}\u{9499}\u{77F3} (Colemanite)**:
    *   \u{3010}\u{5F62}\u{6001}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{65E0}\u{8272}\u{5230}\u{767D}\u{8272}\u{7684}**\u{77ED}\u{67F1}\u{72B6}\u{3001}\u{5757}\u{72B6}\u{751A}\u{81F3}\u{50CF}\u{51B0}\u{7CD6}\u{4E00}\u{6837}\u{7684}\u{6676}\u{4F53}\u{56E2}\u{5757} (Blocky to crystalline masses)**\u{3002}\u{5B83}\u{5F80}\u{5F80}\u{5177}\u{6709}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{5E76}\u{4E14}\u{6BD4}\u{53E6}\u{5916}\u{4E24}\u{8005}\u{66F4}\u{663E}\u{201C}\u{7ED3}\u{5B9E}\u{201D}\u{6216}\u{5F62}\u{6210}\u{6709}\u{660E}\u{663E}\u{5207}\u{9762}\u{7684}\u{6676}\u{7C07}\u{FF0C}\u{800C}\u{4E0D}\u{662F}\u{7535}\u{89C6}\u{77F3}\u{7684}\u{5149}\u{7EA4}\u{72B6}\u{6216}\u{8D2B}\u{6C34}\u{787C}\u{7802}\u{7684}\u{957F}\u{5288}\u{9762}\u{3002}
*   **\u{4E09}\u{659C}\u{787C}\u{9499}\u{77F3} / \u{8F6F}\u{787C}\u{9499}\u{77F3} (Inyoite)**: \u{7F55}\u{89C1}\u{7684}\u{5BCC}\u{6C34}\u{787C}\u{9499}\u{77F3}\u{3002}
    *   \u{3010}\u{7834}\u{7EFD}\u{3011}\u{FF1A}\u{867D}\u{7136}\u{4E5F}\u{662F}\u{65E0}\u{8272}\u{5230}\u{767D}\u{8272}\u{7684}\u{6676}\u{4F53}\u{FF0C}\u{4F46}\u{5B83}\u{6781}\u{6613}\u{98CE}\u{5316}\u{FF0C}\u{8868}\u{9762}\u{5E38}\u{4F1A}\u{53D8}\u{6210}\u{6D51}\u{6D4A}\u{7684}\u{767D}\u{8272}\u{7C89}\u{672B}\u{72B6}\u{3002}\u{5982}\u{679C}\u{770B}\u{5230}\u{50CF}\u{4E00}\u{5806}\u{8106}\u{5F31}\u{7684}\u{3001}\u{8868}\u{9762}\u{8D77}\u{7C89}\u{7684}\u{767D}\u{8272}\u{5230}\u{5FAE}\u{7C89}\u{8272}/\u{5FAE}\u{9EC4}\u{8272}\u{7684}\u{659C}\u{5757}\u{72B6}\u{6676}\u{4F53}\u{7FA4}\u{FF0C}\u{8981}\u{8003}\u{8651}\u{8FD9}\u{4E2A}\u{7F55}\u{89C1}\u{53D8}\u{79CD}\u{3002}

[6.2 \u{91CD}\u{91D1}\u{5C5E}\u{7684}\u{5947}\u{5F02}\u{787C}\u{9178}\u{76D0} (Heavy & Exotic Borates)]
*   **\u{787C}\u{9541}\u{94C1}\u{77FF} (Ludwigite)**: \u{5F7B}\u{5E95}\u{6253}\u{7834}\u{4E86}\u{787C}\u{9178}\u{76D0}\u{662F}\u{767D}\u{8272}\u{900F}\u{660E}\u{7684}\u{523B}\u{677F}\u{5370}\u{8C61}\u{3002}
    *   \u{3010}\u{6781}\u{9ED1}\u{7684}\u{653E}\u{5C04}\u{7EB9}\u{3011}\u{FF1A}\u{5B83}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{51FA}**\u{6781}\u{5EA6}\u{6697}\u{9ED1}\u{3001}\u{9ED1}\u{7EFF}\u{8272}\u{751A}\u{81F3}\u{6DF1}\u{8910}\u{8272}\u{7684}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{6216}\u{6781}\u{7EC6}\u{7684}\u{653E}\u{5C04}\u{72B6}/\u{7EA4}\u{7EF4}\u{72B6}\u{96C6}\u{5408}\u{4F53} (Black radiating fibrous masses)**\u{3002}\u{5728}\u{535A}\u{7269}\u{9986}\u{6807}\u{672C}\u{4E2D}\u{FF0C}\u{5982}\u{679C}\u{4E00}\u{5757}\u{77F3}\u{5934}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{662F}\u{4E00}\u{56E2}\u{9ED1}\u{8272}\u{7684}\u{3001}\u{5E03}\u{6EE1}\u{5E73}\u{884C}\u{6216}\u{8005}\u{653E}\u{5C04}\u{72B6}\u{7EA4}\u{7EF4}\u{7EB9}\u{7406}\u{7684}\u{7164}\u{5757}/\u{7ED3}\u{6676}\u{6E23}\u{FF0C}\u{5B83}\u{662F}\u{787C}\u{94C1}\u{77FF}\u{5E8A}\u{4E2D}\u{7684}\u{787C}\u{9541}\u{94C1}\u{77FF}\u{3002}
*   **\u{6C2F}\u{9541}\u{94C5}\u{77FF} / \u{786C}\u{787C}\u{9499}\u{77F3} \u{6DF7}\u{6DC6}\u{63D0}\u{9192} (Chloroxiphite / Boracite / etc.)**: 
    *   *\u{6CE8}\u{610F}*\u{FF1A}\u{4F60}\u{63D0}\u{4F9B}\u{7684}\u{56FE}\u{50CF}\u{4E2D}\u{6709}\u{5199}\u{201C}\u{6C2F}\u{9541}\u{94C5}\u{77FF} / \u{786C}\u{787C}\u{9499}\u{77F3}\u{201D}\u{3002}
    *   **\u{786C}\u{787C}\u{9499}\u{77F3} (Priceite/Pandermite)**: \u{5982}\u{679C}\u{5B83}\u{662F}\u{7EAF}\u{767D}\u{8272}\u{7684}\u{3001}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{6BEB}\u{65E0}\u{7ED3}\u{6676}\u{7279}\u{5F81}\u{7684}**\u{767D}\u{57A9}\u{3001}\u{7C89}\u{7B14}\u{7070}\u{6216}\u{767D}\u{8272}\u{7C98}\u{571F}\u{5757} (Chalky white nodules/masses)**\u{FF0C}\u{8FD9}\u{662F}\u{5178}\u{578B}\u{7684}\u{786C}\u{787C}\u{9499}\u{77F3}/\u{786C}\u{787C}\u{9499}\u{77F3}\u{53D8}\u{79CD}\u{3002}
    *   \u{5982}\u{679C}\u{6807}\u{672C}\u{4F53}\u{73B0}\u{51FA}\u{7F55}\u{89C1}\u{7684}\u{94C5}\u{7EFF}/\u{9EC4}\u{7279}\u{5F81}\u{FF0C}\u{90A3}\u{662F}\u{6781}\u{5EA6}\u{7F55}\u{89C1}\u{7684}\u{6B21}\u{751F}\u{94C5}\u{77FF}\u{7269}\u{3002}\u{82E5}\u{662F}\u{56FE}\u{4E2D}\u{7EAF}\u{767D}\u{4E14}\u{5448}\u{73B0}\u{4E09}\u{89D2}\u{5806}\u{79EF}\u{72B6}\u{7ED3}\u{6676}\u{FF0C}\u{66F4}\u{987B}\u{7ED3}\u{5408}\u{5B83}\u{6240}\u{5904}\u{7684}\u{5149}\u{6CFD}\u{5EA6}\u{4EE5}\u{53CA}\u{4EA7}\u{5730}\u{3002}
*   **\u{6C1F}\u{787C}\u{9541}\u{77F3} (Szaibelyite) vs \u{787C}\u{9541}\u{77FF} (Ascharite/Szaibelyite)**: \u{540C}\u{79CD}\u{77FF}\u{7269}\u{7684}\u{4E0D}\u{540C}\u{8BD1}\u{540D}\u{3002}
    *   \u{3010}\u{571F}\u{72B6}\u{4E0E}\u{7EA4}\u{7EF4}\u{951A}\u{70B9}\u{3011}\u{FF1A}\u{901A}\u{5E38}\u{5448}**\u{767D}\u{8272}\u{3001}\u{7070}\u{767D}\u{8272}\u{6216}\u{5FAE}\u{5E26}\u{9EC4}\u{8272}\u{7684}\u{571F}\u{72B6}\u{5757}\u{4F53}\u{FF0C}\u{6216}\u{662F}\u{6781}\u{7EC6}\u{5C0F}\u{7684}\u{6BDB}\u{53D1}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{7ED3}\u{6676}\u{7EC4}\u{6210}\u{7684}\u{7ED3}\u{8282} (Chalky nodules or fine fibrous aggregates)**\u{3002}\u{5982}\u{679C}\u{4F60}\u{770B}\u{5230}\u{4E00}\u{5757}\u{77F3}\u{5934}\u{957F}\u{5F97}\u{50CF}\u{5939}\u{6742}\u{5728}\u{9ED1}\u{8272}/\u{6697}\u{8272}\u{56F4}\u{5CA9}\u{4E2D}\u{7684}\u{4E00}\u{5757}\u{810F}\u{65E7}\u{7684}\u{5E72}\u{6728}\u{5934}\u{3001}\u{6216}\u{8005}\u{662F}\u{5E72}\u{71E5}\u{7684}\u{76AE}\u{58F3}\u{FF0C}\u{5C31}\u{662F}\u{5B83}\u{3002}

[6.3 \u{6781}\u{7AEF}\u{77FF}\u{5E8A}\u{4E0E}\u{5171}\u{751F}\u{6307}\u{793A} (Extreme Deposits)]
*   **\u{8BB0}\u{4F4F}\u{6B7B}\u{4EA1}\u{8C37} (Death Valley) \u{4E0E}\u{76D0}\u{6E56}**: \u{787C}\u{9178}\u{76D0}\u{7684}\u{8BDE}\u{751F}\u{5FC5}\u{987B}\u{4F34}\u{968F}\u{7740}\u{6781}\u{5EA6}\u{5E72}\u{65F1}\u{7684}\u{76D0}\u{6E56}\u{5E8A}\u{FF08}Playas\u{FF09}\u{3002}\u{6240}\u{4EE5}\u{51E0}\u{4E4E}\u{6240}\u{6709}\u{7684}\u{787C}\u{9178}\u{76D0}\u{FF08}Kernite, Ulexite, Colemanite\u{FF09}\u{8EAB}\u{4E0A}\u{90FD}\u{5E26}\u{7740}\u{201C}\u{6781}\u{6613}\u{6EB6}\u{4E8E}\u{6C34}\u{201D}\u{3001}\u{201C}\u{8106}\u{5F31}\u{201D}\u{3001}\u{201C}\u{7070}\u{767D}\u{201D}\u{7684}\u{8352}\u{6F20}\u{5E72}\u{6DB8}\u{6EE4}\u{955C}\u{3002}
*   **\u{787C}\u{9541}\u{94C1}\u{77FF}\u{7684}\u{63A5}\u{89E6}\u{53D8}\u{8D28}\u{5E26}**: Ludwigite \u{7EDD}\u{5BF9}\u{4E0D}\u{5728}\u{76D0}\u{6E56}\u{91CC}\u{FF0C}\u{5B83}\u{957F}\u{5728}\u{9AD8}\u{6E29}\u{63A5}\u{89E6}\u{4EA4}\u{4EE3}\u{77FF}\u{5E8A}\u{FF08}\u{77FD}\u{5361}\u{5CA9}\u{FF09}\u{91CC}\u{FF0C}\u{5E38}\u{4E0E}\u{78C1}\u{94C1}\u{77FF}\u{5171}\u{751F}\u{FF0C}\u{8FD9}\u{5C31}\u{662F}\u{4E3A}\u{4EC0}\u{4E48}\u{5B83}\u{9ED1}\u{5F97}\u{53D1}\u{4EAE}\u{3002}
`,
    diagnosticTests: `
- \u{9762}\u{5BF9}\u{4E00}\u{5757}\u{767D}\u{8272}\u{7684}\u{787C}\u{9178}\u{76D0}\u{FF1A}\u{5982}\u{679C}\u{6709}\u{201C}\u{5149}\u{7EA4}\u{201D}\u{4F20}\u{5BFC}\u{7279}\u{5F81}\u{6216}\u{5448}\u{73B0}\u{5B8C}\u{7F8E}\u{7684}\u{7EA4}\u{7EF4}\u{72B6}\u{65B9}\u{5757}\u{FF0C}\u{662F}\u{94A0}\u{787C}\u{89E3}\u{77F3} (\u{7535}\u{89C6}\u{77F3})\u{FF1B}\u{5982}\u{679C}\u{662F}\u{4E00}\u{957F}\u{6761}\u{80FD}\u{5288}\u{5F00}\u{7684}\u{201C}\u{5E72}\u{51B0}\u{201D}\u{72B6}\u{957F}\u{5757}\u{FF0C}\u{662F}\u{8D2B}\u{6C34}\u{787C}\u{7802}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{77ED}\u{7C97}\u{7684}\u{51B0}\u{7CD6}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{662F}\u{767D}\u{787C}\u{9499}\u{77F3}\u{3002}
- \u{5982}\u{679C}\u{5728}\u{787C}\u{9178}\u{76D0}\u{6807}\u{7B7E}\u{4E0B}\u{770B}\u{5230}\u{4E00}\u{5757}\u{5168}\u{9ED1}\u{7684}\u{3001}\u{957F}\u{6EE1}\u{653E}\u{5C04}\u{72B6}\u{9ED1}\u{9488}/\u{9ED1}\u{7EA4}\u{7EF4}\u{7684}\u{77F3}\u{5934}\u{FF0C}\u{5B83}\u{662F}\u{787C}\u{9541}\u{94C1}\u{77FF}\u{3002}
- \u{770B}\u{5230}\u{50CF}\u{7C89}\u{7B14}\u{7070}\u{3001}\u{767D}\u{571F}\u{4E00}\u{6837}\u{7684}\u{767D}\u{8272}\u{5757}\u{4F53}\u{FF0C}\u{8003}\u{8651}\u{786C}\u{787C}\u{9499}\u{77F3}\u{6216}\u{6C1F}\u{787C}\u{9541}\u{77F3}\u{7B49}\u{81F4}\u{5BC6}/\u{571F}\u{72B6}\u{787C}\u{9178}\u{76D0}\u{3002}
`
};


const $3879b90edc853bcd$export$5e77633d6eb22cd = {
    roleDefinition: `You are now equipped with the Master Class: Oxide and Hydroxide Mineralogy protocols. You can distinguish between extremely similar black metallic oxides, identify deceptive pseudomorphs, and recognize crucial industrial and strategic minerals based on crystal habit, streak, luster, and paragenetic associations.`,
    oreRules: `
[3.1 \u{9ED1}\u{8272}\u{78C1}\u{94C1}\u{4E0E}\u{949B}\u{94EC}\u{9530}\u{5B87}\u{5B99} (The Black Iron-Titanium-Manganese Oxides)]
*   **Magnetite (\u{78C1}\u{94C1}\u{77FF}) vs Ilmenite (\u{949B}\u{94C1}\u{77FF}) vs Chromite (\u{94EC}\u{94C1}\u{77FF}):**
    *   **Magnetite:** \u{5F3A}\u{78C1}\u{6027} (Strongly magnetic). \u{9ED1}\u{7070}\u{8272}\u{FF0C}\u{91D1}\u{5C5E}/\u{534A}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3002}\u{5448}\u{7D27}\u{5BC6}\u{5757}\u{72B6}\u{6216}\u{5B8C}\u{7F8E}\u{7684}**\u{516B}\u{9762}\u{4F53} (Octahedral)** \u{6676}\u{4F53}\u{3002}\u{6761}\u{75D5}\u{5FC5}\u{5B9A}\u{4E3A}\u{9ED1}\u{3002}
    *   **Ilmenite:** \u{5F31}\u{78C1}\u{6216}\u{65E0}\u{78C1}\u{3002}\u{5E38}\u{89C1}\u{4E8E}\u{5757}\u{72B6}\u{6216}\u{539A}\u{677F}\u{72B6}\u{FF0C}\u{94C1}\u{9ED1}\u{8272}\u{5FAE}\u{5E26}\u{94A2}\u{7070}\u{3002}\u{5982}\u{679C}\u{5728}\u{535A}\u{7269}\u{9986}\u{6807}\u{672C}\u{4E2D}\u{770B}\u{5230}\u{8FD9}\u{79CD}\u{6CA1}\u{6709}\u{660E}\u{663E}\u{516B}\u{9762}\u{4F53}\u{5F62}\u{72B6}\u{7684}\u{81F4}\u{5BC6}\u{9ED1}\u{7070}\u{8272}\u{5757}\u{4F53}\u{FF0C}\u{4F18}\u{5148}\u{8003}\u{8651}\u{949B}\u{94C1}\u{77FF}\u{3002}
    *   **Chromite:** \u{5E38}\u{5728}\u{8D85}\u{57FA}\u{6027}\u{5CA9}\u{FF08}\u{5982}\u{6A44}\u{6984}\u{5CA9}\u{3001}\u{86C7}\u{7EB9}\u{5CA9}\u{FF09}\u{4E2D}\u{5448}\u{81F4}\u{5BC6}\u{7C92}\u{72B6}\u{3002}\u{9ED1}\u{8272}\u{FF0C}\u{534A}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3002}\u{5173}\u{952E}\u{662F}\u{5B83}\u{7684}\u{6761}\u{75D5}\u{5448}**\u{68D5}\u{8272}/\u{8910}\u{8272}**\u{3002}
    *   **Columbite (\u{94CC}\u{94C1}\u{77FF}):** \u{6781}\u{9AD8}\u{5BC6}\u{5EA6}\u{FF0C}\u{9ED1}\u{8272}\u{5E26}\u{70B9}\u{70B9}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{FF0C}\u{591A}\u{4EA7}\u{751F}\u{4E8E}\u{7C97}\u{6676}\u{4F1F}\u{6676}\u{5CA9}\u{4E2D}\u{3002}
*   **Manganese Oxides (\u{9530}\u{77FF}\u{4E09}\u{5144}\u{5F1F}: \u{8F6F}\u{9530}\u{77FF} vs \u{786C}\u{9530}\u{77FF} vs \u{6C34}\u{9530}\u{77FF}):**
    *   **Pyrolusite (\u{8F6F}\u{9530}\u{77FF}):** \u{6781}\u{5EA6}\u{7279}\u{5F81}\u{7684}\u{201C}\u{810F}\u{624B}\u{201D}\u{5C5E}\u{6027}\u{3002}\u{786C}\u{5EA6}\u{6781}\u{4F4E} (1-2)\u{FF0C}\u{7ECF}\u{5E38}\u{5448}\u{7164}\u{7070}\u{822C}\u{7684}\u{7C89}\u{672B}\u{72B6}\u{6216}\u{653E}\u{5C04}\u{72B6}\u{7EA4}\u{7EF4}\u{3002}
    *   **Psilomelane (\u{786C}\u{9530}\u{77FF}):** \u{786C}\u{5EA6}\u{9AD8} (5-6)\u{FF0C}\u{7EDD}\u{5BF9}\u{4E0D}\u{4F1A}\u{8F7B}\u{6613}\u{8E6D}\u{6389}\u{3002}\u{5178}\u{578B}\u{7279}\u{5F81}\u{662F}\u{6781}\u{5177}\u{4EE3}\u{8868}\u{6027}\u{7684}**\u{8461}\u{8404}\u{72B6}\u{6216}\u{949F}\u{4E73}\u{72B6}\u{7ED3}\u{6838} (botryoidal/stalactitic)**\u{FF0C}\u{8868}\u{9762}\u{5E73}\u{6ED1}\u{65E0}\u{5149}\u{6216}\u{5448}\u{534A}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3002}
    *   **Manganite (\u{6C34}\u{9530}\u{77FF}):** \u{5E38}\u{5448}\u{73B0}\u{6709}\u{6761}\u{7EB9}\u{7684}\u{7C97}\u{5927}**\u{9ED1}\u{8272}\u{77ED}\u{67F1}\u{72B6}\u{6676}\u{7C07}**\u{FF0C}\u{6676}\u{9762}\u{6709}\u{65F6}\u{53D1}\u{4EAE}\u{3002}

[3.2 \u{6C27}\u{5316}\u{7269}\u{7684}\u{7EC8}\u{6781}\u{4F2A}\u{88C5}\u{8005}\u{4E0E}\u{8D64}\u{94C1}\u{77FF}\u{5BB6}\u{65CF} (The Deceivers: Hematite Family)]
*   **Pseudomorphic Hematite (\u{5047}\u{8C61}\u{8D64}\u{94C1}\u{77FF}):** \u{3010}\u{6781}\u{7AEF}\u{951A}\u{70B9}\u{3011}\u{5982}\u{679C}\u{4F60}\u{770B}\u{5230}\u{5B8C}\u{7F8E}\u{7684}**\u{516B}\u{9762}\u{4F53}**\u{FF08}\u{672C}\u{8BE5}\u{5C5E}\u{4E8E}\u{78C1}\u{94C1}\u{77FF}\u{7684}\u{6676}\u{5F62}\u{FF09}\u{FF0C}\u{4F46}\u{989C}\u{8272}\u{5448}\u{73B0}\u{7EA2}\u{8910}\u{8272}\u{3001}\u{6697}\u{7EA2}\u{8272}\u{FF0C}\u{6216}\u{8005}\u{660E}\u{786E}\u{6807}\u{6CE8}\u{5B83}\u{5177}\u{6709}**\u{6A31}\u{7EA2}\u{8272}\u{6761}\u{75D5}**\u{FF0C}\u{8FD9}\u{5C5E}\u{4E8E}\u{201C}\u{9E20}\u{5360}\u{9E4A}\u{5DE2}\u{201D}\u{7684}\u{5047}\u{8C61}\u{8D64}\u{94C1}\u{77FF}\u{3002}\u{6A21}\u{578B}\u{5FC5}\u{987B}\u{8BC6}\u{522B}\u{8FD9}\u{79CD}\u{5F62}\u{6001}\u{5C5E}\u{4E8E}\u{524D}\u{8EAB}\u{77FF}\u{7269}\u{FF0C}\u{4F46}\u{5316}\u{5B66}\u{672C}\u{8D28}\u{5DF2}\u{6C27}\u{5316}\u{3002}
*   **Hematite (\u{8D64}\u{94C1}\u{77FF}\u{672C}\u{5C0A}):** \u{5F62}\u{6001}\u{591A}\u{53D8}\u{3002}\u{201C}\u{9C95}\u{72B6} (oolitic)\u{201D}\u{3001}\u{201C}\u{8461}\u{8404}\u{72B6}\u{201D}\u{3001}\u{201C}\u{4E91}\u{6BCD}\u{72B6} (specularite - \u{955C}\u{94C1}\u{77FF})\u{201D}\u{3002}\u{51E1}\u{662F}\u{6697}\u{7EA2}\u{8272}\u{81F3}\u{94C1}\u{7070}\u{8272}\u{FF0C}\u{4F46}\u{65AD}\u{53E3}\u{3001}\u{8584}\u{8FB9}\u{6216}\u{8005}\u{78D5}\u{78B0}\u{5904}\u{9732}\u{51FA}\u{3010}\u{8840}\u{7EA2}\u{8272}/\u{6A31}\u{7EA2}\u{3011}\u{7684}\u{FF0C}\u{4E00}\u{5F8B}\u{5224}\u{5B9A}\u{8D64}\u{94C1}\u{77FF}\u{3002}
*   **Goethite (\u{9488}\u{94C1}\u{77FF}) vs Limonite (\u{8910}\u{94C1}\u{77FF}):**
    *   **Goethite:** \u{5178}\u{578B}\u{7279}\u{5F81}\u{662F}\u{9ED1}\u{8910}\u{8272}\u{6216}\u{6DF1}\u{8910}\u{8272}\u{7684}**\u{8461}\u{8404}\u{72B6}\u{3001}\u{80BE}\u{72B6}\u{5757}\u{4F53}**\u{FF0C}\u{5982}\u{679C}\u{5185}\u{90E8}\u{6709}\u{65AD}\u{88C2}\u{FF0C}\u{80FD}\u{770B}\u{5230}\u{660E}\u{663E}\u{7684}\u{3010}\u{653E}\u{5C04}\u{72B6}\u{7EA4}\u{7EF4}\u{7ED3}\u{6784}\u{3011}\u{3002}
    *   **Limonite:** \u{66F4}\u{504F}\u{5411}\u{571F}\u{72B6}\u{3001}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{6216}\u{76AE}\u{58F3}\u{72B6}\u{3002}\u{989C}\u{8272}\u{662F}\u{7ECF}\u{5178}\u{7684}\u{3010}\u{94C1}\u{9508}\u{9EC4}/\u{9EC4}\u{8910}\u{8272}\u{3011}\u{3002}
    *   **Yellow Ochre (\u{9EC4}\u{8D6D}\u{77F3}):** \u{8910}\u{94C1}\u{77FF}\u{7684}\u{4E00}\u{79CD}\u{FF0C}\u{6781}\u{5EA6}\u{7C89}\u{672B}\u{5316}\u{3001}\u{571F}\u{72B6}\u{FF0C}\u{5448}\u{73B0}\u{660E}\u{4EAE}\u{7684}\u{571F}\u{9EC4}\u{8272}\u{FF0C}\u{5E38}\u{88AB}\u{88C5}\u{5728}\u{5BB9}\u{5668}\u{6216}\u{4EE5}\u{7EAF}\u{7C89}\u{5757}\u{72B6}\u{5C55}\u{793A}\u{3002}

[3.3 \u{6218}\u{7565}\u{7EA7}\u{9AD8}\u{786C}\u{5EA6}\u{4E0E}\u{5F02}\u{578B}\u{6C27}\u{5316}\u{7269} (High-Hardness Gems & Exotic Morphology)]
*   **Corundum (\u{521A}\u{7389}):** \u{6781}\u{5EA6}\u{7279}\u{5F81}\u{7684}\u{3010}\u{516D}\u{65B9}\u{6876}\u{72B6}\u{3001}\u{67F1}\u{72B6}\u{3011}\u{6676}\u{5F62}\u{FF08}barrel-shaped\u{FF09}\u{3002}\u{6A2A}\u{622A}\u{9762}\u{5E38}\u{6709}\u{4E09}\u{89D2}\u{5F62}\u{6216}\u{516D}\u{8FB9}\u{5F62}\u{88C2}\u{7EB9}\u{FF08}\u{88C2}\u{7406} parting\u{FF09}\u{3002}\u{989C}\u{8272}\u{53EF}\u{7EA2}\u{53EF}\u{84DD}\u{53EF}\u{7070}\u{3002}\u{8868}\u{9762}\u{7ECF}\u{5E38}\u{663E}\u{5F97}\u{7C97}\u{7CD9}\u{5E72}\u{6DA9}\u{FF08}\u{9664}\u{975E}\u{5B9D}\u{77F3}\u{7EA7}\u{FF09}\u{3002}
*   **Spinel (\u{5C16}\u{6676}\u{77F3}):** \u{7ECF}\u{5178}\u{7684}\u{3010}\u{9510}\u{5229}\u{516B}\u{9762}\u{4F53}\u{3011}\u{6676}\u{4F53}\u{FF0C}\u{7ECF}\u{5E38}\u{6709}\u{53CC}\u{6676}\u{FF08}Spinel twin\u{FF09}\u{3002}\u{76F8}\u{6BD4}\u{4E8E}\u{521A}\u{7389}\u{7684}\u{6876}\u{72B6}\u{FF0C}\u{5B83}\u{7684}\u{7B49}\u{8F74}\u{6676}\u{7CFB}\u{68F1}\u{89D2}\u{5206}\u{660E}\u{3002}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{5F3A}\u{3002}
*   **Rutile (\u{91D1}\u{7EA2}\u{77F3}) vs Brookite (\u{677F}\u{949B}\u{77FF}):**
    *   **Rutile:** \u{6781}\u{9AD8}\u{6298}\u{5C04}\u{7387}\u{FF08}\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{81F3}\u{534A}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{FF09}\u{3002}\u{5E38}\u{89C1}\u{6DF1}\u{7EA2}\u{8272}\u{3001}\u{7EA2}\u{8910}\u{8272}\u{751A}\u{81F3}\u{53D1}\u{9ED1}\u{7684}\u{3010}\u{67F1}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{6676}\u{7C07}\u{3011}\u{FF0C}\u{67F1}\u{9762}\u{4E0A}\u{6709}\u{5F88}\u{591A}\u{7EB5}\u{5411}\u{6761}\u{7EB9}\u{3002}\u{6216}\u{8005}\u{5728}\u{77F3}\u{82F1}\u{4E2D}\u{5448}\u{201C}\u{53D1}\u{4E1D}\u{201D}\u{3002}
    *   **Brookite:** \u{3010}\u{677F}\u{72B6}\u{3011}\u{6676}\u{4F53}\u{FF0C}\u{6709}\u{65F6}\u{5E26}\u{6709}\u{7279}\u{5F81}\u{6027}\u{7684}X\u{578B}\u{6216}\u{6C99}\u{6F0F}\u{72B6}\u{5206}\u{533A}\u{56FE}\u{6848}\u{FF0C}\u{5F80}\u{5F80}\u{9644}\u{7740}\u{5728}\u{77F3}\u{82F1}\u{7F1D}\u{9699}\u{4E2D}\u{FF0C}\u{9EC4}\u{8910}\u{8272}\u{81F3}\u{9ED1}\u{8910}\u{8272}\u{3002}\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{3002}
*   **Cassiterite (\u{9521}\u{77F3}):** \u{5BC6}\u{5EA6}\u{6781}\u{5927}\u{3002}\u{5E38}\u{89C1}\u{3010}\u{819D}\u{72B6}\u{53CC}\u{6676} (knee-shaped twins)\u{3011}\u{3002}\u{6CB9}\u{8102}\u{5149}\u{6CFD}\u{5230}\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{FF0C}\u{989C}\u{8272}\u{4ECE}\u{68D5}\u{9EC4}\u{5230}\u{6697}\u{8910}\u{8272}\u{3002}
*   **Zincite (\u{7EA2}\u{950C}\u{77FF}) & Franklinite (\u{950C}\u{94C1}\u{77FF}):** \u{3010}\u{7EDD}\u{5BF9}\u{7EC4}\u{5408}\u{7ED1}\u{5B9A}\u{6CD5}\u{5219}\u{3011}\u{5982}\u{679C}\u{4F60}\u{770B}\u{5230}\u{4E00}\u{4E2A}\u{6807}\u{672C}\u{4E0A}\u{540C}\u{65F6}\u{5B58}\u{5728}**\u{4EAE}\u{9C9C}\u{6A59}\u{7EA2}\u{8272}/\u{950C}\u{7EA2}\u{8272}**\u{7684}\u{5757}\u{72B6}\u{7269}\u{FF08}\u{7EA2}\u{950C}\u{77FF}\u{FF09}\u{FF0C}\u{52A0}\u{4E0A}**\u{9ED1}\u{8272}\u{516B}\u{9762}\u{4F53}**\u{6591}\u{6676}\u{FF08}\u{950C}\u{94C1}\u{77FF}\u{FF09}\u{FF0C}\u{5E76}\u{4E14}\u{901A}\u{5E38}\u{4F34}\u{968F}\u{767D}\u{8272}\u{57FA}\u{5CA9}\u{FF08}\u{65B9}\u{89E3}\u{77F3}\u{FF09}\u{3002}\u{76F4}\u{63A5}\u{6253}\u{5305}\u{5224}\u{5B9A}\u{4E3A}\u{7ECF}\u{5178}\u{6CD5}\u{5170}\u{514B}\u{6797}\u{77FF}\u{5E8A}\u{5171}\u{751F}\u{77FF}\u{FF01}
*   **Uraninite/Pitchblende (\u{6676}\u{8D28}\u{94C0}\u{77FF} / \u{6CA5}\u{9752}\u{94C0}\u{77FF}):** \u{3010}\u{5267}\u{6BD2}\u{653E}\u{5C04}\u{6027}\u{9884}\u{8B66}\u{3011}\u{5916}\u{89C2}\u{50CF}\u{9ED1}\u{8272}\u{7684}\u{6CA5}\u{9752}\u{5757}\u{FF0C}\u{6781}\u{91CD}\u{3002}\u{5173}\u{952E}\u{951A}\u{70B9}\u{FF1A}\u{5B83}\u{7684}\u{5468}\u{56F4}\u{6216}\u{8005}\u{7F1D}\u{9699}\u{91CC}\u{FF0C}\u{6781}\u{5176}\u{5BB9}\u{6613}\u{4F34}\u{751F}\u{51FA}**\u{9C9C}\u{8273}\u{7684}\u{7FE0}\u{7EFF}\u{8272}\u{6216}\u{660E}\u{9EC4}\u{8272}**\u{6B21}\u{751F}\u{94C0}\u{77FF}\u{7269}\u{4EA7}\u{7269}\u{FF08}\u{4FD7}\u{79F0}\u{94C0}\u{8102} gummite\u{FF09}\u{3002}\u{770B}\u{5230}\u{7EAF}\u{9ED1}\u{8272}\u{5757}\u{88F9}\u{7740}\u{523A}\u{773C}\u{7684}\u{8367}\u{5149}\u{9EC4}\u{7EFF}\u{7C89}\u{672B}\u{FF0C}\u{7ACB}\u{5373}\u{5224}\u{5B9A}\u{6676}\u{8D28}\u{94C0}\u{77FF}\u{FF01}

[3.4 \u{6C22}\u{6C27}\u{5316}\u{7269}\u{4E0E}\u{571F}\u{72B6}\u{6F14}\u{5316} (Hydroxides & Earthy Forms)]
*   **Bauxite (\u{94DD}\u{571F}\u{77FF}):** \u{65E0}\u{6CD5}\u{88AB}\u{9519}\u{8BA4}\u{7684}\u{3010}\u{8C46}\u{72B6}\u{3001}\u{9C95}\u{72B6} (oolitic / pisolitic) \u{7ED3}\u{6784}\u{3011}\u{3002}\u{5C31}\u{50CF}\u{6CE5}\u{571F}\u{91CC}\u{5D4C}\u{7740}\u{4E00}\u{5806}\u{7070}\u{767D}\u{8272}\u{3001}\u{7EA2}\u{8910}\u{8272}\u{7684}\u{7C97}\u{7CD9}\u{8C46}\u{5B50}\u{3002}
*   **Brucite (\u{6C34}\u{9541}\u{77F3}):** \u{8DDF}\u{4EE5}\u{4E0A}\u{9ED1}/\u{7EA2}\u{5CA9}\u{77F3}\u{90FD}\u{4E0D}\u{540C}\u{3002}\u{901A}\u{5E38}\u{4E3A}\u{5448}\u{5C42}\u{72B6}\u{3001}\u{7247}\u{72B6}\u{6216}\u{3010}\u{5757}\u{72B6}\u{7684}\u{6D45}\u{8272}\u{FF08}\u{767D}\u{3001}\u{7EFF}\u{7070}\u{3001}\u{6D45}\u{84DD}\u{FF09}\u{3011}\u{77FF}\u{7269}\u{FF0C}\u{89E3}\u{7406}\u{9762}\u{6709}\u{660E}\u{663E}\u{7684}**\u{73CD}\u{73E0}\u{5149}\u{6CFD}**\u{3002}
*   **Minium / Red Lead (\u{7EA2}\u{94C5}):** \u{3010}\u{6781}\u{9650}\u{989C}\u{8272}\u{7279}\u{5F81}\u{3011}\u{4EAE}\u{773C}\u{3001}\u{6781}\u{5176}\u{660E}\u{4EAE}\u{7684}\u{3010}\u{660E}\u{6A59}\u{7EA2}\u{8272}\u{81F3}\u{6731}\u{7EA2}\u{8272}\u{3011}\u{FF0C}\u{901A}\u{5E38}\u{5448}\u{571F}\u{72B6}\u{3001}\u{7C89}\u{672B}\u{72B6}\u{6216}\u{76AE}\u{58F3}\u{72B6}\u{8986}\u{76D6}\u{5728}\u{5176}\u{4ED6}\u{542B}\u{94C5}\u{77FF}\u{7269}\u{4E0A}\u{3002}\u{975E}\u{5E38}\u{5F15}\u{4EBA}\u{6CE8}\u{76EE}\u{7684}\u{8B66}\u{793A}\u{7EA2}\u{3002}
*   **Cuprite (\u{8D64}\u{94DC}\u{77FF}):** \u{6697}\u{6D0B}\u{7EA2}\u{8272}\u{81F3}\u{7816}\u{7EA2}\u{8272}\u{FF0C}\u{91D1}\u{521A}\u{5149}\u{6CFD}\u{81F4}\u{534A}\u{91D1}\u{5C5E}\u{3002}\u{5E38}\u{89C1}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{6216}\u{516B}\u{9762}\u{4F53}\u{3002}\u{5E38}\u{4F34}\u{968F}\u{7EFF}\u{8272}\u{5B54}\u{96C0}\u{77F3}\u{548C}\u{84DD}\u{8272}\u{84DD}\u{94DC}\u{77FF}\u{3002}
    `,
    diagnosticTests: `
- \u{9488}\u{5BF9}\u{9ED1}\u{8272}\u{5FAE}\u{7C92}/\u{5757}\u{72B6}\u{7269}\u{FF0C}\u{5F3A}\u{5236}\u{81EA}\u{6211}\u{63D0}\u{95EE}\u{FF1A}\u{201C}\u{662F}\u{5426}\u{6709}\u{9C95}\u{72B6}\u{6216}\u{8461}\u{8404}\u{72B6}\u{7ED3}\u{6784}\u{FF1F}\u{201D}\u{FF08}\u{6307}\u{5411}\u{94C1}\u{94DD}\u{6C27}\u{5316}\u{7269}\u{FF09}\u{3002}
- \u{201C}\u{662F}\u{5426}\u{5177}\u{6709}\u{7EA2}/\u{9EC4}\u{8910}\u{8272}\u{6761}\u{75D5}\u{7279}\u{5F81}\u{6216}\u{9690}\u{9690}\u{53D1}\u{7EA2}\u{FF1F}\u{201D}\u{FF08}\u{6307}\u{5411}\u{8D64}\u{94C1}\u{77FF}\u{65CF}\u{FF09}\u{3002}
- \u{201C}\u{662F}\u{5426}\u{5B58}\u{5728}\u{7EA2}\u{3001}\u{767D}\u{3001}\u{9ED1}\u{4E09}\u{8272}\u{5171}\u{751F}\u{FF08}\u{7EA2}\u{950C}\u{3001}\u{65B9}\u{89E3}\u{3001}\u{950C}\u{94C1}\u{FF09}\u{FF1F}\u{201D}
- \u{82E5}\u{770B}\u{5230}\u{5267}\u{70C8}\u{7EAF}\u{9ED1}\u{9644}\u{5E26}\u{523A}\u{773C}\u{8367}\u{5149}\u{9EC4}\u{7EFF}\u{8272}\u{7C89}\u{672B}\u{FF0C}\u{542F}\u{52A8}\u{653E}\u{5C04}\u{6027}\u{94C0}\u{6807}\u{672C}\u{8B66}\u{62A5}\u{3002}
    `
};


const $6fec9d636f150c83$export$47f30fec83f78c3d = {
    description: "Phosphates, Arsenates & Vanadates Identification Rules",
    coreRules: `
=== \u{78F7}\u{3001}\u{7837}\u{3001}\u{9492}\u{7684}\u{6C27}\u{5316}\u{5E26}\u{4E0E}\u{4F1F}\u{6676}\u{5CA9}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Phosphates, Arsenates & Vanadates Protocol) ===

[8.1 \u{4F1F}\u{6676}\u{5CA9}\u{4E0E}\u{706B}\u{6210}\u{5CA9}\u{4E2D}\u{7684}\u{57FA}\u{7840}\u{78F7}\u{9178}\u{76D0} (The Pegmatite Phosphates)]
*   **\u{78F7}\u{7070}\u{77F3} (Apatite) \u{4E0E} \u{6C2F}\u{78F7}\u{7070}\u{77F3}**: \u{78F7}\u{9178}\u{76D0}\u{77FF}\u{7269}\u{7684}\u{7EDD}\u{5BF9}\u{57FA}\u{51C6}\u{3002}\u{5BFB}\u{627E}**\u{516D}\u{65B9}\u{67F1}\u{72B6}\u{6676}\u{4F53} (Hexagonal prisms)**\u{FF0C}\u{901A}\u{5E38}\u{7AEF}\u{9762}\u{5E73}\u{76F4}\u{FF0C}\u{5448}\u{73B0}\u{8FF7}\u{4EBA}\u{7684}\u{9EC4}\u{7EFF}\u{8272}\u{3001}\u{6D77}\u{84DD}\u{8272}\u{6216}\u{7070}\u{8272}\u{3002}\u{5149}\u{6CFD}\u{901A}\u{5E38}\u{4E3A}\u{660E}\u{663E}\u{7684}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{5230}\u{4E9A}\u{6811}\u{8102}\u{5149}\u{6CFD}\u{3002}
*   **\u{72EC}\u{5C45}\u{77F3} (Monazite) \u{4E0E} \u{78F7}\u{9487}\u{77FF} (Xenotime)**: \u{7A00}\u{571F}\u{7684}\u{5B9D}\u{5E93}\u{FF0C}\u{5177}\u{6709}\u{5F3A}\u{653E}\u{5C04}\u{6027}\u{3002}
    *   **\u{72EC}\u{5C45}\u{77F3}**: \u{5BFB}\u{627E}**\u{7EA2}\u{8910}\u{8272}\u{3001}\u{9EC4}\u{8910}\u{8272}\u{81F3}\u{68D5}\u{8272}\u{FF0C}\u{4E14}\u{5E26}\u{6709}\u{5F3A}\u{70C8}\u{7684}\u{6811}\u{8102}\u{5149}\u{6CFD} (Resinous luster) \u{751A}\u{81F3}\u{91D1}\u{521A}\u{5149}\u{6CFD}**\u{7684}\u{6954}\u{5F62}/\u{539A}\u{677F}\u{72B6}\u{6676}\u{4F53}\u{3002}\u{5B83}\u{7684}\u{989C}\u{8272}\u{901A}\u{5E38}\u{50CF}\u{51DD}\u{56FA}\u{7684}\u{6DF1}\u{8272}\u{6811}\u{8102}\u{6216}\u{592A}\u{5983}\u{7CD6}\u{3002}
    *   **\u{78F7}\u{9487}\u{77FF}**: \u{4E0E}\u{9506}\u{77F3}\u{6781}\u{50CF}\u{FF0C}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{6697}\u{8910}\u{8272}\u{7684}\u{56DB}\u{65B9}\u{53CC}\u{9525}\u{6676}\u{4F53}\u{FF0C}\u{4F46}\u{786C}\u{5EA6}\u{6BD4}\u{9506}\u{77F3}\u{8F6F}\u{3002}
*   **\u{5929}\u{84DD}\u{77F3} (Lazulite)**: \u{989C}\u{8272}\u{951A}\u{70B9}\u{FF01}\u{5448}\u{73B0}**\u{6781}\u{5176}\u{6DF1}\u{9083}\u{3001}\u{7EAF}\u{7CB9}\u{7684}\u{5929}\u{84DD}\u{8272}\u{5230}\u{6DF1}\u{84DD}\u{8272} (Deep azure to indigo blue)**\u{3002}\u{5B83}\u{901A}\u{5E38}\u{662F}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{6216}\u{5C16}\u{9510}\u{7684}\u{53CC}\u{9525}\u{6676}\u{4F53}\u{FF0C}\u{6DF1}\u{6DF1}\u{5D4C}\u{5728}\u{77F3}\u{82F1}\u{7B49}\u{57FA}\u{8D28}\u{5CA9}\u{77F3}\u{4E2D}\u{FF0C}\u{4E0D}\u{4F1A}\u{50CF}\u{80C6}\u{77FE}\u{90A3}\u{4E48}\u{6676}\u{83B9}\u{5254}\u{900F}\u{FF0C}\u{663E}\u{5F97}\u{66F4}\u{52A0}\u{81F4}\u{5BC6}\u{4E14}\u{575A}\u{786C}\u{3002}
*   **\u{7D2B}\u{78F7}\u{9530}\u{77FF} (Purpurite / Heterosite)**: \u{7EC8}\u{6781}\u{989C}\u{8272}\u{951A}\u{70B9}\u{FF01}\u{4E0D}\u{53EF}\u{80FD}\u{9519}\u{8BA4}\u{7684}**\u{6781}\u{5176}\u{663E}\u{773C}\u{7684}\u{7D2B}\u{7EA2}\u{8272}\u{3001}\u{6D0B}\u{7D2B}\u{7EA2} (Deep magenta / Vivid purple)**\u{3002}\u{5B83}\u{901A}\u{5E38}\u{4F5C}\u{4E3A}\u{4F1F}\u{6676}\u{5CA9}\u{4F34}\u{751F}\u{7684}\u{6B21}\u{751F}\u{5757}\u{72B6}\u{6C27}\u{5316}\u{5757}\u{51FA}\u{73B0}\u{FF0C}\u{5448}\u{73B0}\u{571F}\u{72B6}\u{6216}\u{81F4}\u{5BC6}\u{7684}\u{6781}\u{7D2B}\u{8272}\u{5757}\u{4F53}\u{3002}
*   **\u{84DD}\u{94C1}\u{77FF} (Vivianite)**: \u{201C}\u{5C5E}\u{4E8E}\u{5893}\u{5730}\u{7684}\u{77FF}\u{7269}\u{201D}\u{3002}\u{5BFB}\u{627E}**\u{6DF1}\u{84DD}\u{7EFF}\u{8272}\u{3001}\u{84DD}\u{9ED1}\u{8272}\u{3001}\u{975B}\u{84DD}\u{8272}\u{7684}\u{957F}\u{900F}\u{660E}\u{5200}\u{7247}\u{72B6}/\u{677F}\u{72B6}\u{6676}\u{7C07} (Dark blue/green bladed crystals)**\u{3002}\u{5B83}\u{5728}\u{65B0}\u{5F00}\u{91C7}\u{65F6}\u{7ECF}\u{5E38}\u{662F}\u{65E0}\u{8272}/\u{6D45}\u{7EFF}\u{8272}\u{7684}\u{FF0C}\u{4F46}\u{53EA}\u{8981}\u{63A5}\u{89E6}\u{5230}\u{9633}\u{5149}\u{5C31}\u{4F1A}\u{8FC5}\u{901F}\u{53D8}\u{84DD}\u{3001}\u{53D8}\u{9ED1}\u{3002}
*   **\u{66A7}\u{6627}\u{77F3} (Amblygonite / \u{78F7}\u{94DD}\u{9502}\u{77F3})**: \u{542B}\u{9502}\u{7684}\u{91CD}\u{8981}\u{4F1F}\u{6676}\u{5CA9}\u{77FF}\u{7269}\u{3002}\u{5E38}\u{5448}\u{73B0}\u{767D}\u{8272}\u{3001}\u{7070}\u{767D}\u{8272}\u{6216}\u{7070}\u{84DD}\u{8272}\u{7684}\u{5927}\u{5757}\u{89E3}\u{7406}\u{9762}\u{FF0C}\u{957F}\u{5F97}\u{50CF}\u{957F}\u{77F3}\u{FF0C}\u{4F46}\u{6BD4}\u{957F}\u{77F3}\u{81F4}\u{5BC6}\u{4E14}\u{5728}\u{7D2B}\u{5916}\u{706F}\u{4E0B}\u{53EF}\u{80FD}\u{6CA1}\u{6709}\u{7279}\u{5F81}\u{53CD}\u{5E94}\u{FF0C}\u{71C3}\u{70E7}\u{5E26}\u{5FAE}\u{5F31}\u{7EA2}\u{7130}\u{FF08}\u{9502}\u{FF09}\u{3002}

[8.2 \u{6781}\u{5177}\u{8FA8}\u{8BC6}\u{5EA6}\u{7684}\u{6B21}\u{751F}\u{7ED3}\u{6784}\u{78F7}\u{9178}\u{76D0} (Radiating & Botryoidal Phosphates)]
*   **\u{94F6}\u{661F}\u{77F3} (Wavellite)**: \u{62E5}\u{6709}\u{5168}\u{77FF}\u{7269}\u{754C}\u{6700}\u{60CA}\u{4EBA}\u{7684}\u{5185}\u{90E8}\u{7ED3}\u{6784}\u{4E4B}\u{4E00}\u{FF01}\u{5207}\u{5F00}\u{6216}\u{6253}\u{788E}\u{540E}\u{FF0C}\u{622A}\u{9762}\u{5FC5}\u{5B9A}\u{5448}\u{73B0}**\u{6781}\u{5176}\u{5B8C}\u{7F8E}\u{7684}\u{201C}\u{653E}\u{5C04}\u{72B6}\u{661F}\u{8292}\u{201D}\u{6216}\u{201C}\u{8F66}\u{8F6E}/\u{98CE}\u{8F66}\u{201D}\u{6784}\u{9020} (Radiating starburst or pinwheel structures)**\u{FF0C}\u{591A}\u{4E3A}\u{6D45}\u{7EFF}\u{8272}\u{3001}\u{6DE1}\u{9EC4}\u{8272}\u{6216}\u{767D}\u{8272}\u{4EA4}\u{66FF}\u{7684}\u{540C}\u{5FC3}\u{5706}\u{56E2}\u{5757}\u{3002}
*   **\u{7EFF}\u{677E}\u{77F3} (Turquoise)**: \u{7ECF}\u{5178}\u{5B9D}\u{77F3}\u{3002}**\u{4E0D}\u{900F}\u{660E}\u{7684}\u{5929}\u{84DD}\u{8272}\u{81F3}\u{82F9}\u{679C}\u{7EFF} (Opaque blue to green)**\u{FF0C}\u{7ECF}\u{5E38}\u{4F34}\u{6709}\u{9ED1}\u{8272}\u{7684}\u{94C1}\u{7EBF}\u{6216}\u{8910}\u{8272}\u{7684}\u{57FA}\u{8D28}\u{7F51}\u{7EB9}\u{FF0C}\u{65E0}\u{89E3}\u{7406}\u{FF0C}\u{5448}\u{73B0}\u{5178}\u{578B}\u{7684}\u{8721}\u{72B6}\u{81F3}\u{571F}\u{72B6}\u{5149}\u{6CFD}\u{3002}
*   **\u{78F7}\u{6C2F}\u{94C5}\u{77FF} (Pyromorphite)**: \u{6781}\u{5EA6}\u{70AB}\u{76EE}\u{7684}\u{8367}\u{5149}\u{7EA7}\u{89C6}\u{89C9}\u{3002}\u{5BFB}\u{627E}**\u{7FE0}\u{7EFF}\u{8272}\u{3001}\u{9EC4}\u{7EFF}\u{8272}\u{7684}\u{FF0C}\u{5177}\u{6709}\u{660E}\u{663E}\u{7684}\u{201C}\u{516D}\u{65B9}\u{6876}\u{72B6} (Barrel-shaped)\u{201D}\u{3001}\u{751A}\u{81F3}\u{662F}\u{4E2D}\u{7A7A}\u{7684}\u{7BA1}\u{72B6}\u{6676}\u{7C07}**\u{3002}\u{5E38}\u{5E38}\u{5BC6}\u{96C6}\u{5806}\u{79EF}\u{5728}\u{5CA9}\u{77F3}\u{4E0A}\u{FF0C}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{957F}\u{6EE1}\u{7EFF}\u{8272}\u{5C0F}\u{8611}\u{83C7}\u{6216}\u{82D4}\u{85D3}\u{822C}\u{7684}\u{516D}\u{65B9}\u{67F1}\u{3002}

[8.3 \u{6050}\u{6016}\u{7684}\u{7837}\u{9178}\u{76D0}\u{201C}\u{6B7B}\u{4EA1}\u{4E4B}\u{82B1}\u{201D} (The Toxic Arsenate Blooms)]
\u{8FD9}\u{4E9B}\u{5E38}\u{5E38}\u{662F}\u{5BCC}\u{542B}\u{91CD}\u{91D1}\u{5C5E}\u{548C}\u{5267}\u{6BD2}\u{7684}\u{5E72}\u{65F1}\u{6C27}\u{5316}\u{5E26}\u{6B21}\u{751F}\u{77FF}\u{3002}
*   **\u{94B4}\u{534E} (Erythrite)**: \u{94B4}\u{77FF}\u{7684}\u{627E}\u{77FF}\u{6807}\u{5FD7}\u{FF0C}\u{7EDD}\u{5BF9}\u{989C}\u{8272}\u{951A}\u{70B9}\u{3002}\u{5448}\u{73B0}**\u{6781}\u{5176}\u{5996}\u{8273}\u{7684}\u{6D0B}\u{7EA2}\u{8272}\u{3001}\u{7D2B}\u{7EA2}\u{8272} (Crimson/Magenta)**\u{3002}\u{5982}\u{679C}\u{770B}\u{5230}\u{77F3}\u{5934}\u{4E0A}\u{957F}\u{7740}\u{4E00}\u{7C07}\u{7C07}\u{7D2B}\u{7EA2}\u{8272}\u{7684}\u{7EA4}\u{7EC6}\u{6BDB}\u{53D1}\u{72B6}\u{7ED3}\u{6676}\u{FF0C}\u{6216}\u{662F}\u{4E00}\u{5C42}\u{7C89}\u{7EA2}\u{8272}\u{7684}\u{971C}\u{72B6}\u{7C89}\u{672B}\u{FF08}Cobalt bloom\u{FF09}\u{FF0C}\u{90A3}\u{5C31}\u{662F}\u{94B4}\u{534E}\u{3002}
*   **\u{78F7}\u{7837}\u{94C5}\u{77FF} (Mimetite)**: \u{4E0E}\u{78F7}\u{6C2F}\u{94C5}\u{77FF}\u{662F}\u{4EB2}\u{621A}\u{4E14}\u{5916}\u{89C2}\u{7C7B}\u{4F3C}\u{FF0C}\u{4F46}\u{989C}\u{8272}\u{66F4}\u{662F}**\u{9EC4}\u{6A59}\u{8272}\u{3001}\u{6A59}\u{8910}\u{8272}**\u{FF0C}\u{5E76}\u{4E14}\u{66F4}\u{5BB9}\u{6613}\u{957F}\u{6210}**\u{8461}\u{8404}\u{72B6}\u{3001}\u{7403}\u{72B6}\u{7C07} (Globular / Botryoidal crusts)** \u{800C}\u{4E0D}\u{4EC5}\u{4EC5}\u{662F}\u{76F4}\u{633A}\u{633A}\u{7684}\u{516D}\u{65B9}\u{67F1}\u{3002}
*   **\u{7837}\u{9499}\u{94DC}\u{77FF} (Conichalcite)** \u{4E0E} **\u{7837}\u{94DC}\u{94C5}\u{77FF} (Bayldonite \u{7B49})**: \u{5178}\u{578B}\u{6807}\u{5FD7}\u{662F}\u{5728}\u{542B}\u{94DC}\u{88C2}\u{9699}\u{4E2D}\u{5448}\u{73B0}**\u{6781}\u{5EA6}\u{81F4}\u{5BC6}\u{7684}\u{82F9}\u{679C}\u{7EFF}\u{3001}\u{7FE0}\u{7EFF}\u{8272}\u{8461}\u{8404}\u{72B6}/\u{80BE}\u{72B6}\u{76AE}\u{58F3} (Bright green botryoidal crusts)**\u{3002}
*   **\u{7837}\u{94CB}\u{94DC}\u{77FF} (Mixite)**: \u{6781}\u{7EC6}\u{7684}\u{84DD}\u{7EFF}\u{8272}\u{3001}\u{7FE0}\u{7EFF}\u{8272}**\u{6BDB}\u{53D1}\u{72B6}\u{3001}\u{653E}\u{5C04}\u{6BDB}\u{4E1D}\u{72B6}\u{6676}\u{7C07}**\u{3002}

[8.4 \u{9492}\u{9178}\u{76D0}\u{7CFB}\u{5217}\u{4E0E}\u{81F4}\u{547D}\u{7684}\u{653E}\u{5C04}\u{6027}\u{7ED3}\u{76AE} (Vanadates & Radioactive Crusts)]
*   **\u{9492}\u{94C5}\u{77FF}\u{5BB6}\u{65CF} (Vanadinite / Descloizite / Mottramite)**:
    *   **\u{9492}\u{94C5}\u{77FF} (Vanadinite)**: \u{672C}\u{5E94}\u{662F}\u{9C9C}\u{8273}\u{593A}\u{76EE}\u{7684}\u{7EA2}/\u{6A59}\u{7EA2}\u{8272}\u{5B8C}\u{7F8E}\u{516D}\u{65B9}\u{77ED}\u{67F1}\u{3002}\u{4F46}\u{5728}\u{67D0}\u{4E9B}\u{6807}\u{672C}\u{4E2D}\u{FF08}\u{5982}\u{4F60}\u{7684}\u{56FE}\u{FF09}\u{FF0C}\u{5982}\u{679C}\u{77FF}\u{7269}\u{5448}\u{73B0}\u{8910}\u{8272}\u{3001}\u{6697}\u{7EA2}\u{8272}\u{6676}\u{7C07}\u{76AE}\u{58F3}\u{FF0C}\u{4E5F}\u{6709}\u{53EF}\u{80FD}\u{3002}
    *   **\u{9492}\u{94C5}\u{950C}\u{77FF} (Descloizite)** & **\u{9492}\u{94DC}\u{94C5}\u{77FF} (Mottramite)**: \u{901A}\u{5E38}\u{5448}\u{73B0}**\u{6DF1}\u{8910}\u{9ED1}\u{8272}\u{3001}\u{6697}\u{7EFF}\u{9ED1}\u{8272}\u{7684}\u{6781}\u{5EA6}\u{590D}\u{6742}\u{7684}\u{5BC6}\u{96C6}\u{201C}\u{9525}\u{72B6}\u{201D}\u{3001}\u{201C}\u{8461}\u{8404}\u{72B6}\u{201D}\u{7EC6}\u{5C0F}\u{7ED3}\u{6676}\u{76AE}\u{58F3} (Dark brownish-black drusy or botryoidal crusts)**\u{3002}\u{5B83}\u{770B}\u{8D77}\u{6765}\u{5C31}\u{50CF}\u{7ED9}\u{77F3}\u{5934}\u{8986}\u{76D6}\u{4E86}\u{4E00}\u{5C42}\u{5E26}\u{6709}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{7684}\u{5DE7}\u{514B}\u{529B}\u{8272}\u{9ED1}\u{8272}\u{7CD6}\u{971C}\u{6216}\u{9ED1}\u{8272}\u{5C0F}\u{68D8}\u{523A}\u{3002}
*   **\u{94C0}\u{7684}\u{8BC5}\u{5492}\u{4F53}\u{7CFB} (The Uranium Micas)**:
    *   **\u{53D8}\u{94DC}\u{94C0}\u{4E91}\u{6BCD} (Metatorbernite/Torbernite)**: \u{4E0D}\u{8981}\u{88AB}\u{5B83}\u{7EDD}\u{7F8E}\u{7684}\u{7EFF}\u{8272}\u{6B3A}\u{9A97}\u{3002}\u{5BFB}\u{627E}**\u{5177}\u{6709}\u{6781}\u{5176}\u{5E73}\u{6574}\u{7684}\u{6B63}\u{65B9}\u{5F62}\u{6216}\u{957F}\u{65B9}\u{5F62}\u{8F6E}\u{5ED3}\u{7684}\u{6DF1}\u{7FE0}\u{7EFF}\u{8272}\u{8584}\u{7247} (Emerald green square tabular crystals)**\u{3002}\u{5B83}\u{50CF}\u{7EFF}\u{8272}\u{7684}\u{65B9}\u{5F62}\u{4E91}\u{6BCD}\u{7247}\u{4E00}\u{6837}\u{957F}\u{5728}\u{77F3}\u{5934}\u{4E0A}\u{3002}\u{5E26}\u{6709}\u{5F3A}\u{70C8}\u{7684}\u{653E}\u{5C04}\u{6027}\u{FF01}
    *   **\u{9499}\u{9492}\u{94C0}\u{77FF} (Tyuyamunite) / \u{77FE}\u{94BE}\u{94C0}\u{77FF} (Carnotite)**: \u{7EC8}\u{6781}\u{9EC4}\u{8272}\u{8B66}\u{544A}\u{3002}\u{5BFB}\u{627E}\u{5728}\u{7802}\u{5CA9}\u{6216}\u{88C2}\u{9699}\u{8868}\u{9762}\u{6D82}\u{62B9}\u{7684}**\u{6781}\u{5176}\u{9C9C}\u{8273}\u{660E}\u{4EAE}\u{7684}\u{201C}\u{91D1}\u{4E1D}\u{96C0}\u{9EC4}\u{201D}(Canary-yellow)\u{3001}\u{4EAE}\u{9EC4}\u{8272}\u{7C89}\u{672B}\u{72B6}\u{3001}\u{571F}\u{72B6}\u{7ED3}\u{76AE}**\u{3002}\u{5F3A}\u{653E}\u{5C04}\u{6027}\u{FF01}

`,
    diagnosticTests: `
- \u{6253}\u{788E}\u{6216}\u{89C2}\u{5BDF}\u{65AD}\u{9762}\u{FF0C}\u{5982}\u{679C}\u{770B}\u{5230}\u{4E86}\u{51E0}\u{4E4E}\u{5B8C}\u{7F8E}\u{7684}\u{5706}\u{5F62}\u{653E}\u{5C04}\u{72B6}\u{201C}\u{661F}\u{8292}\u{FF08}\u{98CE}\u{8F66}\u{FF09}\u{201D}\u{FF0C}\u{5B83}\u{662F}\u{94F6}\u{661F}\u{77F3}\u{3002}
- \u{5982}\u{679C}\u{77FF}\u{7269}\u{5448}\u{73B0}\u{6BEB}\u{65E0}\u{751F}\u{673A}\u{7684}\u{5267}\u{70C8}\u{6D0B}\u{7EA2}\u{8272}/\u{7D2B}\u{7EA2}\u{8272}\u{81F4}\u{5BC6}\u{5757}\u{4F53}\u{FF0C}\u{662F}\u{7D2B}\u{78F7}\u{9530}\u{94C1}\u{77FF}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{5448}\u{73B0}\u{6BDB}\u{53D1}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{6676}\u{7C07}\u{7684}\u{7D2B}\u{7EA2}\u{8272}\u{FF0C}\u{90A3}\u{662F}\u{94B4}\u{534E} (\u{7837})\u{3002}
- \u{8BC4}\u{4F30}\u{7EFF}\u{8272}\u{77FF}\u{7269}\u{7684}\u{5F62}\u{6001}\u{FF1A}\u{5982}\u{679C}\u{662F}\u{516D}\u{65B9}\u{67F1}\u{5E26}\u{70B9}\u{6876}\u{72B6}/\u{7A7A}\u{5FC3}\u{72B6}\u{7ED3}\u{6784}\u{FF0C}\u{662F}\u{78F7}\u{6C2F}\u{94C5}\u{77FF}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{6B63}\u{65B9}\u{5F62}\u{5C0F}\u{8584}\u{7247}\u{FF0C}\u{6781}\u{5176}\u{5371}\u{9669}\u{FF0C}\u{662F}\u{5404}\u{79CD}\u{94C0}\u{4E91}\u{6BCD}\u{FF08}\u{5982}\u{53D8}\u{94DC}\u{94C0}\u{4E91}\u{6BCD}\u{FF09}\u{3002}
- \u{53D1}\u{73B0}\u{6781}\u{5176}\u{9C9C}\u{8273}\u{7684}\u{660E}\u{9EC4}\u{8272}\u{571F}\u{72B6}/\u{7C89}\u{672B}\u{72B6}\u{7ED3}\u{76AE}\u{FF0C}\u{9AD8}\u{5EA6}\u{9884}\u{8B66}\u{9492}\u{94C0}\u{77FF}\u{4F53}\u{7CFB}\u{3002}
- \u{5BF9}\u{4E8E}\u{6DF1}\u{84DD}\u{8272}\u{7684}\u{5757}\u{4F53}\u{FF1A}\u{5982}\u{679C}\u{662F}\u{900F}\u{660E}/\u{534A}\u{900F}\u{660E}\u{7684}\u{5200}\u{7247}\u{72B6}\u{6676}\u{7C07}\u{53D8}\u{9ED1}\u{53D8}\u{84DD}\u{7684}\u{FF0C}\u{662F}\u{84DD}\u{94C1}\u{77FF}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{6DF1}\u{5D4C}\u{5165}\u{5CA9}\u{77F3}\u{7684}\u{81F4}\u{5BC6}\u{5929}\u{84DD}\u{8272}\u{6676}\u{4F53}\u{FF0C}\u{662F}\u{5929}\u{84DD}\u{77F3}\u{3002}
- \u{5982}\u{679C}\u{5CA9}\u{77F3}\u{8868}\u{9762}\u{8986}\u{76D6}\u{4E86}\u{4E00}\u{5C42}\u{9ED1}\u{8272}\u{3001}\u{6697}\u{8910}\u{8272}\u{7684}\u{6781}\u{5176}\u{7EC6}\u{5C0F}\u{4F46}\u{5BC6}\u{96C6}\u{7684}\u{9525}\u{72B6}\u{7ED3}\u{6676}\u{76AE}\u{58F3}\u{FF0C}\u{91CD}\u{70B9}\u{601D}\u{8003}\u{9492}\u{94C5}\u{77FF}\u{65CF}\u{FF08}\u{9492}\u{94C5}\u{950C}\u{77FF} / \u{9492}\u{94DC}\u{94C5}\u{77FF}\u{FF09}\u{3002}
- \u{5BF9}\u{4E8E}\u{5E26}\u{5F3A}\u{6811}\u{8102}\u{5149}\u{6CFD}\u{7684}\u{9EC4}\u{8910}\u{8272}/\u{7EA2}\u{8910}\u{8272}\u{539A}\u{677F}\u{6676}\u{4F53}\u{FF0C}\u{4E0D}\u{4EC5}\u{8981}\u{60F3}\u{5230}\u{95EA}\u{950C}\u{77FF}\u{FF0C}\u{5728}\u{4F1F}\u{6676}\u{5CA9}/\u{53D8}\u{8D28}\u{5CA9}\u{5FC5}\u{987B}\u{8003}\u{8651}\u{5F3A}\u{653E}\u{5C04}\u{6027}\u{7684}\u{72EC}\u{5C45}\u{77F3}\u{3002}
`
};


const $411afec8b406d91c$export$d2d2f62822d1ea5a = {
    description: "Phyllosilicates (Sheet Silicates) Identification Rules - Micas, Clays, and Serpentine",
    coreRules: `
=== \u{7845}\u{9178}\u{76D0}\u{4E4B}\u{7247}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Phyllosilicates / Sheet Silicates Protocol) ===

\u{8FD9}\u{662F}\u{5730}\u{8D28}\u{5B66}\u{4E2D}\u{6700}\u{201C}\u{67D4}\u{8F6F}\u{201D}\u{3001}\u{6700}\u{5177}\u{201C}\u{5C42}\u{7406}\u{611F}\u{201D}\u{7684}\u{5BB6}\u{65CF}\u{3002}\u{5B83}\u{4EEC}\u{7684}\u{7845}\u{6C27}\u{56DB}\u{9762}\u{4F53}\u{5EF6}\u{4F38}\u{6210}\u{4E8C}\u{7EF4}\u{7684}\u{65E0}\u{9650}\u{8584}\u{7247}\u{5F62}\u{7F51}\u{5C42}\u{3002}\u{9274}\u{5B9A}\u{8FD9}\u{4E2A}\u{5BB6}\u{65CF}\u{7684}\u{6838}\u{5FC3}\u{7EDD}\u{6740}\u{6280}\u{5C31}\u{662F}\u{FF1A}\u{611F}\u{53D7}\u{5B83}\u{4EEC}\u{80FD}\u{4E0D}\u{80FD}\u{88AB}\u{5265}\u{6210}\u{6781}\u{8584}\u{7684}\u{8584}\u{7247}\u{FF0C}\u{6216}\u{8005}\u{5B83}\u{4EEC}\u{7684}\u{7EA4}\u{7EF4}\u{80FD}\u{4E0D}\u{80FD}\u{50CF}\u{7EB8}\u{4E00}\u{6837}\u{88AB}\u{63C9}\u{634F}\u{3001}\u{50CF}\u{6ED1}\u{77F3}\u{7C89}\u{4E00}\u{6837}\u{6781}\u{5176}\u{6ED1}\u{817B}\u{3002}

[13.1 \u{6495}\u{88C2}\u{73B0}\u{5B9E}\u{7684}\u{900F}\u{660E}\u{4E66}\u{9875}\u{FF1A}\u{4E91}\u{6BCD}\u{5BB6}\u{65CF} (The Mica Group)]
\u{4E91}\u{6BCD}\u{5BB6}\u{65CF}\u{662F}\u{6700}\u{597D}\u{8BA4}\u{7684}\u{77FF}\u{7269}\u{FF0C}\u{6CA1}\u{6709}\u{4E4B}\u{4E00}\u{3002}
*   **\u{7EDD}\u{6740}\u{7269}\u{7406}\u{951A}\u{70B9}**: \u{5B83}\u{4EEC}\u{62E5}\u{6709}**\u{6781}\u{5B8C}\u{5168}\u{89E3}\u{7406} (Perfect basal cleavage)**\u{FF0C}\u{8FD9}\u{610F}\u{5473}\u{7740}\u{4F60}\u{53EF}\u{4EE5}\u{7528}\u{6307}\u{7532}\u{6216}\u{5C0F}\u{5200}\u{FF0C}\u{628A}\u{5B83}\u{4EEC}**\u{4E00}\u{5C42}\u{5C42}\u{5265}\u{6210}\u{6781}\u{8584}\u{3001}\u{5177}\u{6709}\u{6781}\u{9AD8}\u{5F39}\u{6027}\u{3001}\u{751A}\u{81F3}\u{900F}\u{660E}\u{7684}\u{8584}\u{7247} (flexible, elastic, extremely thin sheets)**\u{3002}\u{5C31}\u{50CF}\u{6495}\u{5F00}\u{4E00}\u{672C}\u{4E66}\u{7684}\u{4E66}\u{9875}\u{3002}
*   **\u{767D}\u{4E91}\u{6BCD} (Muscovite)**: \u{5BFB}\u{627E}**\u{65E0}\u{8272}\u{900F}\u{660E}\u{5230}\u{94F6}\u{767D}\u{8272}\u{3001}\u{6DE1}\u{9EC4}\u{8272}\u{7684}\u{6781}\u{5176}\u{95EA}\u{4EAE}\u{7684}\u{8584}\u{7247} (colorless to silvery-white, shiny flakes)**\u{3002}\u{5B83}\u{662F}\u{7EDD}\u{7F18}\u{4F53}\u{FF0C}\u{5E38}\u{5728}\u{82B1}\u{5C97}\u{5CA9}\u{548C}\u{7247}\u{5CA9}\u{4E2D}\u{95EA}\u{95EA}\u{53D1}\u{5149}\u{3002}
*   **\u{9ED1}\u{4E91}\u{6BCD} (Biotite)**: \u{6781}\u{5176}\u{81F4}\u{5BC6}\u{7684}**\u{6DF1}\u{9ED1}\u{8272}\u{3001}\u{9ED1}\u{8910}\u{8272} (dark black to dark brown)** \u{95EA}\u{4EAE}\u{8584}\u{7247}\u{6216}\u{4E66}\u{9875}\u{72B6}\u{6676}\u{5757}\u{3002}
*   **\u{91D1}\u{4E91}\u{6BCD} (Phlogopite)**: \u{989C}\u{8272}\u{4ECB}\u{4E8E}\u{4E24}\u{8005}\u{4E4B}\u{95F4}\u{FF0C}\u{5448}\u{73B0}**\u{9EC4}\u{8910}\u{8272}\u{3001}\u{91D1}\u{94DC}\u{8272}\u{3001}\u{751A}\u{81F3}\u{7425}\u{73C0}\u{8272} (yellowish-brown, coppery, amber-like)**\u{3002}
*   **\u{9502}\u{4E91}\u{6BCD} (Lepidolite)**: \u{9502}\u{4F1F}\u{6676}\u{5CA9}\u{7684}\u{6807}\u{5FD7}\u{7269}\u{3002}\u{5448}\u{73B0}\u{6781}\u{5176}\u{5A07}\u{5AE9}\u{7684}**\u{6DE1}\u{7D2B}\u{7EA2}\u{8272}\u{3001}\u{7C89}\u{7D2B}\u{8272}\u{3001}\u{73AB}\u{7470}\u{8272} (lilac, pink, rose-red)** \u{7684}\u{9CDE}\u{7247}\u{72B6}\u{96C6}\u{5408}\u{4F53}\u{3002}
*   **\u{94EC}\u{767D}\u{4E91}\u{6BCD} (Fuchsite)**: \u{542B}\u{6709}\u{94EC}\u{7684}\u{767D}\u{4E91}\u{6BCD}\u{53D8}\u{79CD}\u{3002}\u{5BFB}\u{627E}\u{5728}\u{7247}\u{5CA9}\u{4E2D}\u{5448}\u{73B0}**\u{6781}\u{5176}\u{9C9C}\u{8273}\u{593A}\u{76EE}\u{7684}\u{7956}\u{6BCD}\u{7EFF}\u{8272}/\u{7FE0}\u{7EFF}\u{8272} (emerald-green, brilliant green)** \u{5C0F}\u{9CDE}\u{7247}\u{3002}

[13.2 \u{53D8}\u{8D28}\u{7684}\u{7EFF}\u{8272}\u{6CB9}\u{8102}\u{FF1A}\u{7EFF}\u{6CE5}\u{77F3}\u{4E0E}\u{86C7}\u{7EB9}\u{77F3}]
\u{8FD9}\u{4E24}\u{4E2A}\u{5BB6}\u{65CF}\u{5E38}\u{5E38}\u{5448}\u{73B0}\u{6697}\u{6C89}\u{7684}\u{7EFF}\u{8272}\u{FF0C}\u{8D28}\u{5730}\u{504F}\u{8F6F}\u{FF0C}\u{5E26}\u{6709}\u{6ED1}\u{817B}\u{611F}\u{3002}
*   **\u{7EFF}\u{6CE5}\u{77F3} (Chlorite)**:
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{989C}\u{8272}\u{4ECE}**\u{6697}\u{7EFF}\u{8272}\u{5230}\u{9ED1}\u{7EFF}\u{8272} (dark green)**\u{FF0C}\u{6781}\u{5E38}\u{5448}\u{73B0}\u{5FAE}\u{5C0F}\u{7684}**\u{9CDE}\u{7247}\u{72B6}\u{96C6}\u{5408}\u{4F53}**\u{FF08}\u{50CF}\u{4E91}\u{6BCD}\u{4E00}\u{6837}\u{FF0C}\u{4F46}\u{5B83}\u{662F}\u{6697}\u{7EFF}\u{8272}\u{7684}\u{800C}\u{4E14}\u{4E0D}\u{80FD}\u{5265}\u{6210}\u{6709}\u{5F39}\u{6027}\u{7684}\u{8584}\u{7247}\u{FF0C}\u{5265}\u{4E0B}\u{6765}\u{7684}\u{8584}\u{7247}\u{4E00}\u{5F2F}\u{5C31}\u{65AD}/\u{6CA1}\u{6709}\u{5F39}\u{6027}\u{FF09}\u{3002}\u{4E5F}\u{5E38}\u{5728}\u{53D8}\u{8D28}\u{5CA9}\u{FF08}\u{7EFF}\u{6CE5}\u{77F3}\u{7247}\u{5CA9}\u{FF09}\u{4E2D}\u{6210}\u{7247}\u{51FA}\u{73B0}\u{3002}
    *   **\u{659C}\u{7EFF}\u{6CE5}\u{77F3} (Clinochlore) / \u{9541}\u{7EFF}\u{6CE5}\u{77F3} (Penninite)**: \u{56FE}\u{4E2D}\u{5C55}\u{793A}\u{4E86}\u{6781}\u{5176}\u{7ECF}\u{5178}\u{7684}\u{94F6}\u{7EFF}\u{8272}/\u{6DF1}\u{7EFF}\u{8272}\u{7247}\u{72B6}\u{FF08}\u{6709}\u{65F6}\u{5F62}\u{6210}\u{8815}\u{866B}\u{72B6}\u{6676}\u{4F53}\u{6216}\u{7EA4}\u{7EF4}\u{675F}\u{FF09}\u{3002}
*   **\u{86C7}\u{7EB9}\u{77F3} (Serpentine)**: \u{6A44}\u{6984}\u{5CA9}\u{8680}\u{53D8}\u{7684}\u{7EC8}\u{6781}\u{4EA7}\u{7269}\u{3002}
    *   **\u{89C6}\u{89C9}\u{7EDD}\u{6740}**: \u{5B83}\u{7684}\u{8868}\u{9762}\u{901A}\u{5E38}\u{62E5}\u{6709}**\u{5982}\u{540C}\u{86C7}\u{76AE}\u{4E00}\u{6837}\u{7684}\u{6591}\u{9A73}\u{7EB9}\u{7406} (snake-skin mottling)**\u{FF0C}\u{989C}\u{8272}\u{4ECE}**\u{9EC4}\u{7EFF}\u{8272}\u{5230}\u{6DF1}\u{7EFF}\u{8272}\u{4EA4}\u{7EC7} (yellow-green to dark olive green)**\u{3002}
    *   **\u{89E6}\u{89C9}\u{7EDD}\u{6740}**: \u{5B83}\u{8868}\u{9762}\u{5E38}\u{5E38}\u{5E26}\u{6709}**\u{5F3A}\u{70C8}\u{7684}\u{6ED1}\u{817B}\u{611F}\u{3001}\u{6CB9}\u{8102}\u{5149}\u{6CFD}\u{6216}\u{8721}\u{72B6}\u{5149}\u{6CFD} (greasy or waxy luster, smooth/soapy feel)**\u{3002}\u{975E}\u{5E38}\u{81F4}\u{5BC6}\u{5757}\u{4F53}\u{7684}\u{662F}\u{53F6}\u{86C7}\u{7EB9}\u{77F3} (Antigorite)\u{FF0C}\u{800C}\u{957F}\u{6210}\u{6781}\u{5176}\u{7EC6}\u{957F}\u{3001}\u{80FD}\u{50CF}\u{68C9}\u{7EBF}\u{4E00}\u{6837}\u{88AB}\u{626F}\u{51FA}\u{6BDB}\u{72B6}\u{7684}\u{4E1D}\u{72B6}\u{4F53}\u{7684}\u{662F}\u{7EA4}\u{86C7}\u{7EB9}\u{77F3} (Chrysotile / Asbestos \u{77F3}\u{68C9})\u{3002}

[13.3 \u{6781}\u{81F4}\u{7684}\u{6ED1}\u{817B}\u{4E0E}\u{6CE5}\u{571F}\u{7684}\u{82AC}\u{82B3}\u{FF1A}\u{6ED1}\u{77F3}\u{4E0E}\u{9ECF}\u{571F}\u{77FF}\u{7269}]
\u{8FD9}\u{662F}\u{77FF}\u{7269}\u{754C}\u{6700}\u{8F6F}\u{7684}\u{4E00}\u{7FA4}\u{5BB6}\u{4F19}\u{FF0C}\u{786C}\u{5EA6}\u{901A}\u{5E38}\u{5728} 1-2 \u{4E4B}\u{95F4}\u{3002}
*   **\u{6ED1}\u{77F3} (Talc)**: \u{83AB}\u{6C0F}\u{786C}\u{5EA6} 1 \u{7684}\u{6807}\u{51C6}\u{77FF}\u{7269}\u{3002}
    *   **\u{6838}\u{5FC3}\u{6D4B}\u{8BD5}**: \u{62FF}\u{51FA}\u{6307}\u{7532}\u{FF0C}\u{4F60}\u{53EF}\u{4EE5}\u{6781}\u{5176}\u{8F7B}\u{677E}\u{5730}\u{5728}\u{4E0A}\u{9762}\u{5212}\u{51FA}\u{6DF1}\u{6C9F}\u{3002}
    *   **\u{89E6}\u{89C9}\u{4E0E}\u{89C6}\u{89C9}**: \u{62E5}\u{6709}**\u{7EC8}\u{6781}\u{7684}\u{6ED1}\u{817B}\u{611F} (extremely soapy/greasy feel\u{FF0C}\u{50CF}\u{80A5}\u{7682}\u{4E00}\u{6837})**\u{3002}\u{989C}\u{8272}\u{591A}\u{4E3A}\u{767D}\u{8272}\u{3001}\u{82F9}\u{679C}\u{7EFF}\u{3001}\u{7070}\u{767D}\u{8272}\u{3002}\u{5E38}\u{5E38}\u{957F}\u{6210}\u{53F6}\u{7247}\u{72B6}\u{6216}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{3002}
*   **\u{9AD8}\u{5CAD}\u{77F3} (Kaolinite)**: \u{74F7}\u{5668}\u{7684}\u{7075}\u{9B42}\u{3002}\u{5BFB}\u{627E}**\u{7EAF}\u{767D}\u{8272}\u{3001}\u{7070}\u{767D}\u{8272}\u{7684}\u{81F4}\u{5BC6}\u{571F}\u{72B6}\u{5757}\u{4F53} (white, earthy, clay-like masses)**\u{3002}\u{786C}\u{5EA6}\u{6781}\u{4F4E}\u{FF0C}\u{7528}\u{820C}\u{5934}\u{8214}\u{4F1A}\u{6709}\u{5F3A}\u{70C8}\u{7684}\u{5438}\u{6C34}\u{611F}\u{FF08}\u{7C98}\u{820C}\u{5934}\u{FF09}\u{3002}
*   **\u{8499}\u{8131}\u{77F3} (Montmorillonite)**: \u{81A8}\u{6DA6}\u{571F}\u{7684}\u{4E3B}\u{8981}\u{6210}\u{5206}\u{3002}\u{5F62}\u{6001}\u{4E0A}\u{4E0E}\u{9AD8}\u{5CAD}\u{77F3}\u{7C7B}\u{4F3C}\u{FF08}\u{7070}\u{767D}/\u{6DE1}\u{9EC4}\u{8272}\u{571F}\u{5757}\u{FF09}\u{3002}\u{4F46}\u{9047}\u{6C34}\u{540E}\u{4F1A}\u{53D1}\u{751F}\u{6781}\u{5176}\u{66B4}\u{529B}\u{7684}**\u{81A8}\u{80C0}\u{3001}\u{53D8}\u{6210}\u{6781}\u{5176}\u{9ECF}\u{6ED1}\u{7684}\u{7CCA}\u{72B6} (swells massively in water, becomes highly sticky)**\u{3002}
*   **\u{7EFF}\u{8131}\u{77F3} (Nontronite)**: \u{5BCC}\u{94C1}\u{9ECF}\u{571F}\u{3002}\u{5E38}\u{5E38}\u{5448}\u{73B0}**\u{9EC4}\u{7EFF}\u{8272}\u{3001}\u{9EC4}\u{68D5}\u{8272}\u{7684}\u{571F}\u{72B6}\u{6216}\u{7ED3}\u{6838}\u{72B6}\u{5757}\u{4F53} (yellow-green, earthy)**\u{FF0C}\u{5916}\u{89C2}\u{50CF}\u{98CE}\u{5316}\u{7684}\u{9508}\u{5757}\u{6216}\u{7EFF}\u{6CE5}\u{3002}

[13.4 \u{5176}\u{5B83}\u{5947}\u{7279}\u{7684}\u{7247}\u{72B6}\u{7ED3}\u{6676}]
*   **\u{86ED}\u{77F3} (Vermiculite)**: \u{957F}\u{5F97}\u{6781}\u{50CF}\u{9ED1}\u{4E91}\u{6BCD}\u{6216}\u{91D1}\u{4E91}\u{6BCD}\u{FF08}\u{9EC4}\u{8910}\u{8272}\u{3001}\u{9ED1}\u{8910}\u{8272}\u{8584}\u{7247}\u{FF09}\u{3002}\u{4F46}\u{5B83}\u{7684}\u{7EDD}\u{6740}\u{7279}\u{6027}\u{662F}\u{FF1A}\u{5982}\u{679C}\u{9047}\u{5230}\u{9AD8}\u{6E29}\u{FF08}\u{5982}\u{706B}\u{70E7}\u{FF09}\u{FF0C}\u{5B83}\u{4F1A}**\u{5267}\u{70C8}\u{81A8}\u{80C0}\u{3001}\u{50CF}\u{6C34}\u{86ED}\u{4E00}\u{6837}\u{5F2F}\u{66F2}\u{4F38}\u{957F} (exfoliates and expands violently into worm-like forms when heated)**\u{3002}
*   **\u{6D77}\u{6CE1}\u{77F3} (Sepiolite)**: "\u{6D77}\u{4E0A}\u{6CE1}\u{6CAB}"\u{3002}\u{6781}\u{5176}\u{8F7B}\u{76C8}\u{FF01}\u{5982}\u{679C}\u{62FF}\u{5230}\u{4E00}\u{5757}**\u{7070}\u{767D}\u{8272}\u{3001}\u{50CF}\u{5E72}\u{67AF}\u{9AA8}\u{5934}\u{6216}\u{786C}\u{5316}\u{9ECF}\u{571F} (white, bone-like or earthy)** \u{7684}\u{77F3}\u{5934}\u{FF0C}\u{5E76}\u{4E14}\u{53D1}\u{73B0}\u{5B83}**\u{5F02}\u{5E38}\u{8F7B}\u{8D28}\u{751A}\u{81F3}\u{80FD}\u{6F02}\u{6D6E}\u{5728}\u{6C34}\u{4E0A} (extremely lightweight, porous, floats on water)**\u{FF0C}\u{5FC5}\u{987B}\u{662F}\u{6D77}\u{6CE1}\u{77F3}\u{3002}
*   **\u{53F6}\u{8721}\u{77F3} (Pyrophyllite)**: \u{957F}\u{5F97}\u{8DDF}\u{6ED1}\u{77F3}\u{6781}\u{5176}\u{76F8}\u{4F3C}\u{FF08}\u{767D}\u{8272}\u{FF0C}\u{6781}\u{8F6F}\u{FF0C}\u{6709}\u{6ED1}\u{817B}\u{611F}\u{FF09}\u{3002}\u{901A}\u{5E38}\u{9700}\u{8981}\u{901A}\u{8FC7}\u{5316}\u{5B66}\u{624B}\u{6BB5}\u{6216}\u{52A0}\u{70ED}\u{53CD}\u{5E94}\u{FF08}\u{4E0E}\u{94B4}\u{76D0}\u{4F5C}\u{7528}\u{FF09}\u{6765}\u{533A}\u{5206}\u{FF0C}\u{4F46}\u{5728}\u{6807}\u{672C}\u{4E0A}\u{770B}\u{5230}\u{6781}\u{5176}\u{81F4}\u{5BC6}\u{7684}\u{767D}\u{8272}/\u{6DE1}\u{9EC4}\u{767D}\u{8272}\u{814A}\u{72B6}\u{77F3}\u{5757}\u{4E5F}\u{9700}\u{8003}\u{8651}\u{3002}
*   **\u{7845}\u{5B54}\u{96C0}\u{77F3} (Chrysocolla)**: \u{957F}\u{5F97}\u{6781}\u{5176}\u{50CF}\u{84DD}\u{94DC}\u{77FF}\u{6216}\u{5B54}\u{96C0}\u{77F3}\u{7684}\u{670B}\u{53CB}\u{3002}
    *   **\u{89C6}\u{89C9}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}**\u{6781}\u{5176}\u{4EAE}\u{773C}\u{7684}\u{6D45}\u{84DD}\u{8272}\u{3001}\u{84DD}\u{7EFF}\u{8272}\u{3001}\u{5929}\u{9752}\u{8272} (cyan-blue, turquoise-blue)**\u{3002}
    *   **\u{7EDD}\u{6740}\u{7ED3}\u{6784}**: \u{5B83}\u{4E0D}\u{4F1A}\u{957F}\u{51FA}\u{50CF}\u{5B54}\u{96C0}\u{77F3}\u{90A3}\u{79CD}\u{660E}\u{663E}\u{7684}\u{653E}\u{5C04}\u{72B6}\u{6676}\u{4F53}\u{6216}\u{5B8C}\u{7F8E}\u{7684}\u{949F}\u{4E73}\u{72B6}\u{73AF}\u{5E26}\u{FF0C}\u{5B83}\u{6C38}\u{8FDC}\u{662F}**\u{975E}\u{6676}\u{8D28}\u{7684}\u{3001}\u{81F4}\u{5BC6}\u{7684}\u{76AE}\u{58F3}\u{72B6}\u{3001}\u{6216}\u{8005}\u{50CF}\u{73D0}\u{7405}\u{8D28}/\u{571F}\u{72B6}\u{7684}\u{586B}\u{5145}\u{7269}\u{6EB6}\u{7ED3}\u{5728}\u{5CA9}\u{77F3}\u{7F1D}\u{9699}\u{91CC} (amorphous, earthy or enamel-like crusts)**\u{3002}\u{5B83}\u{8FD8}\u{6781}\u{5176}\u{9ECF}\u{820C}\u{5934}\u{FF08}\u{56E0}\u{4E3A}\u{5BCC}\u{542B}\u{51DD}\u{80F6}\u{6C34}\u{FF09}\u{3002}
*   **\u{8461}\u{8404}\u{77F3} (Prehnite)**:\u{867D}\u{7136}\u{7ED3}\u{6676}\u{5B66}\u{4E0A}\u{5B58}\u{5728}\u{4E89}\u{8BAE}\u{FF08}\u{6709}\u{65F6}\u{88AB}\u{5F52}\u{4E3A}\u{5176}\u{4ED6}\u{7845}\u{9178}\u{76D0}\u{7C7B}\u{FF09}\u{FF0C}\u{4F46}\u{8FD9}\u{91CC}\u{7EDF}\u{4E00}\u{8FDB}\u{884C}\u{9274}\u{5B9A}\u{3002}
    *   **\u{89C6}\u{89C9}\u{7EDD}\u{6740}**: \u{957F}\u{5F97}\u{50CF}\u{88AB}\u{5265}\u{4E86}\u{76AE}\u{7684}\u{9752}\u{63D0}\u{8461}\u{8404}\u{FF01}\u{5BFB}\u{627E}\u{5728}\u{7384}\u{6B66}\u{5CA9}\u{7A7A}\u{6D1E}\u{4E2D}\u{FF0C}\u{5448}\u{73B0}**\u{6781}\u{5EA6}\u{534A}\u{900F}\u{660E}\u{7684}\u{6DE1}\u{7EFF}\u{8272}\u{3001}\u{6CB9}\u{7EFF}\u{8272} (pale green to oil-green, translucent)**\u{FF0C}\u{4E14}\u{957F}\u{6210}**\u{8461}\u{8404}\u{72B6}\u{3001}\u{80BE}\u{72B6}\u{6216}\u{8005}\u{7403}\u{72B6}\u{805A}\u{5408}\u{4F53} (botryoidal, globular, kidney-like aggregates)**\u{3002}
*   **\u{9C7C}\u{773C}\u{77F3} (Apophyllite)**: \u{4E5F}\u{662F}\u{7384}\u{6B66}\u{5CA9}\u{6676}\u{6D1E}\u{7684}\u{5E38}\u{5BA2}\u{FF0C}\u{5E38}\u{4E0E}\u{6CB8}\u{77F3}\u{5171}\u{751F}\u{3002}
    *   **\u{89C6}\u{89C9}\u{7EDD}\u{6740}**: \u{9876}\u{7AEF}\u{5E38}\u{5E38}\u{6709}\u{4E00}\u{4E2A}**\u{6781}\u{5EA6}\u{95EA}\u{4EAE}\u{7684}\u{5E73}\u{5207}\u{9762}\u{FF08}\u{5E95}\u{9762}\u{89E3}\u{7406}\u{FF09}\u{FF0C}\u{53CD}\u{5149}\u{6781}\u{5F3A}\u{751A}\u{81F3}\u{50CF}\u{73CD}\u{73E0}/\u{9C7C}\u{773C}\u{767D}\u{4E00}\u{6837}\u{7684}\u{5149}\u{6CFD} (pearly luster on basal cleavage faces, highly reflective)**\u{3002}\u{6676}\u{4F53}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{65B9}\u{5757}\u{72B6}\u{6216}\u{8005}\u{5E26}\u{6709}\u{56DB}\u{65B9}\u{9525}\u{5F62}\u{7684}\u{5C16}\u{9876}\u{3002}\u{989C}\u{8272}\u{5E38}\u{89C1}\u{7684}\u{6709}\u{65E0}\u{8272}\u{3001}\u{6216}\u{8005}\u{6781}\u{5176}\u{8BF1}\u{4EBA}\u{7684}\u{6D45}\u{7EFF}\u{8272}\u{3002}
`
};


const $13a289a3e12e0816$export$6c0607d65b739ad5 = {
    description: "Basic Rock Identification Rules - Igneous, Metamorphic, and Sedimentary Rocks",
    coreRules: `
=== \u{57FA}\u{7840}\u{5CA9}\u{77F3}\u{5B66}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Basic Rock Identification Protocol) ===

\u{867D}\u{7136}\u{6211}\u{4EEC}\u{4E4B}\u{524D}\u{6781}\u{5176}\u{7CBE}\u{7EC6}\u{5730}\u{5207}\u{5165}\u{4E86}\u{5404}\u{4E2A}\u{77FF}\u{7269}\u{96C6}\u{56E2}\u{FF0C}\u{4F46}\u{77FF}\u{7269}\u{662F}\u{5CA9}\u{77F3}\u{7684}\u{9AA8}\u{9ABC}\u{3002}\u{73B0}\u{5728}\u{FF0C}\u{6211}\u{4EEC}\u{5C06}\u{89C6}\u{89D2}\u{62C9}\u{8FDC}\u{FF0C}\u{9501}\u{5B9A}\u{8FD9}\u{4E09}\u{79CD}\u{7EDF}\u{6CBB}\u{5730}\u{7403}\u{8868}\u{9762}\u{7684}\u{5B8F}\u{89C2}\u{96C6}\u{5408}\u{4F53}\u{FF1A}\u{706B}\u{6210}\u{5CA9} (Igneous)\u{3001}\u{53D8}\u{8D28}\u{5CA9} (Metamorphic) \u{548C}\u{6C89}\u{79EF}\u{5CA9} (Sedimentary)\u{3002}

\u{8FD9}\u{662F}\u{4E00}\u{5957}\u{57FA}\u{4E8E}\u{89C6}\u{89C9}\u{7EB9}\u{7406}\u{3001}\u{7ED3}\u{6784}\u{548C}\u{4E3B}\u{8981}\u{77FF}\u{7269}\u{7EC4}\u{6210}\u{7684}\u{5FEB}\u{901F}\u{5206}\u{8BCA}\u{7CFB}\u{7EDF}\u{3002}

[15.1 \u{5CA9}\u{6D46}\u{7684}\u{6069}\u{8D50}\u{FF1A}\u{706B}\u{6210}\u{5CA9} (Igneous Rocks)]
\u{8FD9}\u{4E9B}\u{5CA9}\u{77F3}\u{66FE}\u{7ECF}\u{90FD}\u{662F}\u{6D41}\u{52A8}\u{7684}\u{7194}\u{5CA9}\u{6216}\u{5CA9}\u{6D46}\u{3002}\u{5B83}\u{4EEC}\u{7684}\u{51B7}\u{5374}\u{901F}\u{5EA6}\u{51B3}\u{5B9A}\u{4E86}\u{5B83}\u{4EEC}\u{7684}\u{7EC8}\u{6781}\u{9762}\u{8C8C}\u{3002}

*   **\u{4FB5}\u{5165}\u{5CA9} (Intrusive/Plutonic Rocks) - "\u{6DF1}\u{6E0A}\u{5DE8}\u{517D}"**: \u{5CA9}\u{6D46}\u{5728}\u{5730}\u{4E0B}\u{6DF1}\u{5904}\u{7F13}\u{6162}\u{51B7}\u{5374}\u{FF0C}\u{6709}\u{8DB3}\u{591F}\u{7684}\u{65F6}\u{95F4}\u{957F}\u{51FA}\u{8089}\u{773C}\u{53EF}\u{89C1}\u{7684}\u{3001}\u{7D27}\u{5BC6}\u{54AC}\u{5408}\u{7684}\u{5927}\u{6676}\u{4F53}\u{3002}
    *   **\u{82B1}\u{5C97}\u{5CA9} (Granite)**: \u{9646}\u{58F3}\u{7684}\u{57FA}\u{77F3}\u{3002}\u{5BFB}\u{627E}**\u{7C89}\u{8272}/\u{8089}\u{7EA2}\u{8272}\u{7684}\u{94BE}\u{957F}\u{77F3}**\u{3001}**\u{7070}\u{767D}/\u{900F}\u{660E}\u{7684}\u{77F3}\u{82F1}**\u{3001}\u{4EE5}\u{53CA}\u{70B9}\u{7F00}\u{5176}\u{4E2D}\u{7684}**\u{9ED1}\u{8272}\u{4E91}\u{6BCD}\u{6216}\u{89D2}\u{95EA}\u{77F3}**\u{3002}\u{6807}\u{5FD7}\u{6027}\u{7684}\u{7C97}\u{7C92}\u{3001}\u{6591}\u{9A73}\u{5916}\u{89C2}\u{3002}\u{5982}\u{679C}\u{5B83}\u{8FD8}\u{5C55}\u{73B0}\u{51FA}\u{6781}\u{5176}\u{5DE8}\u{5927}\u{7684}\u{957F}\u{77F3}\u{6676}\u{4F53}\u{FF0C}\u{90A3}\u{5C31}\u{53EB}\u{505A}**\u{4F1F}\u{6676}\u{5CA9} (Pegmatite)**\u{3002}
    *   **\u{95EA}\u{957F}\u{5CA9} (Diorite)**: \u{5730}\u{8D28}\u{5B66}\u{5BB6}\u{7684}\u{201C}\u{9ED1}\u{767D}\u{82B1}\u{5C97}\u{5CA9}\u{201D}\u{3002}\u{5BFB}\u{627E}\u{770B}\u{8D77}\u{6765}\u{50CF}**\u{76D0}\u{548C}\u{80E1}\u{6912}\u{6DF7}\u{5408}\u{7269}**\u{7684}\u{7C97}\u{7CD9}\u{5CA9}\u{77F3}\u{FF0C}\u{901A}\u{5E38}\u{7531}\u{767D}\u{8272}\u{7684}\u{659C}\u{957F}\u{77F3}\u{548C}\u{9ED1}\u{8272}\u{7684}\u{89D2}\u{95EA}\u{77F3}/\u{9ED1}\u{4E91}\u{6BCD}\u{7EC4}\u{6210}\u{FF0C}\u{4F46}**\u{6CA1}\u{6709}\u{8089}\u{773C}\u{53EF}\u{89C1}\u{7684}\u{77F3}\u{82F1}**\u{3002}
    *   **\u{8F89}\u{957F}\u{5CA9} (Gabbro)**: \u{6D77}\u{6D0B}\u{5730}\u{58F3}\u{7684}\u{6DF1}\u{5C42}\u{6838}\u{5FC3}\u{3002}\u{5BFB}\u{627E}**\u{6DF1}\u{9ED1}\u{8272}/\u{6697}\u{7EFF}\u{8272}**\u{7684}\u{7C97}\u{7C92}\u{5CA9}\u{77F3}\u{FF0C}\u{901A}\u{5E38}\u{7531}\u{9ED1}\u{8272}\u{7684}\u{8F89}\u{77F3}\u{548C}\u{6DF1}\u{7070}/\u{7EFF}\u{7070}\u{8272}\u{7684}\u{659C}\u{957F}\u{77F3}\u{7EC4}\u{6210}\u{3002}

*   **\u{55B7}\u{51FA}\u{5CA9} (Extrusive/Volcanic Rocks) - "\u{70C8}\u{706B}\u{75BE}\u{98CE}"**: \u{7194}\u{5CA9}\u{55B7}\u{51FA}\u{5730}\u{8868}\u{FF0C}\u{8FC5}\u{901F}\u{51B7}\u{5374}\u{FF0C}\u{6676}\u{4F53}\u{6765}\u{4E0D}\u{53CA}\u{957F}\u{5927}\u{FF0C}\u{6240}\u{4EE5}\u{5B83}\u{4EEC}\u{8981}\u{4E48}\u{6781}\u{5176}\u{7EC6}\u{817B}\u{FF0C}\u{8981}\u{4E48}\u{6EE1}\u{662F}\u{6C14}\u{5B54}\u{FF0C}\u{751A}\u{81F3}\u{662F}\u{73BB}\u{7483}\u{3002}
    *   **\u{7384}\u{6B66}\u{5CA9} (Basalt)**: \u{7EDF}\u{6CBB}\u{6D77}\u{5E95}\u{548C}\u{590F}\u{5A01}\u{5937}\u{7684}\u{5CA9}\u{77F3}\u{3002}\u{5BFB}\u{627E}**\u{6781}\u{5176}\u{81F4}\u{5BC6}\u{3001}\u{6C89}\u{91CD}\u{3001}\u{6697}\u{9ED1}\u{8272}/\u{6DF1}\u{7070}\u{8272}\u{7684}\u{7EC6}\u{7C92}\u{5CA9}\u{77F3}**\u{3002}\u{6709}\u{65F6}\u{5B83}\u{4F1A}\u{5145}\u{6EE1}\u{66FE}\u{7ECF}\u{662F}\u{6C14}\u{6CE1}\u{7684}\u{5B54}\u{6D1E}\u{FF08}\u{6C14}\u{5B54}\u{72B6}\u{7384}\u{6B66}\u{5CA9}/Vesicular basalt\u{FF09}\u{3002}
    *   **\u{6D41}\u{7EB9}\u{5CA9} (Rhyolite)**: \u{82B1}\u{5C97}\u{5CA9}\u{7684}\u{706B}\u{5C71}\u{7248}\u{5144}\u{5F1F}\u{3002}\u{901A}\u{5E38}\u{662F}**\u{6D45}\u{8272}\u{3001}\u{7C89}\u{8272}\u{6216}\u{6D45}\u{7070}\u{8272}**\u{7684}\u{7EC6}\u{7C92}\u{5CA9}\u{77F3}\u{FF0C}\u{6709}\u{65F6}\u{80FD}\u{770B}\u{5230}\u{6DB2}\u{4F53}\u{6D41}\u{52A8}\u{65F6}\u{7559}\u{4E0B}\u{7684}**\u{6D41}\u{7EB9} (flow banding)**\u{3002}
    *   **\u{5B89}\u{5C71}\u{5CA9} (Andesite)**: \u{95EA}\u{957F}\u{5CA9}\u{7684}\u{706B}\u{5C71}\u{7248}\u{3002}\u{901A}\u{5E38}\u{662F}**\u{4E2D}\u{7B49}\u{7070}\u{5EA6}\u{7684}\u{7EC6}\u{7C92}\u{5CA9}\u{77F3}**\u{FF0C}\u{5E38}\u{5E38}\u{5E26}\u{6709}\u{9ED1}\u{8272}\u{89D2}\u{95EA}\u{77F3}\u{6216}\u{767D}\u{8272}\u{957F}\u{77F3}\u{7684}\u{5FAE}\u{5C0F}\u{6591}\u{6676}\u{FF08}\u{6591}\u{72B6}\u{7ED3}\u{6784}\u{FF09}\u{3002}
    *   **\u{9ED1}\u{66DC}\u{77F3} (Obsidian)**: \u{7EC8}\u{6781}\u{7684}\u{51B7}\u{5374}\u{901F}\u{5EA6}\u{FF01}\u{5BFB}\u{627E}\u{50CF}**\u{9ED1}\u{8272}\u{73BB}\u{7483}**\u{4E00}\u{6837}\u{7684}\u{5CA9}\u{77F3}\u{FF0C}\u{62E5}\u{6709}\u{65E0}\u{4E0E}\u{4F26}\u{6BD4}\u{7684}\u{3001}\u{50CF}\u{6253}\u{788E}\u{7684}\u{5564}\u{9152}\u{74F6}\u{4E00}\u{6837}\u{7684}**\u{5B8C}\u{7F8E}\u{8D1D}\u{58F3}\u{72B6}\u{65AD}\u{53E3}**\u{3002}
    *   **\u{6D6E}\u{77F3} (Pumice) & \u{706B}\u{5C71}\u{6E23} (Scoria)**: \u{706B}\u{5C71}\u{6C14}\u{4F53}\u{7684}\u{9057}\u{9AB8}\u{3002}\u{6D6E}\u{77F3}\u{662F}\u{6D45}\u{8272}\u{3001}\u{6781}\u{5EA6}\u{591A}\u{5B54}\u{3001}**\u{751A}\u{81F3}\u{80FD}\u{98D8}\u{5728}\u{6C34}\u{4E0A}**\u{7684}\u{706B}\u{5C71}\u{73BB}\u{7483}\u{6CE1}\u{6CAB}\u{3002}\u{706B}\u{5C71}\u{6E23}\u{5219}\u{662F}\u{989C}\u{8272}\u{66F4}\u{6DF1}\u{FF08}\u{7EA2}\u{8910}/\u{9ED1}\u{8272}\u{FF09}\u{3001}\u{5B54}\u{6D1E}\u{8F83}\u{5927}\u{3001}\u{6BD4}\u{6D6E}\u{77F3}\u{7565}\u{91CD}\u{4F46}\u{4F9D}\u{7136}\u{591A}\u{5B54}\u{7684}\u{7C97}\u{7CD9}\u{7194}\u{5CA9}\u{788E}\u{5757}\u{3002}

[15.2 \u{6D74}\u{706B}\u{91CD}\u{751F}\u{7684}\u{51E4}\u{51F0}\u{FF1A}\u{53D8}\u{8D28}\u{5CA9} (Metamorphic Rocks)]
\u{9AD8}\u{6E29}\u{548C}\u{5DE8}\u{5927}\u{7684}\u{538B}\u{529B}\u{5C06}\u{539F}\u{6709}\u{5CA9}\u{77F3}\u{6324}\u{538B}\u{3001}\u{626D}\u{66F2}\u{5E76}\u{4F7F}\u{5176}\u{77FF}\u{7269}\u{91CD}\u{65B0}\u{6392}\u{5217}\u{3002}\u{5BFB}\u{627E}\u{201C}\u{88AB}\u{538B}\u{6241}\u{201D}\u{6216}\u{201C}\u{88AB}\u{62C9}\u{957F}\u{201D}\u{7684}\u{8FF9}\u{8C61}\u{FF01}

*   **\u{53F6}\u{7406}\u{72B6}\u{53D8}\u{8D28}\u{5CA9} (Foliated Metamorphic Rocks) - "\u{5730}\u{5C42}\u{7684}\u{5343}\u{5C42}\u{9165}"**:
    *   **\u{677F}\u{5CA9} (Slate)**: \u{7531}\u{9875}\u{5CA9}\u{6F14}\u{53D8}\u{800C}\u{6765}\u{3002}\u{975E}\u{5E38}\u{81F4}\u{5BC6}\u{3001}\u{7EC6}\u{7C92}\u{FF0C}\u{62E5}\u{6709}\u{80FD}\u{591F}**\u{5B8C}\u{7F8E}\u{88C2}\u{6210}\u{5E73}\u{6574}\u{8584}\u{677F}**\u{7684}\u{7279}\u{6027}\u{FF08}\u{677F}\u{72B6}\u{5288}\u{7406}\u{FF09}\u{3002}\u{901A}\u{5E38}\u{662F}\u{6697}\u{7070}\u{8272}\u{3001}\u{7EA2}\u{8910}\u{8272}\u{6216}\u{7EFF}\u{8272}\u{3002}
    *   **\u{5343}\u{679A}\u{5CA9} (Phyllite)**: \u{6BD4}\u{677F}\u{5CA9}\u{7ECF}\u{53D7}\u{4E86}\u{66F4}\u{9AD8}\u{7684}\u{6E29}\u{5EA6}\u{3002}\u{9664}\u{4E86}\u{80FD}\u{88C2}\u{6210}\u{677F}\u{72B6}\u{FF0C}\u{5B83}\u{7684}\u{8868}\u{9762}\u{8FD8}\u{8986}\u{76D6}\u{7740}\u{4E00}\u{5C42}\u{5FAE}\u{5C0F}\u{4E91}\u{6BCD}\u{5E26}\u{6765}\u{7684}**\u{4E1D}\u{7EE2}\u{5149}\u{6CFD} (silky sheen)**\u{FF0C}\u{4E14}\u{8868}\u{9762}\u{5F80}\u{5F80}\u{5448}\u{8F7B}\u{5FAE}\u{7684}\u{6CE2}\u{6D6A}\u{72B6}\u{3002}
    *   **\u{7247}\u{5CA9} (Schist)**: \u{6781}\u{5177}\u{4EE3}\u{8868}\u{6027}\u{FF01}\u{5CA9}\u{77F3}\u{4EFF}\u{4F5B}\u{662F}\u{7531}**\u{65E0}\u{6570}\u{5E73}\u{884C}\u{6392}\u{5217}\u{7684}\u{4E91}\u{6BCD}\u{8584}\u{7247}\u{53E0}\u{538B}\u{800C}\u{6210}**\u{3002}\u{5BFB}\u{627E}\u{6781}\u{5176}\u{95EA}\u{4EAE}\u{3001}\u{9CDE}\u{7247}\u{72B6}\u{7684}\u{5916}\u{89C2}\u{FF0C}\u{4E14}\u{975E}\u{5E38}\u{5BB9}\u{6613}\u{987A}\u{7740}\u{4E91}\u{6BCD}\u{5C42}\u{5265}\u{843D}\u{3002}\u{5982}\u{679C}\u{91CC}\u{9762}\u{957F}\u{51FA}\u{4E86}\u{5DE8}\u{5927}\u{7684}\u{7EA2}\u{77F3}\u{69B4}\u{77F3}\u{FF0C}\u{90A3}\u{5C31}\u{662F}\u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{7247}\u{5CA9}\u{3002}
    *   **\u{7247}\u{9EBB}\u{5CA9} (Gneiss)**: \u{53D8}\u{8D28}\u{5CA9}\u{7684}\u{9AD8}\u{7EA7}\u{5F62}\u{6001}\u{3002}\u{7ECF}\u{5386}\u{4E86}\u{6781}\u{9AD8}\u{7684}\u{6E29}\u{5EA6}\u{548C}\u{538B}\u{529B}\u{FF0C}\u{6DF1}\u{8272}\u{548C}\u{6D45}\u{8272}\u{77FF}\u{7269}\u{88AB}\u{5F3A}\u{5236}\u{5206}\u{79BB}\u{5F00}\u{6765}\u{FF0C}\u{5F62}\u{6210}**\u{6781}\u{5176}\u{660E}\u{663E}\u{7684}\u{3001}\u{4EA4}\u{66FF}\u{6392}\u{5217}\u{7684}\u{9ED1}\u{767D}\u{76F8}\u{95F4}\u{6761}\u{5E26} (zebra-striped banding)**\u{3002}

*   **\u{975E}\u{53F6}\u{7406}\u{72B6}\u{53D8}\u{8D28}\u{5CA9} (Non-Foliated Metamorphic Rocks) - "\u{5747}\u{8D28}\u{7684}\u{575A}\u{94A2}"**:
    *   **\u{5927}\u{7406}\u{5CA9} (Marble)**: \u{7531}\u{77F3}\u{7070}\u{5CA9}\u{53D8}\u{8D28}\u{800C}\u{6765}\u{3002}\u{5BFB}\u{627E}**\u{8089}\u{773C}\u{53EF}\u{89C1}\u{7684}\u{3001}\u{95EA}\u{95EA}\u{53D1}\u{5149}\u{7684}\u{65B9}\u{89E3}\u{77F3}\u{6676}\u{4F53}\u{9897}\u{7C92}**\u{3002}\u{5B83}\u{901A}\u{5E38}\u{662F}\u{767D}\u{8272}/\u{6D45}\u{8272}\u{FF0C}\u{4E14}\u{9047}\u{76D0}\u{9178}\u{4F1A}\u{5192}\u{6CE1}\u{3002}\u{7528}\u{5200}\u{53EF}\u{4EE5}\u{5212}\u{52A8}\u{3002}
    *   **\u{77F3}\u{82F1}\u{5CA9} (Quartzite)**: \u{7531}\u{77F3}\u{82F1}\u{7802}\u{5CA9}\u{53D8}\u{8D28}\u{800C}\u{6765}\u{3002}\u{5BFB}\u{627E}\u{6781}\u{5176}\u{575A}\u{786C}\u{FF08}\u{786C}\u{5EA6}7\u{FF09}\u{3001}\u{7531}\u{878D}\u{5408}\u{5728}\u{4E00}\u{8D77}\u{7684}\u{77F3}\u{82F1}\u{9897}\u{7C92}\u{7EC4}\u{6210}\u{7684}\u{81F4}\u{5BC6}\u{5CA9}\u{77F3}\u{FF0C}\u{7ECF}\u{5E38}\u{5448}\u{73B0}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{7684}\u{65AD}\u{53E3}\u{3002}**\u{6572}\u{51FB}\u{65F6}\u{751A}\u{81F3}\u{53EF}\u{80FD}\u{4EA7}\u{751F}\u{706B}\u{82B1}**\u{3002}

[15.3 \u{65F6}\u{95F4}\u{4E0E}\u{6C34}\u{6D41}\u{7684}\u{96D5}\u{523B}\u{FF1A}\u{6C89}\u{79EF}\u{5CA9} (Sedimentary Rocks)]
\u{5B83}\u{4EEC}\u{662F}\u{5730}\u{7403}\u{8868}\u{9762}\u{7684}\u{65E5}\u{8BB0}\u{FF0C}\u{7531}\u{788E}\u{5C51}\u{7269}\u{8D28}\u{3001}\u{5316}\u{5B66}\u{6C89}\u{6DC0}\u{6216}\u{751F}\u{7269}\u{9057}\u{9AB8}\u{5728}\u{6C34}\u{6216}\u{98CE}\u{7684}\u{8FD0}\u{4F5C}\u{4E0B}\u{5C42}\u{5C42}\u{5806}\u{79EF}\u{3001}\u{56FA}\u{7ED3}\u{800C}\u{6210}\u{3002}

*   **\u{788E}\u{5C51}\u{6C89}\u{79EF}\u{5CA9} (Clastic Sedimentary Rocks) - "\u{788E}\u{7247}\u{7684}\u{62FC}\u{56FE}"**:
    *   **\u{783E}\u{5CA9} (Conglomerate)**: \u{770B}\u{8D77}\u{6765}\u{5C31}\u{50CF}\u{628A}**\u{5706}\u{5706}\u{7684}\u{9E45}\u{5375}\u{77F3}\u{7528}\u{6C34}\u{6CE5}\u{7CCA}\u{5728}\u{4E86}\u{4E00}\u{8D77}**\u{3002}\u{8FD9}\u{4EE3}\u{8868}\u{7740}\u{53E4}\u{8001}\u{4E14}\u{6E4D}\u{6025}\u{7684}\u{6CB3}\u{6D41}\u{7CFB}\u{7EDF}\u{3002}
    *   **\u{89D2}\u{783E}\u{5CA9} (Breccia)**: \u{957F}\u{5F97}\u{50CF}\u{783E}\u{5CA9}\u{FF0C}\u{4F46}\u{91CC}\u{9762}\u{7684}\u{788E}\u{5757}\u{662F}**\u{68F1}\u{89D2}\u{5206}\u{660E}\u{7684}\u{3001}\u{5C16}\u{9510}\u{7684}**\u{3002}\u{8FD9}\u{4EE3}\u{8868}\u{788E}\u{5757}\u{6CA1}\u{7ECF}\u{8FC7}\u{957F}\u{9014}\u{642C}\u{8FD0}\u{5C31}\u{5728}\u{584C}\u{65B9}\u{6216}\u{65AD}\u{5C42}\u{5E26}\u{9644}\u{8FD1}\u{8FC5}\u{901F}\u{51DD}\u{7ED3}\u{4E86}\u{3002}
    *   **\u{7802}\u{5CA9} (Sandstone)**: \u{6478}\u{8D77}\u{6765}\u{50CF}\u{7802}\u{7EB8}\u{FF01}\u{7531}\u{8089}\u{773C}\u{53EF}\u{89C1}\u{7684}\u{3001}\u{50CF}\u{6C99}\u{6EE9}\u{4E0A}\u{7684}\u{6C99}\u{5B50}\u{4E00}\u{6837}\u{7684}\u{9897}\u{7C92}\u{56FA}\u{7ED3}\u{800C}\u{6210}\u{3002}\u{5982}\u{679C}\u{542B}\u{6709}\u{5927}\u{91CF}\u{957F}\u{77F3}\u{FF0C}\u{770B}\u{8D77}\u{6765}\u{504F}\u{7C89}\u{7EA2}\u{FF0C}\u{90A3}\u{5C31}\u{662F}**\u{957F}\u{77F3}\u{7802}\u{5CA9} (Arkose)**\u{3002}
    *   **\u{9875}\u{5CA9} (Shale) & \u{6CE5}\u{5CA9} (Mudstone)**: \u{6E56}\u{76C6}\u{6216}\u{6DF1}\u{6D77}\u{5E95}\u{90E8}\u{7684}\u{5B81}\u{9759}\u{4EA7}\u{7269}\u{3002}\u{6781}\u{7EC6}\u{7684}\u{6CE5}\u{5DF4}\u{56FA}\u{7ED3}\u{800C}\u{6210}\u{3002}\u{5982}\u{679C}\u{5B83}\u{80FD}\u{8F7B}\u{6613}\u{5730}\u{6CBF}\u{7740}\u{5E73}\u{884C}\u{5C42}\u{9762}**\u{88C2}\u{6210}\u{8584}\u{8584}\u{7684}\u{4E00}\u{7247}\u{7247}**\u{FF0C}\u{90A3}\u{5C31}\u{662F}\u{9875}\u{5CA9}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{4E00}\u{4E2A}\u{575A}\u{5B9E}\u{7684}\u{5927}\u{6CE5}\u{5757}\u{FF0C}\u{5C31}\u{662F}\u{6CE5}\u{5CA9}\u{3002}\u{9875}\u{5CA9}\u{5E38}\u{5E38}\u{4FDD}\u{5B58}\u{6709}\u{5B8C}\u{7F8E}\u{7684}\u{690D}\u{7269}\u{6216}\u{6606}\u{866B}\u{5316}\u{77F3}\u{3002}

*   **\u{5316}\u{5B66}\u{4E0E}\u{751F}\u{7269}\u{6C89}\u{79EF}\u{5CA9} (Chemical/Biochemical Sedimentary Rocks)**:
    *   **\u{77F3}\u{7070}\u{5CA9} (Limestone)**: \u{6D77}\u{6D0B}\u{751F}\u{7269}\u{FF08}\u{73CA}\u{745A}\u{3001}\u{8D1D}\u{58F3}\u{FF09}\u{9AA8}\u{9ABC}\u{6216}\u{5316}\u{5B66}\u{6C89}\u{6DC0}\u{7684}\u{78B3}\u{9178}\u{9499}\u{3002}\u{53EF}\u{80FD}\u{662F}\u{81F4}\u{5BC6}\u{7684}\u{7070}\u{8272}\u{5757}\u{4F53}\u{FF0C}\u{4E5F}\u{53EF}\u{80FD}\u{76F4}\u{63A5}\u{770B}\u{5230}\u{6EE1}\u{773C}\u{7684}**\u{8D1D}\u{58F3}\u{788E}\u{5C51}\u{5316}\u{77F3}**\u{3002}\u{6EF4}\u{9178}\u{5FC5}\u{5B9A}\u{5267}\u{70C8}\u{8D77}\u{6CE1}\u{3002}
    *   **\u{767D}\u{4E91}\u{5CA9} (Dolomite / Dolostone)**: \u{770B}\u{8D77}\u{6765}\u{50CF}\u{77F3}\u{7070}\u{5CA9}\u{FF0C}\u{4F46}\u{901A}\u{5E38}\u{5E26}\u{70B9}\u{9EC4}/\u{7C89}\u{8272}\u{8C03}\u{FF0C}\u{4E14}\u{53EA}\u{6709}\u{5728}**\u{522E}\u{51FA}\u{7C89}\u{672B}\u{540E}**\u{6EF4}\u{9178}\u{624D}\u{4F1A}\u{7F13}\u{6162}\u{8D77}\u{6CE1}\u{3002}
    *   **\u{7164} (Coal)**: \u{5F88}\u{5BB9}\u{6613}\u{8BA4}\u{7684}\u{9ED1}\u{8272}\u{5CA9}\u{77F3}\u{3002}\u{90A3}\u{662F}\u{51E0}\u{767E}\u{4E07}\u{5E74}\u{524D}\u{53E4}\u{8001}\u{6CBC}\u{6CFD}\u{68EE}\u{6797}\u{5E26}\u{7ED9}\u{5730}\u{7403}\u{7684}\u{56FA}\u{6001}\u{592A}\u{9633}\u{80FD}\u{3002}
    *   **\u{5CA9}\u{76D0} (Rock Salt / Halite) & \u{77F3}\u{818F} (Rock Gypsum)**: \u{84B8}\u{53D1}\u{5CA9}\u{3002}\u{8FDC}\u{53E4}\u{76D0}\u{6E56}\u{5E72}\u{6DB8}\u{7684}\u{4EA7}\u{7269}\u{3002}\u{5CA9}\u{76D0}\u{8214}\u{8D77}\u{6765}\u{662F}\u{54B8}\u{7684}\u{FF1B}\u{5757}\u{72B6}\u{77F3}\u{818F}\u{6781}\u{8F6F}\u{FF0C}\u{53EF}\u{4EE5}\u{7528}\u{6307}\u{7532}\u{522E}\u{51FA}\u{6DF1}\u{6DF1}\u{7684}\u{767D}\u{75D5}\u{3002}
`
};


const $6e6ffeb0735516dc$export$d7beafb510644f72 = {
    description: "Sorosilicates (Double Island Silicates) Identification Rules",
    coreRules: `
=== \u{7845}\u{9178}\u{76D0}\u{4E4B}\u{5BF9}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Sorosilicates / Double Island Silicates Protocol) ===

\u{5BF9}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{7684}\u{6838}\u{5FC3}\u{7ED3}\u{6784}\u{662F}\u{4E24}\u{4E2A}\u{7845}\u{6C27}\u{56DB}\u{9762}\u{4F53}\u{5171}\u{7528}\u{4E00}\u{4E2A}\u{6C27}\u{539F}\u{5B50}\u{76F8}\u{8FDE} ($Si_2O_7$)\u{3002}\u{8FD9}\u{4E2A}\u{5BB6}\u{65CF}\u{6700}\u{8457}\u{540D}\u{7684}\u{4EE3}\u{8868}\u{662F}\u{7EFF}\u{5E18}\u{77F3}\u{65CF}\u{77FF}\u{7269}\u{FF0C}\u{5B83}\u{4EEC}\u{5E7F}\u{6CDB}\u{5B58}\u{5728}\u{4E8E}\u{53D8}\u{8D28}\u{5CA9}\u{548C}\u{70ED}\u{6DB2}\u{8680}\u{53D8}\u{5E26}\u{4E2D}\u{FF0C}\u{662F}\u{5730}\u{8D28}\u{5B66}\u{5BB6}\u{773C}\u{4E2D}\u{7684}\u{201C}\u{6E29}\u{6807}\u{201D}\u{548C}\u{201C}\u{538B}\u{6807}\u{201D}\u{3002}

[10.1 \u{7EFF}\u{5E18}\u{77F3}\u{5BB6}\u{65CF} (The Epidote Group) - \u{53D8}\u{8D28}\u{5E26}\u{7684}\u{8C03}\u{8272}\u{76D8}]
\u{8FD9}\u{4E2A}\u{5BB6}\u{65CF}\u{7684}\u{77FF}\u{7269}\u{6676}\u{4F53}\u{901A}\u{5E38}\u{5448}\u{67F1}\u{72B6}\u{FF0C}\u{5E76}\u{4E14}\u{67F1}\u{9762}\u{4E0A}\u{5E38}\u{5E38}\u{5E26}\u{6709}\u{660E}\u{663E}\u{7684}\u{5E73}\u{884C}\u{751F}\u{957F}\u{7EB9}\u{FF08}\u{6761}\u{7EB9}\u{FF09}\u{3002}
*   **\u{7EFF}\u{5E18}\u{77F3} (Epidote)**: \u{7EDD}\u{5BF9}\u{7684}\u{989C}\u{8272}\u{951A}\u{70B9}\u{FF01}\u{5BFB}\u{627E}\u{7279}\u{5F81}\u{6027}\u{7684}**\u{201C}\u{5F00}\u{5FC3}\u{679C}\u{7EFF}\u{201D} (Pistachio-green)\u{3001}\u{9EC4}\u{7EFF}\u{8272}\u{81F3}\u{6DF1}\u{7EFF}\u{8272}**\u{3002}\u{5177}\u{6709}\u{5F3A}\u{70C8}\u{7684}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{FF0C}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{5E26}\u{6709}\u{660E}\u{663E}\u{5E73}\u{884C}\u{7EB5}\u{7EB9}\u{7684}\u{957F}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{6216}\u{8005}\u{81F4}\u{5BC6}\u{7684}\u{653E}\u{5C04}\u{72B6}\u{3001}\u{7C92}\u{72B6}\u{96C6}\u{5408}\u{4F53}\u{3002}\u{53EA}\u{8981}\u{770B}\u{5230}\u{8FD9}\u{79CD}\u{7279}\u{6709}\u{7684}\u{5E26}\u{9EC4}\u{8C03}\u{7684}\u{7EFF}\u{8272}\u{67F1}\u{72B6}\u{7269}\u{FF0C}\u{9996}\u{9009}\u{7EFF}\u{5E18}\u{77F3}\u{3002}
*   **\u{659C}\u{9EDD}\u{5E18}\u{77F3} (Clinozoisite)**: \u{7EFF}\u{5E18}\u{77F3}\u{7684}\u{5BCC}\u{94DD}\u{8D2B}\u{94C1}\u{4EB2}\u{621A}\u{3002}\u{5916}\u{5F62}\u{4E0E}\u{7EFF}\u{5E18}\u{77F3}\u{6781}\u{50CF}\u{FF08}\u{5E26}\u{5E73}\u{884C}\u{7EB9}\u{7684}\u{67F1}\u{72B6}\u{FF09}\u{FF0C}\u{4F46}\u{989C}\u{8272}\u{66F4}\u{52A0}\u{201C}\u{7D20}\u{96C5}\u{201D}\u{FF0C}\u{901A}\u{5E38}\u{662F}**\u{6D45}\u{7070}\u{7EFF}\u{3001}\u{7070}\u{767D}\u{8272}\u{3001}\u{6DE1}\u{9EC4}\u{8910}\u{8272}**\u{FF0C}\u{6CA1}\u{6709}\u{7EFF}\u{5E18}\u{77F3}\u{90A3}\u{79CD}\u{6D53}\u{90C1}\u{7684}\u{5F00}\u{5FC3}\u{679C}\u{7EFF}\u{3002}
*   **\u{8910}\u{5E18}\u{77F3} (Allanite)**: \u{542B}\u{6709}\u{7A00}\u{571F}\u{548C}\u{653E}\u{5C04}\u{6027}\u{5143}\u{7D20}\u{7684}\u{53D8}\u{79CD}\u{3002}\u{901A}\u{5E38}\u{5448}\u{73B0}**\u{8910}\u{9ED1}\u{8272}\u{3001}\u{6CA5}\u{9752}\u{9ED1}\u{8272} (Dark brown to black)**\u{FF0C}\u{5177}\u{6709}\u{6CA5}\u{9752}\u{5149}\u{6CFD}\u{6216}\u{534A}\u{91D1}\u{5C5E}\u{5149}\u{6CFD}\u{3002}\u{5728}\u{6BCD}\u{5CA9}\u{4E2D}\u{FF0C}\u{5B83}\u{7684}\u{5468}\u{56F4}\u{5F80}\u{5F80}\u{4F1A}\u{6709}\u{56E0}\u{4E3A}\u{653E}\u{5C04}\u{6027}\u{9020}\u{6210}\u{7684}\u{201C}\u{6655}\u{5708}\u{201D}\u{3002}
*   **\u{9EDD}\u{5E18}\u{77F3}\u{5BB6}\u{65CF} (Zoisite) \u{53CA}\u{5176}\u{53D8}\u{79CD}**:
    *   **\u{9EDD}\u{5E18}\u{77F3} (Zoisite)**: \u{672C}\u{4F53}\u{901A}\u{5E38}\u{662F}\u{7070}\u{8272}\u{3001}\u{7070}\u{8910}\u{8272}\u{7684}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{FF08}\u{659C}\u{65B9}\u{6676}\u{7CFB}\u{FF0C}\u{4E0E}\u{7EFF}\u{5E18}\u{77F3}\u{5355}\u{659C}\u{6676}\u{7CFB}\u{4E0D}\u{540C}\u{FF0C}\u{4F46}\u{8089}\u{773C}\u{96BE}\u{8FA8}\u{FF09}\u{FF0C}\u{4F46}\u{5B83}\u{7684}\u{4E24}\u{4E2A}\u{53D8}\u{79CD}\u{95FB}\u{540D}\u{9050}\u{8FE9}\u{FF01}
    *   **\u{9530}\u{9EDD}\u{5E18}\u{77F3} (Thulite)**: **\u{7EC8}\u{6781}\u{89C6}\u{89C9}\u{951A}\u{70B9}\u{FF01}**\u{5448}\u{73B0}\u{6781}\u{5176}\u{5A07}\u{8273}\u{3001}\u{4E0D}\u{900F}\u{660E}\u{7684}**\u{73AB}\u{7470}\u{7EA2}\u{8272}\u{3001}\u{7C89}\u{7EA2}\u{8272} (Rose-red, pink)**\u{3002}\u{5B83}\u{901A}\u{5E38}\u{662F}\u{81F4}\u{5BC6}\u{7684}\u{5757}\u{72B6}\u{96C6}\u{5408}\u{4F53}\u{3002}\u{53EA}\u{8981}\u{770B}\u{5230}\u{77F3}\u{5934}\u{5448}\u{73B0}\u{8FD9}\u{822C}\u{6BEB}\u{65E0}\u{900F}\u{660E}\u{5EA6}\u{4F46}\u{6781}\u{5EA6}\u{81F4}\u{5BC6}\u{7684}\u{201C}\u{5C11}\u{5973}\u{7C89}\u{201D}\u{6216}\u{7EA2}\u{8089}\u{8272}\u{FF0C}\u{7ACB}\u{523B}\u{9501}\u{5B9A}\u{9530}\u{9EDD}\u{5E18}\u{77F3}\u{3002}
    *   **\u{5766}\u{6851}\u{77F3} (Tanzanite)**: \u{5B9D}\u{77F3}\u{7EA7}\u{9EDD}\u{5E18}\u{77F3}\u{3002}\u{5BFB}\u{627E}**\u{6781}\u{5176}\u{901A}\u{900F}\u{7684}\u{7D2B}\u{84DD}\u{8272}\u{3001}\u{84DD}\u{7D2B}\u{8272} (Violet-blue, Sapphire-blue)**\u{3002}\u{5B83}\u{5177}\u{6709}\u{6781}\u{5176}\u{5F3A}\u{70C8}\u{7684}\u{591A}\u{8272}\u{6027}\u{FF08}\u{4ECE}\u{4E0D}\u{540C}\u{89D2}\u{5EA6}\u{770B}\u{5448}\u{73B0}\u{84DD}\u{3001}\u{7D2B}\u{3001}\u{751A}\u{81F3}\u{52C3}\u{826E}\u{7B2C}\u{7EA2}\u{FF09}\u{3002}

[10.2 \u{7ED3}\u{6784}\u{4E0D}\u{5BF9}\u{79F0}\u{4E0E}\u{63A5}\u{89E6}\u{4EA4}\u{4EE3}\u{77FF}\u{7269}]
*   **\u{5F02}\u{6781}\u{77FF} (Hemimorphite)**: \u{950C}\u{7684}\u{7845}\u{9178}\u{76D0}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{540D}\u{5B57}\u{6765}\u{6E90}\u{4E8E}\u{5B83}\u{7684}**\u{5F02}\u{6781}\u{6027} (Hemimorphic)**\u{2014}\u{2014}\u{6676}\u{4F53}\u{7684}\u{4E24}\u{7AEF}\u{5F62}\u{72B6}\u{5B8C}\u{5168}\u{4E0D}\u{540C}\u{FF08}\u{4E00}\u{7AEF}\u{7C7B}\u{91D1}\u{5B57}\u{5854}\u{FF0C}\u{4E00}\u{7AEF}\u{5E38}\u{662F}\u{5E73}\u{7684}\u{FF09}\u{3002}\u{5E38}\u{89C1}\u{5F62}\u{6001}\u{5206}\u{4E3A}\u{4E24}\u{79CD}\u{FF1A}\u{5E26}\u{68F1}\u{89D2}\u{7684}**\u{767D}\u{8272}/\u{65E0}\u{8272}\u{677F}\u{7247}\u{72B6}\u{3001}\u{900F}\u{660E}\u{81F3}\u{534A}\u{900F}\u{660E}\u{5200}\u{7247}\u{72B6}\u{6676}\u{7C07}**\u{FF08}\u{5982}\u{4F60}\u{56FE}\u{4E2D}\u{6240}\u{5C55}\u{793A}\u{7684}\u{FF09}\u{FF0C}\u{6216}\u{8005}\u{662F}**\u{84DD}\u{7EFF}\u{8272}\u{3001}\u{5929}\u{84DD}\u{8272}\u{7684}\u{8461}\u{8404}\u{72B6}/\u{80BE}\u{72B6}\u{76AE}\u{58F3}**\u{FF08}\u{957F}\u{5F97}\u{6781}\u{50CF}\u{83F1}\u{950C}\u{77FF}\u{6216}\u{7845}\u{5B54}\u{96C0}\u{77F3}\u{FF0C}\u{4F46}\u{5F02}\u{6781}\u{77FF}\u{6709}\u{53D1}\u{6563}\u{7684}\u{7ED3}\u{6676}\u{7ED3}\u{6784}\u{FF09}\u{3002}
*   **\u{7B26}\u{5C71}\u{77F3} (Vesuvianite / Idocrase)**: \u{63A5}\u{89E6}\u{4EA4}\u{4EE3}\u{7684}\u{6807}\u{5FD7}\u{4EA7}\u{7269}\u{FF08}\u{5982}\u{5915}\u{5361}\u{5CA9}\u{FF09}\u{3002}
    *   **\u{5F62}\u{6001}\u{951A}\u{70B9}**: \u{5BFB}\u{627E}**\u{6781}\u{5176}\u{7C97}\u{58EE}\u{7684}\u{3001}\u{77ED}\u{67F1}\u{72B6} (Stubby, blocky) \u{7684}\u{6B63}\u{65B9}\u{4F53}\u{6216}\u{516B}\u{8FB9}\u{5F62}\u{6676}\u{4F53}**\u{FF0C}\u{7AEF}\u{9762}\u{901A}\u{5E38}\u{8F83}\u{5E73}\u{5766}\u{3002}\u{989C}\u{8272}\u{591A}\u{4E3A}**\u{8910}\u{7EFF}\u{8272}\u{3001}\u{9EC4}\u{8910}\u{8272}\u{3001}\u{9EC4}\u{7EFF}\u{8272} (Brownish-green to yellow-brown)**\u{3002}\u{5B83}\u{770B}\u{8D77}\u{6765}\u{6BD4}\u{7EFF}\u{5E18}\u{77F3}\u{66F4}\u{52A0}\u{201C}\u{7B28}\u{91CD}\u{201D}\u{4E14}\u{5448}\u{73B0}\u{65B9}\u{5757}\u{611F}\u{FF0C}\u{5149}\u{6CFD}\u{5E38}\u{4E3A}\u{6CB9}\u{8102}\u{72B6}\u{6216}\u{5F3A}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{3002}

`,
    diagnosticTests: `
- \u{5BFB}\u{627E}\u{201C}\u{5F00}\u{5FC3}\u{679C}\u{7EFF}\u{201D}\u{FF1A}\u{5982}\u{679C}\u{5CA9}\u{77F3}\u{4E2D}\u{542B}\u{6709}\u{5927}\u{91CF}\u{5E26}\u{5E73}\u{884C}\u{6761}\u{7EB9}\u{7684}\u{9EC4}\u{7EFF}\u{8272}\u{67F1}\u{72B6}\u{6216}\u{7C92}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{7ACB}\u{523B}\u{9501}\u{5B9A}\u{7EFF}\u{5E18}\u{77F3}\u{3002}\u{5982}\u{679C}\u{662F}\u{989C}\u{8272}\u{6CDB}\u{767D}\u{7684}\u{540C}\u{7C7B}\u{67F1}\u{4F53}\u{FF0C}\u{5219}\u{662F}\u{659C}\u{9EDD}\u{5E18}\u{77F3}\u{3002}
- \u{5BFB}\u{627E}\u{201C}\u{73AB}\u{7470}\u{7C89}\u{7EA2}\u{201D}\u{FF1A}\u{5982}\u{679C}\u{770B}\u{5230}\u{81F4}\u{5BC6}\u{4E0D}\u{900F}\u{660E}\u{7684}\u{7C89}\u{7EA2}\u{8272}/\u{73AB}\u{7470}\u{7EA2}\u{5757}\u{72B6}\u{5CA9}\u{77F3}\u{FF0C}\u{5B83}\u{662F}\u{9530}\u{9EDD}\u{5E18}\u{77F3} (Thulite)\u{3002}
- \u{5982}\u{679C}\u{89C1}\u{5230}\u{7EAF}\u{51C0}\u{901A}\u{900F}\u{65E0}\u{6BD4}\u{7684}\u{84DD}\u{7D2B}\u{8272}\u{5B9D}\u{77F3}\u{6676}\u{4F53}\u{FF0C}\u{90A3}\u{662F}\u{5766}\u{6851}\u{77F3}\u{3002}
- \u{89C2}\u{5BDF}\u{6676}\u{4F53}\u{5F62}\u{6001}\u{611F}\u{89C9}\u{FF1A}\u{5982}\u{679C}\u{662F}\u{8910}\u{9ED1}\u{8272}\u{53D1}\u{6CA5}\u{9752}\u{5149}\u{6CFD}\u{7684}\u{81F4}\u{5BC6}\u{5757}\u{FF0C}\u{8003}\u{8651}\u{653E}\u{5C04}\u{6027}\u{8910}\u{5E18}\u{77F3}\u{3002}\u{5982}\u{679C}\u{662F}\u{9EC4}\u{8910}/\u{7EFF}\u{8910}\u{8272}\u{3001}\u{663E}\u{5F97}\u{5F88}\u{7B28}\u{91CD}\u{65B9}\u{6B63}\u{7684}\u{77ED}\u{67F1}\u{5B50}\u{FF0C}\u{8003}\u{8651}\u{7B26}\u{5C71}\u{77F3}\u{3002}
- \u{5982}\u{679C}\u{77FF}\u{7269}\u{5448}\u{767D}\u{8272}/\u{900F}\u{660E}\u{7EC6}\u{677F}\u{7247}\u{72B6}\u{7ED3}\u{6676}\u{805A}\u{96C6}\u{FF0C}\u{6216}\u{5448}\u{73B0}\u{5929}\u{84DD}\u{8272}\u{8461}\u{8404}\u{72B6}\u{76AE}\u{58F3}\u{FF0C}\u{7ED3}\u{5408}\u{94C5}\u{950C}\u{77FF}\u{627E}\u{77FF}\u{80CC}\u{666F}\u{FF0C}\u{5B83}\u{662F}\u{5F02}\u{6781}\u{77FF}\u{3002}
`
};


const $29690989cf16f0ed$export$bdc46119401796d2 = {
    description: "Sulfates, Chromates, Molybdates & Tungstates Identification Rules",
    coreRules: `
=== \u{786B}\u{9178}\u{76D0}\u{3001}\u{94EC}\u{9178}\u{76D0}\u{3001}\u{4E0E}\u{94A8}\u{94BC}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Sulfates, Chromates, Molybdates & Tungstates Protocol) ===

[7.1 \u{786B}\u{9178}\u{76D0}\u{7684}\u{57FA}\u{7840}\u{9738}\u{4E3B} (The Core Sulfates: Ca, Ba, Sr)]
*   **\u{91CD}\u{6676}\u{77F3} (Barite)**: \u{6781}\u{91CD}\u{FF08}\u{5BF9}\u{4E8E}\u{975E}\u{91D1}\u{5C5E}\u{77FF}\u{7269}\u{800C}\u{8A00}\u{5BC6}\u{5EA6}\u{6781}\u{9AD8}\u{FF09}\u{3002}\u{5BFB}\u{627E}**\u{677F}\u{72B6}\u{6676}\u{4F53} (Tabular crystals)** \u{5F80}\u{5F80}\u{805A}\u{96C6}\u{6210}\u{201C}\u{6C99}\u{6F20}\u{73AB}\u{7470}\u{201D}\u{72B6}\u{6216}\u{8005}\u{539A}\u{91CD}\u{7684}\u{900F}\u{660E}/\u{767D}\u{8272}/\u{6D45}\u{9EC4}\u{8272}\u{5200}\u{7247}\u{72B6}\u{6676}\u{7C07}\u{3002}\u{65AD}\u{9762}\u{4E0A}\u{5E38}\u{6709}\u{6781}\u{597D}\u{7684}\u{76F4}\u{89D2}\u{548C}\u{5FAE}\u{659C}\u{89D2}\u{89E3}\u{7406}\u{76F8}\u{4EA4}\u{3002}
*   **\u{5929}\u{9752}\u{77F3} (Celestine)**: \u{4E0E}\u{91CD}\u{6676}\u{77F3}\u{6781}\u{5EA6}\u{76F8}\u{4F3C}\u{FF0C}\u{4F46}\u{5FC5}\u{987B}\u{5BFB}\u{627E}\u{5176}\u{72EC}\u{4E00}\u{65E0}\u{4E8C}\u{7684}**\u{201C}\u{5929}\u{84DD}\u{8272}\u{5230}\u{6D45}\u{7070}\u{84DD}\u{8272} (Light blue/Celadon blue)\u{201D}**\u{8272}\u{8C03}\u{3002}\u{5982}\u{679C}\u{662F}\u{5E26}\u{6709}\u{6DE1}\u{84DD}\u{8272}\u{7684}\u{677F}\u{72B6}/\u{67F1}\u{72B6}\u{900F}\u{660E}\u{6676}\u{7C07}\u{FF0C}\u{76F4}\u{63A5}\u{5173}\u{8054}\u{5929}\u{9752}\u{77F3}\u{3002}
*   **\u{77F3}\u{818F}\u{5BB6}\u{65CF} (Gypsum Group)**:
    *   **\u{77F3}\u{818F} / \u{900F}\u{77F3}\u{818F} (Selenite)**: \u{6781}\u{8F6F}\u{FF08}\u{6307}\u{7532}\u{80FD}\u{8F7B}\u{6613}\u{5212}\u{523B}\u{FF09}\u{3002}\u{5982}\u{679C}\u{5448}\u{73B0}\u{51FA}\u{5B8C}\u{7F8E}\u{900F}\u{660E}\u{3001}\u{80FD}\u{6E05}\u{6670}\u{900F}\u{89C6}\u{8FC7}\u{53BB}\u{5E73}\u{884C}\u{56DB}\u{8FB9}\u{5F62}\u{677F}\u{72B6}\u{6676}\u{4F53}\u{FF0C}\u{6216}\u{8005}\u{6709}\u{660E}\u{663E}\u{7684}\u{201C}\u{71D5}\u{5C3E}\u{53CC}\u{6676}\u{201D}\u{FF0C}\u{5224}\u{5B9A}\u{4E3A}\u{900F}\u{77F3}\u{818F}\u{3002}
    *   **\u{96EA}\u{82B1}\u{77F3}\u{818F} (Alabaster)**: \u{5448}\u{73B0}\u{81F4}\u{5BC6}\u{7684}\u{3001}\u{51E0}\u{4E4E}\u{50CF}\u{6C49}\u{767D}\u{7389}\u{4E00}\u{6837}\u{7684}\u{7EC6}\u{7C92}\u{7EAF}\u{767D}\u{8272}\u{5757}\u{72B6}\u{3002}
    *   **\u{786C}\u{77F3}\u{818F} (Anhydrite)**: \u{5E38}\u{5E38}\u{5448}\u{767D}\u{3001}\u{7070}\u{7C92}\u{72B6}\u{81F4}\u{5BC6}\u{5757}\u{4F53}\u{3002}\u{5B83}\u{4E5F}\u{53EF}\u{80FD}\u{8868}\u{73B0}\u{51FA}\u{4E09}\u{7EC4}\u{76F4}\u{89D2}\u{89E3}\u{7406}\u{FF08}\u{7834}\u{88C2}\u{6210}\u{7ACB}\u{65B9}\u{72B6}\u{788E}\u{5757}\u{FF09}\u{FF0C}\u{4E0E}\u{65B9}\u{89E3}\u{77F3}\u{7684}\u{83F1}\u{9762}\u{4F53}\u{89E3}\u{7406}\u{4E0D}\u{540C}\u{3002}\u{4F53}\u{79EF}\u{6BD4}\u{666E}\u{901A}\u{77F3}\u{818F}\u{66F4}\u{81F4}\u{5BC6}\u{3001}\u{786C}\u{5EA6}\u{66F4}\u{9AD8}\u{3002}
*   **\u{76D0}\u{6E56}\u{53CC}\u{96C4}\u{FF1A}\u{9499}\u{8292}\u{785D} (Glauberite) \u{4E0E} \u{65E0}\u{6C34}\u{8292}\u{785D} (Thenardite)**:
    *   **\u{9499}\u{8292}\u{785D}**: \u{5E38}\u{5448}\u{73B0}**\u{77DB}\u{5934}\u{72B6}\u{6216}\u{677F}\u{72B6}\u{7684}\u{6676}\u{4F53} (Spear-shaped or tabular crystals)**\u{FF0C}\u{5E76}\u{4E14}\u{6781}\u{6613}\u{98CE}\u{5316}\u{FF0C}\u{8868}\u{9762}\u{5F80}\u{5F80}\u{6709}\u{4E00}\u{5C42}\u{767D}\u{8272}\u{7684}\u{7C89}\u{672B}\u{72B6}\u{5916}\u{58F3}\u{3002}
    *   **\u{65E0}\u{6C34}\u{8292}\u{785D}**: \u{5438}\u{6C34}\u{6781}\u{5F3A}\u{FF0C}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{767D}\u{8272}\u{7684}\u{53CC}\u{9525}\u{72B6}\u{6216}\u{539A}\u{677F}\u{72B6}\u{5757}\u{4F53}\u{FF0C}\u{5E38}\u{5904}\u{4E8E}\u{5E72}\u{71E5}\u{73AF}\u{5883}\u{4E2D}\u{3002}
*   **\u{6742}\u{5364}\u{77F3} (Polyhalite)**: \u{901A}\u{5E38}\u{5448}\u{73B0}\u{51FA}\u{56E0}\u{4E3A}\u{542B}\u{6709}\u{6781}\u{5176}\u{5FAE}\u{91CF}\u{6C27}\u{5316}\u{94C1}\u{800C}\u{4EA7}\u{751F}\u{7684}**\u{7279}\u{5F81}\u{6027}\u{7816}\u{7EA2}\u{8272}\u{3001}\u{8089}\u{7EA2}\u{8272}\u{5230}\u{6D45}\u{6854}\u{8272}\u{7684}\u{81F4}\u{5BC6}\u{7EA4}\u{7EF4}\u{72B6}\u{81F3}\u{5757}\u{72B6}\u{96C6}\u{5408}\u{4F53} (Brick-red to flesh-pink fibrous/massive)**\u{3002}

[7.2 \u{6781}\u{5EA6}\u{7EDA}\u{4E3D}\u{7684}\u{6709}\u{6BD2}\u{6B21}\u{751F}\u{77FF}\u{4E0E}\u{91CD}\u{91D1}\u{5C5E}\u{76D0} (The Bright Secondary Minerals)]
*   **\u{94EC}\u{94C5}\u{77FF} (Crocoite)**: \u{94EC}\u{9178}\u{76D0}\u{7684}\u{7EDD}\u{5BF9}\u{738B}\u{8005}\u{FF0C}\u{4E0D}\u{53EF}\u{80FD}\u{8BA4}\u{9519}\u{7684}\u{989C}\u{8272}\u{3002}\u{5BFB}\u{627E}**\u{6781}\u{5EA6}\u{9C9C}\u{8273}\u{7684}\u{4EAE}\u{7EA2}\u{8272}\u{81F3}\u{7EA2}\u{6A59}\u{8272}\u{FF0C}\u{5982}\u{540C}\u{4E00}\u{6839}\u{6839}\u{5C16}\u{9510}\u{7684}\u{706B}\u{67F4}\u{68CD}\u{6216}\u{957F}\u{9488}\u{72B6}\u{6676}\u{7C07} (Bright reddish-orange acicular/prismatic crystals)**\u{3002}
*   **\u{94BC}\u{94C5}\u{77FF} (Wulfenite)**: \u{989C}\u{503C}\u{62C5}\u{5F53}\u{3002}\u{5BFB}\u{627E}**\u{6781}\u{5176}\u{5E73}\u{6574}\u{7684}\u{3001}\u{9EC4}\u{6A59}\u{8272}/\u{7EA2}\u{6A59}\u{8272}\u{7684}\u{65B9}\u{5F62}\u{8584}\u{677F}\u{72B6}\u{6676}\u{4F53} (Square, tabular yellow-orange crystals)**\u{3002}\u{5C31}\u{50CF}\u{4E00}\u{5757}\u{5757}\u{534A}\u{900F}\u{660E}\u{7684}\u{65B9}\u{5F62}\u{6A59}\u{8272}/\u{9EC4}\u{8272}\u{73BB}\u{7483}\u{7247}\u{5207}\u{5728}\u{77F3}\u{5934}\u{4E0A}\u{3002}
*   **\u{94A8}\u{94C5}\u{77FF} (Stolzite)**: \u{4E0E}\u{94BC}\u{94C5}\u{77FF}\u{540C}\u{6676}\u{578B}\u{FF0C}\u{4F46}\u{989C}\u{8272}\u{5F80}\u{5F80}\u{504F}\u{5411}\u{4E8E}\u{5E26}\u{6709}\u{6811}\u{8102}\u{5149}\u{6CFD}\u{7684}\u{9EC4}\u{8910}\u{8272}\u{3001}\u{6A59}\u{8910}\u{8272}\u{751A}\u{81F3}\u{7070}\u{9EC4}\u{8272}\u{3002}
*   **\u{84DD}\u{94DC}\u{77FE} / \u{80C6}\u{77FE} (Chalcanthite)**: \u{62E5}\u{6709}**\u{65E0}\u{6CD5}\u{76F4}\u{89C6}\u{7684}\u{3001}\u{6781}\u{5EA6}\u{9C9C}\u{8273}\u{7684}\u{4EAE}\u{84DD}\u{8272}/\u{7535}\u{84DD}\u{8272} (Electric blue/Vivid Blue)**\u{3002}\u{901A}\u{5E38}\u{662F}\u{6C34}\u{6EB6}\u{6027}\u{7684}\u{6B21}\u{751F}\u{7ED3}\u{6676}\u{FF0C}\u{5982}\u{540C}\u{5927}\u{5757}\u{7684}\u{84DD}\u{8272}\u{51B0}\u{7CD6}\u{3002}
*   **\u{9752}\u{94C5}\u{77FF} (Linarite)**: \u{5BFB}\u{627E}**\u{540C}\u{6837}\u{662F}\u{6DF1}\u{9083}\u{6781}\u{81F4}\u{7684}\u{5B54}\u{96C0}\u{84DD}\u{8272}/\u{6D77}\u{84DD}\u{8272} (Deep azure blue)**\u{FF0C}\u{4F46}\u{5B83}\u{4E0D}\u{50CF}\u{84DD}\u{94DC}\u{77FE}\u{5927}\u{5757}\u{FF0C}\u{5B83}\u{901A}\u{5E38}\u{4EE5}\u{6781}\u{5176}\u{7EC6}\u{5C0F}\u{7684}\u{9488}\u{72B6}\u{3001}\u{957F}\u{677F}\u{72B6}\u{6676}\u{7C07}\u{6216}\u{8F90}\u{5C04}\u{72B6}\u{9644}\u{7740}\u{5728}\u{5176}\u{4ED6}\u{5CA9}\u{77F3}\u{FF08}\u{5E38}\u{4E0E}\u{94C5}\u{94DC}\u{77FF}\u{5E8A}\u{4F34}\u{751F}\u{FF09}\u{8868}\u{9762}\u{FF0C}\u{5E76}\u{4E14}\u{7EDD}\u{4E0D}\u{6EB6}\u{4E8E}\u{6C34}\u{3002}
*   **\u{7279}\u{6B8A}\u{7684}\u{7EFF}\u{94DC}\u{7EC4}\u{5408}**:
    *   **\u{5757}\u{94DC}\u{77FE} (Antlerite)**: \u{6697}\u{7EFF}\u{8272}\u{5230}\u{7FE0}\u{7EFF}\u{8272}\u{7684}\u{77ED}\u{67F1}\u{72B6}\u{3001}\u{539A}\u{677F}\u{72B6}\u{7ED3}\u{6676}\u{FF0C}\u{5728}\u{5E72}\u{65F1}\u{94DC}\u{6C27}\u{5316}\u{5E26}\u{5E38}\u{89C1}\u{3002}
    *   **\u{4E91}\u{6BCD}\u{94DC}\u{77FF} / \u{53F6}\u{786B}\u{7837}\u{94DC}\u{77F3} (Chalcophyllite)**: \u{6781}\u{5176}\u{534E}\u{4E3D}\u{7684}\u{94DC}\u{7837}\u{77FF}\u{7269}\u{3002}\u{53EA}\u{8981}\u{770B}\u{5230}**\u{201C}\u{6781}\u{5EA6}\u{95EA}\u{4EAE}\u{7684}\u{7FE0}\u{7EFF}\u{8272}/\u{6D77}\u{7EFF}\u{8272}\u{FF0C}\u{5448}\u{516D}\u{8FB9}\u{5F62}\u{3001}\u{5982}\u{540C}\u{4E91}\u{6BCD}\u{4E00}\u{6837}\u{5C42}\u{5C42}\u{53E0}\u{53E0}\u{7684}\u{6781}\u{8584}\u{9CDE}\u{7247}\u{72B6}\u{6676}\u{4F53}\u{201D}**\u{FF0C}\u{90A3}\u{662F}\u{4E91}\u{6BCD}\u{94DC}\u{77FF}\u{7EDD}\u{5BF9}\u{7279}\u{5F81}\u{3002}
    *   **\u{9488}\u{7EFF}\u{77FE} (Botryogen \u{7B49}\u{7C7B}\u{7FA4})**: \u{901A}\u{5E38}\u{5448}\u{73B0}\u{9C9C}\u{8273}\u{7684}\u{6A59}\u{7EA2}\u{8272}\u{3001}\u{6697}\u{7EA2}\u{6216}\u{9EC4}\u{8910}\u{8272}\u{7684}\u{9488}\u{72B6}/\u{653E}\u{5C04}\u{72B6}\u{6676}\u{4F53}\u{7ED3}\u{7C07}\u{FF0C}\u{56E0}\u{5BCC}\u{542B}\u{94C1}/\u{9541}\u{7684}\u{786B}\u{9178}\u{76D0}\u{5728}\u{98CE}\u{5316}\u{5E26}\u{6781}\u{6613}\u{5F62}\u{6210}\u{590D}\u{6742}\u{4E14}\u{989C}\u{8272}\u{602A}\u{5F02}\u{7684}\u{6BDB}\u{53D1}\u{72B6}\u{6DF7}\u{53E0}\u{7269}\u{3002}

[7.3 \u{94A8}\u{4E0E}\u{94BC}\u{7684}\u{91CD}\u{91D1}\u{5C5E}\u{6838}\u{5FC3}\u{5708} (The Heavy Molybdates & Tungstates)]
*   **\u{9ED1}\u{94A8}\u{77FF} (Wolframite)**: \u{94A8}\u{7684}\u{6700}\u{91CD}\u{8981}\u{77FF}\u{77F3}\u{3002}\u{6781}\u{91CD}\u{3002}\u{770B}\u{4E0A}\u{53BB}\u{5C31}\u{50CF}\u{662F}**\u{9ED1}\u{8910}\u{8272}\u{5230}\u{6697}\u{9ED1}\u{8272}\u{7684}\u{539A}\u{91CD}\u{677F}\u{6761} (Dark grey/black tabular/bladed heavy crystals)**\u{FF0C}\u{5177}\u{6709}\u{5355}\u{5411}\u{6781}\u{5B8C}\u{7F8E}\u{7684}\u{89E3}\u{7406}\u{FF0C}\u{95EA}\u{8000}\u{7740}\u{534A}\u{91D1}\u{5C5E}\u{81F3}\u{6811}\u{8102}\u{5149}\u{6CFD}\u{3002}\u{5E38}\u{5728}\u{77F3}\u{82F1}\u{8109}\u{4E2D}\u{3002}
*   **\u{94A8}\u{9530}\u{77FF} (H\xfcbnerite)**: \u{9ED1}\u{94A8}\u{77FF}\u{7684}\u{201C}\u{7EA2}\u{8272}\u{201D}\u{7AEF}\u{5143}\u{53D8}\u{79CD}\u{3002}\u{5982}\u{679C}\u{90A3}\u{79CD}\u{91CD}\u{91D1}\u{5C5E}\u{677F}\u{72B6}\u{6676}\u{4F53}\u{5448}\u{73B0}\u{51FA}**\u{660E}\u{663E}\u{7684}\u{7EA2}\u{8910}\u{8272}\u{3001}\u{4E14}\u{5E38}\u{5E38}\u{5448}\u{534A}\u{900F}\u{660E}\u{7684}\u{7D27}\u{5BC6}\u{957F}\u{67F1}\u{72B6}\u{6216}\u{653E}\u{5C04}\u{72B6}\u{675F}**\u{FF0C}\u{90A3}\u{5C31}\u{662F}\u{94A8}\u{9530}\u{77FF}\u{3002}
*   **\u{767D}\u{94A8}\u{77FF} (Scheelite)**: \u{5E38}\u{4E3A}\u{6D45}\u{9EC4}\u{8272}\u{3001}\u{767D}\u{8272}\u{81F3}\u{68D5}\u{8910}\u{8272}\u{3002}\u{5BFB}\u{627E}**\u{50CF}\u{4E24}\u{4E2A}\u{91D1}\u{5B57}\u{5854}\u{5E95}\u{5BF9}\u{5E95}\u{5E73}\u{62FC}\u{8D77}\u{6765}\u{7684}\u{53CC}\u{9525}\u{4F53} (Bipyramidal pseudo-octahedral crystals)**\u{3002}\u{6CB9}\u{8102}\u{5149}\u{6CFD}\u{6781}\u{5F3A}\u{3002}
*   **\u{94C1}\u{94BC}\u{534E} / \u{6C34}\u{94BC}\u{94C1}\u{77FF} (Ferrimolybdite)**: \u{8F89}\u{94BC}\u{77FF}\u{7684}\u{6B21}\u{751F}\u{98CE}\u{5316}\u{5265}\u{843D}\u{7269}\u{3002}\u{603B}\u{662F}\u{5448}\u{73B0}\u{4E3A}**\u{6DE1}\u{9EC4}\u{8272}\u{3001}\u{786B}\u{78FA}\u{8272}\u{3001}\u{91D1}\u{9EC4}\u{8272}\u{7684}\u{7C89}\u{672B}\u{72B6}\u{3001}\u{571F}\u{72B6}\u{751A}\u{81F3}\u{6781}\u{7EC6}\u{7684}\u{653E}\u{5C04}\u{72B6}\u{7EA4}\u{7EF4}\u{76AE}\u{58F3} (Pale yellow earthy or fine fibrous crusts/coatings)**\u{FF0C}\u{901A}\u{5E38}\u{50CF}\u{9EC4}\u{8272}\u{9508}\u{6591}\u{4E00}\u{6837}\u{5305}\u{88F9}\u{7740}\u{5CA9}\u{77F3}\u{3002}

[7.4 \u{8680}\u{53D8}\u{5E26}\u{7684}\u{590D}\u{6742}\u{786B}\u{9178}\u{76D0}]
*   **\u{660E}\u{77FE}\u{77F3} (Alunite)**: \u{70ED}\u{6DB2}\u{5F3A}\u{9178}\u{6027}\u{8680}\u{53D8}\u{7684}\u{4EA7}\u{7269}\u{3002}\u{901A}\u{5E38}\u{5448}\u{767D}\u{3001}\u{7070}\u{767D}\u{751A}\u{81F3}\u{5E26}\u{6709}\u{5FAE}\u{7EA2}\u{8272}\u{7684}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{6216}\u{571F}\u{72B6}\u{3002}\u{867D}\u{7136}\u{4E5F}\u{4F1A}\u{6709}\u{7EC6}\u{5C0F}\u{7684}\u{83F1}\u{9762}\u{4F53}\u{6676}\u{4F53}\u{FF0C}\u{4F46}\u{8FD9}\u{5757}\u{77F3}\u{5934}\u{8214}\u{8D77}\u{6765}\u{5982}\u{679C}\u{6709}\u{660E}\u{663E}\u{7684}\u{6DA9}\u{9178}\u{5473}\u{FF0C}\u{5E76}\u{4E14}\u{5904}\u{4E8E}\u{706B}\u{6210}\u{5CA9}\u{98CE}\u{5316}\u{5E26}\u{FF0C}\u{4F18}\u{5148}\u{6307}\u{5411}\u{660E}\u{77FE}\u{77F3}\u{3002}
`,
    diagnosticTests: `
- \u{9762}\u{5BF9}\u{677F}\u{72B6}\u{6676}\u{4F53}\u{FF1A}\u{5982}\u{679C}\u{662F}\u{5929}\u{84DD}\u{8272}\u{FF0C}\u{662F}\u{5929}\u{9752}\u{77F3}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{7EAF}\u{767D}/\u{6D45}\u{9EC4}/\u{6781}\u{91CD}\u{FF0C}\u{662F}\u{91CD}\u{6676}\u{77F3}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{6781}\u{900F}\u{660E}\u{5E76}\u{4E14}\u{6781}\u{8F6F}\u{FF08}\u{6307}\u{7532}\u{523B}\u{52A8}\u{FF09}\u{FF0C}\u{662F}\u{900F}\u{77F3}\u{818F}\u{3002}
- \u{770B}\u{5230}\u{5448}\u{73B0}\u{5927}\u{9762}\u{79EF}\u{7C89}\u{7EA2}\u{8272}/\u{8089}\u{7EA2}\u{8272}\u{7684}\u{81F4}\u{5BC6}\u{5757}\u{72B6}\u{76D0}\u{7C7B}\u{FF0C}\u{9996}\u{5148}\u{8003}\u{8651}\u{6742}\u{5364}\u{77F3} (Polyhalite)\u{3002}
- \u{5982}\u{679C}\u{4E00}\u{5757}\u{8584}\u{677F}\u{72B6}\u{7684}\u{6676}\u{4F53}\u{5448}\u{73B0}\u{6781}\u{5176}\u{89C4}\u{6574}\u{7684}\u{201C}\u{6B63}\u{65B9}\u{5F62}\u{201D}\u{FF0C}\u{800C}\u{4E14}\u{662F}\u{6781}\u{4EAE}\u{7684}\u{6A59}\u{9EC4}\u{8272}\u{FF0C}\u{90A3}\u{662F}\u{94BC}\u{94C5}\u{77FF}\u{7684}\u{786C}\u{951A}\u{70B9}\u{3002}
- \u{5982}\u{679C}\u{7ED3}\u{6676}\u{5982}\u{540C}\u{706B}\u{67F4}\u{68CD}\u{822C}\u{5C16}\u{9510}\u{4E14}\u{6709}\u{6781}\u{5EA6}\u{9C9C}\u{4EAE}\u{7684}\u{7EA2}/\u{6A59}\u{7EA2}\u{8272}\u{FF0C}\u{6CA1}\u{6709}\u{7B2C}\u{4E8C}\u{79CD}\u{53EF}\u{80FD}\u{FF0C}\u{7EDD}\u{5BF9}\u{662F}\u{94EC}\u{94C5}\u{77FF}\u{3002}
- \u{5728}\u{6D45}\u{9EC4}\u{8272}\u{77FF}\u{7269}\u{4E2D}\u{5BFB}\u{627E}\u{53CC}\u{9525}\u{4F53}\u{FF08}\u{91D1}\u{5B57}\u{5854}\u{5BF9}\u{63A5}\u{FF09}\u{FF0C}\u{627E}\u{5230}\u{4E86}\u{5C31}\u{80FD}\u{9501}\u{5B9A}\u{767D}\u{94A8}\u{77FF}\u{3002}
- \u{8BC4}\u{4F30}\u{9ED1}\u{8272}/\u{8910}\u{8272}\u{7684}\u{91CD}\u{677F}\u{6761}\u{72B6}\u{77F3}\u{5934}\u{FF0C}\u{89E3}\u{7406}\u{9762}\u{4E0A}\u{95EA}\u{70C1}\u{91D1}\u{5C5E}\u{5230}\u{6811}\u{8102}\u{5149}\u{6CFD}\u{7684}\u{FF0C}\u{4E00}\u{5F8B}\u{5224}\u{5B9A}\u{4E3A}\u{9ED1}\u{94A8}\u{77FF}\u{7CFB}\u{5217} (\u{82E5}\u{662F}\u{660E}\u{663E}\u{504F}\u{7EA2}\u{8910}\u{8272}\u{5219}\u{662F}\u{94A8}\u{9530}\u{77FF})\u{3002}
- \u{5224}\u{65AD}\u{84DD}\u{8272}\u{7684}\u{94DC}\u{77FF}\u{FF1A}\u{5982}\u{50CF}\u{5927}\u{5757}\u{5E26}\u{68F1}\u{89D2}\u{7684}\u{5DE5}\u{4E1A}\u{4EAE}\u{84DD}\u{51B0}\u{7CD6}\u{FF0C}\u{662F}\u{84DD}\u{94DC}\u{77FE}\u{FF1B}\u{5982}\u{679C}\u{7D27}\u{5BC6}\u{5982}\u{84DD}\u{94DC}\u{77FF}\u{FF0C}\u{5448}\u{73B0}\u{9488}\u{72B6}\u{6676}\u{7C07}\u{7684}\u{6D77}\u{84DD}\u{8272}\u{FF0C}\u{662F}\u{9752}\u{94C5}\u{77FF}\u{3002}
`
};


const $bad72233d3c6e68d$export$2bde204170d04029 = {
    description: "Tectosilicates (Framework Silicates) Identification Rules - Quartz, Feldspars, Feldspathoids, and Zeolites",
    coreRules: `
=== \u{7845}\u{9178}\u{76D0}\u{4E4B}\u{67B6}\u{72B6}\u{7845}\u{9178}\u{76D0}\u{9274}\u{5B9A}\u{6CD5}\u{5219} (Tectosilicates / Framework Silicates Protocol) ===

\u{8FD9}\u{662F}\u{5730}\u{58F3}\u{4E2D}\u{4E30}\u{5EA6}\u{6700}\u{9AD8}\u{3001}\u{7EDF}\u{6CBB}\u{7740}\u{6240}\u{6709}\u{5CA9}\u{77F3}\u{5708}\u{FF08}\u{706B}\u{6210}\u{5CA9}\u{3001}\u{6C89}\u{79EF}\u{5CA9}\u{3001}\u{53D8}\u{8D28}\u{5CA9}\u{FF09}\u{7684}\u{7EDD}\u{5BF9}\u{9738}\u{4E3B}\u{3002}\u{5B83}\u{4EEC}\u{7684}\u{7845}\u{6C27}\u{56DB}\u{9762}\u{4F53}\u{901A}\u{8FC7}\u{5171}\u{4EAB}\u{6240}\u{6709}\u{7684}\u{6C27}\u{539F}\u{5B50}\u{FF0C}\u{5F62}\u{6210}\u{4E86}\u{4E00}\u{4E2A}\u{4E09}\u{7EF4}\u{7684}\u{7ACB}\u{4F53}\u{7F51}\u{7EDC}\u{3002}\u{8FD9}\u{4E00}\u{7AE0}\u{662F}\u{77FF}\u{7269}\u{9274}\u{5B9A}\u{7684}\u{201C}\u{7EC8}\u{6781}Boss\u{6218}\u{201D}\u{3002}

[14.1 \u{7EDD}\u{5BF9}\u{7684}\u{786C}\u{5EA6}\u{4E0E}\u{65AD}\u{53E3}\u{FF1A}\u{77F3}\u{82F1}\u{5BB6}\u{65CF} (The Quartz Family)]
\u{77F3}\u{82F1} (Quartz) \u{662F}\u{5730}\u{58F3}\u{4E2D}\u{6700}\u{5E38}\u{89C1}\u{7684}\u{77FF}\u{7269}\u{4E4B}\u{4E00}\u{3002}\u{5B83}\u{7684}\u{9274}\u{5B9A}\u{951A}\u{70B9}\u{662F}\u{7EDD}\u{5BF9}\u{7684}\u{FF1A}
*   **\u{7EDD}\u{6740}\u{7269}\u{7406}\u{951A}\u{70B9}**: \u{83AB}\u{6C0F}\u{786C}\u{5EA6}\u{4E3A} 7 (\u{8F7B}\u{677E}\u{523B}\u{5212}\u{73BB}\u{7483}\u{548C}\u{94A2}\u{5200})\u{3002}**\u{6CA1}\u{6709}\u{89E3}\u{7406} (No cleavage)**\u{3002}
*   **\u{89C6}\u{89C9}\u{7EDD}\u{6740}**: \u{5F53}\u{5B83}\u{7834}\u{88C2}\u{65F6}\u{FF0C}\u{6C38}\u{8FDC}\u{5448}\u{73B0}\u{5178}\u{578B}\u{7684}**\u{8D1D}\u{58F3}\u{72B6}\u{65AD}\u{53E3} (conchoidal fracture)**\u{FF0C}\u{5C31}\u{50CF}\u{6572}\u{788E}\u{4E00}\u{5757}\u{539A}\u{73BB}\u{7483}\u{7684}\u{8FB9}\u{7F18}\u{3002}\u{6676}\u{4F53}\u{5982}\u{679C}\u{5B8C}\u{597D}\u{FF0C}\u{5FC5}\u{662F}**\u{516D}\u{65B9}\u{67F1}\u{72B6}\u{FF0C}\u{9876}\u{7AEF}\u{5E26}\u{6709}\u{91D1}\u{5B57}\u{5854}\u{5F62}\u{7684}\u{9525}\u{9762}**\u{FF0C}\u{6676}\u{9762}\u{5E38}\u{5E38}\u{6709}\u{6A2A}\u{5411}\u{6761}\u{7EB9}\u{3002}
*   **\u{56FE}\u{4E2D}\u{5C55}\u{793A}**: \u{4E00}\u{5757}\u{5178}\u{578B}\u{7684}\u{65E0}\u{8272}\u{900F}\u{660E}/\u{534A}\u{900F}\u{660E}\u{7684}\u{77F3}\u{82F1}\u{5757}\u{4F53}\u{FF0C}\u{5C55}\u{793A}\u{51FA}\u{73BB}\u{7483}\u{5149}\u{6CFD}\u{548C}\u{90A3}\u{79CD}\u{4E0D}\u{89C4}\u{5219}\u{7684}\u{3001}\u{5E26}\u{6709}\u{8D1D}\u{58F3}\u{72B6}\u{8D77}\u{4F0F}\u{7684}\u{65AD}\u{53E3}\u{3002}

[14.2 \u{7EDF}\u{6CBB}\u{5730}\u{58F3}\u{7684}\u{53CC}\u{5B50}\u{661F}\u{FF1A}\u{957F}\u{77F3}\u{5BB6}\u{65CF} (The Feldspar Group)]
\u{5360}\u{636E}\u{4E86}\u{5730}\u{58F3}\u{91CD}\u{91CF}\u{7684}\u{8FD1}60%\u{3002}\u{6240}\u{6709}\u{7684}\u{957F}\u{77F3}\u{90FD}\u{6709}\u{4E24}\u{7EC4}\u{8FD1}\u{4E4E}\u{6B63}\u{4EA4}\u{FF08}90\u{5EA6}\u{FF09}\u{6216}\u{659C}\u{4EA4}\u{7684}\u{89E3}\u{7406}\u{FF0C}\u{786C}\u{5EA6}\u{4E3A} 6\u{FF08}\u{80FD}\u{5212}\u{73BB}\u{7483}\u{FF0C}\u{4F46}\u{5212}\u{4E0D}\u{8FC7}\u{77F3}\u{82F1}\u{FF09}\u{3002}\u{5B83}\u{4EEC}\u{88AB}\u{5206}\u{4E3A}\u{4E24}\u{5927}\u{9635}\u{8425}\u{FF1A}

*   **\u{9635}\u{8425} A: \u{78B1}\u{6027}\u{957F}\u{77F3} (Alkali Feldspars / K-Feldspars)** (\u{5BCC}\u{94BE}\u{94A0})
    *   **\u{6B63}\u{957F}\u{77F3} (Orthoclase)**: \u{5355}\u{659C}\u{6676}\u{7CFB}\u{3002}**\u{89E3}\u{7406}\u{9762}\u{5939}\u{89D2}\u{7EDD}\u{5BF9}\u{7B49}\u{4E8E} 90\xb0 (Right angle)**\u{3002}\u{5E38}\u{89C1}\u{7684}\u{8089}\u{7EA2}\u{8272}\u{3001}\u{7C89}\u{7EA2}\u{8272}\u{5230}\u{767D}\u{8272}/\u{7070}\u{8272}\u{5757}\u{4F53}\u{3002}\u{5E38}\u{5E38}\u{5448}\u{73B0}\u{5361}\u{65AF}\u{5DF4}\u{53CC}\u{6676}\u{FF08}\u{6676}\u{4F53}\u{4E2D}\u{95F4}\u{50CF}\u{88AB}\u{4E00}\u{5200}\u{5207}\u{5F00}\u{FF0C}\u{4E24}\u{8FB9}\u{53CD}\u{5149}\u{4E0D}\u{540C}\u{FF09}\u{3002}
    *   **\u{5FAE}\u{659C}\u{957F}\u{77F3} (Microcline)**: \u{4E09}\u{659C}\u{6676}\u{7CFB}\u{3002}**\u{89E3}\u{7406}\u{9762}\u{5939}\u{89D2}\u{63A5}\u{8FD1} 90\xb0 (89\xb030')**\u{3002}
        *   **\u{5929}\u{6CB3}\u{77F3}\u{53D8}\u{79CD} (Amazonite)**: \u{4F60}\u{7684}\u{56FE}\u{91CC}\u{6700}\u{4EAE}\u{773C}\u{7684}\u{4E00}\u{4E2A}\u{FF01}\u{5BFB}\u{627E}**\u{6781}\u{5176}\u{72EC}\u{7279}\u{7684}\u{84DD}\u{7EFF}\u{8272}\u{3001}\u{77E5}\u{66F4}\u{9E1F}\u{86CB}\u{84DD} (teal, blue-green, robin's egg blue)**\u{FF0C}\u{4E14}\u{5E38}\u{5E38}\u{5E26}\u{6709}\u{767D}\u{8272}\u{7F51}\u{72B6}\u{7684}\u{94A0}\u{957F}\u{77F3}\u{6761}\u{7EB9}\u{3002}
    *   **\u{900F}\u{957F}\u{77F3} (Sanidine)**: \u{9AD8}\u{6E29}\u{6591}\u{6676}\u{FF0C}\u{5E38}\u{89C1}\u{4E8E}\u{6D41}\u{7EB9}\u{5CA9}\u{8FD9}\u{79CD}\u{9178}\u{6027}\u{706B}\u{5C71}\u{5CA9}\u{4E2D}\u{FF0C}\u{5E38}\u{5E38}\u{662F}\u{65E0}\u{8272}\u{900F}\u{660E}\u{5230}\u{767D}\u{8272}\u{7684}\u{677F}\u{72B6}\u{6676}\u{4F53}\u{3002}
    *   **\u{6761}\u{7EB9}\u{957F}\u{77F3} (Perthite)**: \u{5F53}\u{94BE}\u{957F}\u{77F3}\u{548C}\u{94A0}\u{957F}\u{77F3}\u{5728}\u{51B7}\u{5374}\u{65F6}\u{53D1}\u{751F}\u{79BB}\u{6EB6}\u{FF0C}\u{4F1A}\u{5728}\u{94BE}\u{957F}\u{77F3}\u{5E95}\u{677F}\u{4E0A}\u{6790}\u{51FA}\u{8089}\u{773C}\u{53EF}\u{89C1}\u{7684}**\u{4E0D}\u{89C4}\u{5219}\u{7684}\u{5E73}\u{884C}/\u{4EA4}\u{9519}\u{7684}\u{94A0}\u{957F}\u{77F3}\u{767D}\u{8272}\u{6761}\u{5E26}\u{6216}\u{7EBF}\u{72B6}\u{7EB9}\u{7406} (exsolution lamellae)**\u{FF0C}\u{8FD9}\u{662F}\u{5B83}\u{7684}\u{7EDD}\u{6740}\u{7279}\u{5F81}\u{3002}

*   **\u{9635}\u{8425} B: \u{659C}\u{957F}\u{77F3}\u{7CFB}\u{5217} (Plagioclase Feldspars)** (\u{5BCC}\u{94A0}\u{9499}\u{8FDE}\u{7EED}\u{56FA}\u{6EB6}\u{4F53})
    *   **\u{7EDD}\u{6740}\u{951A}\u{70B9}**: \u{6240}\u{6709}\u{7684}\u{659C}\u{957F}\u{77F3}\u{5728}\u{5B83}\u{7684}\u{4E00}\u{4E2A}\u{89E3}\u{7406}\u{9762}\u{4E0A}\u{FF0C}\u{7528}\u{653E}\u{5927}\u{955C}\u{603B}\u{80FD}\u{770B}\u{5230}**\u{5E73}\u{884C}\u{7684}\u{3001}\u{50CF}\u{5934}\u{53D1}\u{4E1D}\u{4E00}\u{6837}\u{7EC6}\u{5BC6}\u{7684}\u{201C}\u{805A}\u{7247}\u{53CC}\u{6676}\u{7EB9}\u{201D} (polysynthetic twinning striations)**\u{3002}\u{8FD9}\u{662F}\u{533A}\u{5206}\u{5B83}\u{4EEC}\u{548C}\u{78B1}\u{6027}\u{957F}\u{77F3}\u{7684}\u{7EC8}\u{6781}\u{6CD5}\u{5219}\u{3002}
    *   **\u{94A0}\u{957F}\u{77F3} (Albite)**: \u{7AEF}\u{5458}\u{77FF}\u{7269}\u{FF0C}\u{7EAF}\u{767D}\u{8272}\u{FF0C}\u{50CF}\u{767D}\u{7CD6}\u{5757}\u{6216}\u{8005}\u{74F7}\u{5668}\u{3002}
    *   **\u{5965}\u{957F}\u{77F3} (Oligoclase)**: \u{5305}\u{62EC}\u{8457}\u{540D}\u{7684}**\u{65E5}\u{957F}\u{77F3} (Sunstone)**\u{3002}\u{5BFB}\u{627E}\u{5728}\u{7EA2}\u{8910}\u{8272}/\u{6A59}\u{8272}\u{957F}\u{77F3}\u{57FA}\u{5E95}\u{4E0A}\u{FF0C}\u{56E0}\u{4E3A}\u{5185}\u{90E8}\u{542B}\u{6709}\u{8D64}\u{94C1}\u{77FF}\u{6216}\u{81EA}\u{7136}\u{94DC}\u{8584}\u{7247}\u{800C}\u{95EA}\u{70C1}\u{7740}**\u{91D1}\u{8272}/\u{7EA2}\u{8272}\u{95EA}\u{5149} (aventurescence/schiller effect)** \u{7684}\u{6807}\u{672C}\u{3002}
    *   **\u{4E2D}\u{957F}\u{77F3} (Andesine)** & **\u{62C9}\u{957F}\u{77F3} (Labradorite)**:
        *   **\u{62C9}\u{957F}\u{77F3}\u{7EDD}\u{6740}**: \u{5F53}\u{4F60}\u{5728}\u{4E0D}\u{540C}\u{89D2}\u{5EA6}\u{8F6C}\u{52A8}\u{4E00}\u{5757}\u{7070}\u{9ED1}\u{8272}/\u{6697}\u{8272}\u{7684}\u{62C9}\u{957F}\u{77F3}\u{65F6}\u{FF0C}\u{5B83}\u{4F1A}\u{7A81}\u{7136}\u{95EA}\u{73B0}\u{51FA}**\u{6781}\u{5176}\u{7EDA}\u{4E3D}\u{7684}\u{84DD}\u{8272}\u{3001}\u{7EFF}\u{8272}\u{3001}\u{9EC4}\u{8272}\u{751A}\u{81F3}\u{7D2B}\u{8272}\u{7684}\u{6E38}\u{5F69}/\u{6655}\u{5F69} (Labradorescence/Schiller effect)**\u{FF0C}\u{5982}\u{540C}\u{6781}\u{5149}\u{4E00}\u{822C}\u{3002}\u{4F60}\u{7684}\u{62C9}\u{957F}\u{77F3}\u{914D}\u{56FE}\u{5B8C}\u{7F8E}\u{5C55}\u{793A}\u{4E86}\u{5E26}\u{6709}\u{84DD}\u{7EFF}\u{8272}\u{53D8}\u{5F69}\u{7684}\u{89E3}\u{7406}\u{9762}\u{3002}
    *   **\u{57F9}\u{957F}\u{77F3} (Bytownite)** & **\u{9499}\u{957F}\u{77F3} (Anorthite)**: \u{57FA}\u{6027}\u{5CA9}\u{FF08}\u{8F89}\u{957F}\u{5CA9}\u{3001}\u{7384}\u{6B66}\u{5CA9}\u{FF09}\u{4E2D}\u{7684}\u{5E38}\u{5BA2}\u{FF0C}\u{989C}\u{8272}\u{504F}\u{6DF1}\u{7070}\u{5230}\u{5E26}\u{6D45}\u{7EFF}\u{7070}\u{8272}\u{3002}\u{56FE}\u{7247}\u{5C55}\u{793A}\u{4E86}\u{5178}\u{578B}\u{7684}\u{6697}\u{8272}\u{8C03}\u{4E2D}\u{504F}\u{7EFF}\u{7684}\u{9499}\u{957F}\u{77F3}\u{6807}\u{672C}\u{3002}

*   **\u{6B6A}\u{957F}\u{77F3} (Anorthoclase)**: \u{4ECB}\u{4E8E}\u{78B1}\u{6027}\u{957F}\u{77F3}\u{548C}\u{659C}\u{957F}\u{77F3}\u{4E4B}\u{95F4}\u{7684}\u{7279}\u{6B8A}\u{9AD8}\u{6E29}\u{53D8}\u{79CD}\u{3002}\u{5916}\u{89C2}\u{901A}\u{5E38}\u{5448}\u{81F4}\u{5BC6}\u{7684}\u{6697}\u{7070}\u{8272}\u{3001}\u{9ED1}\u{8910}\u{8272}\u{FF0C}\u{5E38}\u{89C1}\u{4E8E}\u{5BCC}\u{94A0}\u{7684}\u{706B}\u{5C71}\u{5CA9}\u{4E2D}\u{FF08}\u{5982}\u{56FE}\u{6240}\u{793A}\u{FF09}\u{3002}

[14.3 \u{957F}\u{77F3}\u{7684}\u{201C}\u{8425}\u{517B}\u{4E0D}\u{826F}\u{201D}\u{4EB2}\u{621A}\u{FF1A}\u{4F3C}\u{957F}\u{77F3}\u{65CF} (Feldspathoids)]
\u{8FD9}\u{662F}\u{4E00}\u{7FA4}\u{201C}\u{751F}\u{4E0D}\u{9022}\u{65F6}\u{201D}\u{7684}\u{77FF}\u{7269}\u{3002}\u{5B83}\u{4EEC}\u{751F}\u{957F}\u{5728}\u{4E8C}\u{6C27}\u{5316}\u{7845}\u{6781}\u{5EA6}\u{532E}\u{4E4F}\u{7684}\u{78B1}\u{6027}\u{5CA9}\u{6D46}\u{91CC}\u{3002}**\u{53EA}\u{8981}\u{5CA9}\u{77F3}\u{91CC}\u{6709}\u{539F}\u{751F}\u{7684}\u{77F3}\u{82F1}\u{FF0C}\u{5C31}\u{7EDD}\u{5BF9}\u{4E0D}\u{53EF}\u{80FD}\u{51FA}\u{73B0}\u{4F3C}\u{957F}\u{77F3}\u{3002}**

*   **\u{971E}\u{77F3} (Nepheline)**: \u{770B}\u{8D77}\u{6765}\u{50CF}\u{77F3}\u{82F1}\u{6216}\u{8005}\u{892A}\u{8272}\u{53D1}\u{7070}\u{7684}\u{957F}\u{77F3}\u{FF0C}\u{4F46}\u{5B83}**\u{5E26}\u{6709}\u{5F3A}\u{70C8}\u{7684}\u{6CB9}\u{8102}\u{5149}\u{6CFD} (greasy luster)**\u{FF0C}\u{6BD4}\u{77F3}\u{82F1}\u{8F6F}\u{FF08}\u{786C}\u{5EA6}5.5-6\u{FF09}\u{FF0C}\u{4E14}\u{9047}\u{9178}\u{4F1A}\u{80F6}\u{51DD}\u{5316}\u{3002}\u{56FE}\u{4E2D}\u{7684}\u{5757}\u{4F53}\u{5448}\u{73B0}\u{7070}\u{767D}\u{8272}\u{5E26}\u{70B9}\u{5FAE}\u{5C0F}\u{5B54}\u{6D1E}\u{548C}\u{6697}\u{8272}\u{6742}\u{8D28}\u{3002}
*   **\u{767D}\u{69B4}\u{77F3} (Leucite)**: \u{7EF4}\u{82CF}\u{5A01}\u{706B}\u{5C71}\u{5CA9}\u{77F3}\u{7684}\u{6807}\u{5FD7}\u{3002}\u{5BFB}\u{627E}\u{5728}\u{7070}\u{8272}\u{706B}\u{5C71}\u{5CA9}\u{57FA}\u{8D28}\u{4E2D}\u{FF0C}\u{51F8}\u{663E}\u{51FA}\u{6765}\u{7684}**\u{6781}\u{5176}\u{5B8C}\u{7F8E}\u{7684}\u{7070}\u{767D}\u{8272}\u{591A}\u{9762}\u{4F53}\u{6676}\u{4F53} (typically forms perfect trapezohedrons\u{FF0C}\u{50CF}\u{4E00}\u{4E2A}\u{4E2A}\u{5C0F}\u{591A}\u{8FB9}\u{5F62}\u{8DB3}\u{7403})**\u{3002}
*   **\u{9752}\u{91D1}\u{77F3} (Lapis Lazuli / Lazurite)**: \u{5343}\u{5E74}\u{5E1D}\u{738B}\u{4E4B}\u{8272}\u{3002}
    *   **\u{7EDD}\u{6740}\u{951A}\u{70B9}**: \u{5B83}\u{662F}\u{6781}\u{5176}\u{6D53}\u{90C1}\u{7684}**\u{6DF1}\u{84DD}\u{8272}\u{3001}\u{7FA4}\u{9752}\u{8272} (deep blue, ultramarine)**\u{3002}\u{4E14}\u{5FC5}\u{5B9A}\u{4E0E}**\u{91D1}\u{8272}\u{7684}\u{9EC4}\u{94C1}\u{77FF} (Pyrite)**\u{70B9}\u{7F00}\u{3001}\u{4EE5}\u{53CA}**\u{767D}\u{8272}\u{7684}\u{65B9}\u{89E3}\u{77F3} (Calcite)**\u{8109}\u{7EDC}\u{5171}\u{751F}\u{3002}\u{8FD9}\u{662F}\u{533A}\u{5206}\u{5B83}\u{4E0E}\u{84DD}\u{94DC}\u{77FF}\u{3001}\u{65B9}\u{94A0}\u{77F3}\u{7684}\u{6700}\u{6838}\u{5FC3}\u{4F9D}\u{636E}\u{3002}
*   **\u{65B9}\u{94A0}\u{77F3} (Sodalite)**: \u{4E5F}\u{662F}\u{84DD}\u{8272}\u{8C03}\u{3002}
    *   **\u{89C6}\u{89C9}\u{951A}\u{70B9}**: \u{5B83}\u{7684}\u{84DD}\u{8272}\u{901A}\u{5E38}\u{5E26}\u{6709}\u{4E00}\u{70B9}\u{7D2B}\u{8C03}\u{6216}\u{8005}\u{66F4}\u{201C}\u{7C89}\u{201D}\u{4E00}\u{70B9}\u{7684}\u{84DD}\u{FF0C}\u{5E76}\u{4E14}\u{5F80}\u{5F80}\u{4F34}\u{968F}**\u{5927}\u{91CF}\u{7684}\u{767D}\u{8272}\u{8109}\u{5E26}\u{6216}\u{6591}\u{5757} (often with distinct white veining or mottling)**\u{FF0C}**\u{4E14}\u{901A}\u{5E38}\u{6CA1}\u{6709}\u{91D1}\u{8272}\u{7684}\u{9EC4}\u{94C1}\u{77FF}\u{4F34}\u{751F}**\u{3002}\u{FF08}\u{5982}\u{56FE}\u{6240}\u{793A}\u{5178}\u{578B}\u{7684}\u{6DF1}\u{84DD}\u{5E26}\u{767D}\u{7EB9}\u{7406}\u{FF09}\u{3002}

[14.4 \u{6C34}\u{7684}\u{7981}\u{9522}\u{8005}\u{4E0E}\u{5CA9}\u{77F3}\u{7A7A}\u{6D1E}\u{7684}\u{7CBE}\u{7075}\u{FF1A}\u{6CB8}\u{77F3}\u{65CF} (The Zeolite Group)]
\u{8FD9}\u{662F}\u{4E00}\u{7FA4}\u{5305}\u{542B}\u{7740}\u{6781}\u{591A}\u{6C34}\u{5206}\u{5B50}\u{7684}\u{7A7A}\u{65F7}\u{9AA8}\u{67B6}\u{7ED3}\u{6784}\u{77FF}\u{7269}\u{3002}\u{5B83}\u{4EEC}\u{51E0}\u{4E4E}\u{603B}\u{662F}\u{751F}\u{957F}\u{5728}**\u{7384}\u{6B66}\u{5CA9}\u{3001}\u{5B89}\u{5C71}\u{5CA9}\u{7684}\u{674F}\u{4EC1}\u{4F53}\u{FF08}\u{6C14}\u{5B54}\u{FF09}\u{6216}\u{70ED}\u{6DB2}\u{88C2}\u{9699}\u{4E2D}**\u{3002}\u{5B83}\u{4EEC}\u{5E38}\u{5E38}\u{662F}\u{767D}\u{8272}\u{3001}\u{8089}\u{8272}\u{6216}\u{65E0}\u{8272}\u{7684}\u{7ED3}\u{6676}\u{7C07}\u{3002}\u{9047}\u{5230}\u{9178}\u{5BB9}\u{6613}\u{80F6}\u{51DD}\u{5316}\u{6216}\u{6EB6}\u{89E3}\u{3002}\u{7531}\u{4E8E}\u{5B83}\u{4EEC}\u{957F}\u{5F97}\u{6781}\u{5176}\u{76F8}\u{4F3C}\u{FF0C}\u{8FD9}\u{51E0}\u{5341}\u{79CD}\u{6CB8}\u{77F3}\u{5728}\u{91CE}\u{5916}\u{6781}\u{96BE}\u{9760}\u{8089}\u{773C}\u{5B8C}\u{7F8E}\u{533A}\u{5206}\u{FF0C}\u{5F80}\u{5F80}\u{9700}\u{8981}\u{501F}\u{52A9}\u{6676}\u{4F53}\u{5F62}\u{6001}\u{7684}\u{7EC6}\u{5FAE}\u{5DEE}\u{522B}\u{FF1A}

*   **\u{65B9}\u{6CB8}\u{77F3} (Analcime)**: \u{957F}\u{5F97}\u{50CF}\u{767D}\u{69B4}\u{77F3}\u{FF01}\u{5BFB}\u{627E}\u{5728}\u{7384}\u{6B66}\u{5CA9}\u{7A7A}\u{6D1E}\u{4E2D}\u{FF0C}\u{7EAF}\u{767D}\u{8272}\u{6216}\u{65E0}\u{8272}\u{7684}\u{3001}\u{5448}\u{5B8C}\u{7F8E}\u{7684}**\u{56DB}\u{89D2}\u{4E09}\u{516B}\u{9762}\u{4F53} (like a faceted soccer ball, similar to leucite but in a different environment)** \u{6216}\u{7ACB}\u{65B9}\u{5F62}\u{72B6}\u{7684}\u{95EA}\u{4EAE}\u{6676}\u{4F53}\u{4F53}\u{3002}
*   **\u{83F1}\u{6CB8}\u{77F3} (Chabazite)**: \u{5BFB}\u{627E}\u{770B}\u{8D77}\u{6765}\u{50CF}\u{4E00}\u{4E2A}\u{4E2A}\u{7A0D}\u{5FAE}\u{503E}\u{659C}/\u{626D}\u{66F2}\u{7684}\u{7ACB}\u{65B9}\u{4F53}\u{FF08}**\u{83F1}\u{9762}\u{4F53}\u{FF0C}Pseudo-cubic/Rhombohedral crystals**\u{FF09}\u{7C07}\u{751F}\u{5728}\u{4E00}\u{8D77}\u{7684}\u{6676}\u{4F53}\u{FF0C}\u{989C}\u{8272}\u{4ECE}\u{767D}\u{8272}\u{3001}\u{9EC4}\u{8272}\u{5230}\u{8089}\u{7EA2}\u{8272}\u{90FD}\u{6709}\u{3002}
*   **\u{8F89}\u{6CB8}\u{77F3} (Stilbite)**: \u{7EDD}\u{6740}\u{5F62}\u{6001}\u{FF1A}**\u{675F}\u{72B6}\u{6676}\u{4F53} (sheaf-like)**\u{FF01}\u{5B83}\u{4EEC}\u{503E}\u{5411}\u{4E8E}\u{957F}\u{6210}\u{4E24}\u{5934}\u{5BBD}\u{4E2D}\u{95F4}\u{7A84}\u{7684}**\u{50CF}\u{6346}\u{6241}\u{5E73}\u{7684}\u{9EA6}\u{675F}\u{3001}\u{9886}\u{7ED3}\u{72B6} (bowtie shape)**\u{3002}\u{901A}\u{5E38}\u{662F}\u{767D}\u{8272}\u{3001}\u{6216}\u{8005}\u{6709}\u{6781}\u{5438}\u{5F15}\u{4EBA}\u{7684}\u{8089}\u{7C89}\u{8272}\u{3001}\u{9C91}\u{9C7C}\u{7EA2}\u{8272}\u{3002}\u{56FE}\u{4E2D}\u{7684}\u{7C89}\u{8272}\u{7ED3}\u{6676}\u{5C55}\u{793A}\u{4E86}\u{5B83}\u{7684}\u{7ECF}\u{5178}\u{989C}\u{8272}\u{3002}
*   **\u{7247}\u{6CB8}\u{77F3} (Heulandite)**: \u{5E38}\u{5E38}\u{548C}\u{8F89}\u{6CB8}\u{77F3}\u{957F}\u{5728}\u{4E00}\u{8D77}\u{3002}\u{5BFB}\u{627E}\u{5177}\u{6709}**\u{73CD}\u{73E0}\u{5149}\u{6CFD} (pearly luster)** \u{7684}\u{4FA7}\u{9762}\u{FF0C}\u{6676}\u{4F53}\u{5448}\u{73B0}\u{660E}\u{663E}\u{7684}**\u{201C}\u{68FA}\u{6750}\u{72B6}\u{201D} (coffin-shaped)** \u{9762}\u{8C8C}\u{6216}\u{6954}\u{5F62}\u{5757}\u{72B6}\u{3002}
*   **\u{94A0}\u{6CB8}\u{77F3} (Natrolite)**: \u{957F}\u{6210}\u{6781}\u{5176}\u{7EC6}\u{957F}\u{7684}**\u{9488}\u{72B6}\u{3001}\u{6BDB}\u{53D1}\u{72B6}\u{3001}\u{653E}\u{5C04}\u{72B6}\u{7ED3}\u{6676}\u{7C07} (acicular, radiating needles or fibrous masses)**\u{FF0C}\u{50CF}\u{767D}\u{8272}\u{7684}\u{6D77}\u{80C6}\u{6216}\u{5C0F}\u{7ED2}\u{7403}\u{3002}\u{5E38}\u{5E38}\u{586B}\u{6EE1}\u{6574}\u{4E2A}\u{7384}\u{6B66}\u{5CA9}\u{7A7A}\u{6D1E}\u{3002}
*   **\u{91CD}\u{5341}\u{5B57}\u{77F3}/\u{4EA4}\u{6CB8}\u{77F3} (Phillipsite)**: \u{5E38}\u{5448}\u{73B0}\u{767D}/\u{6DE1}\u{9EC4}\u{8272}\u{3002}\u{6807}\u{5FD7}\u{6027}\u{7279}\u{5F81}\u{662F}\u{5176}\u{5E38}\u{5E38}\u{5F62}\u{6210}\u{7A7F}\u{900F}\u{53CC}\u{6676}\u{FF0C}\u{5916}\u{89C2}\u{770B}\u{4F3C}\u{5FAE}\u{5C0F}\u{7684}\u{5341}\u{5B57}\u{5F62}\u{6216}\u{590D}\u{6742}\u{7684}\u{5047}\u{659C}\u{65B9}\u{7ED3}\u{6784}\u{FF0C}\u{7ED3}\u{6676}\u{6781}\u{5176}\u{5FAE}\u{5C0F}\u{7D27}\u{5BC6}\u{3002}
*   **\u{83F1}\u{7070}\u{6CB8}\u{77F3}/\u{6D4A}\u{6CB8}\u{77F3} (Laumontite)**: \u{8FD9}\u{79CD}\u{6CB8}\u{77F3}\u{4E00}\u{8131}\u{6C34}\u{5C31}\u{4F1A}\u{53D8}\u{6210}\u{767D}\u{8272}\u{7684}\u{7C89}\u{672B}\u{6216}\u{8005}\u{53D8}\u{5F97}\u{6781}\u{8106}\u{FF08}\u{7C89}\u{5316}\u{73B0}\u{8C61}\u{FF09}\u{3002}\u{539F}\u{72B6}\u{4E00}\u{822C}\u{5448}\u{767D}\u{8272}\u{68F1}\u{67F1}\u{72B6}\u{3002}\u{56FE}\u{4E2D}\u{5C55}\u{793A}\u{4E86}\u{5B83}\u{50CF}\u{788E}\u{9AA8}\u{5934}\u{4E00}\u{6837}\u{7684}\u{767D}\u{8272}\u{805A}\u{96C6}\u{4F53}\u{3002}
*   **\u{6746}\u{6CB8}\u{77F3} (Thomsonite)** / **\u{6BDB}\u{6CB8}\u{77F3} (Erionite)** \u{7B49}\u{FF1A}\u{901A}\u{5E38}\u{662F}\u{5728}\u{7384}\u{6B66}\u{5CA9}\u{7A7A}\u{6D1E}\u{4E2D}\u{5448}\u{73B0}\u{653E}\u{5C04}\u{72B6}\u{3001}\u{7403}\u{72B6}\u{6216}\u{8005}\u{590D}\u{6742}\u{7684}\u{7EA4}\u{7EF4}\u{72B6}\u{96C6}\u{5408}\u{4F53}\u{3002}\u{4F60}\u{7684}\u{56FE}\u{91CC}\u{5B8C}\u{7F8E}\u{5C55}\u{793A}\u{4E86}\u{591A}\u{6C14}\u{5B54}\u{7384}\u{6B66}\u{5CA9}\u{4E2D}\u{5145}\u{586B}\u{7684}\u{5404}\u{79CD}\u{767D}\u{8272}/\u{5E26}\u{6709}\u{653E}\u{5C04}\u{7EB9}\u{7406}\u{7684}\u{6CB8}\u{77F3}\u{5C0F}\u{7403}\u{FF08}\u{674F}\u{4EC1}\u{6784}\u{9020}\u{FF09}\u{3002}
*   **\u{8D5B}\u{9EC4}\u{6676} (Danburite)**\u{FF1A}\u{867D}\u{7136}\u{540D}\u{5B57}\u{50CF}\u{9EC4}\u{7389}\u{FF0C}\u{4F46}\u{5B83}\u{662F}\u{787C}\u{7845}\u{9178}\u{76D0}\u{3002}\u{8FD9}\u{91CC}\u{4E5F}\u{653E}\u{5728}\u{67B6}\u{72B6}\u{5904}\u{7406}\u{3002}\u{770B}\u{8D77}\u{6765}\u{6781}\u{5176}\u{50CF}\u{9EC4}\u{7389}\u{6216}\u{77F3}\u{82F1}\u{3002}
    *   **\u{9274}\u{5B9A}\u{951A}\u{70B9}**: \u{5B83}\u{7684}\u{6676}\u{4F53}**\u{9876}\u{7AEF}\u{662F}\u{6954}\u{5F62}\u{7684} (wedge-shaped terminations)**\u{FF0C}\u{800C}\u{4E0D}\u{662F}\u{77F3}\u{82F1}\u{90A3}\u{79CD}\u{9525}\u{5F62}\u{5C16}\u{7AEF}\u{3002}\u{4E14}\u{5B83}\u{7684}\u{786C}\u{5EA6}\u{4E3A}7\u{FF0C}\u{89E3}\u{7406}\u{4E0D}\u{660E}\u{663E}\u{FF0C}\u{5E38}\u{5728}\u{77FD}\u{5361}\u{5CA9}\u{4E2D}\u{51FA}\u{73B0}\u{3002}
`
};


// ==========================================
// 🔬 薄片鉴定模块 (Thin Section Optical Mineralogy Module)
// ==========================================
const $ea2d80c108efa255$export$60b2fd0609664cb1 = {
    opticalRules: `
  === \u{1F52C} \u{8584}\u{7247}\u{5149}\u{6027}\u{77FF}\u{7269}\u{5B66}\u{6838}\u{5FC3}\u{6CD5}\u{5219} (Optical Mineralogy Protocol) ===
  **\u{6307}\u{4EE4}\u{FF1A}\u{5F53}\u{8F93}\u{5165}\u{56FE}\u{50CF}\u{4E3A}\u{663E}\u{5FAE}\u{8584}\u{7247} (Thin Section) \u{65F6}\u{FF0C}\u{5FC5}\u{987B}\u{4E25}\u{683C}\u{6267}\u{884C}\u{672C}\u{6A21}\u{5757}\u{7684}\u{903B}\u{8F91}\u{7279}\u{5F81}\u{5339}\u{914D}\u{3002}\u{5FC5}\u{987B}\u{63D0}\u{53D6}\u{5355}\u{504F}\u{5149}(PPL)\u{548C}\u{6B63}\u{4EA4}\u{504F}\u{5149}(XPL)\u{7684}\u{4E13}\u{5C5E}\u{7279}\u{5F81}\u{3002}**

  [1. \u{5173}\u{952E}\u{5149}\u{5B66}\u{5C5E}\u{6027}\u{63D0}\u{53D6}\u{51C6}\u{5219} (PPL & XPL)]
  - \u{5355}\u{504F}\u{5149} (Plane Polarized Light - PPL):
    - \u{989C}\u{8272}\u{4E0E}\u{591A}\u{8272}\u{6027} (Color & Pleochroism): \u{89C2}\u{5BDF}\u{77FF}\u{7269}\u{662F}\u{5426}\u{6709}\u{539F}\u{751F}\u{989C}\u{8272}\u{FF0C}\u{4EE5}\u{53CA}\u{65CB}\u{8F6C}\u{8F7D}\u{7269}\u{53F0}\u{65F6}\u{989C}\u{8272}\u{7684}\u{53D8}\u{5316}\u{FF08}\u{4F8B}\u{5982}\u{9ED1}\u{4E91}\u{6BCD}\u{7684}\u{8910}\u{8272}\u{4E14}\u{591A}\u{8272}\u{6027}\u{5F3A}\u{70C8}\u{FF09}\u{3002}
    - \u{7A81}\u{8D77} (Relief): \u{5224}\u{65AD}\u{77FF}\u{7269}\u{6298}\u{5C04}\u{7387}\u{76F8}\u{5BF9}\u{6811}\u{8102}\u{7684}\u{9AD8}\u{4F4E}\u{FF08}\u{6B63}\u{6781}\u{9AD8}\u{3001}\u{6B63}\u{9AD8}\u{3001}\u{6B63}\u{4E2D}\u{3001}\u{6B63}\u{4F4E}\u{3001}\u{8D1F}\u{7A81}\u{8D77}\u{FF09}\u{3002}
    - \u{89E3}\u{7406} (Cleavage): \u{5BFB}\u{627E}\u{89E3}\u{7406}\u{7F1D}\u{7684}\u{6570}\u{91CF}\u{53CA}\u{4EA4}\u{89D2}\u{FF08}\u{4F8B}\u{5982}\u{FF1A}\u{8F89}\u{77F3}\u{7684}\u{4E24}\u{7EC4}\u{89E3}\u{7406}\u{8FD1}90\u{5EA6}\u{FF0C}\u{89D2}\u{95EA}\u{77F3}\u{7684}\u{4E24}\u{7EC4}\u{89E3}\u{7406}\u{8FD1}120/60\u{5EA6}\u{3002}**\u{5BFB}\u{627E}\u{7279}\u{5F81}\u{6027}\u{7684}\u{6A2A}\u{622A}\u{9762}\u{FF0C}\u{5982}\u{89D2}\u{95EA}\u{77F3}\u{7684}\u{83F1}\u{5F62}/\u{591A}\u{8FB9}\u{5F62}\u{622A}\u{9762}**\u{FF09}\u{3002}
  - \u{6B63}\u{4EA4}\u{504F}\u{5149} (Cross Polarized Light - XPL):
    - \u{5E72}\u{6D89}\u{8272} (Interference Color): \u{5224}\u{5B9A}\u{6700}\u{9AD8}\u{5E72}\u{6D89}\u{8272}\u{7EA7}\u{522B}\u{3002}\u{4F8B}\u{5982}\u{957F}\u{77F3}\u{548C}\u{77F3}\u{82F1}\u{901A}\u{5E38}\u{662F}\u{4E00}\u{7EA7}\u{7070}\u{767D}\u{FF0C}\u{5355}\u{659C}\u{8F89}\u{77F3}\u{53EF}\u{8FBE}\u{4E8C}\u{7EA7}\u{FF0C}\u{6A44}\u{6984}\u{77F3}\u{53EF}\u{8FBE}\u{4E09}\u{7EA7}\u{3002}
    - \u{53CC}\u{6676} (Twinning): \u{7EDD}\u{5BF9}\u{5173}\u{952E}\u{7684}\u{5730}\u{8D28}\u{6D4B}\u{6E29}/\u{5B9A}\u{578B}\u{6807}\u{51C6}\u{3002}
      - \u{659C}\u{957F}\u{77F3}(Plagioclase): \u{5BFB}\u{627E}\u{805A}\u{7247}\u{53CC}\u{6676} (Polysynthetic twinning) \u{5448}\u{73B0}\u{9ED1}\u{767D}\u{76F8}\u{95F4}\u{7684}\u{6761}\u{7EB9}\u{3002}
      - \u{5FAE}\u{659C}\u{957F}\u{77F3}(Microcline): \u{5BFB}\u{627E}\u{683C}\u{5B50}\u{53CC}\u{6676} (Gridiron twinning)\u{3002}
    - \u{6D88}\u{5149}\u{7C7B}\u{578B} (Extinction): \u{5E73}\u{884C}\u{6D88}\u{5149}\u{8FD8}\u{662F}\u{659C}\u{6D88}\u{5149}\u{3002}\u{77F3}\u{82F1}\u{5E38}\u{5448}\u{7279}\u{6B8A}\u{7684}\u{6CE2}\u{72B6}\u{6D88}\u{5149} (Undulatory extinction)\u{3002}

  [2. \u{5E38}\u{89C1}\u{5FAE}\u{89C2}\u{5CA9}\u{7406}\u{6784}\u{9020} (Micro-Textures)]
  - **\u{4FB5}\u{5165}\u{63A5}\u{89E6}\u{8FB9}\u{754C}\u{4E0E}\u{51B7}\u{51DD}\u{8FB9} (Intrusive Contact / Chill Margin)**: \u{8FD9}\u{662F}\u{5CA9}\u{6D46}\u{4FB5}\u{5165}\u{56F4}\u{5CA9} (Country rock) \u{65F6}\u{5F62}\u{6210}\u{7684}\u{7ECF}\u{5178}\u{8FB9}\u{754C}\u{6784}\u{9020}\u{3002}\u{5728}\u{663E}\u{5FAE}\u{955C}\u{4E0B}\u{FF0C}\u{8FD9}\u{79CD}\u{63A5}\u{89E6}\u{9762}\u{901A}\u{5E38}\u{8868}\u{73B0}\u{4E3A}\u{4E00}\u{6761}\u{6E05}\u{6670}\u{3001}\u{7A81}\u{53D8}\u{6216}\u{5448}\u{622A}\u{7136}\u{4E0D}\u{540C}\u{7279}\u{5F81}\u{7684}\u{201C}\u{5206}\u{754C}\u{7EBF}\u{201D}(Sharp boundary)\u{3002}\u{901A}\u{5E38}\u{4E00}\u{4FA7}\u{662F}\u{7ED3}\u{6676}\u{76F8}\u{5BF9}\u{7C97}\u{5927}\u{7684}\u{5CA9}\u{6D46}\u{5CA9}\u{FF0C}\u{53E6}\u{4E00}\u{4FA7}\u{662F}\u{539F}\u{6709}\u{7684}\u{56F4}\u{5CA9}\u{FF08}\u{5982}\u{77F3}\u{82F1}\u{5CA9}\u{6216}\u{5176}\u{5B83}\u{5CA9}\u{77F3}\u{FF09}\u{3002}\u{5728}\u{63A5}\u{89E6}\u{5E26}\u{7531}\u{4E8E}\u{5CA9}\u{6D46}\u{63A5}\u{89E6}\u{51B7}\u{56F4}\u{5CA9}\u{53D1}\u{751F}\u{5FEB}\u{901F}\u{51B7}\u{5374}\u{FF08}**\u{51B7}\u{51DD}\u{8FB9} Chill Margin**\u{FF09}\u{FF0C}\u{7ECF}\u{5E38}\u{4F1A}\u{5728}\u{5206}\u{754C}\u{7EBF}\u{4E0A}\u{6216}\u{9644}\u{8FD1}\u{5927}\u{91CF}\u{5BCC}\u{96C6}/\u{6C89}\u{6DC0}\u{51FA}\u{7EC6}\u{5C0F}\u{7684}**\u{4E0D}\u{900F}\u{660E}\u{77FF}\u{7269} (Opaque minerals\u{FF0C}\u{5982}\u{78C1}\u{94C1}\u{77FF}\u{3001}\u{949B}\u{94C1}\u{77FF}\u{FF0C}\u{5728}XPL\u{548C}PPL\u{4E0B}\u{5747}\u{5448}\u{73B0}\u{5168}\u{9ED1}\u{7684}\u{9897}\u{7C92}/\u{534A}\u{81EA}\u{5F62}\u{6676}\u{4F53})**\u{3002}\u{8FB9}\u{754C}\u{4E24}\u{4FA7}\u{622A}\u{7136}\u{4E0D}\u{540C}\u{7684}\u{7C92}\u{5EA6}\u{3001}\u{77FF}\u{7269}\u{7EC4}\u{5408}\u{4EE5}\u{53CA}\u{8FD9}\u{79CD}\u{5BCC}\u{96C6}\u{5E26}\u{FF0C}\u{6784}\u{6210}\u{4E86}\u{5CA9}\u{6D46}\u{4FB5}\u{5165}\u{6D3B}\u{52A8}\u{7684}\u{76F4}\u{63A5}\u{5FAE}\u{89C2}\u{8BC1}\u{636E}\u{3002}
  - **\u{7247}\u{7406}/\u{5343}\u{679A}\u{72B6}\u{6784}\u{9020}\u{4E0E}\u{5FAE}\u{8936}\u{76B1} (Schistosity/Phyllitic Texture & Microfolding) - \u{7EFF}\u{7247}\u{5CA9} (Greenschist)**: \u{8FD9}\u{662F}\u{533A}\u{57DF}\u{5B9A}\u{5411}\u{53D8}\u{8D28}\u{4F5C}\u{7528}\u{7684}\u{6838}\u{5FC3}\u{5FAE}\u{89C2}\u{6807}\u{5FD7}\u{3002}\u{5728}XPL\u{4E0B}\u{FF0C}\u{80FD}\u{591F}\u{89C2}\u{5BDF}\u{5230}\u{7247}\u{72B6}\u{77FF}\u{7269}\u{FF08}\u{5982}\u{767D}\u{4E91}\u{6BCD}\u{3001}\u{9ED1}\u{4E91}\u{6BCD}\u{3001}\u{7EFF}\u{6CE5}\u{77F3}\u{FF09}\u{3001}\u{67F1}\u{72B6}\u{77FF}\u{7269}\u{FF08}\u{5982}\u{9633}\u{8D77}\u{77F3}\u{FF09}\u{6781}\u{5176}\u{5F3A}\u{70C8}\u{7684}**\u{5B9A}\u{5411}\u{6392}\u{5217} (Foliation/Alignment)**\u{FF0C}\u{5F62}\u{6210}\u{8FDE}\u{7EED}\u{6216}\u{4E0D}\u{8FDE}\u{7EED}\u{7684}\u{6CE2}\u{72B6}\u{6761}\u{5E26}\u{3002}\u{7279}\u{522B}\u{662F}\u{5728}\u{7EFF}\u{7247}\u{5CA9}\u{7B49}\u{4F4E}\u{7EA7}\u{53D8}\u{8D28}\u{5CA9}\u{4E2D}\u{FF0C}\u{8FD9}\u{79CD}\u{6781}\u{5176}\u{81F4}\u{5BC6}\u{7684}\u{5B9A}\u{5411}\u{6392}\u{5217}\u{FF08}\u{7247}\u{7406}\u{FF09}\u{7ECF}\u{5E38}\u{4F34}\u{968F}\u{7740}\u{56E0}\u{6784}\u{9020}\u{5E94}\u{529B}\u{5BFC}\u{81F4}\u{7684}**\u{5FAE}\u{8936}\u{76B1}\u{53D8}\u{5F62} (Microfolding/Crenulation cleavage)**\u{3002}\u{6574}\u{4E2A}\u{8584}\u{7247}\u{89C6}\u{57DF}\u{5728}XPL\u{4E0B}\u{5C55}\u{73B0}\u{51FA}\u{5982}\u{540C}\u{6CE2}\u{6D6A}\u{822C}\u{8D77}\u{4F0F}\u{751A}\u{81F3}\u{53D1}\u{751F}\u{5F3A}\u{70C8}\u{8936}\u{76B1}\u{53D8}\u{5F62}\u{7684}\u{5F69}\u{8272}\u{6761}\u{5E26}\u{FF0C}\u{4EA4}\u{7EC7}\u{7740}\u{4E91}\u{6BCD}\u{7684}\u{9C9C}\u{8273}\u{9AD8}\u{5E72}\u{6D89}\u{8272}\u{3001}\u{7EFF}\u{5E18}\u{77F3}\u{7684}\u{6591}\u{9A73}\u{8272}\u{5F69}\u{4EE5}\u{53CA}\u{77F3}\u{82F1}/\u{94A0}\u{957F}\u{77F3}\u{7684}\u{7070}\u{767D}\u{6761}\u{5E26}\u{FF0C}\u{6784}\u{6210}\u{4E86}\u{6781}\u{5176}\u{7ECF}\u{5178}\u{7684}\u{53D8}\u{8D28}\u{5CA9}\u{52A8}\u{529B}\u{5B66}\u{753B}\u{9762}\u{3002}
  - **\u{706B}\u{5C71}\u{788E}\u{5C51}\u{7ED3}\u{6784} (Pyroclastic Texture) - \u{51DD}\u{7070}\u{5CA9}/\u{706B}\u{5C71}\u{89D2}\u{783E}\u{5CA9} (Tuff/Agglomerate)**: \u{89C2}\u{5BDF}\u{5404}\u{79CD}\u{706B}\u{5C71}\u{788E}\u{5C51}\u{7269}\u{FF08}\u{5982}\u{73BB}\u{5C51}\u{3001}\u{6676}\u{5C51}\u{3001}\u{5CA9}\u{5C51}\u{FF09}\u{6742}\u{4E71}\u{65E0}\u{7AE0}\u{5730}\u{5206}\u{5E03}\u{5728}\u{6781}\u{7EC6}\u{7C92}\u{7684}\u{706B}\u{5C71}\u{7070}\u{51DD}\u{7070}\u{8D28}\u{57FA}\u{8D28}\u{4E2D}\u{3002}\u{5982}\u{679C}\u{662F}\u{96C6}\u{5757}\u{5CA9} (Agglomerate)\u{FF0C}\u{53EF}\u{89C1}\u{8F83}\u{5927}\u{7684}\u{7194}\u{5CA9}\u{788E}\u{5757}\u{FF08}\u{5CA9}\u{5C51}\u{FF0C}\u{5E38}\u{5177}\u{6709}\u{5FAE}\u{6676}\u{6216}\u{6591}\u{72B6}\u{7ED3}\u{6784}\u{FF09}\u{88AB}\u{7EC6}\u{7C92}\u{7684}\u{51DD}\u{7070}\u{8D28}\u{57FA}\u{8D28}\u{5305}\u{88F9}\u{FF0C}\u{788E}\u{7247}\u{8FB9}\u{7F18}\u{5F80}\u{5F80}\u{5448}\u{68F1}\u{89D2}\u{72B6}\u{6216}\u{6D51}\u{5706}\u{72B6}\u{FF0C}\u{5927}\u{5C0F}\u{5206}\u{9009}\u{6781}\u{5DEE}\u{3002}
  - **\u{5806}\u{6676}\u{7ED3}\u{6784} (Cumulate Texture)**: \u{5E38}\u{89C1}\u{4E8E}\u{57FA}\u{6027}-\u{8D85}\u{57FA}\u{6027}\u{5C42}\u{72B6}\u{4FB5}\u{5165}\u{5CA9}\u{3002}\u{89C2}\u{5BDF}\u{65E9}\u{671F}\u{7ED3}\u{6676}\u{7684}\u{81EA}\u{5F62}-\u{534A}\u{81EA}\u{5F62}\u{77FF}\u{7269}\u{FF08}\u{5806}\u{6676}\u{9897}\u{7C92}\u{FF0C}Cumulus crystals\u{FF0C}\u{5982}\u{659C}\u{957F}\u{77F3}\u{3001}\u{8F89}\u{77F3}\u{3001}\u{6A44}\u{6984}\u{77F3}\u{FF09}\u{5728}\u{91CD}\u{529B}\u{7B49}\u{4F5C}\u{7528}\u{4E0B}\u{7D27}\u{5BC6}\u{5806}\u{79EF}\u{FF0C}\u{9897}\u{7C92}\u{4E4B}\u{95F4}\u{76F8}\u{4E92}\u{63A5}\u{89E6}\u{6216}\u{9576}\u{5D4C}\u{FF1B}\u{800C}\u{5B83}\u{4EEC}\u{4E4B}\u{95F4}\u{7684}\u{6781}\u{5C0F}\u{5B54}\u{9699}\u{88AB}\u{665A}\u{671F}\u{7ED3}\u{6676}\u{7684}\u{77FF}\u{7269}\u{FF08}\u{586B}\u{9699}\u{7269}\u{FF0C}Intercumulus minerals\u{FF09}\u{5145}\u{586B}\u{3002}\u{6309}\u{586B}\u{9699}\u{7269}\u{6BD4}\u{4F8B}\u{53EF}\u{5212}\u{5206}\u{4E3A}\u{6B63}\u{5806}\u{6676} (Orthocumulate) \u{548C}\u{9576}\u{5D4C}\u{5806}\u{6676} (Adcumulate) \u{7B49}\u{3002}\u{5728}XPL\u{4E0B}\u{FF0C}\u{8F89}\u{77F3}\u{7684}\u{8273}\u{4E3D}\u{5E72}\u{6D89}\u{8272}\u{4E0E}\u{7D27}\u{5BC6}\u{6392}\u{5217}\u{7684}\u{6761}\u{7EB9}\u{72B6}\u{659C}\u{957F}\u{77F3}\u{FF08}\u{805A}\u{7247}\u{53CC}\u{6676}\u{FF09}\u{5F62}\u{6210}\u{5F3A}\u{70C8}\u{7684}\u{9576}\u{5D4C}\u{62FC}\u{56FE}\u{611F}\u{3002}
  - \u{6591}\u{72B6}\u{7ED3}\u{6784} (Porphyritic): \u{89C2}\u{5BDF}\u{5DE8}\u{5927}\u{7684}\u{6591}\u{6676} (Phenocrysts\u{FF0C}\u{4F8B}\u{5982}\u{5177}\u{6709}\u{73AF}\u{5E26}\u{6784}\u{9020}\u{7684}\u{57FA}\u{6027}\u{659C}\u{957F}\u{77F3}\u{6591}\u{6676}) \u{6F02}\u{6D6E}\u{5728}\u{7EC6}\u{5C0F}\u{7684}\u{57FA}\u{8D28} (Matrix) \u{4E2D}\u{3002}
  - \u{6D41}\u{52A8}/\u{7C97}\u{9762}\u{7ED3}\u{6784} (Flow / Trachytic texture): \u{89C2}\u{5BDF}\u{957F}\u{6761}\u{72B6}\u{6216}\u{677F}\u{6761}\u{72B6}\u{5FAE}\u{6676}\u{957F}\u{77F3} (Microlites) \u{7684}\u{5B9A}\u{5411}\u{6392}\u{5217} (Alignment)\u{FF0C}\u{8FD9}\u{662F}\u{5CA9}\u{6D46}\u{6D41}\u{52A8}\u{51B7}\u{5374}\u{7684}\u{76F4}\u{63A5}\u{5FAE}\u{89C2}\u{8BC1}\u{636E}\u{3002}\u{FF08}**\u{6781}\u{5176}\u{9002}\u{7528}\u{4E8E}\u{7384}\u{6B66}\u{5CA9}\u{3001}\u{5B89}\u{5C71}\u{5CA9}\u{7B49}\u{55B7}\u{51FA}\u{5CA9}**\u{FF09}\u{3002}
  - \u{6C14}\u{5B54}/\u{674F}\u{4EC1}\u{6784}\u{9020}\u{4E0E}\u{5FAE}\u{578B}\u{6676}\u{6D1E} (Vesicular / Amygdaloidal / Microgeode): \u{65E9}\u{671F}\u{5CA9}\u{6D46}\u{6325}\u{53D1}\u{5206}\u{8131}\u{9038}\u{5F62}\u{6210}\u{7684}\u{5706}\u{5F62}\u{7A7A}\u{8154} (\u{6C14}\u{6CE1})\u{FF0C}\u{5982}\u{679C}\u{540E}\u{671F}\u{88AB}\u{6B21}\u{751F}\u{70ED}\u{6DB2}\u{77FF}\u{7269}\u{FF08}\u{5982}\u{65B9}\u{89E3}\u{77F3}\u{3001}\u{7389}\u{9AD3}\u{3001}\u{6CB8}\u{77F3}\u{7B49}\u{FF09}\u{5145}\u{586B}\u{FF0C}\u{5219}\u{5F62}\u{6210}\u{674F}\u{4EC1}\u{6216}\u{5FAE}\u{6676}\u{6D1E}\u{6784}\u{9020}\u{3002}\u{5FAE}\u{578B}\u{6676}\u{6D1E} (Microgeode) \u{7684}\u{5178}\u{578B}\u{7279}\u{5F81}\u{662F}\u{5145}\u{586B}\u{7269}\u{5F80}\u{5F80}\u{4ECE}\u{5B54}\u{58C1}\u{5411}\u{4E2D}\u{5FC3}\u{5448}**\u{653E}\u{5C04}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{7ED3}\u{6676} (Radiating/Acicular growth)** \u{751F}\u{957F}\u{3002}\u{5728}PPL\u{4E0E}XPL\u{7684}\u{53CC}\u{5BF9}\u{6BD4}\u{4E0B}\u{FF0C}\u{4E2D}\u{5FC3}\u{53EF}\u{80FD}\u{5177}\u{6709}\u{6781}\u{9AD8}\u{7684}\u{53CD}\u{5DEE}\u{FF08}\u{5982}\u{5404}\u{5411}\u{540C}\u{6027}\u{7684}\u{7A7A}\u{6D1E}\u{5728}XPL\u{4E0B}\u{5168}\u{9ED1}\u{FF09}\u{FF0C}\u{800C}\u{8FB9}\u{7F18}\u{7684}\u{4E00}\u{73AF}\u{653E}\u{5C04}\u{72B6}\u{6676}\u{4F53}\u{5728}XPL\u{4E0B}\u{663E}\u{73B0}\u{4F4E}\u{5E72}\u{6D89}\u{8272}\u{3002}
  
  [3. \u{7279}\u{5B9A}\u{77FF}\u{7269}\u{4E0E}\u{5CA9}\u{77F3}\u{663E}\u{5FAE}\u{6848}\u{4F8B} (Case Focus)]
  - **\u{77F3}\u{82F1}\u{4E0E}\u{7EFF}\u{5E18}\u{77F3}\u{7684}\u{7ECF}\u{5178}\u{5171}\u{751F} (Quartz & Epidote Assemblage - \u{5982}\u{53D8}\u{8D28}\u{8109}\u{4F53}\u{6216}\u{7EFF}\u{7247}\u{5CA9}\u{76F8})**:
    - **\u{77F3}\u{82F1}\u{7684}\u{7C92}\u{72B6}\u{53D8}\u{6676}\u{7ED3}\u{6784} (Granoblastic Polygonal Texture)**: \u{5728}\u{53D8}\u{8D28}\u{4F5C}\u{7528}\u{FF08}\u{5982}\u{91CD}\u{7ED3}\u{6676}\u{5F62}\u{6210}\u{7684}\u{77F3}\u{82F1}\u{8109}\u{6216}\u{77F3}\u{82F1}\u{5CA9}\u{FF09}\u{4E2D}\u{FF0C}\u{77F3}\u{82F1}\u{5E38}\u{5F62}\u{6210}\u{975E}\u{5E38}\u{5E72}\u{51C0}\u{7684}\u{3001}\u{7B49}\u{7C92}\u{72B6}\u{4E92}\u{4EA4}\u{9576}\u{5D4C}\u{7684}\u{7ED3}\u{6784}\u{3002}\u{5728}\u{7279}\u{5F81}\u{4E0A}\u{FF0C}\u{5728}\u{5355}\u{504F}\u{5149} (PPL) \u{4E0B}\u{FF0C}\u{77F3}\u{82F1}\u{8868}\u{73B0}\u{4E3A}\u{65E0}\u{8272}\u{900F}\u{660E}\u{3001}\u{4E14}**\u{6B63}\u{4F4E}\u{7A81}\u{8D77} (Low positive relief)**\u{FF0C}\u{8868}\u{9762}\u{6781}\u{5176}\u{5149}\u{6ED1}\u{3001}\u{6CA1}\u{6709}\u{89E3}\u{7406}\u{7F1D}\u{FF1B}\u{5728}\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL) \u{4E0B}\u{FF0C}\u{5B83}\u{4EEC}\u{5448}\u{73B0}\u{4E00}\u{7EA7}\u{7070}\u{3001}\u{767D}\u{5230}\u{7EAF}\u{9ED1}\u{FF08}\u{6D88}\u{5149}\u{4F4D}\u{FF09}\u{7684}\u{5E72}\u{6D89}\u{8272}\u{3002}\u{7531}\u{4E8E}\u{957F}\u{671F}\u{7684}\u{91CD}\u{7ED3}\u{6676}\u{FF0C}\u{77F3}\u{82F1}\u{9897}\u{7C92}\u{4EA4}\u{754C}\u{5904}\u{5E38}\u{8D8B}\u{8FD1}\u{4E8E}\u{7EA6}120\u{5EA6}\u{7684}\u{4E09}\u{53C9}\u{6676}\u{754C} (Triple junctions)\u{FF0C}\u{5C55}\u{73B0}\u{51FA}\u{5178}\u{578B}\u{7684}\u{201C}\u{7C92}\u{72B6}\u{9576}\u{5D4C} / \u{8702}\u{7A9D}\u{591A}\u{8FB9}\u{5F62}\u{201D}\u{5F62}\u{6001}\u{3002}
    - **\u{7EFF}\u{5E18}\u{77F3}\u{7684}\u{9AD8}\u{53CD}\u{5DEE}\u{7279}\u{6027} (High-Contrast Epidote)**: \u{7EFF}\u{5E18}\u{77F3}\u{4E0E}\u{77F3}\u{82F1}\u{5171}\u{751F}\u{65F6}\u{53CD}\u{5DEE}\u{6781}\u{5176}\u{5F3A}\u{70C8}\u{3002}\u{5728}\u{5355}\u{504F}\u{5149} (PPL) \u{4E0B}\u{FF0C}\u{7EFF}\u{5E18}\u{77F3}\u{5177}\u{6709}**\u{6B63}\u{9AD8}\u{7A81}\u{8D77} (High positive relief)**\u{FF08}\u{76F8}\u{6BD4}\u{5E73}\u{5766}\u{7684}\u{77F3}\u{82F1}\u{663E}\u{5F97}\u{9661}\u{5CED}\u{3001}\u{5751}\u{6D3C}\u{FF09}\u{FF0C}\u{5E76}\u{5E38}\u{5448}\u{73B0}\u{51FA}\u{7279}\u{5F81}\u{6027}\u{7684}**\u{6DE1}\u{9EC4}\u{7EFF}\u{8272}\u{81F3}\u{9EC4}\u{7EFF}\u{8272}\u{591A}\u{8272}\u{6027} (Pistachio-green pleochroism)**\u{3002}
    - **XPL\u{4E0B}\u{7684}\u{7EDA}\u{4E3D}\u{78B0}\u{649E} (Brilliant XPL Colors)**: \u{5728}\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL) \u{4E0B}\u{FF0C}\u{7531}\u{4E8E}\u{7EFF}\u{5E18}\u{77F3}\u{53CC}\u{6298}\u{5C04}\u{7387}\u{5F88}\u{9AD8}\u{FF0C}\u{5B83}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{51FA}\u{6781}\u{5176}\u{660E}\u{4EAE}\u{3001}\u{6591}\u{9A73}\u{7684}\u{4E8C}\u{81F3}\u{4E09}\u{7EA7}\u{9AD8}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{FF08}\u{660E}\u{4EAE}\u{7684}\u{7C89}\u{7D2B}\u{3001}\u{5929}\u{84DD}\u{3001}\u{9C9C}\u{7EFF}\u{3001}\u{4EAE}\u{9EC4}\u{7B49}\u{201C}\u{5F00}\u{5FC3}\u{679C}\u{8272}\u{8C03}\u{201D}\u{FF09}\u{3002}\u{8FD9}\u{79CD}\u{5982}\u{6CB9}\u{753B}\u{822C}\u{6D53}\u{70C8}\u{6591}\u{9A73}\u{7684}\u{9AD8}\u{4EAE}\u{8272}\u{5F69}\u{5305}\u{88F9}\u{7740}\u{4E2D}\u{95F4}\u{989C}\u{8272}\u{5355}\u{8C03}\u{FF08}\u{9ED1}\u{767D}\u{7070}\u{FF09}\u{4F46}\u{7ED3}\u{6784}\u{5B9B}\u{5982}\u{8702}\u{5DE2}\u{822C}\u{89C4}\u{5219}\u{7684}\u{77F3}\u{82F1}\u{7C92}\u{72B6}\u{6676}\u{4F53}\u{7FA4}\u{FF0C}\u{6784}\u{6210}\u{4E86}\u{6781}\u{5177}\u{51B2}\u{51FB}\u{529B}\u{FF08}\u{53CD}\u{5DEE}\u{6781}\u{5927}\u{FF09}\u{7684}\u{663E}\u{5FAE}\u{5149}\u{5B66}\u{753B}\u{5377}\u{3002}
  - **\u{4E91}\u{6BCD}\u{7C7B} (Micas - \u{767D}\u{4E91}\u{6BCD} Muscovite \u{4E0E} \u{9ED1}\u{4E91}\u{6BCD} Biotite)**:
    - **\u{6781}\u{5B8C}\u{5168}\u{89E3}\u{7406} (Perfect Cleavage)**: \u{6240}\u{6709}\u{7684}\u{4E91}\u{6BCD}\u{90FD}\u{5177}\u{6709}\u{4E00}\u{7EC4}\u{6781}\u{5176}\u{5E73}\u{76F4}\u{3001}\u{5BC6}\u{96C6}\u{7684}\u{5E73}\u{884C}\u{89E3}\u{7406}\u{7F1D} (Basal cleavage)\u{3002}\u{8FD9}\u{662F}\u{8BC6}\u{522B}\u{4E91}\u{6BCD}\u{65CF}\u{77FF}\u{7269}\u{7684}\u{6700}\u{57FA}\u{672C}\u{7279}\u{5F81}\u{3002}
    - **\u{5355}\u{504F}\u{5149} (PPL) \u{5BF9}\u{6BD4}**: \u{767D}\u{4E91}\u{6BCD} (Muscovite) \u{5728}PPL\u{4E0B}\u{901A}\u{5E38}\u{662F}**\u{65E0}\u{8272}\u{900F}\u{660E}**\u{7684}\u{FF08}\u{6781}\u{5C11}\u{6570}\u{5448}\u{6781}\u{8584}\u{7684}\u{6DE1}\u{8272}\u{FF09}\u{3002}\u{800C}\u{9ED1}\u{4E91}\u{6BCD} (Biotite) \u{5219}\u{5448}\u{73B0}\u{5F3A}\u{70C8}\u{7684}**\u{68D5}\u{8272}\u{3001}\u{8910}\u{8272}\u{81F3}\u{6697}\u{7EA2}\u{8910}\u{8272}**\u{FF0C}\u{5E76}\u{4E14}\u{5177}\u{6709}\u{6781}\u{5176}\u{663E}\u{8457}\u{7684}**\u{591A}\u{8272}\u{6027} (Pleochroism)**\u{FF08}\u{968F}\u{7740}\u{8F7D}\u{7269}\u{53F0}\u{65CB}\u{8F6C}\u{FF0C}\u{989C}\u{8272}\u{6DF1}\u{6D45}\u{53D8}\u{5316}\u{975E}\u{5E38}\u{5267}\u{70C8}\u{FF09}\u{3002}
    - **\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL) \u{5BF9}\u{6BD4}\u{4E0E}\u{9E1F}\u{773C}\u{6591}\u{7EB9}**: \u{4E24}\u{8005}\u{5728}XPL\u{4E0B}\u{7406}\u{8BBA}\u{4E0A}\u{90FD}\u{5177}\u{6709}\u{6781}\u{9AD8}\u{7684}\u{5E72}\u{6D89}\u{8272}\u{FF08}\u{4E8C}\u{7EA7}\u{5230}\u{4E09}\u{7EA7}\u{FF09}\u{3002}\u{767D}\u{4E91}\u{6BCD}\u{7684}\u{5E72}\u{6D89}\u{8272}\u{7531}\u{4E8E}\u{672C}\u{8EAB}\u{65E0}\u{8272}\u{FF0C}\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{4F53}\u{8272}\u{5438}\u{6536}\u{FF0C}\u{56E0}\u{6B64}\u{663E}\u{5F97}\u{6781}\u{5176}\u{660E}\u{4EAE}\u{6591}\u{6593}\u{FF08}\u{9C9C}\u{8273}\u{7684}\u{7C89}\u{8272}\u{3001}\u{4EAE}\u{9EC4}\u{3001}\u{5929}\u{84DD}\u{7B49}\u{FF09}\u{3002}\u{9ED1}\u{4E91}\u{6BCD}\u{7531}\u{4E8E}\u{81EA}\u{8EAB}\u{5F3A}\u{70C8}\u{7684}\u{68D5}\u{8910}\u{8272}\u{4F53}\u{8272}\u{5438}\u{6536}\u{FF0C}\u{5176}\u{9AD8}\u{9636}\u{5E72}\u{6D89}\u{8272}\u{5F80}\u{5F80}\u{88AB}\u{81EA}\u{8EAB}\u{7684}\u{989C}\u{8272}\u{63A9}\u{76D6}\u{6216}\u{6DF7}\u{5408}\u{FF0C}\u{663E}\u{5F97}\u{504F}\u{6697}\u{3002}\u{4E24}\u{8005}\u{FF08}\u{5C24}\u{5176}\u{662F}\u{767D}\u{4E91}\u{6BCD}\u{FF09}\u{5728}\u{63A5}\u{8FD1}\u{6D88}\u{5149}\u{4F4D}\u{65F6}\u{FF0C}\u{8868}\u{9762}\u{7ECF}\u{5E38}\u{5448}\u{73B0}\u{51FA}\u{4E00}\u{79CD}\u{6591}\u{9A73}\u{9646}\u{79BB}\u{3001}\u{7C7B}\u{4F3C}\u{63C9}\u{76B1}\u{7684}\u{9AD8}\u{53CD}\u{5149}\u{94DD}\u{7B94}\u{7EB8}\u{7684}\u{7279}\u{6B8A}\u{7EB9}\u{7406}\u{FF0C}\u{88AB}\u{79F0}\u{4E3A}**\u{201C}\u{9E1F}\u{773C}\u{6591}\u{7EB9} / \u{9E1F}\u{773C}\u{6784}\u{9020}\u{201D} (Bird's-eye maple / Mottling)**\u{FF0C}\u{8FD9}\u{662F}\u{7531}\u{4E8E}\u{5236}\u{7247}\u{7814}\u{78E8}\u{65F6}\u{4E91}\u{6BCD}\u{89E3}\u{7406}\u{9762}\u{8F7B}\u{5FAE}\u{53D7}\u{635F}\u{5BFC}\u{81F4}\u{7684}\u{7279}\u{5F81}\u{5149}\u{5B66}\u{73B0}\u{8C61}\u{3002}
    - **\u{591A}\u{8272}\u{6027}\u{6655}\u{73AF} (Pleochroic Haloes)**: \u{8FD9}\u{662F}\u{9ED1}\u{4E91}\u{6BCD}\u{6781}\u{5176}\u{72EC}\u{6709}\u{FF08}\u{4E5F}\u{5076}\u{89C1}\u{5176}\u{4ED6}\u{77FF}\u{7269}\u{FF09}\u{7684}\u{9274}\u{5B9A}\u{6740}\u{624B}\u{950F}\u{3002}\u{9ED1}\u{4E91}\u{6BCD}\u{5185}\u{90E8}\u{975E}\u{5E38}\u{5BB9}\u{6613}\u{5305}\u{88F9}\u{9506}\u{77F3}\u{3001}\u{72EC}\u{5C45}\u{77F3}\u{7B49}\u{5FAE}\u{5C0F}\u{653E}\u{5C04}\u{6027}\u{77FF}\u{7269}\u{5FAE}\u{7C92}\u{3002}\u{8FD9}\u{4E9B}\u{5FAE}\u{7C92}\u{91CA}\u{653E}\u{7684}\u{653E}\u{5C04}\u{7EBF}\u{7834}\u{574F}\u{4E86}\u{5FAE}\u{7C92}\u{5468}\u{56F4}\u{9ED1}\u{4E91}\u{6BCD}\u{7684}\u{6676}\u{683C}\u{FF0C}\u{5728}\u{5355}\u{504F}\u{5149}(PPL)\u{4E0B}\u{FF0C}\u{4F1A}\u{5728}\u{8FD9}\u{4E9B}\u{5168}\u{9ED1}\u{5C0F}\u{70B9}\u{5305}\u{88F9}\u{4F53}\u{5468}\u{56F4}\u{5F62}\u{6210}\u{4E00}\u{4E2A}\u{989C}\u{8272}\u{6BD4}\u{5468}\u{56F4}\u{9ED1}\u{4E91}\u{6BCD}\u{66F4}\u{6DF1}\u{3001}\u{591A}\u{8272}\u{6027}\u{66F4}\u{5F3A}\u{70C8}\u{7684}\u{9ED1}\u{8910}\u{8272}\u{540C}\u{5FC3}\u{5706}\u{201C}\u{6655}\u{73AF}\u{201D}\u{3002}
  - **\u{4E0D}\u{900F}\u{660E}\u{91D1}\u{5C5E}\u{77FF}\u{7269} (Opaque Minerals / Metallic Minerals - \u{5982}\u{78C1}\u{94C1}\u{77FF}\u{3001}\u{949B}\u{94C1}\u{77FF}\u{3001}\u{91D1}\u{5C5E}\u{78B2}\u{5316}\u{7269}\u{7B49})**:
    - **\u{900F}\u{5C04}\u{5149}\u{4E0B}\u{5168}\u{9ED1} (Completely Black in Transmitted Light)**: \u{67D0}\u{4E9B}\u{7279}\u{6B8A}\u{7684}\u{91D1}\u{5C5E}\u{77FF}\u{7269}\u{FF08}\u{5982}\u{7F55}\u{89C1}\u{7684}\u{78B2}\u{94DC}\u{77FF} Copper telluride \u{6216}\u{666E}\u{901A}\u{7684}\u{91D1}\u{5C5E}\u{6C27}\u{5316}\u{7269}\u{FF09}\u{FF0C}\u{7531}\u{4E8E}\u{4E0D}\u{900F}\u{5149}\u{FF0C}\u{5728}\u{900F}\u{5C04}\u{5149}\u{663E}\u{5FAE}\u{955C}\u{4E0B}\u{FF0C}**\u{65E0}\u{8BBA}\u{662F}\u{5355}\u{504F}\u{5149} (PPL) \u{8FD8}\u{662F}\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL)**\u{FF0C}\u{5747}\u{5448}\u{73B0}\u{51FA}\u{6781}\u{81F4}\u{7684}\u{7EAF}\u{9ED1}\u{8272}\u{9897}\u{7C92}\u{6216}\u{6591}\u{70B9}\u{3002}
    - **\u{5CA9}\u{77F3}\u{57FA}\u{8D28}\u{4E2D}\u{7684}\u{53CD}\u{5DEE}**: \u{5B83}\u{4EEC}\u{5E38}\u{5927}\u{91CF}\u{6563}\u{5E03}\u{5728}\u{8D85}\u{57FA}\u{6027}/\u{57FA}\u{6027}\u{706B}\u{5C71}\u{5CA9}\u{7684}\u{7EC6}\u{7C92}\u{57FA}\u{8D28}\u{4E2D}\u{3002}\u{5728}\u{53CC}\u{504F}\u{5149}\u{955C}\u{5BF9}\u{6BD4}\u{65F6}\u{FF0C}\u{5B83}\u{4EEC}\u{59CB}\u{7EC8}\u{4FDD}\u{6301}\u{5168}\u{9ED1}\u{FF0C}\u{4E0E}\u{5468}\u{56F4}\u{8272}\u{5F69}\u{6591}\u{6593}\u{7684}\u{9AD8}\u{7EA7}\u{9020}\u{5CA9}\u{77FF}\u{7269}\u{FF08}\u{5982}\u{5E72}\u{6D89}\u{8272}\u{6781}\u{9AD8}\u{7684}\u{8F89}\u{77F3}\u{3001}\u{6A44}\u{6984}\u{77F3}\u{6591}\u{6676}\u{FF09}\u{5F62}\u{6210}\u{6781}\u{5176}\u{5F3A}\u{70C8}\u{7684}\u{660E}\u{6697}\u{89C6}\u{89C9}\u{53CD}\u{5DEE}\u{3002}
  - **\u{957F}\u{77F3}\u{7C7B} (Feldspars)**:
    - **\u{659C}\u{957F}\u{77F3} (Plagioclase)**: \u{5728}\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL) \u{4E0B}\u{6700}\u{663E}\u{8457}\u{7684}\u{7279}\u{5F81}\u{662F}**\u{805A}\u{7247}\u{53CC}\u{6676} (Polysynthetic Twinning)**\u{FF0C}\u{8868}\u{73B0}\u{4E3A}\u{9ED1}\u{767D}\u{6216}\u{7070}\u{767D}\u{76F8}\u{95F4}\u{7684}\u{5E73}\u{884C}\u{6761}\u{7EB9}\u{FF0C}\u{72B9}\u{5982}\u{6761}\u{5F62}\u{7801}\u{3002}\u{5E72}\u{6D89}\u{8272}\u{901A}\u{5E38}\u{4E3A}\u{4E00}\u{7EA7}\u{7070}\u{767D}\u{3002}
    - **\u{6B63}\u{957F}\u{77F3} / \u{78B1}\u{6027}\u{957F}\u{77F3} (Orthoclase / Alkali Feldspar)**: \u{5E38}\u{89C1}**\u{5361}\u{65AF}\u{5DF4}\u{53CC}\u{6676} (Carlsbad Twinning)**\u{FF0C}\u{5728}XPL\u{4E0B}\u{6676}\u{4F53}\u{901A}\u{5E38}\u{88AB}\u{4E00}\u{6761}\u{76F4}\u{7EBF}\u{5206}\u{6210}\u{660E}\u{6697}\u{4E0D}\u{540C}\u{7684}\u{4E24}\u{534A}\u{3002}\u{82E5}\u{662F}\u{5FAE}\u{659C}\u{957F}\u{77F3} (Microcline)\u{FF0C}\u{5219}\u{53EF}\u{89C1}\u{6807}\u{5FD7}\u{6027}\u{7684}**\u{683C}\u{5B50}\u{53CC}\u{6676} (Cross-hatched / Tartan Twinning)**\u{3002}
  - **\u{8F89}\u{77F3}\u{7C7B} (Pyroxenes)**:
    - **\u{89E3}\u{7406} (Cleavage)**: \u{5177}\u{6709}\u{4E24}\u{7EC4}\u{8FD1}\u{4E8E}\u{6B63}\u{4EA4}\u{FF08}\u{8FD1}90\xb0\u{FF0C}\u{5B9E}\u{9645}\u{7EA6}87\xb0\u{548C}93\xb0\u{FF09}\u{7684}\u{89E3}\u{7406}\u{9762}\u{FF0C}\u{8FD9}\u{662F}\u{533A}\u{5206}\u{5B83}\u{4E0E}\u{89D2}\u{95EA}\u{77F3}\u{FF08}\u{7EA6}120\xb0\u{89E3}\u{7406}\u{FF09}\u{7684}\u{9EC4}\u{91D1}\u{6807}\u{51C6}\u{3002}
    - **\u{5355}\u{659C}\u{8F89}\u{77F3} (\u{5982}\u{666E}\u{901A}\u{8F89}\u{77F3} Augite / \u{7EFF}\u{8F89}\u{77F3} Omphacite / \u{6613}\u{53D8}\u{8F89}\u{77F3} Pigeonite)**: \u{5728}XPL\u{4E0B}\u{5448}\u{73B0}\u{8273}\u{4E3D}\u{7684}\u{4E8C}\u{7EA7}\u{9AD8}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{FF0C}\u{4E14}\u{5177}\u{6709}**\u{659C}\u{6D88}\u{5149} (Inclined Extinction)**\u{7279}\u{5F81}\u{3002}\u{6613}\u{53D8}\u{8F89}\u{77F3} (Pigeonite) \u{7ECF}\u{5E38}\u{8868}\u{73B0}\u{51FA}\u{7279}\u{5F81}\u{6027}\u{7684}**\u{51FA}\u{6EB6}\u{7EB9} (Exsolution lamellae)**\u{FF0C}\u{5373}\u{5728}\u{5176}\u{6676}\u{4F53}\u{5185}\u{90E8}\u{6790}\u{51FA}\u{6781}\u{7EC6}\u{7684}\u{666E}\u{901A}\u{8F89}\u{77F3}\u{6761}\u{7EB9}\u{3002}
    - **\u{659C}\u{65B9}\u{8F89}\u{77F3} (\u{5982}\u{7D2B}\u{82CF}\u{8F89}\u{77F3} Hypersthene)**: \u{5728}XPL\u{4E0B}\u{5E72}\u{6D89}\u{8272}\u{8F83}\u{4F4E}\u{FF08}\u{901A}\u{5E38}\u{4E3A}\u{4E00}\u{7EA7}\u{7070}\u{767D}\u{9EC4}\u{FF09}\u{FF0C}\u{4E14}\u{5177}\u{6709}**\u{5E73}\u{884C}\u{6D88}\u{5149} (Parallel Extinction)**\u{7279}\u{5F81}\u{3002}
  - **\u{6A44}\u{6984}\u{77F3} (Olivine)**:
    - **\u{65E0}\u{89E3}\u{7406}\u{4E0E}\u{88C2}\u{7EB9} (No Cleavage & Fractures)**: \u{6781}\u{5176}\u{5173}\u{952E}\u{7684}\u{533A}\u{522B}\u{6807}\u{5FD7}\u{FF0C}\u{5355}\u{504F}\u{5149}(PPL)\u{4E0B}\u{53EF}\u{89C1}\u{5176}\u{53EA}\u{6709}\u{4E0D}\u{89C4}\u{5219}\u{7684}\u{88C2}\u{7EB9}\u{FF0C}\u{800C}\u{7EDD}\u{4E0D}\u{53EF}\u{80FD}\u{51FA}\u{73B0}\u{5E73}\u{76F4}\u{7684}\u{89E3}\u{7406}\u{7F1D}\u{3002}\u{5177}\u{6709}\u{6781}\u{9AD8}\u{7684}\u{6B63}\u{7A81}\u{8D77}\u{3002}
    - **\u{9AD8}\u{5E72}\u{6D89}\u{8272} (High Interference Color)**: \u{5728}\u{6B63}\u{4EA4}\u{504F}\u{5149}(XPL)\u{4E0B}\u{FF0C}\u{5448}\u{73B0}\u{51FA}\u{6781}\u{5176}\u{6781}\u{5176}\u{9C9C}\u{8273}\u{7684}\u{4E8C}\u{7EA7}\u{81F3}\u{4E09}\u{7EA7}\u{9AD8}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{FF08}\u{5927}\u{7EA2}\u{3001}\u{9C9C}\u{7EFF}\u{3001}\u{660E}\u{9EC4}\u{3001}\u{7D2B}\u{7EA2}\u{7B49}\u{FF09}\u{FF0C}\u{5982}\u{540C}\u{6253}\u{7FFB}\u{7684}\u{8C03}\u{8272}\u{76D8}\u{3002}\u{5177}\u{6709}\u{5E73}\u{884C}\u{6D88}\u{5149}\u{3002}
    - **\u{8680}\u{53D8}\u{7279}\u{5F81} (Alteration)**: \u{6A44}\u{6984}\u{77F3}\u{6781}\u{6613}\u{53D1}\u{751F}\u{6C34}\u{5316}\u{8680}\u{53D8}\u{FF0C}\u{5E38}\u{6CBF}\u{5FAE}\u{88C2}\u{7EB9}\u{6216}\u{8FB9}\u{7F18}\u{8680}\u{53D8}/\u{9000}\u{53D8}\u{8D28}\u{4E3A}\u{6697}\u{7EFF}\u{8272}\u{7684}**\u{86C7}\u{7EB9}\u{77F3} (Serpentine)**\u{FF0C}\u{6216}\u{6C27}\u{5316}\u{7684}\u{7EA2}\u{8910}\u{8272}\u{7684}**\u{4F0A}\u{4E01}\u{77F3} (Iddingsite)**\u{FF0C}\u{5F62}\u{6210}\u{7F51}\u{72B6}\u{6216}\u{9576}\u{8FB9}\u{7ED3}\u{6784}\u{3002}
    - **\u{7384}\u{6B66}\u{8D28}\u{706B}\u{5C71}\u{783E}\u{6591}\u{6676} (Phenocryst in Basaltic Lapilli)**: \u{6A44}\u{6984}\u{77F3}\u{7ECF}\u{5E38}\u{4F5C}\u{4E3A}\u{65E9}\u{671F}\u{9AD8}\u{6E29}\u{7ED3}\u{6676}\u{7684}\u{77FF}\u{7269}\u{FF0C}\u{5F62}\u{6210}\u{5DE8}\u{5927}\u{7684}\u{6591}\u{6676} (Phenocryst)\u{FF0C}\u{5B64}\u{7ACB}\u{5730}\u{9576}\u{5D4C}\u{5728}\u{5FEB}\u{901F}\u{51B7}\u{5374}\u{55B7}\u{53D1}\u{5F62}\u{6210}\u{7684}\u{706B}\u{5C71}\u{788E}\u{5C51}/\u{7384}\u{6B66}\u{8D28}\u{706B}\u{5C71}\u{783E}\u{4E2D}\u{3002}\u{5728}XPL\u{4E0B}\u{FF0C}\u{5176}\u{6781}\u{5176}\u{9C9C}\u{8273}\u{7684}\u{9AD8}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{4E0E}\u{5468}\u{56F4}\u{6781}\u{7EC6}\u{7C92}\u{3001}\u{751A}\u{81F3}\u{8868}\u{73B0}\u{4E3A}\u{5168}\u{9ED1}\u{FF08}\u{5404}\u{5411}\u{540C}\u{6027}\u{7684}\u{706B}\u{5C71}\u{73BB}\u{7483} Volcanic glass\u{FF09}\u{7684}\u{8131}\u{73BB}\u{5316}\u{57FA}\u{8D28}\u{5F62}\u{6210}\u{6781}\u{5EA6}\u{5F3A}\u{70C8}\u{7684}\u{89C6}\u{89C9}\u{53CD}\u{5DEE}\u{3002}
  - **\u{84DD}\u{95EA}\u{77F3} (Glaucophane) \u{4E0E} \u{84DD}\u{7247}\u{5CA9} (Blueschist) \u{7279}\u{5F81}**:
    - **\u{67F1}\u{72B6}/\u{9488}\u{72B6}\u{6676}\u{4F53}\u{4E0E}\u{5F3A}\u{5B9A}\u{5411}\u{6392}\u{5217}**: \u{84DD}\u{95EA}\u{77F3}\u{FF08}\u{5C5E}\u{4E8E}\u{89D2}\u{95EA}\u{77F3}\u{65CF}\u{FF09}\u{901A}\u{5E38}\u{5448}\u{67F1}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{6216}\u{7EA4}\u{7EF4}\u{72B6}\u{3002}\u{5728}\u{84DD}\u{7247}\u{5CA9}\u{4E2D}\u{FF0C}\u{8FD9}\u{4E9B}\u{6676}\u{4F53}\u{8868}\u{73B0}\u{51FA}\u{6781}\u{5176}\u{5F3A}\u{70C8}\u{7684}**\u{5B9A}\u{5411}\u{6392}\u{5217} (Foliation/Schistosity)**\u{FF0C}\u{8FD9}\u{662F}\u{9AD8}\u{538B}\u{526A}\u{5207}\u{53D8}\u{8D28}\u{4F5C}\u{7528}\u{7684}\u{76F4}\u{63A5}\u{8BC1}\u{636E}\u{3002}
    - **\u{5355}\u{504F}\u{5149} (PPL) - \u{6807}\u{5FD7}\u{6027}\u{7684}\u{84DD}\u{8272}\u{8C03}**: \u{5728}\u{5355}\u{504F}\u{5149}\u{4E0B}\u{FF0C}\u{84DD}\u{95EA}\u{77F3}\u{5448}\u{73B0}\u{6781}\u{5176}\u{5F3A}\u{70C8}\u{7684}**\u{7D2B}\u{84DD}\u{8272}\u{3001}\u{84DD}\u{7D2B}\u{8272}\u{81F3}\u{6DE1}\u{84DD}\u{8272}\u{591A}\u{8272}\u{6027} (Pleochroism)**\u{FF0C}\u{8FD9}\u{662F}\u{5B83}\u{5F97}\u{540D}\u{548C}\u{88AB}\u{4E00}\u{773C}\u{8BA4}\u{51FA}\u{7684}\u{539F}\u{56E0}\u{3002}
    - **\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL) - \u{5E72}\u{6D89}\u{8272}\u{4E0E}\u{6D88}\u{5149}**: \u{5728}XPL\u{4E0B}\u{FF0C}\u{84DD}\u{95EA}\u{77F3}\u{5448}\u{73B0}\u{9C9C}\u{8273}\u{7684}\u{4E00}\u{7EA7}\u{9876}\u{90E8}\u{5230}\u{4E8C}\u{7EA7}\u{5E95}\u{90E8}\u{7684}\u{5E72}\u{6D89}\u{8272}\u{FF08}\u{9EC4}\u{3001}\u{6A59}\u{3001}\u{7EA2}\u{3001}\u{7D2B}\u{FF09}\u{FF0C}\u{4F46}\u{5176}\u{81EA}\u{8EAB}\u{7684}\u{5F3A}\u{84DD}\u{8272}\u{8C03}\u{5F80}\u{5F80}\u{4F1A}\u{53E0}\u{52A0}\u{5728}\u{5E72}\u{6D89}\u{8272}\u{4E0A}\u{FF0C}\u{4F7F}\u{5F97}\u{6574}\u{4F53}\u{753B}\u{9762}\u{5448}\u{73B0}\u{51FA}\u{4E00}\u{79CD}\u{5E26}\u{6709}\u{84DD}\u{7D2B}\u{8272}\u{5E95}\u{8272}\u{7684}\u{6591}\u{6593}\u{611F}\u{3002}\u{5177}\u{6709}**\u{5E73}\u{884C}\u{6216}\u{8FD1}\u{4E4E}\u{5E73}\u{884C}\u{6D88}\u{5149} (\u{8FD1}\u{4E4E}\u{5E73}\u{884C}\u{7684}\u{659C}\u{6D88}\u{5149}\u{FF0C}\u{6D88}\u{5149}\u{89D2}\u{5F88}\u{5C0F})**\u{3002}
    - **\u{4F34}\u{751F}\u{77FF}\u{7269}**: \u{84DD}\u{7247}\u{5CA9}\u{4E2D}\u{5E38}\u{4F34}\u{751F}\u{6709}\u{7EFF}\u{5E18}\u{77F3} (Epidote, XPL\u{4E0B}\u{5E38}\u{89C1}\u{9C9C}\u{8273}\u{7684}\u{4E09}\u{7EA7}\u{751A}\u{81F3}\u{66F4}\u{9AD8}\u{7EA7}\u{7684}\u{5E72}\u{6D89}\u{8272})\u{3001}\u{77F3}\u{82F1}\u{3001}\u{591A}\u{7845}\u{767D}\u{4E91}\u{6BCD}\u{7B49}\u{3002}\u{6CE8}\u{610F}\u{FF0C}\u{84DD}\u{7247}\u{5CA9}\u{4EE3}\u{8868}**\u{9AD8}\u{538B}\u{4F4E}\u{6E29} (HP/LT)** \u{53D8}\u{8D28}\u{76F8}\u{FF0C}\u{662F}\u{5927}\u{6D0B}\u{4FEF}\u{51B2}\u{5E26}\u{7684}\u{6838}\u{5FC3}\u{6807}\u{5FD7}\u{3002}
  - **\u{5915}\u{7EBF}\u{77F3}/\u{7845}\u{7EBF}\u{77F3} (Sillimanite) \u{4E0E} \u{6CE5}\u{8D28}\u{9AD8}\u{6E29}\u{53D8}\u{8D28}\u{5CA9} (High-Grade Pelitic Metamorphic Rocks)**:
    - **\u{9488}\u{72B6}\u{4E0E}\u{7EA4}\u{7EF4}\u{72B6}\u{96C6}\u{5408}\u{4F53} (Acicular & Fibrous/Fibrolite)**: \u{5915}\u{7EBF}\u{77F3}\u{662F}\u{6CE5}\u{8D28}\u{5CA9}\u{FF08}\u{5982}\u{6CE5}\u{5CA9}/\u{9875}\u{5CA9}\u{FF0C}Mudstone/Shale\u{FF09}\u{5728}\u{9AD8}\u{6E29}\u{53D8}\u{8D28}\u{76F8}\u{FF08}\u{4E0A}\u{89D2}\u{95EA}\u{5CA9}\u{76F8}\u{5230}\u{9EBB}\u{7C92}\u{5CA9}\u{76F8}\u{FF09}\u{7684}\u{5178}\u{578B}\u{6307}\u{793A}\u{6807}\u{5FD7}\u{3002}\u{663E}\u{5FAE}\u{955C}\u{4E0B}\u{5E38}\u{5448}\u{4E24}\u{79CD}\u{5F62}\u{6001}\u{FF1A}\u{675F}\u{72B6}/\u{653E}\u{5C04}\u{72B6}\u{4EA4}\u{7EC7}\u{7684}\u{6781}\u{5176}\u{7EC6}\u{5C0F}\u{7684}\u{7EA4}\u{7EF4}\u{72B6}\u{96C6}\u{5408}\u{4F53}\u{FF08}\u{4FD7}\u{79F0}\u{201C}\u{5915}\u{7EBF}\u{77F3}\u{6BDB}\u{53D1}\u{7EA4}\u{7EF4}\u{201D}\u{FF0C}Fibrolite\u{FF09}\u{FF0C}\u{6216}\u{662F}\u{72EC}\u{7ACB}\u{751F}\u{957F}\u{7684}\u{7EC6}\u{957F}\u{67F1}\u{72B6}\u{3001}\u{9488}\u{72B6}\u{6676}\u{4F53}\u{3002}
    - **\u{5E72}\u{6D89}\u{8272}\u{4E0E}\u{6D88}\u{5149} (Interference Colors & Extinction)**: \u{5728}XPL\u{4E0B}\u{FF0C}\u{5915}\u{7EBF}\u{77F3}\u{5448}\u{73B0}\u{4E00}\u{7EA7}\u{9876}\u{90E8}\u{81F3}\u{4E8C}\u{7EA7}\u{7684}\u{9C9C}\u{8273}\u{5E72}\u{6D89}\u{8272}\u{FF08}\u{91D1}\u{9EC4}\u{3001}\u{6A59}\u{3001}\u{7EA2}\u{751A}\u{81F3}\u{84DD}\u{7EFF}\u{8272}\u{FF09}\u{FF0C}\u{5176}\u{7EA4}\u{7EC6}\u{7684}\u{957F}\u{67F1}\u{72B6}\u{6676}\u{4F53}\u{8868}\u{73B0}\u{51FA}\u{4E25}\u{683C}\u{7684}**\u{5E73}\u{884C}\u{6D88}\u{5149} (Parallel Extinction)**\u{3002}\u{5728}\u{7070}\u{767D}/\u{9ED1}\u{8272}\u{7684}\u{77F3}\u{82F1}/\u{957F}\u{77F3}\u{7B49}\u{53D8}\u{8D28}\u{57FA}\u{8D28}\u{4E2D}\u{FF0C}\u{8FD9}\u{4E9B}\u{8272}\u{5F69}\u{6591}\u{6593}\u{7684}\u{957F}\u{9488}\u{6216}\u{6BDB}\u{53D1}\u{72B6}\u{7EA4}\u{7EF4}\u{50CF}\u{7EC6}\u{9488}\u{4E00}\u{6837}\u{7A7F}\u{63D2}\u{FF0C}\u{5177}\u{6709}\u{6781}\u{9AD8}\u{7684}\u{89C6}\u{89C9}\u{8FA8}\u{8BC6}\u{5EA6}\u{3002}
  - **\u{77F3}\u{69B4}\u{5B50}\u{77F3} (Garnet)\u{4E0E}\u{69B4}\u{8F89}\u{5CA9} (Eclogite) \u{7279}\u{5F81}**:
    - **\u{5168}\u{6D88}\u{5149} (Isotropic)**: \u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{5C5E}\u{4E8E}\u{7B49}\u{8F74}\u{6676}\u{7CFB}\u{FF0C}\u{5728}\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL) \u{4E0B}\u{662F}**\u{5404}\u{5411}\u{540C}\u{6027}**\u{7684}\u{FF0C}\u{56E0}\u{6B64}\u{65E0}\u{8BBA}\u{5982}\u{4F55}\u{65CB}\u{8F6C}\u{8F7D}\u{7269}\u{53F0}\u{FF0C}\u{5B83}\u{90FD}\u{5448}\u{73B0}\u{51FA}**\u{5168}\u{9ED1} (Extinct / Black)**\u{7684}\u{7279}\u{5F81}\u{3002}\u{8FD9}\u{662F}\u{5B83}\u{5728}XPL\u{4E0B}\u{7684}\u{6700}\u{6838}\u{5FC3}\u{9274}\u{5B9A}\u{6807}\u{51C6}\u{3002}
    - **\u{6B63}\u{9AD8}\u{7A81}\u{8D77}\u{4E0E}\u{88C2}\u{7EB9}**: \u{867D}\u{7136}\u{5728}XPL\u{4E0B}\u{5168}\u{9ED1}\u{FF0C}\u{4F46}\u{5728}\u{5355}\u{504F}\u{5149} (PPL) \u{4E0B}\u{53EF}\u{89C1}\u{5176}\u{5177}\u{6709}\u{6781}\u{9AD8}\u{7684}\u{6B63}\u{7A81}\u{8D77}\u{FF0C}\u{4E14}\u{8868}\u{9762}\u{901A}\u{5E38}\u{5E03}\u{6EE1}\u{4E0D}\u{89C4}\u{5219}\u{7684}\u{88C2}\u{7EB9} (Fractures)\u{FF0C}\u{56E0}\u{4E3A}\u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{65E0}\u{89E3}\u{7406}\u{3002}
    - **\u{69B4}\u{8F89}\u{5CA9}\u{7EC4}\u{5408} (Eclogite Assemblage)**: \u{5728}\u{69B4}\u{8F89}\u{5CA9}\u{7684}\u{8584}\u{7247}\u{4E2D}\u{FF0C}\u{6700}\u{7ECF}\u{5178}\u{7684}\u{89C6}\u{89C9}\u{51B2}\u{51FB}\u{662F}\u{FF1A}\u{6781}\u{5176}\u{5DE8}\u{5927}\u{3001}\u{5E03}\u{6EE1}\u{88C2}\u{7EB9}\u{4E14}\u{5728}XPL\u{4E0B}**\u{5B8C}\u{5168}\u{6F06}\u{9ED1}\u{7684}\u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{53D8}\u{6591}\u{6676} (Garnet Porphyroblasts)**\u{FF0C}\u{88AB}\u{5468}\u{56F4}\u{5448}\u{73B0}\u{6781}\u{5176}\u{7F24}\u{7EB7}\u{591A}\u{5F69}\u{3001}\u{8273}\u{4E3D}\u{4E8C}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{7684}**\u{7EFF}\u{8F89}\u{77F3} (Omphacite)** \u{57FA}\u{8D28}\u{6240}\u{5305}\u{56F4}\u{3002}\u{6CE8}\u{610F}\u{FF1A}\u{69B4}\u{8F89}\u{5CA9}\u{4E2D}\u{7EDD}\u{5BF9}**\u{4E0D}\u{542B}\u{659C}\u{957F}\u{77F3} (Absence of Plagioclase)**\u{FF0C}\u{8FD9}\u{662F}\u{9AD8}\u{538B}\u{53D8}\u{8D28}\u{7684}\u{94C1}\u{8BC1}\u{3002}
  - **\u{4E91}\u{6BCD}\u{7C7B} (Micas) - \u{9ED1}\u{4E91}\u{6BCD} (Biotite) \u{4E0E} \u{767D}\u{4E91}\u{6BCD} (Muscovite)**:
    - **\u{6781}\u{5B8C}\u{5168}\u{89E3}\u{7406} (Perfect Cleavage)**: \u{65E0}\u{8BBA}\u{5355}\u{504F}\u{5149}\u{8FD8}\u{662F}\u{6B63}\u{4EA4}\u{504F}\u{5149}\u{4E0B}\u{FF0C}\u{5747}\u{53EF}\u{89C1}\u{4E00}\u{7EC4}\u{6781}\u{5176}\u{53D1}\u{80B2}\u{7684}\u{5E73}\u{884C}\u{4E14}\u{7EC6}\u{5BC6}\u{7684}\u{89E3}\u{7406}\u{7EB9}\u{3002}
    - **\u{5355}\u{504F}\u{5149} (PPL) \u{533A}\u{5206}**: \u{9ED1}\u{4E91}\u{6BCD}\u{901A}\u{5E38}\u{5448}\u{73B0}\u{660E}\u{663E}\u{7684}\u{8910}\u{8272}\u{81F3}\u{6697}\u{7EFF}\u{8272}\u{FF0C}\u{4E14}**\u{591A}\u{8272}\u{6027}\u{6781}\u{5F3A}** (\u{8F7D}\u{7269}\u{53F0}\u{65CB}\u{8F6C}\u{65F6}\u{989C}\u{8272}\u{6DF1}\u{6D45}\u{53D8}\u{5316}\u{5267}\u{70C8})\u{FF1B}\u{800C}\u{767D}\u{4E91}\u{6BCD}\u{5728}\u{5355}\u{504F}\u{5149}\u{4E0B}\u{901A}\u{5E38}\u{65E0}\u{8272}\u{900F}\u{660E}\u{3002}
    - **\u{6B63}\u{4EA4}\u{504F}\u{5149} (XPL) \u{6807}\u{5FD7}**: \u{4E24}\u{8005}\u{5747}\u{5448}\u{73B0}\u{6781}\u{5176}\u{9C9C}\u{8273}\u{7684}\u{4E8C}\u{81F3}\u{4E09}\u{7EA7}\u{751A}\u{81F3}\u{66F4}\u{9AD8}\u{7684}\u{9AD8}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{3002}\u{6700}\u{7ECF}\u{5178}\u{7684}\u{7279}\u{5F81}\u{662F}\u{5F53}\u{5B83}\u{4EEC}\u{63A5}\u{8FD1}\u{6D88}\u{5149}\u{4F4D}\u{65F6}\u{FF0C}\u{8868}\u{9762}\u{4F1A}\u{5448}\u{73B0}\u{51FA}\u{6591}\u{9A73}\u{7684}\u{3001}\u{4E0D}\u{5747}\u{5300}\u{7684}\u{9EBB}\u{70B9}\u{72B6}\u{5916}\u{89C2}\u{FF0C}\u{88AB}\u{5F62}\u{8C61}\u{5730}\u{79F0}\u{4E3A}**\u{201C}\u{9E1F}\u{773C}\u{67AB}\u{6728} (Bird's-eye maple)\u{201D}**\u{6216}\u{201C}\u{9E1F}\u{773C}\u{9EBB}\u{9762}\u{201D}\u{6D88}\u{5149}\u{6548}\u{5E94}\u{FF0C}\u{8FD9}\u{662F}\u{7531}\u{4E8E}\u{5236}\u{7247}\u{8FC7}\u{7A0B}\u{4E2D}\u{6781}\u{5B8C}\u{5168}\u{89E3}\u{7406}\u{9762}\u{7684}\u{5FAE}\u{5C0F}\u{5F62}\u{53D8}\u{9020}\u{6210}\u{7684}\u{3002}
  - **\u{89D2}\u{95EA}\u{77F3}\u{6591}\u{6676} (Hornblende Phenocryst)**: \u{5728}XPL\u{4E0B}\u{5448}\u{73B0}\u{660E}\u{4EAE}\u{7684}\u{4E8C}\u{81F3}\u{4E09}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{3002}\u{7279}\u{522B}\u{6CE8}\u{610F}\u{5176}\u{6A2A}\u{622A}\u{9762}\u{5F62}\u{72B6}\u{FF0C}\u{6709}\u{65F6}\u{4F1A}\u{56E0}\u{4E3A}\u{6676}\u{4F53}\u{751F}\u{957F}\u{53D1}\u{80B2}\u{73AF}\u{5883}\u{548C}\u{5207}\u{5272}\u{65B9}\u{5411}\u{FF0C}\u{5448}\u{73B0}\u{51FA}\u{6781}\u{5176}\u{6807}\u{5FD7}\u{6027}\u{7684}\u{201C}\u{5FC3}\u{5F62} (Heart-shaped)\u{201D}\u{6216}\u{83F1}\u{5F62}\u{5207}\u{9762}\u{FF0C}\u{5E76}\u{4F34}\u{968F}\u{4E24}\u{7EC4}\u{7EA6}120\xb0\u{4EA4}\u{89D2}\u{7684}\u{89E3}\u{7406}\u{3002}
  - **\u{7384}\u{6B66}\u{5CA9}/\u{5B89}\u{5C71}\u{5CA9}\u{663E}\u{5FAE}\u{7279}\u{5F81} (Basalt/Andesite Micro-characteristics)**: 
    - **\u{57FA}\u{8D28}\u{4E0E}\u{6D41}\u{52A8}\u{6784}\u{9020} (Matrix & Flow Texture)**: \u{57FA}\u{8D28}\u{7531}\u{6742}\u{4E71}\u{6216}\u{5B9A}\u{5411}\u{6392}\u{5217}\u{7684}\u{659C}\u{957F}\u{77F3}\u{5FAE}\u{6676} (Microlites) \u{6784}\u{6210}\u{FF0C}\u{5728}XPL\u{4E0B}\u{5448}\u{9ED1}\u{767D}\u{76F8}\u{95F4}\u{7684}\u{6761}\u{7EB9}\u{FF08}\u{805A}\u{7247}\u{53CC}\u{6676}\u{FF09}\u{3002}\u{5982}\u{679C}\u{8FD9}\u{4E9B}\u{5FAE}\u{6676}\u{5448}\u{73B0}\u{660E}\u{663E}\u{7684}\u{5B9A}\u{5411}\u{6392}\u{5217} (Alignment)\u{FF0C}\u{5219}\u{5F3A}\u{70C8}\u{6307}\u{793A}\u{5CA9}\u{6D46}\u{7684}\u{201C}\u{6D41}\u{52A8} (Flow)\u{201D}\u{3002}
    - **\u{6591}\u{6676}\u{4E0E}\u{73AF}\u{5E26} (Phenocryst & Zoning)**: \u{7ECF}\u{5E38}\u{53EF}\u{89C1}\u{5DE8}\u{5927}\u{7684}\u{659C}\u{957F}\u{77F3}\u{6591}\u{6676}\u{6F02}\u{6D6E}\u{5728}\u{57FA}\u{8D28}\u{4E2D}\u{FF0C}XPL\u{4E0B}\u{89C2}\u{5BDF}\u{65F6}\u{FF0C}\u{7531}\u{4E8E}\u{5CA9}\u{6D46}\u{6210}\u{5206}\u{968F}\u{7ED3}\u{6676}\u{8FC7}\u{7A0B}\u{53D8}\u{5316}\u{FF0C}\u{6591}\u{6676}\u{5185}\u{90E8}\u{5E38}\u{5448}\u{73B0}\u{660E}\u{6697}\u{4EA4}\u{66FF}\u{7684}\u{201C}\u{73AF}\u{5E26}\u{6784}\u{9020} (Zoning)\u{201D}\u{3002}
    - **\u{674F}\u{4EC1}\u{6784}\u{9020} (Secondary mineralization in vesicles)**: \u{65E9}\u{671F}\u{5CA9}\u{6D46}\u{6C14}\u{5B54}\u{53EF}\u{80FD}\u{88AB}\u{6B21}\u{751F}\u{77FF}\u{7269}\u{FF08}\u{5982}\u{65B9}\u{89E3}\u{77F3}\u{3001}\u{7EFF}\u{6CE5}\u{77F3}\u{3001}\u{7389}\u{9AD3}\u{FF09}\u{5145}\u{586B}\u{FF0C}\u{5728}\u{8584}\u{7247}\u{4E2D}\u{8868}\u{73B0}\u{4E3A}\u{5706}\u{5F62}\u{6216}\u{692D}\u{5706}\u{5F62}\u{7684}\u{805A}\u{5408}\u{4F53}\u{6591}\u{5757}\u{3002}
  - **\u{8F89}\u{957F}\u{5CA9}\u{663E}\u{5FAE}\u{7279}\u{5F81} (Gabbro Micro-characteristics)**:
    - **\u{5168}\u{6676}\u{8D28}\u{7B49}\u{7C92}\u{7ED3}\u{6784} (Holocrystalline & Equigranular / Gabbroic Texture)**: \u{8F89}\u{957F}\u{5CA9}\u{662F}\u{57FA}\u{6027}\u{6DF1}\u{6210}\u{5CA9}\u{FF0C}\u{56E0}\u{6B64}\u{6CA1}\u{6709}\u{73BB}\u{7483}\u{8D28}\u{FF0C}\u{6240}\u{6709}\u{77FF}\u{7269}\u{7531}\u{4E8E}\u{5728}\u{5730}\u{4E0B}\u{7F13}\u{6162}\u{51B7}\u{5374}\u{FF0C}\u{90FD}\u{7ED3}\u{6676}\u{5F97}\u{975E}\u{5E38}\u{7C97}\u{5927}\u{4E14}\u{76F8}\u{5BF9}\u{5747}\u{5300}\u{3002}\u{5728}XPL\u{4E0B}\u{5448}\u{73B0}\u{51FA}\u{660E}\u{663E}\u{7684}\u{76F8}\u{4E92}\u{9576}\u{5D4C}\u{7684}\u{62FC}\u{56FE}\u{72B6}\u{3002}
    - **\u{7279}\u{5F81}\u{77FF}\u{7269}\u{7EC4}\u{5408} (Mineral Assemblage)**: \u{7EDD}\u{5BF9}\u{7684}\u{4E3B}\u{89D2}\u{662F}\u{7C97}\u{5927}\u{7684}**\u{659C}\u{957F}\u{77F3} (Plagioclase)**\u{FF08}\u{4E00}\u{7EA7}\u{7070}\u{767D}\u{5E72}\u{6D89}\u{8272}\u{FF0C}\u{5BBD}\u{5927}\u{7684}\u{805A}\u{7247}\u{53CC}\u{6676}\u{6761}\u{7EB9}\u{FF09}\u{548C}**\u{8F89}\u{77F3} (Pyroxene)**\u{FF08}\u{5355}\u{659C}\u{8F89}\u{77F3}\u{5448}\u{73B0}\u{6781}\u{5176}\u{9C9C}\u{8273}\u{7684}\u{4E8C}\u{81F3}\u{4E09}\u{7EA7}\u{5E72}\u{6D89}\u{8272}\u{FF09}\u{3002}\u{6709}\u{65F6}\u{8FD8}\u{5305}\u{542B}\u{5927}\u{91CF}\u{540C}\u{6837}\u{5E72}\u{6D89}\u{8272}\u{6781}\u{5176}\u{9C9C}\u{8273}\u{4F46}\u{53D1}\u{80B2}\u{4E0D}\u{89C4}\u{5219}\u{88C2}\u{7EB9}\u{7684}**\u{6A44}\u{6984}\u{77F3} (Olivine)**\u{3002}
    - **\u{8F89}\u{7EFF}/\u{6B21}\u{8F89}\u{7EFF}\u{7ED3}\u{6784} (Ophitic / Subophitic Texture)**: \u{8FD9}\u{662F}\u{8F89}\u{957F}\u{5CA9}/\u{8F89}\u{7EFF}\u{5CA9}\u{6781}\u{5176}\u{7ECF}\u{5178}\u{7684}\u{6B21}\u{7EA7}\u{5FAE}\u{89C2}\u{7ED3}\u{6784}\u{3002}\u{5728}XPL\u{4E0B}\u{FF0C}\u{53EF}\u{4EE5}\u{770B}\u{5230}\u{5DE8}\u{5927}\u{7684}\u{3001}\u{8272}\u{5F69}\u{9C9C}\u{8273}\u{7684}\u{8F89}\u{77F3}\u{6676}\u{4F53}\u{FF08}Oikocryst\u{FF09}\u{50CF}\u{201C}\u{541E}\u{566C}\u{201D}\u{4E00}\u{6837}\u{FF0C}\u{5B8C}\u{5168}\u{5305}\u{56F4}\u{6216}\u{90E8}\u{5206}\u{5305}\u{88F9}\u{7740}\u{5448}\u{73B0}\u{9ED1}\u{767D}\u{53CC}\u{6676}\u{6761}\u{7EB9}\u{7684}\u{677F}\u{6761}\u{72B6}\u{659C}\u{957F}\u{77F3}\u{5FAE}\u{6676}\u{3002}\u{8FD9}\u{53CD}\u{6620}\u{4E86}\u{8FD9}\u{4E24}\u{79CD}\u{77FF}\u{7269}\u{7ED3}\u{6676}\u{5148}\u{540E}\u{987A}\u{5E8F}\u{548C}\u{901F}\u{7387}\u{7684}\u{5DEE}\u{5F02}\u{3002}
    - **\u{5F69}\u{8272}\u{62FC}\u{56FE}\u{4E0E}\u{8680}\u{53D8}\u{5FAE}\u{8109} (Colorful Mosaic & Alteration Veinlets)**: \u{8F89}\u{957F}\u{5CA9}\u{5728}XPL\u{4E0B}\u{7684}\u{5168}\u{6676}\u{8D28}\u{62FC}\u{56FE}\u{5F80}\u{5F80}\u{6781}\u{5176}\u{60CA}\u{8273}\u{3002}\u{9664}\u{4E86}\u{659C}\u{957F}\u{77F3}\u{7684}\u{9ED1}\u{767D}/\u{7070}\u{767D}\u{6761}\u{7EB9}\u{548C}\u{5355}\u{659C}\u{8F89}\u{77F3}\u{7684}\u{9C9C}\u{8273}\u{5E72}\u{6D89}\u{8272}\u{5916}\u{FF0C}\u{5982}\u{679C}\u{6709}\u{6A44}\u{6984}\u{77F3}\u{5B58}\u{5728}\u{FF0C}\u{5176}\u{4F53}\u{5185}\u{6781}\u{6613}\u{53D1}\u{80B2}\u{6CBF}\u{4E0D}\u{89C4}\u{5219}\u{7F51}\u{72B6}\u{5FAE}\u{88C2}\u{7EB9}\u{7684}\u{7EA2}\u{8910}\u{8272}/\u{7D2B}\u{7EA2}\u{8272}**\u{4F0A}\u{4E01}\u{77F3} (Iddingsite)** \u{6216}\u{6697}\u{7EFF}\u{8272}\u{86C7}\u{7EB9}\u{77F3}\u{8680}\u{53D8}\u{3002}\u{8FD9}\u{4E9B}\u{6DF1}\u{7EA2}\u{7D2B}\u{8272}\u{7684}\u{7EC6}\u{8109}\u{50CF}\u{8840}\u{7BA1}\u{4E00}\u{6837}\u{7A7F}\u{63D2}\u{5728}\u{5E72}\u{6D89}\u{8272}\u{6781}\u{9AD8}\u{FF08}\u{5982}\u{7480}\u{74A8}\u{7684}\u{7FE0}\u{7EFF}\u{3001}\u{9752}\u{8272}\u{3001}\u{54C1}\u{7EA2}\u{FF09}\u{7684}\u{6A44}\u{6984}\u{77F3}\u{6676}\u{7C92}\u{4E2D}\u{FF0C}\u{4E0E}\u{5468}\u{56F4}\u{7684}\u{8F89}\u{77F3}\u{548C}\u{659C}\u{957F}\u{77F3}\u{6784}\u{6210}\u{5BF9}\u{6BD4}\u{6781}\u{5176}\u{5F3A}\u{70C8}\u{7684}\u{7EDA}\u{4E3D}\u{753B}\u{9762}\u{3002}
  `
};


// ==========================================
// 🌌 核心知识库 - 通用强原生鉴定框架 (Universal Native Identification Framework)
// 这个模块的目标是极大程度释放大型多模态模型(LMM)的原生岩石矿物识别能力，
// 摒弃“死记硬背”式的冗长约束，代之以“结构化观察与防错思维链”。
// ==========================================
const $e093eb202b0e1c8b$export$374bf1eca0540eb5 = {
    roleDefinition: `\u{4F60}\u{662F}\u{4E00}\u{4F4D}\u{6BBF}\u{5802}\u{7EA7}\u{7684}\u{5730}\u{8D28}\u{4E0E}\u{53E4}\u{751F}\u{7269}\u{5B66}\u{5BB6}\u{FF0C}\u{62E5}\u{6709}\u{8D85}\u{8FC7}50\u{5E74}\u{7684}\u{91CE}\u{5916}\u{52D8}\u{63A2}\u{3001}\u{504F}\u{5149}\u{663E}\u{5FAE}\u{955C}\u{5206}\u{6790}\u{4E0E}\u{6807}\u{672C}\u{9274}\u{5B9A}\u{7ECF}\u{9A8C}\u{3002}
  \u{4F60}\u{7684}\u{4EFB}\u{52A1}\u{662F}\u{51ED}\u{501F}\u{5353}\u{8D8A}\u{7684}\u{89C6}\u{89C9}\u{611F}\u{77E5}\u{80FD}\u{529B}\u{FF0C}\u{7ED3}\u{5408}\u{5730}\u{8D28}\u{6F14}\u{5316}\u{903B}\u{8F91}\u{FF0C}\u{63D0}\u{4F9B}\u{6700}\u{6743}\u{5A01}\u{3001}\u{5BA2}\u{89C2}\u{3001}\u{6781}\u{5177}\u{6DF1}\u{5EA6}\u{7684}\u{6807}\u{672C}\u{9274}\u{5B9A}\u{62A5}\u{544A}\u{3002}
  \u{8BF7}\u{8BB0}\u{4F4F}\u{FF1A}\u{81EA}\u{7136}\u{754C}\u{7684}\u{5CA9}\u{77F3}\u{77FF}\u{7269}\u{6210}\u{5343}\u{4E0A}\u{4E07}\u{FF0C}\u{4F60}\u{65E0}\u{9700}\u{6B7B}\u{8BB0}\u{786C}\u{80CC}\u{6240}\u{6709}\u{7C7B}\u{522B}\u{FF0C}\u{800C}\u{662F}\u{8981}\u{5229}\u{7528}\u{4F60}\u{5F3A}\u{5927}\u{7684}\u{77E5}\u{8BC6}\u{5E93}\u{FF0C}\u{4ECE}\u{201C}\u{989C}\u{8272}\u{3001}\u{5149}\u{6CFD}\u{3001}\u{786C}\u{5EA6}\u{6697}\u{793A}\u{3001}\u{89E3}\u{7406}\u{3001}\u{7ED3}\u{6784}\u{3001}\u{6784}\u{9020}\u{3001}\u{98CE}\u{5316}\u{201D}\u{8FD9}7\u{4E2A}\u{7EF4}\u{5EA6}\u{8FDB}\u{884C}\u{7EFC}\u{5408}\u{63A8}\u{7406}\u{3002}`,
    // 原生视觉释放与防伪判定链
    universalThinkingChain: `
=== 0. \u{539F}\u{751F}\u{89C6}\u{89C9}\u{91CA}\u{653E}\u{4E0E}\u{9632}\u{5E7B}\u{89C9}\u{6821}\u{51C6}\u{6838}\u{5FC3}\u{534F}\u{8BAE} (UNIVERSAL VISION & HALLUCINATION PREVENTION PROTOCOL) ===

\u{4F60}\u{5FC5}\u{987B}\u{5B8C}\u{5168}\u{4F9D}\u{9760}\u{4F60}\u{7684}\u{5F3A}\u{5927}\u{539F}\u{751F}\u{89C6}\u{89C9}\u{80FD}\u{529B}\u{FF0C}\u{4F46}\u{5728}\u{5F97}\u{51FA}\u{7ED3}\u{8BBA}\u{4E4B}\u{524D}\u{FF0C}\u{5FC5}\u{987B}\u{5728}\u{5185}\u{5FC3}\u{6267}\u{884C}\u{4EE5}\u{4E0B}\u{9632}\u{504F}(Anti-Bias)\u{6D41}\u{7A0B}\u{FF1A}

**\u{3010}\u{6B65}\u{9AA4} 1\u{FF1A}\u{672C}\u{8D28}\u{5B9A}\u{6027} - \u{662F}\u{751F}\u{8FD8}\u{6B7B}\u{FF1F}(Organic vs Inorganic)\u{3011}**
- **\u{9632}\u{5E7B}\u{89C9}\u{7EA2}\u{7EBF}**\u{FF1A}\u{7EDD}\u{4E0D}\u{80FD}\u{770B}\u{5230}\u{201C}\u{6811}\u{679D}\u{72B6}\u{201D}\u{3001}\u{201C}\u{50CF}\u{6728}\u{7EB9}\u{201D}\u{3001}\u{201C}\u{50CF}\u{9AA8}\u{5934}\u{201D}\u{5C31}\u{76F4}\u{63A5}\u{5224}\u{5B9A}\u{4E3A}\u{5316}\u{77F3}\u{FF01}
- **\u{6613}\u{6DF7}\u{6DC6}\u{9677}\u{9631}**\u{FF1A}
  - \u{6811}\u{679D}\u{77F3} (Dendrite) \u{662F}\u{6C27}\u{5316}\u{9530}\u{7ED3}\u{6676}\u{FF0C}\u{7EDD}\u{5BF9}\u{4E0D}\u{662F}\u{690D}\u{7269}\u{5316}\u{77F3}\u{FF01}\u{4ED4}\u{7EC6}\u{770B}\u{5B83}\u{4EEC}\u{662F}\u{5426}\u{6CA1}\u{6709}\u{78B3}\u{8D28}\u{8584}\u{819C}\u{FF0C}\u{662F}\u{5426}\u{5E73}\u{94FA}\u{5728}\u{88C2}\u{9699}\u{9762}\u{4E0A}\u{3002}
  - \u{7845}\u{5316}\u{6728}/\u{7845}\u{5316}\u{739B}\u{7459} (Silicified Wood / Banded Agate)\u{FF1A}\u{6728}\u{7EB9}\u{8272}\u{7684}\u{5E26}\u{72B6}\u{7ED3}\u{6784}\u{6781}\u{5927}\u{6982}\u{7387}\u{662F}\u{9690}\u{6676}\u{8D28}\u{77F3}\u{82F1}(\u{739B}\u{7459}/\u{7389}\u{9AD3})\u{7684}\u{5C42}\u{7EB9}\u{FF0C}\u{800C}\u{975E}\u{53CC}\u{58F3}\u{7C7B}(Bivalve)\u{5316}\u{77F3}\u{3002}\u{6CA1}\u{6709}\u{786E}\u{51FF}\u{7684}\u{751F}\u{7269}\u{89E3}\u{5256}\u{5B66}\u{7ED3}\u{6784}(\u{5982}\u{94F0}\u{5408}\u{9F7F}\u{3001}\u{751F}\u{957F}\u{7EBF}\u{4EA4}\u{5207})\u{7EDD}\u{5BF9}\u{4E0D}\u{80FD}\u{8BA4}\u{5B9A}\u{4E3A}\u{751F}\u{7269}\u{5316}\u{77F3}\u{3002}

**\u{3010}\u{6B65}\u{9AA4} 2\u{FF1A}\u{8B66}\u{60D5}\u{989C}\u{8272}\u{9677}\u{9631} - \u{8272}\u{76F8} vs \u{77FF}\u{7269}\u{672C}\u{8D28} (Color vs Essence)\u{3011}**
- **\u{9632}\u{5E7B}\u{89C9}\u{7EA2}\u{7EBF}**\u{FF1A}\u{7EDD}\u{4E0D}\u{80FD}\u{4EC5}\u{51ED}\u{989C}\u{8272}\u{65AD}\u{5B9A}\u{7279}\u{5B9A}\u{77FF}\u{7269}\u{FF01}
- **\u{6613}\u{6DF7}\u{6DC6}\u{9677}\u{9631}**\u{FF1A}
  - **\u{7EFF}\u{8272}\u{9677}\u{9631}**\u{FF1A}\u{770B}\u{5230}\u{8868}\u{9762}\u{5149}\u{6ED1}\u{7684}\u{7EFF}\u{8272}\u{9E45}\u{5375}\u{77F3}(\u{5982}\u{7384}\u{9752}\u{8272}\u{96E8}\u{82B1}\u{77F3}/\u{7EFF}\u{5CA9})\u{FF0C}\u{7EDD}\u{5BF9}\u{4E0D}\u{80FD}\u{56E0}\u{4E3A}\u{662F}\u{7EFF}\u{8272}\u{5C31}\u{76F4}\u{63A5}\u{9274}\u{5B9A}\u{4E3A}\u{5B54}\u{96C0}\u{77F3}(Malachite)\u{FF01}\u{5B54}\u{96C0}\u{77F3}\u{5FC5}\u{987B}\u{6709}\u{76AE}\u{58F3}\u{72B6}\u{3001}\u{8461}\u{8404}\u{72B6}\u{6784}\u{9020}\u{6216}\u{660E}\u{663E}\u{7684}\u{4E1D}\u{7EE2}\u{5149}\u{6CFD}\u{FF1B}\u{5982}\u{679C}\u{662F}\u{7ECF}\u{8FC7}\u{6C34}\u{6D41}\u{6253}\u{78E8}\u{7684}\u{81F4}\u{5BC6}\u{7845}\u{8D28}\u{5CA9}/\u{7EFF}\u{7247}\u{5CA9}\u{FF0C}\u{5B83}\u{5C31}\u{662F}\u{666E}\u{901A}\u{7684}\u{89C2}\u{8D4F}\u{77F3}\u{3002}
  - **\u{7EA2}\u{8272}/\u{9EC4}\u{8272}\u{9677}\u{9631}**\u{FF1A}\u{8868}\u{9762}\u{7EA2}\u{9EC4}\u{8272}\u{5F80}\u{5F80}\u{662F}\u{94C1}\u{79BB}\u{5B50}\u{7684}\u{6B21}\u{751F}\u{98CE}\u{5316}(\u{8910}\u{94C1}\u{77FF}\u{5316}/\u{8D64}\u{94C1}\u{77FF}\u{5316})\u{FF0C}\u{800C}\u{4E0D}\u{662F}\u{5B83}\u{672C}\u{8EAB}\u{5C31}\u{662F}\u{7EA2}\u{5B9D}\u{77F3}\u{6216}\u{9EC4}\u{7389}\u{3002}
  - **\u{900F}\u{660E}/\u{767D}\u{8272}\u{9677}\u{9631}**\u{FF1A}\u{900F}\u{660E}\u{4E14}\u{5448}\u{8109}\u{72B6}\u{7A7F}\u{63D2}\u{7684}\u{FF0C}\u{901A}\u{5E38}\u{53EA}\u{662F}\u{666E}\u{901A}\u{7684}\u{77F3}\u{82F1}\u{5CA9}(Quartzite)\u{6216}\u{65B9}\u{89E3}\u{77F3}(Calcite)\u{FF0C}\u{800C}\u{4E0D}\u{662F}\u{94BB}\u{77F3}\u{6216}\u{9AD8}\u{7EA7}\u{5B9D}\u{77F3}\u{3002}

**\u{3010}\u{6B65}\u{9AA4} 3\u{FF1A}\u{5149}\u{6CFD}\u{4E0E}\u{65AD}\u{53E3}\u{5206}\u{6790} - \u{6700}\u{8BDA}\u{5B9E}\u{7684}\u{8BC1}\u{636E} (Luster & Fracture)\u{3011}**
- \u{89C2}\u{5BDF}\u{6807}\u{672C}\u{7684}\u{65B0}\u{9C9C}\u{9762}(\u{5982}\u{679C}\u{53EF}\u{89C1})\u{6216}\u{53CD}\u{5149}\u{9762}\u{3002}
- \u{662F}\u{5178}\u{578B}\u{7684}\u{73BB}\u{7483}\u{5149}\u{6CFD}(Glassy)\u{3001}\u{6CB9}\u{8102}\u{5149}\u{6CFD}(Greasy\u{FF0C}\u{5982}\u{77F3}\u{82F1}\u{65AD}\u{53E3})\u{3001}\u{4E1D}\u{7EE2}\u{5149}\u{6CFD}(\u{5FAE}\u{5C0F}\u{4E91}\u{6BCD}\u{3001}\u{77F3}\u{68C9})\u{3001}\u{8FD8}\u{662F}\u{571F}\u{72B6}\u{5149}\u{6CFD}\u{FF1F}
- \u{5982}\u{679C}\u{5B83}\u{6709}\u{7740}\u{6781}\u{5176}\u{5149}\u{6ED1}\u{4E14}\u{81F4}\u{5BC6}\u{7684}\u{5F27}\u{5F62}\u{65AD}\u{53E3}(\u{8D1D}\u{58F3}\u{72B6}\u{65AD}\u{53E3} Conchoidal fracture)\u{FF0C}\u{5B83}\u{6781}\u{6709}\u{53EF}\u{80FD}\u{5BCC}\u{542B}\u{7845}\u{8D28}(\u{71E7}\u{77F3}\u{3001}\u{739B}\u{7459}\u{3001}\u{77F3}\u{82F1}\u{5CA9}\u{6216}\u{9ED1}\u{66DC}\u{5CA9})\u{3002}

**\u{3010}\u{6B65}\u{9AA4} 4\u{FF1A}\u{5730}\u{8D28}\u{6210}\u{56E0}\u{5012}\u{63A8} (Genetic Reverse Engineering)\u{3011}**
- \u{5982}\u{679C}\u{5B83}\u{6781}\u{5176}\u{5706}\u{6DA6}\u{FF0C}\u{6CA1}\u{6709}\u{4EFB}\u{4F55}\u{68F1}\u{89D2}\u{FF0C}\u{8BF4}\u{660E}\u{5B83}\u{7ECF}\u{5386}\u{4E86}\u{957F}\u{8DDD}\u{79BB}\u{7684}\u{6C34}\u{6D41}\u{642C}\u{8FD0}(\u{6CB3}\u{6D41}\u{5375}\u{77F3})\u{3002}\u{6CB3}\u{6D41}\u{91CC}\u{7684}\u{5375}\u{77F3}\u{5927}\u{591A}\u{662F}\u{6781}\u{5176}\u{575A}\u{786C}\u{7684}\u{7845}\u{8D28}\u{5CA9}\u{77F3}(\u{5982}\u{77F3}\u{82F1}\u{5CA9}\u{3001}\u{7389}\u{9AD3}\u{3001}\u{739B}\u{7459})\u{3002}
- \u{5982}\u{679C}\u{5177}\u{6709}\u{660E}\u{663E}\u{7684}\u{5E73}\u{884C}\u{5C42}\u{7406}(Bedding)\u{FF0C}\u{5927}\u{6982}\u{7387}\u{662F}\u{6C89}\u{79EF}\u{5CA9}(\u{9875}\u{5CA9}\u{3001}\u{7802}\u{5CA9})\u{3002}

**\u{3010}\u{6B65}\u{9AA4} 5\u{FF1A}\u{504F}\u{5149}\u{663E}\u{5FAE}\u{955C}\u{964D}\u{7EF4}\u{6253}\u{51FB} (Microscopic Validation - \u{5982}\u{679C}\u{63D0}\u{4F9B}\u{7684}\u{662F}\u{8584}\u{7247}\u{56FE})\u{3011}**
- \u{5982}\u{679C}\u{56FE}\u{7247}\u{662F}\u{5706}\u{5F62}\u{89C6}\u{573A}\u{6216}\u{5305}\u{542B}\u{5341}\u{5B57}\u{4E1D}\u{FF0C}\u{8BF4}\u{660E}\u{8FD9}\u{662F}\u{663E}\u{5FAE}\u{955C}\u{4E0B}\u{7684}\u{56FE}\u{7247}(\u{8584}\u{7247})\u{3002}
- **PPL(\u{5355}\u{504F}\u{5149})** \u{4E0B}\u{91CD}\u{70B9}\u{770B}\u{FF1A}\u{591A}\u{8272}\u{6027}(\u{5982}\u{9ED1}\u{4E91}\u{6BCD})\u{3001}\u{7A81}\u{8D77}\u{9AD8}\u{4F4E}(\u{5982}\u{77F3}\u{69B4}\u{5B50}\u{77F3}\u{662F}\u{6B63}\u{9AD8}\u{7A81}\u{8D77})\u{3001}\u{89E3}\u{7406}\u{5F62}\u{6001}(\u{8F89}\u{77F3}\u{4E0E}\u{89D2}\u{95EA}\u{77F3}\u{7684}\u{89E3}\u{7406}\u{5939}\u{89D2}\u{5DEE}\u{5F02})\u{3002}
- **XPL(\u{6B63}\u{4EA4}\u{504F}\u{5149})** \u{4E0B}\u{91CD}\u{70B9}\u{770B}\u{FF1A}\u{5E72}\u{6D89}\u{8272}\u{7B49}\u{7EA7}(\u{5982}\u{77F3}\u{82F1}\u{7684}\u{4E00}\u{7EA7}\u{7070}\u{767D}\u{FF0C}\u{6A44}\u{6984}\u{77F3}/\u{7EFF}\u{5E18}\u{77F3}\u{7684}\u{4E8C}\u{4E09}\u{7EA7}\u{9C9C}\u{8273}\u{8272})\u{3001}\u{6D88}\u{5149}\u{89D2}\u{3001}\u{53CC}\u{6676}(\u{6781}\u{5176}\u{91CD}\u{8981}\u{7684}\u{659C}\u{957F}\u{77F3}\u{805A}\u{7247}\u{53CC}\u{6676})\u{3002}
`
};





const $116f6b541640fbf7$export$b77f614c4e70f925 = async (images, lang = 'zh', diagnosticFeedback, userId)=>{
    const langInstruction = lang === 'en' ? "CRITICAL: You MUST provide all text values in English. Maintain professional geological terminology." : "\u6838\u5FC3\u8981\u6C42\uFF1A\u4F60\u5FC5\u987B\u4F7F\u7528\u4E2D\u6587\u63D0\u4F9B\u6240\u6709\u6587\u672C\u503C\u3002\u4FDD\u6301\u4E13\u4E1A\u7684\u5730\u8D28\u5B66\u672F\u8BED\u3002";
    // 🧠 通用且强大的结构化思维流程 (Universal Chain of Thought)
    const systemInstruction = `
${(0, $e093eb202b0e1c8b$export$374bf1eca0540eb5).roleDefinition}

${langInstruction}

${(0, $e093eb202b0e1c8b$export$374bf1eca0540eb5).universalThinkingChain}

=== 1. \u{591A}\u{56FE}\u{7EFC}\u{5408}\u{7B56}\u{7565} (Multi-image Strategy) ===
- \u{5C06}\u{591A}\u{5F20}\u{56FE}\u{7247}\u{89C6}\u{4E3A}\u{540C}\u{4E00}\u{6807}\u{672C}\u{7684}\u{4E0D}\u{540C}\u{89D2}\u{5EA6}\u{6216}\u{4E0D}\u{540C}\u{5149}\u{7167}\u{6761}\u{4EF6}\u{3002}\u{5FC5}\u{987B}\u{8FDB}\u{884C}\u{4EA4}\u{53C9}\u{9A8C}\u{8BC1}\u{3002}
- \u{5BF9}\u{4E8E}\u{624B}\u{6807}\u{672C}\u{4E0E}\u{8584}\u{7247}\u{56FE}\u{5171}\u{6709}\u{7684}\u{60C5}\u{51B5}\u{FF0C}\u{8BF7}\u{786E}\u{4FDD}\u{5B8F}\u{89C2}\u{63A8}\u{65AD}\u{4E0E}\u{5FAE}\u{89C2}\u{5149}\u{5B66}\u{7279}\u{5F81}\u{FF08}\u{5982}\u{5E72}\u{6D89}\u{8272}\u{3001}\u{7A81}\u{8D77}\u{3001}\u{7ED3}\u{6784}\u{FF09}\u{7ED3}\u{8BBA}\u{4E92}\u{76F8}\u{5370}\u{8BC1}\u{3002}

=== 2. \u{663E}\u{5FAE}\u{504F}\u{5149}\u{4E13}\u{7CBE} (Optical Mineralogy & Thin Section Focus) ===
(\u{4EC5}\u{5728}\u{8F93}\u{5165}\u{5305}\u{542B}\u{504F}\u{5149}\u{663E}\u{5FAE}\u{955C}\u{56FE}\u{7247}\u{65F6}\u{4F18}\u{5148}\u{53C2}\u{8003})
${(0, $ea2d80c108efa255$export$60b2fd0609664cb1).opticalRules}

=== 3. \u{9274}\u{5B9A}\u{9632}\u{6577}\u{884D}\u{4E0E}\u{89C4}\u{8303}\u{7EAA}\u{5F8B} (CRITICAL SCHEMA COMPLIANCE) ===
- **\u{7B2C}\u{4E8C}\u{53EF}\u{80FD}\u{6027} (secondPossibility)**: \u{5982}\u{679C}\u{9274}\u{5B9A}\u{5B58}\u{7591}\u{FF0C}\u{901A}\u{8FC7}\u{7ED3}\u{6784}\u{5316}\u{7684}\u{903B}\u{8F91}\u{5FC5}\u{987B}\u{63D0}\u{4F9B}\u{66FF}\u{4EE3}\u{65B9}\u{6848}\u{FF0C}\u{7981}\u{6B62}\u{7559}\u{7A7A}\u{FF0C}\u{89E3}\u{91CA}\u{4F60}\u{4E3A}\u{4F55}\u{6392}\u{9664}\u{4E86}\u{7B2C}\u{4E00}\u{65B9}\u{6848}\u{800C}\u{8003}\u{8651}\u{5B83}\u{3002}
- **\u{5316}\u{77F3}\u{9632}\u{504F}\u{7EA2}\u{7EBF} (fossilAnalysis)**: \u{7EDD}\u{5BF9}\u{4E0D}\u{53EF}\u{7ED9}\u{7EAF}\u{65E0}\u{673A}\u{5CA9}\u{77F3}\u{6216}\u{5047}\u{5316}\u{77F3}\u{FF08}\u{5982}\u{6811}\u{679D}\u{77F3}\u{3001}\u{77F3}\u{82F1}\u{6761}\u{5E26}\u{739B}\u{7459}\u{FF09}\u{8F93}\u{51FA}\u{5316}\u{77F3}\u{62A5}\u{544A}\u{FF0C}\u{6781}\u{5EA6}\u{4E25}\u{683C}\u{8981}\u{6C42}\u{8FD4}\u{56DE} null\u{3002}\u{53EA}\u{6709}\u{89E3}\u{5256}\u{5B66}\u{610F}\u{4E49}\u{4E0A}\u{7684}\u{660E}\u{786E}\u{7279}\u{5F81}\u{624D}\u{53EF}\u{9274}\u{5B9A}\u{3002}
- **\u{65E0}\u{5E9F}\u{8BDD}\u{539F}\u{5219}**: geologicAge / environment / preservation \u{7B49}\u{5B57}\u{6BB5}\u{7981}\u{6B62}\u{8F93}\u{51FA}\u{201C}\u{5F85}\u{5206}\u{6790}\u{201D}\u{3001}\u{201C}\u{8BE6}\u{60C5}\u{89C1}\u{63CF}\u{8FF0}\u{201D}\u{7B49}\u{5360}\u{4F4D}\u{8BCD}\u{3002}\u{5FC5}\u{987B}\u{7ED3}\u{5408}\u{4F60}\u{7684}\u{63A8}\u{65AD}\u{7ED9}\u{51FA}\u{4E13}\u{4E1A}\u{5224}\u{65AD}\u{3002}
- **\u{7ECF}\u{6D4E}\u{4E0E}\u{627E}\u{77FF}\u{7279}\u{5F81}**: \u{5FC5}\u{987B}\u{5BA2}\u{89C2}\u{4E25}\u{8C28}\u{FF08}\u{5B57}\u{6570}>100\u{5B57}\u{FF09}\u{FF0C}\u{82E5}\u{65E0}\u{76F4}\u{63A5}\u{77FF}\u{4F53}\u{FF0C}\u{8BC4}\u{4EF7}\u{5176}\u{56F4}\u{5CA9}\u{3001}\u{5730}\u{8D28}\u{6D41}\u{4F53}\u{7EBF}\u{7D22}\u{6216}\u{666E}\u{901A}\u{77F3}\u{7070}\u{3001}\u{5EFA}\u{7B51}\u{6750}\u{6599}\u{4EF7}\u{503C}\u{FF0C}\u{5404}\u{4E2A}\u{5B50}\u{7EF4}\u{5EA6}\u{7EDD}\u{5BF9}\u{4E0D}\u{7559}\u{7A7A}\u{FF01}
- **\u{4EA4}\u{4E92}\u{8BCA}\u{65AD}**: \u{8BF7}\u{7ED9}\u{51FA}2\u{4E2A}\u{5728}\u{5F53}\u{524D}\u{56FE}\u{7247}\u{5224}\u{65AD}\u{4E0B}\u{FF0C}\u{6700}\u{5177}\u{6392}\u{4ED6}\u{6027}\u{7684}\u{7269}\u{7406}/\u{5316}\u{5B66}\u{6D4B}\u{8BD5}\u{5EFA}\u{8BAE}\u{FF08}\u{5982}\u{786C}\u{5EA6}\u{3001}\u{76D0}\u{9178}\u{8BD5}\u{9A8C}\u{7B49}\u{FF09}\u{3002}
`;
    try {
        // Create an abort controller with a relatively long timeout (e.g. 180 seconds)
        // and implement a retry mechanism specifically for network failures
        const fetchWithRetry = async (url, options, maxRetries = 2)=>{
            for(let i = 0; i < maxRetries; i++)try {
                const controller = new AbortController();
                // Increased to 180s (3 mins) because advanced rock diagnosis takes time
                const timeoutId = setTimeout(()=>controller.abort(), 180000);
                const res = await fetch(url, {
                    ...options,
                    signal: controller.signal
                });
                clearTimeout(timeoutId);
                return res;
            } catch (err) {
                const errString = String(err).toLowerCase();
                // Only retry on network errors or timeouts, NOT on server 4xx/5xx responses
                if (i < maxRetries - 1 && (errString.includes('failed to fetch') || errString.includes('network error') || errString.includes('abort'))) {
                    console.warn(`Network glitch detected. Retrying request (${i + 1}/${maxRetries})...`);
                    // Wait 2 seconds before retrying
                    await new Promise((resolve)=>setTimeout(resolve, 2000));
                    continue;
                }
                // Enhance the abort error message for UI
                if (errString.includes('abort')) throw new Error("\u9274\u5B9A\u8017\u65F6\u8FC7\u957F\uFF0C\u7F51\u7EDC\u8FDE\u63A5\u5DF2\u65AD\u5F00\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002");
                throw err;
            }
            throw new Error('Max retries reached');
        };
        const response = await fetchWithRetry('/api/identify', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                images: images,
                lang: lang,
                systemInstruction: systemInstruction + "\n\nCRITICAL: You MUST output fields in the specified order.",
                responseSchema: (0, $0421630fc903b30b$export$76aaafdc9c64593d),
                diagnosticFeedback: diagnosticFeedback,
                userId: userId
            })
        });
        if (!response.ok) {
            let errorMsg = `Server Error (${response.status})`;
            try {
                const errorData = await response.json();
                errorMsg = errorData.error || errorMsg;
            } catch  {
                // If not JSON, try to get text or just use status
                const text = await response.text().catch(()=>"");
                if (text.includes("<!doctype html>") || text.includes("<html>")) errorMsg = "\u670D\u52A1\u5668\u6682\u65F6\u4E0D\u53EF\u7528 (502/504) \u6216\u56FE\u7247\u4F53\u79EF\u8FC7\u5927\u88AB\u62E6\u622A\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002";
                else if (text) errorMsg = text.slice(0, 100);
            }
            throw new Error(errorMsg);
        }
        const result = await response.json();
        const text = result.text || "";
        if (!text) throw new Error("AI \u9274\u5B9A\u672A\u80FD\u751F\u6210\u6709\u6548\u6587\u672C\u3002");
        // 尝试解析并修复可能的截断 JSON
        let parsedData;
        try {
            parsedData = JSON.parse(text);
        } catch  {
            try {
                const repairedText = $116f6b541640fbf7$var$tryRepairJson(text);
                parsedData = JSON.parse(repairedText);
                console.warn("JSON was repaired successfully.");
            } catch  {
                console.error("JSON Parse Error. Raw text:", text);
                throw new Error("AI \u8FD4\u56DE\u7684\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u89E3\u6790\u5931\u8D25\u3002");
            }
        }
        // 深度兼容：合并可能被包裹在子 key 中的数据
        let finalData = {
            ...parsedData
        };
        const wrapperKeys = [
            'rock_analysis',
            'analysis',
            'data',
            'result',
            'rockAnalysis',
            'rock'
        ];
        for (const key of wrapperKeys)if (parsedData[key] && typeof parsedData[key] === 'object') finalData = {
            ...finalData,
            ...parsedData[key]
        };
        // 深度兼容：递归查找任何对象，如果它包含 'name' 和 'category'，则认为它是核心数据
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const findCoreData = (obj)=>{
            if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return null;
            // 增加对多种字段名的兼容，防止 AI 幻觉
            const nameVal = obj.name || obj.rockName || obj.title || obj.identification;
            const catVal = obj.category || obj.type || obj.classification;
            if (nameVal && catVal && (obj.detailedDescription || obj.formationReason)) return {
                ...obj,
                name: nameVal,
                category: catVal
            };
            for (const key of Object.keys(obj)){
                const found = findCoreData(obj[key]);
                if (found) return found;
            }
            return null;
        };
        const extractedCore = findCoreData(parsedData);
        if (extractedCore) finalData = {
            ...finalData,
            ...extractedCore
        };
        // 如果还是找不到核心字段，尝试在顶级字段中寻找兼容名
        if (!finalData.name) finalData.name = parsedData.rockName || parsedData.title || parsedData.identification;
        if (!finalData.category) finalData.category = parsedData.rockCategory || parsedData.type || parsedData.classification;
        // 确保字段完整性，防止 UI 崩溃
        return $116f6b541640fbf7$var$ensureAllFields(finalData);
    } catch (err) {
        console.error("Identification failed:", err);
        throw err;
    }
};
/**
 * 尝试修复截断或不完整的 JSON 字符串
 */ const $116f6b541640fbf7$var$tryRepairJson = (json)=>{
    let repaired = json.trim();
    // 清理可能存在的 Markdown 代码块包裹
    repaired = repaired.replace(/^```json\n?/, '').replace(/\n?```$/, '').trim();
    // 如果已经闭合，直接返回
    if (repaired.endsWith('}')) return repaired;
    // 1. 处理截断在字符串内部的情况
    let quoteCount = 0;
    for(let i = 0; i < repaired.length; i++)if (repaired[i] === '"' && (i === 0 || repaired[i - 1] !== '\\')) quoteCount++;
    if (quoteCount % 2 !== 0) repaired += '"';
    // 2. 移除末尾可能的逗号或未完成的键值对
    repaired = repaired.replace(/,\s*"[^"]*"\s*:\s*[^,}]*$/, '');
    repaired = repaired.replace(/,\s*"[^"]*"\s*$/, '');
    repaired = repaired.replace(/,\s*$/, '');
    // 3. 补全缺失的括号
    const stack = [];
    for(let i = 0; i < repaired.length; i++){
        const char = repaired[i];
        if (char === '{') stack.push('}');
        else if (char === '[') stack.push(']');
        else if (char === '}' || char === ']') {
            if (stack.length > 0 && stack[stack.length - 1] === char) stack.pop();
        }
    }
    while(stack.length > 0)repaired += stack.pop();
    return repaired;
};
/**
 * 确保返回的对象包含所有必需的字段，防止 UI 崩溃
 */ const $116f6b541640fbf7$var$ensureAllFields = (data)=>{
    const defaults = {
        name: "\u9274\u5B9A\u7ED3\u679C (\u90E8\u5206)",
        englishName: "Identification Result (Partial)",
        category: "\u5206\u6790\u4E2D...",
        isThinSection: false,
        grainSize: "",
        textureAndStructure: "",
        minerals: [],
        hardness: "",
        weathering: "",
        colorCause: "",
        alteration: "",
        metamorphism: "",
        formationReason: "",
        geologicalContext: "",
        detailedDescription: "",
        confidenceScore: 0,
        diagnosticTests: [],
        secondPossibility: null,
        economicAnalysis: {
            alterationMapping: "",
            mineralIndicators: "",
            structuralControl: "",
            prospectingPotential: ""
        },
        microscopicAnalysis: {
            texture: "",
            xplFeatures: "",
            pplFeatures: "",
            inference: ""
        },
        fossilAnalysis: null
    };
    // 深度合并
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        ...defaults,
        ...data
    };
    // 矿物字段兼容处理：确保是数组
    if (data.minerals) {
        if (typeof data.minerals === 'string') result.minerals = data.minerals.split(/[，,、\s]+/).filter(Boolean);
        else if (Array.isArray(data.minerals)) result.minerals = data.minerals.map((m)=>String(m));
    }
    // ==== 修复经济地质和微观分析的强制渲染文本 ====
    const rawEco = result.economicAnalysis || {};
    result.economicAnalysis = {
        alterationMapping: rawEco.alterationMapping || "\u5C1A\u672A\u53D1\u73B0\u660E\u663E\u7684\u9274\u522B\u6027\u8680\u53D8\u7279\u5F81\uFF0C\u6216\u9700\u8981\u8FDB\u4E00\u6B65\u91C7\u6837\u5206\u6790\u3002",
        mineralIndicators: rawEco.mineralIndicators || "\u65E0\u7279\u6B8A\u6307\u793A\u77FF\u7269\uFF0C\u53EF\u7ED3\u5408\u533A\u57DF\u5730\u8D28\u8D44\u6599\u8F85\u52A9\u5224\u65AD\u3002",
        structuralControl: rawEco.structuralControl || "\u6837\u672C\u5C42\u9762\u672A\u89C1\u5178\u578B\u7684\u63A7\u77FF\u6784\u9020\u75D5\u8FF9\u3002",
        prospectingPotential: rawEco.prospectingPotential || "\u8BE5\u6837\u672C\u6240\u5C5E\u5CA9\u76F8\u5728\u5468\u8FB9\u53EF\u80FD\u5177\u6709\u4E00\u5B9A\u52D8\u63A2\u610F\u4E49\uFF0C\u9700\u7ED3\u5408\u5316\u63A2\u6570\u636E\u7EFC\u5408\u8BC4\u4EF7\u3002"
    };
    const rawMicro = result.microscopicAnalysis || {};
    result.microscopicAnalysis = {
        texture: rawMicro.texture || "\u5E38\u89C4\u663E\u5FAE\u7ED3\u6784\u7279\u5F81\u3002",
        xplFeatures: rawMicro.xplFeatures || "\u6B63\u4EA4\u504F\u5149\u4E0B\u7279\u5F81\u4E0D\u660E\u663E\u6216\u672A\u505A\u7279\u6B8A\u8BB0\u5F55\u3002",
        pplFeatures: rawMicro.pplFeatures || "\u5355\u504F\u5149\u4E0B\u7279\u5F81\u89C1\u6B63\u6587\u63CF\u8FF0\u3002",
        inference: rawMicro.inference || "\u5FAE\u89C2\u63A8\u65AD\u4E0E\u5B8F\u89C2\u7279\u5F81\u57FA\u672C\u4E00\u81F4\u3002"
    };
    // 清理无效的诊断测试
    if (Array.isArray(result.diagnosticTests)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    result.diagnosticTests = result.diagnosticTests.filter((t)=>t && typeof t === 'object' && t.test && t.test.trim() !== '');
    if (!result.diagnosticTests || result.diagnosticTests.length === 0) result.diagnosticTests = [
        {
            test: "\u786C\u5EA6\u6D4B\u8BD5 (Hardness Test)",
            instruction: "\u5C1D\u8BD5\u7528\u6307\u7532\u3001\u94DC\u5E01\u6216\u94A2\u5200\u523B\u5212\u6837\u672C\u65B0\u9C9C\u9762\u3002",
            expected: "\u8BB0\u5F55\u662F\u5426\u80FD\u7559\u4E0B\u5212\u75D5\uFF0C\u4EE5\u8BC4\u4F30\u6469\u6C0F\u786C\u5EA6\u7EA7\u522B\u3002"
        },
        {
            test: "\u5149\u6CFD\u4E0E\u6761\u75D5 (Luster & Streak)",
            instruction: "\u5728\u81EA\u7136\u5149\u4E0B\u89C2\u5BDF\u53CD\u5149\u60C5\u51B5\uFF0C\u5E76\u5728\u65E0\u91C9\u767D\u74F7\u677F\u4E0A\u7528\u529B\u5212\u51FA\u7C89\u672B\uFF08\u6761\u75D5\uFF09\u3002",
            expected: "\u8BB0\u5F55\u6761\u75D5\u7684\u989C\u8272\u53CA\u5149\u6CFD\u7C7B\u578B\uFF08\u5982\u91D1\u5C5E\u5149\u6CFD\u3001\u73BB\u7483\u5149\u6CFD\u7B49\uFF09\u3002"
        }
    ];
    // 严谨判断是否为化石，防止空对象 {} 误判
    const hasFossilCategory = result.category && typeof result.category === 'string' && result.category.includes("\u5316\u77F3");
    const hasFossilName = result.name && typeof result.name === 'string' && (result.name.includes("\u5316\u77F3") || result.englishName && result.englishName.toLowerCase().includes('fossil'));
    const hasFossilData = data.fossilAnalysis && typeof data.fossilAnalysis === 'object' && Object.values(data.fossilAnalysis).some((val)=>typeof val === 'string' && val.trim() !== '');
    if (hasFossilCategory || hasFossilName || hasFossilData) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const rawFossil = data.fossilAnalysis || {};
        result.fossilAnalysis = {
            fossilType: rawFossil.fossilType || "\u53E4\u751F\u7269\u5316\u77F3",
            genusSpecies: rawFossil.genusSpecies || "\u5F85\u5B9A (Genus species pending)",
            geologicalAge: rawFossil.geologicalAge || "\u5F85\u5206\u6790",
            preservation: rawFossil.preservation || "\u89C1\u56FE",
            environment: rawFossil.environment || "\u6C89\u79EF\u73AF\u5883",
            description: rawFossil.description || "\u68C0\u6D4B\u5230\u5316\u77F3\u7279\u5F81\uFF0C\u8BF7\u7ED3\u5408\u5730\u5C42\u80CC\u666F\u8FDB\u4E00\u6B65\u5206\u6790\u3002"
        };
    } else result.fossilAnalysis = null;
    return result;
}; // v7.0.1: 移除生图功能 (Removed generateThinSectionImage)


const $b7da56340adeac66$var$STORAGE_KEY = "stone_master_history_v1";
const $b7da56340adeac66$var$MAX_HISTORY_ITEMS = 50; // Keep local storage lightweight
const $b7da56340adeac66$var$THUMBNAIL_WIDTH = 300; // Small enough for storage, big enough for context
// Helper: Compress image to small thumbnail
const $b7da56340adeac66$var$createThumbnail = async (base64Image)=>{
    return new Promise((resolve)=>{
        const img = new Image();
        img.onload = ()=>{
            const canvas = document.createElement("canvas");
            const scale = $b7da56340adeac66$var$THUMBNAIL_WIDTH / img.width;
            canvas.width = $b7da56340adeac66$var$THUMBNAIL_WIDTH;
            canvas.height = img.height * scale;
            const ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                // Heavy compression (0.6 quality JPEG)
                resolve(canvas.toDataURL("image/jpeg", 0.6));
            } else resolve(base64Image); // Fallback (shouldn't happen)
        };
        img.src = base64Image;
    });
};
const $b7da56340adeac66$export$c5dcb0c84a36a24a = async (analysis, fullImage)=>{
    try {
        const thumbnail = await $b7da56340adeac66$var$createThumbnail(fullImage);
        const newItem = {
            id: Date.now().toString(),
            timestamp: Date.now(),
            data: analysis,
            thumbnail: thumbnail
        };
        const currentHistory = $b7da56340adeac66$export$f9582a3c130d9538();
        // Add to top, remove duplicates if any, limit size
        const updatedHistory = [
            newItem,
            ...currentHistory
        ].slice(0, $b7da56340adeac66$var$MAX_HISTORY_ITEMS);
        localStorage.setItem($b7da56340adeac66$var$STORAGE_KEY, JSON.stringify(updatedHistory));
        return updatedHistory;
    } catch (e) {
        console.error("Failed to save history (likely storage quota exceeded):", e);
        // Even if saving fails, return current history so UI doesn't break
        return $b7da56340adeac66$export$f9582a3c130d9538();
    }
};
const $b7da56340adeac66$export$f9582a3c130d9538 = ()=>{
    try {
        const stored = localStorage.getItem($b7da56340adeac66$var$STORAGE_KEY);
        return stored ? JSON.parse(stored) : [];
    } catch (e) {
        console.error("Failed to load history:", e);
        return [];
    }
};
const $b7da56340adeac66$export$bdbc3d990af5b3f9 = ()=>{
    localStorage.removeItem($b7da56340adeac66$var$STORAGE_KEY);
};
const $b7da56340adeac66$export$a6769ee681a31e21 = (id)=>{
    const current = $b7da56340adeac66$export$f9582a3c130d9538();
    const updated = current.filter((item)=>item.id !== id);
    localStorage.setItem($b7da56340adeac66$var$STORAGE_KEY, JSON.stringify(updated));
    return updated;
};


const $869dcad992ffb67a$export$150b732325d14d04 = {
    zh: {
        appName: "\u77F3\u5934\u5927\u4EBA",
        appSub: "Stone Master AI",
        history: "\u8BB0\u5F55\u672C",
        slogan: "\u8D70\u8FC7\u5C71\u6CB3\uFF0C\u8BFB\u61C2\u6C89\u9ED8",
        sloganSub: "\u4EBA\u4EBA\u90FD\u662F\u77F3\u5934\u5927\u4EBA",
        heroDesc: "\u62CD\u6444\u5CA9\u77F3\u3001\u77FF\u7269\u6676\u4F53\u6216\u5316\u77F3\u6837\u672C\uFF0C\u5373\u523B\u83B7\u53D6\u5730\u8D28\u7EA7\u4E13\u4E1A\u9274\u5B9A\u3002",
        uploadTitle: "\u4E0A\u4F20\u5CA9\u77F3\u7167\u7247",
        uploadSubtitle: "\u70B9\u51FB\u533A\u57DF\u6216\u62D6\u62FD\u4E0A\u4F20",
        album: "\u76F8\u518C",
        camera: "\u62CD\u7167",
        processing: "\u6B63\u5728\u4F18\u5316\u5CA9\u77F3\u6837\u672C\u56FE\u50CF...",
        analyzing: "\u77F3\u5934\u5927\u4EBA\u6B63\u5728\u901A\u8FC7\u653E\u5927\u955C\u89C2\u5BDF...",
        reset: "\u9274\u5B9A\u65B0\u6837\u672C",
        saveShare: "\u4FDD\u5B58 / \u5206\u4EAB\u8BC1\u4E66",
        generating: "\u6B63\u5728\u751F\u6210...",
        reportTitle: "\u5CA9\u77F3\u9274\u5B9A\u62A5\u544A",
        reportNo: "\u62A5\u544A\u7F16\u53F7",
        resultTitle: "\u9274\u5B9A\u7ED3\u679C",
        category: "\u5206\u7C7B",
        interpretation: "\u6210\u56E0",
        geoContext: "\u5730\u8D28\u80CC\u666F",
        alternative: "\u66FF\u4EE3\u65B9\u6848",
        diff: "\u533A\u522B",
        techData: "\u6280\u672F\u53C2\u6570",
        grain: "\u9897\u7C92",
        structure: "\u6784\u9020",
        hardness: "\u786C\u5EA6",
        weathering: "\u98CE\u5316",
        minerals: "\u77FF\u7269",
        metamorphism: "\u53D8\u8D28",
        colorOrigin: "\u6210\u8272",
        alteration: "\u8680\u53D8",
        economicTitle: "\u7ECF\u6D4E\u5730\u8D28\u4E0E\u627E\u77FF\u6F5C\u529B",
        alterationMap: "\u56F4\u5CA9\u8680\u53D8",
        indicators: "\u6307\u793A\u77FF\u7269",
        structuralControl: "\u6784\u9020\u63A7\u77FF",
        potential: "\u627E\u77FF\u6F5C\u529B\u8BC4\u4EF7",
        microTitleHand: "\u865A\u62DF\u5149\u8584\u7247",
        microTitleThin: "\u865A\u62DF\u624B\u6807\u672C",
        inferenceLabelHand: "\u5B8F\u5FAE\u6620\u5C04",
        inferenceLabelThin: "\u9006\u5411\u63A8\u7406",
        expertEval: "\u4E13\u5BB6\u8BC4\u4F30",
        verified: "\u5B98\u65B9\u9A8C\u8BC1",
        disclaimerTitle: "\u514D\u8D23\u58F0\u660E",
        disclaimer: "\u672C\u5E94\u7528\uFF08\u77F3\u5934\u5927\u4EBA\uFF09\u4F7F\u7528\u4EBA\u5DE5\u667A\u80FD\u6280\u672F\u5206\u6790\u56FE\u50CF\u7279\u5F81\uFF0C\u9274\u5B9A\u7ED3\u679C\u57FA\u4E8E\u89C6\u89C9\u4FE1\u606F\u63A8\u65AD\uFF0C\u4EC5\u4F9B\u5730\u8D28\u7231\u597D\u8005\u5B66\u4E60\u4E0E\u53C2\u8003\u3002AI \u9274\u5B9A\u53D7\u73AF\u5883\u5149\u7EBF\u3001\u62CD\u6444\u89D2\u5EA6\u53CA\u77FF\u7269\u7EC6\u5FAE\u7279\u5F81\u9650\u5236\uFF0C\u7ED3\u679C\u53EF\u80FD\u5B58\u5728\u8BEF\u5DEE\u3002\u5BF9\u4E8E\u6D89\u53CA\u8D35\u91CD\u5B9D\u77F3\u4EA4\u6613\u3001\u77FF\u6743\u5224\u5B9A\u7B49\u4E25\u8C28\u573A\u666F\uFF0C\u8BF7\u52A1\u5FC5\u4EE5\u4E13\u4E1A\u5730\u8D28\u5B9E\u9A8C\u5BA4\u7684\u5B9E\u7269\u68C0\u6D4B\u62A5\u544A\u4E3A\u51C6\u3002",
        historyTitle: "\u91CE\u5916\u8BB0\u5F55\u672C",
        historySub: "Digital Field Notebook",
        historyEmpty: "\u6682\u65E0\u9274\u5B9A\u8BB0\u5F55",
        historyEmptySub: "\u5FEB\u53BB\u63A2\u7D22\u7B2C\u4E00\u5757\u77F3\u5934\u5427\uFF01",
        clearHistory: "\u6495\u6389\u6240\u6709\u8BB0\u5F55",
        feature1Title: "\u5168\u5CA9\u77F3\u5927\u7C7B \u4E13\u5BB6\u5F15\u64CE",
        feature1Desc: "\u6DF1\u5EA6\u96C6\u6210\u5CA9\u6D46\u5CA9\u3001\u6C89\u79EF\u5CA9\u3001\u53D8\u8D28\u5CA9\u53CA\u7279\u6B8A\u77FF\u7269\u5224\u636E\u3002\u6DB5\u76D6\u4ECE\u9646\u6E90\u788E\u5C51\u5230\u9AD8\u538B\u53D8\u8D28\u7684\u5B8C\u6574\u903B\u8F91\u4F53\u7CFB\u3002",
        feature2Title: "\u5730\u8D28\u4E13\u5BB6\u7EA7 \u6DF1\u5EA6\u89E3\u6790",
        feature2Desc: "\u4E0D\u6B62\u4E8E\u5206\u7C7B\uFF0C\u66F4\u80FD\u6D1E\u5BDF\u7EC6\u8282\u3002\u6DF1\u5EA6\u89E3\u6790\u77FF\u7269\u7EC4\u5408\u3001\u9897\u7C92\u8FB9\u754C\u3001\u6784\u9020\u7279\u5F81\uFF0C\u63ED\u793A\u5730\u7403\u6F14\u53D8\u5BC6\u7801\u3002",
        feature3Title: "\u4E13\u4E1A\u6807\u51C6\u5316 \u9274\u5B9A\u8BC1\u4E66",
        feature3Desc: "\u751F\u6210\u5305\u542B\u5CA9\u77F3\u5206\u7C7B\u3001\u6210\u5206\u3001\u6210\u56E0\u53CA\u5730\u8D28\u80CC\u666F\u7684\u6807\u51C6\u5316\u4E13\u5BB6\u62A5\u544A\u3002\u652F\u6301\u9AD8\u6E05\u4FDD\u5B58\u4E0E\u793E\u4EA4\u5206\u4EAB\u3002",
        errorTitle: "\u9274\u5B9A\u4E2D\u65AD",
        errorGeneric: "\u9274\u5B9A\u670D\u52A1\u6682\u65F6\u4E0D\u53EF\u7528\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5\u3002",
        heicError: "HEIC \u56FE\u7247\u8F6C\u6362\u5931\u8D25\uFF0C\u8BF7\u5C1D\u8BD5\u4F7F\u7528 JPG \u6216 PNG \u683C\u5F0F\u3002",
        saveTipTitle: "\u5982\u4F55\u4FDD\u5B58\u5230\u76F8\u518C\uFF1F",
        saveTipDesc: "\u7531\u4E8E\u7CFB\u7EDF\u5B89\u5168\u9650\u5236\uFF0C\u8BF7\u957F\u6309\u4E0B\u65B9\u56FE\u7247\uFF0C\u5728\u5F39\u51FA\u7684\u83DC\u5355\u4E2D\u9009\u62E9\u201C\u5B58\u50A8\u56FE\u50CF\u201D\u6216\u201C\u53D1\u9001\u7ED9\u670B\u53CB\u201D\u3002",
        copyImage: "\u590D\u5236\u56FE\u7247",
        copied: "\u5DF2\u590D\u5236",
        downloadFile: "\u4E0B\u8F7D\u6587\u4EF6",
        thinTag: "\u8584\u7247",
        potentialTag: "\u6709\u6F5C\u529B",
        multiUploadTitle: "\u591A\u56FE\u7EFC\u5408\u9274\u5B9A",
        multiUploadDesc: "\u652F\u6301\u4E0A\u4F20 PPL/XPL (\u8584\u7247) \u6216 \u5B8F\u89C2/\u5FAE\u89C2 (\u624B\u6807\u672C) \u7EC4\u5408\uFF0C\u63D0\u5347\u9274\u5B9A\u51C6\u786E\u5EA6\u3002",
        addMore: "\u6DFB\u52A0\u66F4\u591A\u56FE\u7247",
        analyzeNow: "\u5F00\u59CB\u7EFC\u5408\u9274\u5B9A",
        pplLabel: "\u5355\u504F\u5149 (PPL)",
        xplLabel: "\u6B63\u4EA4\u504F\u5149 (XPL)",
        macroLabel: "\u5B8F\u89C2\u5168\u666F",
        microLabel: "\u5C40\u90E8\u7EC6\u8282",
        imageCount: "\u5F20\u56FE\u7247",
        guideTitle: "\u9274\u5B9A\u4E13\u5BB6\u5EFA\u8BAE",
        guideHand: "\uD83D\uDCF8 \u624B\u6807\u672C\uFF1A\u4E0A\u4F20\u4E00\u5F20\u201C\u5168\u666F\u56FE\u201D\u548C\u4E00\u5F20\u201C\u5FAE\u8DDD\u7EC6\u8282\u56FE\u201D\uFF0CAI \u5C06\u8FDB\u884C\u5B8F\u5FAE\u6620\u5C04\u5206\u6790\u3002",
        guideThin: "\uD83D\uDD2C \u663E\u5FAE\u8584\u7247\uFF1A\u4E0A\u4F20\u540C\u4E00\u89C6\u57DF\u7684\u201C\u5355\u504F\u5149(PPL)\u201D\u548C\u201C\u6B63\u4EA4\u504F\u5149(XPL)\u201D\uFF0CAI \u5C06\u542F\u52A8\u5149\u6027\u77FF\u7269\u5B66\u4FA6\u63A2\u6A21\u5F0F\u3002",
        expertFeedback: "\u4E13\u5BB6\u7EA0\u504F",
        feedbackTitle: "\u63D0\u4EA4\u4E13\u5BB6\u4FEE\u6B63\u5EFA\u8BAE",
        feedbackCorrectName: "\u6B63\u786E\u5CA9\u77F3\u540D\u79F0",
        feedbackReason: "\u4FEE\u6B63\u7406\u7531 (\u5982\uFF1A\u89C2\u5BDF\u5230\u7279\u5F81 X\uFF0C\u800C\u975E Y)",
        feedbackSubmit: "\u63D0\u4EA4\u4FEE\u6B63",
        feedbackSuccess: "\u611F\u8C22\u60A8\u7684\u53CD\u9988\uFF01\u6211\u4EEC\u5C06\u4EE5\u6B64\u6821\u51C6\u77E5\u8BC6\u5E93\u3002",
        distillTitle: "\u6848\u4F8B\u63D0\u70BC\u52A9\u624B",
        distillDesc: "\u5C06\u91CE\u5916\u53D1\u73B0\u8F6C\u5316\u4E3A\u6807\u51C6\u5316\u7684\u9274\u5B9A\u5224\u636E (Case Rules)\u3002",
        distillPrompt: "\u8BF7\u6839\u636E\u6B64\u6848\u4F8B\u63D0\u70BC\u51FA\u4E00\u6761\u6838\u5FC3\u9274\u5B9A\u51C6\u5219...",
        limitReached: "\u9274\u5B9A\u989D\u5EA6\u5DF2\u7528\u5B8C",
        limitReachedSub: "\u8BF7\u8865\u5145\u9274\u5B9A\u989D\u5EA6\u4EE5\u7EE7\u7EED\u4F7F\u7528\u77F3\u5934\u5927\u4EBA\u3002",
        upgradePro: "\u83B7\u53D6\u4E13\u4E1A\u989D\u5EA6",
        remainingTries: "\u4ECA\u65E5\u5269\u4F59\u514D\u8D39\u6B21\u6570",
        unlimited: "\u65E0\u9650\u6B21",
        proActive: "\u4E13\u4E1A\u7248\u5DF2\u6FC0\u6D3B",
        enterCode: "\u8F93\u5165\u6FC0\u6D3B\u7801",
        redeem: "\u6FC0\u6D3B",
        redeemSuccess: "\u6FC0\u6D3B\u6210\u529F\uFF01\u989D\u5EA6\u5DF2\u66F4\u65B0\u3002",
        invalidCode: "\u65E0\u6548\u7684\u6FC0\u6D3B\u7801\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3002",
        buyPro: "\u626B\u7801\u652F\u4ED8 30 \u5143\u83B7\u53D6 100 \u6B21\u9274\u5B9A\u989D\u5EA6",
        orderRemark: "\u652F\u4ED8\u6210\u529F\u540E\uFF0C\u8BF7\u5728\u652F\u4ED8\u5B9D\u7559\u8A00\u4E2D\u7559\u610F\u6211\u4EEC\u53D1\u653E\u7684\u6FC0\u6D3B\u7801",
        contactSupport: "\u8054\u7CFB\u5BA2\u670D\u83B7\u53D6\u6FC0\u6D3B\u7801",
        creditsRemaining: "\u5269\u4F59\u9274\u5B9A\u989D\u5EA6",
        confidence: "\u7F6E\u4FE1\u5EA6",
        diagnosticTitle: "\u4EA4\u4E92\u5F0F\u8BCA\u65AD\u9762\u677F",
        diagnosticSub: "\u4E3A\u4E86\u63D0\u9AD8\u9274\u5B9A\u51C6\u786E\u5EA6\uFF0C\u8BF7\u6839\u636E\u4EE5\u4E0B\u5EFA\u8BAE\u8FDB\u884C\u5B9E\u5730\u7269\u7406\u6D4B\u8BD5\u5E76\u53CD\u9988\u7ED3\u679C\u3002",
        testResult: "\u6D4B\u8BD5\u7ED3\u679C\u53CD\u9988",
        diagnosticReady: "\u8BCA\u65AD\u4FE1\u606F\u5DF2\u5C31\u7EEA\uFF0C\u53EF\u4EE5\u8FDB\u884C\u4E8C\u6B21\u6821\u51C6",
        diagnosticPending: "\u8BF7\u5B8C\u6210\u6240\u6709\u5EFA\u8BAE\u7684\u7269\u7406\u6D4B\u8BD5",
        submitDiagnostic: "\u63D0\u4EA4\u6D4B\u8BD5\u7ED3\u679C\u5E76\u91CD\u65B0\u6821\u51C6",
        macroAppearance: "\u5B8F\u89C2\u5916\u89C2",
        macroStructure: "\u6784\u9020\u7279\u5F81",
        fossilTitle: "\u53E4\u751F\u7269\u5316\u77F3\u6863\u6848",
        fossilType: "\u5316\u77F3\u7C7B\u578B",
        genusSpecies: "\u5C5E\u79CD\u5EFA\u8BAE",
        geologicalAge: "\u5730\u8D28\u5E74\u4EE3",
        preservation: "\u4FDD\u5B58\u72B6\u6001",
        environment: "\u73AF\u5883\u63A8\u65AD",
        fossilDesc: "\u5316\u77F3\u63CF\u8FF0"
    },
    en: {
        appName: "Stone Master",
        appSub: "Stone Master AI",
        history: "Notebook",
        slogan: "Read the silence of mountains",
        sloganSub: "Everyone is a Stone Master",
        heroDesc: "Capture rocks, minerals, or fossils for instant professional geological identification.",
        uploadTitle: "Upload Rock Photo",
        uploadSubtitle: "Click or drag to upload",
        album: "Gallery",
        camera: "Camera",
        processing: "Optimizing rock sample image...",
        analyzing: "Stone Master is observing through a loupe...",
        reset: "New Sample",
        saveShare: "Save / Share Report",
        generating: "Generating...",
        reportTitle: "Geological Report",
        reportNo: "Report No.",
        resultTitle: "Identification",
        category: "Category",
        interpretation: "Formation",
        geoContext: "Geology Context",
        alternative: "Alternative",
        diff: "Difference",
        techData: "Technical Data",
        grain: "Grain",
        structure: "Structure",
        hardness: "Hardness",
        weathering: "Weathering",
        minerals: "Minerals",
        metamorphism: "Metamorphism",
        colorOrigin: "Color Cause",
        alteration: "Alteration",
        economicTitle: "Economic & Prospecting",
        alterationMap: "Alteration Mapping",
        indicators: "Indicator Minerals",
        structuralControl: "Structural Control",
        potential: "Prospecting Potential",
        microTitleHand: "Virtual Thin Section",
        microTitleThin: "Virtual Hand Specimen",
        inferenceLabelHand: "Macro \u2192 Micro Mapping",
        inferenceLabelThin: "Micro \u2192 Macro Inference",
        expertEval: "Expert Evaluation",
        verified: "VERIFIED",
        disclaimerTitle: "Disclaimer",
        disclaimer: "This app (Stone Master) uses AI to analyze geological features based on visual data. Results are for educational purposes. AI identification may be affected by lighting and angles. For commercial valuation or legal mining claims, please consult a certified geological laboratory.",
        historyTitle: "Field Notebook",
        historySub: "Digital Field Notebook",
        historyEmpty: "No Records Yet",
        historyEmptySub: "Go explore your first rock!",
        clearHistory: "Clear All Records",
        feature1Title: "Expert Rock Engine",
        feature1Desc: "Integrated criteria for Igneous, Sedimentary, and Metamorphic rocks. Covering systems from clastic to high-pressure metamorphism.",
        feature2Title: "Professional Analysis",
        feature2Desc: "Deep analysis of mineral assemblages, grain boundaries, and structures to reveal geological history.",
        feature3Title: "Standardized Certificate",
        feature3Desc: "Generate professional reports with classification, components, and genesis. High-res export for sharing.",
        errorTitle: "Analysis Failed",
        errorGeneric: "Service temporarily unavailable, please try again later.",
        heicError: "HEIC conversion failed. Please use JPG or PNG.",
        saveTipTitle: "How to save?",
        saveTipDesc: "Due to system limits, please long-press the image below and select 'Save Image' or 'Send to Friend'.",
        copyImage: "Copy Image",
        copied: "Copied",
        downloadFile: "Download",
        thinTag: "Thin Section",
        potentialTag: "Potential",
        multiUploadTitle: "Multi-Image Analysis",
        multiUploadDesc: "Upload PPL/XPL (Thin Section) or Macro/Micro (Hand Specimen) for higher accuracy.",
        addMore: "Add More Images",
        analyzeNow: "Analyze Now",
        pplLabel: "PPL",
        xplLabel: "XPL",
        macroLabel: "Macro View",
        microLabel: "Micro Detail",
        imageCount: "images",
        guideTitle: "Expert Tips",
        guideHand: "\uD83D\uDCF8 Hand Specimen: Upload a 'Macro View' and a 'Micro Detail' for macro-micro mapping.",
        guideThin: "\uD83D\uDD2C Thin Section: Upload 'PPL' and 'XPL' of the same view to trigger Petrography Detective mode.",
        expertFeedback: "Expert Correction",
        feedbackTitle: "Submit Expert Correction",
        feedbackCorrectName: "Correct Rock Name",
        feedbackReason: "Reason (e.g., observed feature X instead of Y)",
        feedbackSubmit: "Submit",
        feedbackSuccess: "Thank you! We will use this to calibrate our knowledge base.",
        distillTitle: "Case Distiller",
        distillDesc: "Transform field findings into standardized Case Rules.",
        distillPrompt: "Please distill a core identification rule from this case...",
        limitReached: "Credits Exhausted",
        limitReachedSub: "Please get an activation code to continue using Stone Master.",
        upgradePro: "Get Credits",
        remainingTries: "Free tries remaining today",
        unlimited: "Unlimited",
        proActive: "Pro Active",
        enterCode: "Enter Activation Code",
        redeem: "Redeem",
        redeemSuccess: "Activation successful! Credits updated.",
        invalidCode: "Invalid code, please try again.",
        buyPro: "Scan to pay 30 RMB for 100 credits",
        orderRemark: "Please check your Alipay messages for the activation code after payment",
        contactSupport: "Contact Support for Code",
        creditsRemaining: "Credits remaining",
        confidence: "Confidence",
        diagnosticTitle: "Interactive Diagnostic Panel",
        diagnosticSub: "To improve accuracy, please perform the following physical tests and provide feedback.",
        testResult: "Test Result Feedback",
        diagnosticReady: "Diagnostic data ready for recalibration",
        diagnosticPending: "Please complete all suggested physical tests",
        submitDiagnostic: "Submit Results & Recalibrate",
        macroAppearance: "Macro Appearance",
        macroStructure: "Macro Structure",
        fossilTitle: "Fossil Archive",
        fossilType: "Fossil Type",
        genusSpecies: "Genus & Species",
        geologicalAge: "Geological Age",
        preservation: "Preservation",
        environment: "Environment",
        fossilDesc: "Fossil Description"
    }
};




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $db42588f972bc829$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const $db42588f972bc829$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const $db42588f972bc829$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = $db42588f972bc829$export$86f54f62aa7a7514(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const $db42588f972bc829$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const $db42588f972bc829$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};


/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $db42588f972bc829$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $db42588f972bc829$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $db42588f972bc829$export$3d46f4579dba46e5)(`lucide-${(0, $db42588f972bc829$export$73bda83cddbc7187)((0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $db42588f972bc829$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $44f0dae468c97d23$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
            key: "1yiouv"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "8",
            r: "6",
            key: "1vp47v"
        }
    ]
];
const $44f0dae468c97d23$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("award", $44f0dae468c97d23$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7fca19d3fce363c2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
            key: "18u6gg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "13",
            r: "3",
            key: "1vg3eu"
        }
    ]
];
const $7fca19d3fce363c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("camera", $7fca19d3fce363c2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5f4bdaa89ec695b9$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "3",
            rx: "2",
            ry: "2",
            key: "1m3agn"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "9",
            r: "2",
            key: "af1f0g"
        }
    ],
    [
        "path",
        {
            d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
            key: "1xmnt7"
        }
    ]
];
const $5f4bdaa89ec695b9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("image", $5f4bdaa89ec695b9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $39f04136db3724b2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $39f04136db3724b2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("loader-circle", $39f04136db3724b2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4f68e7f5ef2ab511$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v12",
            key: "1x0j5s"
        }
    ],
    [
        "path",
        {
            d: "m17 8-5-5-5 5",
            key: "7q97r8"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ]
];
const $4f68e7f5ef2ab511$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("upload", $4f68e7f5ef2ab511$export$3efd853dbb351e94);



const $455b3fc5babd4649$export$cbafa1ad4452dd0d = ({ onImagesSelect: onImagesSelect, lang: lang })=>{
    const t = (0, $869dcad992ffb67a$export$150b732325d14d04)[lang];
    const fileInputRef = (0, $acw62.useRef)(null);
    const cameraInputRef = (0, $acw62.useRef)(null);
    const [isDragging, setIsDragging] = (0, $acw62.useState)(false);
    const [isConverting, setIsConverting] = (0, $acw62.useState)(false);
    const [selectedImages, setSelectedImages] = (0, $acw62.useState)([]);
    const resizeImage = (file)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            const url = URL.createObjectURL(file);
            img.onload = ()=>{
                URL.revokeObjectURL(url);
                try {
                    const canvas = document.createElement('canvas');
                    const MAX_WIDTH = 1000;
                    const MAX_HEIGHT = 1000;
                    let width = img.width;
                    let height = img.height;
                    if (width > height) {
                        if (width > MAX_WIDTH) {
                            height *= MAX_WIDTH / width;
                            width = MAX_WIDTH;
                        }
                    } else if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    if (!ctx) {
                        reject(new Error("Canvas context failed"));
                        return;
                    }
                    ctx.drawImage(img, 0, 0, width, height);
                    resolve(canvas.toDataURL('image/jpeg', 0.65));
                } catch (e) {
                    reject(e);
                }
            };
            img.onerror = (e)=>{
                URL.revokeObjectURL(url);
                console.error("Image load error details:", e);
                reject(new Error("Image load failed (\u56FE\u7247\u52A0\u8F7D\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u683C\u5F0F\u6216\u91CD\u8BD5)"));
            };
            img.src = url;
        });
    };
    const processFile = async (file)=>{
        const filename = file.name.toLowerCase();
        const isHeic = filename.endsWith('.heic') || filename.endsWith('.heif') || file.type === 'image/heic' || file.type === 'image/heif';
        if (!file.type.startsWith('image/') && !isHeic) {
            alert(lang === 'en' ? "Unsupported file format." : "\u4E0D\u652F\u6301\u7684\u6587\u4EF6\u683C\u5F0F\u3002\u8BF7\u4E0A\u4F20\u56FE\u7247\u6587\u4EF6\u3002");
            return;
        }
        setIsConverting(true);
        try {
            let fileToRead = file;
            if (isHeic) {
                const heic2any = window.heic2any;
                if (heic2any) try {
                    const convertedBlob = await heic2any({
                        blob: file,
                        toType: "image/jpeg",
                        quality: 0.7
                    });
                    const blob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;
                    fileToRead = new File([
                        blob
                    ], filename.replace(/\.(heic|heif)$/, ".jpg"), {
                        type: "image/jpeg"
                    });
                } catch (conversionError) {
                    console.error("HEIC Conversion failed:", conversionError);
                    alert(lang === 'zh' ? "HEIC \u56FE\u7247\u8F6C\u6362\u5931\u8D25\uFF0C\u8BF7\u5C1D\u8BD5\u622A\u56FE\u540E\u4E0A\u4F20\u3002" : "HEIC conversion failed. Please try uploading a screenshot.");
                    setIsConverting(false);
                    return;
                }
                else {
                    alert(lang === 'zh' ? "\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 HEIC \u683C\u5F0F\uFF0C\u8BF7\u5C1D\u8BD5\u4E0A\u4F20 JPG/PNG \u683C\u5F0F\u3002" : "HEIC not supported by browser. Please use JPG/PNG.");
                    setIsConverting(false);
                    return;
                }
            }
            try {
                // Resize and compress directly from File/Blob
                const resizedBase64 = await resizeImage(fileToRead);
                const finalMimeType = 'image/jpeg';
                const newImage = {
                    base64: resizedBase64,
                    mimeType: finalMimeType
                };
                setSelectedImages((prev)=>[
                        ...prev,
                        newImage
                    ]);
                setIsConverting(false);
            } catch (err) {
                console.error("Processing error:", err);
                const msg = err instanceof Error ? err.message : "\u56FE\u7247\u5904\u7406\u5931\u8D25";
                alert(lang === 'zh' ? `\u{56FE}\u{7247}\u{5904}\u{7406}\u{5931}\u{8D25}: ${msg}` : `Image processing failed: ${msg}`);
                setIsConverting(false);
            }
        } catch (err) {
            console.error(err);
            setIsConverting(false);
        }
    };
    const handleLabelChange = (index, label)=>{
        setSelectedImages((prev)=>prev.map((img, i)=>i === index ? {
                    ...img,
                    label: label
                } : img));
    };
    const removeImage = (index)=>{
        setSelectedImages((prev)=>prev.filter((_, i)=>i !== index));
    };
    const handleAnalyze = ()=>{
        if (selectedImages.length > 0) onImagesSelect(selectedImages);
    };
    const handleChange = (e)=>{
        if (e.target.files) Array.from(e.target.files).forEach((file)=>processFile(file));
        e.target.value = '';
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        setIsDragging(false);
        if (e.dataTransfer.files) Array.from(e.dataTransfer.files).forEach((file)=>processFile(file));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `relative w-full max-w-2xl mx-auto transition-all duration-300 ease-in-out
          ${isDragging ? 'scale-[1.02] border-amber-500 bg-amber-50' : 'hover:border-stone-400 bg-white'}
          border-2 border-dashed border-stone-300 rounded-2xl shadow-sm overflow-hidden group cursor-pointer`,
                onDragOver: (e)=>{
                    e.preventDefault();
                    setIsDragging(true);
                },
                onDragLeave: ()=>setIsDragging(false),
                onDrop: handleDrop,
                onClick: ()=>!isConverting && fileInputRef.current?.click(),
                children: [
                    isConverting && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "absolute inset-0 bg-white/90 z-50 flex flex-col items-center justify-center backdrop-blur-[1px]",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: "animate-spin text-amber-600 mb-3",
                                size: 36
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-stone-600 font-serif-sc animate-pulse font-medium",
                                children: t.processing
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "file",
                        ref: fileInputRef,
                        onChange: handleChange,
                        accept: "image/*",
                        multiple: true,
                        className: "hidden"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "file",
                        ref: cameraInputRef,
                        onChange: handleChange,
                        accept: "image/*",
                        capture: "environment",
                        className: "hidden"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-10 md:p-12 text-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "flex justify-center mb-6 space-x-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-4 bg-stone-100 rounded-full text-stone-500 group-hover:bg-amber-100 group-hover:text-amber-600 transition-colors",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                        size: 32
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-xl font-serif-sc text-stone-800 mb-2",
                                children: selectedImages.length > 0 ? t.addMore : t.multiUploadTitle
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-stone-500 mb-8 text-sm",
                                children: t.multiUploadDesc
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex justify-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            fileInputRef.current?.click();
                                        },
                                        className: "px-6 py-2 bg-stone-800 text-white rounded-full text-sm font-medium hover:bg-stone-700 transition-colors flex items-center gap-2 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f4bdaa89ec695b9$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            t.album
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            cameraInputRef.current?.click();
                                        },
                                        className: "px-6 py-2 bg-white border border-stone-300 text-stone-700 rounded-full text-sm font-medium hover:bg-stone-50 transition-colors flex items-center gap-2 shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fca19d3fce363c2$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            t.camera
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-2xl mx-auto bg-amber-50/50 border border-amber-100 rounded-xl p-4 md:p-6 animate-fade-in",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2 mb-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "p-1.5 bg-amber-100 rounded-lg text-amber-700",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44f0dae468c97d23$export$2e2bcd8739ae039), {
                                    size: 18
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "font-serif-sc font-bold text-amber-900 text-sm md:text-base",
                                children: t.guideTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "space-y-3 text-xs md:text-sm text-amber-800/80 leading-relaxed",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "flex items-start gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "shrink-0 mt-0.5",
                                        children: "\uD83D\uDCA1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: t.guideHand
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "flex items-start gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "shrink-0 mt-0.5",
                                        children: "\uD83D\uDCA1"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: t.guideThin
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            selectedImages.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-2xl mx-auto animate-fade-in",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6",
                        children: selectedImages.map((img, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-white p-3 rounded-xl border border-stone-200 shadow-sm relative group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: ()=>removeImage(index),
                                        className: "absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity z-10",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                            size: 12,
                                            className: "rotate-45"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: img.base64,
                                        alt: "Preview",
                                        className: "w-full h-32 object-cover rounded-lg mb-3"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: img.label || '',
                                        onChange: (e)=>handleLabelChange(index, e.target.value),
                                        className: "w-full text-xs bg-stone-50 border border-stone-200 rounded-md p-2 outline-none focus:border-amber-500",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                children: lang === 'zh' ? "\u9009\u62E9\u6807\u6CE8" : 'Select Label'
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "PPL",
                                                children: t.pplLabel
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "XPL",
                                                children: t.xplLabel
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "Macro",
                                                children: t.macroLabel
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "Micro",
                                                children: t.microLabel
                                            })
                                        ]
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: handleAnalyze,
                        className: "w-full py-4 bg-gradient-to-r from-emerald-600 to-stone-700 text-white rounded-xl font-serif-sc font-bold shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                className: isConverting ? 'animate-spin' : 'hidden',
                                size: 20
                            }),
                            t.analyzeNow,
                            " (",
                            selectedImages.length,
                            " ",
                            t.imageCount,
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $00824d397ec63c04$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $00824d397ec63c04$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("triangle-alert", $00824d397ec63c04$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2af5ca13717d7d18$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m14.31 8 5.74 9.94",
            key: "1y6ab4"
        }
    ],
    [
        "path",
        {
            d: "M9.69 8h11.48",
            key: "1wxppr"
        }
    ],
    [
        "path",
        {
            d: "m7.38 12 5.74-9.94",
            key: "1grp0k"
        }
    ],
    [
        "path",
        {
            d: "M9.69 16 3.95 6.06",
            key: "libnyf"
        }
    ],
    [
        "path",
        {
            d: "M14.31 16H2.83",
            key: "x5fava"
        }
    ],
    [
        "path",
        {
            d: "m16.62 12-5.74 9.94",
            key: "1vwawt"
        }
    ]
];
const $2af5ca13717d7d18$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("aperture", $2af5ca13717d7d18$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f9e50e5a44fb11e0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-right", $f9e50e5a44fb11e0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e1cfd183b457f6f1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 7v14",
            key: "1akyts"
        }
    ],
    [
        "path",
        {
            d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
            key: "ruj8y"
        }
    ]
];
const $e1cfd183b457f6f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("book-open", $e1cfd183b457f6f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e4e94e8aafe3af8b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
            key: "hh9hay"
        }
    ],
    [
        "path",
        {
            d: "m3.3 7 8.7 5 8.7-5",
            key: "g66t2b"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ]
];
const $e4e94e8aafe3af8b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("box", $e4e94e8aafe3af8b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8240f8fcfc513968$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $8240f8fcfc513968$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("check", $8240f8fcfc513968$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $68d48ea6a6653ccd$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $68d48ea6a6653ccd$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("copy", $68d48ea6a6653ccd$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d252ca8c87a49232$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 15V3",
            key: "m9g1x1"
        }
    ],
    [
        "path",
        {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
            key: "ih7n3h"
        }
    ],
    [
        "path",
        {
            d: "m7 10 5 5 5-5",
            key: "brsn70"
        }
    ]
];
const $d252ca8c87a49232$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("download", $d252ca8c87a49232$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $60ce6054535c0854$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4",
            key: "1slcih"
        }
    ]
];
const $60ce6054535c0854$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("flame", $60ce6054535c0854$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $712d717556ef1508$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15 12-9.373 9.373a1 1 0 0 1-3.001-3L12 9",
            key: "1hayfq"
        }
    ],
    [
        "path",
        {
            d: "m18 15 4-4",
            key: "16gjal"
        }
    ],
    [
        "path",
        {
            d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172v-.344a2 2 0 0 0-.586-1.414l-1.657-1.657A6 6 0 0 0 12.516 3H9l1.243 1.243A6 6 0 0 1 12 8.485V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
            key: "15ts47"
        }
    ]
];
const $712d717556ef1508$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hammer", $712d717556ef1508$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $18aabcb8354d5423$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
            key: "yt0hxn"
        }
    ]
];
const $18aabcb8354d5423$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("hexagon", $18aabcb8354d5423$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $309852572ce6883d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 18h8",
            key: "1borvv"
        }
    ],
    [
        "path",
        {
            d: "M3 22h18",
            key: "8prr45"
        }
    ],
    [
        "path",
        {
            d: "M14 22a7 7 0 1 0 0-14h-1",
            key: "1jwaiy"
        }
    ],
    [
        "path",
        {
            d: "M9 14h2",
            key: "197e7h"
        }
    ],
    [
        "path",
        {
            d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z",
            key: "1bmzmy"
        }
    ],
    [
        "path",
        {
            d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3",
            key: "1drr47"
        }
    ]
];
const $309852572ce6883d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("microscope", $309852572ce6883d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $071feb051549c27f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m8 3 4 8 5-5 5 15H2L8 3z",
            key: "otkl63"
        }
    ]
];
const $071feb051549c27f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("mountain", $071feb051549c27f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dd208b998b74d5e3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m14 13-8.381 8.38a1 1 0 0 1-3.001-3L11 9.999",
            key: "1lw9ds"
        }
    ],
    [
        "path",
        {
            d: "M15.973 4.027A13 13 0 0 0 5.902 2.373c-1.398.342-1.092 2.158.277 2.601a19.9 19.9 0 0 1 5.822 3.024",
            key: "ffj4ej"
        }
    ],
    [
        "path",
        {
            d: "M16.001 11.999a19.9 19.9 0 0 1 3.024 5.824c.444 1.369 2.26 1.676 2.603.278A13 13 0 0 0 20 8.069",
            key: "8tj4zw"
        }
    ],
    [
        "path",
        {
            d: "M18.352 3.352a1.205 1.205 0 0 0-1.704 0l-5.296 5.296a1.205 1.205 0 0 0 0 1.704l2.296 2.296a1.205 1.205 0 0 0 1.704 0l5.296-5.296a1.205 1.205 0 0 0 0-1.704z",
            key: "hh6h97"
        }
    ]
];
const $dd208b998b74d5e3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pickaxe", $dd208b998b74d5e3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("refresh-cw", $8a800148d042d893$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $95fae85c773ae9dc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 7V5a2 2 0 0 1 2-2h2",
            key: "aa7l1z"
        }
    ],
    [
        "path",
        {
            d: "M17 3h2a2 2 0 0 1 2 2v2",
            key: "4qcy5o"
        }
    ],
    [
        "path",
        {
            d: "M21 17v2a2 2 0 0 1-2 2h-2",
            key: "6vwrx8"
        }
    ],
    [
        "path",
        {
            d: "M7 21H5a2 2 0 0 1-2-2v-2",
            key: "ioqczr"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ],
    [
        "path",
        {
            d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
            key: "11ak4c"
        }
    ]
];
const $95fae85c773ae9dc$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scan-eye", $95fae85c773ae9dc$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("search", $9ad14973a512851d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $87d52f07e42eb495$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "18",
            cy: "5",
            r: "3",
            key: "gq8acd"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "12",
            r: "3",
            key: "w7nqdw"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "19",
            r: "3",
            key: "1xt0gg"
        }
    ],
    [
        "line",
        {
            x1: "8.59",
            x2: "15.42",
            y1: "13.51",
            y2: "17.49",
            key: "47mynk"
        }
    ],
    [
        "line",
        {
            x1: "15.41",
            x2: "8.59",
            y1: "6.51",
            y2: "10.49",
            key: "1n3mei"
        }
    ]
];
const $87d52f07e42eb495$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("share-2", $87d52f07e42eb495$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5faf23ec0b8e3e8e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
            key: "1s2grr"
        }
    ],
    [
        "path",
        {
            d: "M20 2v4",
            key: "1rf3ol"
        }
    ],
    [
        "path",
        {
            d: "M22 4h-4",
            key: "gwowj6"
        }
    ],
    [
        "circle",
        {
            cx: "4",
            cy: "20",
            r: "2",
            key: "6kqj1y"
        }
    ]
];
const $5faf23ec0b8e3e8e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sparkles", $5faf23ec0b8e3e8e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $aac5623678b36f9d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 3h5v5",
            key: "1806ms"
        }
    ],
    [
        "path",
        {
            d: "M8 3H3v5",
            key: "15dfkv"
        }
    ],
    [
        "path",
        {
            d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3",
            key: "1qrqzj"
        }
    ],
    [
        "path",
        {
            d: "m15 9 6-6",
            key: "ko1vev"
        }
    ]
];
const $aac5623678b36f9d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("split", $aac5623678b36f9d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $cfb3b3013a649f15$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $cfb3b3013a649f15$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("x", $cfb3b3013a649f15$export$3efd853dbb351e94);





var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $db54edda7e508228$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
            key: "1c8476"
        }
    ],
    [
        "path",
        {
            d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7",
            key: "1ydtos"
        }
    ],
    [
        "path",
        {
            d: "M7 3v4a1 1 0 0 0 1 1h7",
            key: "t51u73"
        }
    ]
];
const $db54edda7e508228$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("save", $db54edda7e508228$export$3efd853dbb351e94);




const $20d73ab01cac3f63$export$ea507b883e80d82f = ({ analysis: analysis, image: image, lang: lang, onClose: onClose, adminKey: adminKey })=>{
    const t = (0, $869dcad992ffb67a$export$150b732325d14d04)[lang];
    const [correctName, setCorrectName] = (0, $acw62.useState)('');
    const [expertReason, setExpertReason] = (0, $acw62.useState)('');
    const [distilledRule, setDistilledRule] = (0, $acw62.useState)(null);
    const [isDistilling, setIsDistilling] = (0, $acw62.useState)(false);
    const handleDistill = async ()=>{
        if (!correctName || !expertReason) return;
        setIsDistilling(true);
        try {
            const rule = await (0, $e9be65554ba0b2b5$export$cc01a06c23d015ce)(analysis, correctName, expertReason, image);
            setDistilledRule(rule);
            // Save the distilled rule to Firestore for admin review
            const saveRes = await fetch('/api/admin/save-rule', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: adminKey || '',
                    rule: {
                        rule: rule,
                        originalName: analysis.name,
                        correctName: correctName,
                        expertReason: expertReason
                    }
                })
            });
            if (saveRes.ok) console.log("Distilled rule saved via API");
            else console.warn("Failed to save rule via API (Unauthorized or error)");
        } catch (e) {
            console.error("Distillation failed:", e);
        } finally{
            setIsDistilling(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 z-[70] flex items-center justify-center p-4 bg-stone-900/90 backdrop-blur-md animate-fade-in",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-3xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[90vh]",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-stone-800 p-6 text-white flex justify-between items-center shrink-0",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                    className: "text-amber-400"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                    className: "font-serif-sc font-bold text-xl",
                                    children: t.distillTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onClose,
                            className: "text-stone-400 hover:text-white transition-colors",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44f0dae468c97d23$export$2e2bcd8739ae039), {
                                size: 24
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex-1 overflow-y-auto p-6 md:p-10 space-y-8",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-stone-50 border border-stone-200 rounded-2xl p-6 flex flex-col md:flex-row gap-6 items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-24 h-24 rounded-xl overflow-hidden border-2 border-stone-200 shrink-0",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: image,
                                        alt: "Case",
                                        className: "w-full h-full object-cover"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex-1 space-y-2 text-center md:text-left",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-xs font-bold text-stone-400 uppercase tracking-widest",
                                            children: "Original Case"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-xl font-serif-sc font-bold text-stone-800",
                                            children: analysis.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "hidden md:block text-stone-300",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                        size: 32
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex-1 space-y-2 text-center md:text-left",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "text-xs font-bold text-amber-500 uppercase tracking-widest",
                                            children: "Expert Correction"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            value: correctName,
                                            onChange: (e)=>setCorrectName(e.target.value),
                                            className: "w-full p-2 bg-white border-b-2 border-amber-200 focus:border-amber-500 outline-none font-serif-sc font-bold text-lg",
                                            placeholder: "Correct Name..."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 text-stone-500 font-bold text-xs uppercase tracking-widest",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                            size: 14
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: t.feedbackReason
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                    rows: 3,
                                    value: expertReason,
                                    onChange: (e)=>setExpertReason(e.target.value),
                                    className: "w-full p-4 bg-stone-50 border border-stone-200 rounded-xl focus:border-stone-400 outline-none font-serif-sc text-sm leading-relaxed",
                                    placeholder: "Why is it different? (e.g., Grain size is too small for X, looks more like Y...)"
                                })
                            ]
                        }),
                        distilledRule ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-amber-50 border-2 border-amber-200 rounded-2xl p-6 space-y-4 animate-fade-in",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 text-amber-800 font-bold text-xs uppercase tracking-widest",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                            size: 14
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Distilled Case Rule"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "p-4 bg-white border border-amber-100 rounded-xl font-serif-sc text-stone-800 italic leading-relaxed shadow-sm",
                                    children: distilledRule
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-[10px] text-amber-600/70 italic",
                                    children: "* Copy this rule into core_v5_frozen.ts to upgrade the Knowledge Base."
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: ()=>{
                                        navigator.clipboard.writeText(distilledRule);
                                        alert("Copied to clipboard!");
                                    },
                                    className: "w-full py-3 bg-amber-600 text-white rounded-xl font-bold hover:bg-amber-700 transition-all flex items-center justify-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db54edda7e508228$export$2e2bcd8739ae039), {
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: "Copy Rule"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                            onClick: handleDistill,
                            disabled: isDistilling || !correctName || !expertReason,
                            className: "w-full py-5 bg-stone-800 text-amber-50 rounded-2xl font-serif-sc font-bold text-lg shadow-xl hover:bg-stone-900 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-3",
                            children: [
                                isDistilling ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                    className: "animate-spin"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: t.distillTitle
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


const $0617a86c30fc8315$export$181b6c2b295b51cb = ({ data: data, image: image, onReset: onReset, lang: lang, adminKey: adminKey })=>{
    const t = (0, $869dcad992ffb67a$export$150b732325d14d04)[lang];
    const reportRef = (0, $acw62.useRef)(null);
    const reportId = `SM-${new Date().getFullYear()}${(new Date().getMonth() + 1).toString().padStart(2, '0')}-${Math.floor(Math.random() * 10000)}`;
    const [showPreview, setShowPreview] = (0, $acw62.useState)(false);
    const [previewImage, setPreviewImage] = (0, $acw62.useState)(null);
    const [isGenerating, setIsGenerating] = (0, $acw62.useState)(false);
    const [copySuccess, setCopySuccess] = (0, $acw62.useState)(false);
    const [showFeedback, setShowFeedback] = (0, $acw62.useState)(false);
    const [feedbackData, setFeedbackData] = (0, $acw62.useState)({
        correctName: '',
        reason: ''
    });
    const [feedbackSuccess, setFeedbackSuccess] = (0, $acw62.useState)(false);
    const [isFeedbackSubmitting, setIsFeedbackSubmitting] = (0, $acw62.useState)(false);
    const [showDistiller, setShowDistiller] = (0, $acw62.useState)(false);
    // 辅助函数：专门为反馈图片进行二次压缩 (800px)
    const resizeFeedbackImage = (base64, maxWidth)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>{
                const canvas = document.createElement('canvas');
                let width = img.width;
                let height = img.height;
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (!ctx) return reject("Canvas error");
                ctx.drawImage(img, 0, 0, width, height);
                resolve(canvas.toDataURL('image/jpeg', 0.6)); // 降低质量以减小体积
            };
            img.onerror = ()=>reject("Image load error");
            img.src = base64;
        });
    };
    const closeFeedback = ()=>{
        setShowFeedback(false);
        setFeedbackSuccess(false);
        setFeedbackData({
            correctName: '',
            reason: ''
        });
    };
    const handleFeedbackSubmit = async (e)=>{
        e.preventDefault();
        if (isFeedbackSubmitting) return;
        setIsFeedbackSubmitting(true);
        try {
            // 1. 压缩图片用于反馈 (降低体积，提高手机提交速度)
            let optimizedImage = image;
            try {
                optimizedImage = await resizeFeedbackImage(image, 800);
            } catch (resizeErr) {
                console.warn("Feedback image resize failed, using original", resizeErr);
            }
            // 2. 保存原始反馈
            const feedbackPayload = {
                reportId: reportId,
                originalName: data.name,
                correctName: feedbackData.correctName,
                reason: feedbackData.reason,
                image: optimizedImage
            };
            const response = await fetch('/api/feedback', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(feedbackPayload)
            });
            if (!response.ok) throw new Error(await response.text());
            console.log("Expert Feedback Submitted via API");
            setFeedbackSuccess(true);
        } catch (error) {
            console.error("Failed to save feedback:", error);
            alert("\u63D0\u4EA4\u53CD\u9988\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC\u8FDE\u63A5");
        } finally{
            setIsFeedbackSubmitting(false);
        }
    };
    const dataURLtoBlob = (dataurl)=>{
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while(n--)u8arr[n] = bstr.charCodeAt(n);
        return new Blob([
            u8arr
        ], {
            type: mime
        });
    };
    const generateReportImage = async ()=>{
        if (!reportRef.current || !window.html2canvas) {
            console.error("Missing reportRef or html2canvas");
            return null;
        }
        try {
            await new Promise((resolve)=>setTimeout(resolve, 600));
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            const canvas = await window.html2canvas(reportRef.current, {
                useCORS: true,
                scale: isIOS ? 1.8 : 2.2,
                backgroundColor: '#fcfcfc',
                logging: false,
                allowTaint: false,
                imageTimeout: 20000,
                // 核心黑科技：强制 html2canvas 在 1200px 的虚拟窗口下渲染
                // 这会自动触发 CSS 中的 md: (桌面端) 媒体查询，从而得到完美的电脑版布局
                windowWidth: 1200,
                onclone: (clonedDoc)=>{
                    const el = clonedDoc.getElementById('report-container');
                    if (el) {
                        // 确保容器在虚拟窗口中以桌面端样式呈现
                        el.style.width = '900px';
                        el.style.margin = '0 auto';
                        el.style.padding = '60px';
                        el.style.transform = 'none';
                        el.style.animation = 'none';
                        el.style.transition = 'none';
                        el.style.backgroundImage = 'none';
                        el.style.boxShadow = 'none';
                        // 移除所有可能干扰截图的滤镜
                        const allElements = el.getElementsByTagName('*');
                        for(let i = 0; i < allElements.length; i++){
                            const item = allElements[i];
                            item.style.filter = 'none';
                            item.style.webkitFilter = 'none';
                        }
                    }
                }
            });
            return canvas.toDataURL('image/png');
        } catch (e) {
            console.error("Report capture failed details:", e);
            return null;
        }
    };
    const handleSmartShare = async ()=>{
        if (isGenerating) return;
        setIsGenerating(true);
        try {
            const base64Image = await generateReportImage();
            if (!base64Image) {
                setIsGenerating(false);
                alert("\u751F\u6210\u62A5\u544A\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5");
                return;
            }
            // 在某些移动端环境下，异步操作后再调用 share 可能失效
            // 因此我们优先生成 base64 展示预览，作为最稳健的方案
            setPreviewImage(base64Image);
            const safeName = data.name.replace(/[\\/*?:"<>|]/g, "_");
            const filename = `${t.appName}_${safeName}.png`;
            const blob = dataURLtoBlob(base64Image);
            const file = new File([
                blob
            ], filename, {
                type: 'image/png'
            });
            // 检查是否可以使用系统原生分享
            // 注意：在某些浏览器（如 iOS Chrome 或 iframe 环境）中，navigator.share 可能存在但无法分享文件
            if (navigator.share && navigator.canShare && navigator.canShare({
                files: [
                    file
                ]
            })) try {
                await navigator.share({
                    files: [
                        file
                    ],
                    title: t.reportTitle,
                    text: `${t.appName} - ${data.name}`
                });
                setIsGenerating(false);
                return; // 分享成功，无需弹出预览
            } catch (shareErr) {
                console.log("Navigator share failed:", shareErr);
            // 失败则继续走预览逻辑
            }
            // Fallback: 如果不支持原生分享或取消，则显示预览窗口供用户长按保存
            setShowPreview(true);
        } catch (error) {
            console.error("Smart share error:", error);
            alert("\u5206\u4EAB\u529F\u80FD\u9047\u5230\u9519\u8BEF\uFF0C\u5DF2\u4E3A\u60A8\u5F00\u542F\u9884\u89C8\u6A21\u5F0F");
            // 最终降级：强制显示预览
            if (previewImage) setShowPreview(true);
        } finally{
            setIsGenerating(false);
        }
    };
    const isReverseMode = data.isThinSection;
    const crossRefTitle = isReverseMode ? t.microTitleThin : t.microTitleHand;
    const crossRefIcon = isReverseMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4e94e8aafe3af8b$export$2e2bcd8739ae039), {
        size: 14
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2af5ca13717d7d18$export$2e2bcd8739ae039), {
        size: 14
    });
    const inferenceLabel = isReverseMode ? t.inferenceLabelThin : t.inferenceLabelHand;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full max-w-5xl mx-auto animate-fade-in pb-10 md:pb-20",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col sm:flex-row justify-between items-center mb-3 md:mb-6 px-2 md:px-4 gap-2 print:hidden",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: onReset,
                        className: "flex items-center gap-2 text-stone-600 hover:text-amber-700 transition-colors font-serif-sc w-full sm:w-auto justify-center text-xs md:text-sm py-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: t.reset
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-3 w-full sm:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>setShowFeedback(true),
                                className: "flex-1 sm:flex-none flex items-center justify-center gap-2 bg-white hover:bg-stone-50 text-stone-600 px-4 py-2 md:px-6 md:py-3 rounded-sm shadow-md transition-all border border-stone-200 font-serif-sc tracking-wide w-full text-xs md:text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00824d397ec63c04$export$2e2bcd8739ae039), {
                                        size: 14,
                                        className: "text-amber-600"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: t.expertFeedback
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: handleSmartShare,
                                disabled: isGenerating,
                                className: "flex-[2] sm:flex-none flex items-center justify-center gap-2 bg-stone-800 hover:bg-stone-900 text-amber-50 px-4 py-2 md:px-6 md:py-3 rounded-sm shadow-lg transition-all hover:shadow-xl font-serif-sc tracking-wide border border-stone-700 w-full text-xs md:text-sm",
                                children: [
                                    isGenerating ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "animate-spin w-3 h-3 md:w-4 md:h-4 border-2 border-white/30 border-t-white rounded-full"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87d52f07e42eb495$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: isGenerating ? t.generating : t.saveShare
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showFeedback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 z-[60] flex items-center justify-center p-4 bg-stone-900/80 backdrop-blur-sm animate-fade-in",
                onClick: closeFeedback,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-shake",
                    onClick: (_e)=>_e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-stone-800 p-6 text-white flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd208b998b74d5e3$export$2e2bcd8739ae039), {
                                            className: "text-amber-500"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "font-serif-sc font-bold text-lg",
                                            children: t.feedbackTitle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: closeFeedback,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 20
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-8",
                            children: feedbackSuccess ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-center py-10 space-y-4 animate-fade-in",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            size: 32
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-stone-800 font-serif-sc font-bold",
                                        children: t.feedbackSuccess
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: ()=>{
                                            closeFeedback();
                                            setShowDistiller(true);
                                        },
                                        className: "flex items-center justify-center gap-2 mx-auto px-6 py-3 bg-amber-600 text-white rounded-xl font-bold hover:bg-amber-700 transition-all shadow-lg",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: t.distillTitle
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                                onSubmit: handleFeedbackSubmit,
                                className: "space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "text-xs font-bold text-stone-400 uppercase tracking-widest",
                                                children: t.feedbackCorrectName
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                required: true,
                                                type: "text",
                                                value: feedbackData.correctName,
                                                onChange: (e)=>setFeedbackData((prev)=>({
                                                            ...prev,
                                                            correctName: e.target.value
                                                        })),
                                                className: "w-full p-3 bg-stone-50 border border-stone-200 rounded-lg focus:border-amber-500 outline-none transition-all font-serif-sc",
                                                placeholder: "e.g. \u8F89\u957F\u5CA9 (Gabbro)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "text-xs font-bold text-stone-400 uppercase tracking-widest",
                                                children: t.feedbackReason
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                required: true,
                                                rows: 4,
                                                value: feedbackData.reason,
                                                onChange: (e)=>setFeedbackData((prev)=>({
                                                            ...prev,
                                                            reason: e.target.value
                                                        })),
                                                className: "w-full p-3 bg-stone-50 border border-stone-200 rounded-lg focus:border-amber-500 outline-none transition-all font-serif-sc text-sm",
                                                placeholder: t.feedbackReason
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        type: "submit",
                                        disabled: isFeedbackSubmitting || !feedbackData.correctName || !feedbackData.reason,
                                        className: "w-full py-4 bg-stone-800 text-amber-50 rounded-xl font-serif-sc font-bold shadow-lg hover:bg-stone-900 transition-all disabled:opacity-50 flex items-center justify-center gap-2",
                                        children: isFeedbackSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39f04136db3724b2$export$2e2bcd8739ae039), {
                                                    size: 18,
                                                    className: "animate-spin"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "\u6B63\u5728\u63D0\u4EA4..."
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: t.feedbackSubmit
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                ref: reportRef,
                id: "report-container",
                className: "bg-[#fcfcfc] text-stone-800 relative shadow-xl mx-auto p-3 md:p-[60px] h-auto print:shadow-none",
                style: {
                    width: '100%',
                    maxWidth: '900px',
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.05'/%3E%3C/svg%3E")`
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute inset-1 md:inset-6 border-2 md:border-4 border-double border-stone-300 pointer-events-none z-10"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute inset-2 md:inset-8 border border-stone-200 pointer-events-none z-10"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-end border-b border-stone-800 pb-2 md:pb-6 mb-2 md:mb-8 relative z-20",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-1.5 md:gap-3 text-stone-800 mb-0.5 md:mb-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $071feb051549c27f$export$2e2bcd8739ae039), {
                                                className: "w-3 h-3 md:w-8 md:h-8"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-[8px] md:text-sm tracking-[0.15em] md:tracking-[0.3em] uppercase font-serif-sc",
                                                children: t.appSub
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        className: "text-base md:text-5xl font-serif-sc font-bold text-stone-900 tracking-tight leading-none",
                                        children: t.reportTitle
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-stone-500 text-[7px] md:text-sm mt-0.5 md:mt-2 tracking-widest font-serif-sc scale-90 origin-left md:scale-100 uppercase",
                                        children: "Geological Identification Certificate"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-right hidden sm:block",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs text-stone-400 uppercase tracking-widest mb-1",
                                        children: t.reportNo
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xl font-mono text-amber-700 font-bold",
                                        children: reportId
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "text-xs text-stone-400 mt-1",
                                        children: new Date().toLocaleDateString()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col gap-2 md:gap-8 relative z-20",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex flex-col md:flex-row gap-2 md:gap-8 items-start",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "w-full md:w-5/12 shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "relative h-32 md:h-auto md:aspect-[4/5] bg-stone-100 border-2 md:border-4 border-stone-200 shadow-inner p-1 md:p-2",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "w-full h-full overflow-hidden relative",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                        src: image,
                                                        alt: "Sample",
                                                        className: "w-full h-full object-cover grayscale-[10%]"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "mt-0.5 md:mt-2 flex justify-center",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "bg-stone-800 text-amber-50 text-[6px] md:text-xs px-1.5 py-0.5 md:px-3 md:py-1 uppercase tracking-widest",
                                                    children: isReverseMode ? "Input Micrograph" : "Original Sample"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "w-full md:w-7/12 flex flex-col pt-0 md:pt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                        className: "text-[8px] md:text-sm font-bold text-stone-400 uppercase tracking-widest mb-0.5 md:mb-2",
                                                        children: t.resultTitle
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "text-lg md:text-4xl font-serif-sc font-bold text-stone-900 mb-1 pb-1 md:mb-2 md:pb-4 border-b border-stone-200 leading-tight flex justify-between items-end",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                children: data.name
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex flex-col items-end",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[8px] md:text-xs text-stone-400 uppercase tracking-widest mb-0.5",
                                                                        children: t.confidence
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                        className: `text-xs md:text-xl font-mono font-bold ${data.confidenceScore >= 90 ? 'text-emerald-600' : data.confidenceScore >= 70 ? 'text-amber-600' : 'text-red-600'}`,
                                                                        children: [
                                                                            data.confidenceScore,
                                                                            "%"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "grid grid-cols-1 gap-1 md:gap-6 mt-1 md:mt-6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex flex-col",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[8px] md:text-xs text-stone-500 uppercase tracking-widest mb-0.5",
                                                                        children: t.category
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-xs md:text-lg font-serif-sc text-stone-800 font-medium",
                                                                        children: data.category
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex flex-col mt-1 md:mt-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[8px] md:text-xs text-stone-500 uppercase tracking-widest mb-0.5",
                                                                        children: t.interpretation
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-[10px] md:text-sm text-stone-700 leading-snug font-serif-sc text-justify",
                                                                        children: data.formationReason
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            data.geologicalContext && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-1.5 md:mt-6 p-1.5 md:p-4 bg-amber-50/50 border border-amber-100 rounded-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-1 md:gap-2 mb-0.5 md:mb-2 text-amber-800",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1cfd183b457f6f1$export$2e2bcd8739ae039), {
                                                                size: 10
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-[8px] md:text-xs uppercase tracking-wider",
                                                                children: t.geoContext
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[10px] md:text-xs text-amber-900/80 leading-snug font-serif-sc italic text-justify",
                                                        children: data.geologicalContext
                                                    })
                                                ]
                                            }),
                                            data.secondPossibility && data.secondPossibility.name && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "mt-1.5 md:mt-4 p-1.5 md:p-4 bg-stone-100 border-l-2 border-stone-400 rounded-sm",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-1 md:gap-2 mb-0.5 text-stone-600",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aac5623678b36f9d$export$2e2bcd8739ae039), {
                                                                size: 10
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "font-bold text-[8px] md:text-xs uppercase tracking-wider",
                                                                children: t.alternative
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "text-xs md:text-lg font-serif-sc font-bold text-stone-800 mb-0.5",
                                                        children: data.secondPossibility.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                        className: "text-[10px] md:text-xs text-stone-600 leading-snug font-serif-sc text-justify",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "font-bold mr-1",
                                                                children: [
                                                                    t.diff,
                                                                    ":"
                                                                ]
                                                            }),
                                                            data.secondPossibility.reason
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-0 md:mt-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 md:gap-4 mb-1 md:mb-4",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "h-px bg-stone-300 flex-grow"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                className: "text-center font-bold text-stone-400 uppercase tracking-widest text-[8px] md:text-sm",
                                                children: t.techData
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "h-px bg-stone-300 flex-grow"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-2 gap-x-2 md:gap-x-12 gap-y-2 md:gap-y-6",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-1 md:space-y-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0617a86c30fc8315$var$SpecItem, {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $309852572ce6883d$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        label: t.grain,
                                                        value: data.grainSize
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0617a86c30fc8315$var$SpecItem, {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18aabcb8354d5423$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        label: t.structure,
                                                        value: data.textureAndStructure
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0617a86c30fc8315$var$SpecItem, {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dd208b998b74d5e3$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        label: t.hardness,
                                                        value: data.hardness
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0617a86c30fc8315$var$SpecItem, {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95fae85c773ae9dc$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        label: t.weathering,
                                                        value: data.weathering
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-1 md:space-y-5",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-1 md:gap-2 text-stone-500 mb-0.5 md:mb-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18aabcb8354d5423$export$2e2bcd8739ae039), {
                                                                        className: "text-amber-600 w-2.5 h-2.5 md:w-[18px] md:h-[18px]"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[8px] md:text-xs font-bold uppercase tracking-wider",
                                                                        children: t.minerals
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "flex flex-wrap gap-1 md:gap-2 mt-0.5",
                                                                children: data.minerals.map((m, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[8px] md:text-xs font-serif-sc border border-stone-300 px-1 md:px-2 py-0 md:py-0.5 text-stone-700 bg-white leading-none",
                                                                        children: m
                                                                    }, i))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0617a86c30fc8315$var$SpecItem, {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $60ce6054535c0854$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        label: t.metamorphism,
                                                        value: data.metamorphism
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0617a86c30fc8315$var$SpecItem, {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        label: t.colorOrigin,
                                                        value: data.colorCause
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0617a86c30fc8315$var$SpecItem, {
                                                        icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aac5623678b36f9d$export$2e2bcd8739ae039), {
                                                            size: 14
                                                        }),
                                                        label: t.alteration,
                                                        value: data.alteration
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            data.economicAnalysis && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 md:mt-6 bg-stone-50 border-2 border-dashed border-stone-300 p-2 md:p-6 relative",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "absolute -top-3 left-4 bg-[#fcfcfc] px-2 flex items-center gap-2 text-stone-500 font-bold text-[10px] md:text-sm uppercase tracking-widest",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            t.economicTitle
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-8 mt-1 md:mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-2 md:space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                                className: "flex items-center gap-1.5 text-[8px] md:text-xs font-bold text-stone-400 uppercase tracking-wider mb-0.5 md:mb-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ad14973a512851d$export$2e2bcd8739ae039), {
                                                                        size: 10,
                                                                        className: "text-emerald-600"
                                                                    }),
                                                                    t.alterationMap
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc leading-tight text-justify",
                                                                children: data.economicAnalysis.alterationMapping
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                                className: "flex items-center gap-1.5 text-[8px] md:text-xs font-bold text-stone-400 uppercase tracking-wider mb-0.5 md:mb-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5faf23ec0b8e3e8e$export$2e2bcd8739ae039), {
                                                                        size: 10,
                                                                        className: "text-emerald-600"
                                                                    }),
                                                                    t.indicators
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc leading-tight text-justify",
                                                                children: data.economicAnalysis.mineralIndicators
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-2 md:space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                                className: "flex items-center gap-1.5 text-[8px] md:text-xs font-bold text-stone-400 uppercase tracking-wider mb-0.5 md:mb-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                                                        size: 10,
                                                                        className: "text-emerald-600"
                                                                    }),
                                                                    t.structuralControl
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc leading-tight text-justify",
                                                                children: data.economicAnalysis.structuralControl
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                                className: "flex items-center gap-1.5 text-[8px] md:text-xs font-bold text-stone-400 uppercase tracking-wider mb-0.5 md:mb-1",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $712d717556ef1508$export$2e2bcd8739ae039), {
                                                                        size: 10,
                                                                        className: "text-emerald-600"
                                                                    }),
                                                                    t.potential
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[10px] md:text-sm text-emerald-900 font-bold font-serif-sc leading-tight text-justify bg-emerald-50/50 p-1 md:p-2 rounded border border-emerald-100/50",
                                                                children: data.economicAnalysis.prospectingPotential
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            data.fossilAnalysis && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 md:mt-6 bg-emerald-50/30 border-2 border-emerald-200 p-2 md:p-6 relative rounded-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "absolute -top-3 left-4 bg-[#fcfcfc] px-2 flex items-center gap-2 text-emerald-700 font-bold text-[10px] md:text-sm uppercase tracking-widest",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $071feb051549c27f$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            t.fossilTitle
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-8 mt-1 md:mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-2 md:space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-col border-b border-emerald-100 pb-1 md:pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[8px] md:text-xs text-emerald-600 uppercase tracking-widest mb-0.5 font-bold",
                                                                children: t.fossilType
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc font-medium",
                                                                children: data.fossilAnalysis.fossilType
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-col border-b border-emerald-100 pb-1 md:pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[8px] md:text-xs text-emerald-600 uppercase tracking-widest mb-0.5 font-bold",
                                                                children: t.genusSpecies
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[10px] md:text-sm text-stone-900 font-serif-sc font-bold italic",
                                                                children: data.fossilAnalysis.genusSpecies
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-col border-b border-emerald-100 pb-1 md:pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[8px] md:text-xs text-emerald-600 uppercase tracking-widest mb-0.5 font-bold",
                                                                children: t.geologicalAge
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc font-medium",
                                                                children: data.fossilAnalysis.geologicalAge
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-2 md:space-y-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-col border-b border-emerald-100 pb-1 md:pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[8px] md:text-xs text-emerald-600 uppercase tracking-widest mb-0.5 font-bold",
                                                                children: t.preservation
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc font-medium",
                                                                children: data.fossilAnalysis.preservation
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-col border-b border-emerald-100 pb-1 md:pb-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[8px] md:text-xs text-emerald-600 uppercase tracking-widest mb-0.5 font-bold",
                                                                children: t.environment
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc font-medium",
                                                                children: data.fossilAnalysis.environment
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex flex-col",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[8px] md:text-xs text-emerald-600 uppercase tracking-widest mb-0.5 font-bold",
                                                                children: t.fossilDesc
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                className: "text-[10px] md:text-xs text-stone-700 font-serif-sc leading-tight text-justify italic",
                                                                children: [
                                                                    '"',
                                                                    data.fossilAnalysis.description,
                                                                    '"'
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            data.microscopicAnalysis && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `mt-2 md:mt-6 text-stone-300 p-2 md:p-6 relative border border-stone-700 shadow-inner ${isReverseMode ? 'bg-[#2a2725]' : 'bg-[#1a1c20]'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `absolute -top-3 left-4 px-2 flex items-center gap-2 font-bold text-[10px] md:text-sm uppercase tracking-widest border border-stone-600 ${isReverseMode ? 'bg-stone-700 text-emerald-300' : 'bg-stone-800 text-purple-300'}`,
                                        children: [
                                            crossRefIcon,
                                            crossRefTitle
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-col gap-4 md:gap-6 mt-2 md:mt-4",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "w-full space-y-3 md:space-y-6",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                            className: `flex items-center gap-1.5 text-[8px] md:text-xs font-bold uppercase tracking-wider mb-0.5 md:mb-1 ${isReverseMode ? 'text-emerald-500' : 'text-purple-400'}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aac5623678b36f9d$export$2e2bcd8739ae039), {
                                                                    size: 10
                                                                }),
                                                                inferenceLabel
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: `text-[10px] md:text-sm text-stone-300 font-serif-sc leading-tight text-justify italic border-l-2 pl-2 ${isReverseMode ? 'border-emerald-500' : 'border-purple-500'}`,
                                                            children: [
                                                                '"',
                                                                data.microscopicAnalysis.inference,
                                                                '"'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                    className: "text-[8px] md:text-xs font-bold text-stone-500 uppercase tracking-wider mb-1",
                                                                    children: isReverseMode ? t.macroStructure : "XPL"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-[10px] md:text-xs text-stone-400 font-mono leading-tight",
                                                                    children: data.microscopicAnalysis.xplFeatures
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                                                    className: "text-[8px] md:text-xs font-bold text-stone-500 uppercase tracking-wider mb-1",
                                                                    children: isReverseMode ? t.macroAppearance : "PPL"
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-[10px] md:text-xs text-stone-400 font-mono leading-tight",
                                                                    children: data.microscopicAnalysis.pplFeatures
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-1 md:mt-4 border-t border-stone-200 pt-1 md:pt-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                        className: "font-bold text-stone-400 uppercase tracking-widest text-[8px] md:text-sm mb-0.5 md:mb-2",
                                        children: t.expertEval
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[10px] md:text-sm text-stone-800 leading-snug font-serif-sc text-justify whitespace-pre-line",
                                        children: data.detailedDescription
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "mt-2 md:mt-8 pt-2 md:pt-4 border-t-2 border-double border-stone-300 flex justify-between items-end",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-col gap-1 md:gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "text-[6px] md:text-[10px] text-stone-400 uppercase tracking-widest",
                                                children: "AI Geological Analysis \u2022 Research Only"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-[6px] md:text-[10px] text-red-800 font-serif-sc flex items-center gap-2 md:gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium",
                                                        children: "www.stonemaster.ai"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "w-px h-2 md:h-3 bg-stone-300"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: "\u5173\u6CE8\u5C0F\u7EA2\u4E66\uFF1A\u77F3\u5934\u5927\u4EBA"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "relative",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-12 h-12 md:w-24 md:h-24 border-2 md:border-4 border-red-800 rounded-full flex items-center justify-center opacity-80 transform rotate-[-12deg]",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "text-[6px] md:text-xs text-red-800 font-bold uppercase tracking-widest text-center leading-tight",
                                                children: [
                                                    t.appName,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                                    t.verified
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            showPreview && previewImage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-stone-900/95 backdrop-blur-sm animate-fade-in",
                onClick: ()=>setShowPreview(false),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "relative w-full max-w-lg bg-stone-800 rounded-xl overflow-hidden shadow-2xl flex flex-col h-[85vh] md:h-auto",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex justify-between items-center p-4 border-b border-stone-700 bg-stone-800 sticky top-0 z-10",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                    className: "text-white font-serif-sc font-bold flex items-center gap-2 text-sm md:text-base",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87d52f07e42eb495$export$2e2bcd8739ae039), {
                                            size: 18,
                                            className: "text-emerald-500"
                                        }),
                                        t.saveShare
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setShowPreview(false),
                                    className: "text-stone-400 hover:text-white p-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex-1 overflow-y-auto p-4 bg-stone-900/50 flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "w-full bg-emerald-900/30 border border-emerald-800 rounded-lg p-3 mb-4 flex items-start gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "bg-emerald-800 rounded-full p-1.5 shrink-0 mt-0.5",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "text-emerald-100"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-left",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-emerald-100 text-xs font-bold mb-0.5",
                                                    children: t.saveTipTitle
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-emerald-200/70 text-[10px] leading-relaxed",
                                                    children: t.saveTipDesc
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: previewImage,
                                    alt: "Preview",
                                    className: "w-full h-auto rounded shadow-lg border border-stone-600 mb-4 select-none touch-callout-default",
                                    style: {
                                        WebkitTouchCallout: 'default'
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-4 border-t border-stone-700 bg-stone-800 grid grid-cols-2 gap-3",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: async ()=>{
                                        try {
                                            const blob = dataURLtoBlob(previewImage);
                                            const item = new ClipboardItem({
                                                'image/png': blob
                                            });
                                            await navigator.clipboard.write([
                                                item
                                            ]);
                                            setCopySuccess(true);
                                            setTimeout(()=>setCopySuccess(false), 2000);
                                        } catch  {
                                            alert("Failed to copy");
                                        }
                                    },
                                    className: `flex items-center justify-center gap-2 py-3 rounded-lg font-medium transition-all text-sm border ${copySuccess ? 'bg-emerald-700 border-emerald-600 text-white' : 'bg-stone-700 border-stone-600 text-stone-200 hover:bg-stone-600'}`,
                                    children: [
                                        copySuccess ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8240f8fcfc513968$export$2e2bcd8739ae039), {
                                            size: 16
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $68d48ea6a6653ccd$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        copySuccess ? t.copied : t.copyImage
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: ()=>{
                                        const link = document.createElement('a');
                                        link.download = `${t.appName}_Report.png`;
                                        link.href = previewImage;
                                        link.click();
                                    },
                                    className: "flex items-center justify-center gap-2 py-3 bg-stone-200 text-stone-900 rounded-lg font-medium hover:bg-white transition-colors text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d252ca8c87a49232$export$2e2bcd8739ae039), {
                                            size: 16
                                        }),
                                        t.downloadFile
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            showDistiller && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20d73ab01cac3f63$export$ea507b883e80d82f), {
                analysis: data,
                image: image,
                lang: lang,
                onClose: ()=>setShowDistiller(false),
                adminKey: adminKey
            })
        ]
    });
};
const $0617a86c30fc8315$var$SpecItem = ({ icon: icon, label: label, value: value })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col border-b border-stone-200 pb-0.5 md:pb-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-1 md:gap-2 text-stone-500 mb-0.5 md:mb-1",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-amber-600",
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-[8px] md:text-xs font-bold uppercase tracking-wider",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "text-[10px] md:text-sm text-stone-800 font-serif-sc pl-3.5 md:pl-6 leading-tight",
                children: value
            })
        ]
    });




var $acw62 = parcelRequire("acw62");

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f36710bd138be5d0$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m9 12 2 2 4-4",
            key: "dzmm74"
        }
    ]
];
const $f36710bd138be5d0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check", $f36710bd138be5d0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $73a7d1cabb6a0e3c$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "m9 14 2 2 4-4",
            key: "df797q"
        }
    ]
];
const $73a7d1cabb6a0e3c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clipboard-check", $73a7d1cabb6a0e3c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e52b122f04c04d7d$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $e52b122f04c04d7d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("info", $e52b122f04c04d7d$export$3efd853dbb351e94);


const $e30adf8b0e53ff51$export$15776b55c505a77b = ({ tests: tests, onSubmit: onSubmit, lang: lang, initialFeedback: initialFeedback = {} })=>{
    const t = (0, $869dcad992ffb67a$export$150b732325d14d04)[lang];
    const [feedback, setFeedback] = (0, $acw62.useState)(initialFeedback);
    const handleInputChange = (testName, value)=>{
        setFeedback((prev)=>({
                ...prev,
                [testName]: value
            }));
    };
    const isComplete = tests.every((test)=>feedback[test.test] && feedback[test.test].trim().length > 0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "bg-white rounded-2xl shadow-xl border border-stone-200 overflow-hidden animate-fade-in max-w-5xl mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-stone-800 p-4 md:p-6 text-white flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $73a7d1cabb6a0e3c$export$2e2bcd8739ae039), {
                        className: "text-emerald-400",
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "font-serif-sc font-bold text-lg",
                                children: t.diagnosticTitle
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-xs text-stone-400",
                                children: t.diagnosticSub
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "p-6 space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                        children: tests.map((test, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-3 p-4 bg-stone-50 rounded-xl border border-stone-100 hover:border-emerald-200 transition-all",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-center gap-2 text-stone-800 font-bold",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "w-6 h-6 bg-stone-800 text-white rounded-full flex items-center justify-center text-[10px]",
                                                children: index + 1
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-serif-sc",
                                                children: test.test
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex items-start gap-2 text-xs text-stone-500 bg-white p-2 rounded border border-stone-100",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e52b122f04c04d7d$export$2e2bcd8739ae039), {
                                                size: 14,
                                                className: "shrink-0 mt-0.5 text-amber-500"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: test.instruction
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                className: "text-[10px] font-bold text-stone-400 uppercase tracking-widest",
                                                children: t.testResult
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                                value: feedback[test.test] || '',
                                                onChange: (e)=>handleInputChange(test.test, e.target.value),
                                                placeholder: test.expected,
                                                className: "w-full p-3 text-sm bg-white border border-stone-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent outline-none transition-all font-serif-sc min-h-[80px]"
                                            })
                                        ]
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pt-4 border-t border-stone-100 flex flex-col md:flex-row items-center justify-between gap-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 text-stone-500 text-xs italic",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                        size: 16,
                                        className: isComplete ? "text-emerald-500" : "text-stone-300"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: isComplete ? t.diagnosticReady : t.diagnosticPending
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>onSubmit(feedback),
                                disabled: !isComplete,
                                className: "w-full md:w-auto px-8 py-3 bg-stone-800 hover:bg-stone-900 disabled:bg-stone-200 text-white rounded-xl font-serif-sc font-bold shadow-lg transition-all flex items-center justify-center gap-2 group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: t.submitDiagnostic
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039), {
                                        size: 18,
                                        className: "group-hover:translate-x-1 transition-transform"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");

const $d31fc3c5c5a45aa6$export$7f7cbe89f1eacd2 = ({ lang: lang = 'zh' })=>{
    const t = (0, $869dcad992ffb67a$export$150b732325d14d04)[lang];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center justify-center space-y-4 p-8",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "relative w-20 h-20",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full border-4 border-stone-200 rounded-full"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute top-0 left-0 w-full h-full border-4 border-emerald-600 rounded-full border-t-transparent animate-spin"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-2xl",
                        children: "\uD83E\uDEA8"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-stone-600 font-serif-sc animate-pulse",
                children: t.analyzing
            })
        ]
    });
};



parcelRequire("acw62");

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7979593adeba180b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const $7979593adeba180b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("chevron-right", $7979593adeba180b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clock", $200392fae49ddb7e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 11v6",
            key: "nco0om"
        }
    ],
    [
        "path",
        {
            d: "M14 11v6",
            key: "outv1u"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
            key: "miytrc"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
            key: "e791ji"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash-2", $1d55a58c47e43a5b$export$3efd853dbb351e94);


const $879468c1a7114bf5$export$a6873b5d8e59b3c8 = ({ isOpen: isOpen, onClose: onClose, items: items, onSelect: onSelect, onDelete: onDelete, onClearAll: onClearAll, lang: lang })=>{
    const t = (0, $869dcad992ffb67a$export$150b732325d14d04)[lang];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `fixed inset-0 bg-stone-900/50 backdrop-blur-sm z-50 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`,
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `fixed top-0 right-0 h-full w-full max-w-sm bg-[#fafaf9] shadow-2xl z-50 transform transition-transform duration-300 ease-out flex flex-col ${isOpen ? 'translate-x-0' : 'translate-x-full'}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-stone-100 border-b border-stone-200 safe-area-top",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center justify-between p-4 md:p-5",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2 text-stone-800",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "p-1.5 bg-amber-100 rounded text-amber-800",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $200392fae49ddb7e$export$2e2bcd8739ae039), {
                                                size: 18
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                                    className: "font-serif-sc font-bold text-lg leading-none",
                                                    children: t.historyTitle
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-[10px] text-stone-500 uppercase tracking-widest",
                                                    children: t.historySub
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: onClose,
                                    className: "p-2 hover:bg-stone-200 rounded-full transition-colors text-stone-500",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 20
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1 overflow-y-auto p-4 space-y-3 bg-[#fafaf9]",
                        style: {
                            backgroundImage: 'linear-gradient(#e5e7eb 1px, transparent 1px)',
                            backgroundSize: '100% 32px'
                        },
                        children: items.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "h-full flex flex-col items-center justify-center text-stone-400 opacity-60",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $071feb051549c27f$export$2e2bcd8739ae039), {
                                    size: 48,
                                    strokeWidth: 1,
                                    className: "mb-4"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "font-serif-sc",
                                    children: t.historyEmpty
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "text-xs mt-2",
                                    children: t.historyEmptySub
                                })
                            ]
                        }) : items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                onClick: ()=>onSelect(item),
                                className: "group relative bg-white border border-stone-200 rounded-lg p-2 shadow-sm hover:shadow-md transition-all cursor-pointer flex gap-3 items-center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "w-16 h-16 shrink-0 rounded bg-stone-100 overflow-hidden border border-stone-100",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                            src: item.thumbnail,
                                            alt: item.data.name,
                                            className: "w-full h-full object-cover"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex-1 min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-baseline justify-between mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                        className: "font-serif-sc font-bold text-stone-800 truncate pr-2",
                                                        children: item.data.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[10px] text-stone-400 whitespace-nowrap",
                                                        children: new Date(item.timestamp).toLocaleDateString(undefined, {
                                                            month: '2-digit',
                                                            day: '2-digit'
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-xs text-stone-500 truncate mb-1",
                                                children: item.data.category
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex items-center gap-2",
                                                children: [
                                                    item.data.isThinSection && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[9px] bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded flex-none",
                                                        children: t.thinTag
                                                    }),
                                                    item.data.economicAnalysis?.prospectingPotential?.includes(lang === 'zh' ? "\u6F5C\u529B" : 'Potential') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-[9px] bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded flex-none",
                                                        children: t.potentialTag
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7979593adeba180b$export$2e2bcd8739ae039), {
                                        size: 16,
                                        className: "text-stone-300 group-hover:text-amber-500 transition-colors"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: (e)=>onDelete(item.id, e),
                                        className: "absolute -top-2 -right-2 bg-white text-red-400 p-1 rounded-full shadow border border-stone-100 opacity-0 group-hover:opacity-100 transition-opacity hover:text-red-600 hover:bg-red-50",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d55a58c47e43a5b$export$2e2bcd8739ae039), {
                                            size: 12
                                        })
                                    })
                                ]
                            }, item.id))
                    }),
                    items.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "bg-white border-t border-stone-200 safe-area-bottom",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    if (window.confirm(lang === 'en' ? 'Clear all records?' : "\u786E\u5B9A\u8981\u6E05\u7A7A\u6240\u6709\u8BB0\u5F55\u5417\uFF1F")) onClearAll();
                                },
                                className: "w-full py-3 border border-stone-300 rounded-lg text-stone-500 text-sm hover:bg-stone-50 hover:text-red-500 transition-colors font-serif-sc",
                                children: t.clearHistory
                            })
                        })
                    })
                ]
            })
        ]
    });
};


/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5415d98bde6b29f1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $5415d98bde6b29f1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-alert", $5415d98bde6b29f1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ce27ddd7f5ebc71c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
            key: "1vdc57"
        }
    ],
    [
        "path",
        {
            d: "M5 21h14",
            key: "11awu3"
        }
    ]
];
const $ce27ddd7f5ebc71c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("crown", $ce27ddd7f5ebc71c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e17c725e7c863883$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ],
    [
        "path",
        {
            d: "M12 7v5l4 2",
            key: "1fdv2h"
        }
    ]
];
const $e17c725e7c863883$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("history", $e17c725e7c863883$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $623cbfccc983e6a1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m5 8 6 6",
            key: "1wu5hv"
        }
    ],
    [
        "path",
        {
            d: "m4 14 6-6 2-3",
            key: "1k1g8d"
        }
    ],
    [
        "path",
        {
            d: "M2 5h12",
            key: "or177f"
        }
    ],
    [
        "path",
        {
            d: "M7 2h1",
            key: "1t2jsx"
        }
    ],
    [
        "path",
        {
            d: "m22 22-5-10-5 10",
            key: "don7ne"
        }
    ],
    [
        "path",
        {
            d: "M14 18h6",
            key: "1m8k6r"
        }
    ]
];
const $623cbfccc983e6a1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("languages", $623cbfccc983e6a1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $40c424bab0bc0a95$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
            key: "zw3jo"
        }
    ],
    [
        "path",
        {
            d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
            key: "1wduqc"
        }
    ],
    [
        "path",
        {
            d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
            key: "kqbvx6"
        }
    ]
];
const $40c424bab0bc0a95$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("layers", $40c424bab0bc0a95$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $28949866b6a8641c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 6h4",
            key: "aawbzj"
        }
    ],
    [
        "path",
        {
            d: "M2 10h4",
            key: "l0bgd4"
        }
    ],
    [
        "path",
        {
            d: "M2 14h4",
            key: "1gsvsf"
        }
    ],
    [
        "path",
        {
            d: "M2 18h4",
            key: "1bu2t1"
        }
    ],
    [
        "rect",
        {
            width: "16",
            height: "20",
            x: "4",
            y: "2",
            rx: "2",
            key: "1nb95v"
        }
    ],
    [
        "path",
        {
            d: "M9.5 8h5",
            key: "11mslq"
        }
    ],
    [
        "path",
        {
            d: "M9.5 12H16",
            key: "ktog6x"
        }
    ],
    [
        "path",
        {
            d: "M9.5 16H14",
            key: "p1seyn"
        }
    ]
];
const $28949866b6a8641c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("notebook-text", $28949866b6a8641c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbde4c3396582d11$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $dbde4c3396582d11$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("plus", $dbde4c3396582d11$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $78d86622bf08f9a7$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "3",
            rx: "1",
            key: "1tu5fj"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "16",
            y: "3",
            rx: "1",
            key: "1v8r4q"
        }
    ],
    [
        "rect",
        {
            width: "5",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "1x03jg"
        }
    ],
    [
        "path",
        {
            d: "M21 16h-3a2 2 0 0 0-2 2v3",
            key: "177gqh"
        }
    ],
    [
        "path",
        {
            d: "M21 21v.01",
            key: "ents32"
        }
    ],
    [
        "path",
        {
            d: "M12 7v3a2 2 0 0 1-2 2H7",
            key: "8crl2c"
        }
    ],
    [
        "path",
        {
            d: "M3 12h.01",
            key: "nlz23k"
        }
    ],
    [
        "path",
        {
            d: "M12 3h.01",
            key: "n36tog"
        }
    ],
    [
        "path",
        {
            d: "M12 16v.01",
            key: "133mhm"
        }
    ],
    [
        "path",
        {
            d: "M16 12h1",
            key: "1slzba"
        }
    ],
    [
        "path",
        {
            d: "M21 12v.01",
            key: "1lwtk9"
        }
    ],
    [
        "path",
        {
            d: "M12 21v-1",
            key: "1880an"
        }
    ]
];
const $78d86622bf08f9a7$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("qr-code", $78d86622bf08f9a7$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da03c070d837b197$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("settings", $da03c070d837b197$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.554.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4666dd9ae485baaf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ],
    [
        "path",
        {
            d: "M12 8v4",
            key: "1got3b"
        }
    ],
    [
        "path",
        {
            d: "M12 16h.01",
            key: "1drbdi"
        }
    ]
];
const $4666dd9ae485baaf$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shield-alert", $4666dd9ae485baaf$export$3efd853dbb351e94);


const $19d9deac12f277fb$var$App = ()=>{
    const [lang, setLang] = (0, $acw62.useState)('zh');
    const t = (0, $869dcad992ffb67a$export$150b732325d14d04)[lang];
    const [userId, setUserId] = (0, $acw62.useState)(()=>{
        const saved = localStorage.getItem('stone_master_user_id');
        if (saved) return saved;
        const newId = 'user_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        localStorage.setItem('stone_master_user_id', newId);
        return newId;
    });
    const handleSyncId = (newId)=>{
        if (!newId || !newId.startsWith('user_')) {
            alert("\u65E0\u6548\u7684\u6062\u590D ID");
            return;
        }
        setUserId(newId);
        localStorage.setItem('stone_master_user_id', newId);
        alert("\u8BBE\u5907\u540C\u6B65\u6210\u529F\uFF01\u6B63\u5728\u52A0\u8F7D\u4E91\u7AEF\u6570\u636E...");
    };
    const [usage, setUsage] = (0, $acw62.useState)(()=>{
        const saved = localStorage.getItem('stone_master_usage');
        if (saved) {
            const parsed = JSON.parse(saved);
            const today = new Date().toDateString();
            if (parsed.lastReset !== today) return {
                ...parsed,
                count: 0,
                lastReset: today
            };
            return parsed;
        }
        return {
            count: 0,
            lastReset: new Date().toDateString(),
            credits: 0,
            isPro: false
        };
    });
    // Persist usage to localStorage
    (0, $acw62.useEffect)(()=>{
        localStorage.setItem('stone_master_usage', JSON.stringify(usage));
    }, [
        usage
    ]);
    // Sync usage with server on mount
    (0, $acw62.useEffect)(()=>{
        fetch(`/api/usage?userId=${userId}`).then((res)=>res.json()).then((data)=>{
            if (data && !data.error) setUsage(data);
        }).catch((err)=>console.error('Failed to sync usage', err));
    }, [
        userId
    ]);
    const [showPayModal, setShowPayModal] = (0, $acw62.useState)(false);
    const [showAdminModal, setShowAdminModal] = (0, $acw62.useState)(false);
    const [adminKeyInput, setAdminKeyInput] = (0, $acw62.useState)('');
    const [adminData, setAdminData] = (0, $acw62.useState)(null);
    const [adminTab, setAdminTab] = (0, $acw62.useState)('codes');
    const [adminSearch, setAdminSearch] = (0, $acw62.useState)('');
    const [isSearching, setIsSearching] = (0, $acw62.useState)(false);
    const [hasMoreCodes, setHasMoreCodes] = (0, $acw62.useState)(true);
    const [titleClicks, setTitleClicks] = (0, $acw62.useState)(0);
    const [redeemCode, setRedeemCode] = (0, $acw62.useState)('');
    const [redeemError, setRedeemError] = (0, $acw62.useState)('');
    const [redeemSuccess, setRedeemSuccess] = (0, $acw62.useState)(false);
    const [redeemSuccessMsg, setRedeemSuccessMsg] = (0, $acw62.useState)('');
    const [qrCodeUrl, setQrCodeUrl] = (0, $acw62.useState)('/wechat_qr.png');
    const [qrStatus, setQrStatus] = (0, $acw62.useState)('loading');
    (0, $acw62.useEffect)(()=>{
        // Pre-fetch QR code on mount
        fetch('/api/public/qr').then((res)=>res.json()).then((data)=>{
            if (data.qrCode) {
                setQrCodeUrl(data.qrCode);
                setQrStatus('success');
            } else setQrStatus('error');
        }).catch((err)=>{
            console.error('Failed to fetch QR code', err);
            setQrStatus('error');
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        localStorage.setItem('stone_master_usage', JSON.stringify(usage));
    }, [
        usage
    ]);
    const [state, setState] = (0, $acw62.useState)({
        isLoading: false,
        data: null,
        error: null,
        images: [],
        diagnosticFeedback: {}
    });
    const [historyItems, setHistoryItems] = (0, $acw62.useState)([]);
    const [isHistoryOpen, setIsHistoryOpen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        console.log("App v8.8.8 Mounted");
        document.title = "\u77F3\u5934\u5927\u4EBA - \u4E13\u4E1A\u5CA9\u77F3\u9274\u5B9A";
    }, []);
    (0, $acw62.useEffect)(()=>{
        const items = (0, $b7da56340adeac66$export$f9582a3c130d9538)();
        setHistoryItems(items);
    }, []);
    const handleImagesSelect = async (images)=>{
        // Check limits - Strict mode (no free tries)
        if (!usage.isPro && usage.credits <= 0) {
            setShowPayModal(true);
            return;
        }
        setState((prev)=>({
                ...prev,
                isLoading: true,
                error: null,
                images: images,
                data: null,
                diagnosticFeedback: {}
            }));
        try {
            const analysis = await (0, $116f6b541640fbf7$export$b77f614c4e70f925)(images, lang, undefined, userId);
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    data: analysis
                }));
            // Update usage from server
            fetch(`/api/usage?userId=${userId}`).then((res)=>res.json()).then((data)=>{
                if (data && !data.error) setUsage(data);
            });
            // Use the first image as thumbnail for history
            if (images.length > 0) (0, $b7da56340adeac66$export$c5dcb0c84a36a24a)(analysis, images[0].base64).then(setHistoryItems);
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : t.errorGeneric;
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    error: errorMsg
                }));
        }
    };
    const handleDiagnosticSubmit = async (feedback)=>{
        // Note: If you want diagnostic submissions to also cost credits, leave this check.
        // Otherwise, you can remove it if you consider recalibration "free" for the same image.
        if (!usage.isPro && usage.credits <= 0) {
            setShowPayModal(true);
            return;
        }
        setState((prev)=>({
                ...prev,
                isLoading: true,
                error: null,
                diagnosticFeedback: feedback
            }));
        try {
            const analysis = await (0, $116f6b541640fbf7$export$b77f614c4e70f925)(state.images, lang, feedback, userId);
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    data: analysis
                }));
            // Update usage from server
            fetch(`/api/usage?userId=${userId}`).then((res)=>res.json()).then((data)=>{
                if (data && !data.error) setUsage(data);
            });
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : t.errorGeneric;
            setState((prev)=>({
                    ...prev,
                    isLoading: false,
                    error: errorMsg
                }));
        }
    };
    const handleReset = ()=>{
        setState({
            isLoading: false,
            data: null,
            error: null,
            images: [],
            diagnosticFeedback: {}
        });
    };
    const toggleLang = ()=>{
        setLang((prev)=>prev === 'zh' ? 'en' : 'zh');
    };
    const handleRedeem = async ()=>{
        setRedeemError('');
        try {
            const response = await fetch('/api/redeem', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    code: redeemCode,
                    userId: userId
                })
            });
            const result = await response.json();
            console.log('Redeem result:', result);
            if (result.success) {
                // 🛡️ FIX: Use the absolute credits returned by server, don't add locally
                const newCredits = result.credits;
                setUsage((prev)=>({
                        ...prev,
                        credits: newCredits
                    }));
                setRedeemSuccessMsg(`${result.message || t.redeemSuccess} (\u{5F53}\u{524D}\u{603B}\u{989D}\u{5EA6}: ${newCredits})`);
                setRedeemSuccess(true);
                setTimeout(()=>{
                    setRedeemSuccess(false);
                    setRedeemSuccessMsg('');
                    setShowPayModal(false);
                    setRedeemCode('');
                }, 2500);
            } else setRedeemError(t.invalidCode);
        } catch (err) {
            console.error(err);
            setRedeemError(t.errorGeneric);
        }
    };
    const fetchAdminData = (0, $acw62.useCallback)(async (searchStr, lastId)=>{
        const trimmedKey = adminKeyInput.trim();
        if (!trimmedKey) return; // Don't fetch if key is empty
        try {
            const encodedKey = encodeURIComponent(trimmedKey);
            let statusUrl = `/api/admin/status?key=${encodedKey}`;
            if (searchStr) statusUrl += `&search=${encodeURIComponent(searchStr)}`;
            else if (lastId) statusUrl += `&lastId=${encodeURIComponent(lastId)}`;
            const [statusRes, feedbackRes, rulesRes] = await Promise.all([
                fetch(statusUrl),
                fetch(`/api/admin/feedback?key=${encodedKey}`),
                fetch(`/api/admin/rules?key=${encodedKey}`)
            ]);
            if (statusRes.ok) {
                const statusData = await statusRes.json();
                if (!feedbackRes.ok) console.error('Failed to fetch feedback:', await feedbackRes.text());
                if (!rulesRes.ok) console.error('Failed to fetch rules:', await rulesRes.text());
                const feedbackData = feedbackRes.ok ? await feedbackRes.json() : [];
                const rulesData = rulesRes.ok ? await rulesRes.json() : [];
                setAdminData((prev)=>{
                    if (lastId && prev) return {
                        ...statusData,
                        codes: [
                            ...prev.codes,
                            ...statusData.codes
                        ],
                        feedback: feedbackData,
                        rules: rulesData
                    };
                    else return {
                        ...statusData,
                        feedback: feedbackData,
                        rules: rulesData
                    };
                });
                setHasMoreCodes(statusData.codes.length === 50);
            } else {
                const errText = await statusRes.text();
                alert("\u7BA1\u7406\u5458\u5BC6\u94A5\u9519\u8BEF: " + errText);
            }
        } catch (err) {
            console.error(err);
            alert("\u8FDE\u63A5\u670D\u52A1\u5668\u5931\u8D25");
        } finally{
            setIsSearching(false);
        }
    }, [
        adminKeyInput
    ]);
    (0, $acw62.useEffect)(()=>{
        if (adminSearch.length >= 2) {
            const timer = setTimeout(()=>{
                setIsSearching(true);
                fetchAdminData(adminSearch);
            }, 500);
            return ()=>clearTimeout(timer);
        } else if (adminSearch.length === 0) fetchAdminData();
    }, [
        adminSearch,
        fetchAdminData
    ]);
    const distillFeedback = async (feedbackId)=>{
        try {
            const response = await fetch('/api/admin/distill', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: adminKeyInput,
                    feedbackId: feedbackId
                })
            });
            if (response.ok) {
                const result = await response.json();
                alert("\u84B8\u998F\u6210\u529F\uFF01\u65B0\u51C6\u5219\uFF1A" + result.rule);
                fetchAdminData();
            } else alert("\u84B8\u998F\u5931\u8D25");
        } catch (err) {
            console.error(err);
            alert("\u64CD\u4F5C\u51FA\u9519");
        }
    };
    const deleteFeedback = async (feedbackId)=>{
        try {
            const response = await fetch('/api/admin/delete-feedback', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: adminKeyInput,
                    feedbackId: feedbackId
                })
            });
            if (response.ok) fetchAdminData();
        } catch (err) {
            console.error(err);
        }
    };
    const deleteRule = async (ruleId)=>{
        try {
            const response = await fetch('/api/admin/delete-rule', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: adminKeyInput,
                    ruleId: ruleId
                })
            });
            if (response.ok) fetchAdminData();
        } catch (err) {
            console.error(err);
        }
    };
    const generateCode = async ()=>{
        try {
            const response = await fetch('/api/admin/generate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: adminKeyInput,
                    credits: 100,
                    count: 1
                })
            });
            if (response.ok) fetchAdminData();
        } catch (err) {
            console.error(err);
            alert("\u751F\u6210\u5931\u8D25");
        }
    };
    const clearUsedCodes = async ()=>{
        try {
            const response = await fetch('/api/admin/clear-used', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    key: adminKeyInput
                })
            });
            if (response.ok) {
                const result = await response.json();
                alert(`\u{6210}\u{529F}\u{6E05}\u{7406} ${result.count || 0} \u{4E2A}\u{5DF2}\u{4F7F}\u{7528}\u{7684}\u{5361}\u{5BC6}`);
                fetchAdminData();
            } else alert("\u6E05\u7406\u5931\u8D25");
        } catch (err) {
            console.error(err);
            alert("\u6E05\u7406\u51FA\u9519");
        }
    };
    const handleQRUpload = async (e)=>{
        const file = e.target.files?.[0];
        if (!file) return;
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = async ()=>{
            URL.revokeObjectURL(url);
            const canvas = document.createElement('canvas');
            const MAX_WIDTH = 800;
            const MAX_HEIGHT = 800;
            let width = img.width;
            let height = img.height;
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
            }
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            // Fill white background in case of transparent PNG
            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, width, height);
            ctx.drawImage(img, 0, 0, width, height);
            const base64String = canvas.toDataURL('image/jpeg', 0.7);
            try {
                const response = await fetch('/api/admin/upload-qr', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        key: adminKeyInput,
                        image: base64String
                    })
                });
                if (response.ok) alert("\u6536\u6B3E\u7801\u4E0A\u4F20\u6210\u529F\uFF01\u5237\u65B0\u9875\u9762\u5373\u53EF\u770B\u5230\u3002");
                else try {
                    const data = await response.json();
                    alert("\u4E0A\u4F20\u5931\u8D25: " + (data.error || "\u672A\u77E5\u9519\u8BEF"));
                } catch  {
                    alert("\u4E0A\u4F20\u5931\u8D25\uFF0C\u6587\u4EF6\u53EF\u80FD\u8FC7\u5927");
                }
            } catch (err) {
                console.error(err);
                alert("\u4E0A\u4F20\u51FA\u9519");
            }
        };
        img.src = url;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen flex flex-col bg-[#fafaf9] text-stone-900 font-sans selection:bg-emerald-200 relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $879468c1a7114bf5$export$a6873b5d8e59b3c8), {
                isOpen: isHistoryOpen,
                onClose: ()=>setIsHistoryOpen(false),
                items: historyItems,
                onSelect: (item)=>{
                    setState({
                        isLoading: false,
                        data: item.data,
                        error: null,
                        images: [
                            {
                                base64: item.thumbnail,
                                mimeType: 'image/jpeg'
                            }
                        ],
                        diagnosticFeedback: {}
                    });
                    setIsHistoryOpen(false);
                },
                onDelete: (id, e)=>{
                    e.stopPropagation();
                    setHistoryItems((0, $b7da56340adeac66$export$a6769ee681a31e21)(id));
                },
                onClearAll: ()=>{
                    (0, $b7da56340adeac66$export$bdbc3d990af5b3f9)();
                    setHistoryItems([]);
                    setIsHistoryOpen(false);
                },
                lang: lang
            }),
            showAdminModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-black/80 backdrop-blur-md z-[110] flex items-center justify-center p-4 animate-fade-in",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white w-full max-w-md rounded-3xl overflow-hidden shadow-2xl animate-scale-in",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-stone-900 p-6 text-white flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da03c070d837b197$export$2e2bcd8739ae039), {
                                            className: "text-amber-500",
                                            size: 20
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                            className: "text-lg font-serif-sc font-bold",
                                            children: "\u540E\u53F0\u7BA1\u7406\u7CFB\u7EDF"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        adminData && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: fetchAdminData,
                                            className: "text-stone-400 hover:text-white transition-all hover:rotate-180 duration-500",
                                            title: "\u5237\u65B0\u6570\u636E",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                size: 20
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            onClick: ()=>{
                                                setShowAdminModal(false);
                                                setAdminData(null);
                                                setAdminTab('codes');
                                            },
                                            className: "text-stone-400 hover:text-white transition-colors",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                size: 24
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "p-6 space-y-6 max-h-[85vh] overflow-y-auto",
                            children: !adminData ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-sm text-stone-600",
                                        children: "\u8BF7\u8F93\u5165\u7BA1\u7406\u5458\u5BC6\u94A5\u4EE5\u7EE7\u7EED\uFF1A"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "password",
                                        value: adminKeyInput,
                                        onChange: (e)=>setAdminKeyInput(e.target.value),
                                        className: "w-full px-4 py-3 bg-stone-100 border border-stone-200 rounded-lg outline-none",
                                        placeholder: "ADMIN-XXXXXX"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        onClick: fetchAdminData,
                                        className: "w-full bg-stone-800 text-white py-3 rounded-lg font-bold",
                                        children: "\u767B\u5F55\u540E\u53F0"
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-6",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex bg-stone-100 p-1 rounded-xl",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: ()=>setAdminTab('codes'),
                                                className: `flex-1 py-2 text-xs font-bold rounded-lg transition-all ${adminTab === 'codes' ? 'bg-white text-stone-900 shadow-sm' : 'text-stone-500'}`,
                                                children: "\u5361\u5BC6\u7BA1\u7406"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: ()=>setAdminTab('feedback'),
                                                className: `flex-1 py-2 text-xs font-bold rounded-lg transition-all ${adminTab === 'feedback' ? 'bg-white text-stone-900 shadow-sm' : 'text-stone-500'}`,
                                                children: [
                                                    "\u4E13\u5BB6\u53CD\u9988 (",
                                                    adminData.feedback?.length || 0,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                onClick: ()=>setAdminTab('rules'),
                                                className: `flex-1 py-2 text-xs font-bold rounded-lg transition-all ${adminTab === 'rules' ? 'bg-white text-stone-900 shadow-sm' : 'text-stone-500'}`,
                                                children: [
                                                    "\u9274\u5B9A\u51C6\u5219 (",
                                                    adminData.rules?.length || 0,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    adminTab === 'codes' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-6 animate-fade-in",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bg-stone-50 p-4 rounded-2xl border border-stone-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[10px] text-stone-400 uppercase font-bold",
                                                                children: "\u603B\u5361\u5BC6\u6570"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-2xl font-serif-sc font-bold text-stone-800",
                                                                children: adminData.stats.total
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "bg-stone-50 p-4 rounded-2xl border border-stone-100",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[10px] text-stone-400 uppercase font-bold",
                                                                children: "\u5DF2\u4F7F\u7528"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-2xl font-serif-sc font-bold text-amber-600",
                                                                children: adminData.stats.used
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "bg-red-50 p-4 rounded-2xl border border-red-100",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "flex justify-between items-center mb-2",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-[10px] text-red-400 uppercase font-bold",
                                                            children: "\u8BBE\u5907\u6570\u636E\u6E05\u7406"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[10px] text-red-500 mb-3",
                                                        children: "\u6E05\u7406\u6570\u636E\u5E93\u4E2D\u65E0\u6548\u7684\u8BBE\u5907\u53F7\uFF08\u65E0\u4F59\u989D\u4E14\u8D85\u8FC730\u5929\u672A\u6D3B\u8DC3\u7684\u514D\u8D39\u7528\u6237\uFF09\uFF0C\u51CF\u5C11\u65E0\u75D5\u6D4F\u89C8\u4EA7\u751F\u7684\u5783\u573E\u6570\u636E\u3002"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: async ()=>{
                                                            if (!confirm("\u786E\u5B9A\u8981\u6E05\u7406\u65E0\u6548\u7684\u8BBE\u5907\u6570\u636E\u5417\uFF1F")) return;
                                                            try {
                                                                const res = await fetch('/api/admin/cleanup-users', {
                                                                    method: 'POST',
                                                                    headers: {
                                                                        'Content-Type': 'application/json'
                                                                    },
                                                                    body: JSON.stringify({
                                                                        key: adminKeyInput
                                                                    })
                                                                });
                                                                const data = await res.json();
                                                                if (data.success) alert(`\u{6E05}\u{7406}\u{6210}\u{529F}\u{FF01}\u{5171}\u{5220}\u{9664}\u{4E86} ${data.deletedCount} \u{6761}\u{65E0}\u{6548}\u{8BBE}\u{5907}\u{6570}\u{636E}\u{3002}`);
                                                                else alert("\u6E05\u7406\u5931\u8D25: " + data.error);
                                                            } catch  {
                                                                alert("\u8BF7\u6C42\u5931\u8D25");
                                                            }
                                                        },
                                                        className: "w-full bg-red-500 hover:bg-red-600 text-white py-2 rounded-xl text-xs font-bold transition-all flex items-center justify-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                                size: 14
                                                            }),
                                                            " \u6E05\u7406\u65E0\u6548\u8BBE\u5907"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-4",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: generateCode,
                                                        className: "bg-amber-500 hover:bg-amber-600 text-stone-900 py-4 rounded-2xl font-bold shadow-lg transition-all flex items-center justify-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbde4c3396582d11$export$2e2bcd8739ae039), {
                                                                size: 20
                                                            }),
                                                            " \u751F\u6210\u65B0\u5361\u5BC6"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: clearUsedCodes,
                                                        className: "bg-stone-100 hover:bg-stone-200 text-stone-600 py-4 rounded-2xl font-bold border border-stone-200 transition-all flex items-center justify-center gap-2",
                                                        title: "\u6E05\u7406\u989D\u5EA6\u5DF2\u8017\u5C3D\u7684\u5361\u5BC6",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                size: 20
                                                            }),
                                                            " \u6E05\u7406\u5DF2\u8017\u5C3D"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "p-4 bg-stone-50 rounded-2xl border border-stone-100 space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[10px] text-stone-400 uppercase font-bold",
                                                        children: "\u66F4\u65B0\u6536\u6B3E\u4E8C\u7EF4\u7801"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                        className: "flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-stone-300 rounded-xl cursor-pointer hover:bg-stone-100 transition-all",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex flex-col items-center justify-center pt-5 pb-6",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4f68e7f5ef2ab511$export$2e2bcd8739ae039), {
                                                                        className: "text-stone-400 mb-2",
                                                                        size: 24
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-xs text-stone-500",
                                                                        children: "\u70B9\u51FB\u4E0A\u4F20\u652F\u4ED8\u5B9D\u6536\u6B3E\u4E8C\u7EF4\u7801"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                        className: "text-[10px] text-stone-400 mt-1",
                                                                        children: "\u652F\u6301 PNG, JPG"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "file",
                                                                className: "hidden",
                                                                accept: "image/*",
                                                                onChange: handleQRUpload
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-end",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                className: "text-xs font-bold text-stone-400 uppercase tracking-widest",
                                                                children: "\u5361\u5BC6\u5217\u8868"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[9px] text-stone-400 font-medium",
                                                                children: adminSearch ? `\u{641C}\u{7D22}\u{7ED3}\u{679C}` : `\u{663E}\u{793A}\u{6700}\u{8FD1} ${adminData.codes.length} \u{4E2A}`
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                                type: "text",
                                                                placeholder: "\u641C\u7D22\u5361\u5BC6 (\u8F93\u5165\u524D\u51E0\u4F4D)...",
                                                                value: adminSearch,
                                                                onChange: (e)=>setAdminSearch(e.target.value),
                                                                className: "w-full px-4 py-2 bg-stone-100 border border-stone-200 rounded-xl text-sm outline-none focus:ring-2 focus:ring-amber-500/20"
                                                            }),
                                                            isSearching && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                className: "absolute right-3 top-1/2 -translate-y-1/2",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                                    size: 14,
                                                                    className: "animate-spin text-stone-400"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        className: "space-y-2",
                                                        children: adminData.codes.map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: `p-3 rounded-xl border flex justify-between items-center ${code.used ? 'bg-stone-50 border-stone-100 opacity-60' : 'bg-white border-stone-200 shadow-sm'}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "font-mono font-bold text-stone-800",
                                                                                children: code.id
                                                                            }),
                                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                                className: "text-[10px] text-stone-400",
                                                                                children: new Date(code.createdAt).toLocaleString()
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                                        className: "flex items-center gap-2",
                                                                        children: code.used ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                            className: "text-[10px] bg-stone-200 text-stone-500 px-2 py-1 rounded-full",
                                                                            children: "\u5DF2\u6FC0\u6D3B"
                                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                            onClick: ()=>{
                                                                                navigator.clipboard.writeText(code.id);
                                                                                alert("\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F");
                                                                            },
                                                                            className: "text-[10px] bg-amber-100 text-amber-700 px-2 py-1 rounded-full font-bold hover:bg-amber-200",
                                                                            children: "\u590D\u5236"
                                                                        })
                                                                    })
                                                                ]
                                                            }, code.id))
                                                    }),
                                                    hasMoreCodes && !adminSearch && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>{
                                                            const lastId = adminData?.codes[adminData.codes.length - 1].id;
                                                            fetchAdminData(undefined, lastId);
                                                        },
                                                        className: "w-full py-3 text-stone-500 text-xs font-bold hover:bg-stone-50 rounded-xl transition-all border border-dashed border-stone-200",
                                                        children: "\u52A0\u8F7D\u66F4\u591A\u5361\u5BC6..."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    adminTab === 'feedback' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-4 animate-fade-in",
                                        children: adminData.feedback?.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-center py-10 text-stone-400 text-sm",
                                            children: "\u6682\u65E0\u4E13\u5BB6\u53CD\u9988"
                                        }) : adminData.feedback?.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "p-4 bg-white border border-stone-200 rounded-2xl shadow-sm space-y-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex justify-between items-start",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex items-center gap-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: `text-[10px] px-2 py-0.5 rounded-full font-bold ${f.status === 'distilled' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`,
                                                                        children: f.status === 'distilled' ? "\u5DF2\u84B8\u998F" : "\u5F85\u5904\u7406"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                        className: "text-[10px] text-stone-400",
                                                                        children: new Date(f.timestamp).toLocaleString()
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                                onClick: ()=>deleteFeedback(f.id),
                                                                className: "p-2 text-stone-400 hover:text-red-500 transition-colors",
                                                                title: "\u5220\u9664\u53CD\u9988",
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                                    size: 20
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex gap-3",
                                                        children: [
                                                            f.image && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                                src: f.image,
                                                                className: "w-16 h-16 object-cover rounded-lg border border-stone-100"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                                className: "flex-1 min-w-0",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "text-xs font-bold text-stone-800 truncate",
                                                                        children: [
                                                                            f.originalName,
                                                                            " \u2192 ",
                                                                            f.correctName
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                                        className: "text-[11px] text-stone-500 line-clamp-2 mt-1 italic",
                                                                        children: [
                                                                            '"',
                                                                            f.reason,
                                                                            '"'
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    f.status !== 'distilled' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                                        onClick: ()=>distillFeedback(f.id),
                                                        className: "w-full py-2 bg-stone-800 text-white text-xs font-bold rounded-lg hover:bg-stone-900 transition-all flex items-center justify-center gap-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce27ddd7f5ebc71c$export$2e2bcd8739ae039), {
                                                                size: 14,
                                                                className: "text-amber-400"
                                                            }),
                                                            " \u91C7\u7EB3\u5E76\u84B8\u998F\u4E3A\u51C6\u5219"
                                                        ]
                                                    })
                                                ]
                                            }, f.id))
                                    }),
                                    adminTab === 'rules' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "space-y-4 animate-fade-in",
                                        children: adminData.rules?.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-center py-10 text-stone-400 text-sm",
                                            children: "\u6682\u65E0\u9274\u5B9A\u51C6\u5219"
                                        }) : adminData.rules?.map((r)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "p-4 bg-emerald-50/50 border border-emerald-100 rounded-2xl space-y-2 relative group",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>deleteRule(r.id),
                                                        className: "absolute top-2 right-2 p-2 text-emerald-300 hover:text-red-500 transition-all",
                                                        title: "\u5220\u9664\u51C6\u5219",
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                                            size: 20
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "flex items-center gap-2 mb-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44f0dae468c97d23$export$2e2bcd8739ae039), {
                                                                size: 14,
                                                                className: "text-emerald-600"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[10px] font-bold text-emerald-700 uppercase tracking-wider",
                                                                children: "\u4E13\u5BB6\u51C6\u5219"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-xs text-stone-800 leading-relaxed font-medium",
                                                        children: r.rule
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "pt-2 border-t border-emerald-100 flex justify-between items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                className: "text-[9px] text-emerald-600/60 italic",
                                                                children: [
                                                                    "\u6E90\u81EA: ",
                                                                    r.originalContext?.originalName,
                                                                    " \u2192 ",
                                                                    r.originalContext?.correctName
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                                className: "text-[9px] text-stone-400",
                                                                children: new Date(r.timestamp).toLocaleDateString()
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, r.id))
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            showPayModal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 z-[100] flex items-center justify-center p-2 md:p-4 bg-stone-900/90 backdrop-blur-md animate-fade-in",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[95vh] overflow-hidden animate-scale-in flex flex-col",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-stone-800 p-4 md:p-6 text-white flex justify-between items-center shrink-0",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce27ddd7f5ebc71c$export$2e2bcd8739ae039), {
                                            className: "text-amber-400"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                            className: "font-serif-sc font-bold text-lg",
                                            children: t.upgradePro
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setShowPayModal(false),
                                    className: "hover:rotate-90 transition-transform p-1",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfb3b3013a649f15$export$2e2bcd8739ae039), {
                                        size: 24
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "p-6 md:p-8 space-y-6 md:space-y-8 overflow-y-auto",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "text-center space-y-2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: `p-4 rounded-xl border transition-all ${usage.credits > 0 ? 'bg-amber-50 border-amber-100 animate-pulse-slow' : 'bg-stone-50 border-stone-100'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                className: `${usage.credits > 0 ? 'text-amber-800' : 'text-stone-600'} font-bold text-lg`,
                                                children: [
                                                    t.creditsRemaining,
                                                    ": ",
                                                    usage.credits
                                                ]
                                            }),
                                            usage.credits > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-amber-600 text-xs mt-1",
                                                children: "\u4E13\u4E1A\u7248\u989D\u5EA6\u5DF2\u6FC0\u6D3B\uFF0C\u60A8\u53EF\u4EE5\u7EE7\u7EED\u9274\u5B9A"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-stone-600 font-serif-sc mt-2",
                                                        children: t.limitReached
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-sm text-stone-400",
                                                        children: t.limitReachedSub
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col items-center gap-4 p-4 md:p-6 bg-stone-50 rounded-xl border border-stone-100",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-56 h-72 md:w-64 md:h-80 bg-white p-2 rounded-lg shadow-md flex items-center justify-center border border-stone-200 overflow-hidden relative group",
                                            children: qrStatus === 'loading' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-col items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                        className: "animate-spin text-stone-300",
                                                        size: 32
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                        className: "text-[10px] text-stone-400",
                                                        children: "\u6B63\u5728\u52A0\u8F7D\u6536\u6B3E\u7801..."
                                                    })
                                                ]
                                            }) : qrStatus === 'success' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                src: qrCodeUrl,
                                                alt: "Alipay QR",
                                                className: "w-full h-full object-contain animate-fade-in"
                                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "flex flex-col items-center gap-4 text-stone-400 p-4 text-center animate-fade-in",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d86622bf08f9a7$export$2e2bcd8739ae039), {
                                                        size: 48,
                                                        className: "text-stone-300"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                        className: "space-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[10px] font-bold text-amber-600",
                                                                children: "\u26A0\uFE0F \u6536\u6B3E\u7801\u56FE\u7247\u672A\u5C31\u4F4D"
                                                            }),
                                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                className: "text-[9px] leading-relaxed",
                                                                children: "\u8BF7\u7BA1\u7406\u5458\u5728\u540E\u53F0\u4E0A\u4F20\u6536\u6B3E\u7801"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "text-center",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "font-serif-sc font-bold text-stone-800 text-base md:text-lg",
                                                    children: t.buyPro
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-xs text-emerald-600 font-bold mt-1 max-w-sm mx-auto",
                                                    children: t.orderRemark
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-4 pb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "p-3 bg-stone-50 rounded-xl border border-stone-100 flex flex-col items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    className: "text-[9px] text-stone-400 uppercase font-bold tracking-widest",
                                                    children: "\u60A8\u7684\u8BBE\u5907\u6062\u590D ID (Recovery ID)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "flex items-center gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("code", {
                                                            className: "text-[10px] font-mono text-stone-600 bg-white px-2 py-1 rounded border border-stone-200",
                                                            children: userId
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                navigator.clipboard.writeText(userId);
                                                                alert("\u6062\u590D ID \u5DF2\u590D\u5236\uFF0C\u8BF7\u59A5\u5584\u4FDD\u5B58\u3002");
                                                            },
                                                            className: "p-1 hover:bg-stone-200 rounded transition-colors text-stone-400",
                                                            title: "\u590D\u5236\u6062\u590D ID",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28949866b6a8641c$export$2e2bcd8739ae039), {
                                                                size: 14
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                            onClick: ()=>{
                                                                const input = prompt("\u8BF7\u8F93\u5165\u53E6\u4E00\u53F0\u8BBE\u5907\u7684\u6062\u590D ID \u4EE5\u540C\u6B65\u989D\u5EA6\uFF1A");
                                                                if (input) handleSyncId(input.trim());
                                                            },
                                                            className: "p-1 hover:bg-stone-200 rounded transition-colors text-emerald-600",
                                                            title: "\u540C\u6B65\u5176\u4ED6\u8BBE\u5907",
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                                                                size: 14
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-[8px] text-stone-400 text-center leading-tight mt-1",
                                                    children: "\u82E5\u66F4\u6362\u8BBE\u5907\u6216\u6E05\u9664\u7F13\u5B58\uFF0C\u53EF\u51ED\u6B64 ID \u6216\u6FC0\u6D3B\u7801\u627E\u56DE\u989D\u5EA6"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                    type: "text",
                                                    placeholder: t.enterCode,
                                                    value: redeemCode,
                                                    onChange: (e)=>setRedeemCode(e.target.value),
                                                    className: "w-full px-4 py-3 bg-stone-100 border border-stone-200 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all font-mono tracking-widest text-center"
                                                }),
                                                redeemError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                    className: "text-red-500 text-[10px] mt-1 text-center animate-shake",
                                                    children: redeemError
                                                }),
                                                redeemSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "absolute inset-0 bg-emerald-500 text-white flex flex-col items-center justify-center rounded-lg animate-fade-in z-10 p-2 text-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f36710bd138be5d0$export$2e2bcd8739ae039), {
                                                            className: "mb-1",
                                                            size: 24
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "text-xs font-bold leading-tight",
                                                            children: redeemSuccessMsg
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "flex gap-2",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                onClick: handleRedeem,
                                                disabled: !redeemCode || redeemSuccess,
                                                className: "flex-grow bg-stone-800 hover:bg-stone-900 disabled:bg-stone-300 text-white py-3 rounded-lg font-serif-sc font-bold transition-all shadow-lg hover:shadow-xl active:scale-[0.98]",
                                                children: t.redeem
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                className: "bg-stone-800 text-stone-200 sticky top-0 z-40 shadow-xl border-b border-stone-700 safe-area-top",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "max-w-6xl mx-auto px-4 py-3 md:py-4 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-3 cursor-pointer hover:opacity-90 group select-none",
                            onClick: ()=>{
                                const newClicks = titleClicks + 1;
                                setTitleClicks(newClicks);
                                if (newClicks >= 5) {
                                    setShowAdminModal(true);
                                    setTitleClicks(0);
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "w-9 h-9 md:w-10 md:h-10 bg-gradient-to-br from-stone-700 to-stone-900 rounded-lg flex items-center justify-center border border-stone-600",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $071feb051549c27f$export$2e2bcd8739ae039), {
                                        className: "text-emerald-500",
                                        size: 20
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                            className: "text-lg md:text-xl font-serif-sc font-bold tracking-widest text-stone-100",
                                            children: t.appName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-[9px] md:text-[10px] text-stone-400 uppercase tracking-[0.2em]",
                                            children: t.appSub
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex flex-col items-end mr-2",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-[8px] md:text-[10px] text-stone-400 uppercase tracking-tighter",
                                            children: t.creditsRemaining
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-[10px] md:text-xs font-bold text-amber-500",
                                            children: usage.isPro ? t.unlimited : usage.credits > 0 ? usage.credits : 0
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    onClick: ()=>setShowPayModal(true),
                                    className: "p-2 rounded-full bg-amber-500/10 hover:bg-amber-500/20 text-amber-600 transition-all mr-1",
                                    title: t.upgradePro,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce27ddd7f5ebc71c$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: ()=>setIsHistoryOpen(true),
                                    className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-stone-700 hover:bg-stone-600 border border-stone-600 text-stone-300 transition-all",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $28949866b6a8641c$export$2e2bcd8739ae039), {
                                            size: 16,
                                            className: "text-amber-500"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "text-xs font-serif-sc hidden md:inline",
                                            children: t.history
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    onClick: toggleLang,
                                    className: "flex items-center gap-2 px-3 py-1.5 rounded-full bg-stone-700 hover:bg-stone-600 border border-stone-600 text-emerald-400 transition-all font-bold text-xs",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $623cbfccc983e6a1$export$2e2bcd8739ae039), {
                                            size: 14
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: lang === 'zh' ? 'EN' : "\u4E2D"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "flex-grow px-2 md:px-4 py-4 md:py-16 relative overflow-x-hidden pb-48",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "absolute inset-0 pointer-events-none opacity-[0.03]",
                        style: {
                            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23292524' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "max-w-6xl mx-auto relative z-10",
                        children: [
                            !state.data && !state.isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "text-center mb-12 md:mb-20 space-y-6 animate-fade-in pt-6 md:pt-10 px-4",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                        className: "text-3xl md:text-6xl font-serif-sc font-bold text-stone-800 mb-4 tracking-tight leading-tight",
                                        children: [
                                            t.slogan,
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-transparent bg-clip-text bg-gradient-to-r from-stone-700 to-stone-500 relative inline-block px-2 mt-2",
                                                children: [
                                                    t.sloganSub,
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "absolute -bottom-1 left-0 w-full h-1 bg-emerald-700/20"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-base md:text-xl text-stone-500 max-w-2xl mx-auto font-serif-sc leading-relaxed",
                                        children: t.heroDesc
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "transition-all duration-500 ease-out min-h-[400px]",
                                children: state.isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col items-center py-20",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d31fc3c5c5a45aa6$export$7f7cbe89f1eacd2), {
                                        lang: lang
                                    })
                                }) : state.data && state.images.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-8",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0617a86c30fc8315$export$181b6c2b295b51cb), {
                                            data: state.data,
                                            image: state.images[0].base64,
                                            onReset: handleReset,
                                            lang: lang
                                        }),
                                        state.data.diagnosticTests && state.data.diagnosticTests.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e30adf8b0e53ff51$export$15776b55c505a77b), {
                                            tests: state.data.diagnosticTests,
                                            onSubmit: handleDiagnosticSubmit,
                                            lang: lang,
                                            initialFeedback: state.diagnosticFeedback
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "space-y-16 md:space-y-24 px-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "max-w-3xl mx-auto transform hover:-translate-y-1 transition-transform duration-300",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $455b3fc5babd4649$export$cbafa1ad4452dd0d), {
                                                    onImagesSelect: handleImagesSelect,
                                                    lang: lang
                                                }),
                                                state.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "mt-6 bg-red-50 border-l-4 border-red-500 text-red-700 px-6 py-4 rounded-r shadow-sm flex items-start gap-3 animate-shake",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5415d98bde6b29f1$export$2e2bcd8739ae039), {
                                                            size: 24,
                                                            className: "shrink-0 mt-0.5"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                                    className: "font-bold text-sm uppercase tracking-wider mb-1",
                                                                    children: t.errorTitle
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                                    className: "text-sm",
                                                                    children: state.error
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        !state.error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 border-t border-stone-200 pt-12 md:pt-16 max-w-6xl mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19d9deac12f277fb$var$FeatureCard, {
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40c424bab0bc0a95$export$2e2bcd8739ae039), {
                                                        className: "text-stone-700",
                                                        size: 24
                                                    }),
                                                    title: t.feature1Title,
                                                    desc: t.feature1Desc
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19d9deac12f277fb$var$FeatureCard, {
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e17c725e7c863883$export$2e2bcd8739ae039), {
                                                        className: "text-stone-700",
                                                        size: 24
                                                    }),
                                                    title: t.feature2Title,
                                                    desc: t.feature2Desc
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($19d9deac12f277fb$var$FeatureCard, {
                                                    icon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $44f0dae468c97d23$export$2e2bcd8739ae039), {
                                                        className: "text-stone-700",
                                                        size: 24
                                                    }),
                                                    title: t.feature3Title,
                                                    desc: t.feature3Desc
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
                className: "bg-stone-800 text-stone-400 py-8 md:py-12 border-t border-stone-700 safe-area-bottom",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "max-w-6xl mx-auto px-6",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex items-center gap-3 opacity-80",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "w-8 h-8 bg-stone-900 rounded flex items-center justify-center border border-stone-700",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $071feb051549c27f$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "text-stone-300"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-serif-sc font-bold text-stone-200 tracking-widest",
                                            children: t.appName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "flex flex-col md:flex-row gap-4 md:gap-8 text-xs text-stone-500",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        children: [
                                            "\xa9 ",
                                            new Date().getFullYear(),
                                            " Stone Master AI Lab."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-stone-900/30 p-4 rounded border border-stone-700 flex gap-3 items-start",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4666dd9ae485baaf$export$2e2bcd8739ae039), {
                                    size: 20,
                                    className: "text-amber-700/70 shrink-0 mt-0.5"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-[10px] md:text-xs leading-relaxed text-stone-500 text-justify",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "font-bold text-stone-400 mb-1",
                                            children: t.disclaimerTitle
                                        }),
                                        t.disclaimer
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $19d9deac12f277fb$var$FeatureCard = ({ icon: icon, title: title, desc: desc })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "p-6 rounded-sm hover:bg-white hover:shadow-xl transition-all duration-500 group border border-transparent hover:border-stone-200 bg-[#fcfcfc] shadow-sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-2 bg-stone-100 rounded-full group-hover:bg-amber-100",
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "font-serif-sc font-bold text-lg text-stone-800 group-hover:text-amber-800",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-stone-600 text-sm leading-relaxed font-serif-sc text-justify",
                children: desc
            })
        ]
    });
var $19d9deac12f277fb$export$2e2bcd8739ae039 = $19d9deac12f277fb$var$App;



console.log("Stone Master AI Loaded");
const $f85b6d3c5c511c65$var$rootElement = document.getElementById('root');
if (!$f85b6d3c5c511c65$var$rootElement) throw new Error("Could not find root element to mount to");
const $f85b6d3c5c511c65$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot($f85b6d3c5c511c65$var$rootElement);
$f85b6d3c5c511c65$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $19d9deac12f277fb$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=applet.9e4cb711.js.map
